'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var logger$1 = require('@fingermarkglobal/logger');
var React = require('react');
var React__default = _interopDefault(React);
var reactRouterDom = require('react-router-dom');
var recoil = require('recoil');
var atoms = require('@fingermarkglobal/atoms');
var jsxRuntime = require('react/jsx-runtime');
var utilities = require('@fingermarkglobal/utilities');
var reactUse = require('react-use');
var reactI18next = require('react-i18next');
require('spinkit/spinkit.css');
var ShoppingCart = _interopDefault(require('heroicons/solid/shopping-cart.svg'));
var cart = require('@fingermarkglobal/cart');
var storage = require('@fingermarkglobal/storage');
var lodash = require('lodash');
var jitsu = require('@fingermarkglobal/jitsu');
var launchdarklyReactClientSdk = require('launchdarkly-react-client-sdk');
var menu_resolver = require('@fingermarkglobal/menu.resolver');
var hydrate = require('@fingermarkglobal/hydrate');
var dateFns = require('date-fns');
var dateFnsTz = require('date-fns-tz');
var html2canvas = _interopDefault(require('html2canvas'));
var react = require('@xstate/react');
var reactErrorBoundary = require('react-error-boundary');
var validation$1 = require('@fingermarkglobal/validation');
var xstate = require('xstate');
var restaurant_resolver = require('@fingermarkglobal/restaurant.resolver');
var asyncEs = require('async-es');
var i18n = _interopDefault(require('i18next'));
var Pusher = _interopDefault(require('pusher-js'));
var health = require('@fingermarkglobal/health');
var restaurant = require('@fingermarkglobal/restaurant');
var settings = require('@fingermarkglobal/settings');
var Plus = _interopDefault(require('heroicons/solid/plus.svg'));
var Minus = _interopDefault(require('heroicons/solid/minus.svg'));
var Pencil = _interopDefault(require('heroicons/solid/pencil.svg'));
var Delete = _interopDefault(require('heroicons/solid/x.svg'));
var Ban = _interopDefault(require('heroicons/solid/ban.svg'));
var ArrowLeft = _interopDefault(require('heroicons/solid/arrow-left.svg'));
var Skeleton = require('react-loading-skeleton');
var Skeleton__default = _interopDefault(Skeleton);
var SolidArrowCircleRight = _interopDefault(require('heroicons/solid/arrow-circle-right.svg'));
var SolidArrowCircleLeft = _interopDefault(require('heroicons/solid/arrow-circle-left.svg'));
var MinimalArrowCircleRight = _interopDefault(require('heroicons/solid/arrow-right.svg'));
var Viewer = _interopDefault(require('react-json-view'));
var googleAnalytics = require('@fingermarkglobal/google-analytics');
var ExclamationCircle = _interopDefault(require('heroicons/outline/exclamation-circle.svg'));
var classNames = _interopDefault(require('classnames'));
var ReactQRCode = _interopDefault(require('react-qr-code'));
var url_shortener = require('@fingermarkglobal/url.shortener');
var CheckCircle = _interopDefault(require('heroicons/solid/check-circle.svg'));
var MoneyBillAlt = _interopDefault(require('@fortawesome/fontawesome-free/svgs/regular/money-bill-alt.svg'));
var CreditCard = _interopDefault(require('@fortawesome/fontawesome-free/svgs/regular/credit-card.svg'));
var transactions = require('@fingermarkglobal/transactions');
var fmApi = require('@fingermarkglobal/fm-api');
var nanoid = require('nanoid');
var ChevronDown = _interopDefault(require('heroicons/outline/chevron-down.svg'));
var GridLoader = _interopDefault(require('react-spinners/GridLoader'));
var sms = require('@fingermarkglobal/sms');
var Keyboard = _interopDefault(require('react-simple-keyboard'));
var ChevronLeft = _interopDefault(require('heroicons/outline/chevron-left.svg'));
var XCircle = _interopDefault(require('heroicons/solid/x-circle.svg'));
var Dinero = _interopDefault(require('dinero.js'));
var PlusCircle = _interopDefault(require('heroicons/solid/plus-circle.svg'));
var framerMotion = require('framer-motion');
var emailValidator = require('email-validator');
var types = require('@fingermarkglobal/types');
var useSWR = _interopDefault(require('swr'));
var clsx = _interopDefault(require('clsx'));
var tailwindMerge = require('tailwind-merge');

function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useMetadata = function useMetadata() {
  var _useRecoilState = recoil.useRecoilState(atoms.metadataState),
    metadata = _useRecoilState[0],
    setMetadata = _useRecoilState[1];
  return {
    metadata: metadata,
    setMetadata: setMetadata
  };
};

var useAccessibility = function useAccessibility(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$isAccessibilityB = _ref.isAccessibilityButtonEnabled,
    isAccessibilityButtonEnabled = _ref$isAccessibilityB === void 0 ? false : _ref$isAccessibilityB;
  var location = reactRouterDom.useLocation();
  var _useMetadata = useMetadata(),
    metadata = _useMetadata.metadata,
    setMetadata = _useMetadata.setMetadata;
  var _ref2 = metadata || {},
    _ref2$accessibilityEn = _ref2.accessibilityEnabled,
    accessibilityEnabled = _ref2$accessibilityEn === void 0 ? false : _ref2$accessibilityEn;
  var isHalf = isAccessibilityButtonEnabled !== null ? !!(isAccessibilityButtonEnabled && accessibilityEnabled) : accessibilityEnabled;
  // This gets exported from here as the accessibility components use this
  // as their 'logic' hook as well
  var wrapperClassName = isHalf ? 'h-half' : 'h-full';
  var allowAccessibilityLogo = isHalf && location.pathname !== '/home';
  var toggleAccessibility = function toggleAccessibility() {
    return setMetadata(function (metadata) {
      return _extends({}, metadata, {
        accessibilityEnabled: !accessibilityEnabled
      });
    });
  };
  return {
    toggleAccessibility: toggleAccessibility,
    accessibilityEnabled: accessibilityEnabled,
    wrapperClassName: wrapperClassName,
    allowAccessibilityLogo: allowAccessibilityLogo
  };
};

var _g;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function SvgWheelchair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 99 116",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.037 52.573c.27 3.88-.46 8.67.39 13.41 1.29 7.14 5 11.06 12.17 12.55a54.3 54.3 0 0011.93 1.16 60.88 60.88 0 0111.66 1 14.8 14.8 0 0110.03 6.86c4 6 8 12.033 12 18.1a5.64 5.64 0 005.88 2.67c2.4-.38 3.79-1.95 4.51-4.24a4.93 4.93 0 00-.8-4.34c-5.07-8.05-10.08-16.14-15.34-24.07-3.32-5-8.69-6.83-14.29-8a68.35 68.35 0 01-9.67-2.31 8.1 8.1 0 01-5.44-6.11c-.35-1.56-.32-2.6 2-2.54 6.78.18 13.56.13 20.35 0 4.84-.06 7.72-4.56 5.45-8.44a6.13 6.13 0 00-5.77-3h-20.06c-1.57 0-2.16-.34-2.09-2a20.73 20.73 0 00-.28-6c-1.46-5.81-6.64-9.83-12-9.21a11.65 11.65 0 00-10.55 11.53c-.15 4.07-.08 8.09-.08 12.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.005 81.114c-.287 18.343 13.936 33.651 32.25 34.71 14.24.76 27.76-6.2 34.27-21.38 1.26-3 .17-5.94-2.39-7-2.73-1.13-5.27 0-6.71 3.09-5 10.54-13.8 16.08-24.46 15.38a24.74 24.74 0 01-12.79-44.85c.38-.28.8-.52 1.19-.8 2.73-1.93 3.43-4.67 1.83-7.15-1.5-2.33-4.56-2.79-7.36-1.1-9.64 5.8-16.05 17.58-15.83 29.1zM41.48 22.92c6.33-.011 11.451-5.15 11.44-11.48C52.909 5.11 47.77-.011 41.44 0 35.11.011 29.989 5.15 30 11.48c.017 6.327 5.153 11.446 11.48 11.44z"
  }))));
}

var _path;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function SvgStanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.797 94.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.47 13.938a6.574 6.574 0 005.679-3.432 7.375 7.375 0 00.038-7.016 6.42 6.42 0 00-11.361-.121 7.385 7.385 0 00-.104 7.015 6.604 6.604 0 005.604 3.554zM69.632 39.792a33.075 33.075 0 00-4.018-14.128c-2.279-3.896-5.772-7.295-9.99-8.639a11.859 11.859 0 00-9.521.424 15.073 15.073 0 00-2.55 1.38 19.794 19.794 0 00-5.1 4.957 30.008 30.008 0 00-5.01 13.756 56.338 56.338 0 00-.056 12.747s.487 4.27 3.103 4.166a3.025 3.025 0 002.807-3.183 50.032 50.032 0 01.962-12.885 25.46 25.46 0 012.244-6.345c-.135 1.223-.544 26.187-.276 26.608l1.506 32.825a3.352 3.352 0 006.702.161c.003-.057.008-.112.01-.169l1.068-24.675 1.112 24.683a3.357 3.357 0 006.712.164c0-.058.01-.112.01-.17L60.797 58c.015-.34-.338-25.932-.338-25.932 2.222 4.338 2.94 9.622 3.11 14.498.05 1.568.05 3.141-.017 4.704a3.045 3.045 0 002.615 3.178 2.966 2.966 0 003.133-2.65 59.007 59.007 0 00.332-12.006c-.17-2.27.184 2.265 0 0zM15.436 31a5.554 5.554 0 004.76-2.742 5.65 5.65 0 00.032-5.604 5.508 5.508 0 00-9.523-.097 5.657 5.657 0 00-.087 5.604A5.565 5.565 0 0015.315 31zM30.658 51.855a25.497 25.497 0 00-3.367-11.286 15.546 15.546 0 00-8.373-6.901 10.386 10.386 0 00-7.98.338A12.842 12.842 0 008.8 35.11a16.258 16.258 0 00-4.275 3.96 23.281 23.281 0 00-4.2 10.99A42.91 42.91 0 00.28 60.241s.409 3.41 2.601 3.328a2.461 2.461 0 002.353-2.543 38.144 38.144 0 01.806-10.293 19.72 19.72 0 011.881-5.07c-.113.977-.456 20.92-.23 21.257L8.95 92.19a2.815 2.815 0 005.618.13l.008-.136.895-18.76.932 18.766a2.82 2.82 0 005.626.131c0-.045.008-.09.008-.135l1.21-25.366c-.45-16.821-.278-21.136-.278-21.136 1.863 3.466 2.465 7.687 2.607 11.582.041 1.253.041 2.51-.014 3.758a2.42 2.42 0 004.817.422 44.946 44.946 0 00.278-9.592c-.142-1.813.155 1.81 0 0z"
  })));
}

var AccessibilityWrapper = function AccessibilityWrapper(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$LogoImage = _ref.LogoImage,
    LogoImage = _ref$LogoImage === void 0 ? null : _ref$LogoImage,
    _ref$isAccessibilityB = _ref.isAccessibilityButtonEnabled,
    isAccessibilityButtonEnabled = _ref$isAccessibilityB === void 0 ? false : _ref$isAccessibilityB,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _useAccessibility = useAccessibility({
      isAccessibilityButtonEnabled: isAccessibilityButtonEnabled
    }),
    wrapperClassName = _useAccessibility.wrapperClassName,
    allowAccessibilityLogo = _useAccessibility.allowAccessibilityLogo;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [allowAccessibilityLogo && LogoImage && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col items-center mt-48",
      children: /*#__PURE__*/jsxRuntime.jsx(LogoImage, {
        "data-test": "logo",
        className: "w-64"
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      id: "accessibility",
      className: "w-full bottom-0 absolute overflow-y-hidden " + className + " " + wrapperClassName,
      "data-test": "accessibility-wrapper",
      style: style,
      children: children
    })]
  });
};
var AccessibilityButton = function AccessibilityButton(_ref2) {
  var className = _ref2.className;
  var _useAccessibility2 = useAccessibility(),
    toggleAccessibility = _useAccessibility2.toggleAccessibility,
    accessibilityEnabled = _useAccessibility2.accessibilityEnabled;
  var accessibilityIconClass = 'w-full h-full fill-current text-accessibility';
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    "data-test": "accessibility-button",
    className: "focus:outline-none bg-accessibility " + className,
    onClick: toggleAccessibility,
    children: accessibilityEnabled ? /*#__PURE__*/jsxRuntime.jsx(SvgStanding, {
      "data-test": "standing-icon",
      className: accessibilityIconClass
    }) : /*#__PURE__*/jsxRuntime.jsx(SvgWheelchair, {
      "data-test": "wheelchair-icon",
      className: accessibilityIconClass
    })
  });
};

var usePrice = function usePrice() {
  var _useRecoilValue = recoil.useRecoilValue(atoms.computedMetadata),
    currency = _useRecoilValue.currency;
  var format = function format(params) {
    if (params === void 0) {
      params = {};
    }
    return utilities.formatPrice(_extends({}, params, {
      currency: currency
    }));
  };
  return {
    formatPrice: format
  };
};

var useTiming = function useTiming(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$idleTime = _ref.idleTime,
    idleTime = _ref$idleTime === void 0 ? 30 : _ref$idleTime,
    _ref$warningTime = _ref.warningTime,
    warningTime = _ref$warningTime === void 0 ? 10 : _ref$warningTime;
  var isIdle = reactUse.useIdle(idleTime * 1000);
  var _useState = React.useState(warningTime),
    timeLeft = _useState[0],
    setTimeLeft = _useState[1];
  var _useState2 = React.useState(false),
    started = _useState2[0],
    setStarted = _useState2[1];
  var _useState3 = React.useState(false),
    timerExpired = _useState3[0],
    setTimerExpired = _useState3[1];
  var timer = React.useRef({});
  React.useEffect(function () {
    setTimerExpired(timeLeft < 0);
  }, [setTimerExpired, timeLeft]);
  React.useEffect(function () {
    if (!started) return;
    if (timer.current.id) return;
    timer.current.id = setInterval(function () {
      try {
        setTimeLeft(function (time) {
          return time - 1;
        });
      } catch (err) {
        logger.error('Components - useTiming - error:', err);
      }
    }, 1000);
    return function () {
      return clearInterval(timer.current.id);
    };
  }, [started]);
  var startTimer = function startTimer() {
    setStarted(true);
  };
  var resetTimer = function resetTimer() {
    clearInterval(timer.current.id);
    setStarted(false);
    timer.current = {};
    setTimeLeft(warningTime);
  };
  return {
    isIdle: isIdle,
    timeLeft: timeLeft >= 0 ? timeLeft : 0,
    startTimer: startTimer,
    resetTimer: resetTimer,
    timerExpired: timerExpired,
    started: started
  };
};

var useLocaleSelection = function useLocaleSelection(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$allowedLanguages = _ref.allowedLanguages,
    allowedLanguages = _ref$allowedLanguages === void 0 ? [] : _ref$allowedLanguages;
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var _useTranslation = reactI18next.useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useRecoilState = recoil.useRecoilState(atoms.localeState),
    currentLanguage = _useRecoilState[0],
    setCurrentLanguage = _useRecoilState[1];
  var _ref2 = (settings == null ? void 0 : settings.settings) || {},
    languageObject = _ref2.languages;
  var languageKeys = Object.keys(languageObject);
  var languages = languageKeys.filter(function (language) {
    return language != 'default';
  }).filter(function (language) {
    return allowedLanguages.length === 0 ? true : allowedLanguages.includes(language);
  }).map(function (language) {
    var _i18n$language, _languageObject$langu, _languageObject$langu2;
    var active = (i18n == null ? void 0 : (_i18n$language = i18n.language) == null ? void 0 : _i18n$language.toLowerCase()) === language.toLowerCase();
    var key = language.toLowerCase();
    var label = ((_languageObject$langu = languageObject[language]) == null ? void 0 : (_languageObject$langu2 = _languageObject$langu.translation) == null ? void 0 : _languageObject$langu2.languageLabel) || language.toUpperCase();
    return {
      key: key,
      label: label,
      active: active
    };
  });
  var onChangeLanguage = React.useCallback(function (key) {
    return function () {
      setCurrentLanguage(key);
      i18n.changeLanguage(key);
    };
  }, [i18n, setCurrentLanguage]);
  return {
    t: t,
    i18n: i18n,
    languages: languages,
    currentLanguage: currentLanguage,
    onChangeLanguage: onChangeLanguage
  };
};

var useTimeoutModal = function useTimeoutModal(_temp) {
  var _settings$interval;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$onTimeout = _ref.onTimeout,
    onTimeout = _ref$onTimeout === void 0 ? null : _ref$onTimeout;
  var history = reactRouterDom.useHistory();
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useState = React.useState(false),
    showWarning = _useState[0],
    setShowWarning = _useState[1];
  var settingsObject = recoil.useRecoilValue(atoms.settingsState);
  var _ref2 = settingsObject || {},
    _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? {} : _ref2$settings;
  var _ref3 = (settings == null ? void 0 : (_settings$interval = settings.interval) == null ? void 0 : _settings$interval.timeout) || {},
    _ref3$warning = _ref3.warning,
    warningTime = _ref3$warning === void 0 ? 10 : _ref3$warning;
  var updatedSession = recoil.useRecoilValue(atoms.sessionState);
  var setSession = recoil.useSetRecoilState(atoms.sessionState);
  var cancelReason = 'CANCELLED_BY_CART_TIMEOUT';
  var idleTimeByRoute = React.useMemo(function () {
    var _settings$interval2;
    var pathname = history.location.pathname;
    var _ref4 = (settings == null ? void 0 : (_settings$interval2 = settings.interval) == null ? void 0 : _settings$interval2.timeout) || {},
      _ref4$receipt = _ref4.receipt,
      receipt = _ref4$receipt === void 0 ? 30 : _ref4$receipt,
      _ref4$session = _ref4.session,
      session = _ref4$session === void 0 ? 30 : _ref4$session,
      _ref4$order = _ref4.order,
      order = _ref4$order === void 0 ? 30 : _ref4$order;
    var orderPaths = ['/cart', '/payment'];
    var sessionPaths = ['/categories', '/category', '/product'];
    var receiptPaths = ['/receipt'];
    if (orderPaths.some(function (path) {
      return pathname.includes(path);
    })) return order;
    if (sessionPaths.some(function (path) {
      return pathname.includes(path);
    })) return session;
    if (receiptPaths.some(function (path) {
      return pathname.includes(path);
    })) return receipt;
    return session;
  }, [settings, history.location]);
  var _useTiming = useTiming({
      idleTime: idleTimeByRoute,
      warningTime: warningTime
    }),
    isIdle = _useTiming.isIdle,
    timeLeft = _useTiming.timeLeft,
    startTimer = _useTiming.startTimer,
    resetTimer = _useTiming.resetTimer,
    timerExpired = _useTiming.timerExpired;
  var reset = function reset() {
    resetTimer();
    setShowWarning(false);
  };

  // useEffect for idle timing
  React.useEffect(function () {
    // cant just set to `isIdle` value as un-idling will close modal
    // - might be the inteded functionality later anyways?
    if (isIdle) setShowWarning(true);
  }, [isIdle]);

  // useEffect for warning timing
  React.useEffect(function () {
    if (!showWarning) return;
    startTimer();
  }, [showWarning, startTimer]);
  React.useEffect(function () {
    var pathname = history.location.pathname;
    var receiptPaths = ['/receipt'];
    if (!timerExpired) return;
    if (onTimeout) {
      onTimeout();
      return;
    }
    if (!receiptPaths.some(function (path) {
      return pathname.includes(path);
    })) {
      setSession(_extends({}, updatedSession, {
        cancelReason: cancelReason
      }));
      if (!!(updatedSession != null && updatedSession.cancelReason)) {
        history.push('/reset');
      }
    } else {
      history.push('/reset');
    }
  }, [timerExpired, onTimeout, history, updatedSession, setSession, history.location]);
  return {
    t: t,
    reset: reset,
    timeLeft: timeLeft,
    showWarning: showWarning,
    formatPrice: formatPrice
  };
};

var Spinner = function Spinner(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "sk-chase " + className,
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    })]
  });
};
var useFormattedMessages = function useFormattedMessages(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    title = _ref2.title,
    message = _ref2.message,
    isFirstLoad = _ref2.isFirstLoad;
  if (title === '' && message === '' && isFirstLoad === false) {
    var _useLocaleSelection = useLocaleSelection(),
      t = _useLocaleSelection.t;
    var formattedTitle = t('defaultLoadingTitle');
    var formattedMessage = t('defaultLoadingMessage');
    return {
      formattedTitle: formattedTitle,
      formattedMessage: formattedMessage
    };
  }
  return {
    formattedTitle: title,
    formattedMessage: message
  };
};
var Loading = function Loading(_temp2) {
  var _ref3 = _temp2 === void 0 ? {} : _temp2,
    _ref3$dataTest = _ref3['data-test'],
    dataTest = _ref3$dataTest === void 0 ? 'loading' : _ref3$dataTest,
    _ref3$title = _ref3.title,
    title = _ref3$title === void 0 ? '' : _ref3$title,
    _ref3$message = _ref3.message,
    message = _ref3$message === void 0 ? '' : _ref3$message,
    _ref3$Image = _ref3.Image,
    Image = _ref3$Image === void 0 ? null : _ref3$Image,
    _ref3$isFirstLoad = _ref3.isFirstLoad,
    isFirstLoad = _ref3$isFirstLoad === void 0 ? false : _ref3$isFirstLoad;
  var _useFormattedMessages = useFormattedMessages({
      title: title,
      message: message,
      isFirstLoad: isFirstLoad
    }),
    formattedTitle = _useFormattedMessages.formattedTitle,
    formattedMessage = _useFormattedMessages.formattedMessage;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: "flex flex-col items-center justify-center space-y-12 text-3xl md:space-y-32 md:text-4xl loading-wrapper h-3/3",
    children: [!isFirstLoad && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "font-bold loading-wrapper-title",
      children: formattedTitle
    }), Image ? /*#__PURE__*/jsxRuntime.jsx(Image, {
      className: "block h-1/2 loading-wrapper-image"
    }) : /*#__PURE__*/jsxRuntime.jsx(Spinner, {
      className: "w-40 h-40 md:w-64 md:h-64 loading-wrapper-spinner " + (isFirstLoad && 'mt-8')
    }), !isFirstLoad && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-center loading-wrapper-message",
      children: formattedMessage
    })]
  });
};

var PrimaryButtonLarge = function PrimaryButtonLarge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'capitalize' : _ref$className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'button-primary' : _ref$dataTest;
  return /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
    className: "py-6 px-8 min-w-24 text-button-large focus:outline-none border-primary-button bg-primary-button text-primary-button font-button-large " + className,
    onClick: onClick,
    disabled: disabled,
    "data-test": dataTest,
    children: children
  });
};
var PrimaryButton = function PrimaryButton(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? 'capitalize' : _ref2$className,
    _ref2$onClick = _ref2.onClick,
    onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
    children = _ref2.children,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? 'button-primary' : _ref2$dataTest;
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    disabled: disabled,
    className: "py-4 px-3 text-button rounded-button border-button border-primary-button bg-primary-button text-primary-button disabled:opacity-50 font-button custom-primary-button primary-button font-button-regular " + className,
    onClick: onClick,
    "data-test": dataTest,
    children: children
  });
};

var SecondaryButtonLarge = function SecondaryButtonLarge(_ref) {
  var children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'capitalize' : _ref$className,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'button-secondary' : _ref$dataTest,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
    className: "py-6 px-8 min-w-24 focus:outline-none border-secondary-button bg-secondary-button text-secondary-button secondary-button-large font-button-large text-button-large " + className,
    disabled: disabled,
    "data-test": dataTest,
    onClick: onClick,
    children: children
  });
};
var SecondaryButton = function SecondaryButton(_ref2) {
  var children = _ref2.children,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? 'capitalize' : _ref2$className,
    _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? 'button-secondary' : _ref2$dataTest,
    _ref2$onClick = _ref2.onClick,
    onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick;
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    className: "py-4 px-6 text-button rounded-button border-button border-secondary-button bg-secondary-button text-secondary-button disabled:opacity-50 font-button custom-secondary-button secondary-button font-button-regular " + className,
    disabled: disabled,
    "data-test": dataTest,
    onClick: onClick,
    children: children
  });
};

var ModalFooter = function ModalFooter(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? null : _ref$action,
    _ref$actionText = _ref.actionText,
    actionText = _ref$actionText === void 0 ? null : _ref$actionText,
    _ref$allowAction = _ref.allowAction,
    allowAction = _ref$allowAction === void 0 ? true : _ref$allowAction,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? null : _ref$closeModal,
    _ref$closeText = _ref.closeText,
    closeText = _ref$closeText === void 0 ? null : _ref$closeText,
    _ref$allowClose = _ref.allowClose,
    allowClose = _ref$allowClose === void 0 ? true : _ref$allowClose,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$buttonsClassName = _ref.buttonsClassName,
    buttonsClassName = _ref$buttonsClassName === void 0 ? '' : _ref$buttonsClassName,
    _ref$spacer = _ref.spacer,
    spacer = _ref$spacer === void 0 ? null : _ref$spacer;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "modal-footer",
    className: "flex flex-wrap md:flex-nowrap p-3 md:p-8 border-t border-solid border-gray-300 rounded-b space-x-4 modal-footer " + className + " " + (spacer ? 'items-center justify-between' : 'items-center justify-end'),
    children: [closeModal && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
      className: "footer-action-button modal-footer-button min-w-24 " + buttonsClassName,
      onClick: closeModal,
      disabled: !allowClose,
      children: closeText
    }), spacer, action && /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
      className: "footer-action-button modal-footer-button min-w-24 " + buttonsClassName,
      onClick: action,
      disabled: !allowAction,
      children: actionText
    })]
  });
};

var ModalHeader = function ModalHeader(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? null : _ref$total,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "modal-header",
    className: "flex items-start justify-between p-3 md:p-8 border-b border-solid border-gray-300 rounded-t modal-text " + className,
    children: [/*#__PURE__*/jsxRuntime.jsx("h3", {
      className: "text-2xl md:text-5xl font-bold font-header modal-header",
      children: title
    }), total && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-2xl md:text-5xl font-bold",
      children: formatPrice({
        price: total
      })
    })]
  });
};

var Modal = function Modal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'modal' : _ref$dataTest,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'inset-0' : _ref$className,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? null : _ref$action,
    _ref$actionText = _ref.actionText,
    actionText = _ref$actionText === void 0 ? null : _ref$actionText,
    _ref$allowAction = _ref.allowAction,
    allowAction = _ref$allowAction === void 0 ? true : _ref$allowAction,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$ModalHeader = _ref.ModalHeader,
    ModalHeader$1 = _ref$ModalHeader === void 0 ? ModalHeader : _ref$ModalHeader,
    _ref$ModalFooter = _ref.ModalFooter,
    ModalFooter$1 = _ref$ModalFooter === void 0 ? ModalFooter : _ref$ModalFooter,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? null : _ref$closeModal,
    _ref$closeText = _ref.closeText,
    closeText = _ref$closeText === void 0 ? null : _ref$closeText,
    _ref$spacer = _ref.spacer,
    spacer = _ref$spacer === void 0 ? null : _ref$spacer,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$loadingTitle = _ref.loadingTitle,
    loadingTitle = _ref$loadingTitle === void 0 ? ' ' : _ref$loadingTitle,
    _ref$loadingMessage = _ref.loadingMessage,
    loadingMessage = _ref$loadingMessage === void 0 ? ' ' : _ref$loadingMessage,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$contentContainer = _ref.contentContainerClassName,
    contentContainerClassName = _ref$contentContainer === void 0 ? 'flex flex-col w-11/12 md:w-5/6 border-0 mx-auto rounded-lg shadow-lg bg-white max-h-full custom-modal bg-modal' : _ref$contentContainer,
    _ref$modalClassName = _ref.modalClassName,
    modalClassName = _ref$modalClassName === void 0 ? '' : _ref$modalClassName;
  if (!open) return null;
  var hasActions = (!!action || !!closeModal) && ModalFooter$1 !== null;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: "absolute flex flex-col items-center py-4 px-0 md:p-8 justify-center w-full h-full bg-gray-600 bg-opacity-70 z-50 " + className + " " + modalClassName,
    children: [isLoading && /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "container-loading-modal",
      className: "flex flex-col w-5/6 max-h-full mx-auto bg-white border-0 rounded-lg shadow-lg custom-modal bg-modal",
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/jsxRuntime.jsx(Loading, {
          title: loadingTitle,
          message: loadingMessage
        })
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "container-content-modal",
      className: contentContainerClassName + " " + (isLoading ? 'hidden' : ''),
      children: [title && /*#__PURE__*/jsxRuntime.jsx(ModalHeader$1, {
        title: title,
        formatPrice: formatPrice
      }), children, hasActions && /*#__PURE__*/jsxRuntime.jsx(ModalFooter$1, {
        action: action,
        actionText: actionText,
        allowAction: allowAction,
        closeModal: closeModal,
        closeText: closeText,
        spacer: spacer
      })]
    })]
  });
};

var TimeoutModal = function TimeoutModal(_ref) {
  var modalAccessibilityClass = _ref.modalAccessibilityClass,
    onTimeout = _ref.onTimeout,
    _ref$Modal = _ref.Modal,
    Modal$1 = _ref$Modal === void 0 ? Modal : _ref$Modal;
  var _useTimeoutModal = useTimeoutModal({
      onTimeout: onTimeout
    }),
    t = _useTimeoutModal.t,
    showWarning = _useTimeoutModal.showWarning,
    timeLeft = _useTimeoutModal.timeLeft,
    reset = _useTimeoutModal.reset,
    formatPrice = _useTimeoutModal.formatPrice;
  return /*#__PURE__*/jsxRuntime.jsx(Modal$1, {
    "data-test": "timeout-modal",
    className: modalAccessibilityClass,
    open: showWarning,
    title: t('timeoutModalTitle'),
    closeText: t('timeoutModalSecondaryAction'),
    closeModal: reset,
    formatPrice: formatPrice,
    children: /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-3xl p-8 modal-text modal-content",
      children: t('timeoutModalContentMessage', {
        timeLeft: timeLeft
      })
    })
  });
};

var BasketCount = function BasketCount(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    path = _ref.path,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$Icon = _ref.Icon,
    Icon = _ref$Icon === void 0 ? ShoppingCart : _ref$Icon,
    _ref$OverwriteIcon = _ref.OverwriteIcon,
    OverwriteIcon = _ref$OverwriteIcon === void 0 ? null : _ref$OverwriteIcon;
  var BasketIcon = OverwriteIcon || Icon;
  var BasketCountLink = function BasketCountLink(_ref2) {
    var _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className;
    if (count && !path) return /*#__PURE__*/jsxRuntime.jsx("a", {
      className: className,
      onClick: onClick,
      children: children
    });
    if (count > 0 && path) return /*#__PURE__*/jsxRuntime.jsx(reactRouterDom.Link, {
      "data-test": "view-order-button",
      className: className,
      to: path || '/customer-details',
      children: children
    });
    return /*#__PURE__*/jsxRuntime.jsx("span", {
      className: className,
      children: children
    });
  };
  return /*#__PURE__*/jsxRuntime.jsxs(BasketCountLink, {
    className: "relative inline-block " + className,
    children: [/*#__PURE__*/jsxRuntime.jsx(BasketIcon, {
      id: "cart-icon",
      className: "w-8 h-auto md:w-16"
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      "data-test": "basket-count",
      className: "absolute inline-flex items-center justify-center w-6 h-6 text-lg font-bold rounded-full -top-1 md:-top-2 -right-1 md:-right-2 md:w-12 md:h-12 sm:text-2xl text-secondary bg-primary",
      children: count ? count : '0'
    })]
  });
};

var REFUND_PREFIX = 'Refund_';
var useTransactions = function useTransactions() {
  var _useCart = cart.useCart(),
    cart$1 = _useCart.cart;
  var _useRecoilState = recoil.useRecoilState(atoms.transactionsState),
    transactions = _useRecoilState[0],
    setTransactions = _useRecoilState[1];
  var total = recoil.useRecoilValue(atoms.orderTotalState);
  var beacon = recoil.useRecoilValue(atoms.beaconState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var payment = recoil.useRecoilValue(atoms.formattedPaymentState);
  var customer = recoil.useRecoilValue(atoms.customerState);
  var removeCurrentSessionFilter = React.useCallback(function (transaction, formatted) {
    var _transaction$session, _formatted$session;
    return (transaction == null ? void 0 : (_transaction$session = transaction.session) == null ? void 0 : _transaction$session.id) !== (formatted == null ? void 0 : (_formatted$session = formatted.session) == null ? void 0 : _formatted$session.id);
  }, []);
  var updateTransaction = React.useCallback(function (_ref) {
    var transactionToUpdate = _ref.transactionToUpdate;
    try {
      var formattedTransaction = transactionToUpdate;
      setTransactions(function (transactions) {
        var formattedTransactions = [].concat(transactions.filter(function (transaction) {
          return removeCurrentSessionFilter(transaction, formattedTransaction);
        }), [formattedTransaction]);
        storage.setTransactions('restaurant/transactions', formattedTransactions);
        return formattedTransactions;
      });
    } catch (err) {
      logger.error('cringer.components - updateTransaction - error to update a transaction into the local storage:', err);
    }
  }, [setTransactions, removeCurrentSessionFilter]);
  var addTransaction = React.useCallback(function (_ref2) {
    var status = _ref2.status,
      message = _ref2.message,
      receiptId = _ref2.receiptId,
      orderStatus = _ref2.orderStatus,
      _ref2$useExistingCart = _ref2.useExistingCart,
      useExistingCart = _ref2$useExistingCart === void 0 ? false : _ref2$useExistingCart,
      _ref2$currentTransact = _ref2.currentTransaction,
      currentTransaction = _ref2$currentTransact === void 0 ? {} : _ref2$currentTransact,
      _ref2$refundInformati = _ref2.refundInformation,
      refundInformation = _ref2$refundInformati === void 0 ? {} : _ref2$refundInformati,
      formattedLastName = _ref2.formattedLastName,
      orderNumber = _ref2.orderNumber;
    var existingCart = currentTransaction.cart,
      existingMessage = currentTransaction.message,
      existingSession = currentTransaction.session,
      existingTotal = currentTransaction.total;
    var formattedCart = useExistingCart ? JSON.parse(JSON.stringify(existingCart)) : JSON.parse(JSON.stringify(cart$1));
    try {
      var formattedTransaction = {
        status: status,
        message: '',
        session: {},
        payment: {},
        cart: {},
        total: '',
        receiptId: ''
      };
      if (useExistingCart) {
        formattedTransaction.message = existingMessage;
        formattedTransaction.session = _extends({}, existingSession, {
          orderNumber: orderNumber || (existingSession == null ? void 0 : existingSession.orderNumber),
          id: "" + REFUND_PREFIX + existingSession.id,
          customer: _extends({}, customer, {
            lastName: formattedLastName || (customer == null ? void 0 : customer.lastName)
          }),
          beaconNumber: !!beacon ? parseInt(beacon) : null,
          status: orderStatus || (session == null ? void 0 : session.status)
        });
        formattedTransaction.payment = refundInformation;
        formattedTransaction.cart = formattedCart;
        formattedTransaction.total = existingTotal;
        formattedTransaction.receiptId = receiptId;
      } else {
        formattedTransaction.message = message;
        formattedTransaction.session = _extends({}, session, {
          orderNumber: orderNumber || (session == null ? void 0 : session.orderNumber),
          customer: _extends({}, customer, {
            lastName: formattedLastName || (customer == null ? void 0 : customer.lastName)
          }),
          beaconNumber: !!beacon ? parseInt(beacon) : null,
          status: orderStatus || (session == null ? void 0 : session.status)
        });
        formattedTransaction.payment = payment;
        formattedTransaction.cart = formattedCart;
        formattedTransaction.total = total;
        formattedTransaction.receiptId = receiptId;
      }
      setTransactions(function (transactions) {
        var formattedTransactions = [].concat(transactions.filter(function (transaction) {
          return removeCurrentSessionFilter(transaction, formattedTransaction);
        }), [formattedTransaction]);
        storage.setTransactions('restaurant/transactions', formattedTransactions);
        return formattedTransactions;
      });
    } catch (err) {
      logger.error('cringer.components - addTransaction - error to add a transaction into the local storage:', err);
    }
  }, [cart$1, payment, session, total, setTransactions, customer, beacon, removeCurrentSessionFilter]);
  return {
    addTransaction: addTransaction,
    transactions: transactions,
    updateTransaction: updateTransaction
  };
};

var useCancelOrder = function useCancelOrder() {
  var history = reactRouterDom.useHistory();
  var _useTransactions = useTransactions(),
    addTransaction = _useTransactions.addTransaction;
  var setSession = recoil.useSetRecoilState(atoms.sessionState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var cancelReason = 'CANCELLED_BY_CUSTOMER';
  var cancelOrder = React.useCallback(function () {
    setSession(_extends({}, session, {
      cancelReason: cancelReason
    }));
    addTransaction({
      status: 'ORDER_CANCELLED'
    });
  }, [addTransaction, setSession, session]);
  React.useEffect(function () {
    if (session && !!(session != null && session.cancelReason)) {
      history.push('/reset');
    }
  }, [history, session]);
  return {
    cancelOrder: cancelOrder
  };
};

var useCancelOrderButton = function useCancelOrderButton() {
  var _useState = React.useState(false),
    showModal = _useState[0],
    setShowModal = _useState[1];
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useCancelOrder = useCancelOrder(),
    cancelOrder = _useCancelOrder.cancelOrder;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var modalAccessibilityClass = accessibilityEnabled ? 'h-half bottom-0 left-0 right-0' : 'inset-0';
  var open = function open() {
    return setShowModal(true);
  };
  var close = function close() {
    return setShowModal(false);
  };
  return {
    t: t,
    confirm: cancelOrder,
    close: close,
    showModal: showModal,
    open: open,
    modalAccessibilityClass: modalAccessibilityClass,
    formatPrice: formatPrice
  };
};

var CancelOrderButton = function CancelOrderButton(_ref) {
  var _ref$Modal = _ref.Modal,
    Modal$1 = _ref$Modal === void 0 ? Modal : _ref$Modal,
    _ref$Button = _ref.Button,
    Button = _ref$Button === void 0 ? SecondaryButton : _ref$Button,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    dataTest = _ref['data-test'];
  var _useCancelOrderButton = useCancelOrderButton(),
    t = _useCancelOrderButton.t,
    confirm = _useCancelOrderButton.confirm,
    close = _useCancelOrderButton.close,
    showModal = _useCancelOrderButton.showModal,
    open = _useCancelOrderButton.open,
    modalAccessibilityClass = _useCancelOrderButton.modalAccessibilityClass,
    formatPrice = _useCancelOrderButton.formatPrice;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(Button, {
      onClick: open,
      className: "focus:outline-none cancel-order-button " + className,
      "data-test": dataTest,
      children: children
    }), /*#__PURE__*/jsxRuntime.jsx(Modal$1, {
      className: modalAccessibilityClass,
      open: showModal,
      title: t('cancelOrderButtonModalTitle'),
      action: close,
      closeModal: confirm,
      actionText: t('cancelOrderButtonModalPrimaryAction'),
      closeText: t('cancelOrderButtonModalSecondaryAction'),
      formatPrice: formatPrice,
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "p-2 xs:p-4 md:p-8 text-xl xs:text-2xl md:text-3xl cancel-order-modal-text",
        children: t('cancelOrderButtonModalQuestion')
      })
    })]
  });
};

var FooterWrapper = function FooterWrapper(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$nextText = _ref.nextText,
    nextText = _ref$nextText === void 0 ? 'Next' : _ref$nextText,
    _ref$nextAction = _ref.nextAction,
    nextAction = _ref$nextAction === void 0 ? null : _ref$nextAction,
    _ref$isNextActionOnBo = _ref.isNextActionOnBottom,
    isNextActionOnBottom = _ref$isNextActionOnBo === void 0 ? false : _ref$isNextActionOnBo,
    _ref$isBasketCountOnB = _ref.isBasketCountOnBottom,
    isBasketCountOnBottom = _ref$isBasketCountOnB === void 0 ? false : _ref$isBasketCountOnB,
    _ref$isQuantityContro = _ref.isQuantityControllerOnBottom,
    isQuantityControllerOnBottom = _ref$isQuantityContro === void 0 ? false : _ref$isQuantityContro,
    _ref$allowNextAction = _ref.allowNextAction,
    allowNextAction = _ref$allowNextAction === void 0 ? true : _ref$allowNextAction,
    _ref$nextActionClass = _ref.nextActionClass,
    nextActionClass = _ref$nextActionClass === void 0 ? '' : _ref$nextActionClass,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$spacer = _ref.spacer,
    spacer = _ref$spacer === void 0 ? null : _ref$spacer,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$enableCancelOrde = _ref.enableCancelOrder,
    enableCancelOrder = _ref$enableCancelOrde === void 0 ? false : _ref$enableCancelOrde,
    _ref$enableCustomCanc = _ref.enableCustomCancelOrder,
    enableCustomCancelOrder = _ref$enableCustomCanc === void 0 ? false : _ref$enableCustomCanc,
    _ref$cancelOrderText = _ref.cancelOrderText,
    cancelOrderText = _ref$cancelOrderText === void 0 ? 'Cancel' : _ref$cancelOrderText,
    _ref$showAccessibilit = _ref.showAccessibilityButton,
    showAccessibilityButton = _ref$showAccessibilit === void 0 ? false : _ref$showAccessibilit,
    _ref$showBasketCount = _ref.showBasketCount,
    showBasketCount = _ref$showBasketCount === void 0 ? true : _ref$showBasketCount,
    _ref$onBasketClick = _ref.onBasketClick,
    onBasketClick = _ref$onBasketClick === void 0 ? function () {} : _ref$onBasketClick,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? null : _ref$total,
    _ref$OverwriteCartIco = _ref.OverwriteCartIcon,
    OverwriteCartIcon = _ref$OverwriteCartIco === void 0 ? null : _ref$OverwriteCartIco,
    _ref$CustomSecondaryB = _ref.CustomSecondaryButton,
    CustomSecondaryButton = _ref$CustomSecondaryB === void 0 ? SecondaryButtonLarge : _ref$CustomSecondaryB,
    _ref$CustomNextAction = _ref.CustomNextActionButton,
    CustomNextActionButton = _ref$CustomNextAction === void 0 ? PrimaryButtonLarge : _ref$CustomNextAction,
    _ref$CustomPreviousAc = _ref.CustomPreviousActionButton,
    CustomPreviousActionButton = _ref$CustomPreviousAc === void 0 ? PrimaryButtonLarge : _ref$CustomPreviousAc,
    _ref$BasketCount = _ref.BasketCount,
    BasketCount$1 = _ref$BasketCount === void 0 ? BasketCount : _ref$BasketCount,
    _ref$couponText = _ref.couponText,
    couponText = _ref$couponText === void 0 ? 'Enter offer' : _ref$couponText,
    _ref$couponAction = _ref.couponAction,
    couponAction = _ref$couponAction === void 0 ? function () {} : _ref$couponAction,
    _ref$isPreviousAction = _ref.isPreviousActionEnabled,
    isPreviousActionEnabled = _ref$isPreviousAction === void 0 ? false : _ref$isPreviousAction,
    _ref$allowPreviousAct = _ref.allowPreviousAction,
    allowPreviousAction = _ref$allowPreviousAct === void 0 ? true : _ref$allowPreviousAct,
    _ref$previousText = _ref.previousText,
    previousText = _ref$previousText === void 0 ? 'Back' : _ref$previousText,
    _ref$previousAction = _ref.previousAction,
    previousAction = _ref$previousAction === void 0 ? null : _ref$previousAction,
    _ref$isAnimationTarge = _ref.isAnimationTargetEnabled,
    isAnimationTargetEnabled = _ref$isAnimationTarge === void 0 ? false : _ref$isAnimationTarge,
    _ref$shouldShowCoupon = _ref.shouldShowCoupon,
    shouldShowCoupon = _ref$shouldShowCoupon === void 0 ? false : _ref$shouldShowCoupon,
    _ref$isFooterStyleVar = _ref.isFooterStyleVariationEnabled,
    isFooterStyleVariationEnabled = _ref$isFooterStyleVar === void 0 ? false : _ref$isFooterStyleVar,
    _ref$hasUnavailableIt = _ref.hasUnavailableItems,
    hasUnavailableItems = _ref$hasUnavailableIt === void 0 ? false : _ref$hasUnavailableIt,
    _ref$isDefaultButtonP = _ref.isDefaultButtonPaddingEnabled,
    isDefaultButtonPaddingEnabled = _ref$isDefaultButtonP === void 0 ? true : _ref$isDefaultButtonP,
    _ref$termsAndConditio = _ref.termsAndConditionsButtonText,
    termsAndConditionsButtonText = _ref$termsAndConditio === void 0 ? '' : _ref$termsAndConditio,
    _ref$showTermsAndCond = _ref.showTermsAndConditionsButton,
    showTermsAndConditionsButton = _ref$showTermsAndCond === void 0 ? false : _ref$showTermsAndCond,
    _ref$setShowTermsAndC = _ref.setShowTermsAndConditionsModal,
    setShowTermsAndConditionsModal = _ref$setShowTermsAndC === void 0 ? function () {} : _ref$setShowTermsAndC,
    _ref$skipAction = _ref.skipAction,
    skipAction = _ref$skipAction === void 0 ? null : _ref$skipAction,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  var footerStyleVariation = isFooterStyleVariationEnabled && "\n    " + (!!spacer || shouldShowCoupon ? 'is-footer-with-coupon' : 'is-not-footer-with-coupon');
  var largeButtons = isDefaultButtonPaddingEnabled ? "md:h-24 md:px-12" : "md:h-24";
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "footer",
    className: "flex justify-center md:justify-between items-center p-2 md:px-8 md:py-8 bg-accessory md:space-x-8 footer bg-bottom footer-main-div " + footerStyleVariation + " " + className,
    children: [isAnimationTargetEnabled && /*#__PURE__*/jsxRuntime.jsx("div", {
      id: "cart-icon",
      className: "absolute left-0 right-0 invisible w-24 ml-auto mr-auto"
    }), showAccessibilityButton && /*#__PURE__*/jsxRuntime.jsx(AccessibilityButton, {
      className: "hidden w-24 h-24 p-2 shadow-lg md:block"
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "footer-inputs",
      className: "flex items-center justify-end md:h-24 footer-inputs ",
      children: [previousAction && isPreviousActionEnabled && /*#__PURE__*/jsxRuntime.jsx(CustomPreviousActionButton, {
        "data-test": "previous-action-button",
        disabled: !allowPreviousAction,
        onClick: previousAction,
        className: largeButtons + " previous-action-button footer-action-button ",
        children: previousText
      }), (enableCancelOrder || enableCustomCancelOrder) && /*#__PURE__*/jsxRuntime.jsx(CancelOrderButton, {
        "data-test": "cancel-action-button",
        className: largeButtons + " cancel-action-button footer-action-button " + (previousAction && isPreviousActionEnabled && 'hidden'),
        Button: CustomSecondaryButton,
        children: cancelOrderText
      }), shouldShowCoupon && /*#__PURE__*/jsxRuntime.jsx(CustomSecondaryButton, {
        "data-test": "coupon-action-button",
        className: "ml-4 font-bold text-3xl h-full coupon-action-button footer-action-button  " + largeButtons,
        onClick: couponAction,
        children: couponText
      }), showTermsAndConditionsButton && /*#__PURE__*/jsxRuntime.jsx(CustomNextActionButton, {
        className: "ml-4 next-action-button " + nextActionClass + " footer-action-button " + largeButtons,
        onClick: function onClick() {
          return setShowTermsAndConditionsModal(true);
        },
        "data-test": "terms-and-conditions-button",
        children: termsAndConditionsButtonText
      }), skipAction && /*#__PURE__*/jsxRuntime.jsx(CustomSecondaryButton, {
        onClick: skipAction,
        className: "ml-4 next-action-button " + nextActionClass + " footer-action-button " + largeButtons,
        "data-test": "skip-action-button",
        children: t('customerDetailsFormSecondaryAction')
      }), !isQuantityControllerOnBottom && spacer, !!nextAction && !isNextActionOnBottom && /*#__PURE__*/jsxRuntime.jsx(CustomNextActionButton, {
        className: "ml-4 next-action-button " + nextActionClass + " footer-action-button " + largeButtons,
        disabled: !allowNextAction,
        onClick: nextAction,
        "data-test": "next-action-button",
        children: nextText
      }), showBasketCount && !isBasketCountOnBottom && !hasUnavailableItems && /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex footer-basket-wrapper",
        children: [/*#__PURE__*/jsxRuntime.jsx(BasketCount$1, {
          className: "md:ml-8",
          count: count,
          onClick: onBasketClick,
          OverwriteIcon: OverwriteCartIcon
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "footer-cart-subtotal",
          className: "self-center text-xs font-bold xs:text-base md:text-4xl md:ml-8 footer-total",
          children: total
        })]
      })]
    })]
  });
};

var AdditionalFooter = function AdditionalFooter(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$nextText = _ref.nextText,
    nextText = _ref$nextText === void 0 ? 'Next' : _ref$nextText,
    _ref$nextAction = _ref.nextAction,
    nextAction = _ref$nextAction === void 0 ? null : _ref$nextAction,
    _ref$isNextActionOnBo = _ref.isNextActionOnBottom,
    isNextActionOnBottom = _ref$isNextActionOnBo === void 0 ? false : _ref$isNextActionOnBo,
    _ref$isBasketCountOnB = _ref.isBasketCountOnBottom,
    isBasketCountOnBottom = _ref$isBasketCountOnB === void 0 ? false : _ref$isBasketCountOnB,
    _ref$isQuantityContro = _ref.isQuantityControllerOnBottom,
    isQuantityControllerOnBottom = _ref$isQuantityContro === void 0 ? false : _ref$isQuantityContro,
    _ref$isPriceOnEnd = _ref.isPriceOnEnd,
    isPriceOnEnd = _ref$isPriceOnEnd === void 0 ? false : _ref$isPriceOnEnd,
    _ref$allowNextAction = _ref.allowNextAction,
    allowNextAction = _ref$allowNextAction === void 0 ? true : _ref$allowNextAction,
    _ref$nextActionClass = _ref.nextActionClass,
    nextActionClass = _ref$nextActionClass === void 0 ? '' : _ref$nextActionClass,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$spacer = _ref.spacer,
    spacer = _ref$spacer === void 0 ? null : _ref$spacer,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$showBasketCount = _ref.showBasketCount,
    showBasketCount = _ref$showBasketCount === void 0 ? true : _ref$showBasketCount,
    _ref$onBasketClick = _ref.onBasketClick,
    onBasketClick = _ref$onBasketClick === void 0 ? function () {} : _ref$onBasketClick,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? null : _ref$total,
    _ref$OverwriteCartIco = _ref.OverwriteCartIcon,
    OverwriteCartIcon = _ref$OverwriteCartIco === void 0 ? null : _ref$OverwriteCartIco,
    _ref$BasketCount = _ref.BasketCount,
    BasketCount$1 = _ref$BasketCount === void 0 ? BasketCount : _ref$BasketCount,
    _ref$basketText = _ref.basketText,
    basketText = _ref$basketText === void 0 ? null : _ref$basketText,
    _ref$previousAction = _ref.previousAction,
    previousAction = _ref$previousAction === void 0 ? null : _ref$previousAction,
    _ref$isPreviousAction = _ref.isPreviousActionOnBottom,
    isPreviousActionOnBottom = _ref$isPreviousAction === void 0 ? false : _ref$isPreviousAction,
    _ref$previousText = _ref.previousText,
    previousText = _ref$previousText === void 0 ? '' : _ref$previousText,
    _ref$isViewOrderDisab = _ref.isViewOrderDisabled,
    isViewOrderDisabled = _ref$isViewOrderDisab === void 0 ? false : _ref$isViewOrderDisab;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "additional-footer",
    className: "flex py-8 bg-footer w-full z-0 justify-between " + className,
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "additional-footer-inputs",
      className: "flex mx-4 justify-between w-full additional-footer-inputs " + className,
      children: [showBasketCount && isBasketCountOnBottom && /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/jsxRuntime.jsx(BasketCount$1, {
          className: "",
          count: count,
          onClick: onBasketClick,
          OverwriteIcon: OverwriteCartIcon,
          text: basketText,
          isViewOrderDisabled: isViewOrderDisabled
        }), !isPriceOnEnd && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "self-center ml-8 text-4xl font-bold",
          children: total
        })]
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex flex-col items-end space-x-4 " + (showBasketCount && isBasketCountOnBottom ? "w-3/4" : "w-full"),
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex items-center",
          children: [isQuantityControllerOnBottom && spacer, previousAction && isPreviousActionOnBottom && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
            "data-test": "previous-action-button",
            onClick: previousAction,
            className: "ml-6 previous-action-button " + nextActionClass,
            children: previousText
          }), nextAction && isNextActionOnBottom && /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
            "data-test": "next-action-button",
            disabled: !allowNextAction,
            onClick: nextAction,
            className: "ml-6 next-action-button " + nextActionClass,
            children: nextText
          }), isPriceOnEnd && /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "additional-footer-price",
            className: "self-center ml-8 text-4xl font-bold",
            children: total
          })]
        })
      })]
    })
  });
};

var translateProductName = function translateProductName(i18nLang) {
  return function (name) {
    var key = name == null ? void 0 : name.text;
    var language = i18nLang !== 'en' ? i18nLang : 'eng';
    var translations = (name == null ? void 0 : name.translations) || [];

    // No key just return empty string
    if (!key) return '';
    var current = translations == null ? void 0 : translations.find(function (translation) {
      var _translation$language;
      return (translation == null ? void 0 : (_translation$language = translation.language) == null ? void 0 : _translation$language.toLowerCase()) === (language == null ? void 0 : language.toLowerCase());
    });
    // Fallback to english key
    return (current == null ? void 0 : current.text) || key;
  };
};

var useOffersAndRewardsMenu = function useOffersAndRewardsMenu() {
  var offersAndRewards = recoil.useRecoilValue(atoms.offersAndRewardsState);
  var formattedProducts = recoil.useRecoilValue(atoms.formattedProductsState);
  var getPromoItem = React.useCallback(function (_ref) {
    var productId = _ref.productId,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      type = _ref.type;
    var product = formattedProducts == null ? void 0 : formattedProducts.find(function (item) {
      return item.id === productId;
    });
    if (!product) {
      return null;
    }
    var promos = [].concat(offersAndRewards.promosWithPoints, offersAndRewards.promos);
    var promoItem = promos == null ? void 0 : promos.find(function (reward) {
      return reward.promoId === product.providerData.PromoId;
    });
    if (type === 'combo' && promoItem) {
      var _title$split$map = title.split('-').map(function (namePart) {
          return namePart.trim();
        }),
        productSize = _title$split$map[1];
      var translatedNameWithSize = lodash.compact([promoItem.name, productSize]).join(' - ');
      return _extends({}, promoItem, {
        name: translatedNameWithSize
      });
    }
    return promoItem;
  }, [formattedProducts, offersAndRewards]);
  return {
    offersAndRewards: offersAndRewards,
    getPromoItem: getPromoItem,
    offerInCart: false // TODO: move this logic outside of this hook SUPERAPAC-880
  };
};

var reduceCustomisationDefaults = function reduceCustomisationDefaults(result, current) {
  var _extends2;
  var min = current.min,
    max = current.max,
    products = current.products;
  var newProducts = products.filter(function (product) {
    return product["default"];
  });
  return _extends({}, result, (_extends2 = {}, _extends2[current.id] = {
    products: newProducts,
    min: min,
    max: max
  }, _extends2));
};
// Should there be a consistent format for these types of things?
// The `customisation` format seems more fullproof, but I dont want to
// abstract early in case this isnt true for all product types in future

var reduceComboDefaults = function reduceComboDefaults(result, current) {
  var _extends3;
  var id = current.id,
    products = current.products;
  var newProducts = products.filter(function (product) {
    return product["default"];
  });
  return _extends({}, result, (_extends3 = {}, _extends3[id] = newProducts, _extends3));
};
var getUpsellCategoryById = function getUpsellCategoryById(upsells, categoryId, filterId) {
  if (filterId === void 0) {
    filterId = null;
  }
  var _upsells$filter = upsells.filter(function (upsell) {
      //Check filter size is being passed and exists in the upsells object
      //This enables different upsells for different sizes (in combos)
      if (filterId && upsell.filterId) {
        return "" + categoryId === "" + upsell.id && "" + filterId === "" + upsell.filterId;
      }
      return "" + categoryId === "" + upsell.id;
    }),
    upsell = _upsells$filter[0];
  return upsell;
};
var getProductById = function getProductById(_ref) {
  var products = _ref.products,
    id = _ref.id;
  return products == null ? void 0 : products.find(function (product) {
    return "" + product.id === "" + id;
  });
};
var getOptionCustomisationsByUid = function getOptionCustomisationsByUid(_ref2) {
  var product = _ref2.product,
    uid = _ref2.uid;
  var _ref3 = product || {},
    _ref3$options = _ref3.options,
    options = _ref3$options === void 0 ? [] : _ref3$options;
  var result = [];
  options.forEach(function (option) {
    var _option$products = option.products,
      products = _option$products === void 0 ? [] : _option$products;
    var productCustomisation = products == null ? void 0 : products.find(function (optionProduct) {
      var _optionProduct$uid = optionProduct.uid,
        optionProductUid = _optionProduct$uid === void 0 ? '' : _optionProduct$uid;
      return optionProductUid === uid;
    });
    if (productCustomisation) result.push.apply(result, productCustomisation.customisations);
  });
  return result;
};
var isValid = function isValid(value) {
  return value && value.length;
};
var generateValidPayload = function generateValidPayload(input, value) {
  if (input === void 0) {
    input = [];
  }
  if (isValid(input)) return [].concat(input);
  return [value];
};
var withinTime = function withinTime(_ref4) {
  var toHour = _ref4.toHour,
    fromHour = _ref4.fromHour,
    current = _ref4.current,
    fromString = _ref4.fromString,
    toString = _ref4.toString;
  // NOTE only check if we have valid to and from hours
  // Seconds fallback to zero if not provided
  if (lodash.isNumber(toHour) && lodash.isNumber(fromHour)) {
    // This only works in the scope of a 24 hour day
    // i.e 8:00 - 14:30 works
    // 14:30 - 8:00 does not
    return dateFns.isWithinInterval(current, {
      start: dateFns.parse(fromString, 'HH:mm', current),
      end: dateFns.parse(toString, 'HH:mm', current)
    });
  } else return true;
};
var filterByVisibilityFlag = function filterByVisibilityFlag(entity) {
  var isVisible = entity.isVisible;
  // Let through if not explicitly false
  var empty = isVisible === null || isVisible === undefined;
  return empty ? true : isVisible;
};
var isAvailabilityValid = function isAvailabilityValid(value) {
  return value && value.length && value.every(function (item) {
    return !lodash.isEmpty(item);
  });
};
var filterByTimeRestrictions = function filterByTimeRestrictions(settings) {
  return function (entity) {
    var availability = entity.availability;
    var _ref5 = settings || {},
      kioskSettings = _ref5.settings,
      flags = _ref5.flags;
    var _ref6 = kioskSettings || {},
      timezone = _ref6.timezone;
    var isAvailabilityEnabled = flags.kiosksYumAuDaypartingEnabled;

    // For all organizations except YUM AU, the "kiosksYumAuDayparting" feature is enabled.
    // This check ensures the feature is bypassed if availability is invalid or if it's explicitly disabled for YUM AU.
    if (!isAvailabilityValid(availability) || !isAvailabilityEnabled) {
      return true;
    }
    return availability.some(function (availabilityIterator) {
      var to = availabilityIterator.to,
        from = availabilityIterator.from,
        year = availabilityIterator.year,
        month = availabilityIterator.month,
        date = availabilityIterator.day,
        weekday = availabilityIterator.weekday;
      var _ref7 = from || {},
        fromHour = _ref7.hour,
        fromMinute = _ref7.minute;
      var _ref8 = to || {},
        toHour = _ref8.hour,
        toMinute = _ref8.minute;
      var fromString = (fromHour != null ? fromHour : 0).toString().padStart(2, '0') + ":" + (fromMinute || 0).toString().padStart(2, '0');
      var toString = (toHour != null ? toHour : 0).toString().padStart(2, '0') + ":" + (toMinute || 0).toString().padStart(2, '0');
      var current = dateFnsTz.utcToZonedTime(new Date(), timezone);
      var dayMap = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      var allDates = [];
      var validYears = generateValidPayload(year, dateFns.getYear(current));
      var validMonths = generateValidPayload(month, dateFns.getMonth(current));
      var validDates = generateValidPayload(date, dateFns.getDate(current));
      var validWeekday = generateValidPayload(weekday, dayMap[dateFns.getDay(current)]);
      validYears.forEach(function (yearIterator) {
        validMonths.forEach(function (monthIterator) {
          validDates.forEach(function (dateIterator) {
            var newDate = new Date(yearIterator, monthIterator, dateIterator);
            allDates.push(newDate);
          });
        });
      });
      var isWithinDates = allDates.map(function (item) {
        // Cannot use isEqual given different timestamp on current
        return dateFns.isSameDay(item, current);
      });
      var isWithinWeek = validWeekday.map(function (item) {
        return dayMap.indexOf(item) === dateFns.getDay(current);
      });
      var compare = dateFns.compareAsc(dateFns.parse(fromString, 'HH:mm', current), dateFns.parse(toString, 'HH:mm', current));

      // Handles time comparisons when intervals span past midnight.
      // If `fromString` is greater than `toString` (indicating a wrap around midnight):
      // - Check if the current time falls within the interval from `fromString` to 23:59.
      // - Additionally, check if the current time falls within the interval from 00:00 to `toString`.
      if (compare === 1) {
        var fromInterval = dateFns.isWithinInterval(current, {
          start: dateFns.parse(fromString, 'HH:mm', current),
          end: dateFns.parse('23:59', 'HH:mm', current)
        });
        var toInterval = dateFns.isWithinInterval(current, {
          start: dateFns.parse('00:00', 'HH:mm', current),
          end: dateFns.parse(toString, 'HH:mm', current)
        });
        return lodash.some(isWithinDates) && lodash.some(isWithinWeek) && (fromInterval || toInterval);
      } else {
        var isWithinTime = withinTime({
          fromHour: fromHour,
          toHour: toHour,
          fromString: fromString,
          toString: toString,
          current: current
        });
        return lodash.some(isWithinDates) && lodash.some(isWithinWeek) && isWithinTime;
      }
    });
  };
};
var getHydratedProductsByPromoId = function getHydratedProductsByPromoId(_ref9) {
  var productsWithPromoId = _ref9.productsWithPromoId,
    hydratedProducts = _ref9.hydratedProducts;
  var result = hydratedProducts.filter(function (product) {
    return productsWithPromoId.some(function (productWithPromoId) {
      return productWithPromoId.promoId === product.providerData.PromoId;
    });
  });
  var sortedResult = lodash.sortBy(result, [function (product) {
    return productsWithPromoId.findIndex(function (p) {
      return p.promoId === product.providerData.PromoId;
    });
  }]);
  return sortedResult;
};
var getHydratedProductsFromCategory = function getHydratedProductsFromCategory(_temp) {
  var _ref10 = _temp === void 0 ? {} : _temp,
    category = _ref10.category,
    offersAndRewards = _ref10.offersAndRewards,
    id = _ref10.id,
    hydratedProducts = _ref10.hydratedProducts;
  if (id === 'offers') {
    return getHydratedProductsByPromoId({
      productsWithPromoId: offersAndRewards.promos,
      hydratedProducts: hydratedProducts
    });
  }
  if (id === 'rewards') {
    return getHydratedProductsByPromoId({
      productsWithPromoId: offersAndRewards.promosWithPoints,
      hydratedProducts: hydratedProducts
    });
  }
  var _ref11 = category || {},
    _ref11$products = _ref11.products,
    categoryProductIds = _ref11$products === void 0 ? [] : _ref11$products;
  //filter at the end to return only products that are available
  //in case a product from a category can't be shown (day/time restrictions)
  //this prevents empty items in the array
  return categoryProductIds == null ? void 0 : categoryProductIds.map(function (categoryProductId) {
    return hydratedProducts == null ? void 0 : hydratedProducts.find(function (hydratedProduct) {
      var _ref12 = hydratedProduct || {},
        productId = _ref12.productId;
      return categoryProductId === productId;
    });
  }).filter(function (product) {
    return product != null;
  });
};
var updatePricesByTimeRestrictions = function updatePricesByTimeRestrictions(_ref13) {
  var product = _ref13.product,
    settings = _ref13.settings;
  var productToUpdate = _extends({}, product);
  var _ref14 = settings || {},
    timezone = _ref14.timezone;
  var _productToUpdate$pric = productToUpdate.priceChanges,
    priceChanges = _productToUpdate$pric === void 0 ? null : _productToUpdate$pric;
  var current = dateFnsTz.utcToZonedTime(new Date(), timezone);
  var updatePrice = false;
  var surcharge;
  if (!priceChanges) return productToUpdate;
  priceChanges.forEach(function (priceChange) {
    var from = priceChange.from,
      to = priceChange.to,
      surchargePrice = priceChange.price;
    var _ref15 = from || {},
      fromHour = _ref15.hour,
      fromMinute = _ref15.minute;
    var _ref16 = to || {},
      toHour = _ref16.hour,
      toMinute = _ref16.minute;
    var fromString = fromHour + ":" + (fromMinute || 0);
    var toString = toHour + ":" + (toMinute || 0);
    var compare = dateFns.compareAsc(dateFns.parse(fromString, 'HH:mm', current), dateFns.parse(toString, 'HH:mm', current));
    if (compare === 1) {
      var fromInterval = dateFns.isWithinInterval(current, {
        start: dateFns.parse(fromString, 'HH:mm', current),
        end: dateFns.parse('23:59', 'HH:mm', current)
      });
      var toInterval = dateFns.isWithinInterval(current, {
        start: dateFns.parse('00:00', 'HH:mm', current),
        end: dateFns.parse(toString, 'HH:mm', current)
      });
      if (fromInterval || toInterval) {
        updatePrice = true;
        surcharge = surchargePrice;
      }
    } else {
      var withinInterval = dateFns.isWithinInterval(current, {
        start: dateFns.parse(fromString, 'HH:mm', current),
        end: dateFns.parse(toString, 'HH:mm', current)
      });
      if (withinInterval) {
        updatePrice = true;
        surcharge = surchargePrice;
      }
    }
  });
  if (productToUpdate.type === 'combo') {
    var filters = productToUpdate.combo.filters.map(function (product) {
      return updatePricesByTimeRestrictions({
        product: product,
        settings: settings
      });
    });
    var options = productToUpdate.options.map(function (product) {
      return updatePricesByTimeRestrictions({
        product: product,
        settings: settings
      });
    });
    productToUpdate.combo = _extends({}, productToUpdate.combo, {
      filters: filters
    });
    productToUpdate.options = options;
  }
  var updatedProduct = _extends({}, productToUpdate, {
    price: updatePrice ? surcharge : productToUpdate.price
  });
  return updatedProduct;
};
var filterImageUrlFallback = function filterImageUrlFallback(product) {
  /**
   * Ensures products have a valid imageUrl. Falls back to originalImageUrl if imageUrl is empty, null, or undefined.
   * Addresses cases where Firebase fails to trigger, causing missing images in some menus.
   */
  var formattedImageUrl = !product.imageUrl || product.imageUrl === null || product.imageUrl === '' || product.imageUrl.toLowerCase() === 'no image found' ? product.originalImageUrl : product.imageUrl;
  return _extends({}, product, {
    imageUrl: formattedImageUrl
  });
};

var screenshot = function screenshot() {
  return function () {
    html2canvas(document.body, {
      logging: false
    });
  };
};
var lock = function lock(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$history = _ref.history,
    history = _ref$history === void 0 ? null : _ref$history,
    _ref$setLock = _ref.setLock,
    setLock = _ref$setLock === void 0 ? null : _ref$setLock,
    _ref$setLockMessageRe = _ref.setLockMessageRecoilState,
    setLockMessageRecoilState = _ref$setLockMessageRe === void 0 ? null : _ref$setLockMessageRe;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_temp2) {
      var _ref3, _ref3$message, message, _ref3$state, state;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$message = _ref3.message, message = _ref3$message === void 0 ? 'lockMessage' : _ref3$message, _ref3$state = _ref3.state, state = _ref3$state === void 0 ? 'MANUAL_LOCK' : _ref3$state;
            _context.prev = 1;
            setLockMessageRecoilState(message);
            _context.next = 5;
            return setLock(state);
          case 5:
            history.push('/lock');
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            logger.error("cringer.components - lock - error: " + _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var unlock = function unlock(_temp3) {
  var _ref4 = _temp3 === void 0 ? {} : _temp3,
    _ref4$history = _ref4.history,
    history = _ref4$history === void 0 ? null : _ref4$history,
    _ref4$setLock = _ref4.setLock,
    setLock = _ref4$setLock === void 0 ? null : _ref4$setLock;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_temp4) {
      var _ref6, _ref6$state, state, _ref6$redirect, redirect;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref6 = _temp4 === void 0 ? {} : _temp4, _ref6$state = _ref6.state, state = _ref6$state === void 0 ? 'MANUAL_UNLOCK' : _ref6$state, _ref6$redirect = _ref6.redirect, redirect = _ref6$redirect === void 0 ? true : _ref6$redirect;
            _context2.prev = 1;
            _context2.next = 4;
            return setLock(state);
          case 4:
            if (redirect) history.push('/home');
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            logger.error("cringer.components - unlock - error: " + _context2.t0);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 7]]);
    }));
    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var reload = function reload() {
  return function () {
    window.location.href = '/';
  };
};
var syncMenu = function syncMenu(_temp5) {
  var _ref7 = _temp5 === void 0 ? {} : _temp5,
    _ref7$isSyncMenuState = _ref7.isSyncMenuStateCalled,
    isSyncMenuStateCalled = _ref7$isSyncMenuState === void 0 ? null : _ref7$isSyncMenuState,
    _ref7$setIsSyncMenuSt = _ref7.setIsSyncMenuStateCalled,
    setIsSyncMenuStateCalled = _ref7$setIsSyncMenuSt === void 0 ? null : _ref7$setIsSyncMenuSt;
  return function () {
    try {
      if (isSyncMenuStateCalled) return;
      logger.info('cringer.components - syncMenu - pusher command received');
      return setIsSyncMenuStateCalled(true);
    } catch (err) {
      logger.error("cringer.components - syncMenu - error: " + err);
    }
  };
};

var reboot = function reboot(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$port = _ref.port,
    port = _ref$port === void 0 ? null : _ref$port;
  return function () {
    var request = {
      topic: 'request/reboot'
    };
    port.postMessage(request);
  };
};

var Warning = function Warning(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$resetErrorBounda = _ref.resetErrorBoundary,
    resetErrorBoundary = _ref$resetErrorBounda === void 0 ? null : _ref$resetErrorBounda,
    _ref$Template = _ref.Template,
    Template = _ref$Template === void 0 ? DefaultTemplate : _ref$Template;
  validation$1.validate({
    name: "'Warning' component",
    parameters: {
      error: error,
      resetErrorBoundary: resetErrorBoundary
    }
  });
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  logger.error("cringer.components - warning:", error);
  var handleReset = React.useCallback(function () {
    resetErrorBoundary();
  }, [resetErrorBoundary]);
  return /*#__PURE__*/jsxRuntime.jsx(Template, {
    headerEnabled: false,
    footerEnabled: false,
    timeoutEnabled: false,
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "warning",
      className: "flex flex-col items-center justify-center w-full h-full",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "warning-text",
        className: "mb-8 text-3xl font-bold text-center md:text-5xl",
        children: t('warningTitle')
      }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        "data-test": "warning-button",
        className: "home-primary-button",
        onClick: handleReset,
        children: t('warningCancelAction')
      })]
    })
  });
};

var lockService = function lockService(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'lockMachine' : _ref$id,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 'default' : _ref$initial;
  var lockMachine = xstate.Machine({
    id: id,
    initial: initial,
    states: {
      "default": {
        on: {
          MANUAL_LOCK: 'manualLocked',
          AUTO_LOCK: 'autoLocked',
          AUTO_UNLOCK: 'autoUnlocked',
          MANUAL_UNLOCK: 'manualUnlocked'
        }
      },
      autoUnlocked: {
        on: {
          MANUAL_LOCK: 'manualLocked',
          AUTO_LOCK: 'autoLocked'
        }
      },
      manualUnlocked: {
        on: {
          AUTO_UNLOCK: 'autoUnlocked',
          MANUAL_LOCK: 'manualLocked'
        }
      },
      autoLocked: {
        on: {
          MANUAL_UNLOCK: 'manualUnlocked'
        }
      },
      manualLocked: {
        on: {
          MANUAL_UNLOCK: 'manualUnlocked'
        }
      }
    }
  });
  return {
    lockMachine: lockMachine
  };
};

var populateMessage = /*#__PURE__*/xstate.assign({
  message: function message(context, _ref) {
    var _message = _ref.message;
    var _ref2 = _message || {},
      error = _ref2.message;
    if (error) return error;
    return _message;
  }
});
var loadingService = function loadingService(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
    _ref3$id = _ref3.id,
    id = _ref3$id === void 0 ? 'loadingMachine' : _ref3$id,
    _ref3$initial = _ref3.initial,
    initial = _ref3$initial === void 0 ? 'loading' : _ref3$initial;
  var loadingMachine = xstate.Machine({
    id: id,
    initial: initial,
    context: {
      message: null
    },
    states: {
      idle: {
        on: {
          START: 'loading'
        }
      },
      loading: {
        on: {
          SUCCESS: {
            target: 'success',
            actions: ['populateMessage']
          },
          FAILURE: {
            target: 'failure',
            actions: ['populateMessage']
          }
        }
      },
      success: {
        type: 'final'
      },
      failure: {
        on: {
          RESTART: 'loading',
          RESET: 'idle'
        }
      }
    }
  }, {
    actions: {
      populateMessage: populateMessage
    }
  });
  return {
    loadingMachine: loadingMachine
  };
};

var EnvironmentBadge = function EnvironmentBadge(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings;
  var env = process.env.POI_APP_ENV || 'unknown';
  if (env === 'prd' || env === 'canary') return null;
  var config = (settings == null ? void 0 : settings.settings) || {};
  var mocks = (config == null ? void 0 : config.mocks) || {};
  var _mocks$order = mocks.order,
    order = _mocks$order === void 0 ? false : _mocks$order,
    _mocks$payment = mocks.payment,
    payment = _mocks$payment === void 0 ? false : _mocks$payment,
    _mocks$voucher = mocks.voucher,
    voucher = _mocks$voucher === void 0 ? false : _mocks$voucher;
  var mocksEnabled = [order && 'O', payment && 'P', voucher && 'V'].filter(Boolean).join(' / ') || null;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "absolute z-50 w-screen h-64 overflow-hidden pointer-events-none",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "absolute flex flex-col items-center justify-end h-48 -mr-28 pb-1 transform rotate-45 opacity-50 bg-primary " + (mocksEnabled ? "w-80 -mt-14 top-1 -right-0.5" : "w-64 -mt-20 top-0 right-1"),
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "overflow-hidden text-6xl font-bold leading-none uppercase text-secondary",
        "data-test": "header-badge-env",
        children: env
      }), mocksEnabled && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "overflow-hidden text-4xl font-bold uppercase text-secondary",
        "data-test": "header-badge-env",
        children: mocksEnabled
      })]
    })
  });
};

var usePrimaryResolver = function usePrimaryResolver() {
  var _useRootViewContext = useRootViewContext(),
    count = _useRootViewContext.count,
    setCount = _useRootViewContext.setCount,
    serial = _useRootViewContext.serial,
    setSerial = _useRootViewContext.setSerial,
    system = _useRootViewContext.system,
    setSystem = _useRootViewContext.setSystem,
    settings = _useRootViewContext.settings,
    setSettings = _useRootViewContext.setSettings,
    transactions = _useRootViewContext.transactions,
    setTransactions = _useRootViewContext.setTransactions,
    setCurrentMenuId = _useRootViewContext.setCurrentMenuId,
    resolverProps = _useRootViewContext.resolverProps,
    retryTime = _useRootViewContext.retryTime;
  var _useState = React.useState(),
    restaurantRun = _useState[0],
    setRestaurantRun = _useState[1];
  var _useState2 = React.useState(),
    restaurantState = _useState2[0],
    setRestaurantState = _useState2[1];
  var _resolverProps$isRetr = resolverProps.isRetryActive,
    isRetryActive = _resolverProps$isRetr === void 0 ? false : _resolverProps$isRetr;
  var _useState3 = React.useState(retryTime),
    timeLeft = _useState3[0],
    setTimeLeft = _useState3[1];
  var _useState4 = React.useState(false),
    timerExpired = _useState4[0],
    setTimerExpired = _useState4[1];
  var timer = React.useRef({});

  // TODO: refactor the useTiming hook and use it here.
  // Task: https://fingermarkglobal.atlassian.net/browse/S2-3803
  React.useEffect(function () {
    setTimerExpired(timeLeft <= 0);
  }, [setTimerExpired, timeLeft]);
  React.useEffect(function () {
    if (!(restaurantState != null && restaurantState.matches('failure')) && isRetryActive) return;
    var id = setInterval(function () {
      try {
        setTimeLeft(function (time) {
          return time - 1;
        });
      } catch (err) {
        logger.error('components - useTiming - error in useTiming at primary resolver:', err);
      }
    }, 1000);
    timer.current.id = id;
    return function () {
      return clearInterval(id);
    };
  }, [restaurantState, isRetryActive]);
  React.useEffect(function () {
    if (!timerExpired) return;
    window.location.reload();
  }, [timerExpired]);
  var loading = React.useMemo(function () {
    if (!restaurantState) return true;
    var states = ['serial', 'settings', 'waiting', 'transactions'];
    return states.map(function (state) {
      return restaurantState == null ? void 0 : restaurantState.matches(state);
    }).some(function (item) {
      return item;
    });
  }, [restaurantState]);
  var retry = React.useCallback(function () {
    setTimeLeft(retryTime);
    return restaurantRun({
      event: 'EXTERNAL_TRANSITION_RESET'
    });
  }, [restaurantRun, setTimeLeft, retryTime]);
  React.useEffect(function () {
    if (restaurantState) return;
    var run = restaurant_resolver.resolveRestaurant({
      transition: function transition(machine) {
        return setRestaurantState(machine);
      }
    });

    // NOTE: first function would normally return previous state...
    setRestaurantRun(function () {
      return function () {
        return run.apply(void 0, arguments);
      };
    });
  }, [restaurantState, setRestaurantRun, setRestaurantState]);
  React.useEffect(function () {
    if (!restaurantState) return;
    if (!(restaurantState != null && restaurantState.matches('waiting'))) return;
    var _restaurantState$cont = restaurantState.context,
      port = _restaurantState$cont.port,
      count = _restaurantState$cont.count,
      serial = _restaurantState$cont.serial,
      origin = _restaurantState$cont.origin,
      resolvedSettings = _restaurantState$cont.settings,
      resolvedTransactions = _restaurantState$cont.transactions;
    setCount(count);
    setSerial(serial);
    setSettings(resolvedSettings);
    setTransactions(resolvedTransactions);
    setCurrentMenuId((resolvedSettings == null ? void 0 : resolvedSettings.menuId) || '');
    setSystem({
      type: origin,
      port: port
    });
  }, [setCount, setSerial, setSystem, setSettings, setTransactions, setCurrentMenuId, restaurantState]);
  React.useEffect(function () {
    if (!restaurantState) return;
    if (!(restaurantState != null && restaurantState.matches('waiting'))) return;
    if (count === null) return;
    if (system === null) return;
    if (serial === null) return;
    if (settings === null) return;
    if (transactions === null) return;

    // Once everything is set then we can resolve to next step.
    restaurantRun({
      event: 'EXTERNAL_TRANSITION_SUCCESS'
    });
  }, [count, system, serial, settings, transactions, restaurantRun, restaurantState]);
  return {
    retry: retry,
    loading: loading,
    settings: settings,
    transactions: transactions,
    state: restaurantState,
    timeLeft: timeLeft,
    isRetryActive: isRetryActive
  };
};

var Alert = function Alert(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'alert' : _ref$dataTest,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'information' : _ref$type,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? null : _ref$message,
    _ref$additionalMessag = _ref.additionalMessage,
    additionalMessage = _ref$additionalMessag === void 0 ? null : _ref$additionalMessag,
    _ref$detail = _ref.detail,
    detail = _ref$detail === void 0 ? null : _ref$detail,
    _ref$onRetryAction = _ref.onRetryAction,
    onRetryAction = _ref$onRetryAction === void 0 ? null : _ref$onRetryAction,
    _ref$onRetryText = _ref.onRetryText,
    onRetryText = _ref$onRetryText === void 0 ? 'Retry' : _ref$onRetryText,
    _ref$onCancelAction = _ref.onCancelAction,
    onCancelAction = _ref$onCancelAction === void 0 ? null : _ref$onCancelAction,
    _ref$onCancelText = _ref.onCancelText,
    onCancelText = _ref$onCancelText === void 0 ? 'Cancel' : _ref$onCancelText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var Message = function Message() {
    switch (type) {
      case 'danger':
        return /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "space-y-4 text-center text-alert",
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            className: "text-3xl font-bold sm:text-6xl sm:leading-none",
            children: message
          }), additionalMessage && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "my-4 text-2xl font-bold sm:text-4xl md:mt-8 md:mb-8",
            children: additionalMessage
          }), detail && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "text-2xl sm:text-3xl text-alert",
            children: detail
          })]
        });
      default:
        return /*#__PURE__*/jsxRuntime.jsxs("div", {
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            className: "text-3xl font-bold text-center sm:text-6xl sm:leading-none",
            children: message
          }), additionalMessage && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "my-4 text-2xl font-bold sm:text-4xl md:mt-8 md:mb-8",
            children: additionalMessage
          }), detail && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "text-2xl sm:text-3xl",
            children: detail
          })]
        });
    }
  };
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: "flex flex-col justify-center items-center space-y-8 " + className,
    children: [/*#__PURE__*/jsxRuntime.jsx(Message, {}), (onRetryAction || onCancelAction || children) && /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "alert-actions",
      className: "flex flex-col items-stretch justify-center space-y-4 alert-actions",
      children: [onRetryAction && /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        className: "home-primary-button",
        onClick: onRetryAction,
        children: onRetryText
      }), onCancelAction && /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        className: "home-primary-button",
        onClick: onCancelAction,
        children: onCancelText
      }), children]
    })]
  });
};

var PrimaryResolverView = function PrimaryResolverView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _usePrimaryResolver = usePrimaryResolver(),
    state = _usePrimaryResolver.state,
    retry = _usePrimaryResolver.retry,
    loading = _usePrimaryResolver.loading,
    timeLeft = _usePrimaryResolver.timeLeft,
    isRetryActive = _usePrimaryResolver.isRetryActive;
  var additionalMessage = isRetryActive ? "Kiosk will try to recover itself in " + timeLeft : '';
  return /*#__PURE__*/jsxRuntime.jsxs(React.Fragment, {
    children: [loading && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center h-screen",
      children: /*#__PURE__*/jsxRuntime.jsx(Loading, {
        dataTest: "resolver-loading",
        isFirstLoad: true
      })
    }), (state == null ? void 0 : state.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center h-screen p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        onRetryAction: retry,
        additionalMessage: additionalMessage,
        message: state.context.message
      })
    }), (state == null ? void 0 : state.matches('success')) && children]
  });
};

// https://medium.com/velotio-perspectives/understanding-node-js-async-flows-parallel-serial-waterfall-and-queues-6f9c4badbc17
var flow = function flow(dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  return new Promise(function (resolve, reject) {
    return asyncEs.waterfall(dependencies, function (error, response) {
      if (error) return reject(error);
      return resolve(response);
    });
  });
};

var languages = {
	en: {
		translation: {
			homeTitle: "EXPRESS",
			homeSubtitle: "ORDER HERE",
			homePrimaryAction: "TAKEAWAY",
			homeSecondaryAction: "EAT IN",
			homeConnectivityIssues: "We are having connectivity issues, please wait while we are trying to recover…",
			homeTermsAndConditionsBannerWarningTitle: "Terms & Conditions",
			homeTermsAndConditionsBannerWarningDescription: "By continuing, you accept our",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "Terms of Use and Privacy Policy",
			adminTitle: "Admin",
			adminGeneralSection: "General",
			adminSerialKeyField: "Serial Key",
			adminMenuSection: "Menu",
			adminOrderingSection: "Ordering",
			adminOrganisationField: "Organisation",
			adminStoreField: "Store",
			adminSiteField: "Site",
			adminTimezoneField: "Timezone",
			adminVersionField: "Version",
			adminEnvironmentField: "Environment",
			adminMockFieldFalseText: "No",
			adminMockFieldTrueText: "Yes",
			adminPaymentSection: "Payment",
			adminMockField: "Mock",
			adminProviderField: "Provider",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "IP Address",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "USB Port",
			adminLockModal: "Lock Screen",
			adminLockModalTitle: "Lock Screen Options",
			adminLockModalClose: "Close",
			adminPrimaryLockAction: "Lock Screen - Kiosk Unavailable",
			adminSecondaryLockAction: "Lock Screen - Restaurant Closed",
			lockMessage: "Kiosk unavailable. Please use another kiosk, or order at the front counter.",
			lockSecondaryMessage: "Restaurant is currently closed.",
			adminLoginTitle: "Please enter the admin password",
			adminRefreshAction: "Refresh",
			adminExitAction: "Exit",
			adminLoginPrimaryAction: "Login",
			adminLoginSecondaryAction: "Cancel",
			adminLoginErrorPasswordMessage: "Incorrect password",
			adminTransactionsAction: "Transactions",
			allergensMessage: "Contains: {{ allergens }}",
			smsSending: "Sending SMS",
			smsErrorMessage: "Failed to send SMS",
			smsErrorDetailsMessage: "Please check the number you have provided",
			smsMockErrorMessage: "Failed mock response",
			smsMockSuccessMessage: "Success mock response",
			smsSuccessTitle: "SMS successfully sent",
			smsSuccessSubtitle: "SMS can take some time to be received",
			smsSuccessButton: "Continue",
			smsPrimaryAction: "Send",
			smsSecondaryAction: "Skip",
			smsCountryCodeCannotBeEmpty: "Country code can not be empty",
			smsCountryCodeStartWithZero: "Country code can not start with zero",
			smsCountryCodeExceedsMaxLength: "Country code exceeds maximum allowed length",
			smsCountryCodeDoesNotMeetMinimumLength: "Country code does not meet minimum required length",
			smsPhoneCannotStartWithZero: "Phone number can not start with '0'",
			smsPhoneExceedsMaxLength: "Phone number exceeds maximum allowed length",
			smsPhoneDoesNotMeetMinimumLength: "Phone number does not meet minimum required length",
			smsTitle: "Send receipt through SMS",
			smsSubtitle: "Please enter your phone number",
			receiptDetailsInstruction: "Please scan the QR code for your receipt",
			receiptDetailsInstructionCash: "Pay for your order at the counter",
			receiptDetailsInstructionCard: "Pick up your order from the collection point",
			receiptDetailsOrderNumber: "ORDER REFERENCE:",
			receiptDetailsPrimaryAction: "Receipt",
			receiptSmsAction: "SMS",
			receiptTermsAndConditionsAction: "Terms & Conditions",
			receiptPrimaryAction: "Done",
			receiptDetailsTaxInvoice: "Tax Invoice",
			receiptDetailsOrderType: "Type",
			receiptPaymentRestaurantName: "Restaurant",
			receiptPaymentRestaurantAddress: "Address",
			receiptPaymentPhone: "Phone",
			receiptPaymentTaxNumber: "ABN",
			receiptPaymentItemQuantity: "Items",
			receiptPaymentTaxTotal: "GST",
			receiptPaymentSubTotal: "Subtotal",
			receiptPaymentTotal: "Total",
			receiptGSTExcludeMessage: "* excludes GST",
			receiptPaymentPending: "Payment pending",
			receiptPaymentKitchenId: "Kitchen ID",
			receiptCash: "Cash",
			receiptDineIn: "Eat In",
			receiptTakeaway: "Takeaway",
			receiptQRCodeOpen: "Receipt",
			smsReceiptHeaderText: "Hi from KFC",
			smsReceiptOrderNumberText: "Your order number is: {{ orderNumber }}",
			smsReceiptUrlText: "Get your receipt at: {{ url }}",
			smsReceiptPendingPaymentText: "Pending Payment",
			smsErrorPrimaryAction: "Try Again",
			smsErrorSecondaryAction: "Continue",
			customerDetailsFullNameLabel: "Full name {{ required }}",
			customerDetailsFirstNameLabel: "First name {{ required }}",
			customerDetailsLastNameLabel: "Last initial {{ required }}",
			customerDetailsPhoneNumberLabel: "Phone Number {{ required }}",
			customerDetailsRequired: "(Required)",
			customerDetailsOptional: "(Optional)",
			customerDetailsFormPrimaryAction: "Continue",
			customerDetailsFormSecondaryAction: "Skip",
			customerDetailsInputInvalidError: "{{ label }} is not valid",
			customerDetailsEmailLabel: "Email {{ required }}",
			customerDetailsEmailDescription: "QR receipt available at checkout",
			customerDetailsInputRequiredError: "{{ label }} is required",
			customerDetailsInputMinimumError: "{{ label }} does not meet minimum required length",
			customerDetailsProfaneInputError: "Please try again, this word is not allowed",
			customerDetailsSpecialCharactersInputError: "Please try again, special characters are not allowed",
			customerDetailsCancelOrderAction: "Cancel",
			receiveEmailAddress: "Sign me up to hear about exclusive coupons and the latest offers",
			cartNextAction: "Proceed to payment",
			cartTitle: "Your Order",
			cartPleaseSelectProduct: "* Please select product to be redeemed",
			cartPreviousAction: "Back",
			cartEmptyMessage: "Your cart is empty",
			cartEmptyPrimaryAction: "Return to the menu",
			cartProductUnavailableGeneral: "This item is currently unavailable",
			cartProductUnavailableAddon: "Unavailable",
			cartProductUnavailableItem: "Back Soon",
			cartCancelOrderAction: "Cancel",
			cartChangeAction: "Change",
			cartRemoveAction: "Remove",
			cartProductUnitPriceEach: "{{price}} Each",
			cartUpsellTitle: "Add more to your order",
			cartUpsellAction: "Add more",
			cartUpsellGalleryCardButtonActionText: "Add",
			cartGroupedModalSecondaryAction: "Close",
			cartNoInternetLoadingTitle: "Connectivity issues",
			cartNoInternetLoadingMessage: "We are having connectivity issues, please wait while we are trying to recover...",
			cartNoInternetTitle: "We are sorry, there was a connectivity issue.",
			cartNoInternetClose: "OK",
			productNextAction: "Add to order",
			productEditingNextAction: "Update order",
			productTitle: "Customise",
			customisationExtraPriceWarning: "You've added {{price}} extra to your meal",
			customisationPriceEach: "{{price}} Each",
			paymentInstructions: "Please follow the payment instructions on the pinpad below",
			paymentErrorMessage: "Oops, something went wrong",
			paymentErrorDetail: "Oops, something went wrong - the pinpad returned: {{message}}",
			paymentErrorQRCodeDetail: "Oops, something went wrong - the QR Code response was: {{message}}",
			paymentErrorQRCodeMessage: "Please scan the QR Code to get the failed payment receipt",
			paymentStatusCheckMessage: "Wait while we check if your payment was successful",
			paymentStatusSuccessMessage: "Your payment was successful, we will now place your order",
			paymentRetryMessage: "Retry",
			paymentCancelMessage: "Cancel",
			paymentOptionsTitle: "Select Payment Method",
			paymentOptionsSecondaryAction: "Back",
			paymentOptionsCARDTitle: "CARD",
			paymentOptionsCASHTitle: "CASH",
			paymentOptionsMOMOPAYTitle: "MOMO",
			paymentOptionsExpressMessage: "Express checkout",
			paymentNoInternetLoadingTitle: "Connectivity issues",
			paymentNoInternetLoadingMessage: "We are having connectivity issues, please wait while we are trying to recover...",
			paymentNoInternetTitle: "We are sorry, there was a connectivity issue.",
			paymentNoInternetClose: "OK",
			paymentFetchingQRCode: "Fetching QR Code",
			paymentScanQRCode: "Please scan the QR Code in Momo app",
			paymentScanQRCodeMessage: "The payment process must be completed in the Momo app. If you wish to cancel the transaction, please do it from the app.",
			categoryComboModalTitle: "Select meal size",
			categoryPreviousAction: "Back",
			productCustomisationsAdditionalPriceWarning: "You've added {{price}} extra to your meal",
			productCustomisationsReadOnlyEach: "{{price}} Each",
			productCustomisationsReadonlyProductRemoved: "No {{name}}",
			productCustomisationsUnlimitedMax: "Unlimited",
			productCancelOrderAction: "Cancel",
			categoriesTitle: "Menu",
			categoriesCancelOrderAction: "Cancel",
			cancelOrderButtonModalQuestion: "Are you sure you want to cancel your order?",
			cancelOrderButtonModalTitle: "Cancel order",
			cancelOrderButtonModalPrimaryAction: "No",
			cancelOrderButtonModalSecondaryAction: "Yes",
			cancelOrderButtonName: "Cancel",
			categoriesNextAction: "Complete",
			categoriesPreviousAction: "Back",
			customerDetailsTitle: "Details",
			customerDetailsFormTitle: "We will call your name when your order is ready",
			customerDetailsFormSubTitle: "Please enter it here",
			customerDetailsPreviousAction: "Back",
			customerDetailsNextAction: "Continue",
			beaconTitle: "Beacon",
			beaconFormHeaderTitle: "Enter the beacon number",
			beaconFormHeaderSubtitle: "And it will buzz and flash when your order is ready for pickup",
			beaconPreviousAction: "Back",
			beaconAdditionalAction: "Cancel",
			beaconCancelAction: "Cancel",
			beaconFormPrimaryAction: "Submit",
			beaconFormSecondaryAction: "Cancel",
			beaconNextAction: "Submit",
			beaconInputError: "Please, enter a valid number",
			couponTitle: "Coupon code",
			couponPreviousAction: "Back",
			couponFormHeaderTitle: "Enter your coupon:",
			couponFormPrimaryAction: "Confirm",
			couponFormSecondaryAction: "Back",
			couponListHeaderTitle: "Coupon",
			couponListAddToCartAction: "Add to cart",
			couponListChangeAction: "Change",
			couponErrorHeaderTitle: "Sorry, this coupon could not be found.",
			couponErrorSecondaryAction: "Return to categories",
			couponErrorPrimaryAction: "Try again",
			couponGroupedModalSecondaryAction: "Close",
			couponComboModalTitle: "Select meal size",
			couponComboModalSecondaryAction: "Close",
			couponNextAction: "Complete",
			composedPreviousAction: "Back",
			composedEditingNextAction: "Update order",
			composedNextAction: "Add to order",
			composedCancelOrderAction: "Cancel",
			composedProductLayerTitle: "Choose the product {{layer}}",
			composedProductFinalTitle: "You chose this product:",
			composedProductFinalCustomise: "Confirm your selection",
			composedHeaderTitle: "Customise",
			orderValidationErrorMessage: "Oops, Something went wrong when we tried to process your order",
			requestTimedOut: "Request timed out",
			orderValidationErrorPrimaryAction: "Retry",
			orderValidationErrorSecondaryAction: "Cancel",
			orderConfirmationErrorMessage: "Oops, something went wrong",
			orderConfirmationAdditionalMessage: "Please ensure your card is removed from the terminal",
			orderConfirmationGenericAdditionalMessage: "Please ensure that your payment is finished on the selected method",
			orderConfirmationErrorPrimaryAction: "Retry",
			orderConfirmationErrorSecondaryAction: "Cancel",
			orderConfirmationLoadingTitle: "Sending to the kitchen",
			orderWebhookPollingConfirmationLoadingTitle: "Confirming with the kitchen",
			orderConfirmationLoadingMessage: "Please wait, sending your order to the kitchen",
			orderWebhookPollingConfirmationLoadingMessage: "Please wait, confirming your order with the kitchen",
			orderConfirmationLoadingMessageFirstAutoRetry: "Stay with us, It's taking a little longer sending your order to the kitchen.",
			orderConfirmationLoadingMessageSecondAutoRetry: "There's a small delay in passing your order over.",
			orderConfirmationNoInternetLoadingTitle: "Connectivity issues",
			orderConfirmationNoInternetLoadingMessage: "We are having connectivity issues, please wait while we are trying to recover...",
			orderConfirmationNoInternetTitle: "We are sorry, there was a problem sending your order to the kitchen. Please take a photo of the receipt and inform the front counter.",
			orderConfirmationNoInternetDetailsTitle: "Details",
			orderConfirmationNoInternetDetailsDateTime: "Date",
			orderConfirmationNoInternetDetailsCardNumber: "Card number",
			orderConfirmationNoInternetClose: "OK",
			orderPostErrorMessage: "Oops, something went wrong",
			orderPostErrorPrimaryAction: "Retry",
			orderPostErrorSecondaryAction: "Cancel",
			categoryGroupedModalSecondaryAction: "Close",
			categoryComboModalSecondaryAction: "Close",
			categoryNextAction: "Complete",
			productPreviousAction: "Back",
			timeoutModalTitle: "Are you still there?",
			timeoutModalSecondaryAction: "Dismiss",
			timeoutModalContentMessage: "Returning home in {{ timeLeft }}",
			productComboSizeAction: "Change",
			productOptionCardPrimaryAction: "Change Selection",
			productOptionCardSecondaryAction: "Customise",
			productOptionItemCardSelectedMessage: "In your meal",
			productOptionsChangeModalCloseAction: "Dismiss",
			offerLimitModalTitle: "An offer already exists in your cart",
			offerLimitConfirmation: "Only 1 offer allowed per order. Would you like to replace the existing offer?",
			orderValidationLoadingTitle: "Updating Cart",
			orderValidationLoadingMessage: "Taking you to check out",
			orderPostLoadingTitle: "Finishing order",
			orderPostLoadingMessage: "Please wait, finishing your order",
			productCustomisationsReadOnlyExtra: "Customisations",
			productCustomisationsProductsMissingError: "Please add {{ productsMissingCount }} item",
			productCustomisationsProductsMissingError_plural: "Please add {{ productsMissingCount }} items",
			autoRedirectNotificationTitle: "Oops, we are still having issues, no more attempts left",
			autoRedirectNotificationAdditionalMessage: "Sorry about that",
			autoRedirectNotificationMessage: "Redirecting you back to safety",
			autoRedirectNotificationButton: "OK",
			upsellModalTitle: "Would you like to add these to the order?",
			productCustomisationModalHeaderTitle: "Customise",
			productCustomisationModalAddToCartAction: "Add to order",
			productCustomisationModalUpdateCartAction: "Update order",
			productCustomisationModalCloseAction: "Dismiss",
			upsellModalCloseAction: "Dismiss",
			productOptionCustomisationModalAddToCartAction: "Add to cart",
			productOptionCustomisationModalUpdateCartAction: "Update order",
			productOptionCustomisationModalCloseAction: "Dismiss",
			bannerWarningTitle: "Your health & wellbeing is our No.1 Priority",
			bannerWarningDescription: "We have increased our already strict cleaning and Hygiene procedures in these challenging times.",
			paymentMethodCard: "Card payments only",
			miniCartNextAction: "Complete",
			miniCartCloseAction: "Close",
			miniCartCheckoutAction: "Checkout",
			miniCartTotal: "Total",
			invalidRouteTitle: "Oops, looks like you're lost",
			invalidRouteButton: "Back to safety",
			templateMenuAction: "Menu",
			templateCancelAction: "Cancel",
			templateBasketAction: "View order",
			templateCouponAction: "Enter offer",
			refundGenericInstructions: "Please wait for the refund",
			refundInstructions: "Please wait for the refund on the pinpad below",
			refundErrorMessage: "Oops, something went wrong attempting to refund you",
			refundRetryMessage: "Retry",
			refundCancelMessage: "Cancel",
			refundCancelButton: "OK",
			refundSuccessButton: "OK",
			refundCancelDetails: "Details",
			refundCancelDateTime: "Date",
			refundCancelCardNumber: "Card number",
			refundCancelOrderNumber: "Order number",
			refundSuccessMessage: "Refund process successfully started. Please note that the time for it to be made effective depends on the payment method.",
			refundCancelledMessage: "We are sorry, there was a problem sending your order to the kitchen. Please take a photo or download Receipt from the QR Code and Inform the front Counter.",
			refundSuccessTitle: "Refund Success",
			refundLoadingTitle: "Refund Loading",
			menuAction: "Menu",
			menuPreviousAction: "Back",
			productCustomisationsRemove: "Remove",
			productCustomisationsChange: "Change",
			productCustomisationsResetting: "Resetting...",
			productCustomisationsReset: "Reset",
			productCustomisationsDeselect: "Deselect",
			productCustomisationsAdd: "Add",
			productCustomisationsSelect: "Select",
			warningTitle: "Oops, looks like something went wrong",
			warningCancelAction: "Cancel",
			warningTryAgainAction: "Try again",
			receiptTitle: "Your order",
			receiptEcoMessage: "Paper free",
			transactionsNavigatorNextAction: "Next",
			transactionsNavigatorPreviousAction: "Previous",
			transactionsTitle: "Transactions",
			transactionsIdentityTitle: "Identity",
			transactionsIdentityId: "Session ID",
			transactionsIdentityStatus: "Status",
			transactionsIdentityTimestamp: "Date",
			transactionsIdentityType: "Order Type",
			transactionsIdentityMessage: "Message",
			transactionsIdentityOrderReference: "Order Reference",
			transactionsPaymentTitle: "Total",
			transactionsPaymentType: "Payment Type",
			transactionsPaymentAmount: "Card Total",
			transactionsPaymentAuthCode: "Auth Code",
			transactionsPaymentCardNumber: "Card Number",
			transactionsPaymentTransactionId: "Transaction ID",
			transactionsPaymentOrderTotal: "Order Total",
			transactionsPaymentNoPaymentFound: "No Payment Selected",
			transactionsPrimaryAction: "Back",
			transactionsPaymentCardType: "Card Type",
			transactionsNotFound: "No transactions stored since last reboot",
			quantityControllerOutlinedLabel: "Quantity",
			defaultLoadingTitle: "Warming up the kitchen",
			loadingCoupon: "Searching for the coupon",
			defaultLoadingMessage: "Please wait",
			termsAndConditionsModalTitle: "Terms & Conditions",
			termsAndConditionsModalCloseAction: "Close",
			ORDER_CONFIRMATION_SUCCESS: "Success",
			ORDER_REFUND_CANCELLED: "Refund Cancelled",
			ORDER_CONFIRMATION_ERROR: "Error",
			ORDER_CANCELLED: "Cancelled",
			ORDER_VALIDATION_ERROR: "Validation Error",
			ORDER_REFUND_SUCCESS: "Refund Success",
			ORDER_VALIDATION_SUCCESS: "Validation Success",
			ORDER_PAYMENT_ERROR: "Payment Error",
			ORDER_PAYMENT_SUCCESS: "Payment Success",
			ORDER_REFUND_ERROR: "Refund Error",
			ORDER_POST_SUCCESS: "Success",
			ORDER_POST_ERROR: "Error",
			transactionsLateRefund: "Late Refund",
			transactionsLateRefundFalse: "No",
			transactionsLateRefundTrue: "Yes",
			transactionLateRefundModalText: "Are you sure you would like to refund",
			transactionLateRefundFailedMessage: "We are sorry, we could not process the refund.",
			transactionLateRefundCancelledMessage: "Refund has been cancelled!",
			showAddonAvailabilityMessage: "Back soon",
			addonRemovedModalTitle: "We removed some items",
			addonRemovedMessage: "By the way, we removed the following:",
			addonRemovedFooterMessage: "Items are only available when purchasing",
			loyaltyOffersTitle: "Member Offers",
			loyaltyOffersPreviousAction: "Back",
			loyaltyOffersNextAction: "Complete",
			loyaltyLoginTitle: "Member Login",
			loyaltyLoginNextAction: "Confirm",
			loyaltyLoginPreviousAction: "Back",
			loyaltyBannerTitle: "EARN AND ENJOY YOUR REWARDS!",
			loyaltyBannerSubtitle: "Are you our member?",
			loyaltyBannerMember: "Hi {{name}}, you have {{totalPoints}} points",
			loyaltyBannerLogin: "Login",
			loyaltyBannerLogout: "Logout",
			loyaltyBannerOffers: "Offers",
			loyaltyBannerOffersAndDeals: "Offers & Deals",
			loyaltyBannerRedeemables: "Redeemables",
			loyaltyLoginCodeTitle: "Enter the code",
			loyaltyQrLoginCodeTitle: "or scan with your app",
			loyaltyWelcomeModalTitle: "Welcome back, {{name}}",
			loyaltyWelcomeModalPoints: "You have {{points}} points",
			loyaltyWelcomeModalConfirm: "Ok",
			loyaltyLogOutModalConfirm: "Are you sure you want to log out?",
			loyaltyLoginFailedModalTitle: "Sorry",
			loyaltyLoginFailedModalClose: "Try again",
			loyaltyLoginFailedModalContent: "We could not verify your code",
			loyaltyLoginOrSkipModalTitle: "Rewards your way",
			loyaltyLoginOrSkipModalLoginButtonText: "Login",
			loyaltyLoginOrSkipModalSkipButtonText: "Skip",
			loyaltyMemberSignInButtonText: "Member sign in",
			loyaltyGuestOrderButtonText: "Guest order",
			loyaltyOrderHistoryTitle: "Order History",
			loyaltyReorderTitle: "Re-order {{orderDate}}",
			loyaltyReorderViewOrder: "View order",
			loyaltyReorderAddToCart: "Add to order",
			loyaltyReorderAddingToCart: "Adding...",
			loyaltyReorderCancel: "Close",
			loyaltyTotal: "Total rewards",
			bestValueProduct: "Best Value",
			hotDealProduct: "Hot Deal",
			appDownloadTitle: "App Download",
			appDownloadContent: "Not a member?",
			appDownloadSubContent: "Scan this code to download the KFC app and sign up",
			appDownloadPreviousAction: "Back",
			appDownloadNextAction: "Sign in",
			chooseCustomisations: "Choose your customisations",
			taxesFees: "Taxes & Fees",
			discount: "Discount",
			chooseProductCustomisations: "customisations",
			cartComboModalTitle: "Select meal size",
			cartComboModalSecondaryAction: "Close",
			headsUpModalTitle: "Heads Up!",
			headsUpModalMessage: "The following ingredients are currently unavailable",
			headsUpModalFooterMessage: "Would you still like to proceed?"
		}
	},
	uae: {
		translation: {
			homeTitle: "اطلب وجبتك هنا",
			homeSubtitle: "اطلب وجبتك هنا",
			homePrimaryAction: "وجبة سفري",
			homeSecondaryAction: "تناولها في المطعم",
			homeConnectivityIssues: "...نواجه مشكلات في الاتصال ، يرجى الانتظار بينما نحاول التعافي",
			homeTermsAndConditionsBannerWarningTitle: "البنود و الظروف",
			homeTermsAndConditionsBannerWarningDescription: "من خلال الاستمرار ، فإنك تقبل لدينا",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "شروط الاستخدام و سياسة الخصوصية",
			adminTitle: "لوحه اللإدارة",
			adminGeneralSection: "جنرال لواء",
			adminSerialKeyField: "رقم مسلسل",
			adminMenuSection: "القائمة",
			adminOrderingSection: "طلب",
			adminOrganisationField: "منظمة",
			adminStoreField: "متجر",
			adminSiteField: "موقع",
			adminTimezoneField: "وحدة زمنية",
			adminVersionField: "إصدار",
			adminEnvironmentField: "بيئة",
			adminMockFieldFalseText: "لا",
			adminMockFieldTrueText: "نعم",
			adminPaymentSection: "دفع",
			adminMockField: "يسخر",
			adminProviderField: "مزود",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "IP Address",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "USB Port",
			adminLockModal: "اقفل الشاشة",
			adminLockModalTitle: "خيارات قفل الشاشة",
			adminLockModalClose: "يغلق",
			adminPrimaryLockAction: "شاشة القفل - كشك غير متوفر",
			adminSecondaryLockAction: "شاشة القفل - المطعم مغلق",
			lockMessage: "الكشك غير متوفر. الرجاء استخدام كشك آخر ، أو اطلب من الشباك الأمامي",
			lockSecondaryMessage: "المطعم مغلق حاليا",
			adminLoginTitle: "الرجاء إدخال كلمة مرور المسؤول",
			adminRefreshAction: "تحديث",
			adminExitAction: "مخرج",
			adminLoginPrimaryAction: "تسجيل الدخول",
			adminLoginSecondaryAction: "إلغاء",
			adminLoginErrorPasswordMessage: "كلمة سر خاطئة",
			adminTransactionsAction: "المعاملات",
			allergensMessage: "يتضمن: {{ allergens }}",
			smsSending: "إرسال الرسائل القصيرة",
			smsErrorMessage: "فشل في إرسال الرسائل القصيرة",
			smsErrorDetailsMessage: "يرجى التحقق من الرقم الذي قدمته",
			smsMockErrorMessage: "فشل استجابة وهمية",
			smsMockSuccessMessage: "استجابة وهمية النجاح",
			smsSuccessTitle: "تم إرسال الرسائل القصيرة بنجاح",
			smsSuccessSubtitle: "قد يستغرق استلام الرسائل القصيرة بعض الوقت",
			smsSuccessButton: "يكمل",
			smsPrimaryAction: "إرسال",
			smsSecondaryAction: "يتخطى",
			smsCountryCodeCannotBeEmpty: "لا يمكن أن يكون رمز البلد فارغًا",
			smsCountryCodeStartWithZero: "لا يمكن أن يبدأ رمز البلد بصفر",
			smsCountryCodeExceedsMaxLength: "رمز البلد يتجاوز الطول الأقصى المسموح به",
			smsCountryCodeDoesNotMeetMinimumLength: "رمز البلد لا يلبي الحد الأدنى للطول المطلوب",
			smsPhoneCannotStartWithZero: "'لا يمكن أن يبدأ رقم الهاتف بالرقم '0",
			smsPhoneExceedsMaxLength: "رقم الهاتف يتجاوز الحد الأقصى للطول المسموح به",
			smsPhoneDoesNotMeetMinimumLength: "رقم الهاتف لا يتوافق مع الحد الأدنى للطول المطلوب",
			smsTitle: "إرسال إيصال عبر الرسائل القصيرة",
			smsSubtitle: "يرجى إدخال رقم الهاتف الخاص بك",
			receiptDetailsInstruction: "يرجى مسح رمز الاستجابة السريعة ضوئيًا لإيصالك",
			receiptDetailsInstructionCash: "ادفع مقابل طلبك على المنضدة",
			receiptDetailsInstructionCard: "استلم طلبك من نقطة التجميع",
			receiptDetailsOrderNumber: "ترتيب المرجعي:",
			receiptDetailsPrimaryAction: "إيصال",
			receiptSmsAction: "رسالة",
			receiptTermsAndConditionsAction: "البنود و الظروف",
			receiptPrimaryAction: "منجز",
			receiptDetailsTaxInvoice: "فاتورة ضريبية",
			receiptDetailsOrderType: "يكتب",
			receiptPaymentRestaurantName: "مطعم",
			receiptPaymentRestaurantAddress: "عنوان",
			receiptPaymentPhone: "هاتف",
			receiptPaymentTaxNumber: "ABN",
			receiptPaymentItemQuantity: "العناصر",
			receiptPaymentTaxTotal: "ضريبة السلع والخدمات",
			receiptPaymentSubTotal: "المجموع الفرعي",
			receiptPaymentTotal: "مجموع",
			receiptGSTExcludeMessage: "* لا يشمل ضريبة السلع والخدمات",
			receiptPaymentPending: "انتظار الدفع",
			receiptPaymentKitchenId: "معرف المطبخ",
			receiptCash: "نقدي",
			receiptDineIn: "وجبة سفري",
			receiptTakeaway: "تناولها في المطعم",
			receiptQRCodeOpen: "إيصال",
			smsReceiptHeaderText: "مرحبامن عند كنتاكى",
			smsReceiptOrderNumberText: "ك طلب رقم يكون: {{ orderNumber }}",
			smsReceiptUrlText: "أحصل طلبك فاتورة  عند: {{ url }}",
			smsReceiptPendingPaymentText: "في انتظار الدفع",
			smsErrorPrimaryAction: "حاول مرة أخري",
			smsErrorSecondaryAction: "يكمل",
			customerDetailsFullNameLabel: "{{ required }} الاسم الكامل",
			customerDetailsFirstNameLabel: "{{required}} الاسم الأول",
			customerDetailsLastNameLabel: "{{required}} اللقب",
			customerDetailsPhoneNumberLabel: "رقم التليفون {{ required }}",
			customerDetailsRequired: "(مطلوب)",
			customerDetailsOptional: "(اختياري)",
			customerDetailsFormPrimaryAction: "إرسال",
			customerDetailsFormSecondaryAction: "تخطي",
			customerDetailsInputInvalidError: "{{ label }} غير صالح",
			customerDetailsEmailLabel: "البريد الإلكتروني اختياري)",
			customerDetailsEmailDescription: "إيصال QR متاح عند الخروج",
			customerDetailsInputRequiredError: "{{ label }} مطلوب",
			customerDetailsInputMinimumError: "{{ label }} لا يلبي الحد الأدنى  المطلوب",
			customerDetailsProfaneInputError: "يرجى المحاولة مرة أخرى ، هذه الكلمة غير مسموح بها",
			customerDetailsSpecialCharactersInputError: "يرجى المحاولة مرة أخرى ، الأحرف الخاصة غير مسموح بها",
			customerDetailsCancelOrderAction: "يلغي",
			receiveEmailAddress: "سجلني لمعرفة المزيد عن الكوبونات الحصرية وأحدث العروض",
			cartNextAction: "الشروع في دفع",
			cartTitle: "طلبك",
			cartPleaseSelectProduct: "الرجاء تحديد المنتج ذي الصلة ليتم استرداده",
			cartPreviousAction: "عودة",
			cartChangeAction: "يتغيرون",
			cartRemoveAction: "إزالة",
			cartProductUnitPriceEach: "{{price}} كل",
			cartEmptyMessage: "عربة التسوق فارغة",
			cartEmptyPrimaryAction: "ارجع إلى القائمة",
			cartProductUnavailableGeneral: "هذا البند غير متوفر حاليا",
			cartProductUnavailableAddon: "غير متوفره",
			cartProductUnavailableItem: "عائد قريبا",
			cartCancelOrderAction: "يلغي",
			cartUpsellTitle: "أضف المزيد إلى طلبك",
			cartUpsellAction: "أضف المزيد",
			cartUpsellGalleryCardButtonActionText: "يضيف",
			cartGroupedModalSecondaryAction: "يغلق",
			cartNoInternetLoadingTitle: "قضايا الاتصال",
			cartNoInternetLoadingMessage: "...نواجه مشكلات في الاتصال ، يرجى الانتظار بينما نحاول التعافي",
			cartNoInternetTitle: "نحن آسفون ، كانت هناك مشكلة في الاتصال.",
			cartNoInternetClose: "نعم",
			productNextAction: "اضافة للأمر",
			productEditingNextAction: "أجل التحديث",
			productTitle: "يعدل أو يكيف",
			customisationExtraPriceWarning: "لقد أضفت {{price}} إضافية إلى وجبتك",
			customisationPriceEach: "{{السعر}} كل",
			categoryComboModalTitle: "حدد حجم الوجبة",
			categoryPreviousAction: "عودة",
			productCustomisationsAdditionalPriceWarning: "لقد أضفت {{price}} إضافية إلى وجبتك",
			productCustomisationsReadOnlyEach: "{{price}} كل",
			productCustomisationsReadonlyProductRemoved: "لا {{name}}",
			productCustomisationsUnlimitedMax: "غير محدود",
			productCancelOrderAction: "يلغي",
			categoriesTitle: "لائحة الطعام",
			categoriesCancelOrderAction: "يلغي",
			cancelOrderButtonModalQuestion: "هل أنت متأكد أنك تريد إلغاء طلبك؟",
			cancelOrderButtonModalTitle: "الغاء الطلب",
			cancelOrderButtonModalPrimaryAction: "لا",
			cancelOrderButtonModalSecondaryAction: "نعم",
			cancelOrderButtonName: "يلغي",
			categoriesNextAction: "اكتمال",
			categoriesPreviousAction: "عودة",
			customerDetailsTitle: "الرجاء إدخال التفاصيل الخاصة بك",
			customerDetailsFormTitle: "سنتصل باسمك عندما يكون طلبك جاهزًا",
			customerDetailsFormSubTitle: "يرجى ادخال",
			customerDetailsPreviousAction: "عودة",
			customerDetailsNextAction: "إرسال",
			beaconTitle: "منارة",
			beaconFormHeaderTitle: "أدخل رقم المنارة",
			beaconFormHeaderSubtitle: "وسيصدر صوتًا ويومض عندما يكون طلبك جاهزًا للاستلام",
			beaconPreviousAction: "عودة",
			beaconAdditionalAction: "يلغي",
			beaconCancelAction: "يلغي",
			beaconFormPrimaryAction: "إرسال",
			beaconFormSecondaryAction: "يلغي",
			beaconNextAction: "إرسال",
			beaconInputError: "من فضلك أدخل رقما صالحا",
			couponTitle: "رمز الكوبون",
			couponPreviousAction: "عودة",
			couponFormHeaderTitle: "أدخل قسيمتك:",
			couponFormPrimaryAction: "يتأكد",
			couponFormSecondaryAction: "عودة",
			couponListHeaderTitle: "قسيمة",
			couponListAddToCartAction: "أضف إلى السلة",
			couponListChangeAction: "يتغير",
			couponErrorHeaderTitle: "عذرا، لا يمكن العثور على هذه القسيمة.",
			couponErrorSecondaryAction: "العودة إلى الفئات",
			couponErrorPrimaryAction: "حاول مرة أخرى",
			couponGroupedModalSecondaryAction: "يغلق",
			couponComboModalTitle: "حدد حجم الوجبة",
			couponComboModalSecondaryAction: "يغلق",
			couponNextAction: "اكتمال",
			composedPreviousAction: "خلف",
			composedEditingNextAction: "أجل التحديث",
			composedNextAction: "اضافة للأمر",
			composedCancelOrderAction: "يلغي",
			composedProductLayerTitle: "اختر المنتج {{layer}}",
			composedProductFinalTitle: "لقد اخترت هذا المنتج:",
			composedProductFinalCustomise: "قم بتأكيد اختيارك",
			composedHeaderTitle: "يعدل أو يكيف",
			orderValidationErrorMessage: "عفوًا ، حدث خطأ ما عندما حاولنا معالجة طلبك",
			requestTimedOut: "الطلب منتهي المدة",
			orderValidationErrorPrimaryAction: "أعد المحاولة",
			orderValidationErrorSecondaryAction: "يلغي",
			orderConfirmationErrorMessage: "تبا شيء ما حدث بشكل خاطئ",
			orderConfirmationGenericAdditionalMessage: "يرجى التأكد من إتمام عملية الدفع بالطريقة المحددة",
			orderConfirmationAdditionalMessage: "يرجى التأكد من إزالة بطاقتك من المحطة",
			orderConfirmationErrorPrimaryAction: "أعد المحاولة",
			orderConfirmationErrorSecondaryAction: "يلغي",
			orderConfirmationLoadingTitle: "تم الدفع بنجاح",
			orderConfirmationLoadingMessage: "يرجى الانتظار ، إرسال طلبك إلى المطبخ",
			orderConfirmationLoadingMessageFirstAutoRetry: "ابق معنا ، يستغرق الأمر وقتًا أطول قليلاً لإرسال طلبك إلى المطبخ.",
			orderConfirmationLoadingMessageSecondAutoRetry: "هناك تأخير بسيط في تمرير طلبك.",
			orderConfirmationNoInternetLoadingTitle: "قضايا الاتصال",
			orderConfirmationNoInternetLoadingMessage: "...نواجه مشكلات في الاتصال ، يرجى الانتظار بينما نحاول التعافي",
			orderConfirmationNoInternetTitle: "معذرة ، حدثت مشكلة أثناء إرسال طلبك إلى المطبخ. يرجى التقاط صورة للإيصال وإبلاغ العداد الأمامي.",
			orderConfirmationNoInternetDetailsTitle: "التفاصيل",
			orderConfirmationNoInternetDetailsDateTime: "تاريخ",
			orderConfirmationNoInternetDetailsCardNumber: "رقم البطاقة",
			orderConfirmationNoInternetClose: "نعم",
			orderPostErrorMessage: "تبا شيء ما حدث بشكل خاطئ",
			orderPostErrorPrimaryAction: "أعد المحاولة",
			orderPostErrorSecondaryAction: "يلغي",
			categoryGroupedModalSecondaryAction: "يغلق",
			categoryComboModalSecondaryAction: "يغلق",
			categoryNextAction: "اكتمال",
			productPreviousAction: "عودة",
			timeoutModalTitle: "أنت لا تزال هناك؟",
			timeoutModalSecondaryAction: "رفض",
			timeoutModalContentMessage: "العودة إلى المنزل في {{timeLeft}}",
			productComboSizeAction: "يتغيرون",
			productOptionCardPrimaryAction: "تغيير التحديد",
			productOptionCardSecondaryAction: "يعدل أو يكيف",
			paymentInstructions: "يرجى اتباع تعليمات الدفع الموجودة على لوحة الدبوس أدناه",
			paymentErrorMessage: "عفوًا شيء ما حدث بشكل خاطئ",
			paymentErrorDetail: "عفوًا ، حدث خطأ - عادت لوحة الدبوس: {{message}}",
			paymentErrorQRCodeDetail: "عفوًا ، حدث خطأ - كانت استجابة رمز الاستجابة السريعة: {{message}}",
			paymentErrorQRCodeMessage: "يرجى مسح رمز الاستجابة السريعة ضوئيًا للحصول على إيصال الدفع الفاشل",
			paymentStatusCheckMessage: "انتظر ريثما نتحقق مما إذا كانت عملية الدفع الخاصة بك ناجحة",
			paymentStatusSuccessMessage: "تم الدفع بنجاح ، سنقوم الآن بتقديم طلبك",
			paymentRetryMessage: "أعد المحاولة",
			paymentCancelMessage: "يلغي",
			paymentOptionsTitle: "اختار طريقة الدفع",
			paymentOptionsSecondaryAction: "خلف",
			paymentOptionsCARDTitle: "بطاقة",
			paymentOptionsCASHTitle: "السيولة النقدية",
			paymentOptionsMOMOPAYTitle: "مومو",
			paymentOptionsExpressMessage: "الخروج السريع",
			paymentNoInternetLoadingTitle: "قضايا الاتصال",
			paymentNoInternetLoadingMessage: "...نواجه مشكلات في الاتصال ، يرجى الانتظار بينما نحاول التعافي",
			paymentNoInternetTitle: "نحن آسفون ، كانت هناك مشكلة في الاتصال.",
			paymentNoInternetClose: "نعم",
			paymentFetchingQRCode: "إحضار رمز الاستجابة السريعة",
			paymentScanQRCode: "يرجى مسح رمز الاستجابة السريعة ضوئيًا في تطبيق مومو",
			paymentScanQRCodeMessage: "يجب إكمال عملية الدفع في تطبيق Momo. إذا كنت ترغب في إلغاء المعاملة، يرجى القيام بذلك من التطبيق.",
			productOptionItemCardSelectedMessage: "في وجبتك",
			productOptionsChangeModalCloseAction: "رفض",
			offerLimitModalTitle: "العرض موجود بالفعل في سلة التسوق الخاصة بك",
			offerLimitConfirmation: "يُسمح بعرض واحد فقط لكل طلب. هل ترغب في استبدال العرض الحالي؟",
			orderValidationLoadingTitle: "تحديث العربة",
			orderValidationLoadingMessage: "أخذك للتحقق",
			orderPostLoadingTitle: "تم الدفع بنجاح",
			orderPostLoadingMessage: "يرجى الانتظار ، إرسال طلبك إلى المطبخ",
			productCustomisationsReadOnlyExtra: "التخصيصات",
			productCustomisationsProductsMissingError: "يُرجى إضافة {{productsMissingCount}} عنصر",
			productCustomisationsProductsMissingError_plural: "الرجاء إضافة {{productsMissingCount}} عنصرًا",
			autoRedirectNotificationTitle: "عفوًا ، ما زلنا نواجه مشكلات ، ولم يتبق المزيد من المحاولات",
			autoRedirectNotificationAdditionalMessage: "اسف بشأن ذلك",
			autoRedirectNotificationMessage: "إعادة توجيهك إلى بر الأمان",
			autoRedirectNotificationButton: "نعم",
			upsellModalTitle: "هل ترغب في إضافة هذه إلى الطلب؟",
			productCustomisationModalHeaderTitle: "يعدل أو يكيف",
			productCustomisationModalAddToCartAction: "اضافة للأمر",
			productCustomisationModalUpdateCartAction: "أجل التحديث",
			productCustomisationModalCloseAction: "رفض",
			upsellModalCloseAction: "رفض",
			productOptionCustomisationModalAddToCartAction: "أضف إلى السلة",
			productOptionCustomisationModalUpdateCartAction: "أجل التحديث",
			productOptionCustomisationModalCloseAction: "رفض",
			bannerWarningTitle: "صحتك ورفاهيتك هي أولويتنا رقم 1",
			bannerWarningDescription: "لقد قمنا بزيادة إجراءات التنظيف والنظافة الصارمة بالفعل في هذه الأوقات الصعبة.",
			paymentMethodCard: "مدفوعات البطاقة فقط",
			miniCartNextAction: "اكتمال",
			miniCartCloseAction: "يغلق",
			miniCartCheckoutAction: "الدفع",
			miniCartTotal: "المجموع",
			invalidRouteTitle: "عفوًا ، يبدو أنك تائه",
			invalidRouteButton: "العودة إلى بر الأمان",
			templateMenuAction: "القائمة",
			templateCancelAction: "يلغي",
			templateBasketAction: "مشاهدة الطلب",
			templateCouponAction: "أدخل العرض",
			refundGenericInstructions: "يرجى الانتظار لاسترداد المبلغ",
			refundInstructions: "يرجى انتظار استرداد الأموال على لوحة الدبوس أدناه",
			refundErrorMessage: "تبا شيء ما حدث بشكل خاطئ",
			refundRetryMessage: "أعد المحاولة",
			refundCancelMessage: "يلغي",
			refundCancelButton: "نعم",
			refundSuccessButton: "نعم",
			refundCancelDetails: "تفاصيل",
			refundCancelDateTime: "تاريخ",
			refundCancelCardNumber: "رقم البطاقة",
			refundCancelOrderNumber: "رقم الطلب",
			refundSuccessMessage: "بدأت عملية استرداد الأموال بنجاح. يرجى ملاحظة أن الوقت اللازم لتفعيله يعتمد على طريقة الدفع.",
			refundCancelledMessage: "معذرة ، حدثت مشكلة أثناء إرسال طلبك إلى المطبخ. يرجى التقاط صورة أو تنزيل الإيصال من رمز الاستجابة السريعة وإبلاغ العداد الأمامي.",
			refundSuccessTitle: "نجاح الاسترداد",
			refundLoadingTitle: "استرداد تحميل",
			menuAction: "لائحة الطعام",
			menuPreviousAction: "رجوع",
			productCustomisationsRemove: "إزالة",
			productCustomisationsChange: "يتغيرون",
			productCustomisationsResetting: "إعادة تعيين...",
			productCustomisationsReset: "إعادة تعيين",
			productCustomisationsDeselect: "قم بإلغاء التحديد",
			productCustomisationsAdd: "يضيف",
			productCustomisationsSelect: "يختار",
			warningTitle: "عفوًا ، يبدو أنه حدث خطأ ما",
			warningCancelAction: "يلغي",
			warningTryAgainAction: "حاول مرة أخري",
			receiptTitle: "طلبك",
			receiptEcoMessage: "ورق مجاني",
			transactionsNavigatorNextAction: "التالي",
			transactionsNavigatorPreviousAction: "سابق",
			transactionsTitle: "المعاملات",
			transactionsIdentityTitle: "هوية",
			transactionsIdentityId: "معرف جلسة العمل",
			transactionsIdentityStatus: "حالة",
			transactionsIdentityTimestamp: "تاريخ",
			transactionsIdentityType: "نوع الطلب",
			transactionsIdentityMessage: "رسالة",
			transactionsIdentityOrderReference: "ترتيب المرجعي",
			transactionsPaymentTitle: "المجموع",
			transactionsPaymentType: "نوع الدفع",
			transactionsPaymentAmount: "إجمالي البطاقة",
			transactionsPaymentAuthCode: "كود المصادقة",
			transactionsPaymentCardNumber: "رقم البطاقة",
			transactionsPaymentTransactionId: "رقم المعاملة",
			transactionsCartTitle: "عربة التسوق",
			transactionsPaymentOrderTotal: "الطلب الكلي",
			transactionsPaymentNoPaymentFound: "لم يتم العثور على دفعة",
			transactionsPrimaryAction: "عودة",
			transactionsPaymentCardType: "نوع البطاقة",
			transactionsNotFound: "لا توجد معاملات مخزنة منذ آخر إعادة تشغيل",
			quantityControllerOutlinedLabel: "الكمية",
			defaultLoadingTitle: "تدفئة المطبخ",
			loadingCoupon: "البحث عن القسيمة",
			defaultLoadingMessage: "انتظر من فضلك",
			termsAndConditionsModalTitle: "البنود و الظروف",
			termsAndConditionsModalCloseAction: "يغلق",
			ORDER_CONFIRMATION_SUCCESS: "نجاح",
			ORDER_REFUND_CANCELLED: "تم إلغاء رد الأموال",
			ORDER_CONFIRMATION_ERROR: "خطأ",
			ORDER_CANCELLED: "ملغى",
			ORDER_VALIDATION_ERROR: "خطأ في التحقق من الصحة",
			ORDER_REFUND_SUCCESS: "تم رد الأموال بنجاح",
			ORDER_VALIDATION_SUCCESS: "نجاح التحقق",
			ORDER_PAYMENT_ERROR: "خطأ في الدفع",
			ORDER_PAYMENT_SUCCESS: "نجاح الدفع",
			ORDER_REFUND_ERROR: "خطأ في رد الأموال",
			ORDER_POST_SUCCESS: "نجاح",
			ORDER_POST_ERROR: "خطأ",
			transactionsLateRefund: "الاسترداد المتأخر",
			transactionsLateRefundFalse: "لا",
			transactionsLateRefundTrue: "نعم",
			transactionLateRefundModalText: "هل أنت متأكد أنك تريد استرداد؟",
			transactionLateRefundFailedMessage: "نحن آسفون ، لم نتمكن من معالجة رد الأموال.",
			transactionLateRefundCancelledMessage: "تم إلغاء رد الأموال!",
			showAddonAvailabilityMessage: "عائد قريبا",
			addonRemovedModalTitle: "أزلنا بعض العناصر",
			addonRemovedMessage: "بالمناسبة ، أزلنا ما يلي:",
			addonRemovedFooterMessage: "العناصر متوفرة فقط عند الشراء",
			loyaltyLoginTitle: "دخول الأعضاء",
			loyaltyLoginNextAction: "يتأكد",
			loyaltyLoginPreviousAction: "عودة",
			loyaltyBannerTitle: "اكسب واستمتع بمكافآتك!",
			loyaltyBannerSubtitle: "هل أنت عضونا؟",
			loyaltyBannerMember: "عضو:",
			loyaltyBannerLogin: "تسجيل الدخول",
			loyaltyBannerLogout: "تسجيل الخروج",
			loyaltyBannerOffers: "عروض",
			loyaltyBannerOffersAndDeals: "العروض والصفقات",
			loyaltyBannerRedeemables: "القابلة للاسترداد",
			loyaltyOffersTitle: "عروض الأعضاء",
			loyaltyOffersPreviousAction: "خلف",
			loyaltyOffersNextAction: "مكتمل",
			loyaltyLoginCodeTitle: "ادخل الرمز",
			loyaltyQrLoginCodeTitle: "أو قم بالمسح باستخدام تطبيقك",
			bestValueProduct: "القيمة الأفضل",
			hotDealProduct: "صفقة ساخنة",
			loyaltyWelcomeModalTitle: "مرحباً بعودتك، {{name}}",
			loyaltyWelcomeModalPoints: "لديك {{points}} نقاط",
			loyaltyWelcomeModalConfirm: "حسنًا",
			loyaltyLogOutModalConfirm: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
			loyaltyLoginFailedModalTitle: "عذرًا",
			loyaltyLoginFailedModalClose: "حاول مجددًا",
			loyaltyLoginFailedModalContent: "لم نتمكن من التحقق من الرمز الخاص بك",
			loyaltyLoginOrSkipModalTitle: "المكافآت بطريقتك",
			loyaltyLoginOrSkipModalLoginButtonText: "تسجيل الدخول",
			loyaltyLoginOrSkipModalSkipButtonText: "تخطي",
			loyaltyMemberSignInButtonText: "تسجيل دخول العضو",
			loyaltyGuestOrderButtonText: "طلب كضيف",
			loyaltyOrderHistoryTitle: "تاريخ الطلب",
			loyaltyReorderTitle: "إعادة الطلب {{orderDate}}",
			loyaltyReorderViewOrder: "مشاهدة الطلب",
			loyaltyReorderAddToCart: "اضافة للأمر",
			loyaltyReorderAddingToCart: "جارٍ الإضافة...",
			loyaltyReorderCancel: "يغلق",
			appDownloadTitle: "تنزيل التطبيق",
			appDownloadContent: "لست عضوًا؟",
			appDownloadSubContent: "امسح هذا الرمز لتنزيل تطبيق كنتاكي والاشتراك",
			appDownloadPreviousAction: "عودة",
			appDownloadNextAction: "تسجيل الدخول",
			chooseCustomisations: "اختر التخصيصات الخاصة بك",
			taxesFees: "الضرائب والرسوم",
			discount: "تخفيض",
			chooseProductCustomisations: "التخصيصات",
			cartComboModalTitle: "حدد حجم الوجبة",
			cartComboModalSecondaryAction: "يغلق"
		}
	},
	tha: {
		translation: {
			actions: "แอคชั่น",
			add: "เพิ่ม",
			addAdditionalItem: "กรุณาเพิ่มรายการใดรายการหนึ่ง",
			addMore: "เพิ่มรายการอีก",
			addMoreToYourOrder: "เพิ่มรายการในการสั่งซื้อของคุณ",
			addToCart: "หยิบใส่ตะกร้า",
			addToOrder: "สั่งเพิ่ม",
			address: "ที่อยู่",
			adminActions: "แอคชั่น",
			adminConsole: "คอนโซล",
			adminExit: "ออก",
			adminKAS: "KAS",
			adminLockScreen: "ล้อกหน้าจอ",
			adminMenu: "เมนู",
			adminPanel: "Admin Panel",
			adminReboot: "รีบูท",
			adminRefresh: "รีเฟรช",
			adminSendSettlementRequest: "ส่งคำขอการชำระ",
			adminSoftLockScreen: "Soft Lock Kiosk",
			adminTransactions: "ธุรกรรม",
			adminView: "Admin View",
			advanced: "Advanced",
			advancedPanel: "Advanced Panel",
			allergensNutritionInfo: "ข้อมูลสารก่อภูมิแพ้และโภชนาการ",
			applePay: "Apple Pay",
			autoRedirectNotificationAdditionalMessage: "หากคุณไม่ต้องการรอ คลิกที่ปุ่มด้านล่างเพื่อไปยังหน้าต่อไป",
			autoRedirectNotificationButton: "ยกเลิก",
			autoRedirectNotificationMessage: "คุณจะถูกนำไปยังหน้าต่อไปในอีก 5 วินาที",
			autoRedirectNotificationTitle: "กำลังเปลี่ยนหน้า",
			back: "กลับ",
			beaconTitle: "หมายเลขบีคอน",
			cancel: "ยกเลิก",
			cancelOrder: "ยกเลิกคำสั่งซื้อ",
			cancelOrderButtonModalPrimaryAction: "ยืนยัน",
			cancelOrderButtonModalQuestion: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อนี้",
			cancelOrderButtonModalSecondaryAction: "ยกเลิก",
			cancelOrderButtonModalTitle: "ยกเลิกคำสั่งซื้อ",
			cancelPaymentInstructions: "หากคุณต้องการยกเลิกการทำธุรกรรม ให้กดปุ่ม [x] สีแดงบนอุปกรณ์ชำระเงิน",
			cancelYourOrder: "ยกเลิกคำสั่งซื้อ?",
			card: "บัตรเครดิต",
			cart: "ตะกร้า",
			cartCancelOrderAction: "ยกเลิก",
			cartChangeAction: "เปลี่ยน",
			cartEmpty: "รถเข็นของคุณว่างเปล่า",
			cartEmptyMessage: "ไม่มีสินค้าในตะกร้า",
			cartEmptyPrimaryAction: "เลือกสินค้า",
			cartNextAction: "ต่อไป",
			cartPreviousAction: "ก่อนหน้า",
			cartProductUnitPriceEach: "ราคาต่อหน่วย",
			cartRemoveAction: "ลบ",
			cartTitle: "ตะกร้าสินค้า",
			cartPleaseSelectProduct: "โปรดเลือกผลิตภัณฑ์ที่เกี่ยวข้องเพื่อแลก",
			cash: "เงินสด",
			categoriesNextAction: "ต่อไป",
			categoriesPreviousAction: "ก่อนหน้า",
			categoriesTitle: "เมนู",
			categoryNextAction: "สมบูรณ์",
			categoryNotFound: "ขออภัย ไม่พบหมวดหมู่นี้",
			categoryPreviousAction: "กลับ",
			change: "เปลี่ยน",
			changeSelection: "เปลี่ยนการเลือก",
			checkKioskConsole: "โปรดตรวจสอบคอนโซล Kiosk สำหรับข้อมูลเพิ่มเติม",
			checkingKitchenMessage: "ตรวจครัว",
			chooseYourLanguage: "เลือกภาษา",
			clear: "ล้าง",
			comingSoon: "เร็ว ๆ นี้",
			completeOrder: "คำสั่งซื้อเสร็จสมบูรณ์",
			confirm: "ยืนยัน",
			console: "คอนโซล",
			contains: "บรรจุ",
			"continue": "ดำเนินการต่อ",
			continueOrder: "สั่งต่อ",
			countryCodeInvalid: "รหัสประเทศต้องอยู่ระหว่าง 2 ถึง 4 อักษร รวมทั้งสัญลักษณ์ '+'",
			couponCode: "ใส่คูปองของคุณ",
			couponTryAgainOnError: "ลองอีกครั้ง",
			customerDetailsEmailDescription: "เราจะส่งใบเสร็จไปยังที่อยู่อีเมลนี้",
			customerDetailsEmailLabel: "อีเมล",
			customerDetailsFirstNameLabel: "ชื่อ",
			customerDetailsFormPrimaryAction: "ต่อไป",
			customerDetailsFormSubTitle: "กรุณากรอกข้อมูลของคุณ",
			customerDetailsFormTitle: "รายละเอียดลูกค้า",
			customerDetailsInputInvalidError: "กรุณากรอกข้อมูลที่ถูกต้อง",
			customerDetailsInputRequiredError: "กรุณากรอกข้อมูล",
			customerDetailsInputMinimumError: "{{ label }} ไม่ตรงตามความยาวขั้นต่ำที่กำหนด",
			customerDetailsLastNameLabel: "นามสกุล",
			customerDetailsPhoneNumberLabel: "หมายเลขโทรศัพท์ {{ required }}",
			customerDetailsOptional: "ไม่จำเป็น",
			customerDetailsPreviousAction: "กลับ",
			customerDetailsProfaneInputError: "กรุณากรอกข้อมูลที่ถูกต้อง",
			customerDetailsRequired: "จำเป็นต้องกรอก",
			customerDetailsSpecialCharactersInputError: "กรุณากรอกข้อมูลที่ถูกต้อง",
			customerDetailsTitle: "รายละเอียดลูกค้า",
			customise: "ปรับแต่ง",
			customiseCategoryAddedPrice: "คุณได้เพิ่ม {{price}} ในมื้ออาหารของคุณแล้ว",
			customiseCategoryMessage: "โปรดเพิ่ม {{quantity}}",
			customiseCategoryMessagePlural: "โปรดเพิ่ม {{quantity}}",
			doYouReallyWantTo: "คุณต้องการจริงๆใช่ไหม",
			done: "เสร็จแล้ว",
			eatIn: "ทานที่ร้าน",
			emailAddress: "อีเมล",
			emailCaseInsensitive: "ไม่ต้องกังวล ที่อยู่อีเมลใช้กับตัวพิมพ์ใหญ่ได้",
			emailInvalid: "ที่อยู่อีเมลไม่ถูกต้อง",
			enterDetails: "กรุณากรอกรายละเอียดของคุณ",
			enterOffer: "ป้อนข้อเสนอ",
			errorPlacingOrder: "ขออภัย เราไม่สามารถดำเนินการตามคำสั่งซื้อของคุณได้ในขณะนี้",
			exit: "ออก",
			extra: "พิเศษ",
			fancyLittleMore: "เลือกเพิ่มอีกนิด?",
			firstName: "ชื่อ",
			generatingReceipt: "กำลังสร้างใบเสร็จรับเงิน",
			giftCard: "บัตรของขวัญ",
			googlePay: "Google Pay",
			gstNumber: "หมายเลข guest",
			bannerWarningDescription: "เราได้เพิ่มขั้นตอนการทำความสะอาดและสุขอนามัยที่เข้มงวดอยู่แล้วในช่วงเวลาที่ท้าทายเหล่านี้",
			bannerWarningTitle: "สุขภาพและความเป็นอยู่ที่ดีของคุณเป็นสิ่งสำคัญอันดับ 1 ของเรา",
			homeConnectivityIssues: "เรากำลังมีปัญหาในการเชื่อมต่อ โปรดรอสักครู่ขณะที่เรากำลังพยายามกู้คืน...",
			homeTermsAndConditionsBannerWarningTitle: "ข้อตกลงและเงื่อนไข",
			homeTermsAndConditionsBannerWarningDescription: "การดำเนินการต่อแสดงว่าคุณยอมรับของเรา",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "ข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัว",
			homePrimaryAction: "ซื้อกลับบ้าน",
			homeSecondaryAction: "กินเข้าไป",
			homeSubtitle: "สั่งซื้อที่นี่",
			homeTitle: "ด่วน",
			hungry: "ด่วน",
			inYourMeal: "ในมื้ออาหารของคุณ",
			items: "ไอเท็ม",
			kas: "KAS",
			keepBrowsing: "เรียกดูต่อ",
			kioskLocked: "ขออภัย เครื่องนี้ไม่พร้อมใช้งาน",
			kioskOverview: "ภาพรวมคีออสก์",
			kitchenErrorMessage: "ขออภัย เราไม่สามารถส่งคำสั่งซื้อของคุณไปที่ห้องครัวได้ โปรดลองอีกครั้ง",
			kitchenTryAgainOnError: "ลองอีกครั้ง",
			large: "ขนาดใหญ่",
			lastInitial: "นามสกุล",
			loadingDataFromCache: "กรุณารอสักครู่ กำลังโหลดข้อมูล",
			lockKiosk: "Lock Kiosk",
			lockScreen: "กรุณาสั่งที่เคาน์เตอร์",
			lockText: "กรุณาสั่งที่เคาน์เตอร์",
			lockscreen: "กรุณาสั่งที่เคาน์เตอร์",
			majorCards: "ชำระผ่านบัตรเท่านั้น",
			manualRefundInstructions: "โปรดถ่ายภาพหน้าจอนี้และนำไปที่เคาน์เตอร์เพื่อขอคืนเงิน",
			manualRefundTitle: "มีปัญหาในการสั่งซื้อของคุณ",
			menu: "เมนู",
			menuAction: "เมนู",
			menuFound: "พบการตั้งค่า",
			menuNotFound: "ขออภัย เราไม่สามารถเรียกรับเมนูได้ โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของเรา",
			menuSettingsError: "ขออภัย เราไม่สามารถรับการตั้งค่าเพื่อรับเมนูได้ โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของเรา",
			menuTryAgainOnError: "ลองอีกครั้ง",
			miniCartCloseAction: "ปิด",
			miniCartNextAction: "ต่อไป",
			next: "ถัดไป",
			no: "ไม่ใช่",
			notFoundSubTitle: "คุณไปผิดหน้า กำลังเปลี่ยนเส้นทางคุณกลับบ้านในไม่ช้า",
			notFoundTitle: "ไม่พบหน้านี้",
			order: "คำสั่งซื้อ",
			orderCancelProcessInstruction: "โปรดรอสักครู่",
			orderCancelProcessTitle: "เรากำลังยกเลิกคำสั่งซื้อของคุณ",
			orderConfirmationGenericAdditionalMessage: "โปรดตรวจสอบให้แน่ใจว่าการชำระเงินของคุณเสร็จสิ้นตามวิธีที่เลือก",
			orderConfirmationAdditionalMessage: "ขอบคุณที่ใช้บริการ",
			orderConfirmationErrorMessage: "ขออภัย มีบางอย่างผิดพลาด โปรดลองอีกครั้ง",
			orderConfirmationErrorPrimaryAction: "ลองอีกครั้ง",
			orderConfirmationErrorSecondaryAction: "ยกเลิก",
			orderConfirmationLoadingMessage: "กรุณารอสักครู่",
			orderConfirmationLoadingMessageFirstAutoRetry: "อยู่กับเรา ใช้เวลานานขึ้นเล็กน้อยในการส่งคำสั่งซื้อของคุณไปที่ห้องครัว",
			orderConfirmationLoadingMessageSecondAutoRetry: "มีความล่าช้าเล็กน้อยในการส่งคำสั่งซื้อของคุณ",
			orderConfirmationLoadingTitle: "กำลังตรวจสอบ",
			orderConfirmationNoInternetClose: "ปิด",
			orderConfirmationNoInternetDetailsDateTime: "วันที่และเวลา",
			orderConfirmationNoInternetDetailsOrderNumber: "หมายเลขคำสั่งซื้อ",
			orderConfirmationNoInternetDetailsTitle: "เชื่อมต่อไม่ได้",
			orderConfirmationNoInternetLoadingMessage: "กรุณารอสักครู่",
			orderConfirmationNoInternetLoadingTitle: "กำลังตรวจสอบ",
			orderConfirmationNoInternetTitle: "เชื่อมต่อไม่ได้",
			orderFinishProcessInstruction: "โปรดรอสักครู่",
			orderFinishProcessMessage: "เรากำลังยืนยันคำสั่งซื้อของคุณไปที่ครัว",
			orderFinishProcessTitle: "เกือบเสร็จแล้ว",
			orderHealthCheckErrorMessage: "ข้อผิดพลาดในครัว",
			orderHealthCheckInstruction: "โปรดรอสักครู่ขณะที่เราตรวจสอบสถานะครัว",
			orderHealthCheckMessage: "ตรวจสอบสถานะครัว",
			orderHealthCheckTitle: "ตรวจครัว",
			orderHealthCheckTryAgainOnError: "เกิดข้อผิดพลาดขณะตรวจสอบสถานะห้องครัว",
			orderHere: "สั่งซื้อที่นี่",
			orderIdMessage: "หมายเลขคำสั่งซื้อ",
			orderInitialsMessage: "ชื่อย่อของลูกค้า",
			orderPickupInstruction: "โปรดถ่ายรูปใบเสร็จนี้ จากนั้นรับสินค้าจากจุดรับสินค้า",
			orderPickupInstructionBeacon: "โปรดยืนข้างเคาน์เตอร์รับสินค้า แล้วเราจะโทรแจ้งหมายเลขคำสั่งซื้อของคุณเมื่อคำสั่งซื้อพร้อม",
			orderPickupInstructionCash: "จากนั้นชำระเงินสำหรับการสั่งซื้อของคุณที่เคาน์เตอร์",
			orderProcessCardErrorMessage: "ขออภัย เราไม่สามารถดำเนินการตามคำสั่งซื้อของคุณได้ โปรดลองอีกครั้งหรือแตะยกเลิกเพื่อคืนเงิน",
			orderProcessCashErrorMessage: "ขออภัย เราไม่สามารถดำเนินการตามคำสั่งซื้อของคุณได้ โปรดลองอีกครั้ง",
			orderProcessErrorMessage: "ขออภัย เราไม่สามารถดำเนินการตามคำสั่งซื้อของคุณได้ โปรดลองอีกครั้ง",
			orderProcessTryAgainOnError: "ลองอีกครั้ง",
			orderProviderError: "มีปัญหาในการติดต่อครัว โปรดอัปเดตรถเข็นของคุณเพื่อลองอีกครั้ง หรือติดต่อพนักงานเพื่อขอความช่วยเหลือ",
			orderStartProcessInstruction: "โปรดรอสักครู่",
			orderStartProcessMessage: "เรากำลังส่งคำสั่งซื้อของคุณไปที่ครัว",
			orderStartProcessMessageCash: "เรากำลังส่งคำสั่งซื้อของคุณไปที่เคาน์เตอร์",
			orderTotal: "ยอดรวมการสั่งซื้อ",
			orderValidationErrorMessage: "ขออภัย มีบางอย่างผิดพลาด โปรดลองอีกครั้ง",
			requestTimedOut: "คำขอหมดเวลา",
			orderValidationErrorPrimaryAction: "ลองอีกครั้ง",
			orderValidationErrorSecondaryAction: "ยกเลิก",
			orderValidationLoadingMessage: "กรุณารอสักครู่",
			orderValidationLoadingTitle: "กำลังตรวจสอบ",
			paperFree: "ไม่ใช้กระดาษ",
			paymentCancelMessage: "คุณได้ยกเลิกการชำระเงิน",
			paymentErrorDetail: "กรุณาตรวจสอบข้อมูลบัตรของคุณ",
			paymentErrorQRCodeDetail: "อ๊ะ มีข้อผิดพลาดเกิดขึ้น - การตอบกลับของ QR Code คือ: {{message}}",
			paymentErrorMessage: "ขออภัย เราไม่สามารถประมวลผลการชำระเงินของคุณได้ โปรดลองอีกครั้ง",
			paymentErrorQRCodeMessage: "กรุณาสแกน QR Code ในร้านค้า",
			paymentInstructions: "กรุณาชำระเงินในร้านค้า",
			paymentMethodCard: "ชำระเงินผ่านบัตรเท่านั้น",
			paymentNoInternetClose: "ปิด",
			paymentFetchingQRCode: "กำลังเรียกรหัส QR",
			paymentScanQRCode: "กรุณาสแกน QR Code ในแอป Momo",
			paymentScanQRCodeMessage: "ขั้นตอนการชำระเงินจะต้องเสร็จสิ้นในแอป Momo หากคุณต้องการยกเลิกธุรกรรม โปรดดำเนินการจากแอป",
			paymentNoInternetLoadingMessage: "กรุณารอสักครู่",
			paymentNoInternetLoadingTitle: "กำลังตรวจสอบ",
			paymentNoInternetTitle: "เชื่อมต่อไม่ได้",
			paymentOptionsCARDTitle: "บัตรเครดิตหรือเดบิต",
			paymentOptionsCASHTitle: "เงินสด",
			paymentOptionsMOMOPAYTitle: "โมโม่",
			paymentOptionsExpressMessage: "ชำระเงินด้วยบัตรเครดิตหรือเดบิต",
			paymentOptionsSecondaryAction: "กลับ",
			paymentOptionsTitle: "ชำระเงิน",
			paymentPending: "ที่รอการชำระเงิน",
			paymentRetryMessage: "กรุณาลองอีกครั้ง",
			paymentStatusCheckMessage: "กรุณารอสักครู่",
			paymentStatusSuccessMessage: "ชำระเงินสำเร็จ",
			paymentTryAgainOnError: "ลองอีกครั้ง",
			paymentTypesAccepted: "ยอมรับประเภทการชำระเงิน",
			paymentWaitingActionOnPinPad: "ชำระเงินแบบไม่ต้องสัมผัสหรือเสียบบัตรของคุณเข้ากับเครื่องอ่าน",
			phoneNumberInvalid: "หมายเลขโทรศัพท์ต้องมีความยาวระหว่าง 9 ถึง 12 ตัวอักษร",
			pleaseWait: "กำลังโหลด โปรดรอสักครู่",
			posFailure: "ขออภัย เราไม่สามารถดำเนินการตามคำสั่งซื้อของคุณได้ในขณะนี้",
			proceedToPayment: "ดำเนินการชำระเงิน",
			productCancelOrderAction: "ยกเลิก",
			productCustomisationModalAddToCartAction: "เพิ่ม",
			productCustomisationModalCloseAction: "ปิด",
			productCustomisationModalHeaderTitle: "ปรับเปลี่ยน",
			productCustomisationModalUpdateCartAction: "ปรับปรุง",
			productCustomisationsAdd: "เพิ่ม",
			productCustomisationsSelect: "เลือก",
			productCustomisationsProductsMissingError: "กรุณาเลือกสินค้า",
			productCustomisationsRemove: "ลบ",
			productCustomisationsChange: "เปลี่ยน",
			productCustomisationsResetting: "รีเซ็ต...",
			productCustomisationsReset: "รีเซ็ต",
			productCustomisationsDeselect: "ยกเลิกการเลือก",
			productNextAction: "ต่อไป",
			productNotFound: "ขออภัย ไม่พบสินค้านี้",
			productOptionCardSecondaryAction: "เพิ่ม",
			productOptionCustomisationModalAddToCartAction: "เพิ่ม",
			productOptionCustomisationModalCloseAction: "ปิด",
			productPreviousAction: "ก่อนหน้า",
			productTitle: "สินค้า",
			productUnavailableInCartMessage: "รายการนี้ไม่พร้อมใช้งาน",
			productUnavailableModalLine1: "อ๊ะ! มีรายการสินค้าในรถเข็นของคุณที่ไม่พร้อมให้บริการในขณะนี้ โปรดลบออกเพื่อดำเนินการต่อ",
			productUnavailableModalLine2: "โปรดลบออกเพื่อดำเนินการต่อ",
			profaneString: "อินพุตไม่ถูกต้อง",
			receiptCard: "บัตรเครดิต",
			receiptCash: "เงินสด",
			receiptClaimInstructions: "กรุณาเก็บใบเสร็จรับเงินเพื่อรับอาหาร",
			receiptClaimInstructionsCash: "กรุณาเก็บใบเสร็จเพื่อชำระค่าสินค้า",
			receiptDetailsInstruction: "โปรดสแกนรหัส QR เพื่อรับใบเสร็จ จากนั้นชำระเงินที่เคาน์เตอร์",
			receiptDetailsInstructionCash: "ชำระค่าสินค้าที่เคาน์เตอร์",
			receiptDetailsInstructionCard: "รับคำสั่งซื้อของคุณจากจุดรวบรวม",
			receiptDetailsOrderNumber: "หมายเลขคำสั่งซื้อ",
			receiptDetailsOrderType: "ประเภทคำสั่งซื้อ",
			receiptEcoMessage: "กระดาษฟรี",
			receiptError: "เกิดข้อผิดพลาดในการส่งใบเสร็จของคุณ",
			receiptInstructions: "ป้อนหมายเลขโทรศัพท์ของคุณ",
			receiptOrderType: "ประเภทคำสั่งซื้อ: {{orderType}}",
			receiptPaymentItemQuantity: "จำนวน",
			receiptPaymentPhone: "โทรศัพท์",
			receiptPaymentRestaurantAddress: "ที่อยู่ร้านอาหาร",
			receiptPaymentRestaurantName: "ชื่อร้านอาหาร",
			receiptPaymentSubTotal: "รวมย่อย",
			receiptPaymentTaxNumber: "หมายเลขภาษี",
			receiptPaymentTaxTotal: "ภาษีรวม",
			receiptPaymentTotal: "รวม",
			receiptPopupClose: "ปิด",
			receiptPopupMessage: "ถ่ายรูปหน้าจอเพื่อใช้เป็นใบเสร็จ หรือสแกนคิวอาร์โค้ดและดาวน์โหลดใบเสร็จ",
			receiptPrimaryAction: "เลือกสินค้า",
			receiptSentSuccess: "ส่งใบเสร็จรับเงินแล้ว",
			receiptSmsAction: "ส่ง SMS",
			receiptTermsAndConditionsAction: "ข้อตกลงและเงื่อนไข",
			receiptSubTotalVatExclusive: "ผลรวมย่อย (ไม่รวม VAT): {{value}}",
			receiptSubTotalVatTotal: "รวมภาษีมูลค่าเพิ่ม 5%: {{value}}",
			receiptTakeaway: "รับที่ร้าน",
			receiptTitle: "คุณต้องการใบเสร็จรับเงินไหม",
			receiptTitleLoading: "กำลังส่งใบเสร็จรับเงิน",
			receiptTotalWithOrderType: "{{orderType}} ทั้งหมด: {{value}}",
			receiveEmailAddress: "ลงทะเบียนเพื่อรับรู้เกี่ยวกับคูปองพิเศษและข้อเสนอล่าสุด",
			refundCancelButton: "ยกเลิก",
			refundCancelCardNumber: "หมายเลขบัตร",
			refundCancelDateTime: "วันที่และเวลา",
			refundCancelDetails: "คุณต้องการยกเลิกคำสั่งซื้อนี้หรือไม่",
			refundCancelledMessage: "คำสั่งซื้อถูกยกเลิกแล้ว",
			refundErrorMessage: "ขออภัย เราไม่สามารถดำเนินการการคืนเงินของคุณได้ โปรดลองอีกครั้ง",
			refundProcessMessage: "การชำระเงินของคุณจะได้รับการคืนเงิน โปรดรอสักครู่",
			refundSuccess: "คืนเงินสำเร็จ",
			refundTryAgainOnError: "ลองอีกครั้ง",
			refundWaitingActionOnPinPad: "อยู่ระหว่างดำเนินการการคืนเงิน",
			regular: "ขนาดปกติ",
			remove: "ลบ",
			removedCustomisedProduct: "ไม่มี {{name}}",
			restart: "รีสตาร์ท",
			restartingApplication: "โปรดรอสักครู่ กำลังเริ่มการทำงานใหม่",
			returnToCategories: "กลับไปที่หมวดหมู่",
			seeReceipt: "ดู",
			seeTransactionReceipt: "ดูใบเสร็จ",
			selectMealSize: "เลือกขนาดอาหาร",
			selectPaymentMethod: "เลือกวิธีการชำระเงิน",
			sendReceipt: "ส่งทาง SMS",
			sendSettlementRequest: "ส่งการชำระ",
			serialEntry: "ป้อนรหัสซีเรียล",
			serialKeyFound: "พบ {{serialKey}}",
			serialKeyNotFound: "ขออภัย เราไม่สามารถรับหมายเลขซีเรียลได้ โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของเรา",
			serialKeyTryAgainOnError: "ลองอีกครั้ง",
			settings: "การตั้งค่า",
			settingsFound: "พบการตั้งค่า",
			settingsNotFound: "ขออภัย เราไม่สามารถรับการตั้งค่า โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของเรา",
			settingsSerialKeyError: "ขออภัย เราไม่สามารถรับหมายเลขซีเรียลได้ โปรดติดต่อฝ่ายสนับสนุนด้านเทคนิคของเรา",
			settingsTryAgainOnError: "ลองอีกครั้ง",
			siteNumber: "หมายเลขไซต์",
			small: "ขนาดเล็ก",
			smsMessageOrder: "Hi from KFC\nYour order number is:\n",
			smsMessageReceipt: "Get your receipt at:\n",
			smsPhoneCannotStartWithZero: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
			smsPhoneDoesNotMeetMinimumLength: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
			smsPhoneExceedsMaxLength: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
			smsPrimaryAction: "ส่งรหัสยืนยัน",
			smsReceiptMessage1: "สวัสดีจากเคเอฟซี",
			smsReceiptMessage2: "หมายเลขคำสั่งซื้อของคุณคือ: {{orderNumber}}",
			smsReceiptMessage3: "รับใบเสร็จของคุณที่: {{- url}}",
			smsReceiptMessage4: "ที่รอการชำระเงิน",
			smsSecondaryAction: "ยกเลิก",
			smsSending: "กำลังส่ง",
			smsSubtitle: "กรุณากรอกหมายเลขโทรศัพท์ของคุณเพื่อรับรหัสยืนยัน",
			smsSuccessButton: "ยืนยัน",
			smsSuccessSubtitle: "กรุณากรอกรหัสยืนยันที่ได้รับ",
			smsSuccessTitle: "รหัสยืนยันถูกส่งไปยังหมายเลขโทรศัพท์ของคุณ",
			smsTitle: "ยืนยันหมายเลขโทรศัพท์",
			softLockScreen: "กรุณาสั่งที่เคาน์เตอร์",
			tableService: "บริการที่โต๊ะ",
			takeaway: "รับกลับ",
			taxInvoice: "ใบกำกับภาษี",
			templateBasketAction: "ดูคำสั่งซื้อ",
			templateCancelAction: "ยกเลิก",
			templateCouponAction: "ป้อนข้อเสนอ",
			templateMenuAction: "เมนู",
			test: "นี่คือการทดสอบการแปล",
			thankYou: "ขอบคุณครับ",
			timeoutModalContentMessage: "กลับถึงบ้าน ตี {{ timeLeft }}",
			timeoutModalSecondaryAction: "ลองอีกครั้ง",
			timeoutModalTitle: "เกิดข้อผิดพลาด",
			timeoutPopupButton: "ขอเวลาอีกนิด",
			timeoutPopupMessageFirstLine: "คุณยังอยู่ไหม",
			timeoutPopupMessageSecondLine: "หมดเวลาใน {{counter}} วินาที",
			total: "ทั้งหมด",
			transactions: "ธุรกรรม",
			updateOrder: "อัพเดทออเดอร์",
			upsellModalTitle: "คุณต้องการ",
			useComingSoon: "เร็ว ๆ นี้",
			useKioskReboot: "รีบูตคีออสก์",
			vatNumber: "หมายเลข VAT",
			viewOrder: "ดูคำสั่งซื้อ",
			waitForReceipt: "กรุณารอเพื่อดูใบเสร็จของคุณ",
			waitingMenu: "กรุณารอสักครู่ กำลังดาวน์โหลดเมนู",
			waitingSerialKey: "โปรดรอสักครู่ กำลังอ่านซีเรียลคีย์",
			waitingSettings: "กรุณารอสักครู่ กำลังดาวน์โหลดการตั้งค่า",
			whenReady: "เราจะโทรหาคุณเมื่อคำสั่งซื้อของคุณพร้อม",
			wouldLikeReceipt: "โปรดป้อนข้อมูลหากคุณต้องการใบเสร็จรับเงิน",
			yes: "ใช่",
			yourOrder: "คำสั่งซื้อของคุณ",
			yourOrderNumber: "หมายเลขคำสั่งซื้อของคุณ",
			adminTitle: "ผู้ดูแลระบบ",
			adminGeneralSection: "ทั่วไป",
			adminSerialKeyField: "รหัสซีเรียล",
			adminMenuSection: "เมนู",
			adminOrderingSection: "การสั่งซื้อ",
			adminOrganisationField: "องค์กร",
			adminStoreField: "ร้านค้า",
			adminSiteField: "ไซต์",
			adminTimezoneField: "เขตเวลา",
			adminVersionField: "เวอร์ชัน",
			adminEnvironmentField: "สิ่งแวดล้อม",
			adminMockFieldFalseText: "ไม่",
			adminMockFieldTrueText: "ใช่",
			adminPaymentSection: "การชำระเงิน",
			adminMockField: "จำลอง",
			adminProviderField: "ผู้ให้บริการ",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "ที่อยู่ IP",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "พอร์ต USB",
			adminLockModal: "ล็อคหน้าจอ",
			adminLockModalTitle: "ตัวเลือกล็อคหน้าจอ",
			adminLockModalClose: "ปิด",
			adminPrimaryLockAction: "หน้าจอล็อก - คีออสก์ไม่พร้อมใช้งาน",
			adminSecondaryLockAction: "หน้าจอล็อก - ร้านอาหารปิด",
			lockMessage: "คีออสก์ไม่พร้อมใช้งาน โปรดใช้คีออสก์อื่นหรือสั่งซื้อที่เคาน์เตอร์ด้านหน้า",
			lockSecondaryMessage: "ร้านอาหารปิดอยู่ในขณะนี้",
			adminLoginTitle: "โปรดป้อนรหัสผ่านผู้ดูแลระบบ",
			adminRefreshAction: "รีเฟรช",
			adminExitAction: "ออก",
			adminLoginPrimaryAction: "เข้าสู่ระบบ",
			adminLoginSecondaryAction: "ยกเลิก",
			adminLoginErrorPasswordMessage: "รหัสผ่านไม่ถูกต้อง",
			adminTransactionsAction: "ธุรกรรม",
			allergensMessage: "ประกอบด้วย: {{ สารก่อภูมิแพ้ }}",
			smsErrorMessage: "ไม่สามารถส่ง SMS",
			smsErrorDetailsMessage: "โปรดตรวจสอบหมายเลขที่คุณระบุ",
			smsMockErrorMessage: "การตอบกลับจำลองล้มเหลว",
			smsMockSuccessMessage: "จำลองการตอบสนองสำเร็จ",
			smsCountryCodeCannotBeEmpty: "รหัสประเทศต้องไม่ว่างเปล่า",
			smsCountryCodeStartWithZero: "รหัสประเทศไม่สามารถขึ้นต้นด้วยศูนย์",
			smsCountryCodeExceedsMaxLength: "รหัสประเทศเกินความยาวสูงสุดที่อนุญาต",
			smsCountryCodeDoesNotMeetMinimumLength: "รหัสประเทศไม่ตรงตามความยาวขั้นต่ำที่กำหนด",
			receiptDetailsPrimaryAction: "ใบเสร็จรับเงิน",
			receiptDetailsTaxInvoice: "ใบกำกับภาษี",
			receiptGSTExcludeMessage: "* ไม่รวม GST",
			receiptPaymentPending: "การชำระเงินรอดำเนินการ",
			receiptPaymentKitchenId: "รหัสครัว",
			receiptDineIn: "กินที่ร้าน",
			receiptQRCodeOpen: "ใบเสร็จ",
			smsReceiptHeaderText: "สวัสดีจาก KFC",
			smsReceiptOrderNumberText: "หมายเลขคำสั่งซื้อของคุณคือ: {{ orderNumber }}",
			smsReceiptUrlText: "รับใบเสร็จของคุณที่: {{ url }}",
			smsReceiptPendingPaymentText: "รอการชำระเงิน",
			smsErrorPrimaryAction: "ลองอีกครั้ง",
			smsErrorSecondaryAction: "ดำเนินการต่อ",
			customerDetailsFullNameLabel: "ชื่อเต็ม {{ required }}",
			customerDetailsFormSecondaryAction: "ข้าม",
			customerDetailsCancelOrderAction: "ยกเลิก",
			cartProductUnavailableGeneral: "รายการนี้ไม่พร้อมใช้งานในปัจจุบัน",
			cartProductUnavailableAddon: "ไม่พร้อมใช้งาน",
			cartProductUnavailableItem: "กลับมาเร็ว ๆ",
			cartUpsellTitle: "เพิ่มในคำสั่งซื้อของคุณ",
			cartUpsellAction: "เพิ่ม",
			cartUpsellGalleryCardButtonActionText: "เพิ่ม",
			cartGroupedModalSecondaryAction: "ปิด",
			cartNoInternetLoadingTitle: "ปัญหาการเชื่อมต่อ",
			cartNoInternetLoadingMessage: "เรากำลังมีปัญหาในการเชื่อมต่อ โปรดรอสักครู่ขณะที่เรากำลังพยายามกู้คืน...",
			cartNoInternetTitle: "ขออภัย มีปัญหาการเชื่อมต่อ",
			cartNoInternetClose: "ตกลง",
			productEditingNextAction: "อัปเดตคำสั่งซื้อ",
			customisationExtraPriceWarning: "คุณได้เพิ่ม {{price}} พิเศษในมื้ออาหารของคุณ",
			customisationPriceEach: "{{price}} แต่ละรายการ",
			categoryComboModalTitle: "เลือกขนาดอาหาร",
			productCustomisationsAdditionalPriceWarning: "คุณได้เพิ่ม {{price}} พิเศษในมื้ออาหารของคุณ",
			productCustomisationsReadOnlyEach: "{{price}} แต่ละรายการ",
			productCustomisationsReadonlyProductRemoved: "ไม่มี {{name}}",
			productCustomisationsUnlimitedMax: "ไม่จำกัด",
			categoriesCancelOrderAction: "ยกเลิก",
			cancelOrderButtonName: "ยกเลิก",
			customerDetailsNextAction: "ดำเนินการต่อ",
			beaconFormHeaderTitle: "ป้อนหมายเลขบีคอน",
			beaconFormHeaderSubtitle: "และจะส่งเสียงและกระพริบเมื่อคำสั่งซื้อของคุณพร้อมสำหรับการรับ",
			beaconPreviousAction: "ย้อนกลับ",
			beaconAdditionalAction: "ยกเลิก",
			beaconCancelAction: "ยกเลิก",
			beaconFormPrimaryAction: "ส่ง",
			beaconFormSecondaryAction: "ยกเลิก",
			beaconNextAction: "ส่ง",
			beaconInputError: "กรุณาป้อนหมายเลขที่ถูกต้อง",
			couponTitle: "รหัสคูปอง",
			couponPreviousAction: "ย้อนกลับ",
			couponFormHeaderTitle: "ป้อนคูปองของคุณ:",
			couponFormPrimaryAction: "ยืนยัน",
			couponFormSecondaryAction: "ย้อนกลับ",
			couponListHeaderTitle: "คูปอง",
			couponListAddToCartAction: "หยิบใส่ตะกร้า",
			couponListChangeAction: "เปลี่ยนแปลง",
			couponErrorHeaderTitle: "ขออภัย ไม่พบคูปองนี้",
			couponErrorSecondaryAction: "กลับสู่หมวดหมู่",
			couponErrorPrimaryAction: "ลองอีกครั้ง",
			couponGroupedModalSecondaryAction: "ปิด",
			couponComboModalTitle: "เลือกขนาดอาหาร",
			couponComboModalSecondaryAction: "ปิด",
			couponNextAction: "เสร็จสมบูรณ์",
			composedPreviousAction: "ย้อนกลับ",
			composedEditingNextAction: "อัปเดตคำสั่ง",
			composedNextAction: "เพิ่มไปยังคำสั่งซื้อ",
			composedCancelOrderAction: "ยกเลิก",
			composedProductLayerTitle: "เลือกผลิตภัณฑ์ {{layer}}",
			composedProductFinalTitle: "คุณเลือกผลิตภัณฑ์นี้:",
			composedProductFinalCustomise: "ยืนยันการเลือกของคุณ",
			composedHeaderTitle: "ปรับแต่ง",
			orderConfirmationNoInternetDetailsCardNumber: "หมายเลขบัตร",
			orderPostErrorMessage: "อ๊ะ มีบางอย่างผิดพลาด",
			orderPostErrorPrimaryAction: "ลองใหม่",
			orderPostErrorSecondaryAction: "ยกเลิก",
			categoryGroupedModalSecondaryAction: "ปิด",
			categoryComboModalSecondaryAction: "ปิด",
			productComboSizeAction: "เปลี่ยนแปลง",
			productOptionCardPrimaryAction: "เปลี่ยนการเลือก",
			productOptionItemCardSelectedMessage: "ในมื้ออาหารของคุณ",
			productOptionsChangeModalCloseAction: "ปิด",
			offerLimitModalTitle: "มีข้อเสนออยู่แล้วในรถเข็นของคุณ",
			offerLimitConfirmation: "อนุญาต 1 ข้อเสนอต่อคำสั่งซื้อเท่านั้น คุณต้องการเปลี่ยนข้อเสนอที่มีอยู่หรือไม่",
			orderPostLoadingTitle: "เสร็จสิ้นการสั่งซื้อ",
			orderPostLoadingMessage: "โปรดรอสักครู่ กำลังดำเนินการสั่งซื้อให้เสร็จสิ้น",
			productCustomisationsReadOnlyExtra: "การปรับแต่ง",
			productCustomisationsProductsMissingError_plural: "โปรดเพิ่ม {{ productsMissingCount }} รายการ",
			upsellModalCloseAction: "ปิด",
			productOptionCustomisationModalUpdateCartAction: "อัปเดตคำสั่งซื้อ",
			miniCartCheckoutAction: "ชำระเงิน",
			miniCartTotal: "ทั้งหมด",
			invalidRouteTitle: "อ๊ะ ดูเหมือนว่าคุณจะหลงทาง",
			invalidRouteButton: "กลับสู่ความปลอดภัย",
			refundGenericInstructions: "กรุณารอการคืนเงิน",
			refundInstructions: "โปรดรอการคืนเงินที่พินแพดด้านล่าง",
			refundRetryMessage: "ลองอีกครั้ง",
			refundCancelMessage: "ยกเลิก",
			refundSuccessButton: "ตกลง",
			refundCancelOrderNumber: "หมายเลขคำสั่งซื้อ",
			refundSuccessMessage: "กระบวนการคืนเงินเริ่มต้นเรียบร้อยแล้ว โปรดทราบว่าเวลาที่จะดำเนินการนั้นจะขึ้นอยู่กับวิธีการชำระเงิน",
			refundSuccessTitle: "คืนเงินสำเร็จ",
			refundLoadingTitle: "กำลังโหลดเงินคืน",
			menuPreviousAction: "ย้อนกลับ",
			warningTitle: "อ๊ะ ดูเหมือนว่ามีบางอย่างผิดพลาด",
			warningCancelAction: "ยกเลิก",
			warningTryAgainAction: "ลองอีกครั้ง",
			transactionsNavigatorNextAction: "ถัดไป",
			transactionsNavigatorPreviousAction: "ก่อนหน้า",
			transactionsTitle: "ธุรกรรม",
			transactionsIdentityTitle: "เอกลักษณ์",
			transactionsIdentityId: "รหัสเซสชัน",
			transactionsIdentityStatus: "สถานะ",
			transactionsIdentityTimestamp: "วันที่",
			transactionsIdentityType: "ประเภทการสั่งซื้อ",
			transactionsIdentityMessage: "ข้อความ",
			transactionsIdentityOrderReference: "การอ้างอิงคำสั่งซื้อ",
			transactionsPaymentTitle: "ทั้งหมด",
			transactionsPaymentType: "ประเภทการชำระเงิน",
			transactionsPaymentAmount: "ยอดรวมของบัตร",
			transactionsPaymentAuthCode: "รหัสรับรองความถูกต้อง",
			transactionsPaymentCardNumber: "หมายเลขบัตร",
			transactionsPaymentTransactionId: "รหัสธุรกรรม",
			transactionsPaymentOrderTotal: "ยอดรวมการสั่งซื้อ",
			transactionsPaymentNoPaymentFound: "ไม่ได้เลือกการชำระเงิน",
			transactionsPrimaryAction: "ย้อนกลับ",
			transactionsPaymentCardType: "ประเภทบัตร",
			transactionsNotFound: "ไม่มีธุรกรรมที่เก็บไว้ตั้งแต่รีบูตครั้งล่าสุด",
			quantityControllerOutlinedLabel: "ปริมาณ",
			defaultLoadingTitle: "อุ่นเครื่องในครัว",
			loadingCoupon: "กำลังค้นหาคูปอง",
			defaultLoadingMessage: "โปรดรอ",
			termsAndConditionsModalTitle: "ข้อตกลงและเงื่อนไข",
			termsAndConditionsModalCloseAction: "ปิด",
			ORDER_CONFIRMATION_SUCCESS: "สำเร็จ",
			ORDER_REFUND_CANCELLED: "การคืนเงินถูกยกเลิก",
			ORDER_CONFIRMATION_ERROR: "ข้อผิดพลาด",
			ORDER_CANCELLED: "ยกเลิก",
			ORDER_VALIDATION_ERROR: "ข้อผิดพลาดในการตรวจสอบ",
			ORDER_REFUND_SUCCESS: "คืนเงินสำเร็จ",
			ORDER_VALIDATION_SUCCESS: "การตรวจสอบความถูกต้องสำเร็จ",
			ORDER_PAYMENT_ERROR: "การชำระเงินผิดพลาด",
			ORDER_PAYMENT_SUCCESS: "ชำระเงินสำเร็จ",
			ORDER_REFUND_ERROR: "ข้อผิดพลาดในการคืนเงิน",
			ORDER_POST_SUCCESS: "สำเร็จ",
			ORDER_POST_ERROR: "ผิดพลาด",
			transactionsLateRefund: "การคืนเงินล่าช้า",
			transactionsLateRefundFalse: "ไม่",
			transactionsLateRefundTrue: "ใช่",
			transactionLateRefundModalText: "คุณแน่ใจหรือว่าต้องการคืนเงิน",
			transactionLateRefundFailedMessage: "ขออภัย เราไม่สามารถดำเนินการคืนเงินได้",
			transactionLateRefundCancelledMessage: "การคืนเงินถูกยกเลิก!",
			showAddonAvailabilityMessage: "กลับมาเร็ว ๆ",
			addonRemovedModalTitle: "เราลบบางรายการ",
			addonRemovedMessage: "อย่างไรก็ตาม เราได้ลบสิ่งต่อไปนี้ออกแล้ว:",
			addonRemovedFooterMessage: "รายการใช้ได้เฉพาะเมื่อซื้อ",
			loyaltyLoginTitle: "เข้าสู่ระบบสมาชิก",
			loyaltyLoginNextAction: "ยืนยัน",
			loyaltyLoginPreviousAction: "ย้อนกลับ",
			loyaltyBannerTitle: "รับและเพลิดเพลินไปกับรางวัลของคุณ!",
			loyaltyBannerSubtitle: "คุณเป็นสมาชิกของเราหรือไม่",
			loyaltyBannerMember: "สมาชิก:",
			loyaltyBannerLogin: "เข้าสู่ระบบ",
			loyaltyBannerLogout: "ออกจากระบบ",
			loyaltyBannerOffers: "ข้อเสนอ",
			loyaltyBannerOffersAndDeals: "ข้อเสนอและข้อเสนอ",
			loyaltyBannerRedeemables: "แลกได้",
			loyaltyOffersTitle: "ข้อเสนอสำหรับสมาชิก",
			loyaltyOffersPreviousAction: "กลับ",
			loyaltyOffersNextAction: "สมบูรณ์",
			loyaltyLoginCodeTitle: "ใส่รหัส",
			loyaltyQrLoginCodeTitle: "หรือสแกนด้วยแอพของคุณ",
			bestValueProduct: "คุ้มค่าที่สุด",
			hotDealProduct: "ข้อเสนอสุดพิเศษ",
			loyaltyWelcomeModalTitle: "ยินดีต้อนรับกลับ, {{name}}",
			loyaltyWelcomeModalPoints: "คุณมี {{points}} คะแนน",
			loyaltyWelcomeModalConfirm: "ตกลง",
			loyaltyLogOutModalConfirm: "คุณแน่ใจหรือว่าต้องการออกจากระบบ?",
			loyaltyLoginFailedModalTitle: "ขออภัย",
			loyaltyLoginFailedModalClose: "ลองอีกครั้ง",
			loyaltyLoginFailedModalContent: "เราไม่สามารถตรวจสอบรหัสของคุณ",
			loyaltyLoginOrSkipModalTitle: "รางวัลตามทางของคุณ",
			loyaltyLoginOrSkipModalLoginButtonText: "เข้าสู่ระบบ",
			loyaltyLoginOrSkipModalSkipButtonText: "ข้าม",
			loyaltyMemberSignInButtonText: "เข้าสู่ระบบสมาชิก",
			loyaltyGuestOrderButtonText: "สั่งซื้อโดยไม่ลงทะเบียน",
			loyaltyOrderHistoryTitle: "ประวัติการสั่งซื้อ",
			loyaltyReorderTitle: "สั่งซื้อใหม่ {{orderDate}}",
			loyaltyReorderViewOrder: "ดูคำสั่งซื้อ",
			loyaltyReorderAddToCart: "สั่งเพิ่ม",
			loyaltyReorderAddingToCart: "กำลังเพิ่ม...",
			loyaltyReorderCancel: "ปิด",
			appDownloadTitle: "ดาวน์โหลดแอป",
			appDownloadContent: "ไม่ใช่สมาชิกหรือ?",
			appDownloadSubContent: "สแกนรหัสนี้เพื่อดาวน์โหลดแอป KFC และสมัครสมาชิก",
			appDownloadPreviousAction: "กลับ",
			appDownloadNextAction: "เข้าสู่ระบบ",
			chooseCustomisations: "เลือกการปรับแต่งของคุณ",
			taxesFees: "ภาษีและค่าธรรมเนียม",
			discount: "การลดราคา",
			chooseProductCustomisations: "การปรับแต่ง",
			cartComboModalTitle: "เลือกขนาดมื้ออาหาร",
			cartComboModalSecondaryAction: "ปิด"
		}
	},
	vnm: {
		translation: {
			homeTitle: "ĐẶT HÀNG",
			homeSubtitle: "NHANH TẠI ĐÂY",
			homePrimaryAction: "Mua mang về",
			homeSecondaryAction: "Ăn tại chỗ",
			homeConnectivityIssues: "Chúng tôi đang gặp sự cố kết nối, vui lòng đợi trong khi chúng tôi đang cố khôi phục…",
			homeTermsAndConditionsBannerWarningTitle: "Điều khoản và điều kiện",
			homeTermsAndConditionsBannerWarningDescription: "Bằng cách tiếp tục, bạn sẽ chấp nhận điều khoản sử dụng",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "Điều khoản sử dụng và chính sách quyền riêng tư",
			adminTitle: "Quản trị viên",
			adminGeneralSection: "Chung",
			adminSerialKeyField: "Mã bảo mật",
			adminMenuSection: "Thực đơn",
			adminOrderingSection: "Đặt hàng",
			adminOrganisationField: "Sắp xếp",
			adminStoreField: "Nhà hàng",
			adminSiteField: "Địa điểm",
			adminTimezoneField: "Múi giờ",
			adminVersionField: "Phiên bản",
			adminEnvironmentField: "Môi trường",
			adminMockFieldFalseText: "Không",
			adminMockFieldTrueText: "Có",
			adminPaymentSection: "Thanh toán",
			adminMockField: "Giả lập",
			adminProviderField: "Nhà cung cấp",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "IP Address",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "USB Port",
			adminLockModal: "Màn hình khóa",
			adminLockModalTitle: "Tùy chọn màn hình khóa",
			adminLockModalClose: "Đóng",
			adminPrimaryLockAction: "Màn hình khóa - Kiosk không khả dụng",
			adminSecondaryLockAction: "Màn hình khóa - Nhà hàng đã đóng cửa",
			lockMessage: "Kiosk không khả dụng. Vui lòng sử dụng Kiosk khác hoặc đặt hàng tại quầy trước.",
			lockSecondaryMessage: "Nhà hàng hiện đang đóng cửa.",
			adminLoginTitle: "Vui lòng nhập mật khẩu quản trị viên",
			adminRefreshAction: "Làm mới",
			adminExitAction: "Thoát",
			adminLoginPrimaryAction: "Đăng nhập",
			adminLoginSecondaryAction: "Huỷ",
			adminLoginErrorPasswordMessage: "Mật khẩu không đúng",
			adminTransactionsAction: "Giao dịch",
			allergensMessage: "Thành phần: {{ allergens }}",
			smsSending: "Gửi tin nhắn SMS",
			smsErrorMessage: "Không thể gửi SMS",
			smsErrorDetailsMessage: "Vui lòng kiểm tra số bạn đã cung cấp",
			smsMockErrorMessage: "Phản hồi mô phỏng không thành công",
			smsMockSuccessMessage: "Phản hồi mô phỏng thành công",
			smsSuccessTitle: "Đã gửi SMS thành công",
			smsSuccessSubtitle: "SMS có thể mất một chút thời gian để nhận được",
			smsSuccessButton: "Tiếp tục",
			smsPrimaryAction: "Gửi",
			smsSecondaryAction: "Bỏ qua",
			smsCountryCodeCannotBeEmpty: "Mã quốc gia không được để trống",
			smsCountryCodeStartWithZero: "Mã quốc gia không thể bắt đầu bằng số không",
			smsCountryCodeExceedsMaxLength: "Mã quốc gia vượt quá độ dài tối đa cho phép",
			smsCountryCodeDoesNotMeetMinimumLength: "Mã quốc gia không đáp ứng độ dài yêu cầu tối thiểu",
			smsPhoneCannotStartWithZero: "Số điện thoại không được bắt đầu bằng '0'",
			smsPhoneExceedsMaxLength: "Số điện thoại vượt quá độ dài tối đa cho phép",
			smsPhoneDoesNotMeetMinimumLength: "Số điện thoại không đáp ứng độ dài yêu cầu tối thiểu",
			smsTitle: "Gửi biên lai qua SMS",
			smsSubtitle: "Xin vui lòng điền số điện thoại của bạn",
			receiptDetailsInstruction: "Vui lòng quét mã QR để nhận biên lai",
			receiptDetailsInstructionCash: "Thanh toán đơn hàng của bạn tại quầy",
			receiptDetailsInstructionCard: "Nhận đơn đặt hàng của bạn từ điểm thu thập",
			receiptDetailsOrderNumber: "THÔNG TIN ĐƠN HÀNG:",
			receiptDetailsPrimaryAction: "Biên lai",
			receiptSmsAction: "Tin nhắn",
			receiptTermsAndConditionsAction: "Điều khoản và điều kiện",
			receiptPrimaryAction: "Hoàn tất",
			receiptDetailsTaxInvoice: "Hóa đơn",
			receiptDetailsOrderType: "Loại",
			receiptPaymentRestaurantName: "Nhà hàng",
			receiptPaymentRestaurantAddress: "Địa chỉ",
			receiptPaymentPhone: "Điện thoại",
			receiptPaymentTaxNumber: "ABN",
			receiptPaymentItemQuantity: "Các sản phẩm",
			receiptPaymentTaxTotal: "Tax",
			receiptPaymentSubTotal: "Tổng phụ",
			receiptPaymentTotal: "Tổng cộng",
			receiptGSTExcludeMessage: "* Không bao gồm GST",
			receiptPaymentPending: "Đang chờ thanh toán",
			receiptPaymentKitchenId: "Kitchen ID",
			receiptCash: "Tiền mặt",
			receiptDineIn: "Ăn tại chỗ",
			receiptTakeaway: "Mua mang về",
			receiptQRCodeOpen: "Biên lai",
			smsReceiptHeaderText: "KFC xin chào",
			smsReceiptOrderNumberText: "Mã đơn hàng của bạn là: {{orderNumber}}",
			smsReceiptUrlText: "Truy cập đường dẫn để xem biên lai: {{- url}}",
			smsReceiptPendingPaymentText: "Đang chờ Thanh toán",
			smsErrorPrimaryAction: "Vui lòng thử lại",
			smsErrorSecondaryAction: "Tiếp tục",
			customerDetailsFullNameLabel: "Họ và tên {{ required }}",
			customerDetailsFirstNameLabel: "Họ {{ required }}",
			customerDetailsLastNameLabel: "Tên {{ required }}",
			customerDetailsPhoneNumberLabel: "Số điện thoại {{ required }}",
			customerDetailsRequired: "(Yêu cầu)",
			customerDetailsOptional: "(Không bắt buộc)",
			customerDetailsFormPrimaryAction: "Tiếp tục",
			customerDetailsFormSecondaryAction: "Bỏ qua",
			customerDetailsInputInvalidError: "{{ label }} không hợp lệ",
			customerDetailsEmailLabel: "Email {{ required }}",
			customerDetailsEmailDescription: "Biên nhận QR có sẵn khi thanh toán",
			customerDetailsInputRequiredError: "{{ label }} bắt buộc",
			customerDetailsInputMinimumError: "{{ label }} chưa đủ số ký tự tối thiểu của",
			customerDetailsProfaneInputError: "Vui lòng thử lại, từ này không được phép",
			customerDetailsSpecialCharactersInputError: "Vui lòng thử lại, ký tự đặc biệt không được phép",
			customerDetailsCancelOrderAction: "Huỷ",
			receiveEmailAddress: "Tôi muốn được thông báo khi có giảm giá và khuyến mãi mới nhất",
			cartNextAction: "Đến mục Thanh toán",
			cartTitle: "Đơn hàng của bạn",
			cartPleaseSelectProduct: "Vui lòng chọn sản phẩm phù hợp để đổi quà",
			cartPreviousAction: "Quay lại",
			cartEmptyMessage: "Giỏ hàng của bạn đang trống",
			cartEmptyPrimaryAction: "Quay lại thực đơn",
			cartProductUnavailableGeneral: "Mặt hàng này hiện không có sẵn",
			cartProductUnavailableAddon: "Không có sẵn",
			cartProductUnavailableItem: "Sẽ quay lại sớm",
			cartCancelOrderAction: "Huỷ",
			cartChangeAction: "Thay đổi",
			cartRemoveAction: "Xoá",
			cartProductUnitPriceEach: "{{price}}",
			cartUpsellTitle: "Thêm nhiều món hơn vào giỏ hàng của bạn",
			cartUpsellAction: "Thêm nhiều món hơn",
			cartUpsellGalleryCardButtonActionText: "Thêm",
			cartGroupedModalSecondaryAction: "Đóng",
			cartNoInternetLoadingTitle: "Sự cố kết nối",
			cartNoInternetLoadingMessage: "Chúng tôi đang gặp sự cố kết nối, vui lòng đợi trong khi chúng tôi đang cố khôi phục...",
			cartNoInternetTitle: "Chúng tôi rất tiếc, đã xảy ra sự cố kết nối.",
			cartNoInternetClose: "Đồng ý",
			productNextAction: "Thêm vào đơn hàng",
			productEditingNextAction: "Cập nhật giỏ hàng",
			productTitle: "Tuỳ chỉnh",
			customisationExtraPriceWarning: "Chúng tôi đã thêm {{price}} vào đơn hàng của bạn",
			customisationPriceEach: "{{price}}",
			paymentInstructions: "Vui lòng làm theo hướng dẫn thanh toán ở máy thanh toán bên dưới",
			paymentErrorMessage: "Rất tiếc, đã xảy ra lỗi",
			paymentErrorDetail: "Rất tiếc, đã xảy ra lỗi thanh toán: {{message}}",
			paymentErrorQRCodeDetail: "Rất tiếc, đã xảy ra lỗi khi thanh toán QR: {{message}}",
			paymentErrorQRCodeMessage: "Vui lòng quét Mã QR để nhận biên lai thanh toán của giao dịch không thành công",
			paymentStatusCheckMessage: "Đợi trong khi chúng tôi kiểm tra xem thanh toán của bạn có thành công không",
			paymentStatusSuccessMessage: "Thanh toán của bạn đã thành công, bây giờ chúng tôi sẽ đặt hàng của bạn",
			paymentRetryMessage: "Thử lại",
			paymentCancelMessage: "Huỷ",
			paymentOptionsTitle: "Lựa chọn phương thức thanh toán",
			paymentOptionsSecondaryAction: "Trở lại",
			paymentOptionsCARDTitle: "Thẻ",
			paymentOptionsCASHTitle: "Tiền mặt",
			paymentOptionsMOMOPAYTitle: "Momo",
			paymentOptionsExpressMessage: "Thanh toán nhanh",
			paymentNoInternetLoadingTitle: "Sự cố kết nối",
			paymentNoInternetLoadingMessage: "Chúng tôi đang gặp sự cố kết nối, vui lòng đợi trong khi chúng tôi đang cố khôi phục...",
			paymentNoInternetTitle: "Chúng tôi rất tiếc, đã xảy ra sự cố kết nối.",
			paymentNoInternetClose: "Đồng ý",
			paymentFetchingQRCode: "Nạp mã QR",
			paymentScanQRCode: "Vui lòng quét Mã QR bằng ứng dụng Momo để thanh toán",
			paymentScanQRCodeMessage: "Quá trình thanh toán phải được hoàn tất trong ứng dụng Momo. Nếu bạn muốn hủy giao dịch, vui lòng thực hiện việc đó từ ứng dụng.",
			categoryComboModalTitle: "Chọn phần ăn",
			categoryPreviousAction: "Quay lại",
			productCustomisationsAdditionalPriceWarning: "Chúng tôi đã thêm {{price}} vào đơn hàng của bạn",
			productCustomisationsReadOnlyEach: "{{price}}",
			productCustomisationsReadonlyProductRemoved: "Không {{name}}",
			productCustomisationsUnlimitedMax: "Không giới hạn",
			productCancelOrderAction: "Huỷ",
			categoriesTitle: "Thực đơn",
			categoriesCancelOrderAction: "Huỷ",
			cancelOrderButtonModalQuestion: "Bạn có chắc chắn muốn hủy đặt hàng của bạn?",
			cancelOrderButtonModalTitle: "Hủy đơn hàng",
			cancelOrderButtonModalPrimaryAction: "Không",
			cancelOrderButtonModalSecondaryAction: "Có",
			cancelOrderButtonName: "Huỷ",
			categoriesNextAction: "Hoàn thành",
			categoriesPreviousAction: "Quay lại",
			customerDetailsTitle: "Thông tin chi tiết",
			customerDetailsFormTitle: "Chúng tôi sẽ gọi tên bạn khi đơn hàng sẵn sàng",
			customerDetailsFormSubTitle: "Vui lòng nhập ở đây",
			customerDetailsPreviousAction: "Quay lại",
			customerDetailsNextAction: "Tiếp tục",
			beaconTitle: "Đèn hiệu",
			beaconFormHeaderTitle: "Nhập số báo hiệu",
			beaconFormHeaderSubtitle: "Và nó sẽ kêu và nhấp nháy khi đơn đặt hàng của bạn đã sẵn sàng để nhận",
			beaconPreviousAction: "Quay lại",
			beaconAdditionalAction: "Huỷ",
			beaconCancelAction: "Huỷ",
			beaconFormPrimaryAction: "Gửi",
			beaconFormSecondaryAction: "Huỷ",
			beaconNextAction: "Gửi",
			beaconInputError: "Vui lòng nhập một số hợp lệ",
			couponTitle: "Mã giảm giá",
			couponPreviousAction: "Quay lại",
			couponFormHeaderTitle: "Nhập phiếu giảm giá của bạn:",
			couponFormPrimaryAction: "Xác nhận",
			couponFormSecondaryAction: "Quay lại",
			couponListHeaderTitle: "Mã giảm giá",
			couponListAddToCartAction: "Thêm vào giỏ hàng",
			couponListChangeAction: "Thay đổi",
			couponErrorHeaderTitle: "Rất tiếc, không thể tìm thấy phiếu giảm giá này.",
			couponErrorSecondaryAction: "Trở về danh mục món ăn",
			couponErrorPrimaryAction: "Vui lòng thử lại",
			couponGroupedModalSecondaryAction: "Đóng",
			couponComboModalTitle: "Chọn cỡ phần ăn",
			couponComboModalSecondaryAction: "Đóng",
			couponNextAction: "Hoàn thành",
			composedPreviousAction: "Quay lại",
			composedEditingNextAction: "Cập nhật đơn hàng",
			composedNextAction: "Thêm vào đơn hàng",
			composedCancelOrderAction: "Huỷ",
			composedProductLayerTitle: "Chọn {{layer}} của sản phẩm",
			composedProductFinalTitle: "Bạn đã chọn món này:",
			composedProductFinalCustomise: "Xác nhận lựa chọn của bạn",
			composedHeaderTitle: "Tuỳ chỉnh",
			orderValidationErrorMessage: "Rất tiếc, đã xảy ra lỗi khi chúng tôi xử lý đơn đặt hàng của bạn",
			requestTimedOut: "Hết thời gian chờ",
			orderValidationErrorPrimaryAction: "Thử lại",
			orderValidationErrorSecondaryAction: "Huỷ",
			orderConfirmationErrorMessage: "Rất tiếc, đã xảy ra lỗi",
			orderConfirmationGenericAdditionalMessage: "Hãy đảm bảo rằng khoản thanh toán của bạn được hoàn tất theo phương thức đã chọn",
			orderConfirmationAdditionalMessage: "Vui lòng đảm bảo thẻ của bạn đã được gỡ khỏi thiết bị thanh toán",
			orderConfirmationErrorPrimaryAction: "Thử lại",
			orderConfirmationErrorSecondaryAction: "Huỷ",
			orderConfirmationLoadingTitle: "Đang gửi đơn xuống nhà hàng",
			orderWebhookPollingConfirmationLoadingTitle: "Đang xác nhận với nhà hàng",
			orderConfirmationLoadingMessage: "Vui lòng đợi, đang gửi đơn hàng của bạn xuống nhà hàng",
			orderWebhookPollingConfirmationLoadingMessage: "Vui lòng đợi, đang xác nhận đơn hàng của bạn với nhà hàng",
			orderConfirmationLoadingMessageFirstAutoRetry: "Hãy đợi thêm một chút, đang mất thêm một chút thời gian để gửi đơn hàng của bạn đến nhà hàng.",
			orderConfirmationLoadingMessageSecondAutoRetry: "Có một chút chậm trễ trong việc gửi đơn hàng của bạn",
			orderConfirmationNoInternetLoadingTitle: "Sự cố kết nối",
			orderConfirmationNoInternetLoadingMessage: "Chúng tôi đang gặp sự cố kết nối, vui lòng đợi trong khi chúng tôi đang cố khôi phục...",
			orderConfirmationNoInternetTitle: "Chúng tôi rất tiếc, đã xảy ra sự cố khi gửi đơn đặt hàng của bạn đến nhà bếp. Vui lòng chụp ảnh biên lai và thông báo cho quầy lễ tân.",
			orderConfirmationNoInternetDetailsTitle: "Thông tin chi tiết",
			orderConfirmationNoInternetDetailsDateTime: "Ngày",
			orderConfirmationNoInternetDetailsCardNumber: "Số thẻ",
			orderConfirmationNoInternetClose: "ĐỒNG Ý",
			orderPostErrorMessage: "Rất tiếc, đã xảy ra lỗi",
			orderPostErrorPrimaryAction: "Thử lại",
			orderPostErrorSecondaryAction: "Huỷ",
			categoryGroupedModalSecondaryAction: "Đóng",
			categoryComboModalSecondaryAction: "Đóng",
			categoryNextAction: "Hoàn thành",
			productPreviousAction: "Quay lại",
			timeoutModalTitle: "Bạn vẫn ở đó chứ?",
			timeoutModalSecondaryAction: "Đóng",
			timeoutModalContentMessage: "Trở về màn hình chính sau {{ timeLeft }}",
			productComboSizeAction: "Thay đổi",
			productOptionCardPrimaryAction: "Thay đổi lựa chọn",
			productOptionCardSecondaryAction: "Tuỳ chỉnh",
			productOptionItemCardSelectedMessage: "Trong phần ăn của bạn",
			productOptionsChangeModalCloseAction: "Đóng",
			offerLimitModalTitle: "Một ưu đãi đã tồn tại trong giỏ hàng của bạn",
			offerLimitConfirmation: "Mỗi đơn hàng chỉ được phép 1 ưu đãi. Bạn có muốn thay thế ưu đãi hiện tại không?",
			orderValidationLoadingTitle: "Đang cập nhật giỏ hàng",
			orderValidationLoadingMessage: "Đang đến mục thanh toán",
			orderPostLoadingTitle: "Đang hoàn tất đơn hàng",
			orderPostLoadingMessage: "Vui lòng đợi, đang hoàn tất đơn đặt hàng của bạn",
			productCustomisationsReadOnlyExtra: "Tùy chỉnh",
			productCustomisationsProductsMissingError: "Vui lòng thêm {{ productsMissingCount }} mặt hàng",
			productCustomisationsProductsMissingError_plural: "Vui lòng thêm {{ productsMissingCount }} mặt hàng",
			autoRedirectNotificationTitle: "Rất tiếc, chúng tôi vẫn đang gặp sự cố, không thể thử lại nữa",
			autoRedirectNotificationAdditionalMessage: "Xin lỗi vì sự cố",
			autoRedirectNotificationMessage: "Chuyển hướng bạn trở lại nơi an toàn",
			autoRedirectNotificationButton: "ĐỒNG Ý",
			upsellModalTitle: "Bạn có muốn thêm vào đơn đặt hàng không?",
			productCustomisationModalHeaderTitle: "Tuỳ chỉnh",
			productCustomisationModalAddToCartAction: "Thêm vào đơn hàng",
			productCustomisationModalUpdateCartAction: "Cập nhật đơn hàng",
			productCustomisationModalCloseAction: "Đóng",
			upsellModalCloseAction: "Đóng",
			productOptionCustomisationModalAddToCartAction: "Thêm vào giỏ hàng",
			productOptionCustomisationModalUpdateCartAction: "Cập nhật đơn hàng",
			productOptionCustomisationModalCloseAction: "Đóng",
			bannerWarningTitle: "Sức khỏe & phúc lợi của bạn là ưu tiên số 1 của chúng tôi",
			bannerWarningDescription: "Chúng tôi đã tăng cường các quy trình làm sạch và Vệ sinh vốn đã nghiêm ngặt của mình trong những thời điểm khó khăn này.",
			paymentMethodCard: "Chỉ chấp nhận thanh toán Thẻ",
			miniCartNextAction: "Hoàn thành",
			miniCartCloseAction: "Đóng",
			miniCartCheckoutAction: "Thanh toán",
			miniCartTotal: "Tổng thanh toán",
			invalidRouteTitle: "Rất tiếc, có vẻ như bạn bị lạc",
			invalidRouteButton: "Trở về nơi an toàn",
			templateMenuAction: "Thực đơn",
			templateCancelAction: "Huỷ",
			templateBasketAction: "Xem đơn hàng",
			templateCouponAction: "Nhập ưu đãi",
			refundGenericInstructions: "Vui lòng chờ hoàn tiền",
			refundInstructions: "Vui lòng đợi tiền hoàn lại trên pinpad bên dưới",
			refundErrorMessage: "Rất tiếc, đã xảy ra lỗi khi cố hoàn tiền cho bạn",
			refundRetryMessage: "Thử lại",
			refundCancelMessage: "Huỷ",
			refundCancelButton: "ĐỒNG Ý",
			refundSuccessButton: "ĐỒNG Ý",
			refundCancelDetails: "Thông tin chi tiết",
			refundCancelDateTime: "Ngày",
			refundCancelCardNumber: "Số thẻ",
			refundCancelOrderNumber: "Mã đơn hàng",
			refundSuccessMessage: "Quá trình hoàn tiền đã bắt đầu thành công. Xin lưu ý rằng thời gian có hiệu lực tùy thuộc vào phương thức thanh toán.",
			refundCancelledMessage: "Chúng tôi rất tiếc, đã xảy ra sự cố khi gửi đơn đặt hàng của bạn đến nhà bếp. Vui lòng chụp ảnh hoặc tải xuống Biên lai từ Mã QR và Thông báo cho quầy thanh toán.",
			refundSuccessTitle: "Hoàn tất hoàn tiền",
			refundLoadingTitle: "Đang thực hiện hoàn tiền",
			menuAction: "Thực đơn",
			menuPreviousAction: "Quay lại",
			productCustomisationsRemove: "Xoá",
			productCustomisationsChange: "Thay đổi",
			productCustomisationsResetting: "Đang đặt lại...",
			productCustomisationsReset: "Đặt lại",
			productCustomisationsDeselect: "Bỏ chọn",
			productCustomisationsAdd: "Thêm",
			productCustomisationsSelect: "Lựa chọn",
			warningTitle: "Rất tiếc, có lỗi đã xảy ra",
			warningCancelAction: "Huỷ",
			warningTryAgainAction: "Vui lòng thử lại",
			receiptTitle: "Đơn hàng của bạn",
			receiptEcoMessage: "Không cần giấy",
			transactionsNavigatorNextAction: "Tiếp theo",
			transactionsNavigatorPreviousAction: "Trước đó",
			transactionsTitle: "Giao dịch",
			transactionsIdentityTitle: "Thông tin",
			transactionsIdentityId: "Phiên làm việc",
			transactionsIdentityStatus: "Tình trạng",
			transactionsIdentityTimestamp: "Ngày",
			transactionsIdentityType: "Loại đơn hàng",
			transactionsIdentityMessage: "Lời nhắn",
			transactionsIdentityOrderReference: "Thông tin đơn hàng",
			transactionsPaymentTitle: "Tổng thanh toán",
			transactionsPaymentType: "Phương thức thanh toán",
			transactionsPaymentAmount: "Tổng số thẻ",
			transactionsPaymentAuthCode: "Mã xác thực",
			transactionsPaymentCardNumber: "Số thẻ",
			transactionsPaymentTransactionId: "Mã giao dịch",
			transactionsPaymentOrderTotal: "Tổng đơn hàng",
			transactionsPaymentNoPaymentFound: "Chưa chọn thanh toán",
			transactionsPrimaryAction: "Quay lại",
			transactionsPaymentCardType: "Loại thẻ",
			transactionsNotFound: "Không có giao dịch nào được lưu trữ kể từ lần khởi động lại cuối cùng",
			quantityControllerOutlinedLabel: "Số lượng",
			defaultLoadingTitle: "Làm nóng căn bếp",
			loadingCoupon: "Đang tìm kiếm phiếu giảm giá",
			defaultLoadingMessage: "Vui lòng chờ",
			termsAndConditionsModalTitle: "Điều khoản và điều kiện",
			termsAndConditionsModalCloseAction: "Đóng",
			ORDER_CONFIRMATION_SUCCESS: "Thành công",
			ORDER_REFUND_CANCELLED: "Hoàn tiền đã bị hủy",
			ORDER_CONFIRMATION_ERROR: "Lỗi",
			ORDER_CANCELLED: "Đã hủy",
			ORDER_VALIDATION_ERROR: "Lỗi xác thực",
			ORDER_REFUND_SUCCESS: "Hoàn tiền thành công",
			ORDER_VALIDATION_SUCCESS: "Xác thực thành công",
			ORDER_PAYMENT_ERROR: "Lỗi Thanh toán",
			ORDER_PAYMENT_SUCCESS: "Thanh toán thành công",
			ORDER_REFUND_ERROR: "Lỗi hoàn tiền",
			ORDER_POST_SUCCESS: "Thành công",
			ORDER_POST_ERROR: "Lỗi",
			transactionsLateRefund: "Hoàn trả muộn",
			transactionsLateRefundFalse: "Không",
			transactionsLateRefundTrue: "Có",
			transactionLateRefundModalText: "Bạn có chắc chắn muốn được hoàn lại tiền không",
			transactionLateRefundFailedMessage: "Rất tiếc, chúng tôi không thể xử lý khoản tiền hoàn lại.",
			transactionLateRefundCancelledMessage: "Hoàn tiền đã bị hủy!",
			showAddonAvailabilityMessage: "Quay lại ngay",
			addonRemovedModalTitle: "Chúng tôi đã xóa một số mục",
			addonRemovedMessage: "Nhân tiện, chúng tôi đã xóa những mục sau:",
			addonRemovedFooterMessage: "Mặt hàng chỉ có khi mua",
			loyaltyLoginTitle: "Đăng nhập thành viên",
			loyaltyLoginNextAction: "Xác nhận",
			loyaltyLoginPreviousAction: "Quay lại",
			loyaltyBannerTitle: "KIẾM VÀ TẬN HƯỞNG THƯỞNG CỦA BẠN!",
			loyaltyBannerSubtitle: "Bạn có phải là thành viên của chúng tôi không?",
			loyaltyBannerMember: "THÀNH VIÊN:",
			loyaltyBannerLogin: "Đăng nhập",
			loyaltyBannerLogout: "Đăng xuất",
			loyaltyBannerOffers: "Ưu đãi",
			loyaltyBannerOffersAndDeals: "Ưu đãi & Ưu đãi",
			loyaltyBannerRedeemables: "Có thể hoàn lại",
			loyaltyOffersTitle: "Ưu đãi dành cho thành viên",
			loyaltyOffersPreviousAction: "Mặt sau",
			loyaltyOffersNextAction: "Hoàn thành",
			loyaltyLoginCodeTitle: "Nhập mã",
			loyaltyQrLoginCodeTitle: "hoặc quét bằng ứng dụng của bạn",
			bestValueProduct: "Giá trị tốt nhất",
			hotDealProduct: "Ưu đãi hấp dẫn",
			loyaltyWelcomeModalTitle: "Chào mừng trở lại, {{name}}",
			loyaltyWelcomeModalPoints: "Bạn có {{points}} điểm",
			loyaltyWelcomeModalConfirm: "OK",
			loyaltyLogOutModalConfirm: "Bạn có chắc chắn muốn đăng xuất không?",
			loyaltyLoginFailedModalTitle: "Xin lỗi",
			loyaltyLoginFailedModalClose: "Thử lại",
			loyaltyLoginFailedModalContent: "Chúng tôi không thể xác minh mã của bạn",
			loyaltyLoginOrSkipModalTitle: "Phần thưởng theo cách của bạn",
			loyaltyLoginOrSkipModalLoginButtonText: "Đăng nhập",
			loyaltyLoginOrSkipModalSkipButtonText: "Bỏ qua",
			loyaltyMemberSignInButtonText: "Đăng nhập thành viên",
			loyaltyGuestOrderButtonText: "Đặt hàng không cần tài khoản",
			loyaltyOrderHistoryTitle: "lịch sử đơn hàng",
			loyaltyReorderTitle: "Đặt hàng lại {{orderDate}}",
			loyaltyReorderViewOrder: "Xem đơn hàng",
			loyaltyReorderAddToCart: "Thêm để đặt hàng",
			loyaltyReorderAddingToCart: "Đang thêm...",
			loyaltyReorderCancel: "Đóng",
			appDownloadTitle: "Tải ứng dụng",
			appDownloadContent: "Không phải là thành viên?",
			appDownloadSubContent: "Quét mã này để tải xuống ứng dụng KFC và đăng ký",
			appDownloadPreviousAction: "Quay lại",
			appDownloadNextAction: "Đăng nhập",
			chooseCustomisations: "Chọn tùy chỉnh của bạn",
			taxesFees: "Thuế và Phí",
			discount: "giảm giá",
			chooseProductCustomisations: "tùy chỉnh",
			cartComboModalTitle: "Chọn kích thước bữa ăn",
			cartComboModalSecondaryAction: "Đóng"
		}
	},
	rus: {
		translation: {
			homeTitle: "ЗАКАЖИ ЗДЕСЬ",
			homeSubtitle: "БЕЗ ОЧЕРЕДИ",
			homePrimaryAction: "С СОБОЙ",
			homeSecondaryAction: "В ЗАЛЕ",
			homeConnectivityIssues: "У нас проблемы с подключением. Пожалуйста, подождите. Выполняется восстановление...",
			homeTermsAndConditionsBannerWarningTitle: "Условия",
			homeTermsAndConditionsBannerWarningDescription: "Продолжая, вы принимаете наши",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "Условия использования и политика конфиденциальности",
			adminTitle: "Администратор",
			adminGeneralSection: "Общий",
			adminSerialKeyField: "Регистрационный ключ",
			adminMenuSection: "Меню",
			adminOrderingSection: "Заказ",
			adminOrganisationField: "Организация",
			adminStoreField: "Ресторан",
			adminSiteField: "Объект",
			adminTimezoneField: "Часовой пояс",
			adminVersionField: "Версия",
			adminEnvironmentField: "Среда",
			adminMockFieldFalseText: "Нет",
			adminMockFieldTrueText: "Да",
			adminPaymentSection: "Платеж",
			adminMockField: "Имитация",
			adminProviderField: "Провайдер",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "IP-адрес",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "USB-порт",
			adminLockModal: "Экран блокировки",
			adminLockModalTitle: "Параметры экрана блокировки",
			adminLockModalClose: "Закрыть",
			adminPrimaryLockAction: "Экран блокировки - Терминал недоступен",
			adminSecondaryLockAction: " Экран блокировки - ресторан закрыт",
			lockMessage: "Терминал недоступен. Воспользуйтесь другим терминалом или оформите заказ на кассе.",
			lockSecondaryMessage: "Ресторан в настоящее время закрыт.",
			adminLoginTitle: "Введите пароль администратора",
			adminRefreshAction: "Обновить",
			adminExitAction: "Выход",
			adminLoginPrimaryAction: "Войти",
			adminLoginSecondaryAction: "Отменить",
			adminLoginErrorPasswordMessage: "Неверный пароль",
			adminTransactionsAction: "Транзакции",
			allergensMessage: "Содержит: {{ аллергены }}",
			smsSending: "Отправка SMS",
			smsErrorMessage: "Не удалось отправить СМС",
			smsErrorDetailsMessage: "Проверьте введенный вами номер",
			smsMockErrorMessage: "Имитационный ответ не получен",
			smsMockSuccessMessage: "Получен фиктивный ответ",
			smsSuccessTitle: "SMS успешно отправлено",
			smsSuccessSubtitle: "Получение SMS может занять некоторое время",
			smsSuccessButton: "Продолжить",
			smsPrimaryAction: "Отправить",
			smsSecondaryAction: "Пропустить",
			smsCountryCodeCannotBeEmpty: "Код страны не может быть пустым",
			smsCountryCodeStartWithZero: "Код страны не должен начинаться с нуля",
			smsCountryCodeExceedsMaxLength: "Код страны превышает максимально допустимую длину",
			smsCountryCodeDoesNotMeetMinimumLength: "Код страны не соответствует требуемой минимальной длине",
			smsPhoneCannotStartWithZero: "Номер телефона не должен начинаться с 0",
			smsPhoneExceedsMaxLength: "Номер телефона превышает максимально допустимую длину",
			smsPhoneDoesNotMeetMinimumLength: "Номер телефона не соответствует минимальной длине",
			smsTitle: "Отправить квитанцию ​​по SMS",
			smsSubtitle: "Введите свой номер телефона",
			receiptDetailsInstruction: "Отсканируйте QR-код",
			receiptDetailsInstructionCash: "Оплатите заказ на стойке",
			receiptDetailsInstructionCard: "Заберите свой заказ в пункте выдачи",
			receiptDetailsOrderNumber: "ССЫЛКА НА ЗАКАЗ:",
			receiptDetailsPrimaryAction: "Квитанция",
			receiptSmsAction: "СМС",
			receiptTermsAndConditionsAction: "Условия",
			receiptPrimaryAction: "Завершить",
			receiptDetailsTaxInvoice: "Счет-фактура",
			receiptDetailsOrderType: "Тип",
			receiptPaymentRestaurantName: "Ресторан",
			receiptPaymentRestaurantAddress: "Адрес",
			receiptPaymentPhone: "Телефон",
			receiptPaymentTaxNumber: "АБН",
			receiptPaymentItemQuantity: "Питание",
			receiptPaymentTaxTotal: "Налог на товары и услуги",
			receiptPaymentSubTotal: "Промежуточный итог",
			receiptPaymentTotal: "Всего",
			receiptGSTExcludeMessage: "* исключает GST",
			receiptPaymentPending: "РеквиптPaymentPending",
			receiptPaymentKitchenId: "Идентификатор кухни",
			receiptCash: "Наличные",
			receiptDineIn: "РецептDineIn",
			receiptTakeaway: "Вынос",
			receiptQRCodeOpen: "Квитанция",
			smsReceiptHeaderText: "Добро пожаловать в KFC",
			smsReceiptOrderNumberText: "Номер вашего заказа: {{номер заказа}}",
			smsReceiptUrlText: "Получите квитанцию: {{ url }}",
			smsReceiptPendingPaymentText: "Платеж ожидает",
			smsErrorPrimaryAction: "Попробуйте еще раз",
			smsErrorSecondaryAction: "Продолжить",
			customerDetailsFullNameLabel: "Полное имя {{ required }}",
			customerDetailsFirstNameLabel: "Фамилия {{ required }}",
			customerDetailsLastNameLabel: "Первая буква фамилии",
			customerDetailsPhoneNumberLabel: "Номер телефона {{ required }}",
			customerDetailsRequired: "(Обязательно)",
			customerDetailsOptional: "(Необязательно)",
			customerDetailsFormPrimaryAction: "Продолжить",
			customerDetailsFormSecondaryAction: "Пропустить",
			customerDetailsInputInvalidError: "{{ label }} недействителен",
			customerDetailsEmailLabel: "Электронная почта {{ требуется }}",
			customerDetailsEmailDescription: "Квитанция QR доступна при оформлении заказа",
			customerDetailsInputRequiredError: "Требуется {{ label }}",
			customerDetailsInputMinimumError: "{{ label }} не соответствует минимально необходимой длине",
			customerDetailsProfaneInputError: "Попробуйте еще раз. Это слово недопустимо.",
			customerDetailsSpecialCharactersInputError: "Попробуйте еще раз. Специальные символы не допускаются.",
			customerDetailsCancelOrderAction: "Отменить",
			receiveEmailAddress: "Подпишитесь на получение эксклюзивных купонов и текущих предложений",
			cartNextAction: "Перейти к оформлению",
			cartTitle: "Ваш заказ",
			cartPleaseSelectProduct: "Пожалуйста, выберите соответствующий продукт для активации",
			cartPreviousAction: "Назад",
			cartEmptyMessage: "Ваша корзина пуста",
			cartEmptyPrimaryAction: "Вернуться в меню",
			cartProductUnavailableGeneral: "Этот предмет сейчас недоступен",
			cartProductUnavailableAddon: "Недоступен",
			cartProductUnavailableItem: "Скоро вернусь",
			cartCancelOrderAction: "Отменить",
			cartChangeAction: "Изменить",
			cartRemoveAction: "Удалить",
			cartProductUnitPriceEach: "{{Цена}} за штуку",
			cartUpsellTitle: "Добавить в заказ",
			cartUpsellAction: "Добавить еще",
			cartUpsellGalleryCardButtonActionText: "Добавить",
			cartGroupedModalSecondaryAction: "Закрыть",
			cartNoInternetLoadingTitle: "Проблемы с подключением",
			cartNoInternetLoadingMessage: "У нас проблемы с подключением. Пожалуйста, подождите. Выполняется восстановление...",
			cartNoInternetTitle: "Извините. Возникла проблема с подключением.",
			cartNoInternetClose: "ОК",
			productNextAction: "Добавить в корзину",
			productEditingNextAction: "Обновить заказ",
			productTitle: "Выберите свой",
			customisationExtraPriceWarning: "Вы добавили к еде дополнительную {{цену}}",
			customisationPriceEach: "{{цена}} за штуку",
			paymentInstructions: "Для оплаты следуйте инструкции на банковском терминале ниже",
			paymentErrorMessage: "К сожалению, что-то пошло не так",
			paymentErrorDetail: "К сожалению, что-то пошло не так. Вернуться к ПИН-паду: {{message}}",
			paymentErrorQRCodeDetail: "К сожалению, что-то пошло не так. Ответ QR-кода: {{message}}",
			paymentErrorQRCodeMessage: "Отсканируйте QR-код платежной квитанции, которая не была выдана",
			paymentStatusCheckMessage: "Подождите, пока мы проверим, прошел ли ваш платеж успешно",
			paymentStatusSuccessMessage: "Ваш платеж прошел успешно, теперь мы размещаем ваш заказ",
			paymentRetryMessage: "Повторить попытку",
			paymentCancelMessage: "Отменить",
			paymentOptionsTitle: "Выберите способ оплаты",
			paymentOptionsSecondaryAction: "Назад",
			paymentOptionsCARDTitle: "КАРТА",
			paymentOptionsCASHTitle: "НАЛИЧНЫЕ",
			paymentOptionsMOMOPAYTitle: "Момо",
			paymentOptionsExpressMessage: "Экспресс-оформление заказа",
			paymentNoInternetLoadingTitle: "Проблемы с подключением",
			paymentNoInternetLoadingMessage: "У нас проблемы с подключением. Пожалуйста, подождите. Выполняется восстановление...",
			paymentNoInternetTitle: "Извините. Не удалось подключиться.",
			paymentNoInternetClose: "ОК",
			paymentFetchingQRCode: "Получение QR-кода",
			paymentScanQRCode: "Отсканируйте QR-код в приложении Momo.",
			paymentScanQRCodeMessage: "Процесс оплаты необходимо завершить в приложении Momo. Если вы хотите отменить транзакцию, сделайте это из приложения.",
			categoryComboModalTitle: "Выберите размер порции",
			categoryPreviousAction: "Назад",
			productCustomisationsAdditionalPriceWarning: "Вы добавили к еде дополнительную {{price}}",
			productCustomisationsReadOnlyEach: "{{price}} Каждый",
			productCustomisationsReadonlyProductRemoved: "Удалить {{name}}",
			productCustomisationsUnlimitedMax: "Неограниченно",
			productCancelOrderAction: "Отменить",
			categoriesTitle: "Меню",
			categoriesCancelOrderAction: "Отменить",
			cancelOrderButtonModalQuestion: "Вы уверены, что хотите отменить свой заказ?",
			cancelOrderButtonModalTitle: "Отменить заказ",
			cancelOrderButtonModalPrimaryAction: "Нет",
			cancelOrderButtonModalSecondaryAction: "Да",
			cancelOrderButtonName: "Отменить",
			categoriesNextAction: "Перейти к заказу",
			categoriesPreviousAction: "Назад",
			customerDetailsTitle: "Подробности",
			customerDetailsFormTitle: "Мы позвоним вам, когда ваш заказ будет готов",
			customerDetailsFormSubTitle: "Введите сюда",
			customerDetailsPreviousAction: "Назад",
			customerDetailsNextAction: "Продолжить",
			beaconTitle: "Маяковое устройство",
			beaconFormHeaderTitle: " Отобразить номер маяка",
			beaconFormHeaderSubtitle: "Когда ваш заказ будет готов к выдаче, он издаст звуковой сигнал и загорится",
			beaconPreviousAction: "Назад",
			beaconAdditionalAction: "Отменить",
			beaconCancelAction: "Отменить",
			beaconFormPrimaryAction: "Отдать",
			beaconFormSecondaryAction: "Отменить",
			beaconNextAction: "Отдать",
			beaconInputError: "Введите правильный номер",
			couponTitle: "Код купона",
			couponPreviousAction: "Назад",
			couponFormHeaderTitle: "Введите купон:",
			couponFormPrimaryAction: "Подтвердить",
			couponFormSecondaryAction: "Назад",
			couponListHeaderTitle: "Купон",
			couponListAddToCartAction: "Добавить в корзину",
			couponListChangeAction: "Изменить",
			couponErrorHeaderTitle: "К сожалению, этот купон не найден.",
			couponErrorSecondaryAction: "Вернуться к категориям",
			couponErrorPrimaryAction: "Попробуйте еще раз",
			couponGroupedModalSecondaryAction: "Закрыть",
			couponComboModalTitle: "Выберите размер порции",
			couponComboModalSecondaryAction: "Закрыть",
			couponNextAction: "Выполнить",
			composedPreviousAction: "Назад",
			composedEditingNextAction: "ComposedEditingNextAction",
			composedNextAction: "Добавить в заказ",
			composedCancelOrderAction: "Отменить",
			composedProductLayerTitle: "Выберите продукт {{Layer}}",
			composedProductFinalTitle: "Вы выбрали этот продукт:",
			composedProductFinalCustomise: "Подтвердите свой выбор",
			composedHeaderTitle: "Изменить состав",
			orderValidationErrorMessage: "К сожалению, что-то пошло не так при попытке обработать ваш заказ",
			requestTimedOut: "истекло время запроса",
			orderValidationErrorPrimaryAction: "Повторить",
			orderValidationErrorSecondaryAction: "Отменить",
			orderConfirmationErrorMessage: "К сожалению, что-то пошло не так",
			orderConfirmationGenericAdditionalMessage: "Пожалуйста, убедитесь, что ваш платеж завершен выбранным способом.",
			orderConfirmationAdditionalMessage: "Пожалуйста, проверьте, получили ли вы карту из терминала",
			orderConfirmationErrorPrimaryAction: "Повторить попытку",
			orderConfirmationErrorSecondaryAction: "Отменить",
			orderConfirmationLoadingTitle: "Отправка на кухню",
			orderConfirmationLoadingMessage: "Пожалуйста, подождите. Ваш заказ отправляется на кухню",
			orderConfirmationLoadingMessageFirstAutoRetry: "Оставайтесь с нами, отправка вашего заказа на кухню занимает немного больше времени.",
			orderConfirmationLoadingMessageSecondAutoRetry: "Есть небольшая задержка в передаче вашего заказа.",
			orderConfirmationNoInternetLoadingTitle: "Проблемы с подключением",
			orderConfirmationNoInternetLoadingMessage: "У нас проблемы с подключением. Пожалуйста, подождите. Выполняется восстановление...",
			orderConfirmationNoInternetTitle: "Извините! Возникла проблема с отправкой вашего заказа на кухню. Пожалуйста, сфотографируйте чек и сообщите об этом на стойке регистрации.",
			orderConfirmationNoInternetDetailsTitle: "Подробности",
			orderConfirmationNoInternetDetailsDateTime: "Дата",
			orderConfirmationNoInternetDetailsCardNumber: "Номер карты",
			orderConfirmationNoInternetClose: "ОК",
			orderPostErrorMessage: "К сожалению, что-то пошло не так",
			orderPostErrorPrimaryAction: "Повторить",
			orderPostErrorSecondaryAction: "Отменить",
			categoryGroupedModalSecondaryAction: "Закрыть",
			categoryComboModalSecondaryAction: "Закрыть",
			categoryNextAction: "Перейти к заказу",
			productPreviousAction: "Назад",
			timeoutModalTitle: "Вы все еще здесь?",
			timeoutModalSecondaryAction: "Отмена",
			timeoutModalContentMessage: "Вернуться на главную страницу через {{ timeLeft }}",
			productComboSizeAction: "Изменить",
			productOptionCardPrimaryAction: "Изменить выбор",
			productOptionCardSecondaryAction: "Изменить состав",
			productOptionItemCardSelectedMessage: "Текущий выбор",
			productOptionsChangeModalCloseAction: "Отмена",
			offerLimitModalTitle: "Предложение уже существует в вашей корзине",
			offerLimitConfirmation: "Для одного заказа допускается только 1 предложение. Хотите заменить существующее предложение?",
			orderValidationLoadingTitle: "Обновить корзину",
			orderValidationLoadingMessage: "Проверка",
			orderPostLoadingTitle: "Постзагрузка заказа",
			orderPostLoadingMessage: "Пожалуйста, подождите. Ваш заказ завершается",
			productCustomisationsReadOnlyExtra: "Индивидуальные элементы",
			productCustomisationsProductsMissingError: "Добавить элементы {{ отсутствующие продукты }}",
			productCustomisationsProductsMissingError_plural: "Добавить позиции {{ количество отсутствующих товаров }} ",
			autoRedirectNotificationTitle: "К сожалению, у нас все еще есть проблемы. Больше никаких действий",
			autoRedirectNotificationAdditionalMessage: "Приносим свои извинения",
			autoRedirectNotificationMessage: "Мы перенаправляем вас из соображений безопасности",
			autoRedirectNotificationButton: "ОК",
			upsellModalTitle: "Хотите добавить в заказ?",
			productCustomisationModalHeaderTitle: "Modal HeaderTitle",
			productCustomisationModalAddToCartAction: "Добавить в корзину",
			productCustomisationModalUpdateCartAction: "Обновить заказ",
			productCustomisationModalCloseAction: "Закрыть",
			upsellModalCloseAction: "Закрыть",
			productOptionCustomisationModalAddToCartAction: "Добавить в корзину",
			productOptionCustomisationModalUpdateCartAction: "Обновить заказ",
			productOptionCustomisationModalCloseAction: "Закрыть",
			bannerWarningTitle: "Наш приоритет №1 — ваше здоровье и благополучие",
			bannerWarningDescription: "В это трудное время мы усилили наши и без того строгие процедуры очистки и гигиены.",
			paymentMethodCard: "Оплатить только картой",
			miniCartNextAction: "Конец",
			miniCartCloseAction: "Закрыть",
			miniCartCheckoutAction: "Оформить заказ",
			miniCartTotal: "Всего",
			invalidRouteTitle: "Ой, похоже, вы запутались",
			invalidRouteButton: "Вернуться из соображений безопасности(???)",
			templateMenuAction: "Меню",
			templateCancelAction: "Отменить",
			templateBasketAction: "Посмотреть заказ",
			templateCouponAction: "Введите промокод (???)",
			refundGenericInstructions: "Пожалуйста, дождитесь возврата средств",
			refundInstructions: "Подождите возврата в PIN-панели ниже",
			refundErrorMessage: "К сожалению, что-то пошло не так! Мы пытаемся вернуть вам деньги",
			refundRetryMessage: "Повторить попытку",
			refundCancelMessage: "Отменить",
			refundCancelButton: "ОК",
			refundSuccessButton: "ОК",
			refundCancelDetails: "Подробности",
			refundCancelDateTime: "Дата",
			refundCancelCardNumber: "Номер карты",
			refundCancelOrderNumber: "Номер заказа",
			refundSuccessMessage: "Процесс возврата успешно запущен. Обратите внимание, что время вступления в силу зависит от способа оплаты.",
			refundCancelledMessage: "Извините! При отправке вашего заказа на кухню возникла проблема. Пожалуйста, сфотографируйте чек или загрузите его с помощью QR-кода и сообщите об этом на стойке регистрации.",
			refundSuccessTitle: "Возврат выполнен успешно",
			refundLoadingTitle: "Загружаются данные для выполнения возврата",
			menuAction: "Меню",
			menuPreviousAction: "Назад",
			productCustomisationsRemove: "Удалить",
			productCustomisationsChange: "Изменить",
			productCustomisationsResetting: "Сброс...",
			productCustomisationsReset: "Сбросить",
			productCustomisationsDeselect: "Отменить выбор",
			productCustomisationsAdd: "Добавить",
			productCustomisationsSelect: "Выбирать",
			warningTitle: "Ой, похоже, что-то пошло не так!",
			warningCancelAction: "Отменить",
			warningTryAgainAction: "Попробовать еще раз",
			receiptTitle: "Ваш заказ",
			receiptEcoMessage: "Квитанция не должна быть нажата (???)",
			transactionsNavigatorNextAction: "Далее",
			transactionsNavigatorPreviousAction: "Предыдущий",
			transactionsTitle: "Транзакции",
			transactionsIdentityTitle: "Идентификация",
			transactionsIdentityId: "Идентификатор сеанса",
			transactionsIdentityStatus: "Статус",
			transactionsIdentityTimestamp: "Дата",
			transactionsIdentityType: "Тип ордера",
			transactionsIdentityMessage: "Сообщение",
			transactionsIdentityOrderReference: "Ссылка на ордер",
			transactionsPaymentTitle: "Всего",
			transactionsPaymentType: "Тип платежа",
			transactionsPaymentAmount: "Общая сумма на карте",
			transactionsPaymentAuthCode: "Код авторизации",
			transactionsPaymentCardNumber: "Номер карты",
			transactionsPaymentTransactionId: "Идентификатор транзакции",
			transactionsPaymentOrderTotal: "Общая сумма заказа",
			transactionsPaymentNoPaymentFound: "Способ оплаты не выбран",
			transactionsPrimaryAction: "Назад",
			transactionsPaymentCardType: "Тип карты",
			transactionsNotFound: "С момента последней перезагрузки транзакции не сохранены",
			quantityControllerOutlinedLabel: "Количество",
			defaultLoadingTitle: "Разогрев кухни",
			loadingCoupon: "В поисках купона",
			defaultLoadingMessage: "пожалуйста, подождите",
			termsAndConditionsModalTitle: "Условия",
			termsAndConditionsModalCloseAction: "Закрывать",
			ORDER_CONFIRMATION_SUCCESS: "Успешно",
			ORDER_REFUND_CANCELLED: "Возврат отменен",
			ORDER_CONFIRMATION_ERROR: "Ошибка",
			ORDER_CANCELLED: "Отменено",
			ORDER_VALIDATION_ERROR: "Ошибка проверки",
			ORDER_REFUND_SUCCESS: "Возврат успешно",
			ORDER_VALIDATION_SUCCESS: "Проверка прошла успешно",
			ORDER_PAYMENT_ERROR: "Ошибка платежа",
			ORDER_PAYMENT_SUCCESS: "Платеж выполнен успешно",
			ORDER_REFUND_ERROR: "Ошибка возврата",
			ORDER_POST_SUCCESS: "Успех",
			ORDER_POST_ERROR: "Ошибка",
			transactionsLateRefund: "Возврат денег",
			transactionsLateRefundFalse: "Нет",
			transactionsLateRefundTrue: "Да",
			transactionLateRefundModalText: "Вы уверены что хотите сделать возврат денег",
			transactionLateRefundFailedMessage: "К сожалению, мы не смогли обработать возврат.",
			transactionLateRefundCancelledMessage: "Возврат отменен!",
			showAddonAvailabilityMessage: "Скоро вернусь",
			addonRemovedModalTitle: "Мы удалили некоторые элементы",
			addonRemovedMessage: "Кстати, мы удалили следующее:",
			addonRemovedFooterMessage: "Предметы доступны только при покупке",
			loyaltyLoginTitle: "Логин участника",
			loyaltyLoginNextAction: "Подтвердить",
			loyaltyLoginPreviousAction: "Назад",
			loyaltyBannerTitle: "ЗАРАБАТЫВАЙТЕ И НАСЛАЖДАЙТЕСЬ СВОИМИ НАГРАДАМИ!",
			loyaltyBannerSubtitle: "Вы наш участник?",
			loyaltyBannerMember: "ЧЛЕН:",
			loyaltyBannerLogin: "Войти",
			loyaltyBannerLogout: "Выход",
			loyaltyBannerOffers: "Предложения",
			loyaltyBannerOffersAndDeals: "Предложения и предложения",
			loyaltyBannerRedeemables: "погашаемые суммы",
			loyaltyOffersTitle: "Предложения для участников",
			loyaltyOffersPreviousAction: "Назад",
			loyaltyOffersNextAction: "Полный",
			loyaltyLoginCodeTitle: "введите код",
			loyaltyQrLoginCodeTitle: "или отсканируйте с помощью приложения",
			bestValueProduct: "Лучшее значение",
			hotDealProduct: "Горячее предложение",
			loyaltyWelcomeModalTitle: "Добро пожаловать обратно, {{name}}",
			loyaltyWelcomeModalPoints: "У вас есть {{points}} очков",
			loyaltyWelcomeModalConfirm: "ОК",
			loyaltyLogOutModalConfirm: "Вы уверены, что хотите выйти из системы?",
			loyaltyLoginFailedModalTitle: "Извините",
			loyaltyLoginFailedModalClose: "Попробуйте снова",
			loyaltyLoginFailedModalContent: "Мы не смогли проверить ваш код",
			loyaltyLoginOrSkipModalTitle: "Награды по-вашему",
			loyaltyLoginOrSkipModalLoginButtonText: "Войти",
			loyaltyLoginOrSkipModalSkipButtonText: "Пропустить",
			loyaltyMemberSignInButtonText: "Вход для участников",
			loyaltyGuestOrderButtonText: "Заказать как гость",
			loyaltyOrderHistoryTitle: "История заказов",
			loyaltyReorderTitle: "Изменение порядка {{orderDate}}",
			loyaltyReorderViewOrder: "Посмотреть заказ",
			loyaltyReorderAddToCart: "Добавить в заказ",
			loyaltyReorderAddingToCart: "Добавление...",
			loyaltyReorderCancel: "Закрывать",
			appDownloadTitle: "Скачать приложение",
			appDownloadContent: "Не являетесь участником?",
			appDownloadSubContent: "Отсканируйте этот код, чтобы скачать приложение KFC и зарегистрироваться",
			appDownloadPreviousAction: "Назад",
			appDownloadNextAction: "Войти",
			chooseCustomisations: "Выберите свои настройки",
			taxesFees: "Налоги и сборы",
			discount: "скидка",
			chooseProductCustomisations: "настройки",
			cartComboModalTitle: "Выберите размер порции",
			cartComboModalSecondaryAction: "Закрывать"
		}
	},
	kaz: {
		translation: {
			homeTitle: "ЭКСПРЕСС",
			homeSubtitle: "ОСЫНДА ТАПСЫРЫС БЕРУ",
			homePrimaryAction: "АЛА КЕТУГЕ",
			homeSecondaryAction: "ЗАЛДА",
			homeConnectivityIssues: "Бізде қосылу проблемалары туындады. Күте тұрыңыз. Қалпына келтіру жүріп жатыр…",
			homeTermsAndConditionsBannerWarningTitle: "Шарттар мен шарттар",
			homeTermsAndConditionsBannerWarningDescription: "Жалғастыру арқылы сіз бізді қабылдайсыз",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "Пайдалану шарттары және Құпиялық саясаты",
			adminTitle: "Әкімші",
			adminGeneralSection: "Ортақ",
			adminSerialKeyField: "Тіркеу кілті",
			adminMenuSection: "Мәзір",
			adminOrderingSection: "Тапсырыс",
			adminOrganisationField: "Ұйым",
			adminStoreField: "Сақтау",
			adminSiteField: "Нысан",
			adminTimezoneField: "Уақыт белдеуі",
			adminVersionField: "Нұсқа",
			adminEnvironmentField: "Орта",
			adminMockFieldFalseText: "Жоқ",
			adminMockFieldTrueText: "Иә",
			adminPaymentSection: "Төлем",
			adminMockField: "Mock",
			adminProviderField: "Жеткізуші",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "IP-адрес",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "USB порты",
			adminLockModal: "Бұғаттау экраны",
			adminLockModalTitle: "Бұғаттау экранының опциялары",
			adminLockModalClose: "Жабу",
			adminPrimaryLockAction: " Бұғаттау экраны – Терминал қолжетімсіз",
			adminSecondaryLockAction: " Бұғаттау экраны – Мейрамхана жабық",
			lockMessage: "Терминал қолжетімсіз. Басқа терминалды пайдаланыңыз немесе тіркеу үстелшесінде тапсырыс жасаңыз.",
			lockSecondaryMessage: "Қазіргі уақытта мейрамхана жабық.",
			adminLoginTitle: "Әкімшінің құпия сөзін енгізіңіз",
			adminRefreshAction: "Жаңарту",
			adminExitAction: "Шығу",
			adminLoginPrimaryAction: "Тіркелу",
			adminLoginSecondaryAction: "Болдырмау",
			adminLoginErrorPasswordMessage: "Қате құпия сөз",
			adminTransactionsAction: "Операциялар",
			allergensMessage: "Ішіндегісі: {{ аллергендер }}",
			smsSending: "СМС жіберу",
			smsErrorMessage: " СМС жіберу сәтсіз болды",
			smsErrorDetailsMessage: "Сіз енгізген нөмірді тексеріңіз",
			smsMockErrorMessage: "Mock жауабы алынған жоқ",
			smsMockSuccessMessage: "Mock жауабы алынды",
			smsSuccessTitle: "СМС сәтті жіберілді",
			smsSuccessSubtitle: "СМС алу біраз уақыт алуы мүмкін",
			smsSuccessButton: "Жалғастыру",
			smsPrimaryAction: "Жіберу",
			smsSecondaryAction: "Өткізу",
			smsCountryCodeCannotBeEmpty: "Ел коды бос болмауы керек",
			smsCountryCodeStartWithZero: "Ел коды нөлден басталмауы керек",
			smsCountryCodeExceedsMaxLength: "Ел коды рұқсат етілген ең үлкен ұзындықтан асып тұр",
			smsCountryCodeDoesNotMeetMinimumLength: "Ел коды талап етілетін ең аз ұзындыққа сәйкес келмейді",
			smsPhoneCannotStartWithZero: "Телефон нөмірі 0-ден басталмауы керек",
			smsPhoneExceedsMaxLength: "Телефон нөмірі рұқсат етілген ең үлкен ұзындықтан асып тұр",
			smsPhoneDoesNotMeetMinimumLength: "Телефон нөмірі талап етілетін ең аз ұзындыққа сәйкес келмейді ",
			smsTitle: "Түбіртекті СМС арқылы жіберу",
			smsSubtitle: "Телефон нөміріңізді енгізіңіз",
			receiptDetailsInstruction: "Түбіртекті алу үшін QR кодын сканерлеп",
			receiptDetailsInstructionCash: "Тапсырысыңызды кассада төлеңіз",
			receiptDetailsInstructionCard: "Тапсырысты қабылдау орнынан алыңыз",
			receiptDetailsOrderNumber: "ТАПСЫРЫС СІЛТЕМЕСІ:",
			receiptDetailsPrimaryAction: "Түбіртек",
			receiptSmsAction: "СМС",
			receiptTermsAndConditionsAction: "Шарттар мен шарттар",
			receiptPrimaryAction: "Орындалды",
			receiptDetailsTaxInvoice: "Шот-фактура",
			receiptDetailsOrderType: "Түрі",
			receiptPaymentRestaurantName: "Мейрамхана",
			receiptPaymentRestaurantAddress: "Мекенжай",
			receiptPaymentPhone: "Телефон",
			receiptPaymentTaxNumber: "ABN",
			receiptPaymentItemQuantity: "Тағамдар",
			receiptPaymentTaxTotal: "Тауарлар мен қызметтерге салынатын салық",
			receiptPaymentSubTotal: "Аралық жиын",
			receiptPaymentTotal: "Жиыны",
			receiptGSTExcludeMessage: "* GST кірмейді",
			receiptPaymentPending: "Төлем күтілуде",
			receiptPaymentKitchenId: "Ас үй сәйкестендіргіші",
			receiptCash: "Қолма-қол ақша",
			receiptDineIn: "Залды",
			receiptTakeaway: "Алып кетуге",
			receiptQRCodeOpen: "Түбіртек",
			smsReceiptHeaderText: "KFC-ге қош келдіңіз",
			smsReceiptOrderNumberText: "Тапсырысыңыздың нөмірі: {{ тапсырыс нөмірі }}",
			smsReceiptUrlText: "Түбіртегіңізді алыңыз: {{ url }}",
			smsReceiptPendingPaymentText: "Төлем күтілуде",
			smsErrorPrimaryAction: "Қайтадан көріңіз",
			smsErrorSecondaryAction: "Жалғастыру",
			customerDetailsFullNameLabel: "Толық аты {{ міндетті түрде }}",
			customerDetailsFirstNameLabel: "Тегі {{ міндетті түрде }}",
			customerDetailsLastNameLabel: "Аты-жөнінің бірінші әріптері {{ міндетті түрде }}",
			customerDetailsPhoneNumberLabel: "Телефон нөмірі {{ required }}",
			customerDetailsRequired: "(Міндетті түрде)",
			customerDetailsOptional: "(Міндетті емес)",
			customerDetailsFormPrimaryAction: "Жалғастыру",
			customerDetailsFormSecondaryAction: "Өткізу",
			customerDetailsInputInvalidError: "{{ затбелгі }} жарамсыз",
			customerDetailsEmailLabel: "Электрондық пошта {{ міндетті түрде }}",
			customerDetailsEmailDescription: "QR түбіртегі кассада қолжетімді",
			customerDetailsInputRequiredError: "{{ затбелгі }} міндетті түрде",
			customerDetailsInputMinimumError: "{{ label }} ең аз талап етілетін ұзындыққа сәйкес келмейді",
			customerDetailsProfaneInputError: "Қайтадан көріңіз. Бұл сөз рұқсат етілмейді.",
			customerDetailsSpecialCharactersInputError: "Қайтадан көріңіз. Арнайы символдар рұқсат етілмейді.",
			customerDetailsCancelOrderAction: "Болдырмау",
			receiveEmailAddress: "Эксклюзивті талондар мен өзекті ұсыныстар алу үшін жазылу",
			cartNextAction: "Төлемге өту",
			cartTitle: "Сіздің тапсырыңыз",
			cartPleaseSelectProduct: "Сатып алынатын тиісті өнімді таңдаңыз",
			cartPreviousAction: "Оралу",
			cartEmptyMessage: "Сіздің себетіңіз бос",
			cartEmptyPrimaryAction: "Мәзірге оралу",
			cartProductUnavailableGeneral: "Бұл элемент қазір қолжетімсіз",
			cartProductUnavailableAddon: "Қолжетімсіз",
			cartProductUnavailableItem: "Жақында оралу",
			cartCancelOrderAction: "Болдырмау",
			cartChangeAction: "Өзгерту",
			cartRemoveAction: "Алып тастау",
			cartProductUnitPriceEach: "{{бағасы}} Әрқайсысы",
			cartUpsellTitle: "Тапсырысыңызға қосу",
			cartUpsellAction: "Тағы да қосу",
			cartUpsellGalleryCardButtonActionText: "Қосу",
			cartGroupedModalSecondaryAction: "Жабу",
			cartNoInternetLoadingTitle: "Қосылу проблемалары",
			cartNoInternetLoadingMessage: "Бізде қосылу проблемалары туындады. Күте тұрыңыз. Қалпына келтіру жүріп жатыр...",
			cartNoInternetTitle: "Кешіріңіз. Қосылу проблемасы туындады.",
			cartNoInternetClose: "OK",
			productNextAction: "Тапсырысқа қосу",
			productEditingNextAction: "Тапсырысты жаңарту",
			productTitle: "Өз бетімен таңдау",
			customisationExtraPriceWarning: "Сіз тағамыңызға қосымша {{бағасы}} қостыңыз",
			customisationPriceEach: "{{бағасы}} Әрқайсысы",
			paymentInstructions: "Төмендегі PIN-падтағы төлем жөніндегі нұсқауларды орындаңыз",
			paymentErrorMessage: "Ой, бірдеңе дұрыс болмады",
			paymentErrorDetail: "Ой, бірдеңе дұрыс болмады. PIN-падқа оралу: {{хабарлама}}",
			paymentErrorQRCodeDetail: "Ой, бірдеңе дұрыс болмады - QR коды келесідей болды: {{message}}",
			paymentErrorQRCodeMessage: "Берілмеген төлем түбіртегін алу үшін QR кодын сканерлеңіз",
			paymentStatusCheckMessage: "Төлеміңіз сәтті болғанын тексергенше күте тұрыңыз",
			paymentStatusSuccessMessage: "Төлеміңіз сәтті болды, біз қазір тапсырысыңызды орындаймыз",
			paymentRetryMessage: "Қайтадан көріңіз",
			paymentCancelMessage: "Болдырмау",
			paymentOptionsTitle: "Төлем әдісін таңдау",
			paymentOptionsSecondaryAction: "Артқа",
			paymentOptionsCARDTitle: "КАРТА",
			paymentOptionsCASHTitle: "ҚОЛМА-ҚОЛ АҚША",
			paymentOptionsMOMOPAYTitle: "Момо",
			paymentOptionsExpressMessage: "Экспресс қызмет көрсету кассасы",
			paymentNoInternetLoadingTitle: "Қосылу проблемалары",
			paymentNoInternetLoadingMessage: "Бізде қосылу проблемалары туындады. Күте тұрыңыз. Қалпына келтіру жүріп жатыр...",
			paymentNoInternetTitle: "Кешіріңіз. Қосылу проблемасы туындады.",
			paymentNoInternetClose: "OK",
			paymentFetchingQRCode: "QR коды алынуда",
			paymentScanQRCode: "Momo қолданбасында QR кодын сканерлеңіз",
			paymentScanQRCodeMessage: "Төлем процесі Momo қолданбасында аяқталуы керек. Транзакциядан бас тартқыңыз келсе, оны қолданбадан орындаңыз.",
			categoryComboModalTitle: "Порция өлшемін таңдаңыз",
			categoryPreviousAction: "Артқа",
			productCustomisationsAdditionalPriceWarning: "Сіз тағамыңызға қосымша {{бағасы}} қостыңыз",
			productCustomisationsReadOnlyEach: "{{бағасы}} Әрқайсысы",
			productCustomisationsReadonlyProductRemoved: "Алып тастау {{атауы}}",
			productCustomisationsUnlimitedMax: "Шектеусіз",
			productCancelOrderAction: "Болдырмау",
			categoriesTitle: "Мәзір",
			categoriesCancelOrderAction: "Болдырмау",
			cancelOrderButtonModalQuestion: "Сіз тапсырысыңызды болдырмауға сенімдісіз бе?",
			cancelOrderButtonModalTitle: "Тапсырысты болдырмау",
			cancelOrderButtonModalPrimaryAction: "Жоқ",
			cancelOrderButtonModalSecondaryAction: "Иә",
			cancelOrderButtonName: "Болдырмау",
			categoriesNextAction: "Орындау",
			categoriesPreviousAction: "Артқа",
			customerDetailsTitle: "Толық ақпарат",
			customerDetailsFormTitle: "Тапсырысыңыз дайын болған кезде біз Сізді шақырамыз",
			customerDetailsFormSubTitle: "Мұнда енгізіңіз",
			customerDetailsPreviousAction: "Артқа",
			customerDetailsNextAction: "Жалғастыру",
			beaconTitle: "Белгі беретін аспап",
			beaconFormHeaderTitle: " Белгі беретін аспап нөмірін көрсетіңіз",
			beaconFormHeaderSubtitle: "Тапсырысыңыз алуға дайын болғанда, ол ызылдап, жанады",
			beaconPreviousAction: "Артқа",
			beaconAdditionalAction: "Болдырмау",
			beaconCancelAction: "Болдырмау",
			beaconFormPrimaryAction: "Беру",
			beaconFormSecondaryAction: "Болдырмау",
			beaconNextAction: "Беру",
			beaconInputError: "Шынайы нөмірді енгізіңіз",
			couponTitle: "Купон коды",
			couponPreviousAction: "Артқа",
			couponFormHeaderTitle: "Купоныңызды енгізіңіз:",
			couponFormPrimaryAction: "Растау",
			couponFormSecondaryAction: "Артқа",
			couponListHeaderTitle: "Купон",
			couponListAddToCartAction: "Себетке қосу",
			couponListChangeAction: "Өзгерту",
			couponErrorHeaderTitle: "Кешіріңіз, бұл купон табылмады.",
			couponErrorSecondaryAction: "«Санаттар» бөліміне оралу",
			couponErrorPrimaryAction: "Қайтадан көріңіз",
			couponGroupedModalSecondaryAction: "Жабу",
			couponComboModalTitle: "Порция өлшемін таңдаңыз",
			couponComboModalSecondaryAction: "Жабу",
			couponNextAction: "Орындау",
			composedPreviousAction: "Артқа",
			composedEditingNextAction: "Тапсырысты жаңарту",
			composedNextAction: "Тапсырысқа қосу",
			composedCancelOrderAction: "Болдырмау",
			composedProductLayerTitle: "Өнімді таңдау {{қаттама}}",
			composedProductFinalTitle: "Сіз осы өнімді таңдадыңыз:",
			composedProductFinalCustomise: "Таңдауыңызды растаңыз",
			composedProductFinalCustomize: "Таңдауыңызды растаңыз",
			composedHeaderTitle: "Өз бетімен таңдау",
			orderValidationErrorMessage: "Ой, тапсырысыңызды өңдемек  болған кезде бірдеңе дұрыс болмады",
			requestTimedOut: "сұрау уақыты аяқталды",
			orderValidationErrorPrimaryAction: "Қайтадан көру",
			orderValidationErrorSecondaryAction: "Болдырмау",
			orderConfirmationErrorMessage: "Ой, бірдеңе дұрыс болмады",
			orderConfirmationGenericAdditionalMessage: "Таңдалған әдіс бойынша төлеміңіздің аяқталғанына көз жеткізіңіз",
			orderConfirmationAdditionalMessage: "Картаны терминалдан алдыңыз ба, тексеріңіз",
			orderConfirmationErrorPrimaryAction: "Қайтадан көру",
			orderConfirmationErrorSecondaryAction: "Болдырмау",
			orderConfirmationLoadingTitle: "Ас үйге жіберу",
			orderConfirmationLoadingMessage: "Күте тұрыңыз. Тапсырысыңызды ас үйге жіберіп жатырмыз",
			orderConfirmationLoadingMessageFirstAutoRetry: "Бізбен бірге болыңыз, тапсырысыңызды ас үйге жіберуге біраз уақыт кетеді.",
			orderConfirmationLoadingMessageSecondAutoRetry: "Тапсырысыңызды өткізуде кішкене кідіріс бар.",
			orderConfirmationNoInternetLoadingTitle: "Қосылу проблемалары",
			orderConfirmationNoInternetLoadingMessage: "Бізде қосылу проблемалары туындады. Күте тұрыңыз. Қалпына келтіру жүріп жатыр...",
			orderConfirmationNoInternetTitle: "Кешіріңіз! Тапсырысыңызды ас үйге жіберу проблемасы туындады. Түбіртекті фотоға түсіріп, тіркеу үстелшесінде хабарлауыңызды сұраймыз.",
			orderConfirmationNoInternetDetailsTitle: "Толық ақпарат",
			orderConfirmationNoInternetDetailsDateTime: "Күні",
			orderConfirmationNoInternetDetailsCardNumber: "Карта нөмірі",
			orderConfirmationNoInternetClose: "OK",
			orderPostErrorMessage: "Ой, бірдеңе дұрыс болмады",
			orderPostErrorPrimaryAction: "Қайтадан көріңіз",
			orderPostErrorSecondaryAction: "Болдырмау",
			categoryGroupedModalSecondaryAction: "Жабу",
			categoryComboModalSecondaryAction: "Жабу",
			categoryNextAction: "Аяқтау",
			productPreviousAction: "Артқа",
			timeoutModalTitle: "Сіз әлі осындасыз ба?",
			timeoutModalSecondaryAction: "Қабылдамау",
			timeoutModalContentMessage: "Басты бетке {{ timeLeft }} соң оралу",
			productComboSizeAction: "Өзгерту",
			productOptionCardPrimaryAction: "Таңдауды өзгерту",
			productOptionCardSecondaryAction: "Өз бетімен таңдау",
			productOptionItemCardSelectedMessage: "Сіздің тағамыңызда",
			productOptionsChangeModalCloseAction: "Қабылдамау",
			offerLimitModalTitle: "Ұсыныс себетіңізде әлдеқашан бар",
			offerLimitConfirmation: "Бір тапсырысқа тек 1 ұсыныс рұқсат етіледі. Бар ұсынысты ауыстырғыңыз келе ме?",
			orderValidationLoadingTitle: "Себетті жаңарту",
			orderValidationLoadingMessage: "Тексеру жүргізілуде",
			orderPostLoadingTitle: "Тапсырысты аяқтау",
			orderPostLoadingMessage: "Күте тұрыңыз. Тапсырысыңыз аяқталып жатыр",
			productCustomisationsReadOnlyExtra: "Өз бетімен таңдалған позициялар",
			productCustomisationsProductsMissingError: "Позицияларды {{ жоқ өнімдер саны }} қосыңыз",
			productCustomisationsProductsMissingError_plural: " Позицияларды {{ жоқ өнімдер саны }} қосыңыз ",
			autoRedirectNotificationTitle: "Ой, бізде әлі де проблемалар бар. Әрекеттер енді жоқ",
			autoRedirectNotificationAdditionalMessage: "Кешірім сұраймыз",
			autoRedirectNotificationMessage: "Қауіпсіздік мақсатында Сізді кері қайтарамыз",
			autoRedirectNotificationButton: "OK",
			upsellModalTitle: "Тапсырысқа қосқыңыз келе ме?",
			productCustomisationModalHeaderTitle: "Өз бетімен таңдау",
			productCustomisationModalAddToCartAction: "Тапсырысқа қосу",
			productCustomisationModalUpdateCartAction: "Тапсырысты жаңарту",
			productCustomisationModalCloseAction: "Қабылдамау",
			upsellModalCloseAction: "Қабылдамау",
			productOptionCustomisationModalAddToCartAction: "Себетке қосу",
			productOptionCustomisationModalUpdateCartAction: "Тапсырысты жаңарту",
			productOptionCustomisationModalCloseAction: "Қабылдамау",
			bannerWarningTitle: "Біздің №1 басымдылық – Сіздің денсаулығыңыз бен амандығыңыз",
			bannerWarningDescription: "Осы қиын уақытта біз онсыз да қатаң тазалық пен гигиена сақтау процедураларын жетілдірдік.",
			paymentMethodCard: "Төлем тек картамен",
			miniCartNextAction: "Аяқтау",
			miniCartCloseAction: "Жабу",
			miniCartCheckoutAction: "Тексеру",
			miniCartTotal: "Жиыны",
			invalidRouteTitle: "Ой, сіз шатасып қалған сияқтысыз",
			invalidRouteButton: "Қауіпсіздік мақсатында оралу(???)",
			templateMenuAction: "Мәзір",
			templateCancelAction: "Болдырмау",
			templateBasketAction: "Тапсырысты тексеру",
			templateCouponAction: "Акция коды енгізу (???)",
			refundGenericInstructions: "Төлемді қайтаруды күтіңіз",
			refundInstructions: "Төмендегі PIN-падта қайтаруды күтіңіз",
			refundErrorMessage: "Ой, бірдеңе дұрыс болмады! Сізге қайтару жасауға тырысып жатырмыз",
			refundRetryMessage: "Қайтадан көру",
			refundCancelMessage: "Болдырмау",
			refundCancelButton: "OK",
			refundSuccessButton: "OK",
			refundCancelDetails: "Толық ақпарат",
			refundCancelDateTime: "Күні",
			refundCancelCardNumber: "Карта нөмірі",
			refundCancelOrderNumber: "Тапсырыс нөмірі",
			refundSuccessMessage: "Қайтару процесі сәтті басталды. Оның күшіне ену уақыты төлем әдісіне байланысты екенін ескеріңіз.",
			refundCancelledMessage: "Кешіріңіз! Тапсырысыңызды ас үйге жіберу проблемасы туындады. Түбіртекті фотоға түсіріп немесе QR коды арқылы жүктеп,  тіркеу үстелшесінде хабарлауыңызды сұраймыз.",
			refundSuccessTitle: "Қайтару сәтті орындалды",
			refundLoadingTitle: "Қайтаруды орындау үшін деректерді жүктеу",
			menuAction: "Мәзір",
			menuPreviousAction: "Артқа",
			productCustomisationsRemove: "Алып тастау",
			productCustomisationsChange: "Өзгерту",
			productCustomisationsResetting: "Қалпына келтіру...",
			productCustomisationsReset: "Қалпына келтіру",
			productCustomisationsDeselect: "Таңдауды алып тастау",
			productCustomisationsAdd: "Қосу",
			productCustomisationsSelect: "таңдаңыз",
			warningTitle: "Ой, бірдеңе дұрыс болмаған сияқты!",
			warningCancelAction: "Болдырмау",
			warningTryAgainAction: "Қайтадан көріңіз",
			receiptTitle: "Сіздің тапсырысыңыз",
			receiptEcoMessage: "Түбіртекті басу керек емес (???)",
			transactionsNavigatorNextAction: "Келесі",
			transactionsNavigatorPreviousAction: "Алдыңғы",
			transactionsTitle: "Операциялар",
			transactionsIdentityTitle: "Сәйкестендіру",
			transactionsIdentityId: "Сессия сәйкестендіргіші",
			transactionsIdentityStatus: "Күйі",
			transactionsIdentityTimestamp: "Күні",
			transactionsIdentityType: "Тапсырыс түрі",
			transactionsIdentityMessage: "Хабарлама",
			transactionsIdentityOrderReference: "Тапсырыс сілтемесі",
			transactionsPaymentTitle: "Жиыны",
			transactionsPaymentType: "Төлем түрі",
			transactionsPaymentAmount: "Карта бойынша жалпы сома",
			transactionsPaymentAuthCode: "Авторландыру коды",
			transactionsPaymentCardNumber: "Карта нөмірі",
			transactionsPaymentTransactionId: "Операция сәйкестендіргіші",
			transactionsPaymentOrderTotal: "Тапсырыстың жалпы сомасы",
			transactionsPaymentNoPaymentFound: "Төлем әдісі таңдалған жоқ",
			transactionsPrimaryAction: "Артқа",
			transactionsPaymentCardType: "Карта түрі",
			transactionsNotFound: "Соңғы қайта жүктеуден бері ешбір операция сақталмады",
			quantityControllerOutlinedLabel: "Саны",
			defaultLoadingTitle: "Ас үйді жылыту",
			loadingCoupon: "Купонды іздеу",
			defaultLoadingMessage: "Өтінемін күте тұрыңыз",
			termsAndConditionsModalTitle: "Шарттар мен шарттар",
			termsAndConditionsModalCloseAction: "Жабық",
			ORDER_CONFIRMATION_SUCCESS: "Сәттілік",
			ORDER_REFUND_CANCELLED: "Қайтару тоқтатылды",
			ORDER_CONFIRMATION_ERROR: "Қате",
			ORDER_CANCELLED: "Бас тартылды",
			ORDER_VALIDATION_ERROR: "Валидация қатесі",
			ORDER_REFUND_SUCCESS: "Төлемді қайтару",
			ORDER_VALIDATION_SUCCESS: "Тексеру сәтті өтті",
			ORDER_PAYMENT_ERROR: "Төлем қатесі",
			ORDER_PAYMENT_SUCCESS: "Төлем сәтті болды",
			ORDER_REFUND_ERROR: "Ақшаны қайтару қатесі",
			ORDER_POST_SUCCESS: "Сәттілік",
			ORDER_POST_ERROR: "Қате",
			transactionsLateRefund: "Төлемді қайтару",
			transactionsLateRefundFalse: "Жоқ",
			transactionsLateRefundTrue: "Иә",
			transactionLateRefundModalText: "Төлемді қайтарғыңыз келетініне сенімдісіз бе",
			transactionLateRefundFailedMessage: "Өкінішке орай, қайтаруыңызды өңдей алмадық.",
			transactionLateRefundCancelledMessage: "Төлемді қайтару тоқтатылды!",
			showAddonAvailabilityMessage: "Жақында орал",
			addonRemovedModalTitle: "Кейбір элементтерді алып тастадық",
			addonRemovedMessage: "Айтпақшы, біз мыналарды алып тастадық:",
			addonRemovedFooterMessage: "Элементтер тек сатып алу кезінде қол жетімді",
			loyaltyLoginTitle: "Мүшеге кіру",
			loyaltyLoginNextAction: "Растау",
			loyaltyLoginPreviousAction: "Артқа",
			loyaltyBannerTitle: "СЫЙЛЫҚТАРЫҢЫЗДЫ ТАБЫП, ЛӘЗАТ АЛЫҢЫЗ!",
			loyaltyBannerSubtitle: "Сіз біздің мүшесіз бе?",
			loyaltyBannerMember: "МҮШЕ:",
			loyaltyBannerLogin: "Кіру",
			loyaltyBannerLogout: "Шығу",
			loyaltyBannerOffers: "Ұсыныстар",
			loyaltyBannerOffersAndDeals: "Ұсыныстар мен мәмілелер",
			loyaltyBannerRedeemables: "Өтелетіндер",
			loyaltyOffersTitle: "Мүше ұсыныстары",
			loyaltyOffersPreviousAction: "Артқа",
			loyaltyOffersNextAction: "Аяқталды",
			loyaltyLoginCodeTitle: "Кодты енгізіңіз",
			loyaltyQrLoginCodeTitle: "немесе қолданбаңызбен сканерлеңіз",
			bestValueProduct: "Ең жақсы мән",
			hotDealProduct: "Ыстық мәміле",
			loyaltyWelcomeModalTitle: "Қош келдіңіз, {{name}}",
			loyaltyWelcomeModalPoints: "Сізде {{points}} ұпай бар",
			loyaltyWelcomeModalConfirm: "Жарайды",
			loyaltyLogOutModalConfirm: "Шынымен жүйеден шығуды қалайсыз ба?",
			loyaltyLoginFailedModalTitle: "Кешіріңіз",
			loyaltyLoginFailedModalClose: "Қайталаңыз",
			loyaltyLoginFailedModalContent: "Біз сіздің кодыңызды тексере алмадық",
			loyaltyLoginOrSkipModalTitle: "Сіздің жолыңызбен сыйлықтар",
			loyaltyLoginOrSkipModalLoginButtonText: "Кіру",
			loyaltyLoginOrSkipModalSkipButtonText: "Өткізіп жіберу",
			loyaltyMemberSignInButtonText: "Мүше кіру",
			loyaltyGuestOrderButtonText: "Қонақ ретінде тапсырыс беру",
			loyaltyOrderHistoryTitle: "Тапсырыс тарихы",
			loyaltyReorderTitle: "Қайта тапсырыс беру {{orderDate}}",
			loyaltyReorderViewOrder: "Тапсырысты қарау",
			loyaltyReorderAddToCart: "Тапсырысқа қосыңыз",
			loyaltyReorderAddingToCart: "Добавление...",
			loyaltyReorderCancel: "Жабық",
			appDownloadTitle: "Қосымшаны жүктеу",
			appDownloadContent: "Мүше емессіз бе?",
			appDownloadSubContent: "KFC қосымшасын жүктеп, тіркелу үшін бұл кодты сканерлеңіз",
			appDownloadPreviousAction: "Артқа",
			appDownloadNextAction: "Кіру",
			chooseCustomisations: "Баптауларыңызды таңдаңыз",
			taxesFees: "Салықтар мен алымдар",
			discount: "жеңілдік",
			chooseProductCustomisations: "теңшеулер",
			cartComboModalTitle: "Тамақ өлшемін таңдаңыз",
			cartComboModalSecondaryAction: "Жабу"
		}
	},
	"fr-CA": {
		translation: {
			homeTitle: "RAPIDE",
			loadingCoupon: "Recherche du coupon",
			homeSubtitle: "COMMANDER ICI",
			homePrimaryAction: "À Emporter",
			homeSecondaryAction: "Sur Place",
			homeConnectivityIssues: "Nous avons des problèmes de connectivité, veuillez patienter pendant que nous essayons de récupérer…",
			homeTermsAndConditionsBannerWarningTitle: "Termes et Conditions",
			homeTermsAndConditionsBannerWarningDescription: "En continuant, vous acceptez notre",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "Conditions d'utilisation et politique de confidentialité",
			adminTitle: "Administrer",
			adminGeneralSection: "Général",
			adminSerialKeyField: "Numéro de série",
			adminMenuSection: "Menu",
			adminOrderingSection: "Commande",
			adminOrganisationField: "Organisation",
			adminStoreField: "Magasin",
			adminSiteField: "Placer",
			adminTimezoneField: "Fuseau horaire",
			adminVersionField: "Version",
			adminEnvironmentField: "Environnement",
			adminMockFieldFalseText: "Non",
			adminMockFieldTrueText: "Oui",
			adminPaymentSection: "Paiment  ",
			adminMockField: "Faux",
			adminProviderField: "Fournisseur",
			adminPaymentPoiIdField: "Poind ?",
			adminPaymentIpAddressField: "Adresse IP",
			adminPaymentUsbPidField: "PID USB?",
			adminPaymentUsbVidField: "VID USB?",
			adminPaymentUsbPortField: "Port USB",
			adminLockModal: "Écran verrouillé",
			adminLockModalTitle: "Options d'écran de verrouillage",
			adminLockModalClose: "Fermer",
			adminPrimaryLockAction: "Écran de verrouillage - Kiosque non disponible",
			adminSecondaryLockAction: "Écran de verrouillage - Restaurant Fermé",
			lockMessage: "Kiosque non-disponible. Veuillez utiliser un autre kiosque ou commandez au comptoir avant.",
			lockSecondaryMessage: "Le restaurant est actuellement fermé.",
			adminLoginTitle: "Veuillez saisir le mot de passe administrateur",
			adminRefreshAction: "Rafaîchir",
			adminExitAction: "Sortie",
			adminLoginPrimaryAction: "Connexion",
			adminLoginSecondaryAction: "Annuler",
			adminLoginErrorPasswordMessage: "Mot de passe incorrect",
			adminTransactionsAction: "Transactions",
			allergensMessage: "Contient: {{allergens}}",
			smsSending: "Envoi de SMS",
			smsErrorMessage: "Échec de l'envoi de SMS",
			smsErrorDetailsMessage: "Veuillez vérifier le numéro que vous avez fourni",
			smsMockErrorMessage: "Réponse simulée échouée",
			smsMockSuccessMessage: "Réponse simulée avec succès?",
			smsSuccessTitle: "SMS envoyé avec succès",
			smsSuccessSubtitle: "Les SMS peuvent prendre un certain temps pour être reçu",
			smsSuccessButton: "Continuer",
			smsPrimaryAction: "Envoyer",
			smsSecondaryAction: "Sauter",
			smsCountryCodeCannotBeEmpty: "Le code du pays ne peut pas être absent",
			smsCountryCodeStartWithZero: "Le code de pays ne peut pas commencer par zéro",
			smsCountryCodeExceedsMaxLength: "Le code de pays dépasse la longueur maximale autorisée",
			smsCountryCodeDoesNotMeetMinimumLength: "Le code du pays ne répond pas à la longueur minimale requise",
			smsPhoneCannotStartWithZero: "Le numéro de téléphone ne peut pas commencer par «0»",
			smsPhoneExceedsMaxLength: "Le numéro de téléphone dépasse la longueur maximale autorisée",
			smsPhoneDoesNotMeetMinimumLength: "Le numéro de téléphone ne répond pas à la longueur minimale requise",
			smsTitle: "Envoyer un reçu via SMS",
			smsSubtitle: "Veuillez entrer votre numéro de téléphone",
			receiptDetailsInstruction: "Veuillez analyser le code QR pour votre reçu",
			receiptDetailsInstructionCash: "Payez votre commande au comptoir",
			receiptDetailsInstructionCard: "Récupérez votre commande au point de retrait",
			receiptDetailsOrderNumber: "RÉFÉRENCE DE L'ACHAT:",
			receiptDetailsPrimaryAction: "Reçu",
			receiptSmsAction: "SMS",
			receiptTermsAndConditionsAction: "Termes et Conditions",
			receiptPrimaryAction: "Terminé",
			receiptDetailsTaxInvoice: "Facture fiscale",
			receiptDetailsOrderType: "Catégorie",
			receiptPaymentRestaurantName: "Restaurant",
			receiptPaymentRestaurantAddress: "Adresse",
			receiptPaymentPhone: "Téléphone",
			receiptPaymentTaxNumber: "???",
			receiptPaymentItemQuantity: "Articles",
			receiptPaymentTaxTotal: "TPS",
			receiptPaymentSubTotal: "Sous-Total",
			receiptPaymentTotal: "Total",
			receiptPaymentPending: "Paiement en attente",
			receiptPaymentKitchenId: "Identifiant de cuisine",
			receiptCash: "Argent Comptant",
			receiptDineIn: "Sur Place",
			receiptTakeaway: "À Emporter",
			receiptQRCodeOpen: "Reçu",
			smsReceiptHeaderText: "Bonjour de PFK",
			smsReceiptOrderNumberText: "Votre numéro de commande est: {{orderNumber}}",
			smsReceiptUrlText: "Obtenez votre reçu à: {{url}}",
			smsReceiptPendingPaymentText: "En attente de Paiement",
			smsErrorPrimaryAction: "Essayer de nouveau",
			smsErrorSecondaryAction: "Continuer ",
			customerDetailsFirstNameLabel: "Prénom {{required}}",
			customerDetailsLastNameLabel: "Dernière initiale {{required}}",
			customerDetailsPhoneNumberLabel: "Numéro de téléphone {{ required }}",
			customerDetailsRequired: "(Requis)",
			customerDetailsOptional: "(Facultatif)",
			customerDetailsFormPrimaryAction: "Continuer",
			customerDetailsFormSecondaryAction: "Sauter",
			customerDetailsInputInvalidError: "{{label}} n'est pas valide",
			customerDetailsEmailLabel: "Courriel {{required}}",
			customerDetailsEmailDescription: "Reçu QR Disponible à la caisse",
			customerDetailsInputRequiredError: "{{label}} est requis",
			customerDetailsInputMinimumError: "{{ label }} ne respecte pas la longueur minimale requise",
			customerDetailsProfaneInputError: "Veuillez réessayer, ce mot n'est pas permis",
			customerDetailsSpecialCharactersInputError: "Veuillez réessayer, les caractères spéciaux ne sont pas permis",
			customerDetailsCancelOrderAction: "Annuler",
			receiveEmailAddress: "M'inscrire pour en savoir plus à propos des coupons exclusifs et offres récentes",
			cartNextAction: "Procédez au Paiment",
			cartTitle: "Votre Commande",
			cartPleaseSelectProduct: "Veuillez sélectionner le produit concerné à utiliser",
			cartPreviousAction: "Retour en arrière",
			cartEmptyMessage: "Votre panier est vide",
			cartEmptyPrimaryAction: "Retour au menu",
			cartProductUnavailableGeneral: "Cet article est actuellement indisponible",
			cartProductUnavailableAddon: "Indisponible",
			cartProductUnavailableItem: "De retour bientôt",
			cartCancelOrderAction: "Annuler",
			cartChangeAction: "Changer",
			cartRemoveAction: "Retirer",
			cartProductUnitPriceEach: "{{price}} chacun",
			cartUpsellTitle: "AJOUTEZ PLUS À VOTRE COMMANDE",
			cartUpsellAction: "Ajouter plus",
			cartUpsellGalleryCardButtonActionText: "Ajouter",
			cartGroupedModalSecondaryAction: "Fermer",
			cartNoInternetLoadingTitle: "Problèmes de connectivité",
			cartNoInternetLoadingMessage: "Nous avons des problèmes de connectivité, veuillez patienter pendant que nous essayons de récupérer ...",
			cartNoInternetTitle: "Nous sommes désolés, il y avait un problème de connectivité.",
			cartNoInternetClose: "D'ACCORD",
			productNextAction: "Ajouter à la commande",
			productEditingNextAction: "Mise à jour de la commande",
			productTitle: "Personnaliser",
			customisationExtraPriceWarning: "Vous avez ajouté {{price}} de plus à votre repas",
			customisationPriceEach: "{{price}} chacun",
			paymentInstructions: "Veuillez suivre les instructions de paiement sur le clavier ci-dessous",
			paymentErrorMessage: "Oups, quelque chose s'est mal passé",
			paymentErrorDetail: "Oups, quelque chose s'est mal passé - le NIP a été refusé: {{message}}",
			paymentErrorQRCodeDetail: "Oups, quelque chose s'est mal passé - la réponse du code QR était: {{message}}",
			paymentErrorQRCodeMessage: "Veuillez analyser le code QR pour obtenir le reçu de paiement rejeté",
			paymentRetryMessage: "Recommencer",
			paymentCancelMessage: "Annuler",
			paymentOptionsTitle: "Choisir Méthode de Paiement",
			paymentOptionsSecondaryAction: "Retour",
			paymentOptionsCARDTitle: "Carte",
			paymentOptionsCASHTitle: "Argent Comptant",
			paymentOptionsMOMOPAYTitle: "Momo",
			paymentOptionsExpressMessage: "Paiement express",
			paymentNoInternetLoadingTitle: "Problèmes de connectivité",
			paymentNoInternetLoadingMessage: "Nous avons des problèmes de connectivité, veuillez patienter pendant que nous essayons de récupérer ...",
			paymentNoInternetTitle: "Nous sommes désolés, il y avait un problème de connectivité.",
			paymentNoInternetClose: "D'ACCORD",
			paymentFetchingQRCode: "Récupération du code QR",
			paymentScanQRCode: "Veuillez scanner le code QR dans l'application Momo",
			paymentScanQRCodeMessage: "Le processus de paiement doit être effectué dans l'application Momo. Si vous souhaitez annuler la transaction, veuillez le faire depuis l'application.",
			categoryComboModalTitle: "Sélectionner Format du repas",
			categoryPreviousAction: "Retour",
			productCustomisationsAdditionalPriceWarning: "Vous avez ajouté {{price}} de plus à votre repas",
			productCustomisationsReadOnlyEach: "{{price}} chacun",
			productCustomisationsReadonlyProductRemoved: "Non {{name}}",
			productCustomisationsUnlimitedMax: "Illimité",
			productCancelOrderAction: "Annuler",
			categoriesTitle: "Menu",
			categoriesCancelOrderAction: "Annuler",
			cancelOrderButtonModalQuestion: "Voulez-vous vraiment annuler votre commande?",
			cancelOrderButtonModalTitle: "Annuler la commande",
			cancelOrderButtonModalPrimaryAction: "Non",
			cancelOrderButtonModalSecondaryAction: "Oui",
			cancelOrderButtonName: "Annuler",
			categoriesNextAction: "Complet",
			categoriesPreviousAction: "Retourner",
			customerDetailsTitle: "Détails",
			customerDetailsFormTitle: "Nous allons appeler votre nom lorsque votre commande sera prête",
			customerDetailsFormSubTitle: "Veuillez y entrer ici",
			customerDetailsPreviousAction: "Retourner",
			customerDetailsNextAction: "Continuer",
			beaconTitle: "Balise",
			beaconFormHeaderTitle: "Entrez le numéro de balise",
			beaconFormHeaderSubtitle: "Et il va buzzer et clignoter lorsque votre commande sera prête",
			beaconPreviousAction: "Retourner",
			beaconAdditionalAction: "Annuler",
			beaconCancelAction: "Annuler",
			beaconFormPrimaryAction: "Soumettre",
			beaconFormSecondaryAction: "Annuler",
			beaconNextAction: "Soumettre",
			beaconInputError: "S'il vous plait, entrez un nombre valide",
			couponTitle: "Code promo",
			couponPreviousAction: "Retourner",
			couponFormHeaderTitle: "Entrer votre coupon:",
			couponFormPrimaryAction: "Confirmer",
			couponFormSecondaryAction: "Retourner",
			couponListHeaderTitle: "Coupon",
			couponListAddToCartAction: "Ajouter au panier",
			couponListChangeAction: "Changer",
			couponErrorHeaderTitle: "Désolé, ce coupon est introuvable.",
			couponErrorSecondaryAction: "Retour aux catégories",
			couponErrorPrimaryAction: "Essayer à nouveau",
			couponGroupedModalSecondaryAction: "Fermer",
			couponComboModalTitle: "Sélectionner Format du repas",
			couponComboModalSecondaryAction: "Fermer",
			couponNextAction: "Complet",
			composedPreviousAction: "Retourner",
			composedEditingNextAction: "Mise à jour Commande",
			composedNextAction: "Ajouter à la commande",
			composedCancelOrderAction: "Annuler",
			composedProductLayerTitle: "Choisisser le produit {{layer}}",
			composedProductFinalTitle: "Vous avez choisi ce produit:",
			composedProductFinalCustomise: "Confirmez votre sélection",
			composedHeaderTitle: "Personnaliser",
			orderValidationErrorMessage: "Oups, quelque chose s'est mal passé lorsque nous avons essayé de traiter votre commande",
			requestTimedOut: "Demande expirée",
			orderValidationErrorPrimaryAction: "Recommencer",
			orderValidationErrorSecondaryAction: "Annuler",
			orderConfirmationErrorMessage: "Oups, quelque chose s'est mal passé",
			orderConfirmationGenericAdditionalMessage: "Veuillez vous assurer que votre paiement est terminé sur la méthode sélectionnée",
			orderConfirmationAdditionalMessage: "Veuillez vous assurer que votre carte est retirée du terminal",
			orderConfirmationErrorPrimaryAction: "Recommencer",
			orderConfirmationErrorSecondaryAction: "Annuler",
			orderConfirmationLoadingTitle: "Envoi à la cuisine",
			orderConfirmationLoadingMessage: "Veuillez patienter, nous envoyons votre commande à la cuisine",
			orderConfirmationLoadingMessageFirstAutoRetry: "Restez avec nous, ça prend un peu plus de temps pour envoyer votre commande en cuisine.",
			orderConfirmationLoadingMessageSecondAutoRetry: "Il y a un petit délai dans le passage de votre commande.",
			orderConfirmationNoInternetLoadingTitle: "Problèmes de connectivité",
			orderConfirmationNoInternetLoadingMessage: "Nous avons des problèmes de connectivité, veuillez patienter pendant que nous essayons de récupérer ...",
			orderConfirmationNoInternetTitle: "Nous sommes désolés, il y a eu un problème en envoyant votre commande à la cuisine. Veuillez prendre une photo du reçu et informer le comptoir avant.",
			orderConfirmationNoInternetDetailsTitle: "Détails",
			orderConfirmationNoInternetDetailsDateTime: "Date",
			orderConfirmationNoInternetDetailsCardNumber: "Numéro de carte",
			orderConfirmationNoInternetClose: "D'ACCORD",
			orderPostErrorMessage: "Oups, quelque chose s'est mal passé",
			orderPostErrorPrimaryAction: "Recommencer",
			orderPostErrorSecondaryAction: "Annuler",
			categoryGroupedModalSecondaryAction: "Fermer",
			categoryComboModalSecondaryAction: "Fermer",
			categoryNextAction: "Complet",
			productPreviousAction: "Retourner",
			timeoutModalTitle: "Êtes-vous toujours là?",
			timeoutModalSecondaryAction: "Rejeter",
			timeoutModalContentMessage: "Retour menu d'accueil {{timeLeft}}",
			productComboSizeAction: "Changer",
			productOptionCardPrimaryAction: "Changement de sélection",
			productOptionCardSecondaryAction: "Personnaliser",
			productOptionItemCardSelectedMessage: "Dans votre repas",
			productOptionsChangeModalCloseAction: "Rejeter",
			offerLimitModalTitle: "Une offre existe déjà dans votre panier",
			offerLimitConfirmation: "Une seule offre autorisée par commande. Souhaitez-vous remplacer l’offre existante ?",
			orderValidationLoadingTitle: "Mise à jour du panier",
			orderValidationLoadingMessage: "Allons vérifier la commande",
			orderPostLoadingTitle: "Terminons la commande",
			orderPostLoadingMessage: "Veuillez patienter, nous terminons votre commande",
			productCustomisationsReadOnlyExtra: "Personnalisations",
			productCustomisationsProductsMissingError: "Veuillez ajouter {{productsMissingCount}} items",
			productCustomisationsProductsMissingError_plural: "Veuillez ajouter {{productsMissingCount}} items",
			autoRedirectNotificationTitle: "Oups, nous avons toujours des problèmes, il ne reste plus de tentatives",
			autoRedirectNotificationAdditionalMessage: "Désolé pour ça",
			autoRedirectNotificationMessage: "On vous redirige vers la sécurité",
			autoRedirectNotificationButton: "D'ACCORD",
			upsellModalTitle: "Souhaitez-vous les ajouter à la commande?",
			productCustomisationModalHeaderTitle: "Personnaliser",
			productCustomisationModalAddToCartAction: "Ajouter à la commande",
			productCustomisationModalUpdateCartAction: "Mise à jour Commande",
			productCustomisationModalCloseAction: "Rejeter",
			upsellModalCloseAction: "Rejeter",
			productOptionCustomisationModalAddToCartAction: "Ajouter au panier",
			productOptionCustomisationModalUpdateCartAction: "Mise à jour Commande",
			productOptionCustomisationModalCloseAction: "Rejeter",
			bannerWarningTitle: "Votre santé et bien-être est notre priorité #1",
			bannerWarningDescription: "Nous avons renforcé nos procédures de nettoyage et d'hygiène déjà strictes en ces temps difficiles.",
			paymentMethodCard: "Paiment par carte seulement",
			miniCartNextAction: "Complet",
			miniCartCloseAction: "Fermer",
			miniCartCheckoutAction: "Passer à la caisse ",
			miniCartTotal: "Total",
			invalidRouteTitle: "Oups, on dirait que vous êtes perdu",
			invalidRouteButton: "Retour à la sécurité",
			templateMenuAction: "Menu",
			templateCancelAction: "Annuler",
			templateBasketAction: "Voir la commande",
			templateCouponAction: "Entrer l'offre",
			refundGenericInstructions: "Veuillez attendre le remboursement",
			refundInstructions: "Veuillez attendre le remboursement du clavier ci-dessous",
			refundErrorMessage: "Oups, quelque chose s'est mal passé en essayant de vous rembourser",
			refundRetryMessage: "Recommencer",
			refundCancelMessage: "Annuler",
			refundCancelButton: "D'ACCORD",
			refundSuccessButton: "D'ACCORD",
			refundCancelDetails: "Détails",
			refundCancelDateTime: "Date",
			refundCancelCardNumber: "Numéro de carte",
			refundSuccessMessage: "Le processus de remboursement a démarré avec succès. Veuillez noter que le délai de mise en vigueur dépend du mode de paiement.",
			refundCancelledMessage: "Nous sommes désolés, il y a eu un problème lors de l'envoi de votre commande en cuisine. Veuillez prendre une photo ou télécharger le reçu à partir du code QR et informer le comptoir avant.",
			refundSuccessTitle: "Remboursement réussi",
			refundLoadingTitle: "Remboursement en cours",
			menuAction: "Menu",
			menuPreviousAction: "Retour",
			productCustomisationsRemove: "Retirer",
			productCustomisationsChange: "Changer",
			productCustomisationsResetting: "Réinitialisation...",
			productCustomisationsReset: "Réinitialiser",
			productCustomisationsDeselect: "Désélectionner",
			productCustomisationsAdd: "Ajouter  ",
			productCustomisationsSelect: "Sélectionner",
			warningTitle: "Oups, on dirait que quelque chose s'est mal passé",
			warningCancelAction: "Annuler",
			warningTryAgainAction: "Essayer de nouveau",
			receiptTitle: "Votre Commande",
			receiptEcoMessage: "SANS PAPIER",
			transactionsNavigatorNextAction: "Suivant",
			transactionsNavigatorPreviousAction: "Précédent",
			transactionsTitle: "Transactions",
			transactionsIdentityTitle: "Identité",
			transactionsIdentityId: "Identifiant de la session",
			transactionsIdentityStatus: "Statut",
			transactionsIdentityTimestamp: "Date",
			transactionsIdentityType: "Type de commande",
			transactionsIdentityMessage: "Message",
			transactionsIdentityOrderReference: "Référence de l'achat",
			transactionsPaymentTitle: "Total",
			transactionsPaymentType: "Type de paiement",
			transactionsPaymentAmount: "Total de la carte",
			transactionsPaymentAuthCode: "code d'autorisation",
			transactionsPaymentCardNumber: "Numéro de carte",
			transactionsPaymentTransactionId: "identifiant de transaction",
			transactionsPaymentOrderTotal: "Total de la commande",
			transactionsPaymentNoPaymentFound: "Aucun paiement sélectionné",
			transactionsPrimaryAction: "Retourner",
			transactionsPaymentCardType: "Type de carte",
			transactionsNotFound: "Aucune transaction stockée depuis le dernier redémarrage",
			quantityControllerOutlinedLabel: "Quantité",
			termsAndConditionsModalTitle: "Termes et Conditions",
			termsAndConditionsModalCloseAction: "Fermer",
			transactionsLateRefund: "Remboursement tardif",
			transactionsLateRefundFalse: "Non",
			transactionsLateRefundTrue: "Oui",
			transactionLateRefundModalText: "Êtes-vous sûr de vouloir rembourser",
			transactionLateRefundFailedMessage: "Nous sommes désolés, nous n'avons pas pu traiter le remboursement.",
			transactionLateRefundCancelledMessage: "Le remboursement a été annulé !",
			showAddonAvailabilityMessage: "De retour bientôt",
			addonRemovedModalTitle: "Nous avons supprimé certains éléments",
			addonRemovedMessage: "Au fait, nous avons supprimé les éléments suivants :",
			addonRemovedFooterMessage: "Les articles ne sont disponibles qu'à l'achat",
			loyaltyLoginTitle: "Identifiant",
			loyaltyLoginNextAction: "Confirmer",
			loyaltyLoginPreviousAction: "Retourner",
			loyaltyBannerTitle: "GAGNEZ ET PROFITEZ DE VOS RÉCOMPENSES !",
			loyaltyBannerSubtitle: "Êtes-vous notre membre ?",
			loyaltyBannerMember: "MEMBRE:",
			loyaltyBannerLogin: "Se connecter",
			loyaltyBannerLogout: "Se déconnecter",
			loyaltyBannerOffers: "Des offres",
			loyaltyBannerOffersAndDeals: "Offres et offres",
			loyaltyBannerRedeemables: "Échangeables",
			loyaltyOffersTitle: "Offres membres",
			loyaltyOffersPreviousAction: "Dos",
			loyaltyOffersNextAction: "Complète",
			loyaltyLoginCodeTitle: "Entrer le code",
			loyaltyQrLoginCodeTitle: "ou scannez avec votre application",
			bestValueProduct: "Meilleure valeur",
			hotDealProduct: "Offre spéciale",
			loyaltyWelcomeModalTitle: "Bienvenue de retour, {{name}}",
			loyaltyWelcomeModalPoints: "Vous avez {{points}} points",
			loyaltyWelcomeModalConfirm: "OK",
			loyaltyLogOutModalConfirm: "Êtes-vous sûr de vouloir vous déconnecter?",
			loyaltyLoginFailedModalTitle: "Désolé",
			loyaltyLoginFailedModalClose: "Réessayer",
			loyaltyLoginFailedModalContent: "Nous n'avons pas pu vérifier votre code",
			loyaltyLoginOrSkipModalTitle: "Récompenses à votre façon",
			loyaltyLoginOrSkipModalLoginButtonText: "Connexion",
			loyaltyLoginOrSkipModalSkipButtonText: "Passer",
			appDownloadTitle: "Téléchargement de l'application",
			loyaltyMemberSignInButtonText: "Connexion membre",
			loyaltyGuestOrderButtonText: "Commander en tant qu'invité",
			loyaltyOrderHistoryTitle: "Historique des commandes",
			loyaltyReorderTitle: "Réorganiser {{orderDate}}",
			loyaltyReorderViewOrder: "Voir l'ordre",
			loyaltyReorderAddToCart: "Ajouter à la commande",
			loyaltyReorderAddingToCart: "Ajouter...",
			loyaltyReorderCancel: "Fermer",
			appDownloadContent: "Pas encore membre?",
			appDownloadSubContent: "Scannez ce code pour télécharger l'application KFC et vous inscrire",
			appDownloadPreviousAction: "Retour",
			appDownloadNextAction: "Se connecter",
			chooseCustomisations: "Choisissez vos personnalisations",
			taxesFees: "Taxes et frais",
			discount: "rabais",
			chooseProductCustomisations: "personnalisations",
			cartComboModalTitle: "Choisissez la taille du repas",
			cartComboModalSecondaryAction: "Fermer",
			defaultLoadingTitle: "Réchauffer la cuisine",
			defaultLoadingMessage: "S'il vous plaît, attendez"
		}
	},
	jpn: {
		translation: {
			homeTitle: "エクスプレス",
			homeSubtitle: "こちらで注文",
			homePrimaryAction: "テイクアウト",
			homeSecondaryAction: "店内飲食",
			homeConnectivityIssues: "接続に問題が発生しています。回復を試みている間お待ちください。",
			homeTermsAndConditionsBannerWarningTitle: "利用規約",
			homeTermsAndConditionsBannerWarningDescription: "続行すると、",
			homeTermsAndConditionsBannerWarningAdditionalDescription: "利用規約とプライバシーポリシーに同意します",
			adminTitle: "管理者",
			adminGeneralSection: "一般",
			adminSerialKeyField: "シリアルキー",
			adminMenuSection: "メニュー",
			adminOrderingSection: "注文",
			adminOrganisationField: "組織",
			adminStoreField: "ストア",
			adminSiteField: "サイト",
			adminTimezoneField: "タイムゾーン",
			adminVersionField: "バージョン",
			adminEnvironmentField: "環境",
			adminMockFieldFalseText: "いいえ",
			adminMockFieldTrueText: "はい",
			adminPaymentSection: "支払い",
			adminMockField: "モック",
			adminProviderField: "プロバイダー",
			adminPaymentPoiIdField: "POID",
			adminPaymentIpAddressField: "IPアドレス",
			adminPaymentUsbPidField: "USB PID",
			adminPaymentUsbVidField: "USB VID",
			adminPaymentUsbPortField: "USBポート",
			adminLockModal: "ロック画面",
			adminLockModalTitle: "ロック画面オプション",
			adminLockModalClose: "閉じる",
			adminPrimaryLockAction: "ロック画面 - キオスク利用不可",
			adminSecondaryLockAction: "ロック画面 - レストラン閉鎖",
			lockMessage: "キオスクは利用できません。別のキオスクをご利用いただくか、フロントカウンターでご注文ください。",
			lockSecondaryMessage: "レストランは現在閉鎖されています。",
			adminLoginTitle: "管理者パスワードを入力してください",
			adminRefreshAction: "リフレッシュ",
			adminExitAction: "終了",
			adminLoginPrimaryAction: "ログイン",
			adminLoginSecondaryAction: "キャンセル",
			adminLoginErrorPasswordMessage: "パスワードが正しくありません",
			adminTransactionsAction: "取引",
			allergensMessage: "含まれています: {{ allergens }}",
			smsSending: "SMS 送信中",
			smsErrorMessage: "SMS 送信に失敗しました",
			smsErrorDetailsMessage: "提供された番号を確認してください",
			smsMockErrorMessage: "モック応答に失敗しました",
			smsMockSuccessMessage: "モック応答に成功しました",
			smsSuccessTitle: "SMS 送信成功",
			smsSuccessSubtitle: "SMS は受信までに時間がかかる場合があります",
			smsSuccessButton: "続行",
			smsPrimaryAction: "送信",
			smsSecondaryAction: "スキップ",
			smsCountryCodeCannotBeEmpty: "国コードは空にできません",
			smsCountryCodeStartWithZero: "国コードは 0 で始まることはできません",
			smsCountryCodeExceedsMaxLength: "国コードが許容される最大長を超えています",
			smsCountryCodeDoesNotMeetMinimumLength: "国コードが必要な最小長に達していません",
			smsPhoneCannotStartWithZero: "電話番号は '0' で始まることはできません",
			smsPhoneExceedsMaxLength: "電話番号が許容される最大長を超えています",
			smsPhoneDoesNotMeetMinimumLength: "電話番号が必要な最小長に達していません",
			smsTitle: "SMS でレシートを送信",
			smsSubtitle: "電話番号を入力してください",
			receiptDetailsInstruction: "レシートの QR コードをスキャンしてください",
			receiptDetailsInstructionCash: "カウンターでご注文の際にお支払いください",
			receiptDetailsInstructionCard: "受け取り場所からご注文をお持ち帰りください",
			receiptDetailsOrderNumber: "注文番号:",
			receiptDetailsPrimaryAction: "レシート",
			receiptSmsAction: "SMS",
			receiptTermsAndConditionsAction: "利用規約",
			receiptPrimaryAction: "完了",
			receiptDetailsTaxInvoice: "税金請求書",
			receiptDetailsOrderType: "タイプ",
			receiptPaymentRestaurantName: "レストラン",
			receiptPaymentRestaurantAddress: "住所",
			receiptPaymentPhone: "電話",
			receiptPaymentTaxNumber: "ABN",
			receiptPaymentItemQuantity: "アイテム数",
			receiptPaymentTaxTotal: "GST",
			receiptPaymentSubTotal: "小計",
			receiptPaymentTotal: "合計",
			receiptGSTExcludeMessage: "* GST は除外されています",
			receiptPaymentPending: "支払い保留中",
			receiptPaymentKitchenId: "キッチン ID",
			receiptCash: "現金",
			receiptDineIn: "店内飲食",
			receiptTakeaway: "テイクアウト",
			receiptQRCodeOpen: "レシート",
			smsReceiptHeaderText: "KFC からこんにちは",
			smsReceiptOrderNumberText: "注文番号は: {{ orderNumber }}",
			smsReceiptUrlText: "次の場所でレシートを取得: {{ url }}",
			smsReceiptPendingPaymentText: "支払い保留中",
			smsErrorPrimaryAction: "再試行",
			smsErrorSecondaryAction: "続行",
			customerDetailsFullNameLabel: "フルネーム {{ required }}",
			customerDetailsFirstNameLabel: "名前 {{ required }}",
			customerDetailsLastNameLabel: "姓 {{ required }}",
			customerDetailsPhoneNumberLabel: "電話番号 {{ required }}",
			customerDetailsRequired: "(必須)",
			customerDetailsOptional: "(オプション)",
			customerDetailsFormPrimaryAction: "続行",
			customerDetailsFormSecondaryAction: "スキップ",
			customerDetailsInputInvalidError: "{{ label }} が無効です",
			customerDetailsEmailLabel: "メール {{ required }}",
			customerDetailsEmailDescription: "チェックアウト時に利用可能な QR レシート",
			customerDetailsInputRequiredError: "{{ label }} は必須です",
			customerDetailsInputMinimumError: "{{ label }} が必要な最小長を満たしていません",
			customerDetailsProfaneInputError: "もう一度お試しください。この単語は許可されていません",
			customerDetailsSpecialCharactersInputError: "もう一度お試しください。特殊文字は許可されていません",
			customerDetailsCancelOrderAction: "キャンセル",
			receiveEmailAddress: "限定クーポンや最新のオファーについての情報を受け取るためにサインアップします",
			cartNextAction: "支払いへ進む",
			cartTitle: "ご注文",
			cartPleaseSelectProduct: "引き換える関連製品を選択してください",
			cartPreviousAction: "戻る",
			cartEmptyMessage: "カートは空です",
			cartEmptyPrimaryAction: "メニューに戻る",
			cartProductUnavailableGeneral: "このアイテムは現在利用できません",
			cartProductUnavailableAddon: "利用不可",
			cartProductUnavailableItem: "近日中に再入荷",
			cartCancelOrderAction: "キャンセル",
			cartChangeAction: "変更",
			cartRemoveAction: "削除",
			cartProductUnitPriceEach: "{{price}} それぞれ",
			cartUpsellTitle: "ご注文に追加",
			cartUpsellAction: "追加",
			cartUpsellGalleryCardButtonActionText: "追加",
			cartGroupedModalSecondaryAction: "閉じる",
			cartNoInternetLoadingTitle: "接続の問題",
			cartNoInternetLoadingMessage: "接続の問題が発生しています。回復を試みている間お待ちください...",
			cartNoInternetTitle: "申し訳ありませんが、接続に問題が発生しました。",
			cartNoInternetClose: "OK",
			productNextAction: "注文に追加",
			productEditingNextAction: "注文を更新",
			productTitle: "カスタマイズ",
			customisationExtraPriceWarning: "お食事に {{price}} 追加されました",
			customisationPriceEach: "{{price}} それぞれ",
			paymentInstructions: "下のピンパッドの支払い手順に従ってください",
			paymentErrorMessage: "おっと、何か問題が発生しました",
			paymentErrorDetail: "おっと、何か問題が発生しました - ピンパッドが返したメッセージ: {{message}}",
			paymentErrorQRCodeDetail: "おっと、何か問題が発生しました - QR コードの応答が次のとおりです: {{message}}",
			paymentErrorQRCodeMessage: "失敗した支払いのレシートを取得するには QR コードをスキャンしてください",
			paymentStatusCheckMessage: "支払いが成功したかどうかを確認しています",
			paymentStatusSuccessMessage: "お支払いが成功しました、今すぐご注文を承ります",
			paymentRetryMessage: "再試行",
			paymentCancelMessage: "キャンセル",
			paymentOptionsTitle: "支払い方法を選択",
			paymentOptionsSecondaryAction: "戻る",
			paymentOptionsCARDTitle: "カード",
			paymentOptionsCASHTitle: "現金",
			paymentOptionsMOMOPAYTitle: "MOMO",
			paymentOptionsExpressMessage: "エクスプレスチェックアウト",
			paymentNoInternetLoadingTitle: "接続の問題",
			paymentNoInternetLoadingMessage: "接続の問題が発生しています。回復を試みている間お待ちください...",
			paymentNoInternetTitle: "申し訳ありませんが、接続に問題が発生しました。",
			paymentNoInternetClose: "OK",
			paymentFetchingQRCode: "QRコードを取得しています",
			paymentScanQRCode: "MomoアプリでQRコ",
			paymentScanQRCodeMessage: "支払いプロセスは Momo アプリで完了する必要があります。 取引をキャンセルしたい場合はアプリからキャンセルを行ってください。",
			categoryComboModalTitle: "食事サイズを選択",
			categoryPreviousAction: "戻る",
			productCustomisationsAdditionalPriceWarning: "食事に{{price}}追加しました",
			productCustomisationsReadOnlyEach: "{{price}} ごと",
			productCustomisationsReadonlyProductRemoved: "{{name}}なし",
			productCustomisationsUnlimitedMax: "無制限",
			productCancelOrderAction: "キャンセル",
			categoriesTitle: "メニュー",
			categoriesCancelOrderAction: "キャンセル",
			cancelOrderButtonModalQuestion: "本当に注文をキャンセルしますか？",
			cancelOrderButtonModalTitle: "注文をキャンセル",
			cancelOrderButtonModalPrimaryAction: "いいえ",
			cancelOrderButtonModalSecondaryAction: "はい",
			cancelOrderButtonName: "キャンセル",
			categoriesNextAction: "完了",
			categoriesPreviousAction: "戻る",
			customerDetailsTitle: "詳細",
			customerDetailsFormTitle: "注文が準備できたらお名前でお呼びします",
			customerDetailsFormSubTitle: "こちらに入力してください",
			customerDetailsPreviousAction: "戻る",
			customerDetailsNextAction: "続ける",
			beaconTitle: "ビーコン",
			beaconFormHeaderTitle: "ビーコン番号を入力",
			beaconFormHeaderSubtitle: "注文が受け取り可能になると、ビーコンが点滅して通知されます",
			beaconPreviousAction: "戻る",
			beaconAdditionalAction: "キャンセル",
			beaconCancelAction: "キャンセル",
			beaconFormPrimaryAction: "送信",
			beaconFormSecondaryAction: "キャンセル",
			beaconNextAction: "送信",
			beaconInputError: "有効な番号を入力してください",
			couponTitle: "クーポンコード",
			couponPreviousAction: "戻る",
			couponFormHeaderTitle: "クーポンを入力してください:",
			couponFormPrimaryAction: "確認",
			couponFormSecondaryAction: "戻る",
			couponListHeaderTitle: "クーポン",
			couponListAddToCartAction: "カートに追加",
			couponListChangeAction: "変更",
			couponErrorHeaderTitle: "申し訳ありませんが、このクーポンは見つかりませんでした。",
			couponErrorSecondaryAction: "カテゴリに戻る",
			couponErrorPrimaryAction: "再試行",
			couponGroupedModalSecondaryAction: "閉じる",
			couponComboModalTitle: "食事サイズを選択",
			couponComboModalSecondaryAction: "閉じる",
			couponNextAction: "完了",
			composedPreviousAction: "戻る",
			composedEditingNextAction: "注文を更新",
			composedNextAction: "注文に追加",
			composedCancelOrderAction: "キャンセル",
			composedProductLayerTitle: "商品 {{layer}} を選択",
			composedProductFinalTitle: "この商品を選択しました:",
			composedProductFinalCustomise: "選択を確認",
			composedHeaderTitle: "カスタマイズ",
			orderValidationErrorMessage: "おっと、注文を処理しようとしたときに何か問題が発生しました",
			requestTimedOut: "リクエストはタイムアウトしました",
			orderValidationErrorPrimaryAction: "再試行",
			orderValidationErrorSecondaryAction: "キャンセル",
			orderConfirmationErrorMessage: "おっと、何か問題が発生しました",
			orderConfirmationAdditionalMessage: "カードが端末から取り外されていることを確認してください",
			orderConfirmationGenericAdditionalMessage: "選択された支払い方法での支払いが完了していることを確認してください",
			orderConfirmationErrorPrimaryAction: "再試行",
			orderConfirmationErrorSecondaryAction: "キャンセル",
			orderConfirmationLoadingTitle: "厨房に送信中",
			orderWebhookPollingConfirmationLoadingTitle: "厨房で確認中",
			orderConfirmationLoadingMessage: "お待ちください、注文を厨房に送信しています",
			orderWebhookPollingConfirmationLoadingMessage: "お待ちください、注文を厨房で確認しています",
			orderConfirmationLoadingMessageFirstAutoRetry: "お待ちください、注文を厨房に送信するのに少し時間がかかっています。",
			orderConfirmationLoadingMessageSecondAutoRetry: "注文を進めるのに少し遅れが発生しています。",
			orderConfirmationNoInternetLoadingTitle: "接続の問題",
			orderConfirmationNoInternetLoadingMessage: "接続の問題が発生しています。回復を試みている間お待ちください...",
			orderConfirmationNoInternetTitle: "申し訳ありませんが、注文を厨房に送信する際に問題が発生しました。レシートの写真を撮影し、フロントカウンターにお知らせください。",
			orderConfirmationNoInternetDetailsTitle: "詳細",
			orderConfirmationNoInternetDetailsDateTime: "日付",
			orderConfirmationNoInternetDetailsCardNumber: "カード番号",
			orderConfirmationNoInternetClose: "OK",
			orderPostErrorMessage: "おっと、何か問題が発生しました",
			orderPostErrorPrimaryAction: "再試行",
			orderPostErrorSecondaryAction: "キャンセル",
			categoryGroupedModalSecondaryAction: "閉じる",
			categoryComboModalSecondaryAction: "閉じる",
			categoryNextAction: "完了",
			productPreviousAction: "戻る",
			timeoutModalTitle: "まだおられますか？",
			timeoutModalSecondaryAction: "閉じる",
			timeoutModalContentMessage: "{{ timeLeft }}で帰宅します",
			productComboSizeAction: "変更",
			productOptionCardPrimaryAction: "選択を変更",
			productOptionCardSecondaryAction: "カスタマイズ",
			productOptionItemCardSelectedMessage: "お食事に含まれる",
			productOptionsChangeModalCloseAction: "閉じる",
			offerLimitModalTitle: "オファーはすでにカート内に存在します",
			offerLimitConfirmation: "1 回の注文につき 1 つのオファーのみが許可されます。既存のオファーを置き換えますか?",
			orderValidationLoadingTitle: "カートを更新中",
			orderValidationLoadingMessage: "お支払いに進んでいます",
			orderPostLoadingTitle: "注文の完了",
			orderPostLoadingMessage: "お待ちください、注文を完了しています",
			productCustomisationsReadOnlyExtra: "カスタマイズ",
			productCustomisationsProductsMissingError: "{{ productsMissingCount }}アイテムを追加してください",
			productCustomisationsProductsMissingError_plural: "{{ productsMissingCount }}アイテムを追加してください",
			autoRedirectNotificationTitle: "おっと、まだ問題が発生しています。もう試行の余地はありません",
			autoRedirectNotificationAdditionalMessage: "お詫び申し上げます",
			autoRedirectNotificationMessage: "安全な場所に戻しています",
			autoRedirectNotificationButton: "OK",
			upsellModalTitle: "これらを注文に追加しますか？",
			productCustomisationModalHeaderTitle: "カスタマイズ",
			productCustomisationModalAddToCartAction: "注文に追加",
			productCustomisationModalUpdateCartAction: "注文を更新",
			productCustomisationModalCloseAction: "閉じる",
			upsellModalCloseAction: "閉じる",
			productOptionCustomisationModalAddToCartAction: "カートに追加",
			productOptionCustomisationModalUpdateCartAction: "注文を更新",
			productOptionCustomisationModalCloseAction: "閉じる",
			bannerWarningTitle: "お客様の健康と幸福は当社の最優先事項です",
			bannerWarningDescription: "これらの厳格なクリーニングと衛生手順をこれからも継続しています。",
			paymentMethodCard: "カード支払いのみ",
			miniCartNextAction: "完了",
			miniCartCloseAction: "閉じる",
			miniCartCheckoutAction: "チェックアウト",
			miniCartTotal: "合計",
			invalidRouteTitle: "おっと、道に迷ったようです",
			invalidRouteButton: "安全な場所に戻る",
			templateMenuAction: "メニュー",
			templateCancelAction: "キャンセル",
			templateBasketAction: "注文を表示",
			templateCouponAction: "オファーを入力",
			refundGenericInstructions: "返金をお待ちください",
			refundInstructions: "下記のピンパッドで返金をお待ちください",
			refundErrorMessage: "おっと、返金の試みで何か問題が発生しました",
			refundRetryMessage: "再試行",
			refundCancelMessage: "キャンセル",
			refundCancelButton: "OK",
			refundSuccessButton: "OK",
			refundCancelDetails: "詳細",
			refundCancelDateTime: "日付",
			refundCancelCardNumber: "カード番号",
			refundCancelOrderNumber: "注文番号",
			refundSuccessMessage: "返金プロセスが正常に開始されました。有効になるまでの時間は支払い方法に依存します。",
			refundCancelledMessage: "申し訳ありませんが、注文を厨房に送信する際に問題が発生しました。レシートをQRコードから写真に撮り、フロントカウンターにお知らせください。",
			refundSuccessTitle: "返金成功",
			refundLoadingTitle: "返金中",
			menuAction: "メニュー",
			menuPreviousAction: "戻る",
			productCustomisationsRemove: "削除",
			productCustomisationsChange: "変更",
			productCustomisationsResetting: "リセット中...",
			productCustomisationsReset: "リセット",
			productCustomisationsDeselect: "選択を解除します",
			productCustomisationsAdd: "追加",
			productCustomisationsSelect: "選択する",
			warningTitle: "おっと、何か問題が発生したようです",
			warningCancelAction: "キャンセル",
			warningTryAgainAction: "再試行",
			receiptTitle: "ご注文",
			receiptEcoMessage: "紙レス",
			transactionsNavigatorNextAction: "次へ",
			transactionsNavigatorPreviousAction: "前へ",
			transactionsTitle: "取引",
			transactionsIdentityTitle: "アイデンティティ",
			transactionsIdentityId: "セッションID",
			transactionsIdentityStatus: "ステータス",
			transactionsIdentityTimestamp: "日付",
			transactionsIdentityType: "注文タイプ",
			transactionsIdentityMessage: "メッセージ",
			transactionsIdentityOrderReference: "注文参照番号",
			transactionsPaymentTitle: "合計",
			transactionsPaymentType: "支払い方法",
			transactionsPaymentAmount: "カード合計",
			transactionsPaymentAuthCode: "承認コード",
			transactionsPaymentCardNumber: "カード番号",
			transactionsPaymentTransactionId: "取引ID",
			transactionsPaymentOrderTotal: "注文合計",
			transactionsPaymentNoPaymentFound: "選択された支払いなし",
			transactionsPrimaryAction: "戻る",
			transactionsPaymentCardType: "カードの種類",
			transactionsNotFound: "最後の再起動以来の保存された取引はありません",
			quantityControllerOutlinedLabel: "数量",
			defaultLoadingTitle: "厨房の準備中",
			loadingCoupon: "クーポンを検索中",
			defaultLoadingMessage: "お待ちください",
			termsAndConditionsModalTitle: "利用規約",
			termsAndConditionsModalCloseAction: "閉じる",
			ORDER_CONFIRMATION_SUCCESS: "成功",
			ORDER_REFUND_CANCELLED: "払い戻しキャンセル",
			ORDER_CONFIRMATION_ERROR: "エラー",
			ORDER_CANCELLED: "キャンセル済み",
			ORDER_VALIDATION_ERROR: "検証エラー",
			ORDER_REFUND_SUCCESS: "払い戻し成功",
			ORDER_VALIDATION_SUCCESS: "検証成功",
			ORDER_PAYMENT_ERROR: "支払いエラー",
			ORDER_PAYMENT_SUCCESS: "支払い成功",
			ORDER_REFUND_ERROR: "払い戻しエラー",
			ORDER_POST_SUCCESS: "成功",
			ORDER_POST_ERROR: "エラー",
			transactionsLateRefund: "遅延払い戻し",
			transactionsLateRefundFalse: "いいえ",
			transactionsLateRefundTrue: "はい",
			transactionLateRefundModalText: "本当に払い戻しを行いますか",
			transactionLateRefundFailedMessage: "申し訳ありませんが、払い戻しを処理できませんでした。",
			transactionLateRefundCancelledMessage: "払い戻しがキャンセルされました！",
			showAddonAvailabilityMessage: "近日中に再開",
			addonRemovedModalTitle: "一部のアイテムが削除されました",
			addonRemovedMessage: "ちなみに、以下が削除されました:",
			addonRemovedFooterMessage: "アイテムは購入時にのみ利用可能です",
			loyaltyOffersTitle: "会員オファー",
			loyaltyOffersPreviousAction: "戻る",
			loyaltyOffersNextAction: "完了",
			loyaltyLoginTitle: "会員ログイン",
			loyaltyLoginNextAction: "確認",
			loyaltyLoginPreviousAction: "戻る",
			loyaltyBannerTitle: "リワードを獲得して楽しむ!",
			loyaltyBannerSubtitle: "当社のメンバーですか？",
			loyaltyBannerMember: "メンバー:",
			loyaltyBannerLogin: "ログイン",
			loyaltyBannerLogout: "ログアウト",
			loyaltyBannerOffers: "オファー",
			loyaltyBannerOffersAndDeals: "オファーとセール",
			loyaltyBannerRedeemables: "引き換え可能品",
			loyaltyLoginCodeTitle: "コードを入力してください",
			loyaltyQrLoginCodeTitle: "またはアプリでスキャンする",
			bestValueProduct: "お買い得",
			hotDealProduct: "ホットディール",
			loyaltyWelcomeModalTitle: "おかえりなさい、{{name}}",
			loyaltyWelcomeModalPoints: "あなたは{{points}}ポイントを持っています",
			loyaltyWelcomeModalConfirm: "OK",
			loyaltyLoginFailedModalTitle: "申し訳ありません",
			loyaltyLoginFailedModalClose: "再試行",
			loyaltyLoginFailedModalContent: "コードを確認できませんでした",
			loyaltyLoginOrSkipModalTitle: "あなたの方法でリワード",
			loyaltyLoginOrSkipModalLoginButtonText: "ログイン",
			loyaltyLoginOrSkipModalSkipButtonText: "スキップ",
			loyaltyMemberSignInButtonText: "会員ログイン",
			loyaltyGuestOrderButtonText: "ゲストとして注文",
			loyaltyLogOutModalConfirm: "ログアウトしてもよろしいですか？",
			loyaltyOrderHistoryTitle: "注文履歴",
			loyaltyReorderTitle: "再注文 {{orderDate}}",
			loyaltyReorderViewOrder: "表示の順序",
			loyaltyReorderAddToCart: "注文に追加",
			loyaltyReorderAddingToCart: "追加中...",
			loyaltyReorderCancel: "近い",
			appDownloadTitle: "アプリダウンロード",
			appDownloadContent: "メンバーではありませんか？",
			appDownloadSubContent: "このコードをスキャンしてKFCアプリをダウンロードし、サインアップしてください",
			appDownloadPreviousAction: "戻る",
			appDownloadNextAction: "サインイン",
			chooseCustomisations: "カスタマイズを選択してください",
			taxesFees: "税金と手数料",
			discount: "割引",
			chooseProductCustomisations: "カスタマイズ",
			cartComboModalTitle: "食事のサイズを選択",
			cartComboModalSecondaryAction: "近い"
		}
	}
};
var mockSettings = {
	languages: languages
};

var unionLanguages = function unionLanguages(_ref) {
  var _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$customSettings = _ref.customSettings,
    customSettings = _ref$customSettings === void 0 ? {} : _ref$customSettings;
  var keys = Object.keys(settings);
  var merged = keys.reduce(function (result, lang) {
    var _settings$lang, _customSettings$lang, _extends2;
    return _extends({}, result, (_extends2 = {}, _extends2[lang] = {
      translation: _extends({}, (_settings$lang = settings[lang]) == null ? void 0 : _settings$lang.translation, (_customSettings$lang = customSettings[lang]) == null ? void 0 : _customSettings$lang.translation)
    }, _extends2));
  }, {});
  return {
    languages: _extends({}, merged)
  };
};
var resolveI18n = function resolveI18n(_ref2) {
  var settings = _ref2.settings,
    serial = _ref2.serial,
    _ref2$overwriteSettin = _ref2.overwriteSettings,
    overwriteSettings = _ref2$overwriteSettin === void 0 ? {} : _ref2$overwriteSettin;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(next) {
      var _settings$settings, _settings$settings$la, isOverwrited, mergedLanguages, mergedSettings, languages, i18nConfig;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            try {
              // TODO: Resolve from settings once new translations
              // get ported to KAS.
              isOverwrited = !!Object.keys(overwriteSettings).length;
              mergedLanguages = unionLanguages({
                settings: _extends({}, mockSettings.languages),
                customSettings: _extends({}, overwriteSettings.languages)
              });
              mergedSettings = isOverwrited ? _extends({}, mockSettings, {
                languages: _extends({}, mockSettings.languages, mergedLanguages.languages, {
                  "default": settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$la = _settings$settings.languages) == null ? void 0 : _settings$settings$la["default"]
                })
              }) : mockSettings;
              languages = mergedSettings.languages;
              i18nConfig = {
                resources: languages,
                lng: 'en',
                keySeparator: false,
                interpolation: {
                  escapeValue: false // react already safes from xss
                }
              };
              i18n.use(reactI18next.initReactI18next).init(i18nConfig);
              next(null, {
                serial: serial,
                settings: _extends({}, settings, {
                  settings: _extends({}, settings.settings, mergedSettings)
                })
              });
            } catch (error) {
              next(error);
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var validation = function validation(_ref) {
  var handler = _ref.handler,
    callback = _ref.callback;
  if (!handler) throw new Error('No `handler` passed into a command handler');
  if (!callback) throw new Error('No `callback` passed into a command handler');
};

// callback is a function that sends a response to a `client-${serial}` event
// payload is optional data that gets sent with the command

var handleReboot = function handleReboot(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$handler = _ref2.handler,
    handler = _ref2$handler === void 0 ? null : _ref2$handler,
    _ref2$callback = _ref2.callback,
    callback = _ref2$callback === void 0 ? null : _ref2$callback;
  return function (payload) {
    validation({
      handler: handler,
      callback: callback
    });
    handler();
  };
};
var handleScreenshot = function handleScreenshot(_temp2) {
  var _ref3 = _temp2 === void 0 ? {} : _temp2,
    _ref3$handler = _ref3.handler,
    handler = _ref3$handler === void 0 ? null : _ref3$handler,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? null : _ref3$callback;
  return function (payload) {
    validation({
      handler: handler,
      callback: callback
    });
    var image = handler();
    callback(image.toDataURL());
  };
};
var handleLock = function handleLock(_temp3) {
  var _ref4 = _temp3 === void 0 ? {} : _temp3,
    _ref4$handler = _ref4.handler,
    handler = _ref4$handler === void 0 ? null : _ref4$handler,
    _ref4$callback = _ref4.callback,
    callback = _ref4$callback === void 0 ? null : _ref4$callback;
  return function (payload) {
    validation({
      handler: handler,
      callback: callback
    });
    handler(payload);
  };
};
var handleUnlock = function handleUnlock(_temp4) {
  var _ref5 = _temp4 === void 0 ? {} : _temp4,
    _ref5$handler = _ref5.handler,
    handler = _ref5$handler === void 0 ? null : _ref5$handler,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? null : _ref5$callback;
  return function (payload) {
    validation({
      handler: handler,
      callback: callback
    });
    handler();
  };
};
var handleReload = function handleReload(_temp5) {
  var _ref6 = _temp5 === void 0 ? {} : _temp5,
    _ref6$handler = _ref6.handler,
    handler = _ref6$handler === void 0 ? null : _ref6$handler,
    _ref6$callback = _ref6.callback,
    callback = _ref6$callback === void 0 ? null : _ref6$callback;
  return function (payload) {
    validation({
      handler: handler,
      callback: callback
    });
    handler();
  };
};
var handleSyncMenu = function handleSyncMenu(_temp6) {
  var _ref7 = _temp6 === void 0 ? {} : _temp6,
    _ref7$handler = _ref7.handler,
    handler = _ref7$handler === void 0 ? null : _ref7$handler,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? null : _ref7$callback;
  return function (payload) {
    validation({
      handler: handler,
      callback: callback
    });
    handler();
  };
};

var pusher = /*#__PURE__*/new Pusher(process.env.POI_APP_PUSHER_ID, {
  cluster: 'ap1'
});
var resolveCommands = function resolveCommands(_ref) {
  var lock = _ref.lock,
    unlock = _ref.unlock,
    reboot = _ref.reboot,
    screenshot = _ref.screenshot,
    serial = _ref.serial,
    reload = _ref.reload,
    syncMenu = _ref.syncMenu;
  return function (next) {
    try {
      var channel = pusher.subscribe("" + serial);
      var callback = function callback(payload) {
        // Client event for receiving callback data
        channel.trigger("client-" + serial, payload);
      };

      // All channel events and handlers
      var events = [{
        name: 'REBOOT',
        handler: handleReboot({
          handler: reboot,
          callback: callback
        })
      }, {
        name: 'SCREENSHOT',
        handler: handleScreenshot({
          handler: screenshot,
          callback: callback
        })
      }, {
        name: 'LOCK',
        handler: handleLock({
          handler: lock,
          callback: callback
        })
      }, {
        name: 'UNLOCK',
        handler: handleUnlock({
          handler: unlock,
          callback: callback
        })
      }, {
        name: 'RELOAD',
        handler: handleReload({
          handler: reload,
          callback: callback
        })
      }, {
        name: 'SYNC_MENU',
        handler: handleSyncMenu({
          handler: syncMenu,
          callback: callback
        })
      }];
      events.forEach(function (e) {
        return channel.bind(e.name, e.handler);
      });
      next(null);
    } catch (error) {
      next(error);
    }
  };
};

var HEALTH_LOG_TAG = '[Health] ';
var setupPingHealthService = function setupPingHealthService(_ref) {
  var serial = _ref.serial,
    settings = _ref.settings;
  var INTERVAL = process.env.POI_APP_HEALTH_TASKS_INTERVAL || 120;
  setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return health.pingHealthService({
            serial: serial,
            settings: settings
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), INTERVAL * 1000);
};
var setupCheckOnlineStatus = function setupCheckOnlineStatus(_ref3) {
  var setOnlineStatus = _ref3.setOnlineStatus,
    serial = _ref3.serial;
  var INTERVAL = process.env.POI_APP_CHECK_ONLINE_STATUS_INTERVAL || 5;
  var MAX_NUMBER_OF_ATTEMPTS = process.env.POI_APP_CHECK_ONLINE_STATUS_MAX_ATTEMPTS || 10;
  var run = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var isOnline;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return health.checkOnlineStatus();
          case 2:
            isOnline = _context2.sent;
            setOnlineStatus(function (currentOnlineStatus) {
              var isInlineTimedOut = !isOnline ? (currentOnlineStatus == null ? void 0 : currentOnlineStatus.numberOfAttempts) >= MAX_NUMBER_OF_ATTEMPTS : false;
              var numberOfAttempts = !isOnline ? (currentOnlineStatus == null ? void 0 : currentOnlineStatus.numberOfAttempts) + 1 : 0;
              if (isOnline !== currentOnlineStatus.isOnline || isInlineTimedOut !== currentOnlineStatus.isInlineTimedOut || numberOfAttempts !== currentOnlineStatus.numberOfAttempts) {
                // first offline detected from an online status, log error
                if (!isOnline && numberOfAttempts <= 1) {
                  logger.error(HEALTH_LOG_TAG + " - " + serial + " - is offline");
                }
                if (isOnline) {
                  logger.info(HEALTH_LOG_TAG + " - " + serial + " - is online");
                }
                return {
                  isOnline: isOnline,
                  isInlineTimedOut: isInlineTimedOut,
                  numberOfAttempts: numberOfAttempts
                };
              }

              // skip update if nothing changed (e.g "yep, still online ...")
              return currentOnlineStatus;
            });
            setTimeout(run, INTERVAL * 1000);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function run() {
      return _ref4.apply(this, arguments);
    };
  }();
  setTimeout(run, INTERVAL * 1000);
};
var setupReportKioskVersion = function setupReportKioskVersion(_ref5) {
  var serial = _ref5.serial,
    settings = _ref5.settings;
  return health.reportKioskVersion({
    serial: serial,
    settings: settings
  })["catch"](function (err) {
    return logger.error("setupReportKioskVersion() - error:", JSON.stringify(err, Object.getOwnPropertyNames(err)));
  });
};
var resolveMonitoring = function resolveMonitoring(_ref6) {
  var serial = _ref6.serial,
    setOnlineStatus = _ref6.setOnlineStatus;
  return function (_ref7, next) {
    var settings = _ref7.settings;
    setupPingHealthService({
      settings: settings,
      serial: serial
    });
    setupCheckOnlineStatus({
      setOnlineStatus: setOnlineStatus,
      serial: serial
    });
    setupReportKioskVersion({
      serial: serial,
      settings: settings
    });
    next(null, {
      serial: serial,
      settings: settings
    });
  };
};

var isProduction = process.env.POI_APP_ENV === 'prd' || process.env.POI_APP_ENV === 'canary';
var isUat = process.env.POI_APP_ENV === 'uat';
var blockClick = function blockClick(event) {
  event.preventDefault();
  event.stopPropagation();
  return false;
};
var blockRightClick = function blockRightClick() {
  var shouldBlock = isProduction || isUat;
  if (shouldBlock) window.oncontextmenu = blockClick;
};

var resolveEnvironment = function resolveEnvironment(args, next) {
  blockRightClick();
  next(null, args);
};

var INTERVAL = 60 * 1000;
var checkRebootTimes = function checkRebootTimes(_ref) {
  var _settings$settings, _settings$settings$in, _settings$settings$in2;
  var settings = _ref.settings,
    callback = _ref.callback;
  var _ref2 = settings || {},
    timezone = _ref2.timezone;
  var currentTime = dateFns.format(dateFnsTz.utcToZonedTime(new Date(), timezone), 'HH:mm');
  var rebootTimes = (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$in = _settings$settings.interval) == null ? void 0 : (_settings$settings$in2 = _settings$settings$in.restart) == null ? void 0 : _settings$settings$in2.times) || [];
  rebootTimes.forEach(function (time) {
    if (time === currentTime) callback(true);
  });
};
var setup = function setup(_ref3) {
  var settings = _ref3.settings,
    callback = _ref3.callback;
  var run = function run() {
    try {
      checkRebootTimes({
        settings: settings,
        callback: callback
      });
    } catch (err) {
      logger.error('components - reboot - error in setup:', err);
    }
  };
  setInterval(run, INTERVAL);
};
var resolveReboots = function resolveReboots(_ref4) {
  var setShouldReboot = _ref4.setShouldReboot;
  return function (_ref5, next) {
    var settings = _ref5.settings;
    setup({
      settings: settings,
      callback: setShouldReboot
    });
    next(null, {
      settings: settings
    });
  };
};

var useMenuScheduler = function useMenuScheduler(_ref) {
  var _settings$settings, _settings$settings$in;
  var settings$1 = _ref.settings;
  var currentMenuId = recoil.useRecoilValue(atoms.currentMenuIdState);
  var _useRecoilState = recoil.useRecoilState(atoms.menuIdState),
    menuId = _useRecoilState[0],
    setMenuId = _useRecoilState[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.secondaryProductsState),
    secondaryProducts = _useRecoilState2[0],
    setSecondaryProducts = _useRecoilState2[1];
  var _useRecoilState3 = recoil.useRecoilState(atoms.syncMenuState),
    isSyncMenuStateCalled = _useRecoilState3[0];
  var setSecondaryCategories = recoil.useSetRecoilState(atoms.secondaryCategoriesState);
  var setSecondaryPromotions = recoil.useSetRecoilState(atoms.secondaryPromotionalState);
  var _ref2 = (settings$1 == null ? void 0 : (_settings$settings = settings$1.settings) == null ? void 0 : (_settings$settings$in = _settings$settings.interval) == null ? void 0 : _settings$settings$in.refresh) || {},
    _ref2$menu = _ref2.menu,
    menu = _ref2$menu === void 0 ? 60 : _ref2$menu;
  var _ref3 = settings$1 || {},
    serial = _ref3.serial;
  var menuRefreshInterval = menu * 60 * 1000;
  var setValues = React.useCallback(function (_ref4) {
    var resolvedCategories = _ref4.resolvedCategories,
      resolvedProducts = _ref4.resolvedProducts,
      resolvedPromotions = _ref4.resolvedPromotions,
      newMenuId = _ref4.newMenuId;
    var productsToHydrate = [].concat(resolvedProducts);
    var productHydration = hydrate.createHydrater({
      items: resolvedProducts
    });
    var hydratedProducts = productsToHydrate.map(function (_ref5) {
      var productId = _ref5.productId;
      return productHydration({
        id: productId
      });
    }).filter(filterByVisibilityFlag);
    setSecondaryProducts(hydratedProducts);
    setSecondaryCategories(resolvedCategories);
    setSecondaryPromotions(resolvedPromotions);
    setMenuId(newMenuId);
  }, [setSecondaryProducts, setSecondaryCategories, setSecondaryPromotions, setMenuId]);
  var syncMenu = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$settingsResolv, count, resolvedSettings, _ref7, _ref7$menuId, newMenuId, _ref8, timestamp, seconds, lastMenuSync, now, timeDifference, _yield$Promise$all, resolvedProducts, resolvedCategories, resolvedPromotions;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return settings.settingsResolve(serial);
        case 2:
          _yield$settingsResolv = _context.sent;
          count = _yield$settingsResolv.count;
          resolvedSettings = _yield$settingsResolv.settings;
          _ref7 = resolvedSettings || {}, _ref7$menuId = _ref7.menuId, newMenuId = _ref7$menuId === void 0 ? '' : _ref7$menuId;
          _ref8 = count || {}, timestamp = _ref8.timestamp;
          seconds = timestamp._seconds;
          lastMenuSync = new Date(seconds * 1000);
          now = new Date();
          timeDifference = dateFns.differenceInMinutes(now, lastMenuSync);
          logger.debug('cringer.components - menu scheduler checking for menu updates');
          if (!(!newMenuId || !count && !isSyncMenuStateCalled)) {
            _context.next = 15;
            break;
          }
          logger.debug('cringer.components - menu scheduler no menu found. aborting...');
          return _context.abrupt("return");
        case 15:
          if (!(secondaryProducts && menuId === newMenuId && !isSyncMenuStateCalled)) {
            _context.next = 18;
            break;
          }
          logger.debug('cringer.components - menu scheduler new menu already downloaded. awaiting to get to home screen...');
          return _context.abrupt("return");
        case 18:
          if (!(newMenuId === currentMenuId || timeDifference < 5 && !isSyncMenuStateCalled)) {
            _context.next = 21;
            break;
          }
          logger.debug('cringer.components - menu id did not change or menu updated just recently...');
          return _context.abrupt("return");
        case 21:
          if (!isSyncMenuStateCalled) {
            _context.next = 25;
            break;
          }
          logger.debug("cringer.components - menu scheduler new menu(" + newMenuId + ") found. reloading...");
          window.location.reload();
          return _context.abrupt("return");
        case 25:
          _context.next = 27;
          return Promise.all([
          // changed from using `settings` to `resolvedSettings` so it uses the latest menu id
          restaurant.getProductsRequest(count, resolvedSettings), restaurant.getCategoriesRequest(resolvedSettings), restaurant.getPromotionalRequest(count, resolvedSettings)]);
        case 27:
          _yield$Promise$all = _context.sent;
          resolvedProducts = _yield$Promise$all[0];
          resolvedCategories = _yield$Promise$all[1];
          resolvedPromotions = _yield$Promise$all[2];
          logger.debug('cringer.components - menu resolve, updating products, categories and promotions...');
          setValues({
            resolvedCategories: resolvedCategories,
            resolvedProducts: resolvedProducts,
            resolvedPromotions: resolvedPromotions,
            newMenuId: newMenuId
          });
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [currentMenuId, serial, setValues, secondaryProducts, menuId, isSyncMenuStateCalled]);
  React.useEffect(function () {
    if (isSyncMenuStateCalled) {
      return logger.debug('cringer.components - pusher sync enabled. not initializating the menu scheduler. aborting...');
    }
    var interval = setInterval(function () {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              syncMenu();
              _context2.next = 8;
              break;
            case 4:
              _context2.prev = 4;
              _context2.t0 = _context2["catch"](0);
              logger.debug('cringer.components - menu scheduler no menu found. aborting...');
              return _context2.abrupt("return");
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 4]]);
      }))();
    }, menuRefreshInterval);
    return function () {
      return clearInterval(interval);
    };
  }, [currentMenuId, menuRefreshInterval, serial, setValues, settings$1, secondaryProducts, menuId, syncMenu, isSyncMenuStateCalled]);
  return {
    syncMenu: syncMenu
  };
};

var INTERVAL$1 = 60 * 1000;
var checkReloadSchedule = function checkReloadSchedule(_ref) {
  var _settings$settings, _settings$settings$in, _settings$settings$in2;
  var settings = _ref.settings,
    lastReloadDate = _ref.lastReloadDate,
    callback = _ref.callback;
  var refreshAppInterval = (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$in = _settings$settings.interval) == null ? void 0 : (_settings$settings$in2 = _settings$settings$in.refresh) == null ? void 0 : _settings$settings$in2.app) || 60;
  var currentDate = new Date();
  var lastReloadInMinutes = dateFns.differenceInMinutes(currentDate, lastReloadDate);
  if (lastReloadInMinutes >= refreshAppInterval) {
    callback({
      shouldReload: true,
      lastReloadDate: currentDate
    });
  }
};
var setup$1 = function setup(_ref2) {
  var settings = _ref2.settings,
    lastReloadDate = _ref2.lastReloadDate,
    callback = _ref2.callback;
  var run = function run() {
    try {
      checkReloadSchedule({
        settings: settings,
        lastReloadDate: lastReloadDate,
        callback: callback
      });
    } catch (err) {
      logger.error('components - reload - setup - error:', err);
    }
  };
  setInterval(run, INTERVAL$1);
};
var resolveReload = function resolveReload(_ref3) {
  var setReloadState = _ref3.setReloadState,
    lastReloadDate = _ref3.lastReloadDate;
  return function (_ref4, next) {
    var settings = _ref4.settings;
    setup$1({
      settings: settings,
      lastReloadDate: lastReloadDate,
      callback: setReloadState
    });
    next(null, {
      settings: settings
    });
  };
};

var useSecondaryResolver = function useSecondaryResolver() {
  var _useRootViewContext = useRootViewContext(),
    settings = _useRootViewContext.settings,
    setSettings = _useRootViewContext.setSettings,
    serial = _useRootViewContext.serial,
    _useRootViewContext$o = _useRootViewContext.overwriteSettings,
    overwriteSettings = _useRootViewContext$o === void 0 ? {} : _useRootViewContext$o;
  var _loadingService = loadingService({
      initial: 'idle'
    }),
    loadingMachine = _loadingService.loadingMachine;
  var _useMachine = react.useMachine(loadingMachine),
    state = _useMachine[0],
    send = _useMachine[1];
  var setShouldReboot = recoil.useSetRecoilState(atoms.rebootState);
  var _useRecoilState = recoil.useRecoilState(atoms.reloadState),
    reloadStateValue = _useRecoilState[0],
    setReloadState = _useRecoilState[1];
  var _ref = reloadStateValue || {},
    lastReloadDate = _ref.lastReloadDate;
  var setOnlineStatus = recoil.useSetRecoilState(atoms.onlineStatusState);
  var _useSystem = useSystem(),
    lock = _useSystem.lock,
    reboot = _useSystem.reboot,
    screenshot = _useSystem.screenshot,
    unlock = _useSystem.unlock,
    reload = _useSystem.reload,
    syncMenu = _useSystem.syncMenu;
  useMenuScheduler({
    settings: settings
  });
  React.useEffect(function () {
    if (!(state != null && state.matches('idle'))) return;
    send('START');
    (function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(send) {
        var _yield$flow, resolvedSettings;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return flow([resolveCommands({
                lock: lock,
                unlock: unlock,
                reboot: reboot,
                screenshot: screenshot,
                serial: serial,
                reload: reload,
                syncMenu: syncMenu
              }), resolveI18n({
                settings: settings,
                overwriteSettings: overwriteSettings
              }), resolveMonitoring({
                serial: serial,
                setOnlineStatus: setOnlineStatus
              }), resolveEnvironment, resolveReboots({
                setShouldReboot: setShouldReboot
              }), resolveReload({
                setReloadState: setReloadState,
                lastReloadDate: lastReloadDate
              })]);
            case 3:
              _yield$flow = _context.sent;
              resolvedSettings = _yield$flow.settings;
              setSettings(resolvedSettings);
              send('SUCCESS');
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              send('FAILURE', {
                message: _context.t0
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })()(send);
  }, [send, state, settings, setSettings, lock, unlock, reboot, screenshot, serial, setShouldReboot, overwriteSettings, reload, setReloadState, lastReloadDate, setOnlineStatus, syncMenu]);
  var retry = function retry() {
    send('RESET');
  };
  return {
    state: state,
    retry: retry
  };
};

var SecondaryResolverView = function SecondaryResolverView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$Loading = _ref.Loading,
    Loading$1 = _ref$Loading === void 0 ? Loading : _ref$Loading,
    _ref$Alert = _ref.Alert,
    Alert$1 = _ref$Alert === void 0 ? Alert : _ref$Alert,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _useSecondaryResolver = useSecondaryResolver(),
    state = _useSecondaryResolver.state,
    retry = _useSecondaryResolver.retry;
  return /*#__PURE__*/jsxRuntime.jsxs(React.Fragment, {
    children: [(state == null ? void 0 : state.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center h-screen p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert$1, {
        type: "danger",
        retry: retry,
        message: state.context.message
      })
    }), (state == null ? void 0 : state.matches('loading')) && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center h-screen",
      children: /*#__PURE__*/jsxRuntime.jsx(Loading$1, {
        isFirstLoad: true
      })
    }), (state == null ? void 0 : state.matches('success')) && children]
  });
};

var packageJson = /*#__PURE__*/require(' ../../../package.json');
var Sentry = /*#__PURE__*/require('@sentry/react');

/* global globalThis */
globalThis.logger = globalThis.logger || /*#__PURE__*/new logger$1.FallbackLogger();
var version = packageJson.version;
var initializeSentry = function initializeSentry() {
  try {
    if (!process.env.POI_APP_SENTRY_ORG || !process.env.POI_APP_SENTRY_PROJECT) {
      logger.error('Required env vars are not defined to initialize Sentry');
      return;
    }
    Sentry.init({
      dsn: "https://" + process.env.POI_APP_SENTRY_ORG + ".ingest.us.sentry.io/" + process.env.POI_APP_SENTRY_PROJECT,
      release: version,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampler: function tracesSampler(_ref) {
        var name = _ref.name,
          parentSampled = _ref.parentSampled;
        if (name.startsWith('healthcheck')) {
          return 0;
        }
        if (name.startsWith('[auth]')) {
          return 1;
        }
        if (name.startsWith('comment')) {
          return 0.01;
        }
        if (typeof parentSampled === 'boolean') {
          return parentSampled;
        }
        return 0.5;
      },
      tracesSampleRate: parseFloat(process.env.POI_APP_SENTRY_ENVIRONMENT === 'development' ? 0.8 : 0.2),
      environment: process.env.POI_APP_SENTRY_ENVIRONMENT,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
    logger.debug('Sentry initialized successfully');
  } catch (error) {
    logger.error('Failed to initialize Sentry:', error.message);
  }
};
var setUpSentryTags = function setUpSentryTags(settings) {
  var _settings$settings, _settings$settings$pr, _settings$settings2, _settings$settings2$p;
  Sentry.setTag('serial', settings == null ? void 0 : settings.serial);
  Sentry.setTag('organisation', settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$pr = _settings$settings.properties) == null ? void 0 : _settings$settings$pr.organisation);
  Sentry.setTag('storeId', settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$p = _settings$settings2.properties) == null ? void 0 : _settings$settings2$p.storeId);
};

var _loadingService = /*#__PURE__*/loadingService(),
  loadingMachine = _loadingService.loadingMachine;
var RootViewContext = /*#__PURE__*/React.createContext();
var RootViewProvider = function RootViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$resolve = _ref.resolve,
    resolve = _ref$resolve === void 0 ? true : _ref$resolve,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$resetHandler = _ref.resetHandler,
    resetHandler = _ref$resetHandler === void 0 ? null : _ref$resetHandler,
    _ref$ErrorComponent = _ref.ErrorComponent,
    ErrorComponent = _ref$ErrorComponent === void 0 ? Warning : _ref$ErrorComponent,
    _ref$overwriteSetting = _ref.overwriteSettings,
    overwriteSettings = _ref$overwriteSetting === void 0 ? {} : _ref$overwriteSetting,
    _ref$resolverProps = _ref.resolverProps,
    resolverProps = _ref$resolverProps === void 0 ? {} : _ref$resolverProps,
    _ref$retryTime = _ref.retryTime,
    retryTime = _ref$retryTime === void 0 ? 30 : _ref$retryTime;
  logger.debug('cringer.components rendering application...');

  // Wrap in secondary `Provider` to allow the use of `useRecoilState`
  var Provider = function Provider(_ref2) {
    var _settings$settings, _settings$settings$si, _settings$settings2, _settings$settings2$s;
    var _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children,
      _ref2$resetHandler = _ref2.resetHandler,
      resetHandler = _ref2$resetHandler === void 0 ? null : _ref2$resetHandler,
      _ref2$ErrorComponent = _ref2.ErrorComponent,
      ErrorComponent = _ref2$ErrorComponent === void 0 ? function () {} : _ref2$ErrorComponent,
      _ref2$overwriteSettin = _ref2.overwriteSettings,
      overwriteSettings = _ref2$overwriteSettin === void 0 ? {} : _ref2$overwriteSettin;
    var _useMachine = react.useMachine(loadingMachine),
      state = _useMachine[0],
      send = _useMachine[1];
    var _useRecoilState = recoil.useRecoilState(atoms.countState),
      count = _useRecoilState[0],
      setCount = _useRecoilState[1];
    var _useRecoilState2 = recoil.useRecoilState(atoms.serialState),
      serial = _useRecoilState2[0],
      setSerial = _useRecoilState2[1];
    var _useRecoilState3 = recoil.useRecoilState(atoms.systemState),
      system = _useRecoilState3[0],
      setSystem = _useRecoilState3[1];
    var _useRecoilState4 = recoil.useRecoilState(atoms.settingsState),
      settings = _useRecoilState4[0],
      setSettings = _useRecoilState4[1];
    var _useRecoilState5 = recoil.useRecoilState(atoms.paymentState),
      payment = _useRecoilState5[0],
      setPayment = _useRecoilState5[1];
    var _useRecoilState6 = recoil.useRecoilState(atoms.transactionsState),
      transactions = _useRecoilState6[0],
      setTransactions = _useRecoilState6[1];
    var setCurrentMenuId = recoil.useSetRecoilState(atoms.currentMenuIdState);
    var setMenuId = recoil.useSetRecoilState(atoms.menuIdState);
    var history = reactRouterDom.useHistory();
    var ldClient = launchdarklyReactClientSdk.useLDClient();
    var _lockService = lockService(),
      lockMachine = _lockService.lockMachine;
    var _useMachine2 = react.useMachine(lockMachine),
      lockMachineState = _useMachine2[0],
      lockMachineSend = _useMachine2[1];
    jitsu.useRouteTracker();
    var available = {
      resolve: resolve,
      send: send,
      state: state,
      count: count,
      setCount: setCount,
      serial: serial,
      setSerial: setSerial,
      system: system,
      setSystem: setSystem,
      settings: settings,
      overwriteSettings: overwriteSettings,
      setSettings: setSettings,
      payment: payment,
      setPayment: setPayment,
      transactions: transactions,
      setTransactions: setTransactions,
      setCurrentMenuId: setCurrentMenuId,
      setMenuId: setMenuId,
      lockMachineState: lockMachineState,
      lockMachineSend: lockMachineSend,
      resolverProps: resolverProps,
      retryTime: retryTime
    };
    var onError = resetHandler ? resetHandler : function () {
      var _payment$info;
      if (payment != null && (_payment$info = payment.info) != null && _payment$info.transactionId) {
        return history.push('/refund');
      }
      return history.push('/reset');
    };
    logger.updateAdditionalFields({
      fields: {
        serial: settings == null ? void 0 : settings.serial,
        storeName: settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$si = _settings$settings.site) == null ? void 0 : _settings$settings$si.name,
        storeId: settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$s = _settings$settings2.site) == null ? void 0 : _settings$settings2$s.storeId,
        kioskName: settings == null ? void 0 : settings.name
      }
    });
    React.useEffect(function () {
      if (!!settings) {
        setUpSentryTags(settings);
      }
      if (!!settings && !!ldClient && typeof (ldClient == null ? void 0 : ldClient.identify) === 'function') {
        var _settings$settings3 = settings.settings,
          configuration = _settings$settings3 === void 0 ? {} : _settings$settings3,
          _settings$serial = settings.serial,
          _serial = _settings$serial === void 0 ? '' : _settings$serial;
        var _configuration$proper = configuration.properties,
          _configuration$proper2 = _configuration$proper.organisation,
          organisation = _configuration$proper2 === void 0 ? '' : _configuration$proper2,
          _configuration$proper3 = _configuration$proper.storeId,
          storeId = _configuration$proper3 === void 0 ? '' : _configuration$proper3;
        ldClient.identify({
          kind: 'multi',
          organisation: {
            key: organisation
          },
          store: {
            key: storeId
          },
          kiosk: {
            key: _serial
          }
        });
      }
    }, [settings, ldClient]);
    return /*#__PURE__*/jsxRuntime.jsxs(reactErrorBoundary.ErrorBoundary, {
      onError: onError,
      FallbackComponent: ErrorComponent,
      children: [/*#__PURE__*/jsxRuntime.jsx(EnvironmentBadge, {
        settings: settings
      }), /*#__PURE__*/jsxRuntime.jsx(RootViewContext.Provider, {
        value: available,
        children: children
      })]
    });
  };
  return /*#__PURE__*/jsxRuntime.jsx(recoil.RecoilRoot, {
    children: /*#__PURE__*/jsxRuntime.jsx(Provider, {
      resetHandler: resetHandler,
      ErrorComponent: ErrorComponent,
      overwriteSettings: overwriteSettings,
      children: /*#__PURE__*/jsxRuntime.jsx(PrimaryResolverView, _extends({}, resolverProps, {
        children: /*#__PURE__*/jsxRuntime.jsx(SecondaryResolverView, _extends({}, resolverProps, {
          children: children
        }))
      }))
    })
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRootViewContext = function useRootViewContext() {
  var context = React.useContext(RootViewContext);
  if (context === undefined) {
    throw new Error('useRootViewContext must be used within a RootViewProvider');
  }
  return context;
};

var createHandlers = function createHandlers(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    _ref$port = _ref.port,
    port = _ref$port === void 0 ? null : _ref$port,
    _ref$history = _ref.history,
    history = _ref$history === void 0 ? null : _ref$history,
    _ref$setLock = _ref.setLock,
    setLock = _ref$setLock === void 0 ? null : _ref$setLock,
    _ref$setLockMessageRe = _ref.setLockMessageRecoilState,
    setLockMessageRecoilState = _ref$setLockMessageRe === void 0 ? null : _ref$setLockMessageRe,
    _ref$isSyncMenuStateC = _ref.isSyncMenuStateCalled,
    isSyncMenuStateCalled = _ref$isSyncMenuStateC === void 0 ? null : _ref$isSyncMenuStateC,
    _ref$setIsSyncMenuSta = _ref.setIsSyncMenuStateCalled,
    setIsSyncMenuStateCalled = _ref$setIsSyncMenuSta === void 0 ? null : _ref$setIsSyncMenuSta;
  switch (type) {
    case 'local':
      return {
        reboot: reload(),
        screenshot: screenshot(),
        lock: lock({
          history: history,
          setLock: setLock,
          setLockMessageRecoilState: setLockMessageRecoilState
        }),
        unlock: unlock({
          history: history,
          setLock: setLock
        }),
        reload: reload(),
        syncMenu: syncMenu({
          isSyncMenuStateCalled: isSyncMenuStateCalled,
          setIsSyncMenuStateCalled: setIsSyncMenuStateCalled
        })
      };
    case 'chrome':
      return {
        screenshot: screenshot(),
        reboot: reboot({
          port: port
        }),
        lock: lock({
          history: history,
          setLock: setLock,
          setLockMessageRecoilState: setLockMessageRecoilState
        }),
        unlock: unlock({
          history: history,
          setLock: setLock
        }),
        reload: reload(),
        syncMenu: syncMenu({
          isSyncMenuStateCalled: isSyncMenuStateCalled,
          setIsSyncMenuStateCalled: setIsSyncMenuStateCalled
        })
      };
    default:
      throw new Error("Invalid 'type' passed to 'createHandlers'");
  }
};
var useSystem = function useSystem() {
  var history = reactRouterDom.useHistory();
  var _useRootViewContext = useRootViewContext(),
    lockMachineState = _useRootViewContext.lockMachineState,
    setLock = _useRootViewContext.lockMachineSend,
    settings = _useRootViewContext.settings;
  var _useRecoilState = recoil.useRecoilState(atoms.lockMessageState),
    lockMessageRecoilState = _useRecoilState[0],
    setLockMessageRecoilState = _useRecoilState[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.syncMenuState),
    isSyncMenuStateCalled = _useRecoilState2[0],
    setIsSyncMenuStateCalled = _useRecoilState2[1];
  var _useRecoilValue = recoil.useRecoilValue(atoms.systemState),
    type = _useRecoilValue.type,
    port = _useRecoilValue.port;

  // Probably don't need to destructure this much...
  // - Just trying to be explicit...
  var _createHandlers = createHandlers({
      type: type,
      port: port,
      history: history,
      setLock: setLock,
      setLockMessageRecoilState: setLockMessageRecoilState,
      settings: settings,
      isSyncMenuStateCalled: isSyncMenuStateCalled,
      setIsSyncMenuStateCalled: setIsSyncMenuStateCalled
    }),
    lock = _createHandlers.lock,
    unlock = _createHandlers.unlock,
    reboot = _createHandlers.reboot,
    screenshot = _createHandlers.screenshot,
    reload = _createHandlers.reload,
    syncMenu = _createHandlers.syncMenu;
  return {
    type: type,
    port: port,
    lock: lock,
    unlock: unlock,
    reboot: reboot,
    screenshot: screenshot,
    lockMachineState: lockMachineState,
    lockMessageRecoilState: lockMessageRecoilState,
    setLockMessageRecoilState: setLockMessageRecoilState,
    reload: reload,
    syncMenu: syncMenu
  };
};

/* eslint-disable max-lines */
var checkScheduleLockInterval = null;
var useRestaurantLock = function useRestaurantLock() {
  var _useState = React.useState(false),
    kioskClosed = _useState[0],
    setKioskClosed = _useState[1];
  var _useState2 = React.useState(false),
    scheduleLock = _useState2[0],
    setScheduleLock = _useState2[1];
  var _useState3 = React.useState(false),
    scheduleUnlock = _useState3[0],
    setScheduleUnlock = _useState3[1];
  var _useSettings = utilities.useSettings(atoms.settingsState),
    rootSettings = _useSettings.settings;
  var _useSystem = useSystem(),
    lock = _useSystem.lock,
    unlock = _useSystem.unlock,
    lockMachineState = _useSystem.lockMachineState,
    lockMessageRecoilState = _useSystem.lockMessageRecoilState,
    setLockMessageRecoilState = _useSystem.setLockMessageRecoilState;
  var _ref = rootSettings || {},
    settings = _ref.settings,
    timezone = _ref.timezone;
  var _ref2 = settings || {},
    site = _ref2.site;
  var _ref3 = site || {},
    _ref3$isKioskClosed = _ref3.isKioskClosed,
    isKioskClosed = _ref3$isKioskClosed === void 0 ? false : _ref3$isKioskClosed,
    _ref3$workingHours = _ref3.workingHours,
    workingHours = _ref3$workingHours === void 0 ? [] : _ref3$workingHours;
  var INTERVAL = 60 * 1000;
  var autoLock = React.useCallback(function (message) {
    return lock({
      state: 'AUTO_LOCK',
      message: message
    });
  }, [lock]);
  var manualLock = React.useCallback(function (message) {
    return lock({
      state: 'MANUAL_LOCK',
      message: message
    });
  }, [lock]);
  var autoUnlock = React.useCallback(function () {
    return unlock({
      state: 'AUTO_UNLOCK'
    });
  }, [unlock]);
  var manualUnlock = React.useCallback(function () {
    return unlock({
      state: 'MANUAL_UNLOCK',
      redirect: false
    });
  }, [unlock]);
  var formatRangeDates = React.useCallback(function (_temp) {
    var _ref4 = _temp === void 0 ? {} : _temp,
      workingHours = _ref4.workingHours,
      baseDate = _ref4.baseDate;
    var todaysSchedule = workingHours == null ? void 0 : workingHours.find(function (item) {
      var weekday = item.weekday;
      return weekday === dateFns.format(baseDate, 'EEE').toLocaleLowerCase();
    });
    var _ref5 = todaysSchedule || {},
      to = _ref5.to,
      from = _ref5.from;
    var _ref6 = from || {},
      _ref6$hour = _ref6.hour,
      hourFrom = _ref6$hour === void 0 ? 0 : _ref6$hour,
      _ref6$minute = _ref6.minute,
      minuteFrom = _ref6$minute === void 0 ? 0 : _ref6$minute;
    var _ref7 = to || {},
      _ref7$hour = _ref7.hour,
      hourTo = _ref7$hour === void 0 ? 23 : _ref7$hour,
      _ref7$minute = _ref7.minute,
      minuteTo = _ref7$minute === void 0 ? 59 : _ref7$minute;

    // if the "to" date is lower than the "from" one we should consider the "to" time in future
    // i.e: `{ hourFrom: 10, hourTo: 1 }` we should consider from current day 10am to next day 1am.
    var formattedFromInMinutes = hourFrom * 60 + minuteFrom;
    var formattedToInMinutes = hourTo * 60 + minuteTo;
    var formattedBaseDateTo = formattedToInMinutes < formattedFromInMinutes ? dateFns.addDays(baseDate, 1) : baseDate;
    var fromDate = dateFns.setMinutes(dateFns.setHours(baseDate, hourFrom), minuteFrom);
    var toDate = dateFns.setMinutes(dateFns.setHours(formattedBaseDateTo, hourTo), minuteTo);
    return {
      fromDate: fromDate,
      toDate: toDate
    };
  }, []);
  var isWithinWorkingHours = React.useCallback(function () {
    var currentDate = new Date();
    var previousDayBaseDate = dateFns.subDays(dateFnsTz.utcToZonedTime(currentDate, timezone), 1);
    var _formatRangeDates = formatRangeDates({
        workingHours: workingHours,
        baseDate: previousDayBaseDate
      }),
      previousDayFromDate = _formatRangeDates.fromDate,
      previousDayToDate = _formatRangeDates.toDate;
    var currentDayBaseDate = dateFnsTz.utcToZonedTime(currentDate, timezone);
    var _formatRangeDates2 = formatRangeDates({
        workingHours: workingHours,
        baseDate: currentDayBaseDate
      }),
      currentDayFromDate = _formatRangeDates2.fromDate,
      currentDayToDate = _formatRangeDates2.toDate;

    // check if current date is within the working hours range defined on both previous and current day
    // why? previous weekday times can overflow to the current weekday
    var withinInterval = dateFns.isWithinInterval(currentDayBaseDate, {
      start: previousDayFromDate,
      end: previousDayToDate
    }) || dateFns.isWithinInterval(currentDayBaseDate, {
      start: currentDayFromDate,
      end: currentDayToDate
    });
    return withinInterval;
  }, [formatRangeDates, timezone, workingHours]);
  var checkScheduleLock = React.useCallback(function () {
    setKioskClosed(isKioskClosed || false);
    var withinInterval = isWithinWorkingHours();
    setScheduleLock(!withinInterval);
    setScheduleUnlock(withinInterval);
  }, [isWithinWorkingHours, isKioskClosed]);
  React.useEffect(function () {
    if (!checkScheduleLockInterval) {
      checkScheduleLockInterval = setInterval(function () {
        try {
          logger.debug('Components - useRestaurantLock - starting checkScheduleLock');
          checkScheduleLock();
        } catch (err) {
          logger.error('Components - useRestaurantLock - checkScheduleLock - error:', err);
        }
      }, INTERVAL);
    }
    return function () {
      clearInterval(checkScheduleLockInterval);
      checkScheduleLockInterval = null;
    };
  }, [INTERVAL, checkScheduleLock]);
  return {
    isWithinWorkingHours: isWithinWorkingHours,
    kioskClosed: kioskClosed,
    scheduleLock: scheduleLock,
    autoLock: autoLock,
    manualLock: manualLock,
    autoUnlock: autoUnlock,
    manualUnlock: manualUnlock,
    lockMachineState: lockMachineState,
    scheduleUnlock: scheduleUnlock,
    lockMessageRecoilState: lockMessageRecoilState,
    setLockMessageRecoilState: setLockMessageRecoilState,
    checkScheduleLock: checkScheduleLock
  };
};

var usePrevious = function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var MAX_MENU_RETRIES = 3;
var MAX_MENU_RETRY_DELAY = 5;
var useRestaurantMenu = function useRestaurantMenu() {
  var _settings$settings$si, _settings$settings, _settings$settings$si2;
  var _useState = React.useState(),
    menuSend = _useState[0],
    setMenuSend = _useState[1];
  var _useState2 = React.useState(),
    menuState = _useState2[0],
    setMenuState = _useState2[1];
  var _useState3 = React.useState(1),
    retryAttempt = _useState3[0],
    setRetryAttempt = _useState3[1];
  var flags = launchdarklyReactClientSdk.useFlags();
  var _useRecoilState = recoil.useRecoilState(atoms.formattedProductsState),
    formattedProducts = _useRecoilState[0],
    setFormattedProducts = _useRecoilState[1];
  var setRawProducts = recoil.useSetRecoilState(atoms.rawProductsState);
  var _useRecoilState2 = recoil.useRecoilState(atoms.productsState),
    products = _useRecoilState2[0],
    setProducts = _useRecoilState2[1];
  var categories = recoil.useRecoilValue(atoms.formattedCategoriesState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var prevSession = usePrevious(session);
  var setCategories = recoil.useSetRecoilState(atoms.categoriesState);
  var _useRecoilState3 = recoil.useRecoilState(atoms.promotionalState),
    promotions = _useRecoilState3[0],
    setPromotions = _useRecoilState3[1];
  var _useRecoilState4 = recoil.useRecoilState(atoms.countState),
    count = _useRecoilState4[0];
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var _useRestaurantLock = useRestaurantLock(),
    isWithinWorkingHours = _useRestaurantLock.isWithinWorkingHours,
    lockMachineState = _useRestaurantLock.lockMachineState;
  var isKioskClosed = (_settings$settings$si = settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$si2 = _settings$settings.site) == null ? void 0 : _settings$settings$si2.isKioskClosed) != null ? _settings$settings$si : false;
  var populateComboImages = function populateComboImages(product, previousImages) {
    var _product$combo, _product$combo$filter;
    var images = [];
    product == null ? void 0 : (_product$combo = product.combo) == null ? void 0 : (_product$combo$filter = _product$combo.filters) == null ? void 0 : _product$combo$filter.forEach(function (filter) {
      var _ref = filter || {},
        imageUrl = _ref.imageUrl;
      if (!previousImages.includes(imageUrl)) {
        var img = new Image();
        img.src = imageUrl;
        images.push(imageUrl);
      }
    });
    return images;
  };

  // Pre load the images before user interaction
  var populateImages = React.useCallback(function (_temp) {
    var _ref2 = _temp === void 0 ? [] : _temp,
      _ref2$source = _ref2.source,
      source = _ref2$source === void 0 ? [] : _ref2$source;
    source.reduce(function (previousImages, currentItem) {
      var _ref3 = currentItem || {},
        imageUrl = _ref3.imageUrl;
      var comboImages = (currentItem == null ? void 0 : currentItem.type) === 'combo' ? populateComboImages(currentItem, previousImages) : [];

      // Do not load repeated images
      if (previousImages.includes(imageUrl)) return [].concat(previousImages, comboImages);
      var img = new Image();
      img.src = imageUrl;
      return [].concat(previousImages, [imageUrl], comboImages);
    }, []);
  }, []);

  // TODO: Refactor the nested modifiers to reduce technical debt. This should be prioritized ASAP.
  // The current implementation is partially due to the changes introduced in the Hawke PR:
  // https://bitbucket.org/fingermarkltd/supersonic-hawke/pull-requests/1797/.
  // The system's data handling for this feature needs improvement to ensure better maintainability and scalability.
  var formatCustomiseForNestedModifiers = React.useCallback(function (products) {
    return products.map(function (product) {
      var _product$customise, _product$combo2;
      if (product.providerData && product.providerData.customise) {
        product.customise = product.providerData.customise;
        product.type = 'customise';
        delete product.providerData.customise;
      }
      if (typeof ((_product$customise = product.customise) == null ? void 0 : _product$customise.categories) === 'string') {
        product.customise.categories = JSON.parse(product.customise.categories);
      }
      if (product.customise && product.customise.categories) {
        product.customise.categories = product.customise.categories.map(function (category) {
          if (category.products) {
            category.products = category.products.map(function (subProduct) {
              return formatCustomiseForNestedModifiers([subProduct])[0];
            });
          }
          return category;
        });
      }
      if (typeof ((_product$combo2 = product.combo) == null ? void 0 : _product$combo2.categories) === 'string') {
        var _product$combo3;
        product.combo.categories = JSON.parse((_product$combo3 = product.combo) == null ? void 0 : _product$combo3.categories);
      }
      if (product.combo && product.combo.categories) {
        product.combo.categories = product.combo.categories.map(function (category) {
          if (category.products) {
            category.products = category.products.map(function (subProduct) {
              return formatCustomiseForNestedModifiers([subProduct])[0];
            });
          }
          return category;
        });
      }
      return product;
    });
  }, []);
  var loading = React.useMemo(function () {
    if (!menuState) return true;
    var states = ['idle', 'waiting', 'populating'];
    return states.map(function (state) {
      return menuState == null ? void 0 : menuState.matches(state);
    }).some(function (item) {
      return item;
    });
  }, [menuState]);
  var existing = React.useMemo(function () {
    var existing = [products, promotions, categories];
    return existing.every(function (item) {
      return item;
    });
  }, [products, promotions, categories]);
  var retry = React.useCallback(function () {
    menuSend({
      event: 'EXTERNAL_TRANSITION_RETRY'
    });
  }, [menuSend]);
  React.useEffect(function () {
    /* Before we fetch the menu, we need to check if the kiosk is closed or outside working hours 
       because we redirect to the lock page when it's true.
       
       After getting the response from the menu, we try to update the menuState.
       Due to redirection, the state is no longer available, leading to a memory leak. 
       To avoid it, we need to check the status of the kiosk before starting the process.
        But, we ignore if the kiosk is closed when the user unlock it manually through the admin page
    */
    if (!(lockMachineState != null && lockMachineState.matches('manualUnlocked')) && (isKioskClosed || !isWithinWorkingHours())) {
      return;
    }
    if (menuState) return;

    // If menuState is not set, start the menu fetch state machine
    var run = menu_resolver.resolveMenu({
      transition: function transition(machine) {
        return setMenuState(machine);
      }
    });

    // If the items are already in the store then skip straight to complete
    if (existing) run({
      event: 'SKIP'
    });
    if (!existing) run({
      event: 'INITIALISE',
      config: {
        count: count,
        settings: settings
      }
    });

    // NOTE: first function would normally return previous state...
    setMenuSend(function () {
      return function () {
        return run.apply(void 0, arguments);
      };
    });
  }, [count, existing, settings, menuState, setMenuSend, setMenuState, isKioskClosed, isWithinWorkingHours, lockMachineState]);
  React.useEffect(function () {
    if (!menuState) return;
    if (!(menuState != null && menuState.matches('waiting'))) return;
    var context = menuState.context;
    var productsToHydrate = formatCustomiseForNestedModifiers([].concat(context == null ? void 0 : context.products));
    var productHydration = hydrate.createHydrater({
      items: context == null ? void 0 : context.products
    });
    var rawHydratedProducts = productsToHydrate.map(function (product) {
      var hydratedProduct = productHydration({
        id: product.productId
      });
      return updatePricesByTimeRestrictions({
        product: hydratedProduct,
        settings: settings
      });
    }).map(filterImageUrlFallback);
    var hydratedProducts = rawHydratedProducts.filter(filterByVisibilityFlag).map(function (product) {
      return updatePricesByTimeRestrictions({
        product: product,
        settings: settings
      });
    }).map(filterImageUrlFallback);
    var promotions = Array.isArray(context == null ? void 0 : context.promotions) ? context == null ? void 0 : context.promotions : [];
    populateImages({
      source: [].concat(hydratedProducts, promotions, context == null ? void 0 : context.categories)
    });
    setProducts(hydratedProducts);
    setRawProducts(rawHydratedProducts);
    setPromotions(context == null ? void 0 : context.promotions);
    setCategories(context == null ? void 0 : context.categories);
  }, [menuState, settings, flags, setProducts, setPromotions, setCategories, setRawProducts, populateImages, formatCustomiseForNestedModifiers]);

  /**
   * This hook processes the products by re-applying visibility and time restriction filters
   * dynamically without needing a kiosks reload.
   *
   * The filtered and updated products are set only if the menu fetch is successful
   * (`menuState.matches('success')`) and there are existing products - `existing` is true.
   *
   * To minimize performance overhead, the products are re-filtered and updated only when a
   * new session is created (i.e., when the session transitions from `null` to a non-null state).
   */
  React.useEffect(function () {
    if (!existing) return;
    if (!menuState || !(menuState != null && menuState.matches('success'))) return;
    if (prevSession === null && session !== null) {
      var updatedProducts = products.filter(filterByTimeRestrictions({
        settings: settings,
        flags: flags
      })).map(function (product) {
        return updatePricesByTimeRestrictions({
          product: product,
          settings: settings
        });
      });
      setFormattedProducts(updatedProducts);
    }
  }, [menuState, existing, flags, session, settings, products, prevSession, setFormattedProducts]);
  React.useEffect(function () {
    if (!existing) return;
    if (!menuState) return;
    if (!(menuState != null && menuState.matches('waiting'))) return;
    menuSend({
      event: 'EXTERNAL_TRANSITION_SUCCESS'
    });
  }, [existing, menuSend, menuState]);
  React.useEffect(function () {
    var timeoutId;
    if (menuState != null && menuState.matches('failure') && retryAttempt <= MAX_MENU_RETRIES) {
      logger.log("Components - useRestaurantMenu - This is the " + retryAttempt + "th retry attempt, trying again in " + MAX_MENU_RETRY_DELAY + " seconds");
      setTimeout(function () {
        logger.log('Components - useRestaurantMenu - Running timeout callback');
        retry();
        setRetryAttempt(function (currentValue) {
          return currentValue + 1;
        });
      }, MAX_MENU_RETRY_DELAY * 1000);
    }
    if (menuState != null && menuState.matches('success')) {
      if (retryAttempt > 1) {
        logger.log("Components - useRestaurantMenu - Successfully called the menu after " + (retryAttempt - 1) + " retry attempts, reseting the state to 0");
        setRetryAttempt(1);
      }
    }
    return clearTimeout(timeoutId);
  }, [menuState, retry, retryAttempt]);
  return {
    send: menuSend,
    state: menuState,
    retry: retry,
    retryAttempt: retryAttempt,
    loading: loading,
    settings: settings,
    products: formattedProducts,
    categories: categories,
    promotions: promotions
  };
};

var useRestaurantCart = function useRestaurantCart() {
  var _useRestaurantMenu = useRestaurantMenu(),
    products = _useRestaurantMenu.products;
  var _useAnalytics = jitsu.useAnalytics(),
    productRemovedTrack = _useAnalytics.productRemovedTrack;
  var _useCart = cart.useCart(),
    _useCart$cart = _useCart.cart,
    cart$1 = _useCart$cart === void 0 ? [] : _useCart$cart,
    _useCart$items = _useCart.items,
    items = _useCart$items === void 0 ? [] : _useCart$items,
    commitAdditionalBagFee = _useCart.commitAdditionalBagFee;
  var _useState = React.useState(0),
    cartUpdateCount = _useState[0],
    setCartUpdateCount = _useState[1];
  var _useRecoilState = recoil.useRecoilState(atoms.orderTotalState),
    total = _useRecoilState[0],
    setTotal = _useRecoilState[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.orderCountState),
    count = _useRecoilState2[0],
    setCount = _useRecoilState2[1];
  var offersAndRewards = recoil.useRecoilValue(atoms.offersAndRewardsState);
  var _useRecoilState3 = recoil.useRecoilState(atoms.totalValidatedState),
    totalValidated = _useRecoilState3[0],
    setTotalValidated = _useRecoilState3[1];
  var setRemovedUpsells = recoil.useSetRecoilState(atoms.removedUpsellState);
  var setOpenCondAddonModal = recoil.useSetRecoilState(atoms.openCondAddonModalState);
  var formattedAddedUpsells = recoil.useRecoilValue(atoms.formattedAddedUpsell);
  var categories = recoil.useRecoilValue(atoms.categoriesState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var addedUpsells = recoil.useRecoilValue(atoms.addedUpsellState);

  // Compute hidden products that are conditional add-ons
  var hiddenProducts = React.useMemo(function () {
    return categories == null ? void 0 : categories.filter(function (category) {
      return (
        // Filter out visible categories and the cross-sell category
        !category.isVisible && category.id !== process.env.POI_APP_CROSS_SELL_CATEGORY_ID
      );
    }).flatMap(function (category) {
      return category.products;
    });
  }, [categories]);

  /**
   * Executes the product updater function and add 1 to the update count.
   * The update count is used to check if the user made some changes on the current cart items.
   * @param {() => {}} productUpdater Product updater function. ie: add(), remove()
   * @param {any} params Object params to pass through
   */
  var onCartUpdateHandler = React.useCallback(function (productUpdater, isRemoveAll) {
    if (isRemoveAll === void 0) {
      isRemoveAll = false;
    }
    return function (params) {
      if (!!productUpdater) productUpdater(params);
      setCartUpdateCount(cartUpdateCount + 1);
      if (isRemoveAll) setTotalValidated(false);
    };
  }, [cartUpdateCount, setTotalValidated]);
  var isCartValidated = React.useMemo(function () {
    return !cart$1.some(function (item) {
      return !item.validated;
    });
  }, [cart$1]);
  var isCartProductsAvailable = React.useMemo(function () {
    return !cart$1.some(function (item) {
      var _ref = item || {},
        _ref$isAvailable = _ref.isAvailable,
        isAvailable = _ref$isAvailable === void 0 ? true : _ref$isAvailable;
      return !isAvailable;
    });
  }, [cart$1]);
  var isCartEvaluated = React.useMemo(function () {
    return !cart$1.some(function (item) {
      return !item.evaluated;
    });
  }, [cart$1]);
  var formattedCart = React.useMemo(function () {
    return cart$1.map(function (item) {
      return _extends({}, item, {
        add: onCartUpdateHandler(item.add),
        remove: onCartUpdateHandler(item.remove),
        removeAll: onCartUpdateHandler(item.removeAll, true)
      });
    });
  }, [cart$1, onCartUpdateHandler]);

  // You might be wondering why we have two calls to commitAdditionalBagFee in two different useEffects.
  // The answer is that with the existing logic, when adding a combo item to the cart, two bags were being added.
  // This specifically occurred for combo products. Simple, grouped, and customize products didn't encounter this issue.
  // Nevertheless, a task has been created to revisit this point in the future: https://fingermarkglobal.atlassian.net/browse/S2UI-662
  React.useEffect(function () {
    commitAdditionalBagFee({
      products: products,
      session: session
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    var isCombo = items == null ? void 0 : items.some(function (item) {
      var _item$product;
      return "" + (item == null ? void 0 : (_item$product = item.product) == null ? void 0 : _item$product.type) === "combo";
    });
    if (!isCombo) {
      commitAdditionalBagFee({
        products: products,
        session: session
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, products, session, commitAdditionalBagFee]);
  React.useEffect(function () {
    var evaluatedCount = cart$1.reduce(function (result, item) {
      return result + item.count.current;
    }, 0);
    setCount(evaluatedCount);
    if (evaluatedCount === 0) {
      setTotal(0);
      return;
    }

    /**
     * There will be situations where the validated total (from pre order response)
     * won't be the same as the calculated total (all products sum).
     * For these situations we should ignore the calculated total and set the validated total
     * but only if all items are validated, which means that none of them have been changed by the user
     * after the pre order response.
     */
    if (!isCartValidated || !totalValidated) {
      var calculatedRawTotal = cart$1.reduce(function (result, current) {
        return result + current.price.current;
      }, 0);
      setTotal(calculatedRawTotal);
    }
  }, [cart$1, setTotal, setCount, isCartValidated, totalValidated, count]);
  React.useEffect(function () {
    var _cart$filter;
    /**
     * Remove hidden upsell products once the main products is removed from the cart.
     */
    var upsellsToRemove = [];
    var upsellsToReduce = [];
    (_cart$filter = cart$1.filter(function (item) {
      return item.isUpsell && hiddenProducts.includes(item.productId);
    })) == null ? void 0 : _cart$filter.forEach(function (upsell) {
      var mainProducts = formattedAddedUpsells[upsell.productId] || [];
      var mainProductIds = mainProducts.map(function (item) {
        return item.productId;
      });
      var mainItemsInCart = cart$1.filter(function (item) {
        return mainProductIds.includes(item.productId);
      });
      if (mainItemsInCart.length === 0) {
        // Remove upsell if no main items exist
        upsellsToRemove.push({
          upsell: upsell,
          mainProducts: lodash.uniqBy(mainProducts, 'productId')
        });
      } else {
        var totalMainQuantity = mainItemsInCart.reduce(function (total, item) {
          return total + item.count.current;
        }, 0);
        var upsellQuantity = upsell.count.current;

        // If upsell quantity is greater than main items quantity, reduce it
        if (upsellQuantity > totalMainQuantity) {
          var quantityToReduce = upsellQuantity - totalMainQuantity;
          upsellsToReduce.push({
            upsell: upsell,
            quantityToReduce: quantityToReduce
          });
        }
      }
      if (!cart$1.some(function (item) {
        return mainProductIds.includes(item.productId);
      })) {
        upsellsToRemove.push({
          upsell: upsell,
          mainProducts: lodash.uniqBy(mainProducts, 'productId')
        });
      }
    });
    if (upsellsToRemove.length) {
      upsellsToRemove.forEach(function (item) {
        var _item$upsell$count;
        item.upsell.removeAll();
        productRemovedTrack(item.upsell, (_item$upsell$count = item.upsell.count) == null ? void 0 : _item$upsell$count.current, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
      });
      setRemovedUpsells(upsellsToRemove);
      setOpenCondAddonModal(true);
    }

    // Handle quantity reduction
    if (upsellsToReduce.length) {
      upsellsToReduce.forEach(function (item) {
        // Remove the excess quantity
        for (var i = 0; i < item.quantityToReduce; i++) {
          item.upsell.remove();
        }
        productRemovedTrack(item.upsell, item.quantityToReduce, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
      });
      // Only show modal if items were completely removed
      if (upsellsToRemove.length) {
        setOpenCondAddonModal(true);
      }
    }
  }, [cart$1, formattedAddedUpsells, setRemovedUpsells, setOpenCondAddonModal, hiddenProducts, productRemovedTrack, addedUpsells, couponNumber, kioskSettings.kiosk, orderTotal]);
  var findOfferInCart = React.useCallback(function (cartItems) {
    return cartItems == null ? void 0 : cartItems.find(function (cartItem) {
      return offersAndRewards == null ? void 0 : offersAndRewards.promos.some(function (offer) {
        return offer.promoId === cartItem.providerData.PromoId;
      });
    });
  }, [offersAndRewards]);
  var offerInCart = React.useMemo(function () {
    return formattedCart.length > 0 && findOfferInCart(formattedCart);
  }, [formattedCart, findOfferInCart]);
  return {
    count: count,
    total: total,
    onCartUpdateHandler: onCartUpdateHandler,
    cartUpdateCount: cartUpdateCount,
    isCartValidated: isCartValidated,
    isCartProductsAvailable: isCartProductsAvailable,
    formattedCart: formattedCart,
    items: items,
    isCartEvaluated: isCartEvaluated,
    offerInCart: offerInCart
  };
};
var useRestaurantSecondaryCart = function useRestaurantSecondaryCart() {
  var _useAnalytics2 = jitsu.useAnalytics(),
    productRemovedTrack = _useAnalytics2.productRemovedTrack;
  var _useSecondaryCart = cart.useSecondaryCart(),
    _useSecondaryCart$sec = _useSecondaryCart.secondaryCart,
    secondaryCart = _useSecondaryCart$sec === void 0 ? [] : _useSecondaryCart$sec,
    push = _useSecondaryCart.push,
    pull = _useSecondaryCart.pull,
    resetSecondaryCart = _useSecondaryCart.resetSecondaryCart;
  var _useState2 = React.useState(0),
    secondaryCartUpdateCount = _useState2[0],
    setSecondaryCartUpdateCount = _useState2[1];
  var setTotal = recoil.useSetRecoilState(atoms.orderTotalState);
  var setCount = recoil.useSetRecoilState(atoms.orderCountState);
  var setRemovedUpsells = recoil.useSetRecoilState(atoms.removedUpsellState);
  var setOpenCondAddonModal = recoil.useSetRecoilState(atoms.openCondAddonModalState);
  var formattedAddedUpsells = recoil.useRecoilValue(atoms.formattedAddedUpsell);
  var validatedOrderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState);
  var _ref2 = validatedOrderPayload || {},
    validatedCart = _ref2.cart;
  var _ref3 = validatedCart || {},
    validatedRawTotal = _ref3.total;
  var _useLocaleSelection = useLocaleSelection(),
    i18n = _useLocaleSelection.i18n;
  var _ref4 = i18n || {},
    language = _ref4.language;
  var translateInline = translateProductName(language);
  var categories = recoil.useRecoilValue(atoms.categoriesState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var addedUpsells = recoil.useRecoilValue(atoms.addedUpsellState);
  var hiddenProducts = React.useMemo(function () {
    return categories == null ? void 0 : categories.filter(function (category) {
      return !category.isVisible && category.id !== process.env.POI_APP_CROSS_SELL_CATEGORY_ID;
    }).flatMap(function (category) {
      return category.products;
    });
  }, [categories]);
  var isSecondaryCartValidated = React.useMemo(function () {
    return !secondaryCart.some(function (item) {
      return !item.validated;
    });
  }, [secondaryCart]);
  var isSecondaryCartEvaluated = React.useMemo(function () {
    return !secondaryCart.some(function (item) {
      return !item.evaluated;
    });
  }, [secondaryCart]);
  var total = React.useMemo(function () {
    // Same rule as the main cart total about validated total
    if (isSecondaryCartValidated && validatedRawTotal) return Math.round(validatedRawTotal * 100) / 100;
    var rawTotal = secondaryCart.reduce(function (result, current) {
      return result + current.price.current;
    }, 0);
    return Math.round(rawTotal * 100) / 100;
  }, [isSecondaryCartValidated, secondaryCart, validatedRawTotal]);
  var count = React.useMemo(function () {
    return secondaryCart.reduce(function (result, item) {
      return result + item.count.current;
    }, 0);
  }, [secondaryCart]);

  /**
   * Executes the product updater function and add 1 to the update count.
   * The update count is used to check if the user made some changes on the current cart items.
   * @param {() => {}} productUpdater Product updater function. ie: add(), remove()
   * @param {any} params Object params to pass through
   */
  var onCartUpdateHandler = React.useCallback(function (productUpdater) {
    return function (params) {
      if (!!productUpdater) productUpdater(params);
      setSecondaryCartUpdateCount(secondaryCartUpdateCount + 1);
    };
  }, [secondaryCartUpdateCount]);
  var formattedSecondaryCart = React.useMemo(function () {
    return secondaryCart.map(function (item) {
      return _extends({}, item, {
        title: translateInline(item == null ? void 0 : item.name),
        options: item.options.map(function (option) {
          return _extends({}, option, {
            products: option.products.map(function (product) {
              return _extends({}, product, {
                title: translateInline(product == null ? void 0 : product.name),
                customisations: product.customisations.map(function (customisation) {
                  return _extends({}, customisation, {
                    title: translateInline(customisation == null ? void 0 : customisation.name),
                    products: customisation.products.map(function (customisationProduct) {
                      return _extends({}, customisationProduct, {
                        title: translateInline(customisationProduct == null ? void 0 : customisationProduct.name)
                      });
                    })
                  });
                })
              });
            })
          });
        }),
        add: onCartUpdateHandler(item.add),
        remove: onCartUpdateHandler(item.remove),
        removeAll: onCartUpdateHandler(item.removeAll)
      });
    });
  }, [secondaryCart, onCartUpdateHandler, translateInline]);
  React.useEffect(function () {
    var _secondaryCart$filter;
    var upsellsToRemove = [];
    var upsellsToReduce = [];
    (_secondaryCart$filter = secondaryCart.filter(function (item) {
      return item.isUpsell && hiddenProducts.includes(item.productId);
    })) == null ? void 0 : _secondaryCart$filter.forEach(function (upsell) {
      var mainProducts = formattedAddedUpsells[upsell.productId] || [];
      var mainProductIds = mainProducts.map(function (item) {
        return item.productId;
      });
      var mainItemsInCart = secondaryCart.filter(function (item) {
        return mainProductIds.includes(item.productId);
      });
      if (mainItemsInCart.length === 0) {
        // Remove upsell if no main items exist
        upsellsToRemove.push({
          upsell: upsell,
          mainProducts: lodash.uniqBy(mainProducts, 'productId')
        });
      } else {
        var totalMainQuantity = mainItemsInCart.reduce(function (total, item) {
          return total + item.count.current;
        }, 0);
        var upsellQuantity = upsell.count.current;

        // If upsell quantity is greater than main items quantity, reduce it
        if (upsellQuantity > totalMainQuantity) {
          var quantityToReduce = upsellQuantity - totalMainQuantity;
          upsellsToReduce.push({
            upsell: upsell,
            quantityToReduce: quantityToReduce
          });
        }
      }
    });
    if (upsellsToRemove.length) {
      upsellsToRemove.forEach(function (item) {
        var _item$upsell$count2;
        item.upsell.removeAll();
        productRemovedTrack(item.upsell, (_item$upsell$count2 = item.upsell.count) == null ? void 0 : _item$upsell$count2.current, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
      });
      setRemovedUpsells(upsellsToRemove);
      setOpenCondAddonModal(true);
    }

    // Handle quantity reduction
    if (upsellsToReduce.length) {
      upsellsToReduce.forEach(function (item) {
        // Remove the excess quantity
        for (var i = 0; i < item.quantityToReduce; i++) {
          item.upsell.remove();
        }
        productRemovedTrack(item.upsell, item.quantityToReduce, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
      });
      // Only show modal if items were completely removed
      if (upsellsToRemove.length) {
        setOpenCondAddonModal(true);
      }
    }
  }, [secondaryCart, formattedAddedUpsells, setRemovedUpsells, setOpenCondAddonModal, hiddenProducts, productRemovedTrack, addedUpsells, couponNumber, kioskSettings.kiosk, orderTotal]);
  var formattedPush = function formattedPush() {
    setTotal(total);
    setCount(count);
    push();
  };
  return {
    count: count,
    total: total,
    onCartUpdateHandler: onCartUpdateHandler,
    secondaryCartUpdateCount: secondaryCartUpdateCount,
    isSecondaryCartEvaluated: isSecondaryCartEvaluated,
    formattedSecondaryCart: formattedSecondaryCart,
    formattedPush: formattedPush,
    pull: pull,
    resetSecondaryCart: resetSecondaryCart
  };
};

var useCustomer = function useCustomer() {
  var _useRecoilState = recoil.useRecoilState(atoms.customerState),
    customer = _useRecoilState[0],
    setCustomerState = _useRecoilState[1];
  var resetCustomer = recoil.useResetRecoilState(atoms.customerState);
  var setCustomer = function setCustomer(_ref) {
    var firstName = _ref.firstName,
      lastName = _ref.lastName,
      _ref$email = _ref.email,
      email = _ref$email === void 0 ? null : _ref$email,
      _ref$phoneNumber = _ref.phoneNumber,
      phoneNumber = _ref$phoneNumber === void 0 ? null : _ref$phoneNumber,
      _ref$receiveMarketing = _ref.receiveMarketingEmail,
      receiveMarketingEmail = _ref$receiveMarketing === void 0 ? false : _ref$receiveMarketing;
    setCustomerState({
      firstName: firstName,
      lastName: lastName,
      email: email ? email.toLowerCase() : process.env.POI_APP_CUSTOMER_EMAIL_DEFAULT,
      phoneNumber: phoneNumber,
      receiveMarketingEmail: receiveMarketingEmail
    });
  };
  return {
    customer: customer,
    setCustomer: setCustomer,
    resetCustomer: resetCustomer
  };
};

/**
 * This is used to control from which part of the
 * app the call for product editing.
 * After editing, it should go back to the page who called it
 */
var useOrigin = function useOrigin() {
  var _useRecoilState = recoil.useRecoilState(atoms.originState),
    origin = _useRecoilState[0],
    setOrigin = _useRecoilState[1];
  return {
    origin: origin,
    setOrigin: setOrigin
  };
};

var useMiniCart = function useMiniCart(_ref) {
  var _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    onSelectCustomisationProduct = _ref.onSelectCustomisationProduct,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom;
  var _useState = React.useState(false),
    showCartPreview = _useState[0],
    setShowCartPreview = _useState[1];
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var history = reactRouterDom.useHistory();
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useRestaurantCart = useRestaurantCart(),
    total = _useRestaurantCart.total,
    count = _useRestaurantCart.count,
    onCartUpdateHandler = _useRestaurantCart.onCartUpdateHandler;
  var _useAnalytics = jitsu.useAnalytics(),
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    cartItemEditTrack = _useAnalytics.cartItemEditTrack;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var _useCart = cart.useCart(),
    cart$1 = _useCart.cart;
  var _useOrigin = useOrigin(),
    setOrigin = _useOrigin.setOrigin;
  var customerSkipPath = '/validate';
  var nextPath = '/customer-details';
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath ? customerSkipPath : !!customer ? customerSkipPath : nextPath;
  React.useEffect(function () {
    if (count === 0 && showCartPreview) {
      setShowCartPreview(false);
    }
  }, [count, showCartPreview, setShowCartPreview]);
  var settingsObject = recoil.useRecoilValue(atoms.settingsState);
  var _ref2 = settingsObject || {},
    _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? {} : _ref2$settings;
  var _ref3 = (settings == null ? void 0 : settings.modes) || {},
    _ref3$miniCart = _ref3.miniCart,
    miniCart = _ref3$miniCart === void 0 ? false : _ref3$miniCart;
  var completeOrder = function completeOrder() {
    orderCompletedTrack();
    history.push(computedNextPath);
  };
  var nextAction = React.useCallback(function () {
    orderCompletedTrack();
    history.push(computedNextPath);
  }, [history, computedNextPath, orderCompletedTrack]);
  var cartHandler = !miniCart ? completeOrder : function () {
    setShowCartPreview(!showCartPreview);
  };
  var onEditProductHandler = function onEditProductHandler(product) {
    return function () {
      var _product$type = product.type,
        type = _product$type === void 0 ? '' : _product$type,
        _product$uid = product.uid,
        uid = _product$uid === void 0 ? '' : _product$uid;
      cartItemEditTrack(kioskSettings.kiosk);
      setOrigin(origin);
      switch (type) {
        case 'combo':
          return history.push("/product/" + product.productId + "/combo/" + product.id + "/cart/" + uid);
        case 'customise':
          setShowCartPreview(false);
          return onSelectCustomisationProduct(product);
        default:
          return history.push("/product/" + product.productId);
      }
    };
  };
  return {
    miniCart: miniCart,
    t: t,
    total: total,
    count: count,
    cart: cart$1,
    onCartUpdateHandler: onCartUpdateHandler,
    onEditProductHandler: onEditProductHandler,
    cartHandler: cartHandler,
    showCartPreview: showCartPreview,
    nextAction: nextAction,
    formatPrice: formatPrice
  };
};

var IconButton = function IconButton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    children = _ref.children,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? false : _ref$large,
    _ref$Icon = _ref.Icon,
    Icon = _ref$Icon === void 0 ? ArrowLeft : _ref$Icon,
    _ref$iconReverse = _ref.iconReverse,
    iconReverse = _ref$iconReverse === void 0 ? false : _ref$iconReverse,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'icon-button' : _ref$dataTest;
  var dynamicClassName = large ? 'py-0 px-2 sm:py-6 sm:px-8 text-xl sm:text-6xl' : 'py-0 px-2 sm:py-4 sm:px-6 text-xl sm:text-3xl';
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    onClick: onClick,
    disabled: disabled,
    className: "uppercase text-black font-bold focus:outline-none " + dynamicClassName + " " + className,
    "data-test": dataTest,
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex items-center justify-center space-x-1 sm:items-start sm:space-x-2 icon-button md:items-center",
      children: [!iconReverse && /*#__PURE__*/jsxRuntime.jsx(Icon, {
        className: "w-7 sm:w-8 mb-icon-button"
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        children: children
      }), iconReverse && /*#__PURE__*/jsxRuntime.jsx(Icon, {
        className: "w-7 sm:w-8 mb-icon-button"
      })]
    })
  });
};

var CartProductLine = function CartProductLine(_temp) {
  var _promoItem$name;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? null : _ref$product,
    _ref$onUpdateHandler = _ref.onUpdateHandler,
    onUpdateHandler = _ref$onUpdateHandler === void 0 ? function () {
      return function () {};
    } : _ref$onUpdateHandler,
    _ref$onEditProductHan = _ref.onEditProductHandler,
    onEditProductHandler = _ref$onEditProductHan === void 0 ? function () {
      return function () {};
    } : _ref$onEditProductHan,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$showComboFilterN = _ref.showComboFilterName,
    showComboFilterName = _ref$showComboFilterN === void 0 ? true : _ref$showComboFilterN;
  validation$1.validate({
    name: 'CartProductLine',
    parameters: {
      product: product
    }
  });
  var productId = product.productId,
    name = product.name,
    count = product.count,
    add = product.add,
    remove = product.remove,
    _product$removeDisabl = product.removeDisabled,
    removeDisabled = _product$removeDisabl === void 0 ? false : _product$removeDisabl,
    _product$addDisabled = product.addDisabled,
    addDisabled = _product$addDisabled === void 0 ? false : _product$addDisabled,
    _product$isAvailable = product.isAvailable,
    isAvailable = _product$isAvailable === void 0 ? true : _product$isAvailable,
    removeAll = product.removeAll,
    _product$editDisabled = product.editDisabled,
    editDisabled = _product$editDisabled === void 0 ? false : _product$editDisabled,
    _product$filterName = product.filterName,
    filterName = _product$filterName === void 0 ? {} : _product$filterName;
  var _useState = React.useState(false),
    isOffer = _useState[0],
    setIsOffer = _useState[1];
  var currentCount = count.current;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    getPromoItem = _useOffersAndRewardsM.getPromoItem,
    offersAndRewards = _useOffersAndRewardsM.offersAndRewards;
  var promoItem = getPromoItem({
    productId: productId
  });
  React.useEffect(function () {
    var _offersAndRewards$off;
    var isSelectedItemAnOffer = !!(offersAndRewards != null && (_offersAndRewards$off = offersAndRewards.offers) != null && _offersAndRewards$off.find(function (offer) {
      return offer.promoId === product.providerData.PromoId;
    }));
    setIsOffer(isSelectedItemAnOffer);
  }, [offersAndRewards, product, setIsOffer]);
  var filterNameText = promoItem != null && promoItem.name ? null : showComboFilterName && (filterName == null ? void 0 : filterName.text) && "(" + (filterName == null ? void 0 : filterName.text) + ")";
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col justify-between rounded p-4 w-full " + (!isAvailable && 'bg-red-100'),
    children: [!isAvailable && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex items-center justify-center space-x-4 text-4xl text-center text-red-600",
      children: [/*#__PURE__*/jsxRuntime.jsx(Ban, {
        className: "w-auto h-12"
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        children: t('cartProductUnavailableGeneral')
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col p-4",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex justify-between w-full",
        children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex items-center justify-center",
          children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
            className: "text-xl font-bold",
            children: [(_promoItem$name = promoItem == null ? void 0 : promoItem.name) != null ? _promoItem$name : name.text, " ", filterNameText]
          }), /*#__PURE__*/jsxRuntime.jsxs("div", {
            "data-test": "product-quantity-count",
            className: "ml-4 text-xl min-w-12",
            children: ["x ", currentCount]
          })]
        }), /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex items-start mx-4 space-x-4",
          children: [product.type !== 'simple' && /*#__PURE__*/jsxRuntime.jsx(IconButton, {
            "data-test": "button-product-edit",
            className: "flex items-center justify-center w-12 h-12 p-2 pr-4 border-2 border-primary disabled:opacity-50 focus:outline-none text-mini-cart-button",
            onClick: onEditProductHandler(product),
            disabled: !isAvailable || editDisabled,
            Icon: Pencil
          }), /*#__PURE__*/jsxRuntime.jsx(IconButton, {
            "data-test": "button-product-quantity-remove",
            className: "flex items-center justify-center w-12 h-12 p-2 pr-4 border-2 border-primary disabled:opacity-50 focus:outline-none text-mini-cart-button",
            onClick: onUpdateHandler(remove),
            disabled: !isAvailable || removeDisabled,
            Icon: Minus
          }), /*#__PURE__*/jsxRuntime.jsx(IconButton, {
            "data-test": "button-product-quantity-add",
            className: "flex items-center justify-center w-12 h-12 p-2 pr-4 border-2 border-primary disabled:opacity-50 focus:outline-none text-mini-cart-button",
            onClick: onUpdateHandler(add),
            disabled: !isAvailable || addDisabled || isOffer,
            Icon: Plus
          }), /*#__PURE__*/jsxRuntime.jsx(IconButton, {
            "data-test": "button-product-remove",
            className: "flex items-center justify-center w-12 h-12 p-2 pr-4 text-white border-2 border-primary disabled:opacity-50 focus:outline-none bg-primary",
            onClick: onUpdateHandler(removeAll, true),
            Icon: Delete
          })]
        })]
      })
    })]
  });
};

var MiniCart = function MiniCart(_ref) {
  var _ref$showCart = _ref.showCart,
    showCart = _ref$showCart === void 0 ? false : _ref$showCart,
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? function () {
      return function () {};
    } : _ref$onSelectCustomis,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$showComboFilterN = _ref.showComboFilterName,
    showComboFilterName = _ref$showComboFilterN === void 0 ? true : _ref$showComboFilterN;
  var _useMiniCart = useMiniCart({
      origin: origin,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath
    }),
    t = _useMiniCart.t,
    count = _useMiniCart.count,
    cart = _useMiniCart.cart,
    onCartUpdateHandler = _useMiniCart.onCartUpdateHandler,
    onEditProductHandler = _useMiniCart.onEditProductHandler,
    cartHandler = _useMiniCart.cartHandler,
    showCartPreview = _useMiniCart.showCartPreview,
    total = _useMiniCart.total,
    nextAction = _useMiniCart.nextAction,
    formatPrice = _useMiniCart.formatPrice;
  if (!showCart) return null;
  var classes = 'absolute top-3 left-0 right-0 transition-transform ease-in-out duration-700 z-0 transform';
  var classList = classes.concat(' ', showCartPreview ? '-translate-y-full' : 'translate-y-0');
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: classList,
    "data-test": "slide-cart",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "relative",
      children: [/*#__PURE__*/jsxRuntime.jsx("button", {
        "data-test": "button-slide-cart",
        type: "button",
        className: "absolute top-0 left-0 right-0 block w-64 py-8 mx-auto mt-1 text-2xl transform -translate-y-full bg-gray-100 border-2 border-b-0 border-black rounded-t-lg outline-none",
        onClick: cartHandler,
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "relative",
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "slide-cart-count",
            className: "absolute top-0 right-0 w-12 h-12 pt-2 -mt-12 -mr-4 text-3xl text-white rounded-full bg-primary",
            children: count
          }), t('cart')]
        })
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "col-span-3 p-6 mb-1 overflow-auto bg-gray-100 border-t-2 border-black overscroll-contain",
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex",
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            className: "w-full overflow-auto h-80",
            children: cart.map(function (product, i) {
              return /*#__PURE__*/jsxRuntime.jsx(CartProductLine, {
                product: product,
                t: t,
                onUpdateHandler: onCartUpdateHandler,
                onEditProductHandler: onEditProductHandler,
                showCustomisations: false,
                showComboFilterName: showComboFilterName
              }, "cart-product-" + i);
            })
          }), /*#__PURE__*/jsxRuntime.jsxs("div", {
            className: "flex flex-col items-center justify-center m-4 mt-6 ml-4 space-y-5 text-4xl",
            children: [/*#__PURE__*/jsxRuntime.jsx("div", {
              className: "text-4xl uppercase",
              children: t('miniCartTotal')
            }), /*#__PURE__*/jsxRuntime.jsx("div", {
              className: "flex items-center justify-center h-16 text-4xl bg-white rounded-lg w-72",
              children: formatPrice({
                price: total
              })
            }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
              onClick: cartHandler,
              className: "w-72",
              children: t('miniCartCloseAction')
            }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
              onClick: nextAction,
              className: "w-72",
              children: t('miniCartCheckoutAction')
            })]
          })]
        })
      })]
    })
  });
};

function usePreviousLocation() {
  var location = reactRouterDom.useLocation();
  var previousLocationRef = React.useRef(null);
  React.useEffect(function () {
    previousLocationRef.current = location;
  }, [location]);
  return previousLocationRef.current;
}

var MiniCartWrapper = function MiniCartWrapper(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? null : _ref$onSelectCustomis,
    _ref$showMiniCartSlid = _ref.showMiniCartSlider,
    showMiniCartSlider = _ref$showMiniCartSlid === void 0 ? false : _ref$showMiniCartSlid,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$showComboFilterN = _ref.showComboFilterName,
    showComboFilterName = _ref$showComboFilterN === void 0 ? true : _ref$showComboFilterN;
  var showCart = showMiniCartSlider && count;
  var previousLocation = usePreviousLocation();
  if (!showCart || !(previousLocation != null && previousLocation.pathname)) return null;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "relative",
    children: /*#__PURE__*/jsxRuntime.jsx(MiniCart, {
      origin: previousLocation == null ? void 0 : previousLocation.pathname,
      showCart: showCart,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath,
      showComboFilterName: showComboFilterName
    })
  });
};

var img = "data:image/png;base64,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";

var loadingImage = process.env.POI_APP_LOADING_THUMBNAIL;
var useLoadableImage = function useLoadableImage(_ref) {
  var customDefaultImage = _ref.customDefaultImage;
  var _useState = React.useState(true),
    isLoading = _useState[0],
    setIsLoading = _useState[1];
  var hiddenImageClassName = React.useMemo(function () {
    if (!isLoading) return '';
    return 'hidden';
  }, [isLoading]);
  var onLoad = React.useCallback(function () {
    setIsLoading(false);
  }, [setIsLoading]);
  var handleFailure = function handleFailure(e) {
    // https://reactjs.org/docs/legacy-event-pooling.html
    // Prevents React from resetting its properties:
    e.persist();
    e.target.onerror = function () {
      e.target.src = customDefaultImage || img;
    };
    e.target.src = loadingImage;
    setIsLoading(false);
  };
  return {
    hiddenImageClassName: hiddenImageClassName,
    onLoad: onLoad,
    isLoading: isLoading,
    handleFailure: handleFailure
  };
};

var _excluded = ["src", "className", "placeholder", "customDefaultImage", "data-test"];
var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  if (placeholder) return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "mb-6 sm:mb-0 sm:mr-6 md:mr-12",
    children: children
  });
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: children
  });
};
var LoadableImage = function LoadableImage(_ref2) {
  var _ref2$src = _ref2.src,
    src = _ref2$src === void 0 ? null : _ref2$src,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? null : _ref2$placeholder,
    _ref2$customDefaultIm = _ref2.customDefaultImage,
    customDefaultImage = _ref2$customDefaultIm === void 0 ? img : _ref2$customDefaultIm,
    _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? 'loadable-image' : _ref2$dataTest,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var imageSrc = src || customDefaultImage;
  var _useLoadableImage = useLoadableImage({
      customDefaultImage: customDefaultImage
    }),
    hiddenImageClassName = _useLoadableImage.hiddenImageClassName,
    onLoad = _useLoadableImage.onLoad,
    isLoading = _useLoadableImage.isLoading,
    handleFailure = _useLoadableImage.handleFailure;
  var defaultSkeletonHeight = 0;
  var defaultSkeletonClassName = 'w-full pt-full';
  var skeletonHeight = placeholder ? placeholder.height : defaultSkeletonHeight;
  var skeletonWidth = placeholder ? placeholder.width : undefined;
  var skeletonClassName = placeholder ? '' : defaultSkeletonClassName;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [isLoading && /*#__PURE__*/jsxRuntime.jsx(Wrapper, {
      placeholder: placeholder,
      children: /*#__PURE__*/jsxRuntime.jsx(Skeleton.SkeletonTheme, {
        children: /*#__PURE__*/jsxRuntime.jsx(Skeleton__default, {
          "data-test": "skeleton-loader",
          height: skeletonHeight,
          width: skeletonWidth,
          className: "" + skeletonClassName
        })
      })
    }), /*#__PURE__*/React.createElement("img", _extends({}, props, {
      "data-test": dataTest,
      key: imageSrc,
      src: imageSrc,
      onLoad: onLoad,
      onError: handleFailure,
      className: hiddenImageClassName + " " + className
    }))]
  });
};

var _excluded$1 = ["src", "className", "customDefaultImage", "data-test"];
var ProductCardLoadableImage = function ProductCardLoadableImage(_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? null : _ref$src,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$customDefaultIma = _ref.customDefaultImage,
    customDefaultImage = _ref$customDefaultIma === void 0 ? img : _ref$customDefaultIma,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'product-card-image' : _ref$dataTest,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var imageSrc = src || customDefaultImage;
  var _useLoadableImage = useLoadableImage({
      customDefaultImage: customDefaultImage
    }),
    hiddenImageClassName = _useLoadableImage.hiddenImageClassName,
    onLoad = _useLoadableImage.onLoad,
    isLoading = _useLoadableImage.isLoading,
    handleFailure = _useLoadableImage.handleFailure;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [isLoading && /*#__PURE__*/jsxRuntime.jsx(Skeleton__default, {
      className: "skeleton-loader",
      "data-test": "skeleton-loader"
    }), /*#__PURE__*/React.createElement("img", _extends({}, props, {
      "data-test": dataTest,
      key: imageSrc,
      src: imageSrc,
      onLoad: onLoad,
      onError: handleFailure,
      className: "skeleton-loader-image " + hiddenImageClassName + " " + className
    }))]
  });
};

var BannerWarning = function BannerWarning(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '' : _ref$width,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? t('bannerWarningTitle') : _ref$title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? t('bannerWarningDescription') : _ref$description,
    _ref$additionalDescri = _ref.additionalDescription,
    additionalDescription = _ref$additionalDescri === void 0 ? null : _ref$additionalDescri,
    _ref$additionalDescri2 = _ref.additionalDescriptionAction,
    additionalDescriptionAction = _ref$additionalDescri2 === void 0 ? function () {} : _ref$additionalDescri2,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'bg-warning' : _ref$backgroundColor,
    _ref$additionalDescri3 = _ref.additionalDescriptionColor,
    additionalDescriptionColor = _ref$additionalDescri3 === void 0 ? 'text-blue-800' : _ref$additionalDescri3,
    _ref$dataTest = _ref.dataTest,
    dataTest = _ref$dataTest === void 0 ? 'banner-warning' : _ref$dataTest;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: "flex justify-start items-center px-6 md:px-12 py-4 rounded-lg " + backgroundColor + " " + className,
    children: [image && /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
      className: "mb-6 sm:mb-0 sm:mr-6 md:mr-12",
      src: image,
      alt: "Banner warning",
      width: width,
      placeholder: placeholder,
      "data-test": "banner-image"
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "banner-title",
        className: "text-3xl font-bold sm:text-4xl",
        children: title
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex",
        children: /*#__PURE__*/jsxRuntime.jsxs("p", {
          "data-test": "banner-description",
          className: "text-2xl sm:text-3xl",
          children: [description, additionalDescription && /*#__PURE__*/jsxRuntime.jsx("span", {
            "data-test": "banner-additional-description",
            onClick: additionalDescriptionAction,
            className: "ml-1 text-2xl " + additionalDescriptionColor + " sm:text-3xl",
            children: additionalDescription
          })]
        })
      })]
    })]
  });
};

var Footer = function Footer(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    hasUnavailableItems = _ref.hasUnavailableItems,
    _ref$nextText = _ref.nextText,
    nextText = _ref$nextText === void 0 ? 'Next' : _ref$nextText,
    _ref$nextAction = _ref.nextAction,
    nextAction = _ref$nextAction === void 0 ? null : _ref$nextAction,
    _ref$isNextActionOnBo = _ref.isNextActionOnBottom,
    isNextActionOnBottom = _ref$isNextActionOnBo === void 0 ? false : _ref$isNextActionOnBo,
    _ref$isBasketCountOnB = _ref.isBasketCountOnBottom,
    isBasketCountOnBottom = _ref$isBasketCountOnB === void 0 ? false : _ref$isBasketCountOnB,
    _ref$isQuantityContro = _ref.isQuantityControllerOnBottom,
    isQuantityControllerOnBottom = _ref$isQuantityContro === void 0 ? false : _ref$isQuantityContro,
    _ref$isPriceOnEnd = _ref.isPriceOnEnd,
    isPriceOnEnd = _ref$isPriceOnEnd === void 0 ? false : _ref$isPriceOnEnd,
    _ref$allowNextAction = _ref.allowNextAction,
    allowNextAction = _ref$allowNextAction === void 0 ? true : _ref$allowNextAction,
    _ref$nextActionClass = _ref.nextActionClass,
    nextActionClass = _ref$nextActionClass === void 0 ? '' : _ref$nextActionClass,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$spacer = _ref.spacer,
    spacer = _ref$spacer === void 0 ? null : _ref$spacer,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$enableCancelOrde = _ref.enableCancelOrder,
    enableCancelOrder = _ref$enableCancelOrde === void 0 ? false : _ref$enableCancelOrde,
    _ref$enableCustomCanc = _ref.enableCustomCancelOrder,
    enableCustomCancelOrder = _ref$enableCustomCanc === void 0 ? false : _ref$enableCustomCanc,
    _ref$cancelOrderText = _ref.cancelOrderText,
    cancelOrderText = _ref$cancelOrderText === void 0 ? 'Cancel' : _ref$cancelOrderText,
    _ref$showAccessibilit = _ref.showAccessibilityButton,
    showAccessibilityButton = _ref$showAccessibilit === void 0 ? false : _ref$showAccessibilit,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? false : _ref$showBottom,
    _ref$showBasketCount = _ref.showBasketCount,
    showBasketCount = _ref$showBasketCount === void 0 ? true : _ref$showBasketCount,
    _ref$showMiniCartSlid = _ref.showMiniCartSlider,
    showMiniCartSlider = _ref$showMiniCartSlid === void 0 ? false : _ref$showMiniCartSlid,
    _ref$isMiniCartEnable = _ref.isMiniCartEnabled,
    isMiniCartEnabled = _ref$isMiniCartEnable === void 0 ? false : _ref$isMiniCartEnable,
    _ref$onBasketClick = _ref.onBasketClick,
    onBasketClick = _ref$onBasketClick === void 0 ? function () {} : _ref$onBasketClick,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? null : _ref$total,
    _ref$OverwriteCartIco = _ref.OverwriteCartIcon,
    OverwriteCartIcon = _ref$OverwriteCartIco === void 0 ? null : _ref$OverwriteCartIco,
    _ref$CustomSecondaryB = _ref.CustomSecondaryButton,
    CustomSecondaryButton = _ref$CustomSecondaryB === void 0 ? SecondaryButton : _ref$CustomSecondaryB,
    _ref$CustomNextAction = _ref.CustomNextActionButton,
    CustomNextActionButton = _ref$CustomNextAction === void 0 ? PrimaryButton : _ref$CustomNextAction,
    _ref$CustomPreviousAc = _ref.CustomPreviousActionButton,
    CustomPreviousActionButton = _ref$CustomPreviousAc === void 0 ? PrimaryButton : _ref$CustomPreviousAc,
    _ref$BasketCount = _ref.BasketCount,
    BasketCount$1 = _ref$BasketCount === void 0 ? BasketCount : _ref$BasketCount,
    _ref$basketText = _ref.basketText,
    basketText = _ref$basketText === void 0 ? null : _ref$basketText,
    _ref$couponText = _ref.couponText,
    couponText = _ref$couponText === void 0 ? 'Enter offer' : _ref$couponText,
    _ref$isCouponEnabled = _ref.isCouponEnabled,
    isCouponEnabled = _ref$isCouponEnabled === void 0 ? false : _ref$isCouponEnabled,
    _ref$showCouponButton = _ref.showCouponButton,
    showCouponButton = _ref$showCouponButton === void 0 ? false : _ref$showCouponButton,
    _ref$couponAction = _ref.couponAction,
    couponAction = _ref$couponAction === void 0 ? function () {} : _ref$couponAction,
    _ref$isPreviousAction = _ref.isPreviousActionEnabled,
    isPreviousActionEnabled = _ref$isPreviousAction === void 0 ? false : _ref$isPreviousAction,
    _ref$allowPreviousAct = _ref.allowPreviousAction,
    allowPreviousAction = _ref$allowPreviousAct === void 0 ? true : _ref$allowPreviousAct,
    _ref$previousText = _ref.previousText,
    previousText = _ref$previousText === void 0 ? 'Back' : _ref$previousText,
    _ref$previousAction = _ref.previousAction,
    previousAction = _ref$previousAction === void 0 ? null : _ref$previousAction,
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? null : _ref$onSelectCustomis,
    _ref$isAnimationTarge = _ref.isAnimationTargetEnabled,
    isAnimationTargetEnabled = _ref$isAnimationTarge === void 0 ? false : _ref$isAnimationTarge,
    _ref$isFooterStyleVar = _ref.isFooterStyleVariationEnabled,
    isFooterStyleVariationEnabled = _ref$isFooterStyleVar === void 0 ? false : _ref$isFooterStyleVar,
    _ref$isDefaultButtonP = _ref.isDefaultButtonPaddingEnabled,
    isDefaultButtonPaddingEnabled = _ref$isDefaultButtonP === void 0 ? true : _ref$isDefaultButtonP,
    _ref$termsAndConditio = _ref.termsAndConditionsButtonText,
    termsAndConditionsButtonText = _ref$termsAndConditio === void 0 ? '' : _ref$termsAndConditio,
    _ref$showTermsAndCond = _ref.showTermsAndConditionsButton,
    showTermsAndConditionsButton = _ref$showTermsAndCond === void 0 ? false : _ref$showTermsAndCond,
    _ref$setShowTermsAndC = _ref.setShowTermsAndConditionsModal,
    setShowTermsAndConditionsModal = _ref$setShowTermsAndC === void 0 ? function () {} : _ref$setShowTermsAndC,
    _ref$caloriesBannerEn = _ref.caloriesBannerEnabled,
    caloriesBannerEnabled = _ref$caloriesBannerEn === void 0 ? false : _ref$caloriesBannerEn,
    _ref$caloriesBannerDe = _ref.caloriesBannerDescription,
    caloriesBannerDescription = _ref$caloriesBannerDe === void 0 ? '' : _ref$caloriesBannerDe,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$isPreviousAction2 = _ref.isPreviousActionOnBottom,
    isPreviousActionOnBottom = _ref$isPreviousAction2 === void 0 ? false : _ref$isPreviousAction2,
    _ref$skipAction = _ref.skipAction,
    skipAction = _ref$skipAction === void 0 ? null : _ref$skipAction,
    _ref$isViewOrderDisab = _ref.isViewOrderDisabled,
    isViewOrderDisabled = _ref$isViewOrderDisab === void 0 ? false : _ref$isViewOrderDisab,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$showComboFilterN = _ref.showComboFilterName,
    showComboFilterName = _ref$showComboFilterN === void 0 ? true : _ref$showComboFilterN;
  var shouldShowCoupon = !spacer && isCouponEnabled && showCouponButton;
  var showFooter = previousAction || nextAction || enableCancelOrder;
  var showMiniCart = showMiniCartSlider && isMiniCartEnabled;
  var footerProps = {
    isViewOrderDisabled: isViewOrderDisabled,
    nextText: nextText,
    nextAction: nextAction,
    isNextActionOnBottom: isNextActionOnBottom,
    isBasketCountOnBottom: isBasketCountOnBottom,
    isQuantityControllerOnBottom: isQuantityControllerOnBottom,
    isPriceOnEnd: isPriceOnEnd,
    allowNextAction: allowNextAction,
    nextActionClass: nextActionClass,
    className: className,
    spacer: spacer,
    count: count,
    enableCancelOrder: enableCancelOrder,
    enableCustomCancelOrder: enableCustomCancelOrder,
    cancelOrderText: cancelOrderText,
    showAccessibilityButton: showAccessibilityButton,
    showBottom: showBottom,
    showBasketCount: showBasketCount,
    showMiniCartSlider: showMiniCartSlider,
    isMiniCartEnabled: isMiniCartEnabled,
    onBasketClick: onBasketClick,
    total: total,
    OverwriteCartIcon: OverwriteCartIcon,
    CustomSecondaryButton: CustomSecondaryButton,
    CustomNextActionButton: CustomNextActionButton,
    CustomPreviousActionButton: CustomPreviousActionButton,
    BasketCount: BasketCount$1,
    basketText: basketText,
    couponText: couponText,
    isCouponEnabled: isCouponEnabled,
    showCouponButton: showCouponButton,
    couponAction: couponAction,
    isPreviousActionEnabled: isPreviousActionEnabled,
    allowPreviousAction: allowPreviousAction,
    previousText: previousText,
    previousAction: previousAction,
    origin: origin,
    onSelectCustomisationProduct: onSelectCustomisationProduct,
    isAnimationTargetEnabled: isAnimationTargetEnabled,
    isFooterStyleVariationEnabled: isFooterStyleVariationEnabled,
    shouldShowCoupon: shouldShowCoupon,
    hasUnavailableItems: hasUnavailableItems,
    isDefaultButtonPaddingEnabled: isDefaultButtonPaddingEnabled,
    termsAndConditionsButtonText: termsAndConditionsButtonText,
    showTermsAndConditionsButton: showTermsAndConditionsButton,
    setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
    isPreviousActionOnBottom: isPreviousActionOnBottom,
    skipAction: skipAction,
    t: t,
    shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath,
    showComboFilterName: showComboFilterName
  };
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [caloriesBannerEnabled && caloriesBannerDescription !== '' && /*#__PURE__*/jsxRuntime.jsx(BannerWarning, {
      className: "items-center p-2 pb-8 m-8 text-center bg-white shadow-lg md:p-4 font-card banner-warning",
      backgroundColor: "bg-white",
      description: caloriesBannerDescription
    }), showMiniCart && /*#__PURE__*/jsxRuntime.jsx(MiniCartWrapper, _extends({}, footerProps)), showBottom && /*#__PURE__*/jsxRuntime.jsx(AdditionalFooter, _extends({}, footerProps)), showFooter && /*#__PURE__*/jsxRuntime.jsx(FooterWrapper, _extends({}, footerProps))]
  });
};

var useCategoriesHeader = function useCategoriesHeader(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$offersAndRewards = _ref.offersAndRewardsCategories,
    offersAndRewardsCategories = _ref$offersAndRewards === void 0 ? [] : _ref$offersAndRewards;
  var history = reactRouterDom.useHistory();
  var sliderContainer = React.useRef(null);
  var flags = launchdarklyReactClientSdk.useFlags();
  var _useParams = reactRouterDom.useParams(),
    id = _useParams.id;
  var routeMatch = reactRouterDom.useRouteMatch();
  var _useRestaurantMenu = useRestaurantMenu(),
    categories = _useRestaurantMenu.categories,
    settings = _useRestaurantMenu.settings,
    products = _useRestaurantMenu.products;
  var _useLocaleSelection = useLocaleSelection(),
    i18n = _useLocaleSelection.i18n;
  var _useState = React.useState(0),
    childJumpCount = _useState[0],
    setChildJumpCount = _useState[1];
  var _useState2 = React.useState(id),
    selectedCategoryId = _useState2[0],
    setSelectedCategoryId = _useState2[1];
  var _useState3 = React.useState(false),
    userSelected = _useState3[0],
    setUserSelected = _useState3[1];
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var setCurrentCategory = recoil.useSetRecoilState(atoms.currentCategoryState);
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    offersAndRewards = _useOffersAndRewardsM.offersAndRewards;
  var _useAnalytics = jitsu.useAnalytics(),
    setViewItemListTrack = _useAnalytics.setViewItemListTrack;
  var _ref2 = sliderContainer || {},
    container = _ref2.current;
  var _ref3 = container || {},
    _ref3$clientWidth = _ref3.clientWidth,
    containerWidth = _ref3$clientWidth === void 0 ? 0 : _ref3$clientWidth,
    child = _ref3.firstChild,
    _ref3$childElementCou = _ref3.childElementCount,
    childCount = _ref3$childElementCou === void 0 ? 0 : _ref3$childElementCou;
  var _ref4 = child || {},
    _ref4$clientWidth = _ref4.clientWidth,
    childWidth = _ref4$clientWidth === void 0 ? 1 : _ref4$clientWidth;
  var _ref5 = i18n || {},
    language = _ref5.language;
  var translateInline = translateProductName(language);
  var _useState4 = React.useState(false),
    hasChildLeftJump = _useState4[0],
    setHasChildLeftJump = _useState4[1];
  var _useState5 = React.useState(false),
    hasChildRightJump = _useState5[0],
    setHasChildRightJump = _useState5[1];
  var childJumpRange = Math.floor(containerWidth / childWidth);
  var childJumpMaxCount = Math.ceil(childCount / childJumpRange);
  var scrollRight = function scrollRight() {
    setUserSelected(true);
    var nextChildJumpCount = Math.min(childJumpCount + 1, childJumpMaxCount - 1);
    setChildJumpCount(nextChildJumpCount);
    container.scroll({
      left: nextChildJumpCount * childJumpRange * childWidth,
      top: 0,
      behavior: 'smooth'
    });
  };
  var scrollLeft = function scrollLeft() {
    setUserSelected(true);
    var nextChildJumpCount = Math.max(childJumpCount - 1, 0);
    setChildJumpCount(nextChildJumpCount);
    container.scroll({
      left: nextChildJumpCount * childJumpRange * childWidth,
      top: 0,
      behavior: 'smooth'
    });
  };

  // scroll the slider to the selected category
  React.useEffect(function () {
    var container = sliderContainer.current;
    if (!container || userSelected) return;
    var selectedItemIndex = formattedCategories.findIndex(function (category) {
      return category.isSelected;
    });
    if (selectedItemIndex !== -1) {
      var _containerWidth = container.clientWidth;
      var itemWidth = container.scrollWidth / formattedCategories.length;
      var selectedItemOffset = selectedItemIndex * itemWidth;
      var containerScrollLeft = container.scrollLeft;
      var itemOffsetRelativeToContainer = selectedItemOffset - containerScrollLeft;
      if (itemOffsetRelativeToContainer < 0 || itemOffsetRelativeToContainer + itemWidth > _containerWidth) {
        var scrollPosition = Math.min(selectedItemOffset, container.scrollWidth - _containerWidth);
        container.scroll({
          left: scrollPosition,
          behavior: 'smooth'
        });

        // Re-calculate childWidth and childJumpRange using live values.

        var firstChildElement = container.firstChild;
        var liveChildWidth = firstChildElement ? firstChildElement.clientWidth : 0;
        var liveChildJumpRange = Math.floor(_containerWidth / liveChildWidth);
        setChildJumpCount(Math.floor(selectedItemOffset / (liveChildJumpRange * liveChildWidth)));
      }
    }
  }, [selectedCategoryId, formattedCategories, userSelected, childJumpRange, childWidth]);
  var categoriesWithOffersAndRewards = lodash.compact(offersAndRewardsCategories).map(function (item) {
    return _extends({}, item, {
      isSelected: item.path === routeMatch.path,
      onClick: function onClick() {
        setSelectedCategoryId(item.id);
        history.push(item.path);
      }
    });
  });
  var formattedCategories = categories == null ? void 0 : categories.filter(filterByTimeRestrictions({
    settings: settings,
    flags: flags
  })).filter(function (category) {
    var parent = category.parent;
    // Filter item which is 0 (false)
    return parent.filter(function (item) {
      return item === 0;
    }).length > 0;
  }).map(function (category) {
    var id = category.id,
      _category$name = category.name,
      name = _category$name === void 0 ? {} : _category$name,
      _category$imageUrl = category.imageUrl,
      imageUrl = _category$imageUrl === void 0 ? '' : _category$imageUrl,
      dualBrand = category.dualBrand,
      children = category.children;
    return _extends({
      imageUrl: imageUrl,
      title: translateInline(name),
      isSelected: "" + id === "" + selectedCategoryId,
      onClick: function onClick() {
        setSelectedCategoryId(id);
        setCurrentCategory(name == null ? void 0 : name.text);
        var productsFromCategory = getHydratedProductsFromCategory({
          category: category,
          id: id,
          hydratedProducts: products,
          offersAndRewards: offersAndRewards
        });
        setViewItemListTrack({
          deviceSettings: kioskSettings.kiosk,
          products: productsFromCategory,
          overrides: {
            item_id: id,
            item_list_name: name == null ? void 0 : name.text
          }
        });
        return (children == null ? void 0 : children.length) > 0 ? history.push("/categories/" + id) : history.push("/category/" + id);
      }
    }, dualBrand && {
      dualBrand: dualBrand
    });
  });

  // Scroll events useEffect
  React.useEffect(function () {
    var container = sliderContainer.current;
    if (!container) return;

    // Checks the scroll position and updates arrow visibility
    var updateArrowVisibility = function updateArrowVisibility() {
      var tolerance = 5;
      setHasChildLeftJump(container.scrollLeft > tolerance);
      setHasChildRightJump(container.scrollLeft < container.scrollWidth - container.clientWidth - tolerance);
    };
    updateArrowVisibility();
    container.addEventListener('scroll', updateArrowVisibility);
    return function () {
      container.removeEventListener('scroll', updateArrowVisibility);
    };
  }, [sliderContainer, formattedCategories]);
  return {
    formattedCategories: [].concat(categoriesWithOffersAndRewards, formattedCategories),
    sliderContainer: sliderContainer,
    hasChildLeftJump: hasChildLeftJump,
    hasChildRightJump: hasChildRightJump,
    selectedCategoryId: selectedCategoryId,
    userSelected: userSelected,
    scrollRight: scrollRight,
    scrollLeft: scrollLeft
  };
};

var CategoriesHeader = function CategoriesHeader(_temp) {
  var _formattedCategories$;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$isItemRounded = _ref.isItemRounded,
    isItemRounded = _ref$isItemRounded === void 0 ? true : _ref$isItemRounded,
    _ref$isSliderEnabled = _ref.isSliderEnabled,
    isSliderEnabled = _ref$isSliderEnabled === void 0 ? true : _ref$isSliderEnabled,
    _ref$isIconMinimal = _ref.isIconMinimal,
    isIconMinimal = _ref$isIconMinimal === void 0 ? false : _ref$isIconMinimal,
    _ref$maxCategories = _ref.maxCategories,
    maxCategories = _ref$maxCategories === void 0 ? 9 : _ref$maxCategories,
    _ref$offersAndRewards = _ref.offersAndRewardsCategories,
    offersAndRewardsCategories = _ref$offersAndRewards === void 0 ? [] : _ref$offersAndRewards;
  var _useCategoriesHeader = useCategoriesHeader({
      offersAndRewardsCategories: offersAndRewardsCategories
    }),
    _useCategoriesHeader$ = _useCategoriesHeader.formattedCategories,
    formattedCategories = _useCategoriesHeader$ === void 0 ? [] : _useCategoriesHeader$,
    sliderContainer = _useCategoriesHeader.sliderContainer,
    hasChildLeftJump = _useCategoriesHeader.hasChildLeftJump,
    hasChildRightJump = _useCategoriesHeader.hasChildRightJump,
    scrollRight = _useCategoriesHeader.scrollRight,
    scrollLeft = _useCategoriesHeader.scrollLeft;
  var categoryIconStylesLeft = (hasChildLeftJump ? '' : 'invisible') + " text-primary category-icon";
  var categoryIconStylesRight = (hasChildRightJump ? '' : 'invisible') + " text-primary category-icon";
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "categories-header",
    className: "categories-header",
    children: [isSliderEnabled && isIconMinimal ? /*#__PURE__*/jsxRuntime.jsx(ArrowLeft, {
      className: categoryIconStylesLeft,
      onClick: scrollLeft,
      "data-test": "scroll-left-button"
    }) : /*#__PURE__*/jsxRuntime.jsx(SolidArrowCircleLeft, {
      className: categoryIconStylesLeft,
      onClick: scrollLeft,
      "data-test": "scroll-left-button"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "categories-header-row",
      ref: sliderContainer,
      children: (_formattedCategories$ = formattedCategories.map(function (_ref2, index) {
        var title = _ref2.title,
          imageUrl = _ref2.imageUrl,
          isSelected = _ref2.isSelected,
          onClick = _ref2.onClick;
        return /*#__PURE__*/jsxRuntime.jsxs("div", {
          "data-test": "category-item",
          "aria-selected": isSelected,
          className: "categories-header-item",
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "category-image",
            className: "categories-header-item-image border-primary " + (isItemRounded && 'rounded-full'),
            onClick: onClick,
            children: /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
              alt: title,
              src: imageUrl
            })
          }), /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "categories-header-item-text " + (isSelected && "border-primary categories-header-item-text-selected"),
            "aria-selected": isSelected,
            children: title
          })]
        }, index);
      })).slice.apply(_formattedCategories$, isSliderEnabled ? [] : [0, maxCategories])
    }), isSliderEnabled && isIconMinimal ? /*#__PURE__*/jsxRuntime.jsx(MinimalArrowCircleRight, {
      "data-test": "scroll-right-button",
      className: categoryIconStylesRight,
      onClick: scrollRight
    }) : /*#__PURE__*/jsxRuntime.jsx(SolidArrowCircleRight, {
      "data-test": "scroll-right-button",
      className: categoryIconStylesRight,
      onClick: scrollRight
    })]
  });
};

var ModalTimeoutError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(ModalTimeoutError, _Error);
  function ModalTimeoutError(message) {
    var _this;
    _this = _Error.call(this, message) || this;
    _this.name = 'TimeoutError';
    return _this;
  }
  return ModalTimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var useModalPromise = function useModalPromise(options) {
  var timeoutSeconds = 10;
  if (options && options.timeoutSeconds !== null) {
    timeoutSeconds = options.timeoutSeconds;
  }
  var _useState = React.useState({
      open: false
    }),
    modal = _useState[0],
    setModal = _useState[1];
  var modalTimeoutId = React.useRef();
  React.useEffect(function () {
    return function () {
      return clearTimeout(modalTimeoutId.current);
    };
  }, []);
  var showModal = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cb) {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return new Promise(function (resolve, reject) {
              clearTimeout(modalTimeoutId.current);
              modalTimeoutId.current = setTimeout(function () {
                return reject(new ModalTimeoutError("Modal timed out after " + timeoutSeconds + " seconds"));
              }, timeoutSeconds * 1000);
              var modalPayload = cb(resolve, reject);
              setModal(_extends({
                open: true
              }, modalPayload));
            });
          case 3:
            result = _context.sent;
            _context.next = 10;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            if (_context.t0 instanceof ModalTimeoutError) {
              setModal({
                open: false
              });
            }
            throw _context.t0;
          case 10:
            setModal({
              open: false
            });
            return _context.abrupt("return", result);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [setModal, timeoutSeconds]);
  return {
    modal: modal,
    showModal: showModal
  };
};

var useLoyaltyBanner = function useLoyaltyBanner() {
  var _history$location;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var history = reactRouterDom.useHistory();
  var currentRoute = (history == null ? void 0 : (_history$location = history.location) == null ? void 0 : _history$location.pathname) || '';
  var _useLocation = reactRouterDom.useLocation(),
    locationState = _useLocation.state;
  var _useRecoilState = recoil.useRecoilState(atoms.loyaltyState),
    loyaltyUser = _useRecoilState[0];
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useModalPromise = useModalPromise({
      timeoutSeconds: 20
    }),
    modal = _useModalPromise.modal,
    showModal = _useModalPromise.showModal;
  var _useCancelOrder = useCancelOrder(),
    cancelOrder = _useCancelOrder.cancelOrder;
  var modalAccessibilityClass = accessibilityEnabled ? 'h-half bottom-0 left-0 right-0' : 'inset-0';
  var loyaltyEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.loyalty',
    defaultValue: false
  });
  var openLoyaltyLoginPage = function openLoyaltyLoginPage() {
    history.push('/loyalty-login', _extends({}, locationState, {
      from: currentRoute
    }));
  };
  var _ref = loyaltyUser || {},
    token = _ref.token;
  var isLoggedIn = !!token;
  return {
    modal: modal,
    showModal: showModal,
    cancelOrder: cancelOrder,
    modalAccessibilityClass: modalAccessibilityClass,
    loyaltyEnabled: loyaltyEnabled,
    isLoggedIn: isLoggedIn,
    loyaltyUser: loyaltyUser,
    history: history,
    t: t,
    openLoyaltyLoginPage: openLoyaltyLoginPage
  };
};

var EMPTY_FUNC = function EMPTY_FUNC() {};
var DefaultMemberTitleComponent = function DefaultMemberTitleComponent(_ref) {
  var t = _ref.t,
    _ref$loyaltyUser = _ref.loyaltyUser,
    points = _ref$loyaltyUser.points,
    name = _ref$loyaltyUser.name;
  return /*#__PURE__*/jsxRuntime.jsx("p", {
    "data-test": "loyalty-banner-member",
    className: "loyalty-banner-text-wrapper-member",
    children: t('loyaltyBannerMember', {
      totalPoints: points,
      name: name
    })
  });
};
var LoggedIn = function LoggedIn(_ref2) {
  var loyaltyUser = _ref2.loyaltyUser,
    _ref2$MemberTitleComp = _ref2.MemberTitleComponent,
    MemberTitleComponent = _ref2$MemberTitleComp === void 0 ? DefaultMemberTitleComponent : _ref2$MemberTitleComp,
    hasOffersPageLink = _ref2.hasOffersPageLink,
    _ref2$onSignOut = _ref2.onSignOut,
    onSignOut = _ref2$onSignOut === void 0 ? EMPTY_FUNC : _ref2$onSignOut,
    _ref2$computedAction = _ref2.computedAction,
    computedAction = _ref2$computedAction === void 0 ? EMPTY_FUNC : _ref2$computedAction,
    t = _ref2.t;
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "loyalty-banner-logged-in",
      className: "loyalty-banner",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "loyalty-banner-text-wrapper",
        children: /*#__PURE__*/jsxRuntime.jsx(MemberTitleComponent, {
          t: t,
          loyaltyUser: loyaltyUser
        })
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "loyalty-banner-button-wrapper",
        children: [hasOffersPageLink && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "loyalty-banner-button-wrapper-offers",
          "data-test": "loyalty-banner-offers",
          onClick: function onClick() {
            return computedAction('/loyalty-offers');
          },
          children: "" + t('loyaltyBannerOffers')
        }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "loyalty-banner-button-wrapper-logout",
          "data-test": "loyalty-banner-logout",
          onClick: onSignOut,
          children: "" + t('loyaltyBannerLogout')
        })]
      })]
    })
  });
};

var DefaultGuestTitleComponent = function DefaultGuestTitleComponent(_ref) {
  var t = _ref.t;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col",
    children: [/*#__PURE__*/jsxRuntime.jsx("p", {
      "data-test": "loyalty-banner-title",
      className: "loyalty-banner-text-wrapper-title",
      children: t('loyaltyBannerTitle')
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      "data-test": "loyalty-banner-subtitle",
      className: "loyalty-banner-text-wrapper-title",
      children: t('loyaltyBannerSubtitle')
    })]
  });
};
var LoggedOut = function LoggedOut(_ref2) {
  var t = _ref2.t,
    _ref2$GuestTitleCompo = _ref2.GuestTitleComponent,
    GuestTitleComponent = _ref2$GuestTitleCompo === void 0 ? DefaultGuestTitleComponent : _ref2$GuestTitleCompo,
    openLoyaltyLoginPage = _ref2.openLoyaltyLoginPage;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "loyalty-banner-logged-out",
    className: "loyalty-banner",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "loyalty-banner-text-wrapper",
      children: /*#__PURE__*/jsxRuntime.jsx(GuestTitleComponent, {
        t: t
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "loyalty-banner-button-wrapper",
      children: /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
        className: "loyalty-banner-button-wrapper-login",
        "data-test": "loyalty-banner-login",
        onClick: openLoyaltyLoginPage,
        children: "" + t('loyaltyBannerLogin')
      })
    })]
  });
};

var DefaultSignOutModal = function DefaultSignOutModal(_ref) {
  var modal = _ref.modal,
    modalAccessibilityClass = _ref.modalAccessibilityClass,
    t = _ref.t;
  return /*#__PURE__*/jsxRuntime.jsx(Modal, {
    className: modalAccessibilityClass,
    open: modal.open,
    title: t('loyaltyLogOutModalConfirm'),
    action: modal.onCancel,
    closeModal: modal.onSignOut,
    actionText: t('cancelOrderButtonModalPrimaryAction'),
    closeText: t('cancelOrderButtonModalSecondaryAction')
  });
};

var EMPTY_FUNC$1 = function EMPTY_FUNC() {};
var LoyaltyBanner = function LoyaltyBanner(_ref) {
  var _ref$computedAction = _ref.computedAction,
    computedAction = _ref$computedAction === void 0 ? EMPTY_FUNC$1 : _ref$computedAction,
    _ref$SignOutModal = _ref.SignOutModal,
    SignOutModal = _ref$SignOutModal === void 0 ? DefaultSignOutModal : _ref$SignOutModal,
    _ref$hasOffersPageLin = _ref.hasOffersPageLink,
    hasOffersPageLink = _ref$hasOffersPageLin === void 0 ? false : _ref$hasOffersPageLin,
    MemberTitleComponent = _ref.MemberTitleComponent,
    GuestTitleComponent = _ref.GuestTitleComponent;
  var _useLoyaltyBanner = useLoyaltyBanner(),
    modal = _useLoyaltyBanner.modal,
    showModal = _useLoyaltyBanner.showModal,
    cancelOrder = _useLoyaltyBanner.cancelOrder,
    loyaltyEnabled = _useLoyaltyBanner.loyaltyEnabled,
    openLoyaltyLoginPage = _useLoyaltyBanner.openLoyaltyLoginPage,
    loyaltyUser = _useLoyaltyBanner.loyaltyUser,
    isLoggedIn = _useLoyaltyBanner.isLoggedIn,
    modalAccessibilityClass = _useLoyaltyBanner.modalAccessibilityClass,
    t = _useLoyaltyBanner.t;
  var handleSignout = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var shouldSignout;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return showModal(function (resolve, _) {
              return {
                onSignOut: function onSignOut() {
                  return resolve(true);
                },
                onCancel: function onCancel() {
                  return resolve(false);
                }
              };
            });
          case 2:
            shouldSignout = _context.sent;
            if (shouldSignout) {
              jitsu.setLoyaltyLogoutSuccessTrack();
              cancelOrder();
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSignout() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!loyaltyEnabled) return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {});
  if (isLoggedIn) return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(LoggedIn, {
      loyaltyUser: loyaltyUser,
      computedAction: computedAction,
      onSignOut: handleSignout,
      MemberTitleComponent: MemberTitleComponent,
      hasOffersPageLink: hasOffersPageLink,
      t: t
    }), /*#__PURE__*/jsxRuntime.jsx(SignOutModal, {
      modal: modal,
      t: t,
      modalAccessibilityClass: modalAccessibilityClass
    })]
  });
  return /*#__PURE__*/jsxRuntime.jsx(LoggedOut, {
    GuestTitleComponent: GuestTitleComponent,
    openLoyaltyLoginPage: openLoyaltyLoginPage,
    t: t
  });
};

var Header = function Header(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? null : _ref$total,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$showBasketCount = _ref.showBasketCount,
    showBasketCount = _ref$showBasketCount === void 0 ? true : _ref$showBasketCount,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? false : _ref$showCategoriesHe,
    _ref$onBasketClick = _ref.onBasketClick,
    onBasketClick = _ref$onBasketClick === void 0 ? function () {} : _ref$onBasketClick,
    _ref$previousAction = _ref.previousAction,
    previousAction = _ref$previousAction === void 0 ? null : _ref$previousAction,
    _ref$menuAction = _ref.menuAction,
    menuAction = _ref$menuAction === void 0 ? null : _ref$menuAction,
    _ref$menuText = _ref.menuText,
    menuText = _ref$menuText === void 0 ? '' : _ref$menuText,
    _ref$allowPreviousAct = _ref.allowPreviousAction,
    allowPreviousAction = _ref$allowPreviousAct === void 0 ? true : _ref$allowPreviousAct,
    _ref$showSubtotal = _ref.showSubtotal,
    showSubtotal = _ref$showSubtotal === void 0 ? true : _ref$showSubtotal,
    _ref$couponText = _ref.couponText,
    couponText = _ref$couponText === void 0 ? 'Enter offer' : _ref$couponText,
    _ref$isCouponEnabled = _ref.isCouponEnabled,
    isCouponEnabled = _ref$isCouponEnabled === void 0 ? false : _ref$isCouponEnabled,
    _ref$showCouponButton = _ref.showCouponButton,
    showCouponButton = _ref$showCouponButton === void 0 ? false : _ref$showCouponButton,
    _ref$couponAction = _ref.couponAction,
    couponAction = _ref$couponAction === void 0 ? function () {} : _ref$couponAction,
    _ref$computedAction = _ref.computedAction,
    computedAction = _ref$computedAction === void 0 ? function () {} : _ref$computedAction,
    _ref$showLoyaltyBanne = _ref.showLoyaltyBanner,
    showLoyaltyBanner = _ref$showLoyaltyBanne === void 0 ? false : _ref$showLoyaltyBanne;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "header",
    className: "flex flex-col py-12 bg-header " + className,
    children: [showCategoriesHeader && /*#__PURE__*/jsxRuntime.jsx(CategoriesHeader, {}), showLoyaltyBanner && /*#__PURE__*/jsxRuntime.jsx(LoyaltyBanner, {
      computedAction: computedAction
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "header-title",
      className: "flex justify-between mb-8",
      children: /*#__PURE__*/jsxRuntime.jsx("h1", {
        className: "px-8 text-6xl font-bold font-header",
        children: title
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "top-0 items-start space-x-4",
        children: previousAction && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          disabled: !allowPreviousAction,
          onClick: menuAction,
          className: "mr-6",
          "data-test": "menu-button",
          children: menuText
        })
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex space-x-8",
        children: [showBasketCount && /*#__PURE__*/jsxRuntime.jsx(BasketCount, {
          count: count,
          onClick: onBasketClick
        }), showSubtotal && /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "text-6xl font-bold",
          "data-test": "header-cart-subtotal",
          children: formatPrice({
            price: total
          })
        }), isCouponEnabled && showCouponButton && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "ml-8 text-4xl font-bold",
          onClick: couponAction,
          "data-test": "enter-offer-button",
          children: couponText
        })]
      })]
    })]
  });
};

var _excluded$2 = ["header", "footer", "timeoutEnabledOverride", "timeoutActionOverride"];
var useTemplate = function useTemplate(_ref) {
  var _settings$settings2, _settings$settings2$m, _orderPayload$cart, _orderPayload$cart$it, _history$location;
  var _ref$timeoutEnabled = _ref.timeoutEnabled,
    timeoutEnabled = _ref$timeoutEnabled === void 0 ? false : _ref$timeoutEnabled,
    _ref$templateOverride = _ref.templateOverride,
    templateOverride = _ref$templateOverride === void 0 ? false : _ref$templateOverride,
    accessibilityActionEnabled = _ref.accessibilityActionEnabled,
    footerEnabled = _ref.footerEnabled;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var history = reactRouterDom.useHistory();
  var _useLocation = reactRouterDom.useLocation(),
    locationState = _useLocation.state;
  var total = recoil.useRecoilValue(atoms.orderTotalState);
  var count = recoil.useRecoilValue(atoms.orderCountState);
  var settings = recoil.useRecoilValue(atoms.settingsState);
  var orderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState);
  var onlineStatus = recoil.useRecoilValue(atoms.onlineStatusState);
  var _onlineStatus$isOnlin = onlineStatus.isOnline,
    isOnline = _onlineStatus$isOnlin === void 0 ? true : _onlineStatus$isOnlin;
  var _settings$settings = settings.settings,
    config = _settings$settings === void 0 ? {} : _settings$settings;
  var _config$content = config.content,
    content = _config$content === void 0 ? {} : _config$content,
    homePageCustomisation = config.homePageCustomisation;
  var isSecondaryHome = content.homeBurger;
  var homeMode = isSecondaryHome ? 'secondary' : 'primary';
  var _ref2 = (orderPayload == null ? void 0 : orderPayload.financialSummary) || {},
    _ref2$taxes = _ref2.taxes,
    taxes = _ref2$taxes === void 0 ? null : _ref2$taxes;
  var formattedTaxes = total === 0 ? 0 : taxes && Number(taxes.toFixed(2));
  var isCouponEnabled = settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$m = _settings$settings2.modes) == null ? void 0 : _settings$settings2$m.coupon;
  var hasUnavailableItems = orderPayload == null ? void 0 : (_orderPayload$cart = orderPayload.cart) == null ? void 0 : (_orderPayload$cart$it = _orderPayload$cart.items) == null ? void 0 : _orderPayload$cart$it.some(function (item) {
    return !item.isAvailable;
  });
  var _useRecoilValue = recoil.useRecoilValue(atoms.templateState),
    header = _useRecoilValue.header,
    footer = _useRecoilValue.footer,
    _useRecoilValue$timeo = _useRecoilValue.timeoutEnabledOverride,
    timeoutEnabledOverride = _useRecoilValue$timeo === void 0 ? timeoutEnabled : _useRecoilValue$timeo,
    timeoutActionOverride = _useRecoilValue.timeoutActionOverride,
    rest = _objectWithoutPropertiesLoose(_useRecoilValue, _excluded$2);
  var currentRoute = (history == null ? void 0 : (_history$location = history.location) == null ? void 0 : _history$location.pathname) || '';
  var modalAccessibilityClass = accessibilityEnabled ? 'h-half bottom-0 left-0 right-0' : 'inset-0';
  var isTimeoutEnabled = templateOverride ? timeoutEnabledOverride : timeoutEnabled;
  var menuText = t('templateMenuAction');
  var menuAction = React.useCallback(function () {
    return history.push('/categories');
  }, [history]);
  var couponText = t('templateCouponAction');
  var computedAction = React.useCallback(function (path) {
    return history.push(path, _extends({}, locationState, {
      from: currentRoute
    }));
  }, [history, currentRoute, locationState]);
  var couponAction = React.useCallback(function () {
    return computedAction('/coupon');
  }, [computedAction]);
  var basketText = t('templateBasketAction');
  var cancelOrderText = t('templateCancelAction');
  /**
   * These are static props which means that they aren't view dependent.
   * Even though, the views can still override them.
   */
  var staticProps = {
    menuAction: menuAction,
    computedAction: computedAction,
    couponAction: couponAction,
    menuText: menuText,
    couponText: couponText,
    cancelOrderText: cancelOrderText,
    basketText: basketText,
    currentRoute: currentRoute,
    total: formatPrice({
      price: total
    }),
    count: count,
    showAccessibilityButton: accessibilityActionEnabled && footerEnabled,
    showCouponButton: false,
    formattedTaxes: formatPrice({
      price: formattedTaxes
    })
  };
  var getBackgroundImage = function getBackgroundImage(props) {
    if (props === void 0) {
      props = {};
    }
    var fallbackImage = isSecondaryHome ? props.secondaryImage : props.primaryImage;
    var serverImageUrl = isSecondaryHome ? homePageCustomisation == null ? void 0 : homePageCustomisation.secondaryBackgroundUrl : homePageCustomisation == null ? void 0 : homePageCustomisation.primaryBackgroundUrl;
    var images = [serverImageUrl, fallbackImage].filter(function (image) {
      return image;
    }).map(function (image) {
      return "url('" + image + "')";
    });
    if (images.length === 0) {
      return {};
    }
    return {
      backgroundImage: images.join(',')
    };
  };
  return _extends({}, rest, {
    modalAccessibilityClass: modalAccessibilityClass,
    accessibilityEnabled: accessibilityEnabled,
    isTimeoutEnabled: isTimeoutEnabled,
    isCouponEnabled: isCouponEnabled,
    header: _extends({}, staticProps, header, {
      homeMode: homeMode
    }),
    footer: _extends({}, staticProps, footer),
    showAccessibilityButton: accessibilityActionEnabled,
    timeoutActionOverride: timeoutActionOverride,
    t: t,
    isOnline: isOnline,
    hasUnavailableItems: hasUnavailableItems,
    getBackgroundImage: getBackgroundImage,
    isSecondaryHome: isSecondaryHome,
    currentRoute: currentRoute
  });
};

var DefaultTemplate = function DefaultTemplate(_ref) {
  var children = _ref.children,
    _ref$timeoutEnabled = _ref.timeoutEnabled,
    timeoutEnabled = _ref$timeoutEnabled === void 0 ? true : _ref$timeoutEnabled,
    _ref$footerEnabled = _ref.footerEnabled,
    footerEnabled = _ref$footerEnabled === void 0 ? true : _ref$footerEnabled,
    _ref$headerEnabled = _ref.headerEnabled,
    headerEnabled = _ref$headerEnabled === void 0 ? true : _ref$headerEnabled,
    _ref$templateOverride = _ref.templateOverride,
    templateOverride = _ref$templateOverride === void 0 ? false : _ref$templateOverride,
    _ref$accessibilityEna = _ref.accessibilityEnabled,
    accessibilityEnabled = _ref$accessibilityEna === void 0 ? true : _ref$accessibilityEna;
  var _useTemplate = useTemplate({
      timeoutEnabled: timeoutEnabled,
      templateOverride: templateOverride,
      accessibilityActionEnabled: accessibilityEnabled,
      footerEnabled: footerEnabled
    }),
    header = _useTemplate.header,
    footer = _useTemplate.footer,
    modalAccessibilityClass = _useTemplate.modalAccessibilityClass,
    isTimeoutEnabled = _useTemplate.isTimeoutEnabled,
    timeoutActionOverride = _useTemplate.timeoutActionOverride,
    showAccessibilityButton = _useTemplate.showAccessibilityButton,
    isOnline = _useTemplate.isOnline,
    isCouponEnabled = _useTemplate.isCouponEnabled;
  return /*#__PURE__*/jsxRuntime.jsx(AccessibilityWrapper, {
    isAccessibilityButtonEnabled: showAccessibilityButton,
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col w-screen h-full",
      children: [headerEnabled && /*#__PURE__*/jsxRuntime.jsx(Header, _extends({}, header, {
        isCouponEnabled: isCouponEnabled
      })), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex-grow overflow-auto",
        children: children
      }), footerEnabled && /*#__PURE__*/jsxRuntime.jsx(Footer, _extends({}, footer, {
        isCouponEnabled: isCouponEnabled
      })), showAccessibilityButton && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex flex-col items-start justify-center",
        children: /*#__PURE__*/jsxRuntime.jsx(AccessibilityButton, {
          className: "absolute bottom-0 block w-24 h-24 p-2 m-8 shadow-lg"
        })
      }), isTimeoutEnabled && isOnline && /*#__PURE__*/jsxRuntime.jsx(TimeoutModal, {
        onTimeout: timeoutActionOverride,
        modalAccessibilityClass: modalAccessibilityClass
      })]
    })
  });
};

var SettingsViewContext = /*#__PURE__*/React.createContext();
var SettingsViewProvider = function SettingsViewProvider(_ref) {
  var children = _ref.children;
  // TODO this should be the `useSettings` hook
  var _useRecoilState = recoil.useRecoilState(atoms.settingsState),
    settings = _useRecoilState[0];
  var available = {
    settings: settings
  };
  return /*#__PURE__*/jsxRuntime.jsx(SettingsViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useSettingsViewContext = function useSettingsViewContext() {
  var context = React.useContext(SettingsViewContext);
  if (context === undefined) {
    throw new Error('useSettingsViewContext must be used within a SettingsViewProvider');
  }
  return context;
};

var useSettingsView = function useSettingsView() {
  var _useSettingsViewConte = useSettingsViewContext(),
    settings = _useSettingsViewConte.settings;
  return {
    settings: settings
  };
};

var SettingsView = function SettingsView() {
  var _useSettingsView = useSettingsView(),
    settings = _useSettingsView.settings;
  return /*#__PURE__*/jsxRuntime.jsx(Viewer, {
    src: settings,
    collapsed: true
  });
};

var ReceiptViewContext = /*#__PURE__*/React.createContext();
var ReceiptViewProvider = function ReceiptViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$smsPagePath = _ref.smsPagePath,
    smsPagePath = _ref$smsPagePath === void 0 ? '/sms' : _ref$smsPagePath,
    _ref$nextPagePath = _ref.nextPagePath,
    nextPagePath = _ref$nextPagePath === void 0 ? '/reset' : _ref$nextPagePath,
    _ref$showTaxNumber = _ref.showTaxNumber,
    showTaxNumber = _ref$showTaxNumber === void 0 ? true : _ref$showTaxNumber,
    _ref$showSubtotal = _ref.showSubtotal,
    showSubtotal = _ref$showSubtotal === void 0 ? true : _ref$showSubtotal,
    _ref$showTaxTotal = _ref.showTaxTotal,
    showTaxTotal = _ref$showTaxTotal === void 0 ? true : _ref$showTaxTotal,
    _ref$showKitchenId = _ref.showKitchenId,
    showKitchenId = _ref$showKitchenId === void 0 ? false : _ref$showKitchenId,
    _ref$showEnergyInform = _ref.showEnergyInformation,
    showEnergyInformation = _ref$showEnergyInform === void 0 ? false : _ref$showEnergyInform,
    _ref$useLargeButtons = _ref.useLargeButtons,
    useLargeButtons = _ref$useLargeButtons === void 0 ? true : _ref$useLargeButtons,
    _ref$showDotAfterInit = _ref.showDotAfterInitials,
    showDotAfterInitials = _ref$showDotAfterInit === void 0 ? false : _ref$showDotAfterInit,
    _ref$showGSTExcludeMe = _ref.showGSTExcludeMessage,
    showGSTExcludeMessage = _ref$showGSTExcludeMe === void 0 ? false : _ref$showGSTExcludeMe,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showFullFirstNam = _ref.showFullFirstName,
    showFullFirstName = _ref$showFullFirstNam === void 0 ? false : _ref$showFullFirstNam,
    _ref$showTxnId = _ref.showTxnId,
    showTxnId = _ref$showTxnId === void 0 ? false : _ref$showTxnId,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$hideNoPrefixWhen = _ref.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref$hideNoPrefixWhen === void 0 ? false : _ref$hideNoPrefixWhen,
    _ref$delayQRCodeRende = _ref.delayQRCodeRenderInMilliseconds,
    delayQRCodeRenderInMilliseconds = _ref$delayQRCodeRende === void 0 ? 0 : _ref$delayQRCodeRende,
    _ref$showRestaurantNa = _ref.showRestaurantName,
    showRestaurantName = _ref$showRestaurantNa === void 0 ? true : _ref$showRestaurantNa,
    _ref$showAddress = _ref.showAddress,
    showAddress = _ref$showAddress === void 0 ? true : _ref$showAddress,
    _ref$showPhoneNumber = _ref.showPhoneNumber,
    showPhoneNumber = _ref$showPhoneNumber === void 0 ? true : _ref$showPhoneNumber,
    _ref$showSavedAmount = _ref.showSavedAmount,
    showSavedAmount = _ref$showSavedAmount === void 0 ? false : _ref$showSavedAmount;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var payment = recoil.useRecoilValue(atoms.formattedPaymentState);
  var order = recoil.useRecoilValue(atoms.confirmedOrderPayloadState);
  var settings = recoil.useRecoilValue(atoms.settingsState);
  var beacon = recoil.useRecoilValue(atoms.beaconState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var upsellState = recoil.useRecoilValue(atoms.upsellState);
  var addedUpsells = recoil.useRecoilValue(atoms.addedUpsellState);
  var _useCart = cart.useCart(),
    cart$1 = _useCart.cart;
  var flags = launchdarklyReactClientSdk.useFlags();
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useAnalytics = jitsu.useAnalytics(),
    paymentCompletedTrack = _useAnalytics.paymentCompletedTrack;
  var _useState = React.useState(false),
    showTermsAndConditionsModal = _useState[0],
    setShowTermsAndConditionsModal = _useState[1];
  var _useRecoilValue = recoil.useRecoilValue(atoms.computedMetadata),
    currency = _useRecoilValue.currency;
  var available = {
    t: t,
    cart: cart$1,
    order: order,
    beacon: beacon,
    session: session,
    settings: settings,
    setTemplate: setTemplate,
    smsPagePath: smsPagePath,
    nextPagePath: nextPagePath,
    registerProductPurchase: googleAnalytics.registerProductPurchase,
    flags: flags,
    formatPrice: formatPrice,
    upsellState: upsellState,
    addedUpsells: addedUpsells,
    showTaxNumber: showTaxNumber,
    showSubtotal: showSubtotal,
    showTaxTotal: showTaxTotal,
    showKitchenId: showKitchenId,
    showEnergyInformation: showEnergyInformation,
    useLargeButtons: useLargeButtons,
    showDotAfterInitials: showDotAfterInitials,
    showGSTExcludeMessage: showGSTExcludeMessage,
    paymentCompletedTrack: paymentCompletedTrack,
    showTermsAndConditionsModal: showTermsAndConditionsModal,
    setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
    showAddonAvailability: showAddonAvailability,
    showFullFirstName: showFullFirstName,
    currency: currency,
    showTxnId: showTxnId,
    payment: payment,
    shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath,
    hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected,
    delayQRCodeRenderInMilliseconds: delayQRCodeRenderInMilliseconds,
    showRestaurantName: showRestaurantName,
    showAddress: showAddress,
    showPhoneNumber: showPhoneNumber,
    showSavedAmount: showSavedAmount
  };
  return /*#__PURE__*/jsxRuntime.jsx(ReceiptViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useReceiptViewContext = function useReceiptViewContext() {
  var context = React.useContext(ReceiptViewContext);
  if (context === undefined) {
    throw new Error('useReceiptViewContext must be used within a ReceiptViewProvider');
  }
  return context;
};

var toCamelCase = function toCamelCase(inputString) {
  if (!inputString) return '';
  if (/^[a-z][a-zA-Z0-9]*$/.test(inputString)) {
    return inputString;
  }
  var words = inputString.toLowerCase().split(' ');
  if (words.length === 1) {
    return words[0];
  } else {
    var camelCaseWords = words.map(function (word, index) {
      return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
    });
    return camelCaseWords.join('');
  }
};
var arrayToString = function arrayToString(arr) {
  return arr.reduce(function (result, item) {
    if (!result.length) return "" + item;
    return result + ", " + item;
  }, '');
};
var findAndReplaceByUID = function findAndReplaceByUID(array, object) {
  return array.map(function (item) {
    return item.uid === object.uid ? object : item;
  });
};
var isThereSpecialCharacters = function isThereSpecialCharacters(word) {
  if (word === '') return false;
  var regex = /^[A-Za-z0-9ƯĐƠĂÂÊÔก-๙ ]+$/;
  return !regex.test(word);
};
var getFirstName = function getFirstName(firstName) {
  var maxNameCharsLimit = 13;
  if ((firstName == null ? void 0 : firstName.length) > maxNameCharsLimit) return firstName.substring(0, 13);
  return firstName;
};
var getDisplayOrderNumber = function getDisplayOrderNumber(_ref) {
  var _customer$lastName, _customer$firstName, _customer$lastName2;
  var _ref$beacon = _ref.beacon,
    beacon = _ref$beacon === void 0 ? null : _ref$beacon,
    _ref$customer = _ref.customer,
    customer = _ref$customer === void 0 ? null : _ref$customer,
    _ref$orderNumber = _ref.orderNumber,
    orderNumber = _ref$orderNumber === void 0 ? null : _ref$orderNumber,
    _ref$aloha = _ref.aloha,
    aloha = _ref$aloha === void 0 ? null : _ref$aloha,
    _ref$oracleMicros = _ref.oracleMicros,
    oracleMicros = _ref$oracleMicros === void 0 ? null : _ref$oracleMicros,
    _ref$showDotAfterInit = _ref.showDotAfterInitials,
    showDotAfterInitials = _ref$showDotAfterInit === void 0 ? false : _ref$showDotAfterInit,
    _ref$showFullFirstNam = _ref.showFullFirstName,
    showFullFirstName = _ref$showFullFirstNam === void 0 ? false : _ref$showFullFirstNam,
    shouldSkipCustomerDetailsPath = _ref.shouldSkipCustomerDetailsPath;
  if (beacon) return beacon;
  if (aloha != null && aloha.lastNameOrderReference) return customer == null ? void 0 : customer.lastName;
  if (oracleMicros) return orderNumber;
  if (customer && customer != null && customer.firstName && !shouldSkipCustomerDetailsPath) return showFullFirstName ? getFirstName(customer == null ? void 0 : customer.firstName) + ". " + (customer == null ? void 0 : (_customer$lastName = customer.lastName) == null ? void 0 : _customer$lastName.substring(0, 1)) + "." : "" + (customer == null ? void 0 : (_customer$firstName = customer.firstName) == null ? void 0 : _customer$firstName.substring(0, 1)) + (showDotAfterInitials ? '.' : '') + (customer == null ? void 0 : (_customer$lastName2 = customer.lastName) == null ? void 0 : _customer$lastName2.substring(0, 1)) + (showDotAfterInitials ? '.' : '');
  return orderNumber;
};

var buildReceiptDetailsData = function buildReceiptDetailsData(_ref) {
  var _settings$settings, _settings$settings2, _order$payment, _order$cart;
  var _ref$t = _ref.t,
    t = _ref$t === void 0 ? null : _ref$t,
    _ref$order = _ref.order,
    order = _ref$order === void 0 ? null : _ref$order,
    _ref$beacon = _ref.beacon,
    beacon = _ref$beacon === void 0 ? null : _ref$beacon,
    _ref$session = _ref.session,
    session = _ref$session === void 0 ? null : _ref$session,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? null : _ref$settings,
    _ref$showDotAfterInit = _ref.showDotAfterInitials,
    showDotAfterInitials = _ref$showDotAfterInit === void 0 ? false : _ref$showDotAfterInit,
    _ref$showFullFirstNam = _ref.showFullFirstName,
    showFullFirstName = _ref$showFullFirstNam === void 0 ? false : _ref$showFullFirstNam,
    shouldSkipCustomerDetailsPath = _ref.shouldSkipCustomerDetailsPath,
    _ref$beaconOrderNumbe = _ref.beaconOrderNumberEnabled,
    beaconOrderNumberEnabled = _ref$beaconOrderNumbe === void 0 ? false : _ref$beaconOrderNumbe;
  if (!settings) return null;
  if (!session) return null;
  if (!order) return null;
  var receiptId = session.receiptId;
  var _ref2 = (order == null ? void 0 : order.session) || {},
    customer = _ref2.customer;
  var _ref3 = ((_settings$settings = settings.settings) == null ? void 0 : _settings$settings.order) || {},
    _ref3$aloha = _ref3.aloha,
    aloha = _ref3$aloha === void 0 ? {} : _ref3$aloha,
    oracleMicros = _ref3.oracleMicros;
  var _ref4 = (settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : _settings$settings2.receipt) || {},
    _ref4$showInitials = _ref4.showInitials,
    showInitials = _ref4$showInitials === void 0 ? false : _ref4$showInitials;
  var paymentMethod = (order == null ? void 0 : (_order$payment = order.payment) == null ? void 0 : _order$payment.paymentType) || 'CARD';
  var orderType = (order == null ? void 0 : (_order$cart = order.cart) == null ? void 0 : _order$cart.mode) === 'DINE_IN' ? t('receiptDineIn') : t('receiptTakeaway');
  var shoulUseFullNameConfiguration = !showInitials ? showFullFirstName : false;
  var datetime = utilities.getFormattedDateTime({
    currentTimestamp: utilities.timestamp(),
    timezone: settings == null ? void 0 : settings.timezone
  });
  var showDate = !!datetime;
  var orderNumber = (order == null ? void 0 : order.orderNumber) || null;
  var instruction = t('receiptDetailsInstruction');
  var instructionPaymentMethod = paymentMethod === 'CASH' ? t('receiptDetailsInstructionCash') : t('receiptDetailsInstructionCard');
  var receiptDetailsPayload = {
    displayOrderNumber: beaconOrderNumberEnabled ? session.beaconNumber : getDisplayOrderNumber({
      beacon: beacon,
      customer: customer,
      orderNumber: orderNumber,
      aloha: aloha,
      oracleMicros: oracleMicros,
      showDotAfterInitials: showDotAfterInitials,
      showFullFirstName: shoulUseFullNameConfiguration,
      shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath
    }),
    paymentMethod: paymentMethod,
    instruction: instruction,
    instructionPaymentMethod: instructionPaymentMethod,
    customer: customer,
    orderType: orderType,
    datetime: datetime,
    showDate: showDate,
    receiptId: receiptId,
    shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath
  };
  return receiptDetailsPayload;
};

var buildReceiptPaymentData = function buildReceiptPaymentData(settings, order, session, t) {
  var _settings, _order;
  if (settings === void 0) {
    settings = null;
  }
  if (order === void 0) {
    order = null;
  }
  if (session === void 0) {
    session = null;
  }
  if (t === void 0) {
    t = null;
  }
  if (!settings) return null;
  if (!order) return null;
  if (!session) return null;
  var config = ((_settings = settings) == null ? void 0 : _settings.settings) || {};
  var _config$site = config.site,
    site = _config$site === void 0 ? {} : _config$site,
    taxRegion = config.taxRegion;
  var _ref = session || {},
    _ref$payment = _ref.payment,
    payment = _ref$payment === void 0 ? {} : _ref$payment;
  var _ref2 = order || {},
    _ref2$session = _ref2.session,
    orderSession = _ref2$session === void 0 ? {} : _ref2$session,
    _ref2$paymentType = _ref2.paymentType,
    paymentType = _ref2$paymentType === void 0 ? {} : _ref2$paymentType,
    _ref2$cart = _ref2.cart,
    cart = _ref2$cart === void 0 ? [] : _ref2$cart;
  var kitchenId = orderSession.kitchenId;
  var _site$name = site.name,
    storeName = _site$name === void 0 ? '' : _site$name,
    _site$taxNumber = site.taxNumber,
    taxNumber = _site$taxNumber === void 0 ? '' : _site$taxNumber;
  var _site$address = site == null ? void 0 : site.address,
    addressLine1 = _site$address.addressLine1,
    addressLine2 = _site$address.addressLine2,
    city = _site$address.city,
    state = _site$address.state,
    postal = _site$address.postal,
    phone = _site$address.phone;
  var _paymentType$method = paymentType.method,
    paymentMethod = _paymentType$method === void 0 ? 'card' : _paymentType$method;
  var _ref3 = (payment == null ? void 0 : payment.cardName) || {},
    _ref3$cardName = _ref3.cardName,
    paymentCreditCardName = _ref3$cardName === void 0 ? null : _ref3$cardName;
  var items = cart.items;
  var productQuantity = items.reduce(function (totalQuantity, product) {
    return totalQuantity + product.quantity;
  }, 0);
  var _ref4 = ((_order = order) == null ? void 0 : _order.financialSummary) || {},
    taxes = _ref4.taxes,
    total = _ref4.total,
    feesBreakdown = _ref4.feesBreakdown,
    taxesBreakdown = _ref4.taxesBreakdown,
    savedAmount = _ref4.savedAmount,
    _ref4$showTaxesBreakd = _ref4.showTaxesBreakdown,
    showTaxesBreakdown = _ref4$showTaxesBreakd === void 0 ? false : _ref4$showTaxesBreakd,
    _ref4$showFeesBreakdo = _ref4.showFeesBreakdown,
    showFeesBreakdown = _ref4$showFeesBreakdo === void 0 ? false : _ref4$showFeesBreakdo,
    _ref4$showBreakdowns = _ref4.showBreakdowns,
    showBreakdowns = _ref4$showBreakdowns === void 0 ? false : _ref4$showBreakdowns,
    subTotalFinancialSumary = _ref4.subTotalFinancialSumary;

  // Assumes that `addressLine1` is always set
  var address = [addressLine2, city, state, postal].reduce(function (result, item) {
    if (item) result = result.concat(", " + item);
    return result;
  }, addressLine1);
  var paymentMethodDetails = paymentMethod === 'cash' ? t('receiptCash') + ". " + t('receiptPaymentPending') : paymentCreditCardName;
  var receiptPaymentPayload = {
    kitchenId: kitchenId,
    paymentMethodDetails: paymentMethodDetails,
    storeName: storeName,
    address: address,
    phone: phone,
    taxNumber: taxNumber,
    productQuantity: productQuantity,
    taxes: taxes,
    total: total,
    feesBreakdown: feesBreakdown,
    taxesBreakdown: taxesBreakdown,
    savedAmount: savedAmount,
    taxRegion: taxRegion,
    showTaxesBreakdown: showTaxesBreakdown,
    showFeesBreakdown: showFeesBreakdown,
    showBreakdowns: showBreakdowns,
    subTotalFinancialSumary: subTotalFinancialSumary
  };
  return receiptPaymentPayload;
};

var parseEnergyToJoules = function parseEnergyToJoules(value) {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    var match = value.match(/^(\d*\.?\d+)\s*(kj|j|cal|kcal)$/i);
    if (match) {
      var numericValue = parseFloat(match[1]);
      var unit = match[2].toLowerCase();
      return unit === 'kj' ? numericValue * 1000 : numericValue;
    }
  }
  return 0;
};
var calculateCustomisationEnergy = function calculateCustomisationEnergy(node) {
  var total = 0;
  if (!node.customisations) return null;
  for (var _iterator = _createForOfIteratorHelperLoose(node.customisations), _step; !(_step = _iterator()).done;) {
    var category = _step.value;
    for (var _iterator2 = _createForOfIteratorHelperLoose(category.products), _step2; !(_step2 = _iterator2()).done;) {
      var _product$count;
      var product = _step2.value;
      var _ref = (_product$count = product.count) != null ? _product$count : {},
        _ref$current = _ref.current,
        current = _ref$current === void 0 ? 0 : _ref$current,
        _ref$initial = _ref.initial,
        initial = _ref$initial === void 0 ? 0 : _ref$initial;
      var parsedEnergy = parseEnergyToJoules(product.energyInformation);
      if (current > 0 && initial === 0 && parsedEnergy > 0) {
        total += parsedEnergy * current;
      }
      total += calculateCustomisationEnergy(product);
    }
  }
  return total;
};
var calculateCustomiseEnergy = function calculateCustomiseEnergy(product) {
  var baseEnergy = parseEnergyToJoules(product.energyInformation);
  var additionalEnergy = calculateCustomisationEnergy(product);
  var total = baseEnergy + additionalEnergy;
  return total >= 1000 ? Math.ceil(total / 1000) + "kJ" : total + "J";
};
var calculateComboEnergy = function calculateComboEnergy(product) {
  var total = 0;
  if (product.options) {
    for (var _iterator3 = _createForOfIteratorHelperLoose(product.options), _step3; !(_step3 = _iterator3()).done;) {
      var _option$products;
      var option = _step3.value;
      var selectedProduct = (_option$products = option.products) == null ? void 0 : _option$products.find(function (p) {
        var _p$count$current, _p$count;
        return ((_p$count$current = (_p$count = p.count) == null ? void 0 : _p$count.current) != null ? _p$count$current : 0) > 0;
      });
      if (selectedProduct) {
        total += parseEnergyToJoules(selectedProduct.energyInformation);
        total += calculateCustomisationEnergy(selectedProduct) || 0;
      }
    }
  }
  return total >= 1000 ? Math.ceil(total / 1000) + "kJ" : total + "J";
};
var calculateTotalEnergy = function calculateTotalEnergy(product) {
  var energyInformation = product.energyInformation,
    type = product.type;
  if (!energyInformation) return null;
  if (type === 'customise') {
    return calculateCustomiseEnergy(product);
  }
  if (type === 'combo') {
    return calculateComboEnergy(product);
  }
  return energyInformation;
};

var useReceiptView = function useReceiptView() {
  var history = reactRouterDom.useHistory();
  var _useReceiptViewContex = useReceiptViewContext(),
    t = _useReceiptViewContex.t,
    cart = _useReceiptViewContex.cart,
    order = _useReceiptViewContex.order,
    beacon = _useReceiptViewContex.beacon,
    session = _useReceiptViewContex.session,
    settings = _useReceiptViewContex.settings,
    setTemplate = _useReceiptViewContex.setTemplate,
    smsPagePath = _useReceiptViewContex.smsPagePath,
    nextPagePath = _useReceiptViewContex.nextPagePath,
    registerProductPurchase = _useReceiptViewContex.registerProductPurchase,
    formatPrice = _useReceiptViewContex.formatPrice,
    upsellState = _useReceiptViewContex.upsellState,
    showTaxNumber = _useReceiptViewContex.showTaxNumber,
    showSubtotal = _useReceiptViewContex.showSubtotal,
    showTaxTotal = _useReceiptViewContex.showTaxTotal,
    showKitchenId = _useReceiptViewContex.showKitchenId,
    showEnergyInformation = _useReceiptViewContex.showEnergyInformation,
    useLargeButtons = _useReceiptViewContex.useLargeButtons,
    showDotAfterInitials = _useReceiptViewContex.showDotAfterInitials,
    showGSTExcludeMessage = _useReceiptViewContex.showGSTExcludeMessage,
    paymentCompletedTrack = _useReceiptViewContex.paymentCompletedTrack,
    showTermsAndConditionsModal = _useReceiptViewContex.showTermsAndConditionsModal,
    setShowTermsAndConditionsModal = _useReceiptViewContex.setShowTermsAndConditionsModal,
    showAddonAvailability = _useReceiptViewContex.showAddonAvailability,
    currency = _useReceiptViewContex.currency,
    showFullFirstName = _useReceiptViewContex.showFullFirstName,
    showTxnId = _useReceiptViewContex.showTxnId,
    payment = _useReceiptViewContex.payment,
    shouldSkipCustomerDetailsPath = _useReceiptViewContex.shouldSkipCustomerDetailsPath,
    hideNoPrefixWhenDefaultNotSelected = _useReceiptViewContex.hideNoPrefixWhenDefaultNotSelected,
    delayQRCodeRenderInMilliseconds = _useReceiptViewContex.delayQRCodeRenderInMilliseconds,
    addedUpsells = _useReceiptViewContex.addedUpsells,
    showRestaurantName = _useReceiptViewContex.showRestaurantName,
    showAddress = _useReceiptViewContex.showAddress,
    showPhoneNumber = _useReceiptViewContex.showPhoneNumber,
    showSavedAmount = _useReceiptViewContex.showSavedAmount;
  var paymentCompletedCalledRef = React.useRef(false);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var showOriginalPriceForCombo = recoil.useRecoilValue(atoms.showOriginalPriceForComboState);
  var beaconOrderNumberEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beaconOrderNumber',
    defaultValue: false
  });
  var onCloseTermsAndConditionsModal = function onCloseTermsAndConditionsModal() {
    return setShowTermsAndConditionsModal(false);
  };
  var termsAndConditionsButtonText = t('receiptTermsAndConditionsAction');
  var termsAndConditionsEnabled = utilities.useSettingsAtPath({
    path: 'settings.content.termsAndConditionsEnabled',
    defaultValue: false
  });
  var termsAndConditionsURL = utilities.useSettingsAtPath({
    path: 'settings.content.termsAndConditionsURL',
    defaultValue: ''
  });
  var _useLocaleSelection = useLocaleSelection(),
    i18n = _useLocaleSelection.i18n;
  var _ref = i18n || {},
    language = _ref.language;
  var translateInline = translateProductName(language);
  var showTermsAndConditionsButton = React.useMemo(function () {
    return termsAndConditionsEnabled && termsAndConditionsURL !== '';
  }, [termsAndConditionsEnabled, termsAndConditionsURL]);
  var smsEnabled = React.useMemo(function () {
    var _settings$settings, _settings$settings$mo;
    return (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$mo = _settings$settings.modes) == null ? void 0 : _settings$settings$mo.sms) || false;
  }, [settings]);
  var receiptPaymentData = React.useMemo(function () {
    return buildReceiptPaymentData(settings, order, session, t);
  }, [settings, order, session, t]);
  var receiptDetailsData = React.useMemo(function () {
    return buildReceiptDetailsData({
      settings: settings,
      session: session,
      order: order,
      beacon: beacon,
      t: t,
      showDotAfterInitials: showDotAfterInitials,
      showFullFirstName: showFullFirstName,
      shouldSkipCustomerDetailsPath: shouldSkipCustomerDetailsPath,
      beaconOrderNumberEnabled: beaconOrderNumberEnabled
    });
  }, [settings, session, order, beacon, t, showDotAfterInitials, showFullFirstName, shouldSkipCustomerDetailsPath, beaconOrderNumberEnabled]);
  var sendSms = React.useCallback(function () {
    history.push(smsPagePath);
  }, [history, smsPagePath]);
  var receiptDone = React.useCallback(function () {
    history.push(nextPagePath);
  }, [history, nextPagePath]);
  var formattedProducts = React.useMemo(function () {
    return cart.map(function (product) {
      var _product$options = product.options,
        options = _product$options === void 0 ? [] : _product$options,
        _product$customisatio = product.customisations,
        customisations = _product$customisatio === void 0 ? [] : _product$customisatio;
      var calculatedEnergyInformation = calculateTotalEnergy(_extends({}, product));
      return _extends({}, product, {
        calculatedEnergyInformation: calculatedEnergyInformation,
        title: translateInline(product == null ? void 0 : product.name),
        options: options == null ? void 0 : options.map(function (option) {
          var _option$products;
          return _extends({}, option, {
            products: (_option$products = option.products) == null ? void 0 : _option$products.map(function (optionProduct) {
              var _optionProduct$custom;
              return _extends({}, optionProduct, {
                customisations: (_optionProduct$custom = optionProduct.customisations) == null ? void 0 : _optionProduct$custom.map(function (optionProductCustomisations) {
                  var _optionProductCustomi;
                  return _extends({}, optionProductCustomisations, {
                    products: (_optionProductCustomi = optionProductCustomisations.products) == null ? void 0 : _optionProductCustomi.map(function (optionProductCustomisationsProduct) {
                      return _extends({}, optionProductCustomisationsProduct, {
                        title: translateInline(optionProductCustomisationsProduct == null ? void 0 : optionProductCustomisationsProduct.name)
                      });
                    })
                  });
                }),
                title: translateInline(optionProduct == null ? void 0 : optionProduct.name)
              });
            })
          });
        }),
        customisations: customisations.map(function (customisation) {
          var _customisation$produc;
          return _extends({}, customisation, {
            products: (_customisation$produc = customisation.products) == null ? void 0 : _customisation$produc.map(function (customisationProduct) {
              return _extends({}, customisationProduct, {
                title: translateInline(customisationProduct == null ? void 0 : customisationProduct.name)
              });
            })
          });
        })
      });
    });
  }, [cart, translateInline]);
  React.useEffect(function () {
    if (!order || !cart) return;
    if (paymentCompletedCalledRef.current) return;
    try {
      paymentCompletedTrack(order, cart, couponNumber, addedUpsells);
      paymentCompletedCalledRef.current = true;
    } catch (error) {
      logger.error("behavioural-analytics - paymentCompletedTrack - error: " + error.message);
    }
  }, [order, cart, paymentCompletedTrack, couponNumber, addedUpsells]);
  React.useEffect(function () {
    var registerPurchase = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _order$cart, _order$cart2;
        var googleAnalyticsPayload;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (order) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              googleAnalyticsPayload = {
                currency: currency || '',
                orderNumber: (order == null ? void 0 : order.orderNumber) || '',
                totalRevenue: (order == null ? void 0 : (_order$cart = order.cart) == null ? void 0 : _order$cart.total) || null,
                products: (order == null ? void 0 : (_order$cart2 = order.cart) == null ? void 0 : _order$cart2.items) || []
              };
              _context.prev = 3;
              _context.next = 6;
              return registerProductPurchase({
                upsellState: upsellState
              }, googleAnalyticsPayload);
            case 6:
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              logger.error('cringer.components - registerProductPurchase - Error:', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 8]]);
      }));
      return function registerPurchase() {
        return _ref2.apply(this, arguments);
      };
    }();
    registerPurchase();
  }, [currency, order, registerProductPurchase, upsellState]);
  React.useEffect(function () {
    var footer = {
      nextAction: receiptDone,
      nextText: t('receiptPrimaryAction'),
      allowNextAction: true,
      isViewOrderDisabled: true,
      showBasketCount: false,
      previousAction: sendSms,
      previousText: t('receiptSmsAction'),
      isPreviousActionEnabled: smsEnabled,
      showTermsAndConditionsButton: showTermsAndConditionsButton,
      termsAndConditionsButtonText: termsAndConditionsButtonText,
      setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
      nextActionClass: 'restaurant-cart-secondary-button'
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        timeoutActionOverride: function timeoutActionOverride() {
          return history.push('/reset');
        },
        footer: footer
      });
    });
  }, [history, setTemplate, receiptDone, t, smsEnabled, sendSms, showTermsAndConditionsButton, termsAndConditionsButtonText, setShowTermsAndConditionsModal]);
  return {
    t: t,
    cart: formattedProducts,
    sendSms: sendSms,
    smsEnabled: smsEnabled,
    receiptDone: receiptDone,
    receiptPaymentData: receiptPaymentData,
    receiptDetailsData: receiptDetailsData,
    formatPrice: formatPrice,
    showTaxNumber: showTaxNumber,
    showSubtotal: showSubtotal,
    showTaxTotal: showTaxTotal,
    showKitchenId: showKitchenId,
    showEnergyInformation: showEnergyInformation,
    useLargeButtons: useLargeButtons,
    showGSTExcludeMessage: showGSTExcludeMessage,
    showAddonAvailability: showAddonAvailability,
    showFullFirstName: showFullFirstName,
    order: order,
    settings: settings,
    termsAndConditionsURL: termsAndConditionsURL,
    showTermsAndConditionsModal: showTermsAndConditionsModal,
    onCloseTermsAndConditionsModal: onCloseTermsAndConditionsModal,
    setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
    showTermsAndConditionsButton: showTermsAndConditionsButton,
    showTxnId: showTxnId,
    payment: payment,
    hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected,
    delayQRCodeRenderInMilliseconds: delayQRCodeRenderInMilliseconds,
    showRestaurantName: showRestaurantName,
    showAddress: showAddress,
    showPhoneNumber: showPhoneNumber,
    showOriginalPriceForCombo: showOriginalPriceForCombo,
    showSavedAmount: showSavedAmount
  };
};

// https://stackoverflow.com/questions/46993591/react-why-label-not-firing-onchange-for-checkbox
var formatLanguage = function formatLanguage(lang) {
  switch (lang) {
    case 'en-US':
    case 'en':
      return 'eng';
    case 'ar-AE':
      return 'uae';
    case 'uae':
      return 'uae';
    case 'vnm':
      return 'vnm';
    case 'rus':
      return 'rus';
    case 'kaz':
      return 'kaz';
    case 'tha':
      return 'tha';
    case 'fr-CA':
    case 'fr-ca':
    case 'DN-FR':
      return 'fr-CA';
    default:
      return 'eng';
  }
};
var getProductNameAccToLang = function getProductNameAccToLang(name, currentLanguage) {
  var _name$translations;
  var productLanguageText = name == null ? void 0 : (_name$translations = name.translations) == null ? void 0 : _name$translations.find(function (value) {
    return (value == null ? void 0 : value.language) === formatLanguage(currentLanguage);
  });
  return productLanguageText == null ? void 0 : productLanguageText.text;
};

var useProductCustomisations = function useProductCustomisations() {
  var isDeliverectProvider = recoil.useRecoilValue(atoms.isDeliverectProviderState);
  var removeDeleteIcon = utilities.useSettingsAtPath({
    path: 'settings.content.removeDeleteIcon',
    defaultValue: false
  });
  var showOutOfStockDefaultItemWarnings = utilities.useSettingsAtPath({
    path: 'settings.content.outOfStockDefaultItemWarning',
    defaultValue: false
  });
  var formatAllergens = function formatAllergens(allergens) {
    if (!allergens || typeof allergens !== 'string') return;
    var stringWithoutUnderline = allergens.split('_').join(' ');
    var allergensFormatted = stringWithoutUnderline.charAt(0).toUpperCase() + stringWithoutUnderline.slice(1);
    return allergensFormatted;
  };
  return {
    removeDeleteIcon: removeDeleteIcon,
    showOutOfStockDefaultItemWarnings: showOutOfStockDefaultItemWarnings,
    formatAllergens: formatAllergens,
    isDeliverectProvider: isDeliverectProvider
  };
};

var ItemAvailabilityWrapper = function ItemAvailabilityWrapper(_ref) {
  var children = _ref.children,
    isAvailable = _ref.isAvailable,
    showAddonAvailability = _ref.showAddonAvailability,
    formatAddonAvailability = _ref.formatAddonAvailability;
  return !isAvailable && showAddonAvailability ? /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "item-availability-wrapper",
    className: "flex items-center justify-between text-gray-400",
    children: [children, /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "text-red-600 text-center " + (formatAddonAvailability && "w-1/2"),
      children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
        i18nKey: "cartProductUnavailableAddon"
      })
    })]
  }) : /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: children
  });
};
var Checkbox = function Checkbox(_ref2) {
  var product = _ref2.product,
    _ref2$formatPrice = _ref2.formatPrice,
    formatPrice = _ref2$formatPrice === void 0 ? function () {} : _ref2$formatPrice,
    _ref2$hideUnavailable = _ref2.hideUnavailable,
    hideUnavailable = _ref2$hideUnavailable === void 0 ? false : _ref2$hideUnavailable,
    _ref2$hideNoPrefixWhe = _ref2.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref2$hideNoPrefixWhe === void 0 ? false : _ref2$hideNoPrefixWhe,
    showAddonAvailability = _ref2.showAddonAvailability,
    _ref2$formatAddonAvai = _ref2.formatAddonAvailability,
    formatAddonAvailability = _ref2$formatAddonAvai === void 0 ? false : _ref2$formatAddonAvai;
  var name = product.name,
    selected = product.selected,
    isInitial = product["default"],
    price = product.price,
    title = product.title,
    isAvailable = product.isAvailable;
  var currentPrice = price.current,
    unitPrice = price.unit;
  var _useLocaleSelection = useLocaleSelection(),
    currentLanguage = _useLocaleSelection.currentLanguage;
  var _useProductCustomisat = useProductCustomisations(),
    showOutOfStockDefaultItemWarnings = _useProductCustomisat.showOutOfStockDefaultItemWarnings;
  var productLanguageText = getProductNameAccToLang(name, currentLanguage);
  if (hideUnavailable && !isAvailable) return null;
  if (isInitial && !selected && !hideNoPrefixWhenDefaultNotSelected) return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex items-center",
    children: [showOutOfStockDefaultItemWarnings && isInitial && !isAvailable ? /*#__PURE__*/jsxRuntime.jsx(ExclamationCircle, {
      className: "w-4 h-4 mr-2 text-orange min-w-4 sm:w-12 sm:h-12"
    }) : null, /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "product-customisation-checkbox",
      children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
        i18nKey: "productCustomisationsReadonlyProductRemoved",
        values: {
          name: title || productLanguageText || name.text
        }
      })
    })]
  });
  if (!selected || isInitial) return null;
  return /*#__PURE__*/jsxRuntime.jsx(ItemAvailabilityWrapper, {
    isAvailable: isAvailable,
    showAddonAvailability: showAddonAvailability,
    formatAddonAvailability: formatAddonAvailability,
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-customisation-checkbox",
      children: [title || productLanguageText || name.text, !!currentPrice && " " + utilities.signaledFormatPrice({
        formatPrice: formatPrice,
        price: unitPrice
      })]
    })
  });
};
var ExtraPrice = function ExtraPrice(_ref3) {
  var count = _ref3.count,
    price = _ref3.price,
    _ref3$formatPrice = _ref3.formatPrice,
    formatPrice = _ref3$formatPrice === void 0 ? function () {} : _ref3$formatPrice;
  var _ref4 = price || {},
    currentPrice = _ref4.current,
    unitPrice = _ref4.unit;
  var _ref5 = count || {},
    initialCount = _ref5.initial;
  return !!currentPrice && /*#__PURE__*/jsxRuntime.jsxs("span", {
    "data-test": "extra-price",
    className: "capitalize",
    children: [!!initialCount && " " + utilities.signaledFormatPrice({
      formatPrice: formatPrice,
      price: currentPrice
    }), !initialCount && /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
      i18nKey: "productCustomisationsReadOnlyEach",
      values: {
        price: " " + utilities.signaledFormatPrice({
          formatPrice: formatPrice,
          price: unitPrice
        })
      }
    })]
  });
};
var Quantity = function Quantity(_ref6) {
  var product = _ref6.product,
    _ref6$showDefaultQuan = _ref6.showDefaultQuantity,
    showDefaultQuantity = _ref6$showDefaultQuan === void 0 ? true : _ref6$showDefaultQuan,
    showAddonAvailability = _ref6.showAddonAvailability,
    _ref6$formatPrice = _ref6.formatPrice,
    formatPrice = _ref6$formatPrice === void 0 ? function () {} : _ref6$formatPrice,
    _ref6$hideUnavailable = _ref6.hideUnavailable,
    hideUnavailable = _ref6$hideUnavailable === void 0 ? false : _ref6$hideUnavailable,
    _ref6$formatAddonAvai = _ref6.formatAddonAvailability,
    formatAddonAvailability = _ref6$formatAddonAvai === void 0 ? false : _ref6$formatAddonAvai;
  var _product$name = product.name,
    name = _product$name === void 0 ? {} : _product$name,
    count = product.count,
    price = product.price,
    isDefault = product["default"],
    title = product.title,
    isAvailable = product.isAvailable;
  var currentCount = count.current,
    initialCount = count.initial;
  var _useLocaleSelection2 = useLocaleSelection(),
    currentLanguage = _useLocaleSelection2.currentLanguage;
  var productLanguageText = getProductNameAccToLang(name, currentLanguage);
  var Wrapper = function Wrapper(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "product-customisation-quantity",
      className: !isAvailable && showAddonAvailability && formatAddonAvailability ? "w-1/2" : '',
      children: children
    });
  };
  if (hideUnavailable && typeof isAvailable === 'boolean' && !isAvailable) return null;

  // no quantity for no default product shouldn't display
  if (!isDefault && !currentCount) return null;

  // default product and same current quantity as default quantity shouldn't display (flag toggle)
  if (!showDefaultQuantity && isDefault && currentCount === initialCount) return null;

  // default product and no quantity should display `No {productName}`
  if (isDefault && currentCount < initialCount && currentCount === 0) return /*#__PURE__*/jsxRuntime.jsx(Wrapper, {
    children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
      i18nKey: "productCustomisationsReadonlyProductRemoved",
      values: {
        name: title || productLanguageText || name.text
      }
    })
  });
  return /*#__PURE__*/jsxRuntime.jsx(ItemAvailabilityWrapper, {
    isAvailable: isAvailable,
    showAddonAvailability: showAddonAvailability,
    formatAddonAvailability: formatAddonAvailability,
    children: /*#__PURE__*/jsxRuntime.jsxs(Wrapper, {
      children: [currentCount + "x", "\xA0", title || productLanguageText || name.text, /*#__PURE__*/jsxRuntime.jsx(ExtraPrice, {
        count: count,
        price: price,
        formatPrice: formatPrice
      })]
    })
  });
};
var Content = function Content(_ref8) {
  var category = _ref8.category,
    showAddonAvailability = _ref8.showAddonAvailability,
    _ref8$formatPrice = _ref8.formatPrice,
    formatPrice = _ref8$formatPrice === void 0 ? function () {} : _ref8$formatPrice,
    _ref8$hideUnavailable = _ref8.hideUnavailable,
    hideUnavailable = _ref8$hideUnavailable === void 0 ? false : _ref8$hideUnavailable,
    _ref8$formatAddonAvai = _ref8.formatAddonAvailability,
    formatAddonAvailability = _ref8$formatAddonAvai === void 0 ? false : _ref8$formatAddonAvai,
    _ref8$hideNoPrefixWhe = _ref8.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref8$hideNoPrefixWhe === void 0 ? false : _ref8$hideNoPrefixWhe;
  var type = category.type,
    products = category.products;
  switch (type) {
    case 'checkbox':
    case 'radio':
    case 'substitutable':
      return products == null ? void 0 : products.map(function (product) {
        var _product$customisatio;
        return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [/*#__PURE__*/jsxRuntime.jsx(Checkbox, {
            product: product,
            formatPrice: formatPrice,
            hideUnavailable: hideUnavailable,
            showAddonAvailability: showAddonAvailability,
            formatAddonAvailability: formatAddonAvailability,
            hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
          }, product == null ? void 0 : product.id), ((_product$customisatio = product.customisations) == null ? void 0 : _product$customisatio.length) > 0 && /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
            customisations: product.customisations,
            formatPrice: formatPrice,
            showAddonAvailability: showAddonAvailability,
            hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
          })]
        });
      });
    case 'quantity':
      return products == null ? void 0 : products.map(function (product) {
        var _product$customisatio2;
        return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [/*#__PURE__*/jsxRuntime.jsx(Quantity, {
            product: product,
            formatPrice: formatPrice,
            showDefaultQuantity: false,
            showAddonAvailability: showAddonAvailability,
            hideUnavailable: hideUnavailable,
            formatAddonAvailability: formatAddonAvailability
          }, product == null ? void 0 : product.id), ((_product$customisatio2 = product.customisations) == null ? void 0 : _product$customisatio2.length) > 0 && /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
            customisations: product.customisations,
            formatPrice: formatPrice,
            showAddonAvailability: showAddonAvailability,
            hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
          })]
        });
      });
    case 'extra':
    case 'selectOption':
    case 'boolean':
      return products == null ? void 0 : products.map(function (product) {
        var _product$customisatio3;
        return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [/*#__PURE__*/jsxRuntime.jsx(Quantity, {
            product: product,
            showDefaultQuantity: false,
            formatPrice: formatPrice,
            showAddonAvailability: showAddonAvailability,
            hideUnavailable: hideUnavailable
          }, product == null ? void 0 : product.id), ((_product$customisatio3 = product.customisations) == null ? void 0 : _product$customisatio3.length) > 0 && /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
            customisations: product.customisations,
            formatPrice: formatPrice,
            showAddonAvailability: showAddonAvailability,
            hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
          })]
        });
      });
    default:
      return null;
  }
};
var CategorySeparator = function CategorySeparator(_ref9) {
  var category = _ref9.category,
    showAddonAvailability = _ref9.showAddonAvailability,
    _ref9$formatPrice = _ref9.formatPrice,
    formatPrice = _ref9$formatPrice === void 0 ? function () {} : _ref9$formatPrice,
    _ref9$hideUnavailable = _ref9.hideUnavailable,
    hideUnavailable = _ref9$hideUnavailable === void 0 ? false : _ref9$hideUnavailable,
    _ref9$formatAddonAvai = _ref9.formatAddonAvailability,
    formatAddonAvailability = _ref9$formatAddonAvai === void 0 ? false : _ref9$formatAddonAvai,
    _ref9$hideNoPrefixWhe = _ref9.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref9$hideNoPrefixWhe === void 0 ? false : _ref9$hideNoPrefixWhe;
  var products = category.products;

  // If category contains any products that aren't default (and have been added) show 'extras' tag
  var shouldShowExtras = products.some(function (product) {
    return !product["default"] && product.count.current > 0;
  });
  return shouldShowExtras ? /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "",
      children: /*#__PURE__*/jsxRuntime.jsx(Content, {
        category: category,
        showAddonAvailability: showAddonAvailability,
        formatPrice: formatPrice,
        hideUnavailable: hideUnavailable,
        formatAddonAvailability: formatAddonAvailability,
        hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
      }, category.id)
    })
  }) : /*#__PURE__*/jsxRuntime.jsx(Content, {
    category: category,
    showAddonAvailability: showAddonAvailability,
    formatPrice: formatPrice,
    hideUnavailable: hideUnavailable,
    formatAddonAvailability: formatAddonAvailability,
    hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
  }, category.id);
};
var ProductCustomisationsReadonly = function ProductCustomisationsReadonly(_temp) {
  var _ref10 = _temp === void 0 ? {} : _temp,
    _ref10$customisations = _ref10.customisations,
    customisations = _ref10$customisations === void 0 ? [] : _ref10$customisations,
    _ref10$className = _ref10.className,
    className = _ref10$className === void 0 ? 'text-3xl' : _ref10$className,
    _ref10$formatPrice = _ref10.formatPrice,
    formatPrice = _ref10$formatPrice === void 0 ? function () {} : _ref10$formatPrice,
    _ref10$showAddonAvail = _ref10.showAddonAvailability,
    showAddonAvailability = _ref10$showAddonAvail === void 0 ? false : _ref10$showAddonAvail,
    _ref10$hideUnavailabl = _ref10.hideUnavailable,
    hideUnavailable = _ref10$hideUnavailabl === void 0 ? false : _ref10$hideUnavailabl,
    _ref10$formatAddonAva = _ref10.formatAddonAvailability,
    formatAddonAvailability = _ref10$formatAddonAva === void 0 ? false : _ref10$formatAddonAva,
    _ref10$hideNoPrefixWh = _ref10.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref10$hideNoPrefixWh === void 0 ? false : _ref10$hideNoPrefixWh;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "product-customisations-readonly",
    className: className,
    children: customisations.map(function (category, index) {
      return /*#__PURE__*/jsxRuntime.jsx(CategorySeparator, {
        category: category,
        showAddonAvailability: showAddonAvailability,
        formatPrice: formatPrice,
        hideUnavailable: hideUnavailable,
        formatAddonAvailability: formatAddonAvailability,
        hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
      }, "category-seperator-" + index);
    })
  });
};

var Products = function Products(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    showAddonAvailability = _ref.showAddonAvailability,
    _ref$hideUnavailable = _ref.hideUnavailable,
    hideUnavailable = _ref$hideUnavailable === void 0 ? false : _ref$hideUnavailable,
    _ref$hideNoPrefixWhen = _ref.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref$hideNoPrefixWhen === void 0 ? false : _ref$hideNoPrefixWhen,
    _ref$redeemableItemId = _ref.redeemableItemId,
    redeemableItemId = _ref$redeemableItemId === void 0 ? '' : _ref$redeemableItemId;
  var _useLocaleSelection = useLocaleSelection(),
    currentLanguage = _useLocaleSelection.currentLanguage;
  return products.map(function (product) {
    var id = product.id,
      name = product.name,
      selected = product.selected,
      customisations = product.customisations,
      price = product.price,
      type = product.type,
      title = product.title,
      isAvailable = product.isAvailable,
      providerData = product.providerData;
    var unit = price.unit;
    var optionPrice = unit && type !== 'customise' ? " " + utilities.signaledFormatPrice({
      formatPrice: formatPrice,
      price: unit
    }) : '';
    var productLanguageText = getProductNameAccToLang(name, currentLanguage);
    var isRedeemed = selected && Number(redeemableItemId) === Number(providerData == null ? void 0 : providerData.itemId);
    return selected && /*#__PURE__*/jsxRuntime.jsxs("div", {
      children: [showAddonAvailability && !isAvailable ? /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex justify-between text-2xl font-bold text-gray-400 md:text-3xl",
        children: [/*#__PURE__*/jsxRuntime.jsxs("p", {
          "data-test": "product-option-name",
          children: [title || productLanguageText || name.text, " ", optionPrice]
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "text-red-600",
          "data-test": "product-option-name-unavailable",
          children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
            i18nKey: "cartProductUnavailableItem"
          })
        })]
      }) : /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "text-2xl font-bold md:text-3xl",
        "data-test": "product-option-name",
        children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
          children: [title || productLanguageText || name.text, " ", optionPrice]
        }), isRedeemed ? /*#__PURE__*/jsxRuntime.jsx("span", {
          className: "px-4 py-2 ml-6 text-2xl bg-yellow-400 w-fit rounded-button disabled:opacity-50",
          "data-test": "cart-redeem-badge",
          children: "Redeemed"
        }) : '']
      }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
        customisations: customisations,
        t: t,
        className: "pl-4 text-2xl md:text-3xl",
        formatPrice: formatPrice,
        showAddonAvailability: showAddonAvailability,
        hideUnavailable: hideUnavailable,
        hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
      })]
    }, "product-" + id);
  });
};
var ProductOption = function ProductOption(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? [] : _ref2$options,
    _ref2$t = _ref2.t,
    t = _ref2$t === void 0 ? function () {} : _ref2$t,
    _ref2$formatPrice = _ref2.formatPrice,
    formatPrice = _ref2$formatPrice === void 0 ? function () {} : _ref2$formatPrice,
    showAddonAvailability = _ref2.showAddonAvailability,
    _ref2$hideUnavailable = _ref2.hideUnavailable,
    hideUnavailable = _ref2$hideUnavailable === void 0 ? false : _ref2$hideUnavailable,
    _ref2$hideNoPrefixWhe = _ref2.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref2$hideNoPrefixWhe === void 0 ? false : _ref2$hideNoPrefixWhe,
    _ref2$redeemableItemI = _ref2.redeemableItemId,
    redeemableItemId = _ref2$redeemableItemI === void 0 ? '' : _ref2$redeemableItemI;
  return options.map(function (option) {
    var id = option.id,
      products = option.products,
      _option$hidden = option.hidden,
      hidden = _option$hidden === void 0 ? false : _option$hidden,
      _option$isVisible = option.isVisible,
      isVisible = _option$isVisible === void 0 ? true : _option$isVisible;
    if (hidden || !isVisible) return null;
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      children: /*#__PURE__*/jsxRuntime.jsx(Products, {
        products: products,
        t: t,
        formatPrice: formatPrice,
        showAddonAvailability: showAddonAvailability,
        hideUnavailable: hideUnavailable,
        hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected,
        redeemableItemId: redeemableItemId
      })
    }, "option-" + id);
  }).filter(function (option) {
    return option;
  });
}; // filter `null`s

var ProductOptionsReadonly = function ProductOptionsReadonly(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    _ref3$options = _ref3.options,
    options = _ref3$options === void 0 ? [] : _ref3$options,
    _ref3$t = _ref3.t,
    t = _ref3$t === void 0 ? function () {} : _ref3$t,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$formatPrice = _ref3.formatPrice,
    formatPrice = _ref3$formatPrice === void 0 ? function () {} : _ref3$formatPrice,
    _ref3$showAddonAvaila = _ref3.showAddonAvailability,
    showAddonAvailability = _ref3$showAddonAvaila === void 0 ? false : _ref3$showAddonAvaila,
    _ref3$hideUnavailable = _ref3.hideUnavailable,
    hideUnavailable = _ref3$hideUnavailable === void 0 ? false : _ref3$hideUnavailable,
    _ref3$hideNoPrefixWhe = _ref3.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref3$hideNoPrefixWhe === void 0 ? false : _ref3$hideNoPrefixWhe,
    _ref3$redeemableItemI = _ref3.redeemableItemId,
    redeemableItemId = _ref3$redeemableItemI === void 0 ? '' : _ref3$redeemableItemI;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "product-options-readonly",
    className: className,
    children: /*#__PURE__*/jsxRuntime.jsx(ProductOption, {
      options: options,
      t: t,
      formatPrice: formatPrice,
      showAddonAvailability: showAddonAvailability,
      hideUnavailable: hideUnavailable,
      hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected,
      redeemableItemId: redeemableItemId
    })
  });
};

var RestaurantProductPrice = function RestaurantProductPrice(_ref) {
  var _product$price;
  var product = _ref.product,
    promoItem = _ref.promoItem,
    formatPrice = _ref.formatPrice,
    RewardPointsComponent = _ref.RewardPointsComponent,
    GSTChar = _ref.GSTChar;
  var currentPrice = product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.current;
  var hasPrice = currentPrice ? true : false;
  var getPromoQty = function getPromoQty(promoItem, product) {
    var _product$providerData, _product$count;
    return (promoItem == null ? void 0 : promoItem.promoId) === (product == null ? void 0 : (_product$providerData = product.providerData) == null ? void 0 : _product$providerData.PromoId) && ((_product$count = product.count) == null ? void 0 : _product$count.current) || 0;
  };
  var points = promoItem != null && promoItem.pointsCost ? /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
    pointsCost: promoItem.pointsCost * getPromoQty(promoItem, product)
  }, "rewardPoints") : null;
  var pointsAndPriceSeparator = promoItem != null && promoItem.pointsCost && hasPrice ? /*#__PURE__*/jsxRuntime.jsx("span", {
    children: "+"
  }) : null;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex justify-end text-2xl sm:text-4xl font-bold",
    children: [points, pointsAndPriceSeparator, hasPrice ? formatPrice({
      price: currentPrice
    }) : null, GSTChar]
  });
};
var CartViewProduct = function CartViewProduct(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$t = _ref2.t,
    t = _ref2$t === void 0 ? null : _ref2$t,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? null : _ref2$product,
    formatPrice = _ref2.formatPrice,
    _ref2$boxClassName = _ref2.boxClassName,
    boxClassName = _ref2$boxClassName === void 0 ? '' : _ref2$boxClassName,
    _ref2$showEnergyInfor = _ref2.showEnergyInformation,
    showEnergyInformation = _ref2$showEnergyInfor === void 0 ? false : _ref2$showEnergyInfor,
    _ref2$showGSTAsterisk = _ref2.showGSTAsterisk,
    showGSTAsterisk = _ref2$showGSTAsterisk === void 0 ? false : _ref2$showGSTAsterisk,
    _ref2$showAddonAvaila = _ref2.showAddonAvailability,
    showAddonAvailability = _ref2$showAddonAvaila === void 0 ? false : _ref2$showAddonAvaila,
    _ref2$RewardPointsCom = _ref2.RewardPointsComponent,
    RewardPointsComponent = _ref2$RewardPointsCom === void 0 ? null : _ref2$RewardPointsCom,
    _ref2$hideNoPrefixWhe = _ref2.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref2$hideNoPrefixWhe === void 0 ? false : _ref2$hideNoPrefixWhe,
    _ref2$showOriginalPri = _ref2.showOriginalPriceForCombo,
    showOriginalPriceForCombo = _ref2$showOriginalPri === void 0 ? false : _ref2$showOriginalPri;
  validation$1.validate({
    name: 'CartViewProduct',
    parameters: {
      product: product,
      t: t,
      formatPrice: formatPrice
    }
  });
  var productId = product.productId,
    name = product.name,
    price = product.price,
    count = product.count,
    options = product.options,
    customisations = product.customisations,
    title = product.title,
    _product$calculatedEn = product.calculatedEnergyInformation,
    calculatedEnergyInformation = _product$calculatedEn === void 0 ? '' : _product$calculatedEn,
    providerData = product.providerData,
    type = product.type;
  var currentPrice = price.current,
    unit = price.unit;
  var unitPrice = React.useMemo(function () {
    if (showOriginalPriceForCombo && type === 'combo') {
      return currentPrice;
    }
    return unit;
  }, [showOriginalPriceForCombo, currentPrice, unit, type]);
  var _useLocaleSelection = useLocaleSelection(),
    currentLanguage = _useLocaleSelection.currentLanguage;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    _useOffersAndRewardsM2 = _useOffersAndRewardsM.loading,
    loading = _useOffersAndRewardsM2 === void 0 ? false : _useOffersAndRewardsM2,
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  if (loading) {
    return null;
  }
  var promoItem = getPromoItem({
    productId: productId
  });
  var productLanguageText = getProductNameAccToLang(name, currentLanguage);
  var NoGST = providerData.NoGST;
  var currentCount = count.current;
  var productTitle = (promoItem == null ? void 0 : promoItem.name) || title || productLanguageText || name.text;
  var productName = productTitle + " " + (currentCount > 1 || currentPrice !== unitPrice ? '-' : '') + "\n    " + (currentPrice !== unitPrice ? formatPrice({
    price: unitPrice
  }) : '') + "\n    " + (currentCount > 1 ? 'x' + currentCount : '') + "\n  ";
  var GSTChar = showGSTAsterisk && NoGST ? '*' : '';
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex cart-view-product flex-col justify-between rounded p-2 md:p-4 w-full " + boxClassName,
    "data-test": "cart-view-product",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between gap-5 mb-2 sm:mb-4",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex justify-start text-2xl sm:text-4xl font-bold",
        children: productName
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-end",
        children: [/*#__PURE__*/jsxRuntime.jsx(RestaurantProductPrice, {
          product: product,
          formatPrice: formatPrice,
          promoItem: promoItem,
          GSTChar: GSTChar,
          RewardPointsComponent: RewardPointsComponent
        }), showEnergyInformation && calculatedEnergyInformation && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "text-2xl font-bold",
          children: calculatedEnergyInformation
        })]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
      customisations: customisations,
      t: t,
      formatPrice: formatPrice,
      showAddonAvailability: showAddonAvailability,
      hideUnavailable: false,
      hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
    }), /*#__PURE__*/jsxRuntime.jsx(ProductOptionsReadonly, {
      options: options,
      t: t,
      formatPrice: formatPrice,
      showAddonAvailability: showAddonAvailability,
      hideUnavailable: true,
      hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
    })]
  });
};

var getQRCodeSize = function getQRCodeSize(size) {
  if (size === void 0) {
    size = null;
  }
  var qrCodeSize = {
    width: 0,
    height: 0
  };
  if (size === null) {
    return qrCodeSize;
  }
  var _size$split = size.split('x'),
    width = _size$split[0],
    height = _size$split[1];
  if (isNaN(parseInt(width)) || isNaN(parseInt(height))) {
    return qrCodeSize;
  }
  qrCodeSize.width = parseInt(width);
  qrCodeSize.height = parseInt(height);
  return qrCodeSize;
};

var QRCode = function QRCode(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? null : _ref$size;
  if (!url || !size) return null;
  var _getQRCodeSize = getQRCodeSize(size),
    width = _getQRCodeSize.width,
    height = _getQRCodeSize.height;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "qr-code",
    className: "w-" + width + "px h-" + height + "px",
    children: /*#__PURE__*/jsxRuntime.jsx(ReactQRCode, {
      size: width,
      value: url
    })
  });
};

var useReceiptQRCode = function useReceiptQRCode(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$customSession = _ref.customSession,
    customSession = _ref$customSession === void 0 ? {} : _ref$customSession;
  var _useState = React.useState(null),
    shortUrl = _useState[0],
    setShortUrl = _useState[1];
  var meta = recoil.useRecoilValue(atoms.metadataState);
  var _ref2 = meta || {},
    _ref2$mobile = _ref2.mobile,
    mobile = _ref2$mobile === void 0 ? false : _ref2$mobile;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var session = recoil.useRecoilValue(atoms.sessionState);
  var _ref3 = session || customSession,
    receiptId = _ref3.receiptId,
    status = _ref3.status;
  var placeholderImage = process.env.REACT_APP_PLACEHOLDER_IMAGE || null;
  React.useEffect(function () {
    setShortUrl(null);
    if (!receiptId) return;
    var baseUrl = status === 'FINISHED' ? process.env.POI_APP_RECEIPT_VIEW_FUNCTION : process.env.POI_APP_RECEIPT_FAILED_FUNCTION;
    var urlToQRCode = baseUrl + "?receiptId=" + receiptId;
    var _shortenUrl = url_shortener.shortenUrl(urlToQRCode),
      request = _shortenUrl[0],
      controller = _shortenUrl[1];
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return request();
          case 3:
            url = _context.sent;
            if (url) {
              setShortUrl(url);
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            logger.error('cringer.components - useReceiptQRCode - error:', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }))();
    return function () {
      controller.abort();
    };
  }, [setShortUrl, receiptId, status]);
  var openReceipt = function openReceipt() {
    var win = window.open(shortUrl, '_blank');
    win.focus();
  };
  return {
    shortUrl: shortUrl,
    placeholderImage: placeholderImage,
    mobile: mobile,
    t: t,
    openReceipt: openReceipt,
    receiptId: receiptId
  };
};

var ReceiptQRCode = function ReceiptQRCode(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '200x200' : _ref$size,
    _ref$customSession = _ref.customSession,
    customSession = _ref$customSession === void 0 ? {} : _ref$customSession,
    _ref$delayQRCodeRende = _ref.delayQRCodeRenderInMilliseconds,
    delayQRCodeRenderInMilliseconds = _ref$delayQRCodeRende === void 0 ? 0 : _ref$delayQRCodeRende;
  var _useState = React.useState(false),
    showQRCode = _useState[0],
    setShowQRCode = _useState[1];
  var _useReceiptQRCode = useReceiptQRCode({
      customSession: customSession
    }),
    shortUrl = _useReceiptQRCode.shortUrl,
    placeholderImage = _useReceiptQRCode.placeholderImage,
    mobile = _useReceiptQRCode.mobile,
    openReceipt = _useReceiptQRCode.openReceipt,
    t = _useReceiptQRCode.t;
  React.useEffect(function () {
    if (delayQRCodeRenderInMilliseconds !== 0) {
      var timer = setTimeout(function () {
        setShowQRCode(true);
      }, delayQRCodeRenderInMilliseconds);
      return function () {
        return clearTimeout(timer);
      };
    } else {
      setShowQRCode(true);
    }
  }, [delayQRCodeRenderInMilliseconds]);
  var _getQRCodeSize = getQRCodeSize(size),
    width = _getQRCodeSize.width,
    height = _getQRCodeSize.height;
  if (mobile) return /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
    onClick: openReceipt,
    children: "" + t('receiptQRCodeOpen')
  });
  if (!showQRCode || !shortUrl) {
    return /*#__PURE__*/jsxRuntime.jsx(Skeleton.SkeletonTheme, {
      children: /*#__PURE__*/jsxRuntime.jsx(Skeleton__default, {
        height: height,
        width: width
      })
    });
  }
  return /*#__PURE__*/jsxRuntime.jsx(QRCode, {
    url: shortUrl,
    placeholderImage: placeholderImage,
    size: size
  });
};

var ReceiptDetails = function ReceiptDetails(_temp) {
  var _receiptDetailsData$d, _receiptDetailsData$d2, _receiptDetailsData$d3;
  var _ref = _temp === void 0 ? {} : _temp,
    showFullFirstName = _ref.showFullFirstName,
    receiptDetailsData = _ref.receiptDetailsData,
    t = _ref.t,
    _ref$boxClassName = _ref.boxClassName,
    boxClassName = _ref$boxClassName === void 0 ? '' : _ref$boxClassName,
    _ref$delayQRCodeRende = _ref.delayQRCodeRenderInMilliseconds,
    delayQRCodeRenderInMilliseconds = _ref$delayQRCodeRende === void 0 ? 0 : _ref$delayQRCodeRende;
  if (!receiptDetailsData) return null;
  if (!t) return null;
  var orderNumberArray = receiptDetailsData == null ? void 0 : (_receiptDetailsData$d = receiptDetailsData.displayOrderNumber) == null ? void 0 : _receiptDetailsData$d.toString().split(' ');
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "receipt-details",
    className: "receipt-details flex flex-col justify-center w-full p-2 md:p-8 " + boxClassName,
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center text-2xl font-bold text-center md:text-5xl receipt-details__instruction",
      children: receiptDetailsData == null ? void 0 : receiptDetailsData.instruction
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center text-2xl font-bold text-center md:text-5xl md:mt-4 receipt-details__instructionPaymentMethod",
      children: receiptDetailsData == null ? void 0 : receiptDetailsData.instructionPaymentMethod
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "grid grid-rows-none gap-2 md:grid-cols-3 md:gap-4 md:mt-12",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-col items-center justify-center w-64 h-64 text-2xl border-4 border-black xs:w-auto receipt-details__reference",
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "receipt-details-reference-label",
            className: "text-2xl receipt-details__reference__label",
            children: t('receiptDetailsOrderNumber')
          }), showFullFirstName ? /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "receipt-details-reference-number",
            className: classNames('py-4 flex-wrap -mt-35 receipt-details__reference__number', orderNumberArray.length > 1 ? 'text-2xl px-2' : 'text-6xl px-4'),
            children: receiptDetailsData == null ? void 0 : (_receiptDetailsData$d2 = receiptDetailsData.displayOrderNumber) == null ? void 0 : (_receiptDetailsData$d3 = _receiptDetailsData$d2.toString().split(' ')) == null ? void 0 : _receiptDetailsData$d3.map(function (name, index) {
              return /*#__PURE__*/jsxRuntime.jsx("div", {
                className: "text-center break-all",
                children: name
              }, index);
            })
          }) : /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "receipt-details-reference-number",
            className: "p-4 flex text-6xl -mt-35 receipt-details__reference__number",
            children: receiptDetailsData == null ? void 0 : receiptDetailsData.displayOrderNumber
          })]
        })
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "text-2xl sm:text-3xl receipt-details__typeInfo",
        children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
          children: [t('receiptDetailsOrderType'), ": ", receiptDetailsData == null ? void 0 : receiptDetailsData.orderType]
        }), (receiptDetailsData == null ? void 0 : receiptDetailsData.showDate) && /*#__PURE__*/jsxRuntime.jsx("div", {
          children: receiptDetailsData == null ? void 0 : receiptDetailsData.datetime
        })]
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center md:justify-end",
        children: /*#__PURE__*/jsxRuntime.jsx(ReceiptQRCode, {
          size: "250x250",
          delayQRCodeRenderInMilliseconds: delayQRCodeRenderInMilliseconds
        })
      })]
    })]
  });
};

var PriceValueFormatted = function PriceValueFormatted(_ref) {
  var price = _ref.price,
    dataTest = _ref['data-test'],
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": dataTest,
    className: "flex items-end justify-center " + className,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      children: formatPrice({
        price: price
      })
    })
  });
};
var FinancialComponentWrapper = function FinancialComponentWrapper(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    dataTest = _ref2['data-test'];
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest + "-financial-component-wrapper",
    className: "flex justify-between w-full",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": dataTest + "-financial-component-wrapper_label-wrapper",
      className: "w-4/5",
      children: [label, ":"]
    }, label), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": dataTest + "-financial-component-wrapper_value-wrapper",
      className: "flex justify-end w-1/5",
      children: value
    })]
  });
};
var FinancialSummary = function FinancialSummary(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
    _ref3$receiptPaymentD = _ref3.receiptPaymentData,
    receiptPaymentData = _ref3$receiptPaymentD === void 0 ? {} : _ref3$receiptPaymentD,
    _ref3$t = _ref3.t,
    t = _ref3$t === void 0 ? function () {} : _ref3$t,
    _ref3$showSubtotal = _ref3.showSubtotal,
    showSubtotal = _ref3$showSubtotal === void 0 ? true : _ref3$showSubtotal,
    _ref3$showTaxTotal = _ref3.showTaxTotal,
    showTaxTotal = _ref3$showTaxTotal === void 0 ? true : _ref3$showTaxTotal,
    _ref3$showGSTExcludeM = _ref3.showGSTExcludeMessage,
    showGSTExcludeMessage = _ref3$showGSTExcludeM === void 0 ? false : _ref3$showGSTExcludeM,
    _ref3$showSavedAmount = _ref3.showSavedAmount,
    showSavedAmount = _ref3$showSavedAmount === void 0 ? false : _ref3$showSavedAmount;
  var _usePrice2 = usePrice(),
    formatPrice = _usePrice2.formatPrice;
  var _receiptPaymentData$t = receiptPaymentData.taxesBreakdown,
    taxesBreakdown = _receiptPaymentData$t === void 0 ? [] : _receiptPaymentData$t,
    _receiptPaymentData$f = receiptPaymentData.feesBreakdown,
    feesBreakdown = _receiptPaymentData$f === void 0 ? [] : _receiptPaymentData$f,
    _receiptPaymentData$s = receiptPaymentData.showTaxesBreakdown,
    showTaxesBreakdown = _receiptPaymentData$s === void 0 ? false : _receiptPaymentData$s,
    _receiptPaymentData$s2 = receiptPaymentData.showFeesBreakdown,
    showFeesBreakdown = _receiptPaymentData$s2 === void 0 ? false : _receiptPaymentData$s2,
    _receiptPaymentData$s3 = receiptPaymentData.showBreakdowns,
    showBreakdowns = _receiptPaymentData$s3 === void 0 ? false : _receiptPaymentData$s3,
    subTotalFinancialSumary = receiptPaymentData.subTotalFinancialSumary,
    total = receiptPaymentData.total,
    taxes = receiptPaymentData.taxes,
    savedAmount = receiptPaymentData.savedAmount;
  var subTotalPrice = showBreakdowns ? subTotalFinancialSumary : utilities.round(total) - utilities.round(taxes);
  if (showBreakdowns) showTaxTotal = false;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "financial-summary",
    className: "flex-row block w-full",
    children: [showSavedAmount && Number(savedAmount) > 0 && /*#__PURE__*/jsxRuntime.jsx(FinancialComponentWrapper, {
      label: t('discount'),
      "data-test": "financial-summary__savedAmount",
      value: /*#__PURE__*/jsxRuntime.jsx(PriceValueFormatted, {
        "data-test": "financial-summary__savedAmount",
        price: formatPrice({
          price: savedAmount,
          defaultPrefix: true
        })
      })
    }), showSubtotal && /*#__PURE__*/jsxRuntime.jsx(FinancialComponentWrapper, {
      label: t('receiptPaymentSubTotal'),
      "data-test": "financial-summary__subtotal",
      value: /*#__PURE__*/jsxRuntime.jsx(PriceValueFormatted, {
        "data-test": "financial-summary__subtotal",
        price: formatPrice({
          price: subTotalPrice,
          defaultPrefix: true
        })
      })
    }), showTaxTotal && /*#__PURE__*/jsxRuntime.jsx(FinancialComponentWrapper, {
      label: t('receiptPaymentTaxTotal'),
      "data-test": "financial-summary__tax-total",
      value: /*#__PURE__*/jsxRuntime.jsx(PriceValueFormatted, {
        "data-test": "financial-summary__tax-total",
        price: formatPrice({
          price: receiptPaymentData.taxes,
          defaultPrefix: true
        })
      })
    }), showTaxesBreakdown && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex-row block w-full",
      children: taxesBreakdown.map(function (tax, index) {
        return /*#__PURE__*/jsxRuntime.jsx(FinancialComponentWrapper, {
          "data-test": "financial-summary__taxes-" + tax.labelCurrentLanguage,
          label: tax == null ? void 0 : tax.labelCurrentLanguage,
          value: /*#__PURE__*/jsxRuntime.jsx(PriceValueFormatted, {
            "data-test": "financial-summary__taxes-" + tax.labelCurrentLanguage,
            price: formatPrice({
              price: tax.value,
              defaultPrefix: true
            })
          }, index)
        }, index);
      })
    }), showFeesBreakdown && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex-row block w-full",
      children: feesBreakdown.map(function (fee, index) {
        return /*#__PURE__*/jsxRuntime.jsx(FinancialComponentWrapper, {
          label: fee == null ? void 0 : fee.labelCurrentLanguage,
          "data-test": "financial-summary__fees-" + fee.labelCurrentLanguage,
          value: /*#__PURE__*/jsxRuntime.jsx(PriceValueFormatted, {
            "data-test": "financial-summary__fees-" + fee.labelCurrentLanguage,
            price: formatPrice({
              price: fee.value,
              defaultPrefix: true
            })
          }, index)
        }, index);
      })
    }), /*#__PURE__*/jsxRuntime.jsx(FinancialComponentWrapper, {
      label: t('receiptPaymentTotal'),
      "data-test": "financial-summary__total",
      value: /*#__PURE__*/jsxRuntime.jsx(PriceValueFormatted, {
        "data-test": "financial-summary__total",
        price: formatPrice({
          price: receiptPaymentData.total,
          defaultPrefix: true
        })
      })
    }), showGSTExcludeMessage && /*#__PURE__*/jsxRuntime.jsxs("div", {
      children: [" ", t('receiptGSTExcludeMessage')]
    })]
  });
};
var ReceiptPayment = function ReceiptPayment(_temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
    _ref4$receiptPaymentD = _ref4.receiptPaymentData,
    receiptPaymentData = _ref4$receiptPaymentD === void 0 ? null : _ref4$receiptPaymentD,
    _ref4$t = _ref4.t,
    t = _ref4$t === void 0 ? null : _ref4$t,
    _ref4$boxClassName = _ref4.boxClassName,
    boxClassName = _ref4$boxClassName === void 0 ? '' : _ref4$boxClassName,
    _ref4$showTaxNumber = _ref4.showTaxNumber,
    showTaxNumber = _ref4$showTaxNumber === void 0 ? true : _ref4$showTaxNumber,
    _ref4$showSubtotal = _ref4.showSubtotal,
    showSubtotal = _ref4$showSubtotal === void 0 ? true : _ref4$showSubtotal,
    _ref4$showTaxTotal = _ref4.showTaxTotal,
    showTaxTotal = _ref4$showTaxTotal === void 0 ? true : _ref4$showTaxTotal,
    _ref4$showKitchenId = _ref4.showKitchenId,
    showKitchenId = _ref4$showKitchenId === void 0 ? false : _ref4$showKitchenId,
    _ref4$showGSTExcludeM = _ref4.showGSTExcludeMessage,
    showGSTExcludeMessage = _ref4$showGSTExcludeM === void 0 ? false : _ref4$showGSTExcludeM,
    _ref4$showRestaurantN = _ref4.showRestaurantName,
    showRestaurantName = _ref4$showRestaurantN === void 0 ? true : _ref4$showRestaurantN,
    _ref4$showAddress = _ref4.showAddress,
    showAddress = _ref4$showAddress === void 0 ? true : _ref4$showAddress,
    _ref4$showPhoneNumber = _ref4.showPhoneNumber,
    showPhoneNumber = _ref4$showPhoneNumber === void 0 ? true : _ref4$showPhoneNumber,
    _ref4$showSavedAmount = _ref4.showSavedAmount,
    showSavedAmount = _ref4$showSavedAmount === void 0 ? false : _ref4$showSavedAmount;
  if (!receiptPaymentData) return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {});
  if (!t) return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {});
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "receipt-payment",
    className: "w-full md:mb-8 receipt-payment grid sm:grid-cols-2 gap-2 md:gap-4 p-2 md:p-4 " + boxClassName,
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "text-3xl",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "receipt-payment__payment-method-details",
        children: receiptPaymentData.paymentMethodDetails
      }), showRestaurantName && /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "receipt-payment__store-name",
        children: [t('receiptPaymentRestaurantName'), ": ", receiptPaymentData.storeName]
      }), showAddress && /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "receipt-payment__store-address",
        children: [t('receiptPaymentRestaurantAddress'), ": ", receiptPaymentData.address]
      }), receiptPaymentData.phone && showPhoneNumber && /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "receipt-payment__store-phone",
        children: [t('receiptPaymentPhone'), ": ", receiptPaymentData.phone]
      }), showTaxNumber && /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "receipt-payment__store-tax-number",
        children: [t('receiptPaymentTaxNumber'), ": ", receiptPaymentData.taxNumber]
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "text-xl sm:text-3xl",
      children: [showKitchenId && /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "receipt-payment__kitchen-id",
        children: [t('receiptPaymentKitchenId'), ": ", receiptPaymentData.kitchenId]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "receipt-payment__product-quantity",
        children: [t('receiptPaymentItemQuantity'), ": ", receiptPaymentData.productQuantity]
      }), /*#__PURE__*/jsxRuntime.jsx(FinancialSummary, {
        t: t,
        showSubtotal: showSubtotal,
        showTaxTotal: showTaxTotal,
        showSavedAmount: showSavedAmount,
        receiptPaymentData: receiptPaymentData,
        showGSTExcludeMessage: showGSTExcludeMessage
      })]
    })]
  });
};

var IFrameModal = function IFrameModal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? 'https://www.google.com/' : _ref$url,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$showModal = _ref.showModal,
    showModal = _ref$showModal === void 0 ? false : _ref$showModal,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsxRuntime.jsx(Modal, {
    "data-test": "iframe-modal",
    open: showModal,
    title: t('termsAndConditionsModalTitle'),
    closeModal: onClose,
    closeText: t('termsAndConditionsModalCloseAction'),
    className: className,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "w-full h-full",
      children: /*#__PURE__*/jsxRuntime.jsx("iframe", {
        src: url,
        className: "w-full h-full",
        sandbox: "allow-scripts allow-top-navigation-by-user-activation"
      })
    })
  });
};

var ReceiptView = function ReceiptView(_ref) {
  var _ref$RewardPointsComp = _ref.RewardPointsComponent,
    RewardPointsComponent = _ref$RewardPointsComp === void 0 ? null : _ref$RewardPointsComp;
  var _useReceiptView = useReceiptView(),
    t = _useReceiptView.t,
    cart = _useReceiptView.cart,
    receiptPaymentData = _useReceiptView.receiptPaymentData,
    receiptDetailsData = _useReceiptView.receiptDetailsData,
    formatPrice = _useReceiptView.formatPrice,
    showTaxNumber = _useReceiptView.showTaxNumber,
    showSubtotal = _useReceiptView.showSubtotal,
    showTaxTotal = _useReceiptView.showTaxTotal,
    showKitchenId = _useReceiptView.showKitchenId,
    showFullFirstName = _useReceiptView.showFullFirstName,
    showEnergyInformation = _useReceiptView.showEnergyInformation,
    showGSTExcludeMessage = _useReceiptView.showGSTExcludeMessage,
    showAddonAvailability = _useReceiptView.showAddonAvailability,
    termsAndConditionsURL = _useReceiptView.termsAndConditionsURL,
    showTermsAndConditionsModal = _useReceiptView.showTermsAndConditionsModal,
    onCloseTermsAndConditionsModal = _useReceiptView.onCloseTermsAndConditionsModal,
    hideNoPrefixWhenDefaultNotSelected = _useReceiptView.hideNoPrefixWhenDefaultNotSelected,
    delayQRCodeRenderInMilliseconds = _useReceiptView.delayQRCodeRenderInMilliseconds,
    showRestaurantName = _useReceiptView.showRestaurantName,
    showAddress = _useReceiptView.showAddress,
    showPhoneNumber = _useReceiptView.showPhoneNumber,
    showOriginalPriceForCombo = _useReceiptView.showOriginalPriceForCombo,
    showSavedAmount = _useReceiptView.showSavedAmount;
  var showGSTAsterisk = receiptDetailsData.orderType === 'Takeaway' && showGSTExcludeMessage ? true : false;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "receipt-page",
    className: "flex flex-col items-center w-full p-2 space-y-8 md:h-full md:p-8 receipt-page",
    children: [/*#__PURE__*/jsxRuntime.jsx(IFrameModal, {
      url: termsAndConditionsURL,
      onClose: onCloseTermsAndConditionsModal,
      showModal: showTermsAndConditionsModal,
      t: t,
      className: "receipt-page-iframe"
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "receipt-title",
      children: t('receiptTitle')
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col w-full h-full space-y-8 md:overflow-y-auto",
      children: [/*#__PURE__*/jsxRuntime.jsx(ReceiptDetails, {
        showFullFirstName: showFullFirstName,
        receiptDetailsData: receiptDetailsData,
        t: t,
        boxClassName: "border-2 border-black bg-white",
        delayQRCodeRenderInMilliseconds: delayQRCodeRenderInMilliseconds
      }), cart && cart.map(function (product) {
        return /*#__PURE__*/jsxRuntime.jsx(CartViewProduct, {
          t: t,
          product: product,
          formatPrice: formatPrice,
          boxClassName: "border-2 border-black bg-white",
          showEnergyInformation: showEnergyInformation,
          showGSTAsterisk: showGSTAsterisk,
          showAddonAvailability: showAddonAvailability,
          RewardPointsComponent: RewardPointsComponent,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected,
          showOriginalPriceForCombo: showOriginalPriceForCombo
        }, product.uid);
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col items-center justify-center w-full space-y-8",
      children: /*#__PURE__*/jsxRuntime.jsx(ReceiptPayment, {
        t: t,
        boxClassName: "border-2 border-black bg-white",
        showSubtotal: showSubtotal,
        showTaxTotal: showTaxTotal,
        showTaxNumber: showTaxNumber,
        showKitchenId: showKitchenId,
        receiptPaymentData: receiptPaymentData,
        showGSTExcludeMessage: showGSTExcludeMessage,
        showRestaurantName: showRestaurantName,
        showAddress: showAddress,
        showPhoneNumber: showPhoneNumber,
        showSavedAmount: showSavedAmount
      })
    })]
  });
};

var PaymentOptionsViewContext = /*#__PURE__*/React.createContext();
var PaymentOptionsViewProvider = function PaymentOptionsViewProvider(_ref) {
  var children = _ref.children,
    _ref$previousPath = _ref.previousPath,
    previousPath = _ref$previousPath === void 0 ? '/cart' : _ref$previousPath,
    _ref$cashNextPath = _ref.cashNextPath,
    nonCardNextPath = _ref$cashNextPath === void 0 ? '/cash-payment' : _ref$cashNextPath,
    _ref$cardNextPath = _ref.cardNextPath,
    cardNextPath = _ref$cardNextPath === void 0 ? '/payment' : _ref$cardNextPath,
    _ref$isPreviousAction = _ref.isPreviousActionEnabled,
    isPreviousActionEnabled = _ref$isPreviousAction === void 0 ? true : _ref$isPreviousAction,
    _ref$showLoyaltyBanne = _ref.showLoyaltyBanner,
    showLoyaltyBanner = _ref$showLoyaltyBanne === void 0 ? false : _ref$showLoyaltyBanne,
    _ref$showServerTotal = _ref.showServerTotal,
    showServerTotal = _ref$showServerTotal === void 0 ? false : _ref$showServerTotal;
  var settings = utilities.useSettings();
  var _useRecoilState = recoil.useRecoilState(atoms.paymentState),
    payment = _useRecoilState[0],
    setPaymentState = _useRecoilState[1];
  var orderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState);
  var _useTranslation = reactI18next.useTranslation(),
    t = _useTranslation.t;
  var total = recoil.useRecoilValue(atoms.orderTotalState);
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useAnalytics = jitsu.useAnalytics(),
    paymentStartedTrack = _useAnalytics.paymentStartedTrack;
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _ref2 = orderPayload || {},
    _ref2$financialSummar = _ref2.financialSummary,
    financialSummary = _ref2$financialSummar === void 0 ? {} : _ref2$financialSummar;
  var _financialSummary$tot = financialSummary.total,
    serverCalculatedAmount = _financialSummary$tot === void 0 ? null : _financialSummary$tot;
  var available = {
    settings: settings,
    previousPath: previousPath,
    nonCardNextPath: nonCardNextPath,
    cardNextPath: cardNextPath,
    paymentState: payment,
    setPaymentState: setPaymentState,
    t: t,
    total: showServerTotal ? serverCalculatedAmount : total,
    formatPrice: formatPrice,
    paymentStartedTrack: paymentStartedTrack,
    setTemplate: setTemplate,
    isPreviousActionEnabled: isPreviousActionEnabled,
    showLoyaltyBanner: showLoyaltyBanner
  };
  return /*#__PURE__*/jsxRuntime.jsx(PaymentOptionsViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var usePaymentOptionsViewContext = function usePaymentOptionsViewContext() {
  var context = React.useContext(PaymentOptionsViewContext);
  if (context === undefined) {
    throw new Error('usePaymentOptionsViewContext must be used within a PaymentOptionsViewProvider');
  }
  return context;
};

var img$1 = "data:image/png;base64,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";

var PaymentOptionButton = function PaymentOptionButton(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    expressMessage = _ref.expressMessage,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'card' : _ref$method,
    title = _ref.title,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'payment' : _ref$dataTest;
  return /*#__PURE__*/jsxRuntime.jsxs("button", {
    onClick: onClick,
    className: "w-full payment-option-button " + className,
    "data-test": dataTest,
    children: [method === 'card' && /*#__PURE__*/jsxRuntime.jsx(CreditCard, {
      className: "w-28 h-36 sm:w-48 sm:h-48 sm:py-6",
      fill: "currentColor",
      "data-test": "credit-card-icon"
    }), method === 'cash' && /*#__PURE__*/jsxRuntime.jsx(MoneyBillAlt, {
      className: "w-28 h-36 sm:w-48 sm:h-48 sm:py-6",
      fill: "currentColor",
      "data-test": "money-bill-icon"
    }), method === 'momopay' && /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
      src: img$1,
      alt: "Momo Pay",
      className: "w-36 h-36 sm:w-42 sm:h-48 sm:py-6",
      "data-test": "momo-pay-logo"
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-4xl font-bold uppercase sm:mt-4 sm:text-7xl",
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-row items-center justify-center h-20 sm:mt-8",
      children: expressMessage && /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-row items-center justify-center text-green-600",
        children: [/*#__PURE__*/jsxRuntime.jsx(CheckCircle, {
          className: "w-8 h-8 mr-1 sm:w-10 sm:h-10 sm:mr-4"
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "text-2xl sm:text-4xl ",
          children: expressMessage
        })]
      })
    })]
  });
};

var usePaymentOptionsView = function usePaymentOptionsView() {
  var history = reactRouterDom.useHistory();
  var _useMetadata = useMetadata(),
    metadata = _useMetadata.metadata;
  var _usePaymentOptionsVie = usePaymentOptionsViewContext(),
    settings = _usePaymentOptionsVie.settings,
    cardNextPath = _usePaymentOptionsVie.cardNextPath,
    t = _usePaymentOptionsVie.t,
    previousPath = _usePaymentOptionsVie.previousPath,
    total = _usePaymentOptionsVie.total,
    paymentState = _usePaymentOptionsVie.paymentState,
    setPaymentState = _usePaymentOptionsVie.setPaymentState,
    formatPrice = _usePaymentOptionsVie.formatPrice,
    paymentStartedTrack = _usePaymentOptionsVie.paymentStartedTrack,
    setTemplate = _usePaymentOptionsVie.setTemplate,
    isPreviousActionEnabled = _usePaymentOptionsVie.isPreviousActionEnabled,
    showLoyaltyBanner = _usePaymentOptionsVie.showLoyaltyBanner;
  var paymentStartedCalledRef = React.useRef({});
  var accessibilityEnabled = React.useMemo(function () {
    return (metadata == null ? void 0 : metadata.accessibilityEnabled) || false;
  }, [metadata]);
  var handleSelection = React.useCallback(function (_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'card' : _ref$type;
    return function () {
      var paymentType = (type == null ? void 0 : type.toLowerCase()) || 'card';
      if (!paymentStartedCalledRef.current[paymentType]) {
        try {
          paymentStartedTrack(paymentType);
          paymentStartedCalledRef.current[paymentType] = true;
        } catch (error) {
          logger.error("behavioural-analytics - paymentStartedTrack - error: " + error.message);
        }
      }
      setPaymentState(function (state) {
        return _extends({}, state, {
          paymentType: paymentType
        });
      });
    };
  }, [setPaymentState, paymentStartedTrack]);
  var onBack = React.useCallback(function () {
    return history.push(previousPath);
  }, [previousPath, history]);
  var paymentOptions = React.useMemo(function () {
    var _settings$settings, _settings$settings$se;
    return Object.entries((settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$se = _settings$settings.settings) == null ? void 0 : _settings$settings$se.paymentMethodOptions) || {}).reduce(function (result, _ref2) {
      var key = _ref2[0],
        value = _ref2[1];
      if (value) result.push(key);
      return result;
    }, []).sort();
  }, [settings]);
  var paymentOptionCards = React.useMemo(function () {
    return paymentOptions.map(function (paymentOption) {
      if (paymentOption !== 'card')
        // differentiating between `card` and `not card` purely for what component to use
        // in future providers should have some way of specifying which icons to use (for extensibility by 3rd party)
        return /*#__PURE__*/jsxRuntime.jsx(PaymentOptionButton, {
          title: t("paymentOptions" + paymentOption.toUpperCase() + "Title"),
          onClick: handleSelection({
            type: paymentOption
          }),
          "data-test": paymentOption + "-payment",
          method: paymentOption
        }, paymentOption);
      if (paymentOption === 'card') return /*#__PURE__*/jsxRuntime.jsx(PaymentOptionButton, {
        expressMessage: t('paymentOptionsExpressMessage'),
        title: t("paymentOptions" + paymentOption.toUpperCase() + "Title"),
        onClick: handleSelection({
          type: paymentOption
        }),
        "data-test": paymentOption + "-payment",
        method: paymentOption
      }, paymentOption);
      return null;
    });
  }, [handleSelection, paymentOptions, t]);
  var formattedTotal = React.useMemo(function () {
    return formatPrice({
      price: total
    });
  }, [total, formatPrice]);
  React.useEffect(function () {
    if (!paymentState) return;
    history.push(cardNextPath);
  }, [cardNextPath, paymentState, history]);
  React.useEffect(function () {
    if (paymentOptions.length !== 1) return;
    var option = paymentOptions[0];
    handleSelection({
      type: option
    })();
  }, [handleSelection, paymentOptions, setPaymentState]);
  React.useEffect(function () {
    var header = {
      showLoyaltyBanner: showLoyaltyBanner
    };
    var footer = {
      showBasketCount: false,
      previousAction: onBack,
      previousText: t('paymentOptionsSecondaryAction'),
      isPreviousActionEnabled: isPreviousActionEnabled
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        footer: footer,
        header: header
      });
    });
  }, [setTemplate, onBack, t, isPreviousActionEnabled, showLoyaltyBanner]);
  return {
    paymentOptions: paymentOptions,
    paymentOptionCards: paymentOptionCards,
    accessibilityEnabled: accessibilityEnabled,
    t: t,
    formattedTotal: formattedTotal
  };
};

var PaymentOptionsView = function PaymentOptionsView() {
  var _usePaymentOptionsVie = usePaymentOptionsView(),
    paymentOptionCards = _usePaymentOptionsVie.paymentOptionCards,
    t = _usePaymentOptionsVie.t,
    formattedTotal = _usePaymentOptionsVie.formattedTotal;
  var numCols = paymentOptionCards ? paymentOptionCards.length : 1;
  var largeCols = numCols < 3 ? numCols : 2;
  var extraLargeCols = numCols;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col items-center w-full h-full p-4 overflow-y-auto sm:p-8 payment-options-view",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "payment-options-title",
      children: t('paymentOptionsTitle')
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "payment-options-subtitle",
      children: formattedTotal
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "grid justify-center w-full gap-8 mt-8 pb-4 sm:grid-cols-1 lg:grid-cols-" + largeCols + " xl:grid-cols-" + extraLargeCols + " sm:mt-32 payment-buttons-container",
      children: paymentOptionCards
    })]
  });
};

var useRestaurantOrder = function useRestaurantOrder() {
  var _config$settings, _config$settings$inte;
  var _useCart = cart.useCart(),
    items = _useCart.items;
  var session = recoil.useRecoilValue(atoms.sessionState);
  var settings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var _useRecoilState = recoil.useRecoilState(atoms.localeState),
    currentLanguage = _useRecoilState[0];
  var orderPayload = recoil.useRecoilValue(atoms.formattedOrderPayloadState({
    items: items
  }));
  var setSession = recoil.useSetRecoilState(atoms.sessionState);
  var _useState = React.useState(null),
    saveSessionState = _useState[0],
    setSaveSessionState = _useState[1];
  var _useState2 = React.useState(null),
    cancelSessionState = _useState2[0],
    setCancelSessionState = _useState2[1];
  var _useState3 = React.useState(null),
    resetSessionState = _useState3[0],
    setResetSessionState = _useState3[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.beaconState),
    beaconNumber = _useRecoilState2[0],
    setBeaconNumber = _useRecoilState2[1];
  var config = recoil.useRecoilValue(atoms.settingsState);
  var location = reactRouterDom.useLocation();
  var _config$settings$orde = config.settings.order,
    order = _config$settings$orde === void 0 ? {} : _config$settings$orde;
  var _order$local = order.local,
    local = _order$local === void 0 ? {} : _order$local,
    _order$type = order.type,
    provider = _order$type === void 0 ? '' : _order$type;
  var ip = local.ip;
  var _ref = (config == null ? void 0 : (_config$settings = config.settings) == null ? void 0 : (_config$settings$inte = _config$settings.interval) == null ? void 0 : _config$settings$inte.timeout) || {},
    _ref$order = _ref.order,
    timeout = _ref$order === void 0 ? 30 : _ref$order;
  var isHomeRoute = location && (location == null ? void 0 : location.pathname) === '/home';
  var _useAnalytics = jitsu.useAnalytics({
      isFirstCall: !session && (items == null ? void 0 : items.length) === 0 && isHomeRoute
    }),
    setAnalyticsIdentify = _useAnalytics.setAnalyticsIdentify,
    dineModeTrack = _useAnalytics.dineModeTrack;
  var startSession = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
      var id, timestamp, payload, _yield$saveOrder, status, receiptId, _yield$saveOrder$sess, _beaconNumber, message;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = nanoid.nanoid();
            timestamp = utilities.timestamp();
            if (!id) {
              logger.error("components - startSession - sessionId is not defined: " + id);
            }
            if (!timestamp) {
              logger.error("components - startSession - timestamp is not defined: " + timestamp);
            }
            payload = {
              settings: settings,
              session: {
                timestamp: timestamp,
                sessionId: id
              }
            };
            logger.updateAdditionalFields({
              fields: {
                sessionId: id
              }
            });
            logger.info('components - session started');
            _context.prev = 7;
            setSession({
              id: id,
              type: type,
              timestamp: timestamp,
              currentLanguage: currentLanguage
            });
            logger.info('components - fetch receipt ID with saveOrder on session start');
            _context.next = 12;
            return fmApi.saveOrder(payload);
          case 12:
            _yield$saveOrder = _context.sent;
            status = _yield$saveOrder.status;
            receiptId = _yield$saveOrder.receiptId;
            _yield$saveOrder$sess = _yield$saveOrder.session.beaconNumber;
            _beaconNumber = _yield$saveOrder$sess === void 0 ? undefined : _yield$saveOrder$sess;
            setSession(function (session) {
              return _extends({}, session, {
                beaconNumber: _beaconNumber,
                status: status,
                receiptId: receiptId
              });
            });
            _context.next = 25;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](7);
            message = (_context.t0 == null ? void 0 : _context.t0.message) || 'No error message available';
            logger.error("components - failed to fetch receipt ID: " + message);
            // On failure carry on without a receipt ID.
            setSession({
              id: id,
              type: type,
              timestamp: timestamp
            });
          case 25:
            _context.prev = 25;
            _context.prev = 26;
            _context.next = 29;
            return setAnalyticsIdentify(id, settings);
          case 29:
            dineModeTrack(type, settings.kiosk);
            _context.next = 35;
            break;
          case 32:
            _context.prev = 32;
            _context.t1 = _context["catch"](26);
            logger.error("behavioural-analytics - error: " + (_context.t1 == null ? void 0 : _context.t1.message));
          case 35:
            return _context.finish(25);
          case 36:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 20, 25, 36], [26, 32]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [settings, setSession, setAnalyticsIdentify, dineModeTrack, currentLanguage]);
  var saveSession = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var beaconNumberValue;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          try {
            logger.info('components - starting saveSession - saveOrder');
            beaconNumberValue = session.beaconNumber;
            fmApi.doSaveOrder({
              timeout: timeout,
              provider: provider,
              transition: function transition(machine) {
                if (!beaconNumber) setBeaconNumber(beaconNumberValue);
                return setSaveSessionState(machine);
              },
              payload: _extends({}, orderPayload, {
                session: _extends({}, session, {
                  sessionId: (session == null ? void 0 : session.id) || (session == null ? void 0 : session.sessionId)
                })
              })
            });
          } catch (err) {
            logger.error('cringer.components - saveSession - error:', err);
          }
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [session, orderPayload, timeout, provider, beaconNumber, setBeaconNumber]);
  var handleCancelSession = React.useCallback(function (machine) {
    if (machine != null && machine.matches('success')) {
      var _ref4 = machine.context || {},
        _ref4$data = _ref4.data,
        payload = _ref4$data === void 0 ? null : _ref4$data;
      logger.info('components - starting cancelSession - saveOrder');
      fmApi.doSaveOrder({
        timeout: timeout,
        provider: provider,
        transition: function transition(machine) {
          return setSaveSessionState(machine);
        },
        payload: _extends({}, orderPayload, {
          status: payload == null ? void 0 : payload.status
        })
      });
    }
    setCancelSessionState(machine);
  }, [orderPayload, timeout, setSaveSessionState, provider]);
  var cancelSession = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          try {
            fmApi.doCancelOrder({
              ip: ip,
              timeout: timeout,
              provider: provider,
              payload: orderPayload,
              transition: function transition(machine) {
                return handleCancelSession(machine);
              }
            });
          } catch (err) {
            logger.error('cringer.components - cancelSession - error:', err);
          }
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [orderPayload, timeout, handleCancelSession, ip, provider]);
  var doResetSession = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          try {
            fmApi.doResetOrder({
              ip: ip,
              timeout: timeout,
              provider: provider,
              payload: orderPayload,
              transition: function transition(machine) {
                return setResetSessionState(machine);
              }
            });
          } catch (err) {
            logger.error('cringer.components - resetSession - error:', err);
          }
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [orderPayload, timeout, setResetSessionState, ip, provider]);
  return {
    saveSession: saveSession,
    startSession: startSession,
    saveSessionState: saveSessionState,
    cancelSession: cancelSession,
    cancelSessionState: cancelSessionState,
    doResetSession: doResetSession,
    resetSessionState: resetSessionState
  };
};

var _loadingService$1 = /*#__PURE__*/loadingService(),
  loadingMachine$1 = _loadingService$1.loadingMachine;
var failedPaymentReceiptUrl = process.env.POI_APP_RECEIPT_FAILED_PAYMENT_FUNCTION;
var CardPaymentViewContext = /*#__PURE__*/React.createContext();
var CardPaymentViewProvider = function CardPaymentViewProvider(_ref) {
  var _settings$settings4, _settings$settings4$r;
  var children = _ref.children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/checkout' : _ref$nextPath,
    _ref$previousPath = _ref.previousPath,
    previousPath = _ref$previousPath === void 0 ? '/cart' : _ref$previousPath,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? false : _ref$showCategoriesHe,
    _ref$showLoyaltyBanne = _ref.showLoyaltyBanner,
    showLoyaltyBanner = _ref$showLoyaltyBanne === void 0 ? false : _ref$showLoyaltyBanne;
  // The `deviceConfig` will be passed from the `useSystem` hook (when it exists 👀)
  var _useSystem = useSystem(),
    port = _useSystem.port;
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var _useRecoilState = recoil.useRecoilState(atoms.paymentState),
    paymentResponse = _useRecoilState[0],
    setPaymentState = _useRecoilState[1];
  var _useState = React.useState(false),
    isMomoPay = _useState[0],
    setIsMomoPay = _useState[1];
  var resetPaymentResponse = recoil.useResetRecoilState(atoms.paymentState);
  var orderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState);
  var _useMachine = react.useMachine(loadingMachine$1),
    paymentState = _useMachine[0],
    paymentSend = _useMachine[1];
  var session = recoil.useRecoilValue(atoms.sessionState);
  var onlineStatus = recoil.useRecoilValue(atoms.onlineStatusState);
  var _onlineStatus$isOnlin = onlineStatus.isOnline,
    isOnline = _onlineStatus$isOnlin === void 0 ? true : _onlineStatus$isOnlin,
    _onlineStatus$isOnlin2 = onlineStatus.isOnlineTimedOut,
    isOnlineTimedOut = _onlineStatus$isOnlin2 === void 0 ? false : _onlineStatus$isOnlin2;
  var _useRestaurantOrder = useRestaurantOrder(),
    saveSession = _useRestaurantOrder.saveSession;
  var provider = React.useMemo(function () {
    var _ref2 = paymentResponse || {},
      _ref2$paymentType = _ref2.paymentType,
      paymentType = _ref2$paymentType === void 0 ? 'card' : _ref2$paymentType; // default card as `cash` will always be set
    var isUsingProviders = paymentType === 'card';
    if (isUsingProviders) {
      var _settings$settings, _settings$settings$pa, _settings$settings2, _settings$settings2$p;
      //this provider option was created differently from the object with its settings
      //it needs to be parsed here to keep compatibility with V1 for now
      //TODO: change KAS to have the correct option in the providers dropdown (ksaMada) when we ditch V1
      if ((settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$pa = _settings$settings.payment) == null ? void 0 : _settings$settings$pa.provider) === 'ksa-mada') {
        return 'ksaMada';
      }
      return settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$p = _settings$settings2.payment) == null ? void 0 : _settings$settings2$p.provider;
    }
    return paymentType;
  }, [settings, paymentResponse]);
  var _ref3 = orderPayload || {},
    _ref3$financialSummar = _ref3.financialSummary,
    financialSummary = _ref3$financialSummar === void 0 ? {} : _ref3$financialSummar;
  var _financialSummary$tot = financialSummary.total,
    amount = _financialSummary$tot === void 0 ? null : _financialSummary$tot;
  var sessionId = session.id,
    _session$kitchenId = session.kitchenId,
    orderId = _session$kitchenId === void 0 ? null : _session$kitchenId,
    receiptId = session.receiptId;
  var _settings$settings3 = settings == null ? void 0 : settings.settings,
    payment = _settings$settings3.payment,
    site = _settings$settings3.site,
    mocks = _settings$settings3.mocks,
    interval = _settings$settings3.interval,
    datasource = _settings$settings3.datasource;
  var storeId = site.storeId;
  var pinpadIntervals = interval.pinpad;
  var _pinpadIntervals$paym = pinpadIntervals.payment,
    timeout = _pinpadIntervals$paym === void 0 ? 30 : _pinpadIntervals$paym;
  var siteId = datasource.storeId;
  var providerSettings = payment == null ? void 0 : payment[provider];
  var isPaymentMocked = mocks.payment;
  var paymentSettings = _extends({
    storeId: storeId,
    siteId: siteId,
    timeout: timeout
  }, providerSettings);
  var orderSettings = {
    orderId: orderId
  };
  var hasFailedPaymentReceipt = (settings == null ? void 0 : (_settings$settings4 = settings.settings) == null ? void 0 : (_settings$settings4$r = _settings$settings4.receipt) == null ? void 0 : _settings$settings4$r.failedPaymentReceipt) || false;
  var config = {
    order: orderSettings,
    settings: paymentSettings,
    port: port,
    provider: provider,
    sessionId: sessionId
  };
  var _useMemo = React.useMemo(function () {
      // Match naming conventions from previous system
      return transactions.buildPaymentHandlers({
        provider: provider,
        mock: isPaymentMocked
      });
    }, [provider, isPaymentMocked]),
    pay = _useMemo.pay;
  var _useTransactions = useTransactions(),
    addTransaction = _useTransactions.addTransaction;
  var available = {
    pay: pay,
    config: config,
    amount: amount,
    nextPath: nextPath,
    paymentSend: paymentSend,
    previousPath: previousPath,
    paymentState: paymentState,
    setPaymentState: setPaymentState,
    paymentResponse: paymentResponse,
    addTransaction: addTransaction,
    resetPaymentResponse: resetPaymentResponse,
    showCategoriesHeader: showCategoriesHeader,
    saveSession: saveSession,
    hasFailedPaymentReceipt: hasFailedPaymentReceipt,
    failedPaymentReceiptUrl: failedPaymentReceiptUrl,
    receiptId: receiptId,
    isOnline: isOnline,
    isOnlineTimedOut: isOnlineTimedOut,
    isMomoPay: isMomoPay,
    setIsMomoPay: setIsMomoPay,
    showLoyaltyBanner: showLoyaltyBanner
  };
  return /*#__PURE__*/jsxRuntime.jsx(CardPaymentViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useCardPaymentViewContext = function useCardPaymentViewContext() {
  var context = React.useContext(CardPaymentViewContext);
  if (context === undefined) {
    throw new Error('useCardPaymentViewContext must be used within a CardPaymentViewProvider');
  }
  return context;
};

var _excluded$3 = ["paymentType"];
var RETRY_ATTEMPTS = 3;
var useCardPaymentView = function useCardPaymentView() {
  var _useCardPaymentViewCo = useCardPaymentViewContext(),
    pay = _useCardPaymentViewCo.pay,
    amount = _useCardPaymentViewCo.amount,
    config = _useCardPaymentViewCo.config,
    nextPath = _useCardPaymentViewCo.nextPath,
    previousPath = _useCardPaymentViewCo.previousPath,
    paymentResponse = _useCardPaymentViewCo.paymentResponse,
    setPaymentResponse = _useCardPaymentViewCo.setPaymentState,
    addTransaction = _useCardPaymentViewCo.addTransaction,
    resetPaymentResponse = _useCardPaymentViewCo.resetPaymentResponse,
    showCategoriesHeader = _useCardPaymentViewCo.showCategoriesHeader,
    saveSession = _useCardPaymentViewCo.saveSession,
    failedPaymentReceiptUrl = _useCardPaymentViewCo.failedPaymentReceiptUrl,
    hasFailedPaymentReceipt = _useCardPaymentViewCo.hasFailedPaymentReceipt,
    receiptId = _useCardPaymentViewCo.receiptId,
    isOnline = _useCardPaymentViewCo.isOnline,
    isOnlineTimedOut = _useCardPaymentViewCo.isOnlineTimedOut,
    isMomoPay = _useCardPaymentViewCo.isMomoPay,
    setIsMomoPay = _useCardPaymentViewCo.setIsMomoPay,
    showLoyaltyBanner = _useCardPaymentViewCo.showLoyaltyBanner;
  var hasCalledPayRef = React.useRef(false);
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useState = React.useState(null),
    paymentState = _useState[0],
    setPaymentState = _useState[1];
  var _useState2 = React.useState(null),
    paymentMachine = _useState2[0],
    setPaymentMachine = _useState2[1];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _useState3 = React.useState(null),
    shortUrl = _useState3[0],
    setShortUrl = _useState3[1];
  var _useState4 = React.useState(false),
    hasOnlineTimedOutOnce = _useState4[0],
    setHasOnlineTimedOutOnce = _useState4[1];
  var _useState5 = React.useState(0),
    retryCount = _useState5[0],
    setRetryCount = _useState5[1];
  var history = reactRouterDom.useHistory();
  var onReset = function onReset() {
    return history.push('/reset');
  };

  //we should bypass payment if amount == 0
  React.useEffect(function () {
    if (amount > 0) return;
    var noAmountPaymentData = {
      paymentType: 'CARD',
      info: {
        config: config,
        cardNumber: '**** 1111',
        paymentType: 'CARD',
        transactionId: nanoid.nanoid(),
        timestamp: utilities.timestamp(),
        result: 'success',
        response: 'success',
        message: 'success',
        authCode: nanoid.nanoid(),
        amount: amount
      }
    };
    setPaymentResponse(noAmountPaymentData);
    if (!(paymentResponse != null && paymentResponse.info)) return; // waits for paymentResponse atom to be set before continuing

    addTransaction({
      status: 'ORDER_PAYMENT_SUCCESS'
    });
    history.push(nextPath);
  }, [addTransaction, history, nextPath, setPaymentResponse, paymentResponse, amount, config]);
  React.useEffect(function () {
    if (isOnlineTimedOut && !hasOnlineTimedOutOnce) {
      setHasOnlineTimedOutOnce(true);
    }
    if (isOnline) {
      setHasOnlineTimedOutOnce(false);
    }
    var header = {
      showCategoriesHeader: showCategoriesHeader,
      showLoyaltyBanner: showLoyaltyBanner
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        timeoutEnabledOverride: paymentState == null ? void 0 : paymentState.matches('failure'),
        timeoutActionOverride: function timeoutActionOverride() {
          return history.push('/reset');
        },
        header: header
      });
    });
  }, [setTemplate, paymentState, showCategoriesHeader, isOnline, isOnlineTimedOut, hasOnlineTimedOutOnce, setHasOnlineTimedOutOnce, history, showLoyaltyBanner]);
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var retry = React.useCallback(function () {
    setRetryCount(function (count) {
      return count + 1;
    });
    if (amount === 0) return;
    if (!paymentMachine) return;
    resetPaymentResponse();
    config.retry = true;
    paymentMachine.send('RETRY', {
      amount: amount,
      config: config
    });
  }, [amount, config, paymentMachine, resetPaymentResponse]);
  var cancel = React.useCallback(function () {
    resetPaymentResponse();
    history.push(previousPath);
  }, [history, previousPath, resetPaymentResponse]);
  React.useEffect(function () {
    if (retryCount >= RETRY_ATTEMPTS && paymentState != null && paymentState.matches('failure')) {
      resetPaymentResponse();
      history.push(previousPath);
    }
  }, [retryCount, paymentState, resetPaymentResponse, history, previousPath]);
  React.useEffect(function () {
    if (hasCalledPayRef.current) return;
    if (paymentState) return;
    if (amount === 0) return;
    if (!isOnline) return;
    hasCalledPayRef.current = true;
    var instance = pay({
      amount: amount,
      config: config,
      transition: function transition(machine) {
        return setPaymentState(machine);
      }
    }); // should config be generated by transactions lib?

    setPaymentMachine(instance == null ? void 0 : instance.paymentMachine);
  }, [pay, history, paymentState, amount, config, isOnline]);
  React.useEffect(function () {
    if ((paymentResponse == null ? void 0 : paymentResponse.paymentType) === 'momopay') {
      setIsMomoPay(true);
    }
  }, [paymentResponse, setIsMomoPay]);
  React.useEffect(function () {
    if (amount === 0) return;
    if (!(paymentState != null && paymentState.matches('success')) && !(paymentState != null && paymentState.matches('statusSuccess'))) return;
    var context = paymentState.context;
    setPaymentResponse(context);
  }, [paymentState, setPaymentResponse, amount]);
  React.useEffect(function () {
    if (amount === 0) return;
    if (paymentState != null && paymentState.matches('failure')) {
      var context = paymentState.context;
      var message = context.message,
        _context$showReceipt = context.showReceipt,
        showReceipt = _context$showReceipt === void 0 ? false : _context$showReceipt;
      if (retryCount < RETRY_ATTEMPTS) {
        setPaymentResponse(context);
      }
      if (hasFailedPaymentReceipt && showReceipt) {
        var urlToQRCode = failedPaymentReceiptUrl + "?receiptId=" + receiptId;
        var _shortenUrl = url_shortener.shortenUrl(urlToQRCode),
          request = _shortenUrl[0],
          controller = _shortenUrl[1];
        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var url;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return request();
              case 3:
                url = _context.sent;
                setShortUrl(url);
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                logger.error('cringer.components - useReceiptQRCode - error:', _context.t0);
              case 10:
                controller.abort();
              case 11:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 7]]);
        }))();
        saveSession();
      }
      return addTransaction({
        status: 'ORDER_PAYMENT_ERROR',
        message: message
      });
    }
    if (!(paymentState != null && paymentState.matches('success')) && !(paymentState != null && paymentState.matches('statusSuccess'))) return;
    var strippedPaymentResponse = _objectWithoutPropertiesLoose(paymentResponse, _excluded$3); // remove `paymentType` from check
    // as it is used to store the payment type selected from payment-methods

    if (lodash.isEmpty(strippedPaymentResponse)) return; // waits for paymentResponse atom to be set before continuing

    addTransaction({
      status: 'ORDER_PAYMENT_SUCCESS'
    });
    if (paymentState != null && paymentState.matches('statusSuccess')) {
      setTimeout(function () {
        return history.push(nextPath);
      }, 3000);
    } else {
      history.push(nextPath);
    }
  }, [addTransaction, history, nextPath, paymentResponse, setPaymentResponse, paymentState, amount, failedPaymentReceiptUrl, hasFailedPaymentReceipt, receiptId, saveSession, isOnline, retryCount]);
  return {
    paymentState: paymentState,
    retry: retry,
    cancel: cancel,
    amount: amount,
    t: t,
    formatPrice: formatPrice,
    hasFailedPaymentReceipt: hasFailedPaymentReceipt,
    shortUrl: shortUrl,
    isOnline: isOnline,
    isOnlineTimedOut: isOnlineTimedOut,
    hasOnlineTimedOutOnce: hasOnlineTimedOutOnce,
    onReset: onReset,
    paymentResponse: paymentResponse,
    isMomoPay: isMomoPay
  };
};

var FailedPaymentQRCode = function FailedPaymentQRCode(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '200x200' : _ref$size,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? '' : _ref$message;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    datatest: "failed-payment-qrcode",
    className: "flex flex-col items-center justify-center m-16",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "mb-8 text-4xl font-bold",
      children: message
    }), /*#__PURE__*/jsxRuntime.jsx(QRCode, {
      size: size,
      url: url
    })]
  });
};

var _style, _path$1, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path4;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function SvgPinPad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    id: "pin_pad_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 53.3 104.8",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pin_pad_svg__st1{fill:none;stroke:#000;stroke-width:2;stroke-miterlimit:10}")), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 103H6.3c-2.2 0-4-1.8-4-4V41.2c0-2.2 1.8-4 4-4h41.3c2.2 0 4 1.8 4 4V99c0 2.2-1.8 4-4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.7 42.1h39v56h-39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pin_pad_svg__st1",
    d: "M40.8 61.7H13.5c-.7 0-1.3-.6-1.3-1.3v-11c0-.7.6-1.3 1.3-1.3h27.3c.7 0 1.3.6 1.3 1.3v11c0 .7-.6 1.3-1.3 1.3zM41.4 77.7v12.4c0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7V77.7c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 16,
    cy: 68.7,
    r: 2.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 27.2,
    cy: 68.7,
    r: 2.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 16,
    cy: 79.4,
    r: 2.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 27.2,
    cy: 79.4,
    r: 2.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 16,
    cy: 90.2,
    r: 2.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 27.2,
    cy: 90.2,
    r: 2.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "pin_pad_svg__st1",
    cx: 38.8,
    cy: 68.7,
    r: 2.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 13c-1.1-1-1-2.8.2-3.7 5.1-4 11.7-6.4 18.9-6.4 7.2 0 13.8 2.4 18.9 6.3 1.2.9 1.3 2.7.2 3.7-.9.8-2.2.9-3.2.1C38.6 9.7 33 7.6 27 7.6s-11.6 2-15.9 5.4c-1 .8-2.4.8-3.2 0zm6.4 6c.8.8 2.2.9 3.1.2 2.6-1.9 5.9-3 9.5-3s6.9 1.1 9.5 3c.9.7 2.2.6 3.1-.2 1.2-1.1 1-3-.3-3.9-3.5-2.4-7.7-3.8-12.4-3.8s-8.9 1.4-12.4 3.8c-1.1 1-1.2 2.8-.1 3.9zm3 8.4c.7.7 1.7.9 2.4.2 2.1-1.8 4.7-2.9 7.5-2.9s5.4 1.1 7.5 2.9c.7.6 1.8.5 2.4-.2.9-1 .8-2.8-.2-3.6-2.7-2.3-6.1-3.6-9.7-3.6s-7 1.3-9.7 3.6c-1 .8-1.1 2.6-.2 3.6zm3 6.7c.5.6 1.2.7 1.8.2 1.5-1.5 3.4-2.4 5.5-2.4s3.9.9 5.5 2.4c.5.5 1.3.4 1.8-.2.7-.9.6-2.3-.1-3.1-2-1.9-4.4-3-7.1-3s-5.1 1.1-7.1 3c-.9.8-.9 2.3-.3 3.1z"
  })));
}

var CardPaymentView = function CardPaymentView() {
  var _paymentState$context;
  var _useCardPaymentView = useCardPaymentView(),
    paymentState = _useCardPaymentView.paymentState,
    retry = _useCardPaymentView.retry,
    cancel = _useCardPaymentView.cancel,
    amount = _useCardPaymentView.amount,
    t = _useCardPaymentView.t,
    formatPrice = _useCardPaymentView.formatPrice,
    hasFailedPaymentReceipt = _useCardPaymentView.hasFailedPaymentReceipt,
    shortUrl = _useCardPaymentView.shortUrl,
    _useCardPaymentView$s = _useCardPaymentView.size,
    size = _useCardPaymentView$s === void 0 ? '300x300' : _useCardPaymentView$s,
    isOnline = _useCardPaymentView.isOnline,
    isOnlineTimedOut = _useCardPaymentView.isOnlineTimedOut,
    hasOnlineTimedOutOnce = _useCardPaymentView.hasOnlineTimedOutOnce,
    onReset = _useCardPaymentView.onReset;
  var OfflineView = React.useMemo(function () {
    return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [!isOnline && !isOnlineTimedOut && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center flex-grow h-full overflow-scroll text-center",
        children: /*#__PURE__*/jsxRuntime.jsx(Loading, {
          title: t('paymentNoInternetLoadingTitle'),
          message: t('paymentNoInternetLoadingMessage')
        })
      }), hasOnlineTimedOutOnce && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center flex-grow h-full",
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-col items-center justify-center h-full p-8",
          children: [/*#__PURE__*/jsxRuntime.jsx("p", {
            className: "mb-32 text-5xl font-bold text-center uppercase",
            children: t('paymentNoInternetTitle')
          }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
            className: "mt-8",
            onClick: onReset,
            children: t('paymentNoInternetClose')
          })]
        })
      })]
    });
  }, [isOnline, isOnlineTimedOut, hasOnlineTimedOutOnce, onReset, t]);
  if (paymentState != null && paymentState.matches('failure')) return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "payment-page-error",
    className: "flex flex-col items-center justify-center flex-grow h-full payment-page-error",
    children: [/*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "danger",
      message: t('paymentErrorMessage'),
      detail: t('paymentErrorDetail', {
        message: paymentState == null ? void 0 : (_paymentState$context = paymentState.context) == null ? void 0 : _paymentState$context.message
      }),
      onRetryText: t('paymentRetryMessage'),
      onRetryAction: retry,
      onCancelAction: cancel,
      onCancelText: t('paymentCancelMessage')
    }), hasFailedPaymentReceipt && shortUrl && /*#__PURE__*/jsxRuntime.jsx(FailedPaymentQRCode, {
      size: size,
      url: shortUrl,
      message: t('paymentErrorQRCodeMessage')
    })]
  });
  if (paymentState != null && paymentState.matches('loading')) {
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "payment-page-loading",
      className: "flex items-center justify-center flex-grow h-full",
      children: [isOnline && /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-center justify-center h-full p-8",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "mb-16 text-3xl font-bold text-center uppercase md:text-5xl",
          children: formatPrice({
            price: amount
          })
        }), /*#__PURE__*/jsxRuntime.jsx(SvgPinPad, {
          className: "block mb-32 h-1/2"
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "mb-32 text-3xl font-bold text-center uppercase md:text-5xl",
          children: t('paymentInstructions')
        }), /*#__PURE__*/jsxRuntime.jsx(ChevronDown, {
          className: "w-32 h-32 animate-bounce text-primary"
        })]
      }), OfflineView]
    });
  }
  if (paymentState != null && paymentState.matches('cancelStatusCheck') || paymentState != null && paymentState.matches('statusCheck') || paymentState != null && paymentState.matches('inquiring') || paymentState != null && paymentState.matches('cancel')) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-status-check",
      className: "flex items-center justify-center flex-grow h-full p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        message: t('paymentStatusCheckMessage')
      })
    });
  }
  if (paymentState != null && paymentState.matches('statusSuccess')) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-status-check",
      className: "flex items-center justify-center flex-grow h-full p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        message: t('paymentStatusSuccessMessage')
      })
    });
  }
  if (paymentState != null && paymentState.matches('success')) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-page-success",
      className: "flex items-center justify-center flex-grow h-full",
      children: OfflineView
    });
  }
  return null;
};

var QRPaymentCode = function QRPaymentCode(_ref) {
  var url = _ref.url;
  return url ? /*#__PURE__*/jsxRuntime.jsx(ReactQRCode, {
    size: 400,
    value: url
  }) : /*#__PURE__*/jsxRuntime.jsx(GridLoader, {
    size: 120
  });
};

var QRCardPaymentView = function QRCardPaymentView() {
  var _useCardPaymentView = useCardPaymentView(),
    paymentState = _useCardPaymentView.paymentState,
    retry = _useCardPaymentView.retry,
    cancel = _useCardPaymentView.cancel,
    amount = _useCardPaymentView.amount,
    t = _useCardPaymentView.t,
    formatPrice = _useCardPaymentView.formatPrice,
    hasFailedPaymentReceipt = _useCardPaymentView.hasFailedPaymentReceipt,
    shortUrl = _useCardPaymentView.shortUrl,
    _useCardPaymentView$s = _useCardPaymentView.size,
    size = _useCardPaymentView$s === void 0 ? '300x300' : _useCardPaymentView$s,
    isOnline = _useCardPaymentView.isOnline,
    isOnlineTimedOut = _useCardPaymentView.isOnlineTimedOut,
    hasOnlineTimedOutOnce = _useCardPaymentView.hasOnlineTimedOutOnce,
    onReset = _useCardPaymentView.onReset,
    isMomoPay = _useCardPaymentView.isMomoPay;
  if (paymentState != null && paymentState.matches('failure')) {
    var _paymentState$context, _paymentState$context2, _paymentState$context3, _paymentState$context4, _paymentState$event;
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "payment-page-error",
      className: "flex flex-col items-center justify-center flex-grow h-full payment-page-error",
      children: [/*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        message: t('paymentErrorMessage'),
        detail: t(isMomoPay ? 'paymentErrorQRCodeDetail' : 'paymentErrorDetail', {
          message: paymentState != null && (_paymentState$context = paymentState.context) != null && (_paymentState$context2 = _paymentState$context.info) != null && _paymentState$context2.message ? paymentState == null ? void 0 : (_paymentState$context3 = paymentState.context) == null ? void 0 : (_paymentState$context4 = _paymentState$context3.info) == null ? void 0 : _paymentState$context4.message : paymentState == null ? void 0 : (_paymentState$event = paymentState.event) == null ? void 0 : _paymentState$event.messsage
        }),
        onRetryText: t('paymentRetryMessage'),
        onRetryAction: retry,
        onCancelAction: cancel,
        onCancelText: t('paymentCancelMessage')
      }), hasFailedPaymentReceipt && shortUrl && /*#__PURE__*/jsxRuntime.jsx(FailedPaymentQRCode, {
        size: size,
        url: shortUrl,
        message: t('paymentErrorQRCodeMessage')
      })]
    });
  }
  if (paymentState != null && paymentState.matches('loading') && isOnline) {
    return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "payment-page-loading",
        className: "flex items-center justify-center flex-grow h-full",
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-col items-center justify-center h-full p-8",
          children: [isMomoPay && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [/*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
              src: img$1,
              alt: "Momo Pay",
              className: "block w-36 h-36 sm:w-42 sm:h-48 sm:py-6",
              "data-test": "momo-pay-logo"
            }), /*#__PURE__*/jsxRuntime.jsx("p", {
              className: "mt-16 mb-8 text-3xl font-bold text-center uppercase md:text-5xl",
              children: t('paymentFetchingQRCode')
            }), /*#__PURE__*/jsxRuntime.jsx("div", {
              className: "block mb-4",
              children: /*#__PURE__*/jsxRuntime.jsx(QRPaymentCode, {})
            })]
          }), /*#__PURE__*/jsxRuntime.jsx("p", {
            className: "mb-16 text-3xl font-bold text-center uppercase md:text-5xl",
            children: formatPrice({
              price: amount
            })
          }), !isMomoPay && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [/*#__PURE__*/jsxRuntime.jsx(SvgPinPad, {
              className: "block mb-4 h-1/2"
            }), /*#__PURE__*/jsxRuntime.jsx("p", {
              className: "mb-32 text-3xl font-bold text-center uppercase md:text-5xl",
              children: t('paymentInstructions')
            }), /*#__PURE__*/jsxRuntime.jsx(ChevronDown, {
              className: "w-32 h-32 animate-bounce text-primary"
            })]
          }), isMomoPay && /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
            onClick: cancel,
            className: "home-primary-button payment-option-page-button",
            children: t('paymentOptionsSecondaryAction')
          })]
        })
      })
    });
  }
  if (paymentState != null && paymentState.matches('statusCheck')) {
    var _paymentState$event2;
    return isMomoPay ? /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-page-loading",
      className: "flex items-center justify-center flex-grow h-full",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-center justify-center h-full p-8",
        children: [/*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
          src: img$1,
          alt: "Momo Pay",
          className: "block w-36 h-36 sm:w-42 sm:h-48 sm:py-6",
          "data-test": "momo-pay-logo"
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "mt-16 mb-8 text-3xl font-bold text-center uppercase md:text-5xl",
          children: t('paymentScanQRCode')
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "block mb-4",
          children: /*#__PURE__*/jsxRuntime.jsx(QRPaymentCode, {
            url: paymentState == null ? void 0 : (_paymentState$event2 = paymentState.event) == null ? void 0 : _paymentState$event2.url
          })
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "mt-8 mb-16 text-4xl font-bold text-center uppercase md:text-6xl",
          children: formatPrice({
            price: amount
          })
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "mt-32 mb-8 text-3xl font-bold text-center uppercase md:text-5xl",
          children: t('paymentScanQRCodeMessage')
        })]
      })
    }) : /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-status-check",
      className: "flex items-center justify-center flex-grow h-full p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        message: t('paymentStatusCheckMessage')
      })
    });
  }
  if (paymentState != null && paymentState.matches('statusSuccess')) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-status-check",
      className: "flex items-center justify-center flex-grow h-full p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        message: t('paymentStatusSuccessMessage')
      })
    });
  }
  if (paymentState != null && paymentState.matches('success')) {
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "payment-page-success",
      className: "flex items-center justify-center flex-grow h-full",
      children: [!isOnline && !isOnlineTimedOut && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center flex-grow h-full overflow-scroll text-center",
        children: /*#__PURE__*/jsxRuntime.jsx(Loading, {
          title: t('paymentNoInternetLoadingTitle'),
          message: t('paymentNoInternetLoadingMessage')
        })
      }), hasOnlineTimedOutOnce && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center flex-grow h-full",
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-col items-center justify-center h-full p-8",
          children: [/*#__PURE__*/jsxRuntime.jsx("p", {
            className: "mb-32 text-5xl font-bold text-center uppercase",
            children: t('paymentNoInternetTitle')
          }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
            className: "mt-8",
            onClick: onReset,
            children: t('paymentNoInternetClose')
          })]
        })
      })]
    });
  }
  return null;
};

var RefundViewContext = /*#__PURE__*/React.createContext();
var RefundViewProvider = function RefundViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/reset' : _ref$nextPath,
    _ref$qrCodeSize = _ref.qrCodeSize,
    qrCodeSize = _ref$qrCodeSize === void 0 ? '200x200' : _ref$qrCodeSize,
    _ref$showServerTotal = _ref.showServerTotal,
    showServerTotal = _ref$showServerTotal === void 0 ? false : _ref$showServerTotal;
  var _useSystem = useSystem(),
    port = _useSystem.port;
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var paymentData = recoil.useRecoilValue(atoms.paymentState);
  var orderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState) || {};
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var serverTotal = recoil.useRecoilValue(atoms.orderServerTotalState);
  var _useState = React.useState(null),
    refundState = _useState[0],
    setRefundState = _useState[1];
  var _useState2 = React.useState(null),
    refundMachine = _useState2[0],
    setRefundMachine = _useState2[1];
  var _useState3 = React.useState(null),
    refundResponse = _useState3[0],
    setRefundResponse = _useState3[1];
  var provider = React.useMemo(function () {
    var _paymentData$info;
    var paymentType = (paymentData == null ? void 0 : paymentData.paymentType) || (paymentData == null ? void 0 : (_paymentData$info = paymentData.info) == null ? void 0 : _paymentData$info.paymentType) || 'card'; // default card as `cash` will always be set
    var isUsingProviders = (paymentType == null ? void 0 : paymentType.toLowerCase()) === 'card';
    if (isUsingProviders) {
      var _settings$settings, _settings$settings$pa, _settings$settings2, _settings$settings2$p;
      //this provider option was created differently from the object with its settings
      //it needs to be parsed here to keep compatibility with V1 for now
      //TODO: change KAS to have the correct option in the providers dropdown (ksaMada) when we ditch V1
      if ((settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$pa = _settings$settings.payment) == null ? void 0 : _settings$settings$pa.provider) === 'ksa-mada') {
        return 'ksaMada';
      }
      return settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$p = _settings$settings2.payment) == null ? void 0 : _settings$settings2$p.provider;
    }
    return paymentType;
  }, [settings, paymentData]);
  var _orderPayload$session = orderPayload.session,
    session = _orderPayload$session === void 0 ? {} : _orderPayload$session,
    _orderPayload$cart = orderPayload.cart,
    cart = _orderPayload$cart === void 0 ? {} : _orderPayload$cart,
    _orderPayload$receipt = orderPayload.receiptId,
    receiptId = _orderPayload$receipt === void 0 ? null : _orderPayload$receipt;
  var sessionId = session.id,
    _session$kitchenId = session.kitchenId,
    orderId = _session$kitchenId === void 0 ? null : _session$kitchenId;
  var timezone = settings.timezone;
  var _settings$settings3 = settings == null ? void 0 : settings.settings,
    payment = _settings$settings3.payment,
    site = _settings$settings3.site,
    mocks = _settings$settings3.mocks,
    interval = _settings$settings3.interval;
  var storeId = site.storeId;
  var pinpadIntervals = interval.pinpad,
    _interval$refundCount = interval.refundCountdown,
    refundCountdown = _interval$refundCount === void 0 ? {} : _interval$refundCount;
  var _refundCountdown$refu = refundCountdown.refundCountdownEnabled,
    refundCountdownEnabled = _refundCountdown$refu === void 0 ? false : _refundCountdown$refu,
    _refundCountdown$coun = refundCountdown.countdown,
    countdown = _refundCountdown$coun === void 0 ? 5 : _refundCountdown$coun;
  var _pinpadIntervals$paym = pinpadIntervals.payment,
    timeout = _pinpadIntervals$paym === void 0 ? 30 : _pinpadIntervals$paym;
  var providerSettings = payment == null ? void 0 : payment[provider];
  var _mocks$payment = mocks.payment,
    isRefundMocked = _mocks$payment === void 0 ? false : _mocks$payment;
  var paymentSettings = _extends({
    storeId: storeId,
    timeout: timeout
  }, providerSettings);
  var orderSettings = {
    orderId: orderId
  };
  var config = {
    order: orderSettings,
    settings: paymentSettings,
    port: port,
    sessionId: sessionId
  };
  var transactionId = paymentData.transactionId,
    timestamp = paymentData.timestamp,
    info = paymentData.info;
  var _useMemo = React.useMemo(function () {
      // Match naming conventions from previous system
      return transactions.buildPaymentHandlers({
        provider: provider,
        mock: isRefundMocked
      });
    }, [provider, isRefundMocked]),
    refund = _useMemo.refund;
  var _useTransactions = useTransactions(),
    addTransaction = _useTransactions.addTransaction;
  var available = {
    nextPath: nextPath,
    config: config,
    refund: refund,
    transactionId: transactionId,
    timestamp: timestamp,
    info: info,
    setTemplate: setTemplate,
    refundState: refundState,
    setRefundState: setRefundState,
    refundMachine: refundMachine,
    setRefundMachine: setRefundMachine,
    refundResponse: refundResponse,
    setRefundResponse: setRefundResponse,
    receiptId: receiptId,
    cart: cart,
    session: session,
    timezone: timezone,
    addTransaction: addTransaction,
    refundCountdownEnabled: refundCountdownEnabled,
    countdown: countdown,
    qrCodeSize: qrCodeSize,
    showServerTotal: showServerTotal,
    serverTotal: serverTotal
  };
  return /*#__PURE__*/jsxRuntime.jsx(RefundViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRefundViewContext = function useRefundViewContext() {
  var context = React.useContext(RefundViewContext);
  if (context === undefined) {
    throw new Error('useRefundViewContext must be used within a RefundViewProvider');
  }
  return context;
};

var RETRY_ATTEMPTS$1 = 3;
var useRefundView = function useRefundView() {
  var _useRefundViewContext = useRefundViewContext(),
    refund = _useRefundViewContext.refund,
    nextPath = _useRefundViewContext.nextPath,
    transactionId = _useRefundViewContext.transactionId,
    info = _useRefundViewContext.info,
    config = _useRefundViewContext.config,
    refundState = _useRefundViewContext.refundState,
    setRefundState = _useRefundViewContext.setRefundState,
    refundMachine = _useRefundViewContext.refundMachine,
    setRefundMachine = _useRefundViewContext.setRefundMachine,
    refundResponse = _useRefundViewContext.refundResponse,
    setTemplate = _useRefundViewContext.setTemplate,
    setRefundResponse = _useRefundViewContext.setRefundResponse,
    receiptId = _useRefundViewContext.receiptId,
    cart = _useRefundViewContext.cart,
    timezone = _useRefundViewContext.timezone,
    addTransaction = _useRefundViewContext.addTransaction,
    refundCountdownEnabled = _useRefundViewContext.refundCountdownEnabled,
    countdown = _useRefundViewContext.countdown,
    qrCodeSize = _useRefundViewContext.qrCodeSize,
    showServerTotal = _useRefundViewContext.showServerTotal,
    serverTotal = _useRefundViewContext.serverTotal;
  var _useTiming = useTiming({
      idleTime: 0,
      warningTime: countdown
    }),
    timeLeft = _useTiming.timeLeft,
    startTimer = _useTiming.startTimer,
    timerExpired = _useTiming.timerExpired;
  var history = reactRouterDom.useHistory();
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _ref = cart || {},
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  var amount = info.amount,
    _info$cardNumber = info.cardNumber,
    cardNumber = _info$cardNumber === void 0 ? '' : _info$cardNumber,
    paymentType = info.paymentType;
  var _useState = React.useState(0),
    retryCount = _useState[0],
    setRetryCount = _useState[1];
  var retry = React.useCallback(function () {
    if (retryCount < RETRY_ATTEMPTS$1) {
      setRetryCount(function (count) {
        return count + 1;
      });
      refundMachine.send('RETRY', _extends({}, info, {
        amount: amount,
        transactionId: transactionId,
        timestamp: utilities.timestamp(),
        config: _extends({}, config, {
          amount: amount
        })
      }));
    }
  }, [refundMachine, info, amount, transactionId, config, retryCount]);
  var cancel = React.useCallback(function () {
    return refundMachine.send('CANCEL');
  }, [refundMachine]);
  var finish = function finish() {
    return history.push(nextPath);
  };
  var dateTime = utilities.getFormattedDateTime({
    currentTimestamp: utilities.timestamp(),
    timezone: timezone
  });
  var shouldShowCountdown = React.useMemo(function () {
    return refundCountdownEnabled && !timerExpired;
  }, [refundCountdownEnabled, timerExpired]);
  React.useEffect(function () {
    if (refundState != null && refundState.matches('cancelled')) {
      startTimer();
    }
  }, [startTimer, refundState]);
  React.useEffect(function () {
    if (refundState) return;
    var _refund = refund(_extends({}, info, {
        amount: amount,
        transactionId: transactionId,
        timestamp: utilities.timestamp(),
        config: _extends({}, config, {
          amount: amount
        }),
        transition: function transition(machine) {
          return setRefundState(machine);
        }
      })),
      refundMachine = _refund.refundMachine; // should config be generated by transactions lib?

    setRefundMachine(refundMachine);
  }, [refund, refundState, amount, info, transactionId, config, setRefundResponse, setRefundState, setRefundMachine]);
  React.useEffect(function () {
    if (retryCount >= RETRY_ATTEMPTS$1 && refundState != null && refundState.matches('failure')) {
      cancel();
    }
  }, [retryCount, refundState, cancel]);
  React.useEffect(function () {
    if (refundState != null && refundState.matches('failure')) {
      var _refundState$context = refundState.context,
        context = _refundState$context === void 0 ? {} : _refundState$context;
      var _context$message = context.message,
        message = _context$message === void 0 ? '' : _context$message;
      return addTransaction({
        status: 'ORDER_REFUND_ERROR',
        message: message,
        receiptId: receiptId
      });
    } else if (refundState != null && refundState.matches('cancelled')) {
      var _refundState$context2 = refundState.context,
        _context = _refundState$context2 === void 0 ? {} : _refundState$context2;
      var _context$message2 = _context.message,
        _message = _context$message2 === void 0 ? '' : _context$message2;
      return addTransaction({
        status: 'ORDER_REFUND_CANCELLED',
        message: _message,
        receiptId: receiptId
      });
    }
    if (!(refundState != null && refundState.matches('success'))) return;
    var response = refundState.context.response;
    setRefundResponse(response);
    addTransaction({
      status: 'ORDER_REFUND_SUCCESS',
      receiptId: receiptId
    });
  }, [refundState, history, nextPath, setRefundState, refundResponse, setRefundResponse, addTransaction, receiptId]);
  React.useEffect(function () {
    setTemplate(function (template) {
      return _extends({}, template, {
        timeoutEnabledOverride: ['success', 'cancelled', 'failure'].includes(refundState == null ? void 0 : refundState.value),
        timeoutActionOverride: function timeoutActionOverride() {
          return history.push('/reset');
        }
      });
    });
  }, [setTemplate, refundState, history]);
  return {
    refundState: refundState,
    retry: retry,
    cancel: cancel,
    finish: finish,
    items: items,
    t: t,
    cardNumber: cardNumber,
    dateTime: dateTime,
    receiptId: receiptId,
    timeLeft: timeLeft,
    shouldShowCountdown: shouldShowCountdown,
    qrCodeSize: qrCodeSize,
    paymentType: paymentType,
    showServerTotal: showServerTotal,
    serverTotal: serverTotal
  };
};

var _path$2;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function SvgArrowPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    className: "arrow-path_svg__w-6 arrow-path_svg__h-6"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
  })));
}

var _path$3, _path2$1;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function SvgRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.769 193.769"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.203 41.104l-9.348 12.009c20.15 15.679 30.201 41.063 26.234 66.253-2.906 18.484-12.838 34.73-27.964 45.748-15.131 11.012-33.64 15.488-52.124 12.567-38.157-6.008-64.32-41.938-58.322-80.098C30.585 79.097 40.52 62.85 55.648 51.835c13.208-9.615 28.991-14.233 45.086-13.317L87.579 52.319l9.759 9.313 20.766-21.801.005.008 9.303-9.769-9.752-9.303-.005.003L95.862 0l-9.31 9.769 14.2 13.525c-19.303-.913-38.21 4.702-54.059 16.242C28.28 52.943 16.19 72.717 12.65 95.221c-7.302 46.445 24.54 90.184 70.985 97.493a86.181 86.181 0 0013.434 1.055c17.89 0 35.273-5.623 50.011-16.356 18.415-13.409 30.503-33.183 34.043-55.682 4.829-30.654-7.403-61.55-31.92-80.627z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M105.24 151.971v-.003h.001v-8.757c10.383-1.159 20.485-7.718 20.485-20.17 0-16.919-15.732-18.859-27.223-20.274-7.347-.878-12.97-1.897-12.97-6.348 0-6.188 8.722-6.855 12.473-6.855 5.567 0 11.507 2.617 13.525 5.957l.586.971 11.542-5.341-.571-1.164c-4.301-8.793-12.009-11.337-17.85-12.364v-7.71H91.723v7.677c-12.582 1.856-20.054 8.839-20.054 18.829 0 16.29 14.791 17.943 25.582 19.153 9.617 1.134 14.094 3.51 14.094 7.469 0 7.563-10.474 8.154-13.685 8.154-7.147 0-14.038-3.566-16.031-8.301l-.495-1.169-12.539 5.316.5 1.169c3.713 8.691 11.725 14.137 22.63 15.425v8.336h13.515z"
  })));
}

var Item = function Item(_ref) {
  var _item$product;
  var className = _ref.className,
    item = _ref.item;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  if (item != null && item.defaultQuantity && (item == null ? void 0 : item.quantity) === (item == null ? void 0 : item.defaultQuantity)) return null;
  var textNo = (item == null ? void 0 : item.quantity) === 0 ? 'No ' : '';
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-row even:bg-gray-100 text-2xl px-4 py-2 " + className,
    children: [/*#__PURE__*/jsxRuntime.jsxs("p", {
      children: [textNo, item == null ? void 0 : (_item$product = item.product) == null ? void 0 : _item$product.name, " ", (item == null ? void 0 : item.quantity) > 1 ? "x " + (item == null ? void 0 : item.quantity) : null]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex-grow"
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      children: item != null && item.price ? formatPrice({
        price: item == null ? void 0 : item.price
      }) : null
    })]
  });
};
var Product = function Product(_ref2) {
  var _item$product2, _item$product3;
  var className = _ref2.className,
    item = _ref2.item;
  return /*#__PURE__*/jsxRuntime.jsxs(React__default.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(Item, {
      className: className,
      item: item
    }), (item == null ? void 0 : (_item$product2 = item.product) == null ? void 0 : _item$product2.customisations) && (item == null ? void 0 : (_item$product3 = item.product) == null ? void 0 : _item$product3.customisations.map(function (customisationItem) {
      return /*#__PURE__*/jsxRuntime.jsx(Item, {
        className: "pl-20",
        item: _extends({}, customisationItem, {
          product: customisationItem
        })
      });
    }))]
  });
};
var ProductSummary = function ProductSummary(_ref3) {
  var _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? 'w-full sm:w-4/5' : _ref3$className,
    items = _ref3.items,
    serverTotal = _ref3.serverTotal,
    _ref3$showServerTotal = _ref3.showServerTotal,
    showServerTotal = _ref3$showServerTotal === void 0 ? false : _ref3$showServerTotal;
  var _usePrice2 = usePrice(),
    formatPrice = _usePrice2.formatPrice;
  var total = showServerTotal ? serverTotal : items.reduce(function (acc, current) {
    return acc + current.price;
  }, 0);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "product-summary-description",
    className: "flex flex-col md:overflow-y-auto mt-4 " + className,
    children: [items.map(function (item) {
      var _item$product4;
      return /*#__PURE__*/jsxRuntime.jsxs(React__default.Fragment, {
        children: [/*#__PURE__*/jsxRuntime.jsx(Product, {
          item: item
        }, "product-" + item.uid), (item == null ? void 0 : (_item$product4 = item.product) == null ? void 0 : _item$product4.comboProducts) && item.product.comboProducts.map(function (comboItem) {
          return /*#__PURE__*/jsxRuntime.jsx(Product, {
            className: "px-4 py-2 sm:pl-12",
            item: _extends({}, comboItem, {
              product: comboItem
            })
          });
        })]
      }, "product-" + item.uid);
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-summary-price",
      className: "flex flex-row even:bg-gray-100 text-2xl font-bold px-4 py-2 w-full",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        children: "Total:"
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex-grow"
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        children: formatPrice({
          price: total
        })
      })]
    })]
  });
};

var RefundView = function RefundView() {
  var _refundState$context;
  var _useRefundView = useRefundView(),
    refundState = _useRefundView.refundState,
    retry = _useRefundView.retry,
    cancel = _useRefundView.cancel,
    finish = _useRefundView.finish,
    items = _useRefundView.items,
    t = _useRefundView.t,
    dateTime = _useRefundView.dateTime,
    timeLeft = _useRefundView.timeLeft,
    shouldShowCountdown = _useRefundView.shouldShowCountdown,
    qrCodeSize = _useRefundView.qrCodeSize,
    paymentType = _useRefundView.paymentType,
    showServerTotal = _useRefundView.showServerTotal,
    serverTotal = _useRefundView.serverTotal;
  var isMomoPay = paymentType === 'MOMOPAY';
  if (refundState != null && refundState.matches('failure')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "refund-page-error",
    className: "flex items-center justify-center flex-grow h-full refund-page-error",
    children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "danger",
      message: t('refundErrorMessage'),
      detail: refundState == null ? void 0 : (_refundState$context = refundState.context) == null ? void 0 : _refundState$context.message,
      onRetryText: t('refundRetryMessage'),
      onRetryAction: retry,
      onCancelAction: cancel,
      onCancelText: t('refundCancelMessage')
    })
  });
  if (refundState != null && refundState.matches('loading')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "refund-page-loading",
    className: "flex items-center justify-center flex-grow h-full",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center h-full p-2 md:p-8",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mt-8 text-3xl font-bold text-center uppercase md:my-16 md:text-5xl",
        children: t('refundLoadingTitle')
      }), isMomoPay ? /*#__PURE__*/jsxRuntime.jsx(SvgRefund, {
        className: "block mb-32 h-1/2"
      }) : /*#__PURE__*/jsxRuntime.jsx(SvgPinPad, {
        className: "block mb-32 h-1/2"
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mb-32 text-3xl font-bold text-center uppercase md:text-5xl",
        children: t(isMomoPay ? 'refundGenericInstructions' : 'refundInstructions')
      }), isMomoPay ? /*#__PURE__*/jsxRuntime.jsx(SvgArrowPath, {
        className: "w-32 h-32 animate-spin text-primary"
      }) : /*#__PURE__*/jsxRuntime.jsx(ChevronDown, {
        className: "w-32 h-32 animate-bounce text-primary"
      })]
    })
  });
  if (refundState != null && refundState.matches('success')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "refund-page-success",
    className: "flex items-center justify-center flex-grow h-full refund-success",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center h-full p-2 md:p-8",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        className: "my-8 text-3xl font-bold text-center uppercase md:my-16 md:text-5xl",
        children: t('refundSuccessTitle')
      }), isMomoPay ? /*#__PURE__*/jsxRuntime.jsx(SvgRefund, {
        className: "block mb-32 h-1/2"
      }) : /*#__PURE__*/jsxRuntime.jsx(SvgPinPad, {
        className: "block mb-32 h-1/2"
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mb-32 text-3xl font-bold text-center uppercase md:text-5xl",
        children: t('refundSuccessMessage')
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        onClick: finish,
        children: t('refundSuccessButton')
      })]
    })
  });
  if (refundState != null && refundState.matches('cancelled')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "refund-page-cancelled",
    className: "flex items-center justify-center flex-grow md:h-full refund-page-cancelled",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center h-full p-2 md:p-8",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mb-4 text-3xl font-bold text-center uppercase md:mb-32 md:text-5xl",
        children: t('refundCancelledMessage')
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col w-full sm:flex-row sm:items-center md:w-4/5",
        children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
          "data-test": "refund-details",
          className: "flex flex-col justify-start w-4/5 md:py-8 md:mb-8",
          children: [/*#__PURE__*/jsxRuntime.jsx("p", {
            className: "mb-4 text-3xl uppercase sm:text-4xl",
            children: t('refundCancelDetails')
          }), /*#__PURE__*/jsxRuntime.jsxs("p", {
            className: "mb-4 text-2xl sm:text-3xl",
            children: [t('refundCancelDateTime'), ": ", dateTime]
          })]
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex items-center justify-center",
          children: /*#__PURE__*/jsxRuntime.jsx(ReceiptQRCode, {
            size: qrCodeSize
          })
        })]
      }), /*#__PURE__*/jsxRuntime.jsx(ProductSummary, {
        items: items,
        serverTotal: serverTotal,
        showServerTotal: showServerTotal
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        className: "mt-4 md:mt-8 home-primary-button",
        onClick: finish,
        disabled: shouldShowCountdown,
        children: shouldShowCountdown ? timeLeft : t('refundCancelButton')
      })]
    })
  });
  return null;
};

var assignContext = /*#__PURE__*/xstate.assign(function (context, event) {
  return {
    onChange: event.onChange,
    maxLength: event.maxLength,
    inputName: event.inputName
  };
});
var phoneService = function phoneService(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'phoneMachine' : _ref$id,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 'country' : _ref$initial;
  var phoneMachine = xstate.Machine({
    id: id,
    initial: initial,
    states: {
      country: {
        on: {
          PHONE: {
            target: 'phone',
            actions: ['assignContext']
          }
        }
      },
      phone: {
        on: {
          COUNTRY: {
            target: 'country',
            actions: ['assignContext']
          }
        }
      }
    }
  }, {
    actions: {
      assignContext: assignContext
    }
  });
  return {
    phoneMachine: phoneMachine
  };
};

var SmsViewContext = /*#__PURE__*/React.createContext();
var SmsViewProvider = function SmsViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nextPagePath = _ref.nextPagePath,
    nextPagePath = _ref$nextPagePath === void 0 ? '/receipt' : _ref$nextPagePath,
    _ref$tryAgainPath = _ref.tryAgainPath,
    tryAgainPath = _ref$tryAgainPath === void 0 ? '/sms' : _ref$tryAgainPath,
    _ref$errorPath = _ref.errorPath,
    errorPath = _ref$errorPath === void 0 ? '/notify' : _ref$errorPath,
    _ref$isLogoEnabled = _ref.isLogoEnabled,
    isLogoEnabled = _ref$isLogoEnabled === void 0 ? false : _ref$isLogoEnabled,
    _ref$isSubtitleEnable = _ref.isSubtitleEnabled,
    isSubtitleEnabled = _ref$isSubtitleEnable === void 0 ? true : _ref$isSubtitleEnable,
    _ref$showDotAfterInit = _ref.showDotAfterInitials,
    showDotAfterInitials = _ref$showDotAfterInit === void 0 ? false : _ref$showDotAfterInit;
  var defaultCountryCode = process.env.POI_APP_COUNTRY_CODE_DEFAULT || '971';
  var confirmedOrderPayload = recoil.useRecoilValue(atoms.confirmedOrderPayloadState);
  var history = reactRouterDom.useHistory();
  var _phoneService = phoneService(),
    phoneMachine = _phoneService.phoneMachine;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var session = recoil.useRecoilValue(atoms.sessionState);
  var _useMachine = react.useMachine(phoneMachine),
    state = _useMachine[0],
    send = _useMachine[1];
  var _useState = React.useState(null),
    smsState = _useState[0],
    setSmsState = _useState[1];
  var _useRecoilState = recoil.useRecoilState(atoms.settingsState),
    settings = _useRecoilState[0];
  var _useState2 = React.useState(''),
    inputError = _useState2[0],
    setInputError = _useState2[1];
  var _useState3 = React.useState(''),
    phoneNumber = _useState3[0],
    setPhoneNumber = _useState3[1];
  var _useState4 = React.useState('phone'),
    currentFocused = _useState4[0],
    setCurrentFocused = _useState4[1];
  var _useState5 = React.useState(defaultCountryCode),
    countryCode = _useState5[0],
    setCountryCode = _useState5[1];
  var _useState6 = React.useState(null),
    keyboardRef = _useState6[0],
    setKeyboardRef = _useState6[1];
  var available = {
    send: send,
    state: state,
    settings: settings,
    currentFocused: currentFocused,
    setCurrentFocused: setCurrentFocused,
    phoneNumber: phoneNumber,
    setPhoneNumber: setPhoneNumber,
    countryCode: countryCode,
    setCountryCode: setCountryCode,
    inputError: inputError,
    setInputError: setInputError,
    nextPagePath: nextPagePath,
    smsState: smsState,
    setSmsState: setSmsState,
    t: t,
    history: history,
    isLogoEnabled: isLogoEnabled,
    isSubtitleEnabled: isSubtitleEnabled,
    sendSMS: sms.sendSMS,
    buildReceiptMessage: sms.buildReceiptMessage,
    confirmedOrderPayload: confirmedOrderPayload,
    tryAgainPath: tryAgainPath,
    errorPath: errorPath,
    keyboardRef: keyboardRef,
    setKeyboardRef: setKeyboardRef,
    session: session,
    showDotAfterInitials: showDotAfterInitials
  };
  return /*#__PURE__*/jsxRuntime.jsx(SmsViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useSmsViewContext = function useSmsViewContext() {
  var context = React.useContext(SmsViewContext);
  if (context === undefined) {
    throw new Error('useSmsViewContext must be used within a SmsViewProvider');
  }
  return context;
};

var validatePhoneNumber = function validatePhoneNumber(t) {
  return function (phoneNumber, countryCode, phoneNumberSettings, countryCodeSettings) {
    var _countryCodeSettings$, _countryCodeSettings, _countryCodeSettings$2, _countryCodeSettings2, _phoneNumberSettings$, _phoneNumberSettings, _phoneNumberSettings$2, _phoneNumberSettings2;
    if (phoneNumber === void 0) {
      phoneNumber = '';
    }
    if (countryCode === void 0) {
      countryCode = '';
    }
    if (phoneNumberSettings === void 0) {
      phoneNumberSettings = null;
    }
    if (countryCodeSettings === void 0) {
      countryCodeSettings = null;
    }
    var _ref = phoneNumber.split('') || [],
      firstPhoneNumber = _ref[0];
    var _ref2 = countryCode.split('') || [],
      firstCountryNumber = _ref2[0];
    if (countryCode.length === 0) return t('smsCountryCodeCannotBeEmpty');
    if (firstCountryNumber === '0') return t('smsCountryCodeStartWithZero');
    if (countryCode.length > ((_countryCodeSettings$ = (_countryCodeSettings = countryCodeSettings) == null ? void 0 : _countryCodeSettings.maxLength) != null ? _countryCodeSettings$ : 3)) return t('smsCountryCodeExceedsMaxLength');
    if (countryCode.length < ((_countryCodeSettings$2 = (_countryCodeSettings2 = countryCodeSettings) == null ? void 0 : _countryCodeSettings2.minLength) != null ? _countryCodeSettings$2 : 2)) return t('smsCountryCodeDoesNotMeetMinimumLength');
    if (phoneNumber.length === 0) return '';
    if (firstPhoneNumber === '0') return t('smsPhoneCannotStartWithZero');
    if (phoneNumber.length > ((_phoneNumberSettings$ = (_phoneNumberSettings = phoneNumberSettings) == null ? void 0 : _phoneNumberSettings.maxLength) != null ? _phoneNumberSettings$ : 12)) return t('smsPhoneExceedsMaxLength');
    if (phoneNumber.length < ((_phoneNumberSettings$2 = (_phoneNumberSettings2 = phoneNumberSettings) == null ? void 0 : _phoneNumberSettings2.minLength) != null ? _phoneNumberSettings$2 : 9)) return t('smsPhoneDoesNotMeetMinimumLength');
    return '';
  };
};

var useSmsView = function useSmsView() {
  var _useSmsViewContext = useSmsViewContext(),
    phoneMachineSend = _useSmsViewContext.send,
    phoneMachineState = _useSmsViewContext.state,
    currentFocused = _useSmsViewContext.currentFocused,
    setCurrentFocused = _useSmsViewContext.setCurrentFocused,
    phoneNumber = _useSmsViewContext.phoneNumber,
    countryCode = _useSmsViewContext.countryCode,
    inputError = _useSmsViewContext.inputError,
    setInputError = _useSmsViewContext.setInputError,
    nextPagePath = _useSmsViewContext.nextPagePath,
    settings = _useSmsViewContext.settings,
    smsState = _useSmsViewContext.smsState,
    setSmsState = _useSmsViewContext.setSmsState,
    setPhoneNumber = _useSmsViewContext.setPhoneNumber,
    setCountryCode = _useSmsViewContext.setCountryCode,
    t = _useSmsViewContext.t,
    history = _useSmsViewContext.history,
    isLogoEnabled = _useSmsViewContext.isLogoEnabled,
    isSubtitleEnabled = _useSmsViewContext.isSubtitleEnabled,
    sendSMS = _useSmsViewContext.sendSMS,
    buildReceiptMessage = _useSmsViewContext.buildReceiptMessage,
    confirmedOrderPayload = _useSmsViewContext.confirmedOrderPayload,
    tryAgainPath = _useSmsViewContext.tryAgainPath,
    errorPath = _useSmsViewContext.errorPath,
    keyboardRef = _useSmsViewContext.keyboardRef,
    setKeyboardRef = _useSmsViewContext.setKeyboardRef,
    session = _useSmsViewContext.session,
    showDotAfterInitials = _useSmsViewContext.showDotAfterInitials;
  var _useState = React.useState(0),
    retryCount = _useState[0],
    setRetryCount = _useState[1];
  var smsSettings = React.useMemo(function () {
    var _settings$settings, _settings$settings$re;
    return (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$re = _settings$settings.receipt) == null ? void 0 : _settings$settings$re.sms) || {};
  }, [settings]);
  var phoneFocusClass = React.useMemo(function () {
    if (currentFocused !== 'phone') return 'border-black';
    return 'border-primary';
  }, [currentFocused]);
  var countryFocusClass = React.useMemo(function () {
    if (currentFocused !== 'country') return 'border-black';
    return 'border-primary';
  }, [currentFocused]);
  var smsSubmitDisabled = React.useMemo(function () {
    if (phoneNumber.length === 0) return true;
    if (inputError.length !== 0) return true;
    return false;
  }, [inputError, phoneNumber]);
  var smsSuccessConfirm = function smsSuccessConfirm() {
    if (smsState != null && smsState.matches('success')) history.push('/receipt');
  };
  var countryCodeSettings = React.useMemo(function () {
    return {
      inputName: 'countryCode',
      maxLength: process.env.POI_APP_COUNTRY_CODE_MAX_LENGTH,
      minLength: process.env.POI_APP_COUNTRY_CODE_MIN_LENGTH,
      onChange: function onChange(newCountryCode) {
        if (newCountryCode.length <= process.env.POI_APP_COUNTRY_CODE_MAX_LENGTH) {
          setCountryCode(newCountryCode);
        }
      }
    };
  }, [setCountryCode]);
  var phoneNumberSettings = React.useMemo(function () {
    return {
      inputName: 'phoneNumber',
      maxLength: process.env.POI_APP_PHONE_NUMBER_MAX_LENGTH,
      minLength: process.env.POI_APP_PHONE_NUMBER_MIN_LENGTH,
      onChange: setPhoneNumber
    };
  }, [setPhoneNumber]);
  var _useMemo = React.useMemo(function () {
      return (phoneMachineState == null ? void 0 : phoneMachineState.context) || {};
    }, [phoneMachineState]),
    _useMemo$inputName = _useMemo.inputName,
    inputName = _useMemo$inputName === void 0 ? countryCodeSettings.inputName : _useMemo$inputName,
    _useMemo$maxLength = _useMemo.maxLength,
    maxLength = _useMemo$maxLength === void 0 ? countryCodeSettings.maxLength : _useMemo$maxLength,
    _useMemo$onChange = _useMemo.onChange,
    onChange = _useMemo$onChange === void 0 ? countryCodeSettings.onChange : _useMemo$onChange;
  var smsSkip = React.useCallback(function () {
    history.push(nextPagePath);
  }, [history, nextPagePath]);
  var onInit = function onInit(keyboard) {
    if (keyboard === void 0) {
      keyboard = {};
    }
    setKeyboardRef(keyboard);
  };
  var onFocusCountry = function onFocusCountry() {
    keyboardRef.clearInput('countryCode');
    setCountryCode('');
    setCurrentFocused('country');
    phoneMachineSend('COUNTRY', countryCodeSettings);
  };
  var onFocusPhone = React.useCallback(function () {
    setCurrentFocused('phone');
    phoneMachineSend('PHONE', phoneNumberSettings);
  }, [phoneMachineSend, setCurrentFocused, phoneNumberSettings]);
  var onTryAgain = React.useCallback(function () {
    setRetryCount(function (count) {
      return count + 1;
    });
    setSmsState(null);
    history.push(tryAgainPath);
  }, [history, tryAgainPath, setSmsState]);
  React.useEffect(function () {
    if (retryCount >= 3 && smsState != null && smsState.matches('error')) history.push(errorPath, {
      redirectPath: nextPagePath
    });
  }, [retryCount, smsState, history, errorPath, nextPagePath]);
  var smsSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var validate, response, _ref2, orderNumber, payment, orderSession, customer, _ref3, _ref3$beaconNumber, beaconNumber, receiptId, _ref4, _ref4$paymentType, paymentType, receiptViewUrl, formattedReceiptViewUrl, _shortenUrl, shortenReceiptViewUrl, shortenedReceiptViewUrl, headerText, orderNumberText, receiptUrlText, pendingPaymentText, receiptMessage;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          validate = validatePhoneNumber(t);
          response = validate(phoneNumber, countryCode, phoneNumberSettings, countryCodeSettings);
          if (!response.length) {
            _context.next = 6;
            break;
          }
          setInputError(response);
          return _context.abrupt("return");
        case 6:
          _ref2 = confirmedOrderPayload || {}, orderNumber = _ref2.orderNumber, payment = _ref2.payment, orderSession = _ref2.session, customer = _ref2.customer;
          _ref3 = orderSession || {}, _ref3$beaconNumber = _ref3.beaconNumber, beaconNumber = _ref3$beaconNumber === void 0 ? '' : _ref3$beaconNumber;
          receiptId = session.receiptId;
          _ref4 = payment || {}, _ref4$paymentType = _ref4.paymentType, paymentType = _ref4$paymentType === void 0 ? '' : _ref4$paymentType;
          receiptViewUrl = process.env.POI_APP_RECEIPT_VIEW_FUNCTION;
          formattedReceiptViewUrl = receiptViewUrl + "?receiptId=" + receiptId;
          _shortenUrl = url_shortener.shortenUrl(formattedReceiptViewUrl), shortenReceiptViewUrl = _shortenUrl[0];
          _context.next = 15;
          return shortenReceiptViewUrl();
        case 15:
          shortenedReceiptViewUrl = _context.sent;
          headerText = t('smsReceiptHeaderText');
          orderNumberText = t('smsReceiptOrderNumberText', {
            orderNumber: getDisplayOrderNumber({
              beacon: beaconNumber,
              customer: customer,
              orderNumber: orderNumber,
              showDotAfterInitials: showDotAfterInitials
            })
          });
          receiptUrlText = t('smsReceiptUrlText', {
            url: shortenedReceiptViewUrl
          });
          pendingPaymentText = paymentType === 'CASH' ? t('smsReceiptPendingPaymentText') : null;
          receiptMessage = buildReceiptMessage({
            settings: smsSettings,
            headerText: headerText,
            orderNumberText: orderNumberText,
            receiptUrlText: receiptUrlText,
            pendingPaymentText: pendingPaymentText
          });
          sendSMS({
            countryCode: countryCode,
            phoneNumber: phoneNumber,
            message: receiptMessage,
            settings: smsSettings,
            transition: function transition(machine) {
              return setSmsState(machine);
            }
          });
          _context.next = 27;
          break;
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](0);
          logger.error('cringer.components - smsSubmit - error:', _context.t0);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 24]]);
  })), [t, phoneNumber, countryCode, phoneNumberSettings, countryCodeSettings, sendSMS, setInputError, setSmsState, buildReceiptMessage, confirmedOrderPayload, smsSettings, session, showDotAfterInitials]);
  React.useEffect(function () {
    var validate = validatePhoneNumber(t);
    setInputError(validate(phoneNumber, countryCode, phoneNumberSettings, countryCodeSettings));
  }, [t, phoneNumber, countryCode, setInputError, phoneNumberSettings, countryCodeSettings]);
  return {
    t: t,
    inputError: inputError,
    smsSubmit: smsSubmit,
    smsSuccessConfirm: smsSuccessConfirm,
    phoneNumber: phoneNumber,
    countryCode: countryCode,
    phoneFocusClass: phoneFocusClass,
    countryFocusClass: countryFocusClass,
    smsSubmitDisabled: smsSubmitDisabled,
    onFocusCountry: onFocusCountry,
    onFocusPhone: onFocusPhone,
    inputName: inputName,
    onChange: onChange,
    onInit: onInit,
    maxLength: maxLength,
    smsState: smsState,
    smsSkip: smsSkip,
    onTryAgain: onTryAgain,
    isLogoEnabled: isLogoEnabled,
    isSubtitleEnabled: isSubtitleEnabled
  };
};

var keyboardService = function keyboardService(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'keyboardMachine' : _ref$id,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 'default' : _ref$initial;
  var keyboardMachine = xstate.Machine({
    id: id,
    initial: initial,
    states: {
      "default": {
        on: {
          LETTER: 'letter',
          NUMPAD: 'numpad',
          SYMBOL: 'symbol'
        }
      },
      letter: {
        on: {
          DEFAULT: 'default',
          NUMPAD: 'numpad',
          SYMBOL: 'symbol'
        }
      },
      numpad: {
        on: {
          LETTER: 'letter',
          DEFAULT: 'default',
          SYMBOL: 'symbol'
        }
      },
      symbol: {
        on: {
          LETTER: 'letter',
          NUMPAD: 'numpad',
          DEFAULT: 'default'
        }
      }
    }
  });
  return {
    keyboardMachine: keyboardMachine
  };
};

var useOnScreenKeyboard = function useOnScreenKeyboard(_ref) {
  var initial = _ref.initial;
  var _keyboardService = keyboardService({
      initial: initial
    }),
    keyboardMachine = _keyboardService.keyboardMachine;
  var _useMachine = react.useMachine(keyboardMachine),
    state = _useMachine[0],
    send = _useMachine[1];
  return {
    state: state,
    send: send
  };
};

var EN = [
	"Q W E R T Y U I O P",
	"A S D F G H J K L",
	"Z X C V B N M"
];
var VI = [
	"Q W E R T Y U I O P Ư",
	"A S D F G H J K L Đ Ơ",
	"Z X C V B N M Ă Â Ê Ô"
];
var TH = [
	"ภ ถ ุ ึ ค ฅ จ ข ช",
	"ๆ ไ ำ พ ะ ั ี ร น ย บ ล ฃ",
	"ฟ ห ก ด เ ้ ่ า ส ว ง",
	"ผ ป แ อ ิ ื ท ม ใ ฝ"
];
var JA = [
	"た て い す か ん な に ら せ",
	"ち と し は き く ま の り",
	"つ さ そ ひ こ み も ね る め"
];
var LayoutsRef = {
	EN: EN,
	VI: VI,
	TH: TH,
	JA: JA
};

var OnScreenKeyboard = function OnScreenKeyboard(_ref) {
  var onChange = _ref.onChange,
    inputName = _ref.inputName,
    _ref$numpadLayout = _ref.numpadLayout,
    numpadLayout = _ref$numpadLayout === void 0 ? ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'] : _ref$numpadLayout,
    _ref$symbolLayout = _ref.symbolLayout,
    symbolLayout = _ref$symbolLayout === void 0 ? ['` ! @ # $ % & ^', '_ - + = { } [ ]', '\\ / | * < > ( )', '~ " \' : ; , ? .'] : _ref$symbolLayout,
    _ref$customTheme = _ref.customTheme,
    customTheme = _ref$customTheme === void 0 ? false : _ref$customTheme,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? null : _ref$maxLength,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'EN' : _ref$layout,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 'letter' : _ref$initial,
    _ref$onInit = _ref.onInit,
    onInit = _ref$onInit === void 0 ? function () {} : _ref$onInit,
    _ref$letter = _ref.letter,
    letter = _ref$letter === void 0 ? true : _ref$letter,
    _ref$symbol = _ref.symbol,
    symbol = _ref$symbol === void 0 ? true : _ref$symbol,
    _ref$numpad = _ref.numpad,
    numpad = _ref$numpad === void 0 ? true : _ref$numpad,
    _ref$space = _ref.space,
    space = _ref$space === void 0 ? false : _ref$space,
    _ref$emailCodes = _ref.emailCodes,
    emailCodes = _ref$emailCodes === void 0 ? '@GMAIL.COM @HOTMAIL.COM @ICLOUD.COM ' : _ref$emailCodes,
    _ref$showEmailCodes = _ref.showEmailCodes,
    showEmailCodes = _ref$showEmailCodes === void 0 ? true : _ref$showEmailCodes,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue;
  var _useOnScreenKeyboard = useOnScreenKeyboard({
      initial: initial
    }),
    state = _useOnScreenKeyboard.state,
    send = _useOnScreenKeyboard.send;
  var classes = [];
  var formattedSymbol = symbol && inputName !== 'email' ? false : symbol;
  var formattedSymbols = formattedSymbol ? '@ . ' : '';

  // TODO document this - https://fingermarkglobal.atlassian.net/browse/S2-4472
  var englishLetterLayout = React.useMemo(function () {
    var layoutLng = [].concat(LayoutsRef['EN']);
    layoutLng[layoutLng.length - 1] = "" + formattedSymbols + layoutLng[layoutLng.length - 1];
    return layoutLng;
  }, [formattedSymbols]);
  var otherLngLetterLayout = React.useMemo(function () {
    if (layout !== 'EN') {
      var layoutLng = [].concat(LayoutsRef[layout] || LayoutsRef['EN']);
      layoutLng[layoutLng.length - 1] = "" + formattedSymbols + layoutLng[layoutLng.length - 1];
      return layoutLng;
    }
    return [];
  }, [layout, formattedSymbols]);

  // TODO document this
  if (!customTheme) classes.push.apply(classes, ['fm-keyboard-theme']);
  var classList = classes.join(' ').concat(' ', className);

  // Include spaces in config as to not render 'empty' keys
  var showENLng = layout !== 'EN' ? '{eng} ' : '';
  var showOtherLng = layout !== 'EN' ? '{lng} ' : '';
  var showLetter = letter ? '{key} ' : '';
  var showNumpad = numpad ? '{num} ' : '';
  var showSymbol = formattedSymbol ? '{sym} ' : '';
  var emailSymbols = showEmailCodes ? (emailCodes == null ? void 0 : emailCodes.trim()) + " " : '';
  var spaceExtraPadding = emailSymbols ? '' : ' ';
  var showSpacebar = space && !emailSymbols ? '{space} ' : spaceExtraPadding;
  var numpadAdditional = formattedSymbol || letter ?
  // Slice off empty space
  [("" + showSymbol + showLetter).slice(0, -1)] : [];
  var layouts = {
    "default": [].concat(otherLngLetterLayout, ["" + showENLng + showNumpad + showSymbol + emailSymbols + "{bksp}"]),
    // || Handles instances where there are no other controls
    letter: [].concat(englishLetterLayout, ["" + showOtherLng + showNumpad + showSymbol + emailSymbols + showSpacebar + "{bksp}"]),
    numpad: [].concat(numpadLayout, numpadAdditional),
    symbol: [].concat(symbolLayout, ["" + showNumpad + showLetter + emailSymbols + "{bksp}"])
  };
  var custom = {
    '{eng}': 'EN',
    '{lng}': layout,
    '{bksp}': 'DEL',
    '{num}': '124',
    '{key}': 'ABC',
    '{sym}': '!#@',
    '{space}': ' '
  };
  var keyPressHandler = function keyPressHandler(key) {
    switch (key) {
      case '{eng}':
        send('LETTER');
        return;
      case '{lng}':
        send('DEFAULT');
        return;
      case '{key}':
        send('LETTER');
        return;
      case '{num}':
        send('NUMPAD');
        return;
      case '{sym}':
        send('SYMBOL');
        return;
      default:
        // @NOTE do not set this to 'default'
        // - That is only a placeholder for initial load
        // - It will effectively 'empty' the keyboard
        return;
    }
  };
  return /*#__PURE__*/jsxRuntime.jsx(Keyboard, {
    keyboardRef: function keyboardRef(r) {
      onInit(r);
      r.setInput(initialValue, inputName);
    },
    layout: layouts,
    display: custom,
    layoutName: initial === 'letter' ? state.value : 'numpad',
    onChange: onChange,
    onKeyPress: keyPressHandler,
    maxLength: maxLength,
    inputName: inputName,
    theme: classList
  });
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".fm-keyboard-theme {\n  display: block;\n  width: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  box-sizing: border-box;\n  touch-action: manipulation;\n}\n\n.fm-keyboard-theme.hg-layout-numpad {\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.fm-keyboard-theme.hg-layout-numpad .hg-row .hg-button {\n  height: 3rem;\n  font-size: 1.5rem;\n}\n\n@media screen and (min-width: 640px) {\n  .fm-keyboard-theme.hg-layout-numpad {\n    max-width: 75%;\n  }\n\n  .fm-keyboard-theme.hg-layout-numpad .hg-row .hg-button {\n    height: 6rem;\n    font-size: 3rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .fm-keyboard-theme.hg-layout-numpad {\n    max-width: 50%;\n  }\n}\n\n.fm-keyboard-theme.hg-layout-numpad .hg-row .hg-button {\n  margin-left: 0;\n  /* There has to be a simpler way */\n  max-width: calc(100% / 3 - 0.75rem / 2);\n}\n\n.fm-keyboard-theme.hg-layout-numpad .hg-row .hg-button.hg-button-bksp,\n.fm-keyboard-theme.hg-layout-numpad .hg-row .hg-button.hg-button-key {\n  margin-left: auto;\n}\n\n.fm-keyboard-theme .hg-row {\n  display: flex;\n}\n\n.fm-keyboard-theme .hg-button {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  height: 3rem;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  background: white;\n  font-size: 1.5rem;\n  box-sizing: border-box;\n  border-radius: 0.25rem;\n  border: 0.125rem solid black;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',\n    Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n    'Noto Color Emoji';\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.fm-keyboard-theme .hg-button span {\n  pointer-events: none;\n}\n\n.fm-keyboard-theme .hg-row:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.fm-keyboard-theme .hg-row .hg-button-container,\n.fm-keyboard-theme .hg-row .hg-button:not(:last-child) {\n  margin-right: 0.75rem;\n}\n\n.fm-keyboard-theme .hg-row > div:last-child {\n  margin-right: 0;\n}\n\n.fm-keyboard-theme .hg-row .hg-button-container {\n  display: flex;\n}\n\n.fm-keyboard-theme .hg-button.hg-activeButton {\n  color: #e4032b;\n  border-color: #e4032b;\n}\n\n.fm-keyboard-theme .hg-button[data-skbtn='{sym}'],\n.fm-keyboard-theme .hg-button[data-skbtn='{num}'],\n.fm-keyboard-theme .hg-button[data-skbtn='{eng}'],\n.fm-keyboard-theme .hg-button[data-skbtn='{lng}'],\n.fm-keyboard-theme .hg-button[data-skbtn='{key}'],\n.fm-keyboard-theme .hg-button[data-skbtn='{bksp}'] {\n  max-width: 8rem;\n}\n\n.fm-keyboard-theme .hg-button[data-skbtn='{bksp}'] {\n  margin-left: auto;\n}\n";
styleInject(css_248z);

var SmsView = function SmsView() {
  var _smsState$context;
  var _useSmsView = useSmsView(),
    t = _useSmsView.t,
    inputError = _useSmsView.inputError,
    smsSubmit = _useSmsView.smsSubmit,
    smsSubmitDisabled = _useSmsView.smsSubmitDisabled,
    smsSuccessConfirm = _useSmsView.smsSuccessConfirm,
    phoneNumber = _useSmsView.phoneNumber,
    countryCode = _useSmsView.countryCode,
    phoneFocusClass = _useSmsView.phoneFocusClass,
    countryFocusClass = _useSmsView.countryFocusClass,
    onFocusCountry = _useSmsView.onFocusCountry,
    onFocusPhone = _useSmsView.onFocusPhone,
    inputName = _useSmsView.inputName,
    maxLength = _useSmsView.maxLength,
    onChange = _useSmsView.onChange,
    smsState = _useSmsView.smsState,
    smsSkip = _useSmsView.smsSkip,
    onTryAgain = _useSmsView.onTryAgain,
    _useSmsView$onInit = _useSmsView.onInit,
    onInit = _useSmsView$onInit === void 0 ? function () {} : _useSmsView$onInit,
    isLogoEnabled = _useSmsView.isLogoEnabled,
    isSubtitleEnabled = _useSmsView.isSubtitleEnabled;
  if (smsState != null && smsState.matches('sending')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "sms-page-loading",
    className: "flex flex-col items-center justify-center h-full p-8 sms-view",
    children: /*#__PURE__*/jsxRuntime.jsx("h1", {
      className: "w-full mb-16 text-5xl font-bold text-center uppercase sm:text-6xl",
      children: (smsState == null ? void 0 : smsState.matches('sending')) && t('smsSending') + "..."
    })
  });
  if (smsState != null && smsState.matches('success')) return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "sms-page-success",
    className: "flex flex-col items-center justify-center h-full md:p-8 sms-view",
    children: [/*#__PURE__*/jsxRuntime.jsx("h1", {
      className: "mb-8 text-5xl font-bold text-center uppercase sm:text-6xl md:mb-16 ",
      children: "" + t('smsSuccessTitle')
    }), isSubtitleEnabled && /*#__PURE__*/jsxRuntime.jsx("h2", {
      className: "mb-8 text-3xl font-bold text-center uppercase sm:text-4xl md:mb-16",
      children: t('smsSuccessSubtitle')
    }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
      onClick: smsSuccessConfirm,
      className: "w-1/2 mb-4 sm:pt-8 home-primary-button",
      children: t('smsSuccessButton')
    })]
  });
  if (smsState != null && smsState.matches('error')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "sms-page-error",
    className: "flex items-center justify-center flex-grow h-full sms-page-error",
    children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "danger",
      message: t('smsErrorMessage'),
      detail: t(smsState == null ? void 0 : (_smsState$context = smsState.context) == null ? void 0 : _smsState$context.error),
      onRetryText: t('smsErrorPrimaryAction'),
      onRetryAction: onTryAgain,
      onCancelAction: smsSkip,
      onCancelText: t('smsErrorSecondaryAction')
    })
  });
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "sms-page",
    className: "flex flex-col items-center justify-center p-2 mt-20 md:h-full sm:p-4 md:p-8 sms-view md:mt-0",
    children: [isLogoEnabled && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "w-full h-48 mb-12 bg-center bg-no-repeat bg-contain bg-logo sms-page-logo"
    }), /*#__PURE__*/jsxRuntime.jsx("h1", {
      className: "text-4xl font-bold text-center uppercase sm:text-6xl md:mb-16 ",
      children: t('smsTitle')
    }), isSubtitleEnabled && /*#__PURE__*/jsxRuntime.jsx("h2", {
      className: "mb-4 text-2xl font-bold text-center uppercase sm:text-4xl md:mb-16",
      children: t('smsSubtitle')
    }), inputError && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "pb-2 text-xl text-center md:pb-4 text-alert sm:text-4xl",
      children: inputError
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "sms-page-input-section",
      className: "flex flex-col items-center w-full",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "input-fields",
        className: "flex w-full space-x-4 sm:w-9/12 md:w-1/2",
        children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex items-center justify-between w-1/4 border-solid border-2 border-black rounded-md bg-white " + countryFocusClass,
          children: [/*#__PURE__*/jsxRuntime.jsx("label", {
            htmlFor: "countryCode",
            className: "inline-block pl-2 text-2xl text-right md:pl-4 sm:text-4xl",
            children: "+"
          }), /*#__PURE__*/jsxRuntime.jsx("input", {
            type: "text",
            id: "countryCode",
            "data-test": "country-code-field",
            name: "countryCode",
            className: "w-full h-8 px-4 pl-0 text-2xl text-right outline-none sm:h-16 sm:text-4xl",
            value: countryCode,
            onFocus: onFocusCountry,
            readOnly: true
          })]
        }), /*#__PURE__*/jsxRuntime.jsx("input", {
          type: "text",
          id: "phoneNumber",
          "data-test": "phone-number-field",
          name: "phoneNumber",
          value: phoneNumber,
          className: "w-3/4 h-12 sm:h-20 px-4 border-solid border-2 rounded-md text-2xl sm:text-4xl outline-none " + phoneFocusClass,
          readOnly: true,
          autoFocus: true,
          onFocus: onFocusPhone
        })]
      }), /*#__PURE__*/jsxRuntime.jsx(OnScreenKeyboard, {
        className: "w-full py-4 sm:w-9/12 md:w-1/2 sm:py-8",
        letter: false,
        symbol: false,
        initial: "numpad",
        onInit: onInit,
        onChange: onChange,
        maxLength: maxLength,
        inputName: inputName,
        initialValue: countryCode
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        onClick: smsSubmit,
        disabled: smsSubmitDisabled,
        className: "w-1/2 mb-4 home-primary-button ",
        children: t('smsPrimaryAction')
      }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        onClick: smsSkip,
        className: "w-1/2 home-primary-button",
        children: t('smsSecondaryAction')
      })]
    })]
  });
};

var AdminViewContext = /*#__PURE__*/React.createContext();
var AdminViewProvider = function AdminViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    children = _ref.children;
  return /*#__PURE__*/jsxRuntime.jsx(AdminViewContext.Provider, {
    children: children
  });
};
var useAdminViewContext = function useAdminViewContext() {
  var context = React.useContext(AdminViewContext);
  if (context === undefined) {
    throw new Error('useAdminViewContext must be used within a AdminViewProvider');
  }
  return context;
};

var useAdminView = function useAdminView() {
  var _payment$provider2;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var history = reactRouterDom.useHistory();
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useState = React.useState(false),
    isOpenModal = _useState[0],
    setOpenModal = _useState[1];
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var _useSystem = useSystem(),
    reboot = _useSystem.reboot,
    lock = _useSystem.lock;
  var _ref = settings || {},
    _ref$settings = _ref.settings,
    config = _ref$settings === void 0 ? {} : _ref$settings;
  var _ref2 = settings || {},
    _ref2$serial = _ref2.serial,
    serial = _ref2$serial === void 0 ? '' : _ref2$serial,
    _ref2$env = _ref2.env,
    env = _ref2$env === void 0 ? '' : _ref2$env,
    _ref2$timezone = _ref2.timezone,
    timezone = _ref2$timezone === void 0 ? '' : _ref2$timezone;
  var _config$datasource = config.datasource,
    datasource = _config$datasource === void 0 ? {} : _config$datasource,
    _config$mocks = config.mocks,
    mocks = _config$mocks === void 0 ? {} : _config$mocks,
    _config$payment = config.payment,
    payment = _config$payment === void 0 ? {} : _config$payment,
    _config$site = config.site,
    site = _config$site === void 0 ? {} : _config$site,
    _config$order = config.order,
    order = _config$order === void 0 ? {} : _config$order,
    _config$content = config.content,
    content = _config$content === void 0 ? {} : _config$content,
    _config$labs = config.labs,
    labs = _config$labs === void 0 ? {} : _config$labs;
  var _datasource$customer = datasource.customer,
    menuOrganisationId = _datasource$customer === void 0 ? '' : _datasource$customer,
    _datasource$storeId = datasource.storeId,
    menuStoreId = _datasource$storeId === void 0 ? '' : _datasource$storeId;
  var _order$organisationId = order.organisationId,
    orderOrganisationId = _order$organisationId === void 0 ? '' : _order$organisationId,
    _order$storeId = order.storeId,
    orderStoreId = _order$storeId === void 0 ? '' : _order$storeId;
  var _site$storeId = site.storeId,
    siteId = _site$storeId === void 0 ? '' : _site$storeId;
  var _payment$provider = payment.provider,
    provider = _payment$provider === void 0 ? '' : _payment$provider,
    _payment$fab = payment.fab,
    fab = _payment$fab === void 0 ? {} : _payment$fab,
    _payment$adyen = payment.adyen,
    adyen = _payment$adyen === void 0 ? {} : _payment$adyen;
  var _ref3 = provider === 'fab' && fab || {},
    _ref3$pid = _ref3.pid,
    paymentUsbPid = _ref3$pid === void 0 ? '' : _ref3$pid,
    _ref3$vid = _ref3.vid,
    paymentUsbVid = _ref3$vid === void 0 ? '' : _ref3$vid,
    _ref3$comPort = _ref3.comPort,
    paymentUsbPort = _ref3$comPort === void 0 ? '' : _ref3$comPort;
  var _ref4 = provider === 'adyen' && adyen || {},
    _ref4$poiId = _ref4.poiId,
    paymentPoiId = _ref4$poiId === void 0 ? '' : _ref4$poiId;
  var _mocks$order = mocks.order,
    orderMock = _mocks$order === void 0 ? false : _mocks$order,
    _mocks$payment = mocks.payment,
    paymentMock = _mocks$payment === void 0 ? false : _mocks$payment;
  var paymentIpAddress = ((_payment$provider2 = payment[provider]) == null ? void 0 : _payment$provider2.pinpadIp) || '';
  var _content$lockScreens = content.lockScreens,
    lockScreens = _content$lockScreens === void 0 ? [{
      name: 'Restaurant Closed',
      message: t('adminPrimaryLockAction')
    }] : _content$lockScreens;
  var manualLock = function manualLock(message) {
    return function () {
      lock({
        state: 'MANUAL_LOCK',
        message: message
      });
    };
  };
  var openModal = function openModal() {
    setOpenModal(true);
  };
  var closeModal = function closeModal() {
    setOpenModal(false);
  };
  var exit = function exit() {
    return history.push('/home');
  };
  var openTransactions = function openTransactions() {
    return history.push('/transactions');
  };
  return {
    settings: settings,
    labs: labs,
    t: t,
    serial: serial,
    menuOrganisationId: menuOrganisationId,
    menuStoreId: menuStoreId,
    orderOrganisationId: orderOrganisationId,
    orderStoreId: orderStoreId,
    siteId: siteId,
    timezone: timezone,
    env: env,
    provider: provider,
    paymentIpAddress: paymentIpAddress,
    paymentUsbPid: paymentUsbPid,
    paymentUsbVid: paymentUsbVid,
    paymentUsbPort: paymentUsbPort,
    exit: exit,
    reboot: reboot,
    paymentPoiId: paymentPoiId,
    orderMock: orderMock,
    paymentMock: paymentMock,
    openModal: openModal,
    closeModal: closeModal,
    isOpenModal: isOpenModal,
    openTransactions: openTransactions,
    lockScreens: lockScreens,
    manualLock: manualLock,
    formatPrice: formatPrice
  };
};

var ResetViewContext = /*#__PURE__*/React.createContext();
var ResetViewProvider = function ResetViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$cancelOrder = _ref.cancelOrder,
    cancelOrder = _ref$cancelOrder === void 0 ? false : _ref$cancelOrder,
    _ref$useResetOrder = _ref.useResetOrder,
    useResetOrder = _ref$useResetOrder === void 0 ? false : _ref$useResetOrder;
  var history = reactRouterDom.useHistory();
  var _useCart = cart.useCart(),
    resetCart = _useCart.resetCart;
  var _useSecondaryCart = cart.useSecondaryCart(),
    resetSecondaryCart = _useSecondaryCart.resetSecondaryCart;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useCustomer = useCustomer(),
    resetCustomer = _useCustomer.resetCustomer;
  var _useRestaurantOrder = useRestaurantOrder(),
    saveSession = _useRestaurantOrder.saveSession,
    saveSessionState = _useRestaurantOrder.saveSessionState,
    cancelSession = _useRestaurantOrder.cancelSession,
    cancelSessionState = _useRestaurantOrder.cancelSessionState,
    resetSessionState = _useRestaurantOrder.resetSessionState,
    doResetSession = _useRestaurantOrder.doResetSession;
  var session = recoil.useRecoilValue(atoms.sessionState);
  var _ref2 = session || {},
    _ref2$status = _ref2.status,
    status = _ref2$status === void 0 ? '' : _ref2$status;
  var resetOrder = recoil.useResetRecoilState(atoms.orderState);
  var resetPaperBag = recoil.useResetRecoilState(atoms.paperBagState);
  var resetSession = recoil.useResetRecoilState(atoms.sessionState);
  var resetBeacon = recoil.useResetRecoilState(atoms.beaconState);
  var resetPayment = recoil.useResetRecoilState(atoms.paymentState);
  var resetTemplate = recoil.useResetRecoilState(atoms.templateState);
  var resetCount = recoil.useResetRecoilState(atoms.orderCountState);
  var resetTotal = recoil.useResetRecoilState(atoms.orderTotalState);
  var resetMetadata = recoil.useResetRecoilState(atoms.metadataState);
  var resetOrigin = recoil.useResetRecoilState(atoms.originState);
  var resetValidatedOrderPayloadState = recoil.useResetRecoilState(atoms.validatedOrderPayloadState);
  var resetConfirmedOrderPayloadState = recoil.useResetRecoilState(atoms.confirmedOrderPayloadState);
  var resetLocaleSelection = recoil.useResetRecoilState(atoms.localeState);
  var resetUpsellState = recoil.useResetRecoilState(atoms.upsellState);
  var resetProductAnimationState = recoil.useResetRecoilState(atoms.productAnimationState);
  var resetCategory = recoil.useResetRecoilState(atoms.categoryState);
  var resetTrackedUpsells = recoil.useResetRecoilState(atoms.trackedUpsellsState);
  var resetOnlineStatus = recoil.useResetRecoilState(atoms.onlineStatusState);
  var resetAddedUpsells = recoil.useResetRecoilState(atoms.addedUpsellState);
  var resetLoyaltyState = recoil.useResetRecoilState(atoms.loyaltyState);
  var resetOffersAndRewardsState = recoil.useResetRecoilState(atoms.offersAndRewardsState);
  var resetCouponNumberState = recoil.useResetRecoilState(atoms.couponNumberState);
  var resetCurrentCategoryState = recoil.useResetRecoilState(atoms.currentCategoryState);
  var resetShowOriginalPriceForComboState = recoil.useResetRecoilState(atoms.showOriginalPriceForComboState);
  var resetPossibleRedemptionsState = recoil.useResetRecoilState(atoms.possibleRedemptionsState);
  var resetOrderServerTotalState = recoil.useResetRecoilState(atoms.orderServerTotalState);
  var _useAnalytics = jitsu.useAnalytics(),
    resetAnalytics = _useAnalytics.resetAnalytics;
  var statusNotAllowedToCancel = ['FINISHED', 'PENDING'];
  var shouldCancelOrder = status && !statusNotAllowedToCancel.includes(status);
  var available = {
    t: t,
    history: history,
    resetCart: resetCart,
    resetSecondaryCart: resetSecondaryCart,
    resetCustomer: resetCustomer,
    resetOrder: resetOrder,
    resetPaperBag: resetPaperBag,
    resetSession: resetSession,
    resetBeacon: resetBeacon,
    resetPayment: resetPayment,
    resetTemplate: resetTemplate,
    resetCount: resetCount,
    resetTotal: resetTotal,
    resetMetadata: resetMetadata,
    resetOrigin: resetOrigin,
    resetValidatedOrderPayloadState: resetValidatedOrderPayloadState,
    resetConfirmedOrderPayloadState: resetConfirmedOrderPayloadState,
    resetLocaleSelection: resetLocaleSelection,
    resetUpsellState: resetUpsellState,
    saveSession: saveSession,
    saveSessionState: saveSessionState,
    cancelOrder: cancelOrder && shouldCancelOrder,
    cancelSession: cancelSession,
    cancelSessionState: cancelSessionState,
    status: status,
    resetProductAnimationState: resetProductAnimationState,
    resetCategory: resetCategory,
    resetTrackedUpsells: resetTrackedUpsells,
    resetAddedUpsells: resetAddedUpsells,
    resetOnlineStatus: resetOnlineStatus,
    resetAnalytics: resetAnalytics,
    resetSessionState: resetSessionState,
    doResetSession: doResetSession,
    useResetOrder: useResetOrder,
    resetLoyaltyState: resetLoyaltyState,
    doLoyaltyLogOut: fmApi.doLoyaltyLogOut,
    resetOffersAndRewardsState: resetOffersAndRewardsState,
    resetCouponNumberState: resetCouponNumberState,
    resetCurrentCategoryState: resetCurrentCategoryState,
    resetShowOriginalPriceForComboState: resetShowOriginalPriceForComboState,
    resetPossibleRedemptionsState: resetPossibleRedemptionsState,
    resetOrderServerTotalState: resetOrderServerTotalState
  };
  return /*#__PURE__*/jsxRuntime.jsx(ResetViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useResetViewContext = function useResetViewContext() {
  var context = React.useContext(ResetViewContext);
  if (context === undefined) {
    throw new Error('useResetViewContext must be used within a ResetViewProvider');
  }
  return context;
};

var useResetView = function useResetView() {
  var _useResetViewContext = useResetViewContext(),
    t = _useResetViewContext.t,
    history = _useResetViewContext.history,
    resetCart = _useResetViewContext.resetCart,
    resetSecondaryCart = _useResetViewContext.resetSecondaryCart,
    resetCustomer = _useResetViewContext.resetCustomer,
    resetOrder = _useResetViewContext.resetOrder,
    resetSession = _useResetViewContext.resetSession,
    resetBeacon = _useResetViewContext.resetBeacon,
    resetPayment = _useResetViewContext.resetPayment,
    resetTemplate = _useResetViewContext.resetTemplate,
    resetCount = _useResetViewContext.resetCount,
    resetTotal = _useResetViewContext.resetTotal,
    resetMetadata = _useResetViewContext.resetMetadata,
    resetOrigin = _useResetViewContext.resetOrigin,
    resetValidatedOrderPayloadState = _useResetViewContext.resetValidatedOrderPayloadState,
    resetConfirmedOrderPayloadState = _useResetViewContext.resetConfirmedOrderPayloadState,
    resetLocaleSelection = _useResetViewContext.resetLocaleSelection,
    resetUpsellState = _useResetViewContext.resetUpsellState,
    cancelOrder = _useResetViewContext.cancelOrder,
    cancelSession = _useResetViewContext.cancelSession,
    cancelSessionState = _useResetViewContext.cancelSessionState,
    status = _useResetViewContext.status,
    resetProductAnimationState = _useResetViewContext.resetProductAnimationState,
    resetCategory = _useResetViewContext.resetCategory,
    resetTrackedUpsells = _useResetViewContext.resetTrackedUpsells,
    resetAddedUpsells = _useResetViewContext.resetAddedUpsells,
    resetAnalytics = _useResetViewContext.resetAnalytics,
    resetSessionState = _useResetViewContext.resetSessionState,
    doResetSession = _useResetViewContext.doResetSession,
    useResetOrder = _useResetViewContext.useResetOrder,
    resetPaperBag = _useResetViewContext.resetPaperBag,
    resetLoyaltyState = _useResetViewContext.resetLoyaltyState,
    doLoyaltyLogOut = _useResetViewContext.doLoyaltyLogOut,
    resetOffersAndRewardsState = _useResetViewContext.resetOffersAndRewardsState,
    resetCouponNumberState = _useResetViewContext.resetCouponNumberState,
    resetCurrentCategoryState = _useResetViewContext.resetCurrentCategoryState,
    resetShowOriginalPriceForComboState = _useResetViewContext.resetShowOriginalPriceForComboState,
    resetPossibleRedemptionsState = _useResetViewContext.resetPossibleRedemptionsState,
    resetOrderServerTotalState = _useResetViewContext.resetOrderServerTotalState;
  var loyaltyUser = recoil.useRecoilValue(atoms.loyaltyState);
  var hasBeenReseted = React.useRef(false);
  var resetStates = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (callback === void 0) {
              callback = function callback() {};
            }
            if (!hasBeenReseted.current) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return Promise.all([resetCart(), resetSecondaryCart(), resetCustomer(), resetOrder(), resetPaperBag(), resetSession(), resetBeacon(), resetPayment(), resetTemplate(), resetCount(), resetTotal(), resetMetadata(), resetOrigin(), resetValidatedOrderPayloadState(), resetConfirmedOrderPayloadState(), resetLocaleSelection(), resetUpsellState(), resetProductAnimationState(), resetCategory(), resetTrackedUpsells(), resetAddedUpsells(), resetAnalytics(), resetLoyaltyState(), resetOffersAndRewardsState(), resetCouponNumberState(), resetCurrentCategoryState(), resetShowOriginalPriceForComboState(), resetPossibleRedemptionsState(), resetOrderServerTotalState()]).then(function () {
              logger.info("components - session finished");
              hasBeenReseted.current = true;
              logger.resetLogs();
              callback();
            })["catch"](function (er) {
              hasBeenReseted.current = true;
              logger.resetLogs();
              logger.warn("components - session finished with error", er);
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [resetBeacon, resetCart, resetSecondaryCart, resetConfirmedOrderPayloadState, resetCount, resetCustomer, resetLocaleSelection, resetMetadata, resetOrder, resetPaperBag, resetOrigin, resetPayment, resetSession, resetTemplate, resetTotal, resetUpsellState, resetValidatedOrderPayloadState, resetProductAnimationState, resetCategory, resetTrackedUpsells, resetAddedUpsells, resetAnalytics, resetLoyaltyState, resetOffersAndRewardsState, resetCouponNumberState, resetCurrentCategoryState, resetShowOriginalPriceForComboState, resetPossibleRedemptionsState, resetOrderServerTotalState]);
  React.useEffect(function () {
    if (useResetOrder) return;
    if (cancelSessionState && !(cancelSessionState != null && cancelSessionState.matches('success')) && !(cancelSessionState != null && cancelSessionState.matches('error'))) {
      return;
    }
    if (status && cancelOrder && !cancelSessionState) {
      cancelSession();
      return;
    }
    if (loyaltyUser != null && loyaltyUser.token) {
      doLoyaltyLogOut({
        token: loyaltyUser.token
      });
    }
    resetStates(function () {
      return history.push('/home');
    });
  }, [history, resetStates, cancelSessionState, status, cancelOrder, cancelSession, useResetOrder, loyaltyUser, doLoyaltyLogOut]);
  React.useEffect(function () {
    if (!useResetOrder) return;
    if (resetSessionState && !(resetSessionState != null && resetSessionState.matches('success')) && !(resetSessionState != null && resetSessionState.matches('error'))) {
      return;
    }
    if (status && cancelOrder && !resetSessionState) {
      doResetSession();
      return;
    }
    if (!cancelOrder && !resetSessionState || resetSessionState != null && resetSessionState.matches('success') || resetSessionState != null && resetSessionState.matches('error')) {
      if (loyaltyUser != null && loyaltyUser.token) {
        doLoyaltyLogOut({
          token: loyaltyUser.token
        });
      }
      resetStates(function () {
        return history.push('/home');
      });
    }
  }, [history, resetStates, status, cancelOrder, resetAnalytics, useResetOrder, resetSessionState, doResetSession, loyaltyUser, doLoyaltyLogOut]);
  return {
    t: t
  };
};

var ResetView = function ResetView() {
  useResetView();
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": 'reset-container',
    className: "flex items-center justify-center h-full",
    children: /*#__PURE__*/jsxRuntime.jsx(Loading, {
      isFirstLoad: true
    })
  });
};

var InvalidRouteViewContext = /*#__PURE__*/React.createContext();
var InvalidRouteViewProvider = function InvalidRouteViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    children = _ref.children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/reset' : _ref$nextPath;
  var available = {
    nextPath: nextPath
  };
  return /*#__PURE__*/jsxRuntime.jsx(InvalidRouteViewContext.Provider, {
    value: available,
    children: children
  });
};
var useInvalidRouteViewContext = function useInvalidRouteViewContext() {
  var context = React.useContext(InvalidRouteViewContext);
  if (context === undefined) {
    throw new Error('useInvalidRouteViewContext must be used within a InvalidRouteViewProvider');
  }
  return context;
};

var useInvalidRouteView = function useInvalidRouteView() {
  var _useInvalidRouteViewC = useInvalidRouteViewContext(),
    nextPath = _useInvalidRouteViewC.nextPath;
  var history = reactRouterDom.useHistory();
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var redirect = function redirect() {
    return history.push(nextPath);
  };
  React.useEffect(function () {
    var timer = setTimeout(function () {
      try {
        redirect();
      } catch (err) {
        logger.error('components - useInvalidRouteView - error:', err);
      }
    }, 5 * 1000); // No KAS setting for this interval

    return function () {
      return clearTimeout(timer);
    };
  });
  return {
    redirect: redirect,
    t: t
  };
};

var InvalidRouteView = function InvalidRouteView() {
  var _useInvalidRouteView = useInvalidRouteView(),
    redirect = _useInvalidRouteView.redirect,
    t = _useInvalidRouteView.t;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "h-screen flex flex-col justify-center items-center space-y-8",
    children: [/*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-2xl xs:text-3xl md:text-5xl font-bold",
      children: t('invalidRouteTitle')
    }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
      onClick: redirect,
      className: "home-primary-button",
      children: t('invalidRouteButton')
    })]
  });
};

var LoyaltyOffersViewContext = /*#__PURE__*/React.createContext();
var LoyaltyOffersViewProvider = function LoyaltyOffersViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/customer-details' : _ref$nextPath,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$customerSkipPath = _ref.customerSkipPath,
    customerSkipPath = _ref$customerSkipPath === void 0 ? '/validate' : _ref$customerSkipPath,
    _ref$showLoyaltyBanne = _ref.showLoyaltyBanner,
    showLoyaltyBanner = _ref$showLoyaltyBanne === void 0 ? true : _ref$showLoyaltyBanne,
    _ref$displayDescripti = _ref.displayDescription,
    displayDescription = _ref$displayDescripti === void 0 ? true : _ref$displayDescripti,
    _ref$hideDisabledButt = _ref.hideDisabledButtons,
    hideDisabledButtons = _ref$hideDisabledButt === void 0 ? false : _ref$hideDisabledButt,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$disableModifyUps = _ref.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref$disableModifyUps === void 0 ? false : _ref$disableModifyUps,
    _ref$showEnergyInform = _ref.showEnergyInformationSeparated,
    showEnergyInformationSeparated = _ref$showEnergyInform === void 0 ? false : _ref$showEnergyInform,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom;
  var history = reactRouterDom.useHistory();
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath ? customerSkipPath : !!customer ? customerSkipPath : nextPath;
  var previousPath = (state == null ? void 0 : state.from) === '/cart' ? '/validate' : (state == null ? void 0 : state.from) || '/categories';
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count; // TODO
  var loading = false; // TODO
  var menuState = true; // TODO

  var available = {
    t: t,
    count: count,
    loading: loading,
    history: history,
    menuState: menuState,
    setTemplate: setTemplate,
    formatPrice: formatPrice,
    mockedReady: true,
    previousPath: previousPath,
    showPriceWarning: showPriceWarning,
    computedNextPath: computedNextPath,
    showLoyaltyBanner: showLoyaltyBanner,
    displayDescription: displayDescription,
    hideDisabledButtons: hideDisabledButtons,
    showAddonAvailability: showAddonAvailability,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    showEnergyInformationSeparated: showEnergyInformationSeparated
  };
  return /*#__PURE__*/jsxRuntime.jsx(LoyaltyOffersViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useLoyaltyOffersViewContext = function useLoyaltyOffersViewContext() {
  var context = React.useContext(LoyaltyOffersViewContext);
  if (context === undefined) {
    throw new Error('useLoyaltyOffersViewContext must be used within a LoyaltyOffersViewProvider');
  }
  return context;
};

/* eslint-disable max-lines */
var formattedProducts = [{
  title: 'Simple Product',
  name: {
    text: 'Simple Product'
  },
  image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000001.png?alt=media',
  price: 10,
  productId: 10000001,
  energyInformation: null,
  description: 'Fingercream is the delicious ice cream simple product from this store.',
  dataTag: 'simple-product-card',
  type: 'simple',
  isAvailable: true,
  posItemId: 0,
  isUpsell: false,
  serves: ''
}, {
  productId: 10000012,
  image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000012.png?alt=media',
  title: 'Grouped',
  serves: '',
  description: 'FingerChips Regular is the delicious french fries simple product from this store.',
  price: 10,
  energyInformation: null,
  dataTag: 'grouped-product-card',
  type: 'grouped',
  isAvailable: true,
  posItemId: 0,
  grouped: [{
    title: 'FingerChips Small',
    name: {
      text: 'FingerChips Small'
    },
    image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000013.png?alt=media',
    price: 5,
    productId: 10000013,
    energyInformation: null,
    description: 'FingerChips Small is the delicious french fries simple product from this store.',
    dataTag: 'grouped-option-card',
    type: 'simple',
    isAvailable: true,
    posItemId: 0,
    isUpsell: false,
    serves: '',
    "default": false
  }, {
    title: 'FingerChips Regular',
    name: {
      text: 'FingerChips Regular'
    },
    image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000014.png?alt=media',
    price: 7,
    productId: 10000014,
    energyInformation: null,
    description: 'FingerChips Regular is the delicious french fries simple product from this store.',
    dataTag: 'grouped-option-card',
    type: 'simple',
    isAvailable: true,
    posItemId: 0,
    isUpsell: false,
    serves: '',
    "default": true
  }, {
    title: 'FingerChips Big',
    name: {
      text: 'FingerChips Big'
    },
    image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000015.png?alt=media',
    price: 10,
    productId: 10000015,
    energyInformation: null,
    description: 'FingerChips Big is the delicious french fries simple product from this store.',
    dataTag: 'grouped-option-card',
    type: 'simple',
    isAvailable: false,
    posItemId: 0,
    isUpsell: false,
    serves: '',
    "default": false
  }]
}, {
  productId: 10000003,
  image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000003.png?alt=media',
  title: 'Grouped',
  serves: '',
  description: 'FingerDrink is a delicious drink grouped product from this store.',
  price: 10,
  energyInformation: null,
  dataTag: 'grouped-product-card',
  type: 'grouped',
  isAvailable: true,
  posItemId: 0,
  grouped: [{
    title: 'FingerDrink Small',
    name: {
      text: 'FingerDrink Small'
    },
    image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000004.png?alt=media',
    price: 5,
    productId: 10000004,
    energyInformation: null,
    description: 'FingerDrink is a delicious drink grouped product from this store.',
    dataTag: 'grouped-option-card',
    type: 'simple',
    isAvailable: false,
    posItemId: 0,
    isUpsell: false,
    serves: '',
    "default": false
  }, {
    title: 'FingerDrink Regular',
    name: {
      text: 'FingerDrink Regular'
    },
    image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000005.png?alt=media',
    price: 7,
    productId: 10000005,
    energyInformation: null,
    description: 'FingerDrink is a delicious drink grouped product from this store.',
    dataTag: 'grouped-option-card',
    type: 'simple',
    isAvailable: true,
    posItemId: 0,
    isUpsell: false,
    serves: '',
    "default": true
  }, {
    title: 'FingerDrink Big',
    name: {
      text: 'FingerDrink Big'
    },
    image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000006.png?alt=media',
    price: 10,
    productId: 10000006,
    energyInformation: null,
    description: 'FingerDrink is a delicious drink grouped product from this store.',
    dataTag: 'grouped-option-card',
    type: 'simple',
    isAvailable: true,
    posItemId: 0,
    isUpsell: false,
    serves: '',
    "default": false
  }]
}, {
  name: {
    text: 'Customisable',
    translations: [{
      language: 'eng',
      text: 'Customisable'
    }]
  },
  image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000007.png?alt=media',
  price: 10,
  productId: 10000007,
  title: 'Customisable',
  energyInformation: null,
  description: 'FingerBurger is the delicious burger from this store.',
  dataTag: 'customisable-product-card',
  serves: '',
  type: 'customise',
  isAvailable: true,
  posItemId: 0,
  isUpsell: false
}, {
  title: 'Combo',
  productId: 10000008,
  isUpsell: false,
  type: 'combo',
  name: {
    text: 'Combo'
  },
  image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000008.png?alt=media',
  description: 'FingerBurger Combo is the delicious combo from this store.',
  price: 27,
  energyInformation: null,
  options: [{
    id: 1,
    name: {
      text: 'Combo Regular',
      translations: [{
        language: 'eng',
        text: 'Combo Regular'
      }]
    },
    price: 27,
    productId: 10000008,
    image: 'https://firebasestorage.googleapis.com/v0/b/restaurant-uat.appspot.com/o/fingerproducts%2Ffingerburger-combo-product.png?alt=media&token=d5d29f76-d7fe-4d2c-9135-36ac6f6b66d4',
    title: 'Combo Regular',
    dataTag: 'combo-option-card',
    type: 'combo',
    isAvailable: true,
    isVisible: true,
    posItemId: 0,
    serves: ''
  }, {
    id: 2,
    name: {
      text: 'Combo Upsize',
      translations: [{
        language: 'eng',
        text: 'Combo Upsize'
      }]
    },
    price: 35,
    productId: 10000008,
    image: 'https://firebasestorage.googleapis.com/v0/b/restaurant-uat.appspot.com/o/fingerproducts%2Ffingerburger-combo-product.png?alt=media&token=d5d29f76-d7fe-4d2c-9135-36ac6f6b66d4',
    title: 'Combo Upsize',
    dataTag: 'combo-option-card',
    type: 'combo',
    isAvailable: true,
    isVisible: true,
    posItemId: 0,
    serves: ''
  }],
  isAvailable: true,
  isVisible: true,
  serves: '',
  dataTag: 'combo-product-card'
}, {
  title: 'Simple Product Partial Availability Morning',
  name: {
    text: 'Simple Product Partial Availability Morning'
  },
  image: 'https://firebasestorage.googleapis.com/v0/b/supersonic-sandbox.appspot.com/o/images%2Forganisations%2F6xd8yNptfZO4uRC5Cbuo%2Fmenus%2F1%2Fversions%2FhMCLyJEVWKuZqv9OHrPc%2Fproducts%2F10000009.png?alt=media',
  price: 10,
  productId: 10000009,
  energyInformation: null,
  description: 'Morning Fingerburger is the delicious morning burger simple product from this store.',
  dataTag: 'simple-product-card',
  type: 'simple',
  isAvailable: false,
  posItemId: 0,
  isUpsell: false,
  serves: ''
}];

var useLoyaltyOffersView = function useLoyaltyOffersView() {
  var _useLoyaltyOffersView = useLoyaltyOffersViewContext(),
    t = _useLoyaltyOffersView.t,
    count = _useLoyaltyOffersView.count,
    loading = _useLoyaltyOffersView.loading,
    history = _useLoyaltyOffersView.history,
    menuState = _useLoyaltyOffersView.menuState,
    formatPrice = _useLoyaltyOffersView.formatPrice,
    setTemplate = _useLoyaltyOffersView.setTemplate,
    previousPath = _useLoyaltyOffersView.previousPath,
    showPriceWarning = _useLoyaltyOffersView.showPriceWarning,
    computedNextPath = _useLoyaltyOffersView.computedNextPath,
    showLoyaltyBanner = _useLoyaltyOffersView.showLoyaltyBanner,
    displayDescription = _useLoyaltyOffersView.displayDescription,
    hideDisabledButtons = _useLoyaltyOffersView.hideDisabledButtons,
    showAddonAvailability = _useLoyaltyOffersView.showAddonAvailability,
    disableModifyUpsellOnCart = _useLoyaltyOffersView.disableModifyUpsellOnCart,
    showEnergyInformationSeparated = _useLoyaltyOffersView.showEnergyInformationSeparated;
  var _useState = React.useState(false),
    showMiniCartModal = _useState[0],
    setShowMiniCartModal = _useState[1];
  var title = React.useMemo(function () {
    return t('loyaltyOffersTitle');
  }, [t]);
  var galleryMaxColumns = undefined; // TODO
  var ready = true; // TODO

  var originPath = '/loyalty-offers';
  var nextAction = React.useCallback(function () {
    history.push(computedNextPath);
  }, [history, computedNextPath]);
  var previousAction = React.useCallback(function () {
    history.push(previousPath);
  }, [history, previousPath]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal]);
  var onCloseMiniCartModal = React.useCallback(function () {
    setShowMiniCartModal(false);
  }, [setShowMiniCartModal]);
  var onConfirmMiniCartModal = React.useCallback(function () {
    history.push(computedNextPath);
  }, [history, computedNextPath]);
  React.useEffect(function () {
    var header = {
      title: title,
      onBasketClick: onBasketClick,
      previousAction: previousAction,
      showLoyaltyBanner: showLoyaltyBanner,
      showSubtotal: false,
      showBasketCount: true,
      isViewOrderDisabled: false,
      previousText: t('loyaltyOffersPreviousAction')
    };
    var footer = {
      nextAction: nextAction,
      onBasketClick: onBasketClick,
      showBasketCount: true,
      allowNextAction: true,
      enableCancelOrder: true,
      nextText: t('loyaltyOffersNextAction'),
      previousText: t('loyaltyOffersPreviousAction')
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [previousAction, setTemplate, nextAction, title, t, onBasketClick, showLoyaltyBanner]);
  return {
    t: t,
    ready: ready,
    loading: loading,
    menuState: menuState,
    originPath: originPath,
    formatPrice: formatPrice,
    showPriceWarning: showPriceWarning,
    formattedProducts: formattedProducts,
    showMiniCartModal: showMiniCartModal,
    displayDescription: displayDescription,
    galleryMaxColumns: galleryMaxColumns,
    hideDisabledButtons: hideDisabledButtons,
    onCloseMiniCartModal: onCloseMiniCartModal,
    showAddonAvailability: showAddonAvailability,
    onConfirmMiniCartModal: onConfirmMiniCartModal,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    showEnergyInformationSeparated: showEnergyInformationSeparated
  };
};

var GalleryCard = function GalleryCard(_ref) {
  var _promoItem$imageUrl, _promoItem$name;
  var descriptive = _ref.descriptive,
    image = _ref.image,
    title = _ref.title,
    type = _ref.type,
    description = _ref.description,
    price = _ref.price,
    energyInformation = _ref.energyInformation,
    _ref$serves = _ref.serves,
    serves = _ref$serves === void 0 ? '' : _ref$serves,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$dataTag = _ref.dataTag,
    dataTag = _ref$dataTag === void 0 ? 'gallery-card' : _ref$dataTag,
    productId = _ref.productId,
    _ref$enableButton = _ref.enableButton,
    enableButton = _ref$enableButton === void 0 ? false : _ref$enableButton,
    buttonActionText = _ref.buttonActionText,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showEnergyInform = _ref.showEnergyInformationSeparated,
    showEnergyInformationSeparated = _ref$showEnergyInform === void 0 ? false : _ref$showEnergyInform,
    _ref$isAvailable = _ref.isAvailable,
    isAvailable = _ref$isAvailable === void 0 ? true : _ref$isAvailable,
    _ref$disabledClass = _ref.disabledClass,
    disabledClass = _ref$disabledClass === void 0 ? 'opacity-30 line-through' : _ref$disabledClass,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$imageHeightClass = _ref.imageHeightClassName,
    imageHeightClassName = _ref$imageHeightClass === void 0 ? 'h-card-image' : _ref$imageHeightClass,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$isAnimated = _ref.isAnimated,
    isAnimated = _ref$isAnimated === void 0 ? false : _ref$isAnimated;
  var showAddonAvailabilityDisabledClass = !isAvailable && showAddonAvailability && 'opacity-30';
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  var promoItem = getPromoItem({
    productId: productId,
    title: title,
    type: type
  });
  var productImage = (_promoItem$imageUrl = promoItem == null ? void 0 : promoItem.imageUrl) != null ? _promoItem$imageUrl : image;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTag,
    className: "gallery-card font-card\n      " + (!isAvailable && !showAddonAvailability ? disabledClass : '') + " " + className,
    onClick: !enableButton && isAvailable && !isAnimated ? onClick : null,
    id: productId,
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "gallery-image",
      className: "gallery-image",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "gallery-image-container",
        children: [/*#__PURE__*/jsxRuntime.jsx(ProductCardLoadableImage, {
          src: productImage,
          className: classNames(imageHeightClassName, 'gallery-card-image', fullWidth ? 'w-full' : 'w-card-image', showAddonAvailabilityDisabledClass)
        }), !isAvailable && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "gallery-cart-availability",
          children: t('showAddonAvailabilityMessage')
        })]
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "gallery-title",
        className: "gallery-card__info__title " + showAddonAvailabilityDisabledClass,
        children: (_promoItem$name = promoItem == null ? void 0 : promoItem.name) != null ? _promoItem$name : title
      }), descriptive && description && /*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "gallery-description",
        className: "gallery-card__info__description " + showAddonAvailabilityDisabledClass,
        children: description
      })]
    }), showEnergyInformationSeparated ? /*#__PURE__*/jsxRuntime.jsxs("div", {
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "gallery-info-price",
        className: "gallery-card__info gallery-card-info gallery-card__info__price " + showAddonAvailabilityDisabledClass,
        children: price && formatPrice({
          price: price
        })
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "gallery-info-energyInformation",
        className: "gallery-card-info gallery-card__info gallery-card__info__energy " + showAddonAvailabilityDisabledClass,
        children: energyInformation
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "gallery-info-serving",
        className: "gallery-card-info gallery-card__info gallery-card__info__serving " + showAddonAvailabilityDisabledClass,
        children: serves
      })]
    }) : /*#__PURE__*/jsxRuntime.jsx("p", {
      "data-test": "gallery-info",
      className: "gallery-card-info gallery-card__info__price__and__energy " + showAddonAvailabilityDisabledClass,
      children: utilities.join(price && formatPrice({
        price: price
      }), energyInformation)()
    }), enableButton && /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "gallery-action",
      className: "gallery-action " + showAddonAvailabilityDisabledClass,
      children: /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
        onClick: isAvailable ? onClick : null,
        children: buttonActionText
      })
    })]
  });
};

var Gallery = function Gallery(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$maxColumns = _ref.maxColumns,
    maxColumns = _ref$maxColumns === void 0 ? 3 : _ref$maxColumns,
    _ref$galleryCardClass = _ref.galleryCardClassName,
    galleryCardClassName = _ref$galleryCardClass === void 0 ? '' : _ref$galleryCardClass,
    _ref$descriptive = _ref.descriptive,
    descriptive = _ref$descriptive === void 0 ? false : _ref$descriptive,
    _ref$Card = _ref.Card,
    Card = _ref$Card === void 0 ? GalleryCard : _ref$Card,
    _ref$dynamicColumns = _ref.dynamicColumns,
    dynamicColumns = _ref$dynamicColumns === void 0 ? false : _ref$dynamicColumns,
    _ref$enableGalleryCar = _ref.enableGalleryCardActionButton,
    enableGalleryCardActionButton = _ref$enableGalleryCar === void 0 ? false : _ref$enableGalleryCar,
    _ref$galleryCardButto = _ref.galleryCardButtonActionText,
    galleryCardButtonActionText = _ref$galleryCardButto === void 0 ? '' : _ref$galleryCardButto,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showEnergyInform = _ref.showEnergyInformationSeparated,
    showEnergyInformationSeparated = _ref$showEnergyInform === void 0 ? false : _ref$showEnergyInform,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  var sharedProps = {
    descriptive: descriptive,
    className: galleryCardClassName,
    enableButton: enableGalleryCardActionButton,
    buttonActionText: galleryCardButtonActionText,
    formatPrice: formatPrice,
    showAddonAvailability: showAddonAvailability,
    showEnergyInformationSeparated: showEnergyInformationSeparated,
    t: t
  };
  if (dynamicColumns || maxColumns == 1) {
    var _columnNumberClass = classNames({
      'sm:grid-cols-2': maxColumns >= 2 && items.length >= 2,
      'md:grid-cols-3': maxColumns >= 3 && items.length >= 3
    });
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "gallery-container gallery-card-categories " + _columnNumberClass,
      "data-test": "gallery",
      children: items.map(function (item, index) {
        return item && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "gallery-card-container",
          children: /*#__PURE__*/jsxRuntime.jsx(Card, _extends({}, item, {
            fullWidth: maxColumns == 1
          }, sharedProps))
        }, index);
      })
    });
  }
  var columnNumberClass = classNames({
    'sm:grid-cols-2': maxColumns >= 2,
    'md:grid-cols-3': maxColumns >= 3
  });

  // If Coupons category exists and is not in the second position, move it to the second position
  var couponsIndex = items.findIndex(function (item) {
    return item.title === 'Coupons';
  });
  if (couponsIndex !== -1 && couponsIndex !== 1) {
    var _items$splice = items.splice(couponsIndex, 1),
      couponsItem = _items$splice[0];
    items.splice(1, 0, couponsItem);
  }
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "gallery-card-categories",
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "gallery-container " + columnNumberClass + " gallery--container",
      "data-test": "gallery",
      children: items.map(function (item, index) {
        return item && /*#__PURE__*/React.createElement(Card, _extends({}, item, {
          key: index
        }, sharedProps));
      })
    })
  });
};

var QuantityControllerButtons = function QuantityControllerButtons(_ref) {
  var product = _ref.product,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disableModifyUps = _ref.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref$disableModifyUps === void 0 ? false : _ref$disableModifyUps,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity,
    _ref$onQtyUpdate = _ref.onQtyUpdate,
    onQtyUpdate = _ref$onQtyUpdate === void 0 ? function () {} : _ref$onQtyUpdate;
  var _ref2 = product || {},
    _ref2$add = _ref2.add,
    add = _ref2$add === void 0 ? function () {} : _ref2$add,
    _ref2$remove = _ref2.remove,
    remove = _ref2$remove === void 0 ? function () {} : _ref2$remove,
    _ref2$count = _ref2.count,
    count = _ref2$count === void 0 ? {} : _ref2$count,
    _ref2$addDisabled = _ref2.addDisabled,
    addDisabled = _ref2$addDisabled === void 0 ? false : _ref2$addDisabled,
    _ref2$removeDisabled = _ref2.removeDisabled,
    removeDisabled = _ref2$removeDisabled === void 0 ? false : _ref2$removeDisabled,
    _ref2$isAvailable = _ref2.isAvailable,
    isAvailable = _ref2$isAvailable === void 0 ? true : _ref2$isAvailable,
    _ref2$isUpsell = _ref2.isUpsell,
    isUpsell = _ref2$isUpsell === void 0 ? false : _ref2$isUpsell;
  var disabledButtonForUpsell = disableModifyUpsellOnCart && isUpsell;
  var couponProductId = recoil.useRecoilValue(atoms.couponProductIdState);
  var disabledButtonForCoupon = isCouponQuantityDisabled && couponProductId === product.productId;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "quantity-controller-buttons",
    className: "flex space-x-1 md:space-x-3 items-center mr-0 xs:mr-2 md:mr-5 " + className,
    children: [/*#__PURE__*/jsxRuntime.jsx("button", {
      "data-test": "button-product-quantity-remove",
      className: "flex items-center justify-center p-1 border border-black rounded-full xs:p-2 disabled:opacity-50 focus:outline-none",
      onClick: function onClick(e) {
        remove(e);
        onQtyUpdate(-1);
      },
      disabled: !isAvailable || removeDisabled || disabledButtonForUpsell || disabledButtonForCoupon,
      children: /*#__PURE__*/jsxRuntime.jsx(Minus, {
        className: "w-4 h-4 md:w-8 md:h-8"
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "product-quantity-count",
      className: "w-2 py-2 text-xl text-center xs:text-3xl xs:w-6 md:w-12",
      children: count.current
    }), /*#__PURE__*/jsxRuntime.jsx("button", {
      "data-test": "button-product-quantity-add",
      className: "flex items-center justify-center p-1 border border-black rounded-full xs:p-2 disabled:opacity-50 focus:outline-none",
      onClick: function onClick(e) {
        add(e);
        onQtyUpdate(1);
      },
      disabled: !isAvailable || addDisabled || disabledButtonForUpsell || disabledButtonForCoupon,
      children: /*#__PURE__*/jsxRuntime.jsx(Plus, {
        className: "w-4 h-4 md:w-8 md:h-8"
      })
    })]
  });
};

var _path$4, _path2$2, _path3$1, _g$1, _path4$1, _g2, _defs;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function SvgKfcIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4032B",
    d: "M1 1.736h30v30H1z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4032B",
    strokeWidth: 2,
    d: "M1 1.736h30v30H1z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kfc-icon_svg__clip0_20_1847)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kfc-icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 14,
    height: 25
  }, _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.402 4.757H9.57v23.977h12.832V4.757z",
    fill: "#fff"
  }))), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#kfc-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.851 19.259c.01.444.27 1.619 1.767 2.734.624.464.91.674.993.73v.004c.04.029-.222.022-.294.029-.117.011-.516-.025-.836.034-.288.053-.25.122-.278.33-.023.165-.001.426-.01.648-.008.223-.02.381.074.489.093.106.152.122.548.098.376-.023 1.418-.024 1.544-.05.161-.032.135.026.042.225-.16.34-.678 1.901-1.485 3.384-.113.208.205.11.477.24.49.236.474.302.603.056.14-.267.848-1.927.957-2.44.014-.067.043-.125.054-.024.008.072.018 2.17-.04 2.831a.123.123 0 00.03.097.268.268 0 00.134.062c.245-.08.54-.14.79-.1a.322.322 0 00.064-.013.137.137 0 00.034-.04.432.432 0 00.039-.114l.001-.01a1.632 1.632 0 00.037-.27 4.79 4.79 0 00.01-.29 10.16 10.16 0 00-.001-.386c-.001-.075-.003-.05-.005-.124a12.667 12.667 0 00-.021-.49 15.256 15.256 0 00-.177-1.616c-.015-.087-.031-.124-.05-.21a7.293 7.293 0 00-.118-.488 5.076 5.076 0 00-.058-.186.637.637 0 01-.018-.106c.006-.03.045-.008.087-.017l.031-.005c.268-.036.734-.012.84-.008.103.003.633.053.783.067.148.014.328.048.32-.4-.002-.12-.002-.19-.002-.302v-.046-.083l.002-.047v-.045-.04l.003-.07v-.019c0-.016 0-.03.002-.045v-.02l.003-.032v-.01a1.2 1.2 0 00.003-.044c.003-.11-.011-.31-.22-.364-.239-.06-.66-.074-1.038-.04-.053.004-.065 0-.049-.015v-.004c.082-.058.63-.359 1.255-.917.688-.615 1.017-.942 1.227-1.387 0 0 .753-1.456.715-2.69-.007-.249.033-.228.188-.224.047.002.225-.01.32-.074.32-.072.603-1.16.603-1.16s.48-1.65.596-2.325c.103-.6.079-.951-.29-1.13l-.06-.034a.069.069 0 01-.033-.079.835.835 0 00.018-.078c.18-.622.5-1.409.428-1.728-.013-.092-.09-.121-.118-.14a.901.901 0 01-.22-.295.197.197 0 01-.009-.05c-.102-1.175-.52-2.648-1.768-3.932-.002 0-.086-.077-.137-.124a5.738 5.738 0 00-.4-.333 6.494 6.494 0 00-1.145-.709 6.012 6.012 0 00-1.058-.354 4.433 4.433 0 00-.558-.111 5.679 5.679 0 00-1.22-.064 9.19 9.19 0 01-.128.006l-.079.003-.088.003a3.96 3.96 0 00-.338.036c-.204.03-.423.07-.558.102-.151.037-.355.079-.609.151-.104.03-.209.063-.314.097l-.088.028a13.38 13.38 0 00-.34.116c-.084.03-.437.182-.514.217a3.468 3.468 0 01-.143.061c-.25.079-.302.222-.31.301a.477.477 0 01-.04.147c-.359.76-1.204.835-1.539.851-.087.004-.165.017-.137.102.072.218.467.626.708.7-.003.035-.207.079-.25.09-.097.025-.497-.01-.517-.006h-.005c-.452.039-.59.347-.632.493a.163.163 0 00.02.133c.1.153.206.277.286.478l.002.006c.02.053.04.111.056.177.01.086.079.175-.008.344-.155.3-.542.393-.6.69-.082.422.064.699.224 1.397.11.478.23.973.314 1.197a.02.02 0 01-.015.027 1.495 1.495 0 00-.113.025c-.224.09-.294.265-.32.609-.056.76.508 1.933.682 2.938.059.34.216.883.477 1.106.06.051.186.084.264.097.204.036.292-.093.304.111.003.043.017.157.019.222.035.722.423 1.438.423 1.438z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "kfc-icon_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 14,
    height: 25
  }, _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.402 4.757H9.57v23.977h12.832V4.757z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#kfc-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.783 13.865c-.147.775-.31 1.165-.415 1.644-.11.497-.324 1.225-.532 1.244-.21.063-.295-.18-.43 0-.08.106-.143.248-.215.339a.571.571 0 00-.091.265c0 .14-.008.592-.134 1.185-.19.895-.534 1.547-.892 1.958-.686.789-1.328.915-1.404.956-.099.052-.247.02-.296-.002-.05-.023-.087-.082-.172-.164-.088-.081-.118.042-.121.074-.003.03.044.402-.051.571-.206.363-.404.395-.514.847-.037.152-.011.383-.194.278-.447-.254-1.088-.944-1.22-1.611-.04-.204-.003-.43.122-.818.072-.227.123-.48.123-.625 0-.259-.101-.478 0-.5.188-.042.273.443.36.392.152-.087.04-.598.04-.598s-.063-.145-.329-.207c-.153-.036-.2-.15-.038-.23.122-.06.264-.138.429-.113 1.102.155 1.42-.066 1.865-.186.088-.022.14-.033.208 0 .068.03.251.13.289.224.038.093-.002.458.057.732.06.276.254.026.302-.083.048-.108.099-.375.108-.443.011-.067.068-.35.17-.435.202-.167.273-.387.306-.473.033-.086.086-.35.076-.738-.01-.387-.08-.428-.173-.512-.093-.083-.204-.067-.44-.282-.21-.193-.384-.504-.537-.7-.152-.195-.406-.405-.695-.476-.288-.069-.169.196-.153.27.012.053.08.287-.017.365-.094.077-.676.468-1.196.332-.62-.161-.833-.505-.846-.837-.009-.235.104-.462.245-.731.083-.158.116-.421.15-.673.026-.202.08-.494.124-.598.032-.075.107-.157.275-.147.166.01.275.092.305.234.108.497.284.622.343.662.06.04.173-.04.216-.069.045-.028.158-.142.122-.203a.777.777 0 01-.095-.207c-.02-.094.098-.082.122-.064.194.153.377.166.712.222.587.098.672-.118 1.075-.049.052.01.152.053.184.113.027.052.076.17.125.192.049.019.169.026.23.037.086.014.239.004.213.162-.066.42-.554.537-.782.576-.094.016-.137.024-.152.037-.05.043-.052.175.005.26.04.06.224.064.477.016.263-.05.516-.177.715-.487.212-.328.328-1.051.353-1.186.024-.135.078-.361.153-.408.073-.046.417-.15.465-.141.058.01.1.037.127.17.027.133-.023.93-.024 1.05-.002.129.064.128.1.11.08-.036.294-.178.343-.342.036-.122-.067-.3-.015-.468.08-.262.16-.332.215-.327.335.032.404.178.323.602m-4.749 4.297a3.4 3.4 0 01-.659.14c-.175.01-.733.047-.826.042a.675.675 0 01-.396-.177c-.026-.023-.053-.103.05-.105.19-.003.514-.105 1.625-.012l.203.018c.029.003.128.05.003.094zm-2.733-.45c-.541-.007-.791-.208-.83-.268-.037-.058.025-.103.082-.121.128-.04.355-.155.447-.225.092-.068.347-.226.476-.31.06-.038.408-.19.612-.048.305.212.59.354 1.112.322.336-.02.328-.29.602-.376.247-.078.294-.139.371-.184.1-.02.174-.044.282.056.137.127.186.227.345.406.218.244.457.358.531.372.074.015.127.075.128.1 0 .024-.03.1-.25.162-.73.21-1.522.076-1.93-.087-.206-.082-.407-.105-.634.006-.23.113-.84.201-1.344.195zm-.26 2.996c-.414.013-1.498-.639-1.97-2.488-.123-.476.178-.861.365-.928.11-.04.168-.053.205-.058.039-.005.227-.004.22.209-.006.172.137 1.606.513 2.125.093.128.18.133.222.02.04-.106.105-.243.125-.294.016-.037.153-.246.193-.088.086.337.288 1.027.373 1.206.141.297-.09.292-.246.296zm-2.177-5.517c-.03-.125.026-.311.32-.123.048.03.186.092.34.136.093.027.153-.012.18-.08.027-.066.103-.2-.028-.263-.13-.065-.453-.121-.637-.573-.033-.08.023-.173.075-.197.052-.024.117-.012.177.045.06.056.188.18.304.184.106.006.123-.037.145-.063.089-.1.344-.472.874-.407.219.027.42.075.494.08.052.004.198.01.337-.016.158-.03.395-.078.28.055-.095.109-.174.154-.09.271l.011.018a.295.295 0 01.001.347l-.009.013c-.117.152-.36.326-.86.358-.228.014-.242.006-.247.136a.412.412 0 00.006.111c.014.065.056.093.215.103.114.007.324-.016.325-.016.051-.015.112.017.08.06l-.03.043a.753.753 0 00-.16.36.208.208 0 01-.109.159h-.002c-.073.038-.368.102-.6.293-.232.191-.716.349-.924.114-.209-.234-.378-.758-.468-1.148zm-.15-2.317c-.066.006-.12-.033-.192-.049-.082-.017-.133.008-.167-.037-.03-.047-.024-.09.023-.108.047-.018.08-.005.128-.014.097-.018.215-.128.302-.006.056.08.008.203-.095.213zm-.804 2.939c-.209-.14-.198-.32-.25-.5-.114-.378-.235-.835-.34-1.223-.063-.234-.079-.785.24-.785.162 0 .282.05.333.201.115.337-.1.278-.045.676.039.28.093.558.182 1.035.04.22.113.75-.082.621m-.653-5.426c.116-.314.328-.582.473-.771.132-.173.07-.401.002-.606-.044-.188-.165-.383-.184-.435-.014-.036-.014-.065-.003-.09l.025-.016.256-.022c.733-.093 1.379-.35 1.574-.459.096-.053.198-.096.302-.131.122-.041.249-.083.375-.1.096-.015.21-.03.306-.04.146-.017.374.084.324.114-.123.073-.692.204-1.193.8-.307.364-.378.59-.482.758-.104.168-.188.208-.335.335a.927.927 0 00-.291.393c-.073.206-.352.925-.389 2.065-.004.133-.027.273-.153.32l-.001.001c-.104.042-.187.11-.205.036-.066-.25-.22-.79-.284-1.133a6.919 6.919 0 00-.07-.321c-.07-.292-.102-.55-.047-.698zm2.227 2.774c-.133.085-.263.182-.363.246-.121.08-.291.004-.241-.165.024-.083.142-.294.338-.33a3.213 3.213 0 01.454-.056c.14-.006.155.106.06.164-.063.038-.16.086-.248.141zm.184.25c.035-.029.05-.03.171-.095.085-.047.183-.105.281-.169.179-.116.516-.235.66-.234.104.002.285.046.381.15.1.11.128.237-.003.215-.13-.022-.268-.057-.519 0-.28.064-.47.17-.605.231a.823.823 0 01-.324.077c-.045-.003-.171-.07-.042-.175zm2.067 2.471c.033.06.043.16.034.202-.01.051-.189.118-.338-.105a.538.538 0 01.01-.599c.14-.171.355-.047.324.016a.606.606 0 00-.03.486zm4.478-2.17c-.055.028-.262-.04-.32-.073-.114-.064-.196-.11-.35-.24-.102-.086-.289-.127-.465-.119-.135.007-.27.036-.373.06-.103.025-.11-.068-.08-.103.03-.035.174-.166.488-.247a.632.632 0 01.178-.004c.13.015.287.101.4.21.112.11.34.303.463.378.058.035.188.072.059.139zm-.128-.516s-.194-.132-.256-.239c-.03-.053-.024-.097.058-.098.29-.003.557-.01.687.098.094.08.096.244.05.351-.053.122-.16.087-.22.078-.062-.008-.32-.19-.32-.19zm1.456-.433c-.044.047-.083.019-.174.041-.07.017-.117.057-.183.051-.102-.009-.153-.132-.098-.212.085-.124.205-.016.301 0 .048.01.082-.005.13.012.047.017.054.06.024.108zm-8.376-5.597c.045-.068.152-.168.26-.245.113-.08.668-.495 1.184-.652.095-.028.12-.042.18-.057.078-.02.143-.186-.017-.21-.17-.025-.238-.014-.328-.01-.09.001-.133-.047-.068-.117.067-.071.186-.143.396-.228.46-.182 1.273-.279 1.652-.313.495-.042.555-.04.877-.016.302.022.538.079.65.098.568.103 1.223.365 1.805.683.306.181.601.383.876.597.833.647 1.79 1.88 1.651 4.474a2.724 2.724 0 01-.073.55c-.02.075-.12.203-.174.033-.172-.555-.393-1.533-.897-2.306-.07-.107-.179-.097-.168.016.004.047.027.542.015.638-.082.637.114.389.402 1.073.09.211.205.63.234.9.007.067.017.146.018.22.003.096-.045.103-.045.103-.198-.001-.542-.094-.728-.1-.21-.007-1.677-.022-2.228.021-.551.042-.852.24-1.164.494a.982.982 0 01-.167.103.106.106 0 01-.067.01 4.425 4.425 0 01-.131-.026.917.917 0 00-.43.002c-.13.039-.193.072-.334-.01-.202-.117-.513-.588-1.595-.596-.613-.005-1.418-.013-1.891.007-.154.007-.233.024-.273.023-.003-.018-.004-.043-.004-.047-.008-.862.556-.671.62-.895.162-.558.2-1.9 1.177-2.723.467-.394.71-.41 1.144-.41.467 0 .924.122 1.156.236.185.091.277.152.35.099.073-.055.267-.23.347-.291.081-.062.05-.158-.026-.22-.073-.06-.766-.929-1.83-1.104-.243-.04-.423-.077-.644-.078a2.749 2.749 0 00-.504.029c-.406.05-.939.275-1.281.41-.019-.02.052-.134.073-.165zm-.35 12.082c.01.444.269 1.619 1.766 2.734.624.464.91.674.993.73v.004c.04.029-.222.022-.294.029-.117.011-.516-.025-.836.034-.288.053-.25.122-.278.33-.023.165-.001.426-.01.648-.008.223-.02.381.074.489.093.106.152.122.548.098.376-.023 1.418-.024 1.544-.05.161-.032.135.026.042.225-.16.34-.678 1.901-1.485 3.384-.113.208.205.11.477.24.49.236.474.302.603.056.14-.267.848-1.927.957-2.44.014-.067.043-.125.054-.024.008.072.018 2.17-.04 2.831a.123.123 0 00.03.097.268.268 0 00.134.062c.245-.08.54-.14.79-.1a.322.322 0 00.064-.013.137.137 0 00.034-.04.432.432 0 00.039-.114l.001-.01a1.632 1.632 0 00.037-.27 4.79 4.79 0 00.01-.29 10.16 10.16 0 00-.001-.386c-.001-.075-.003-.05-.005-.124a12.667 12.667 0 00-.021-.49 15.256 15.256 0 00-.177-1.616c-.015-.087-.031-.124-.05-.21a7.293 7.293 0 00-.118-.488 5.076 5.076 0 00-.058-.186.637.637 0 01-.018-.106c.006-.03.045-.008.087-.017l.031-.005c.268-.036.734-.012.84-.008.103.003.633.053.783.067.148.014.328.048.32-.4-.002-.12-.002-.19-.002-.302v-.046-.083l.002-.047v-.045-.04l.003-.07v-.019c0-.016 0-.03.002-.045v-.02l.003-.032v-.01a1.2 1.2 0 00.003-.044c.003-.11-.011-.31-.22-.364-.239-.06-.66-.074-1.038-.04-.053.004-.065 0-.049-.015v-.004c.082-.058.63-.359 1.255-.917.688-.615 1.017-.942 1.227-1.387 0 0 .753-1.456.715-2.69-.007-.249.033-.228.188-.224.047.002.225-.01.32-.074.32-.072.603-1.16.603-1.16s.48-1.65.596-2.325c.103-.6.079-.951-.29-1.13l-.06-.034a.069.069 0 01-.033-.079.835.835 0 00.018-.078c.18-.622.5-1.409.428-1.728-.013-.092-.09-.121-.118-.14a.901.901 0 01-.22-.295.197.197 0 01-.009-.05c-.102-1.175-.52-2.648-1.768-3.932-.002 0-.086-.077-.137-.124a5.738 5.738 0 00-.4-.333 6.494 6.494 0 00-1.145-.709 6.012 6.012 0 00-1.058-.354 4.433 4.433 0 00-.558-.111 5.679 5.679 0 00-1.22-.064 9.19 9.19 0 01-.128.006l-.079.003-.088.003a3.96 3.96 0 00-.338.036c-.204.03-.423.07-.558.102-.151.037-.355.079-.609.151-.104.03-.209.063-.314.097l-.088.028a13.38 13.38 0 00-.34.116c-.084.03-.437.182-.514.217a3.468 3.468 0 01-.143.061c-.25.079-.302.222-.31.301a.477.477 0 01-.04.147c-.359.76-1.204.835-1.539.851-.087.004-.165.017-.137.102.072.218.467.626.708.7-.003.035-.207.079-.25.09-.097.025-.497-.01-.517-.006h-.005c-.452.039-.59.347-.632.493a.163.163 0 00.02.133c.1.153.206.277.286.478l.002.006c.02.053.04.111.056.177.01.086.079.175-.008.344-.155.3-.542.393-.6.69-.082.422.064.699.224 1.397.11.478.23.973.314 1.197a.02.02 0 01-.015.027 1.495 1.495 0 00-.113.025c-.224.09-.294.265-.32.609-.056.76.508 1.933.682 2.938.059.34.216.883.477 1.106.06.051.186.084.264.097.204.036.292-.093.304.111.003.043.017.157.019.222.035.722.423 1.438.423 1.438z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kfc-icon_svg__clip0_20_1847"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.568 4.736)",
    d: "M0 0h12.864v24H0z"
  })))));
}

var _path$5, _path2$3, _path3$2, _path4$2, _path5, _path6, _path7, _path8, _path9;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function SvgTbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#501098",
    d: "M1 1.894h30v30H1z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#501098",
    strokeWidth: 2,
    d: "M1 1.894h30v30H1z"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.807 15.28a10.127 10.127 0 10-20.247 0v7.876a.333.333 0 00.333.333H25.48a.333.333 0 00.326-.333V15.28z",
    fill: "#fff"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.728 14.907c-.346-.853-3.296-.213-7.404 1.997-4.108 2.21-6.385 4.66-6.025 5.386.36.726 4.494.233 7.803-1.598 4.494-2.483 6.052-4.713 5.626-5.779",
    fill: "#501098"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.075 21.111a2.515 2.515 0 01-1.817-.726 17.977 17.977 0 014.028-2.882c.154.327.24.683.253 1.045a2.517 2.517 0 01-2.464 2.563z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73 22.936c.222.234.502.404.812.493l.107.04H5.892a.333.333 0 01-.333-.333v-7.85a10.113 10.113 0 014.222-8.23l-.12.14a1.025 1.025 0 00-.067 1.112c.107.293-.22.666-.386.82a5.593 5.593 0 00-1.551 3.788c.008 1.378.212 2.747.606 4.068.107.438.183.883.226 1.331.666-.552 1.332-1.091 2.057-1.584 1.139-.746 2.058-1.332 2.863-1.738 1.811-.972 2.277-.865.846 0a24.553 24.553 0 00-3.762 2.663c-3.702 3.33-3.15 4.987-2.763 5.38M25.805 23.162a.333.333 0 01-.327.333h-12.81l.187-.04a20.168 20.168 0 005.652-2.17c3.955-2.045 6.552-4.662 7.238-6.619l.033-.087a.403.403 0 010 .087v8.496",
    fill: "#501098"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.259 6.171a10.12 10.12 0 0114.201 6.485 1.625 1.625 0 00-.506-.306 5.725 5.725 0 00-1.098-.3 5.993 5.993 0 01-1.998-.539c-1.291-.706-3.01-3.728-5.759-4.527a5.946 5.946 0 00-2.743-.154c-.226.04-.666.087-.845-.126-.327-.426-.573-.666-1.08-.586l-.192.053",
    fill: "#9E7FBA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.906 26.095h-2.35v.576h.84v2.17h.668v-2.17h.842v-.576zM8.586 26.095l-1.17 2.744h.708l.152-.4h1.091l.15.4h.741l-1.121-2.744h-.551zm-.101 1.797l.356-.974.334.974h-.69zM11.542 28.27c-.441 0-.69-.338-.69-.803 0-.464.257-.806.713-.806a.632.632 0 01.55.297l.54-.388a1.312 1.312 0 00-1.09-.521c-.927 0-1.416.633-1.416 1.418 0 .786.487 1.425 1.408 1.425a1.44 1.44 0 001.15-.498l-.555-.412a.718.718 0 01-.61.288z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.147 26.048a1.42 1.42 0 101.402 1.419 1.354 1.354 0 00-1.402-1.419zm0 2.217c-.444 0-.703-.338-.703-.798s.26-.806.703-.806c.443 0 .698.34.698.806 0 .467-.26.792-.698.792v.006zM18.095 27.353a.63.63 0 00.395-.634c0-.424-.334-.672-.988-.672h-1.094v2.844h1.236c.724 0 1.074-.264 1.074-.818a.698.698 0 00-.623-.72zm-1.037-.752h.273c.332 0 .468.068.468.271 0 .204-.131.298-.392.298h-.35v-.57zm.41 1.7h-.41v-.591h.424c.37 0 .527.081.527.297 0 .217-.12.294-.54.294zM19.685 27.743h1.203v-.578h-1.203v-.52h1.442v-.598h-2.133v2.847h2.166v-.598h-1.475v-.553zM22.19 26.047H21.5v2.847h1.95v-.598H22.19v-2.249zM24.477 26.047h-.692v2.847h1.95v-.598h-1.258v-2.249zM26.404 28.296l-.094.184-.092-.184h-.042v.304h.042v-.218l.072.144h.04l.074-.144v.218h.04v-.304h-.04zM25.911 28.334h.086v.266h.041v-.267h.086v-.037h-.213v.038z",
    fill: "#fff"
  })));
}

var getPromoQty = function getPromoQty(promoItem, product) {
  return promoItem.promoId === product.providerData.PromoId && product.count.current;
};
var CartUnitPrice = function CartUnitPrice(_ref) {
  var promoItem = _ref.promoItem,
    unitPrice = _ref.unitPrice,
    t = _ref.t,
    formatPrice = _ref.formatPrice;
  var formattedPrice = t('cartProductUnitPriceEach', {
    price: formatPrice({
      price: unitPrice
    })
  });
  if (promoItem) {
    if (unitPrice) {
      return /*#__PURE__*/jsxRuntime.jsx("span", {
        children: formattedPrice
      });
    }
    return null;
  }
  return /*#__PURE__*/jsxRuntime.jsx("span", {
    children: formattedPrice
  });
};
var CartProduct = function CartProduct(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? null : _ref2$product,
    _ref2$changeText = _ref2.changeText,
    changeText = _ref2$changeText === void 0 ? 'Change' : _ref2$changeText,
    _ref2$removeText = _ref2.removeText,
    removeText = _ref2$removeText === void 0 ? 'Remove' : _ref2$removeText,
    _ref2$onEditProductHa = _ref2.onEditProductHandler,
    onEditProductHandler = _ref2$onEditProductHa === void 0 ? function () {
      return function () {};
    } : _ref2$onEditProductHa,
    _ref2$formatPrice = _ref2.formatPrice,
    formatPrice = _ref2$formatPrice === void 0 ? function () {} : _ref2$formatPrice,
    _ref2$t = _ref2.t,
    t = _ref2$t === void 0 ? function () {} : _ref2$t,
    _ref2$showEnergyInfor = _ref2.showEnergyInformation,
    showEnergyInformation = _ref2$showEnergyInfor === void 0 ? false : _ref2$showEnergyInfor,
    _ref2$showAddonAvaila = _ref2.showAddonAvailability,
    showAddonAvailability = _ref2$showAddonAvaila === void 0 ? false : _ref2$showAddonAvaila,
    _ref2$disableModifyUp = _ref2.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref2$disableModifyUp === void 0 ? false : _ref2$disableModifyUp,
    _ref2$isCouponQuantit = _ref2.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref2$isCouponQuantit === void 0 ? false : _ref2$isCouponQuantit,
    _ref2$hideDisabledBut = _ref2.hideDisabledButtons,
    hideDisabledButtons = _ref2$hideDisabledBut === void 0 ? false : _ref2$hideDisabledBut,
    _ref2$RewardPointsCom = _ref2.RewardPointsComponent,
    RewardPointsComponent = _ref2$RewardPointsCom === void 0 ? null : _ref2$RewardPointsCom,
    _ref2$hideNoPrefixWhe = _ref2.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref2$hideNoPrefixWhe === void 0 ? false : _ref2$hideNoPrefixWhe,
    _ref2$hideComboProduc = _ref2.hideComboProductsUnitPrice,
    hideComboProductsUnitPrice = _ref2$hideComboProduc === void 0 ? false : _ref2$hideComboProduc,
    _ref2$alignButtons = _ref2.alignButtons,
    alignButtons = _ref2$alignButtons === void 0 ? false : _ref2$alignButtons;
  var _useAnalytics = jitsu.useAnalytics(),
    productRemovedTrack = _useAnalytics.productRemovedTrack,
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    embeddedErrorTrack = _useAnalytics.embeddedErrorTrack;
  validation$1.validate({
    name: 'CartProduct',
    parameters: {
      product: product
    }
  });
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  var _useProductCustomisat = useProductCustomisations(),
    formatAllergens = _useProductCustomisat.formatAllergens;
  var promoItem = getPromoItem({
    productId: product == null ? void 0 : product.productId
  });
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var addedUpsells = recoil.useRecoilValue(atoms.addedUpsellState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var title = product.title,
    name = product.name,
    price = product.price,
    options = product.options,
    _product$customisatio = product.customisations,
    customisations = _product$customisatio === void 0 ? [] : _product$customisatio,
    _product$isAvailable = product.isAvailable,
    isAvailable = _product$isAvailable === void 0 ? true : _product$isAvailable,
    removeAll = product.removeAll,
    _product$editDisabled = product.editDisabled,
    editDisabled = _product$editDisabled === void 0 ? false : _product$editDisabled,
    _product$count = product.count,
    count = _product$count === void 0 ? {} : _product$count,
    _product$filterName = product.filterName,
    filterName = _product$filterName === void 0 ? {} : _product$filterName,
    _product$isBag = product.isBag,
    isBag = _product$isBag === void 0 ? false : _product$isBag,
    _product$type = product.type,
    type = _product$type === void 0 ? '' : _product$type,
    _product$allergens = product.allergens,
    allergens = _product$allergens === void 0 ? [] : _product$allergens,
    _product$dualBrand = product.dualBrand,
    dualBrand = _product$dualBrand === void 0 ? '' : _product$dualBrand,
    _product$calculatedEn = product.calculatedEnergyInformation,
    calculatedEnergyInformation = _product$calculatedEn === void 0 ? '' : _product$calculatedEn;
  var currentPrice = price.current,
    unitPrice = price.unit;
  var shouldRenderCartProductChangeButton = !hideDisabledButtons || hideDisabledButtons && !(!isAvailable || editDisabled);
  var shouldRenderButtonsBag = !isBag;
  React.useEffect(function () {
    if (!isAvailable) {
      embeddedErrorTrack(kioskSettings.kiosk, t('cartProductUnavailableGeneral'), 'cart');
    }
  }, [isAvailable, product, kioskSettings.kiosk, t, embeddedErrorTrack]);
  var hasAllergens = allergens.length > 0;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "cart-product",
    className: "cart-product flex flex-col justify-between rounded shadow-lg p-2 md:p-4 w-full " + (!isAvailable && 'bg-red-100') + " bg-white",
    children: [!isAvailable && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex items-center justify-center space-x-4 text-4xl text-center text-red-600",
      children: [/*#__PURE__*/jsxRuntime.jsx(Ban, {
        className: "w-auto h-12"
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "cart-product-unavailable-text",
        children: t('cartProductUnavailableGeneral')
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-row w-full p-2 md:p-4",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex items-center w-1/2 my-2 mr-2",
        children: [dualBrand === 'KFC' && /*#__PURE__*/jsxRuntime.jsx(SvgKfcIcon, {
          className: "overflow-visible mr-4"
        }), dualBrand === 'TB' && /*#__PURE__*/jsxRuntime.jsx(SvgTbIcon, {
          className: "overflow-visible mr-4"
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "text-2xl font-bold md:text-4xl",
          "data-test": "cart-product-name",
          children: (promoItem == null ? void 0 : promoItem.name) || title || (filterName == null ? void 0 : filterName.text) || name.text
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-center justify-center w-1/2 my-2 sm:flex-row",
        children: [shouldRenderButtonsBag && /*#__PURE__*/jsxRuntime.jsx(QuantityControllerButtons, {
          product: product,
          className: "quantity-controller-cart",
          disableModifyUpsellOnCart: disableModifyUpsellOnCart,
          isCouponQuantityDisabled: isCouponQuantityDisabled,
          onQtyUpdate: function onQtyUpdate(qty) {
            if (qty < 1) {
              productRemovedTrack(product, count.current + qty, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
            } else {
              var categoryName = product != null && product.isUpsell ? 'cart' : currentCategory;
              productAddedToCartTrack(_extends({}, product, {
                count: {
                  current: count.current + qty
                }
              }), kioskSettings.kiosk, couponNumber, categoryName);
            }
          }
        }), /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-col items-end ml-0 md:ml-auto cart-product-total",
          children: [promoItem != null && promoItem.pointsCost ? /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
            pointsCost: (promoItem == null ? void 0 : promoItem.pointsCost) * getPromoQty(promoItem, product)
          }) : /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "text-2xl font-bold md:text-4xl",
            "data-test": "cart-product-total",
            children: formatPrice({
              price: currentPrice
            })
          }), showEnergyInformation && calculatedEnergyInformation && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "text-2xl font-bold",
            "data-test": "cart-product-energy-information",
            children: calculatedEnergyInformation
          })]
        })]
      })]
    }), hasAllergens && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "text-3xl flex flex-col justify-between p-2 md:p-4 pt-0",
      children: /*#__PURE__*/jsxRuntime.jsx("p", {
        children: t('allergensMessage', {
          allergens: allergens.map(function (allerger) {
            return formatAllergens(allerger);
          }).join(', ')
        })
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col justify-between p-2 md:p-4 pt-0\n          " + (alignButtons ? 'sm:flex-row' : showAddonAvailability ? 'sm:flex-col' : 'sm:flex-row') + "\n        ",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col w-full",
        children: [hideComboProductsUnitPrice && type === 'combo' ? /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {}) : /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "pb-2 text-2xl md:pb-4 md:text-3xl",
          "data-test": "cart-product-unit-price",
          children: /*#__PURE__*/jsxRuntime.jsx(CartUnitPrice, {
            t: t,
            promoItem: promoItem,
            unitPrice: unitPrice,
            formatPrice: formatPrice
          })
        }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
          customisations: customisations,
          t: t,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
        }), /*#__PURE__*/jsxRuntime.jsx(ProductOptionsReadonly, {
          options: options,
          t: t,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex custom-modal-actions items-modal-actions space-y-modal-actions-none space-x-modal-actions max-h-modal-actions\n            " + (alignButtons ? 'flex-col items-stretch space-y-4' : showAddonAvailability ? 'flex-row justify-center items-center space-x-4 pb-4 py-8' : 'flex-col items-stretch space-y-4') + "\n          ",
        children: [shouldRenderButtonsBag && shouldRenderCartProductChangeButton && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "edit-button py-small-secondary-button footer-action-button",
          "data-test": "cart-product-change-button",
          disabled: !isAvailable || editDisabled,
          onClick: onEditProductHandler(product),
          children: changeText
        }), shouldRenderButtonsBag && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "remove-button py-small-secondary-button footer-action-button",
          "data-test": "cart-product-remove-button",
          disabled: isBag,
          onClick: function onClick() {
            removeAll();
            productRemovedTrack(product, count.current, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
          },
          children: removeText
        })]
      })]
    })]
  });
};

function handleChangeMenuBrandStateTheme(dualBrand, menuBrand, setMenuBrand) {
  if (!dualBrand) return;
  if (dualBrand !== menuBrand) {
    setMenuBrand(dualBrand);
  }
  if (dualBrand === 'KFC') {
    document.documentElement.classList.remove('tb-theme');
  } else {
    document.documentElement.classList.add('tb-theme');
  }
}

var useMiniCartModal = function useMiniCartModal(_ref) {
  var _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useAnalytics = jitsu.useAnalytics(),
    cartItemEditTrack = _useAnalytics.cartItemEditTrack;
  var _useRestaurantSeconda = useRestaurantSecondaryCart(),
    total = _useRestaurantSeconda.total,
    formattedSecondaryCart = _useRestaurantSeconda.formattedSecondaryCart,
    secondaryCartUpdateCount = _useRestaurantSeconda.secondaryCartUpdateCount,
    isSecondaryCartEvaluated = _useRestaurantSeconda.isSecondaryCartEvaluated,
    formattedPush = _useRestaurantSeconda.formattedPush,
    pull = _useRestaurantSeconda.pull,
    resetSecondaryCart = _useRestaurantSeconda.resetSecondaryCart;
  var _useOrigin = useOrigin(),
    setOrigin = _useOrigin.setOrigin;
  var history = reactRouterDom.useHistory();
  var _useState = React.useState(false),
    shouldConfirm = _useState[0],
    setShouldConfirm = _useState[1];
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var upsellsRemoved = recoil.useRecoilValue(atoms.removedUpsellState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var _useRecoilState = recoil.useRecoilState(atoms.menuBrandState),
    menuBrand = _useRecoilState[0],
    setMenuBrand = _useRecoilState[1];
  var onEditProductHandler = function onEditProductHandler(product) {
    return function () {
      var _product$type = product.type,
        type = _product$type === void 0 ? '' : _product$type,
        _product$uid = product.uid,
        uid = _product$uid === void 0 ? '' : _product$uid,
        _product$dualBrand = product.dualBrand,
        dualBrand = _product$dualBrand === void 0 ? '' : _product$dualBrand;
      handleChangeMenuBrandStateTheme(dualBrand, menuBrand, setMenuBrand);
      cartItemEditTrack(kioskSettings.kiosk);
      setOrigin(origin);
      switch (type) {
        case 'combo':
          onClose({
            updatedStaged: product,
            clearOrigin: false
          });
          return history.push("/product/" + product.productId + "/combo/" + product.id + "/cart/" + uid);
        case 'customise':
          return onClose({
            updatedStaged: product,
            clearOrigin: false
          });
        default:
          onClose({
            clearOrigin: false
          });
          return history.push("/product/" + product.productId);
      }
    };
  };
  var onClose = React.useCallback(function (_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
      updatedStaged = _ref2.updatedStaged,
      _ref2$clearOrigin = _ref2.clearOrigin,
      clearOrigin = _ref2$clearOrigin === void 0 ? true : _ref2$clearOrigin;
    if (clearOrigin) setOrigin(null);
    if (!shouldConfirm) formattedPush();
    resetSecondaryCart();
    onCloseCallback({
      updatedStaged: updatedStaged
    });
  }, [onCloseCallback, formattedPush, resetSecondaryCart, setOrigin, shouldConfirm]);
  var onConfirm = React.useCallback(function () {
    setOrigin(null);
    formattedPush();
    setShouldConfirm(true);
    resetSecondaryCart();
  }, [formattedPush, resetSecondaryCart, setOrigin]);
  React.useEffect(function () {
    if (!shouldConfirm) return;
    if (!isSecondaryCartEvaluated) return;
    onConfirmCallback();
  }, [isSecondaryCartEvaluated, onConfirmCallback, shouldConfirm]);
  React.useEffect(function () {
    if (formattedSecondaryCart.length) return;
    // if upsells are being removed, do not pull products from main cart as
    // this will put the removed upsell back to secondary cart
    if (upsellsRemoved.length) return;
    // prevents pulling cart to secondary when completing in mini-cart modal
    if (!shouldConfirm) pull();
  }, [pull, formattedSecondaryCart, upsellsRemoved, shouldConfirm]);
  React.useEffect(function () {
    if (!secondaryCartUpdateCount && !upsellsRemoved.length) return;
    if (!formattedSecondaryCart) return;
    if (formattedSecondaryCart.length) return;
    onClose();
  }, [formattedSecondaryCart, onCloseCallback, onClose, secondaryCartUpdateCount, upsellsRemoved]);
  return {
    t: t,
    onEditProductHandler: onEditProductHandler,
    formattedSecondaryCart: formattedSecondaryCart,
    total: total,
    onConfirm: onConfirm,
    onClose: onClose,
    formatPrice: formatPrice
  };
};

var MiniCartModal = function MiniCartModal(_ref) {
  var _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    _ref$disableModifyUps = _ref.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref$disableModifyUps === void 0 ? false : _ref$disableModifyUps,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity,
    _ref$hideDisabledButt = _ref.hideDisabledButtons,
    hideDisabledButtons = _ref$hideDisabledButt === void 0 ? false : _ref$hideDisabledButt;
  var _useMiniCartModal = useMiniCartModal({
      origin: origin,
      onCloseCallback: onCloseCallback,
      onConfirmCallback: onConfirmCallback
    }),
    t = _useMiniCartModal.t,
    onEditProductHandler = _useMiniCartModal.onEditProductHandler,
    formattedSecondaryCart = _useMiniCartModal.formattedSecondaryCart,
    total = _useMiniCartModal.total,
    onClose = _useMiniCartModal.onClose,
    onConfirm = _useMiniCartModal.onConfirm,
    formatPrice = _useMiniCartModal.formatPrice;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
      title: t('cartTitle'),
      total: total
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "mini-cart-modal",
      id: "mini-cart-modal",
      className: "max-h-full p-2 space-y-8 overflow-y-auto md:p-8 overscroll-auto",
      children: formattedSecondaryCart && formattedSecondaryCart.map(function (product, i) {
        return /*#__PURE__*/jsxRuntime.jsx(CartProduct, {
          product: product,
          t: t,
          onEditProductHandler: onEditProductHandler,
          changeText: t('cartChangeAction'),
          removeText: t('cartRemoveAction'),
          formatPrice: formatPrice,
          disableModifyUpsellOnCart: disableModifyUpsellOnCart,
          isCouponQuantityDisabled: isCouponQuantityDisabled,
          hideDisabledButtons: hideDisabledButtons
        }, "cart-product-" + i);
      })
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      action: onConfirm,
      actionText: t('miniCartNextAction'),
      closeModal: onClose,
      closeText: t('miniCartCloseAction')
    })]
  });
};

var LoyaltyOffersView = function LoyaltyOffersView() {
  var _useLoyaltyOffersView = useLoyaltyOffersView(),
    t = _useLoyaltyOffersView.t,
    loading = _useLoyaltyOffersView.loading,
    menuState = _useLoyaltyOffersView.menuState,
    originPath = _useLoyaltyOffersView.originPath,
    formatPrice = _useLoyaltyOffersView.formatPrice,
    showPriceWarning = _useLoyaltyOffersView.showPriceWarning,
    formattedProducts = _useLoyaltyOffersView.formattedProducts,
    showMiniCartModal = _useLoyaltyOffersView.showMiniCartModal,
    displayDescription = _useLoyaltyOffersView.displayDescription,
    galleryMaxColumns = _useLoyaltyOffersView.galleryMaxColumns,
    hideDisabledButtons = _useLoyaltyOffersView.hideDisabledButtons,
    onCloseMiniCartModal = _useLoyaltyOffersView.onCloseMiniCartModal,
    showAddonAvailability = _useLoyaltyOffersView.showAddonAvailability,
    onConfirmMiniCartModal = _useLoyaltyOffersView.onConfirmMiniCartModal,
    disableModifyUpsellOnCart = _useLoyaltyOffersView.disableModifyUpsellOnCart,
    showEnergyInformationSeparated = _useLoyaltyOffersView.showEnergyInformationSeparated;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(Modal, {
      open: showMiniCartModal,
      formatPrice: formatPrice,
      children: /*#__PURE__*/jsxRuntime.jsx(MiniCartModal, {
        onCloseCallback: onCloseMiniCartModal,
        onConfirmCallback: onConfirmMiniCartModal,
        origin: originPath,
        showPriceWarning: showPriceWarning,
        disableModifyUpsellOnCart: disableModifyUpsellOnCart,
        hideDisabledButtons: hideDisabledButtons
      })
    }), loading /*|| !ready */ &&
    /*#__PURE__*/
    // TODO
    jsxRuntime.jsx("div", {
      className: "flex flex-col items-center justify-center h-full p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Loading, {})
    }), !menuState &&
    /*#__PURE__*/
    // TODO
    jsxRuntime.jsx("div", {
      className: "flex flex-col items-center justify-center h-full p-8",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        message: 'Error'
      })
    }), menuState &&
    /*#__PURE__*/
    // TODO
    jsxRuntime.jsx(Gallery, {
      descriptive: displayDescription,
      items: formattedProducts,
      showEnergyInformationSeparated: showEnergyInformationSeparated,
      galleryCardClassName: 'gallery-card-category',
      formatPrice: formatPrice,
      maxColumns: galleryMaxColumns,
      showAddonAvailability: showAddonAvailability,
      t: t
    })]
  });
};

var formatModalAccessibilityClass = function formatModalAccessibilityClass(accessibilityEnabled) {
  return accessibilityEnabled ? 'h-full bottom-0 left-0 right-0' : 'inset-0';
};

var LoyaltyLoginViewContext = /*#__PURE__*/React.createContext();
var LoyaltyLoginViewProvider = function LoyaltyLoginViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$qrLoginEnabled = _ref.qrLoginEnabled,
    qrLoginEnabled = _ref$qrLoginEnabled === void 0 ? false : _ref$qrLoginEnabled;
  var history = reactRouterDom.useHistory();
  var _useStage = cart.useStage(),
    stage = _useStage.stage,
    staged = _useStage.staged;
  var _useCart = cart.useCart(),
    commit = _useCart.commit;
  var _useRestaurantMenu = useRestaurantMenu(),
    products = _useRestaurantMenu.products;
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var _useRecoilState = recoil.useRecoilState(atoms.offersAndRewardsState),
    setOffersAndRewards = _useRecoilState[1];
  var settings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var previousPathFromState = state.from;
  var previousPath = state.from === '/home' ? '/reset' : state.from;

  //TODO manage this in portal eventually???
  var loyaltyLoginCodeLength = 6;
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var loyaltyOffersEnabled = utilities.useSettingsAtPath({
    path: 'settings.loyalty.enablePromos',
    defaultValue: false
  });
  var loyaltyRewardsEnabled = utilities.useSettingsAtPath({
    path: 'settings.loyalty.enablePromosWithPoints',
    defaultValue: false
  });
  var signInCartResumeEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.signInCartResume',
    defaultValue: false
  });
  var loyalStoreId = utilities.useSettingsAtPath({
    path: 'settings.loyalty.integrationStoreId',
    defaultValue: ''
  });
  var baseNextPath = previousPathFromState === '/home' || previousPathFromState === '/app-download' ? '/categories' : state.from;
  var nextPath = beaconEnabled ? '/beacon' : baseNextPath;
  var notAMemberPath = '/app-download';
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _useState = React.useState(''),
    loyaltyLoginCode = _useState[0],
    setLoyaltyLoginCode = _useState[1];
  var loyaltyLoginPayload = recoil.useRecoilValue(atoms.formattedLoyaltyPayloadState());
  var _useRecoilState2 = recoil.useRecoilState(atoms.loyaltyState),
    loyaltyUser = _useRecoilState2[0],
    setLoyalty = _useRecoilState2[1];
  var _useState2 = React.useState(''),
    loginMachineStatus = _useState2[0],
    setLoginMachineStatus = _useState2[1];
  var resetMachine = React.useCallback(function () {
    setLoginMachineStatus('');
  }, [setLoginMachineStatus]);
  var handleOffersAndRewardsResponse = React.useCallback(function (machine) {
    var value = machine.value,
      _machine$context = machine.context,
      _machine$context2 = _machine$context === void 0 ? {} : _machine$context,
      data = _machine$context2.data;
    if (value !== 'success') {
      return;
    }
    var offersAndRewards = data;
    if (!loyaltyOffersEnabled) {
      offersAndRewards = _extends({}, offersAndRewards, {
        promos: []
      });
    }
    if (!loyaltyRewardsEnabled) {
      offersAndRewards = _extends({}, offersAndRewards, {
        promosWithPoints: []
      });
    }
    setOffersAndRewards(offersAndRewards);
  }, [setOffersAndRewards, loyaltyOffersEnabled, loyaltyRewardsEnabled]);
  var calledQrLogin = React.useRef(false);
  var controller = React.useRef(new AbortController()); // Move the controller to useRef

  // Track user navigation away from the page
  React.useEffect(function () {
    var currentController = controller.current;
    return function () {
      if (calledQrLogin.current) {
        currentController.abort();
      }
    };
  }, []);
  var handleQrLoyaltyResponse = React.useCallback(function (res) {
    return function (machine) {
      var value = machine.value,
        _machine$context3 = machine.context,
        _machine$context4 = _machine$context3 === void 0 ? {} : _machine$context3,
        data = _machine$context4.data;
      if (value === 'processing') return setLoginMachineStatus('qr-waiting');
      if (value !== 'success') {
        setLoginMachineStatus('failed');
        return void res(false);
      }
      setLoginMachineStatus('success');
      var _ref2 = data || {},
        _ref2$customer = _ref2.customer,
        customer = _ref2$customer === void 0 ? {} : _ref2$customer,
        token = _ref2.token,
        _ref2$transaction = _ref2.transaction,
        _ref2$transaction2 = _ref2$transaction === void 0 ? {} : _ref2$transaction,
        id = _ref2$transaction2.id,
        points = _ref2$transaction2.points,
        cartItems = _ref2.cartItems;
      jitsu.setLoyaltyLoginSuccessTrack({
        transactionId: id,
        customerId: customer.id
      });
      setLoyalty({
        transactionId: id,
        customerId: customer.id,
        name: customer.name,
        points: points,
        token: token,
        cartItems: cartItems
      });
      if (loyaltyOffersEnabled || loyaltyRewardsEnabled) {
        fmApi.doLoyaltyOffersAndRewards({
          token: token,
          storeId: loyalStoreId,
          transition: handleOffersAndRewardsResponse
        });
      }
      res(true);
    };
  }, [setLoyalty, setLoginMachineStatus, handleOffersAndRewardsResponse, loyaltyOffersEnabled, loyaltyRewardsEnabled, loyalStoreId]);
  React.useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (qrLoginEnabled) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return new Promise(function (res) {
                fmApi.doLoyaltyQrLogIn({
                  payload: _extends({}, loyaltyLoginPayload),
                  transition: handleQrLoyaltyResponse(res),
                  abortSignal: controller.current.signal
                });
              });
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();
    if (loyaltyLoginPayload.sessionId && !calledQrLogin.current) {
      calledQrLogin.current = true;
      fetchData();
    }
  }, [loyaltyLoginPayload.sessionId, qrLoginEnabled, loyaltyLoginPayload, handleQrLoyaltyResponse]);
  var handleLoyaltyResponse = React.useCallback(function (res) {
    return function (machine) {
      var value = machine.value,
        _machine$context5 = machine.context,
        _machine$context6 = _machine$context5 === void 0 ? {} : _machine$context5,
        data = _machine$context6.data;
      if (value === 'processing') return setLoginMachineStatus(value);
      if (value !== 'success') {
        setLoginMachineStatus('failed');
        setLoyaltyLoginCode('');
        jitsu.setLoyaltyLoginFailTrack();
        return void res(false);
      }
      setLoginMachineStatus('success');
      var _ref4 = data || {},
        _ref4$customer = _ref4.customer,
        customer = _ref4$customer === void 0 ? {} : _ref4$customer,
        token = _ref4.token,
        _ref4$transaction = _ref4.transaction,
        _ref4$transaction2 = _ref4$transaction === void 0 ? {} : _ref4$transaction,
        id = _ref4$transaction2.id,
        points = _ref4$transaction2.points,
        cartItems = _ref4.cartItems;
      jitsu.setLoyaltyLoginSuccessTrack({
        transactionId: id,
        customerId: customer.id
      });
      setLoyalty({
        transactionId: id,
        customerId: customer.id,
        name: customer.name,
        points: points,
        token: token,
        cartItems: cartItems
      });
      if (loyaltyOffersEnabled || loyaltyRewardsEnabled) {
        fmApi.doLoyaltyOffersAndRewards({
          token: token,
          storeId: loyalStoreId,
          transition: handleOffersAndRewardsResponse
        });
      }
      res(true);
    };
  }, [setLoyalty, setLoginMachineStatus, handleOffersAndRewardsResponse, loyaltyOffersEnabled, loyaltyRewardsEnabled, loyalStoreId]);
  React.useEffect(function () {
    if (!signInCartResumeEnabled) return;
    if (!(loyaltyUser != null && loyaltyUser.cartItems)) return;
    if ((loyaltyUser == null ? void 0 : loyaltyUser.cartItems.length) === 0) return;
    var cartItems = loyaltyUser.cartItems;
    cartItems.forEach(function (cartItem) {
      var _cartItem$offerId = cartItem.offerId,
        offerId = _cartItem$offerId === void 0 ? null : _cartItem$offerId,
        _cartItem$rewardId = cartItem.rewardId,
        rewardId = _cartItem$rewardId === void 0 ? null : _cartItem$rewardId;
      if (offerId) {
        var product = products == null ? void 0 : products.find(function (product) {
          return parseInt(product.providerData.PromoId) === parseInt(cartItem.offerId);
        });
        var option = product == null ? void 0 : product.options[0];
        if (option && loyaltyOffersEnabled) {
          stage({
            product: _extends({}, product, option, {
              name: product.name,
              filterName: option.name,
              imageUrl: product == null ? void 0 : product.imageUrl
            })
          });
        }
      }
      if (rewardId) {
        var _product = products == null ? void 0 : products.find(function (product) {
          return parseInt(product.providerData.PromoId) === parseInt(cartItem.rewardId);
        });
        var _option = _product == null ? void 0 : _product.options[0];
        if (_option && loyaltyRewardsEnabled) {
          stage({
            product: _extends({}, _product, _option, {
              name: _product.name,
              filterName: _option.name,
              imageUrl: _product == null ? void 0 : _product.imageUrl
            })
          });
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loyaltyUser, products]);
  React.useEffect(function () {
    if (staged) commit({
      staged: staged
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staged]);
  var onConfirmCode = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(loyaltyLoginCode.length < 6)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", false);
        case 2:
          _context2.next = 4;
          return new Promise(function (res) {
            fmApi.doLoyaltyLogIn({
              payload: _extends({}, loyaltyLoginPayload, {
                code: loyaltyLoginCode
              }),
              transition: handleLoyaltyResponse(res)
            });
          });
        case 4:
          return _context2.abrupt("return", _context2.sent);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [loyaltyLoginCode, loyaltyLoginPayload, handleLoyaltyResponse]);
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var available = {
    resetMachine: resetMachine,
    loginMachineStatus: loginMachineStatus,
    loyaltyLoginCode: loyaltyLoginCode,
    setLoyaltyLoginCode: setLoyaltyLoginCode,
    onConfirmCode: onConfirmCode,
    previousPath: previousPath,
    setTemplate: setTemplate,
    nextPath: nextPath,
    history: history,
    loyaltyUser: loyaltyUser,
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    t: t,
    locationState: state,
    notAMemberPath: notAMemberPath,
    loyaltyLoginCodeLength: loyaltyLoginCodeLength,
    qrLoginEnabled: qrLoginEnabled,
    sessionId: loyaltyLoginPayload.sessionId
  };
  return /*#__PURE__*/jsxRuntime.jsx(LoyaltyLoginViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useLoyaltyLoginViewContext = function useLoyaltyLoginViewContext() {
  var context = React.useContext(LoyaltyLoginViewContext);
  if (context === undefined) {
    throw new Error('useLoyaltyLoginViewContext must be used within a LoyaltyLoginViewProvider');
  }
  return context;
};

var useLoyaltyLoginView = function useLoyaltyLoginView() {
  var _useLoyaltyLoginViewC = useLoyaltyLoginViewContext(),
    resetMachine = _useLoyaltyLoginViewC.resetMachine,
    loyaltyUser = _useLoyaltyLoginViewC.loyaltyUser,
    loginMachineStatus = _useLoyaltyLoginViewC.loginMachineStatus,
    loyaltyLoginCode = _useLoyaltyLoginViewC.loyaltyLoginCode,
    setLoyaltyLoginCode = _useLoyaltyLoginViewC.setLoyaltyLoginCode,
    onConfirmCode = _useLoyaltyLoginViewC.onConfirmCode,
    locationState = _useLoyaltyLoginViewC.locationState,
    previousPath = _useLoyaltyLoginViewC.previousPath,
    setTemplate = _useLoyaltyLoginViewC.setTemplate,
    nextPath = _useLoyaltyLoginViewC.nextPath,
    history = _useLoyaltyLoginViewC.history,
    modalAccessibilityClass = _useLoyaltyLoginViewC.modalAccessibilityClass,
    t = _useLoyaltyLoginViewC.t,
    notAMemberPath = _useLoyaltyLoginViewC.notAMemberPath,
    loyaltyLoginCodeLength = _useLoyaltyLoginViewC.loyaltyLoginCodeLength,
    offersAndRewardsMachineStatus = _useLoyaltyLoginViewC.offersAndRewardsMachineStatus,
    qrLoginEnabled = _useLoyaltyLoginViewC.qrLoginEnabled,
    sessionId = _useLoyaltyLoginViewC.sessionId;
  var title = React.useMemo(function () {
    return t('loyaltyLoginTitle');
  }, [t]);

  //TODO fix this so that it doesnt use hardcode value
  var allowNextAction = React.useMemo(function () {
    return loyaltyLoginCode.length >= loyaltyLoginCodeLength;
  }, [loyaltyLoginCode, loyaltyLoginCodeLength]);
  var failedModalClosed = React.useCallback(function () {
    resetMachine();
  }, [resetMachine]);
  var successModalClosed = React.useCallback(function () {
    resetMachine();
    history.push(nextPath, _extends({}, locationState, {
      from: '/loyalty-login'
    }));
  }, [resetMachine, history, nextPath, locationState]);
  var nextAction = React.useCallback(function () {
    onConfirmCode();
  }, [onConfirmCode]);
  var previousAction = React.useCallback(function () {
    if (previousPath === '/reset') {
      history.push(previousPath, _extends({}, locationState, {
        origin: '/loyalty-login'
      }));
    } else {
      history.goBack();
    }
  }, [history, previousPath, locationState]);
  var skipAction = React.useCallback(function () {
    history.push(nextPath, _extends({}, locationState, {
      from: '/loyalty-login'
    }));
  }, [history, nextPath, locationState]);
  var notAMemberAction = React.useCallback(function () {
    history.push(notAMemberPath, _extends({}, locationState, {
      from: '/loyalty-login'
    }));
  }, [history, locationState, notAMemberPath]);
  React.useEffect(function () {
    var header = {
      title: title,
      isViewOrderDisabled: true,
      showBasketCount: false,
      previousText: t('loyaltyLoginPreviousAction'),
      previousAction: previousAction,
      showSubtotal: false,
      showMenuAction: false
    };
    var footer = {
      nextText: t('loyaltyLoginNextAction'),
      nextAction: nextAction,
      skipAction: skipAction,
      spacer: true,
      enableCancelOrder: false,
      isPreviousActionEnabled: true,
      previousAction: previousAction,
      allowNextAction: allowNextAction,
      showBasketCount: false,
      t: t
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [previousAction, setTemplate, nextAction, skipAction, title, allowNextAction, t]);
  return {
    loyaltyUser: loyaltyUser,
    loyaltyLoginCodeLength: loyaltyLoginCodeLength,
    loginMachineStatus: loginMachineStatus,
    loyaltyLoginCode: loyaltyLoginCode,
    setLoyaltyLoginCode: setLoyaltyLoginCode,
    modalAccessibilityClass: modalAccessibilityClass,
    successModalClosed: successModalClosed,
    failedModalClosed: failedModalClosed,
    notAMemberAction: notAMemberAction,
    t: t,
    offersAndRewardsMachineStatus: offersAndRewardsMachineStatus,
    qrLoginEnabled: qrLoginEnabled,
    sessionId: sessionId
  };
};

var useLoyaltyLoginCode = function useLoyaltyLoginCode() {
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var loyaltyEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.loyalty',
    defaultValue: false
  });
  return {
    loyaltyEnabled: loyaltyEnabled,
    t: t
  };
};

var InputLabel = function InputLabel(_ref) {
  var _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'input-label' : _ref$dataTest,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'text-2xl font-medium text-gray-500 uppercase' : _ref$className;
  return /*#__PURE__*/jsxRuntime.jsxs("label", {
    "data-test": dataTest,
    className: "flex flex-col space-y-4 generic-input-label " + className,
    htmlFor: id,
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      children: label ? "" + label : null
    }), children]
  });
};
var Input = function Input(_ref2) {
  var _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? 'input' : _ref2$dataTest,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$onFocus = _ref2.onFocus,
    onFocus = _ref2$onFocus === void 0 ? function () {} : _ref2$onFocus,
    _ref2$onChange = _ref2.onChange,
    onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? '' : _ref2$value,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? '' : _ref2$id,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'text' : _ref2$type,
    _ref2$checked = _ref2.checked,
    checked = _ref2$checked === void 0 ? false : _ref2$checked,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? '' : _ref2$placeholder,
    _ref2$autoFocus = _ref2.autoFocus,
    autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus,
    _ref2$isError = _ref2.isError,
    isError = _ref2$isError === void 0 ? false : _ref2$isError;
  var isText = type === 'text';
  var isCheckbox = type === 'checkbox';
  var inputRef = React.useRef();
  var inputStyles = (isCheckbox ? 'w-6 h-6 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 flex-1 checked:border-blue-600 focus:outline-none transition duration-200 cursor-pointer' : 'h-12 sm:h-20 px-4 border-solid border-2 ' + (isError ? 'border-primary' : 'border-black') + ' rounded-md text-4xl') + " " + className;
  React.useEffect(function () {
    if (isText && inputRef != null && inputRef.current && value != null && value.length) {
      setTimeout(function () {
        var _inputRef$current, _inputRef$current2;
        (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
        (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.setSelectionRange(value.length, value.length);
      }, 300);
    }
  }, [value, inputRef, isText]);
  return /*#__PURE__*/jsxRuntime.jsx("input", {
    ref: inputRef,
    id: id,
    type: type,
    value: value,
    checked: checked,
    "data-test": dataTest,
    className: inputStyles,
    placeholder: placeholder,
    onFocus: onFocus,
    onChange: onChange,
    autoFocus: autoFocus
  });
};

var LoyaltyLoginCode = function LoyaltyLoginCode(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    loyaltyLoginCode = _ref.loyaltyLoginCode,
    _ref$setLoyaltyLoginC = _ref.setLoyaltyLoginCode,
    setLoyaltyLoginCode = _ref$setLoyaltyLoginC === void 0 ? function () {} : _ref$setLoyaltyLoginC,
    CustomLogo = _ref.CustomLogo,
    _ref$customTheme = _ref.customTheme,
    customTheme = _ref$customTheme === void 0 ? false : _ref$customTheme,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$loyaltyLoginCode = _ref.loyaltyLoginCodeLength,
    loyaltyLoginCodeLength = _ref$loyaltyLoginCode === void 0 ? null : _ref$loyaltyLoginCode;
  var _useLoyaltyLoginCode = useLoyaltyLoginCode(),
    loyaltyEnabled = _useLoyaltyLoginCode.loyaltyEnabled,
    t = _useLoyaltyLoginCode.t;
  var isError = loyaltyLoginCodeLength ? loyaltyLoginCode.length < loyaltyLoginCodeLength : false;
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: loyaltyEnabled && /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "loyalty-login-code",
      className: "flex flex-col items-center justify-center space-y-8 w-4/5 font-bold",
      children: [CustomLogo && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "py-8",
        children: /*#__PURE__*/jsxRuntime.jsx(CustomLogo, {})
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex flex-col items-center justify-center text-5xl text-center mb-8",
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "loyalty-login-code-title",
          children: t('loyaltyLoginCodeTitle', {
            codeLength: loyaltyLoginCodeLength
          })
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Input, {
        type: "text",
        "data-test": "loyalty-login-code-input",
        id: "loyalty-login-code",
        value: loyaltyLoginCode,
        className: "w-1/2",
        isError: isError
      }), /*#__PURE__*/jsxRuntime.jsx(OnScreenKeyboard, {
        letter: false,
        symbol: false,
        initial: "numpad",
        onChange: setLoyaltyLoginCode,
        maxLength: loyaltyLoginCodeLength,
        id: "loyalty-login-code",
        customTheme: customTheme,
        className: className
      })]
    })
  });
};

var LoyaltyWelcomeModal = function LoyaltyWelcomeModal(_ref) {
  var onConfirm = _ref.onConfirm,
    loyaltyUser = _ref.loyaltyUser,
    t = _ref.t;
  var _ref2 = loyaltyUser || {},
    name = _ref2.name,
    points = _ref2.points;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
      title: t('loyaltyWelcomeModalTitle', {
        name: name
      })
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-3xl p-0 modal-text text-center modal-content",
      children: t('loyaltyWelcomeModalPoints', {
        points: points
      })
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      action: onConfirm,
      actionText: t('loyaltyWelcomeModalConfirm'),
      buttonsClassName: 'w-full'
    })]
  });
};

var LoginFailedModal = function LoginFailedModal(_ref) {
  var t = _ref.t,
    onClose = _ref.onClose;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
      title: t('loyaltyLoginFailedModalTitle')
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-3xl p-0 modal-text text-center modal-content",
      children: t('loyaltyLoginFailedModalContent')
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      action: onClose,
      actionText: t('loyaltyLoginFailedModalClose'),
      buttonsClassName: 'w-full'
    })]
  });
};

var NotAMemberSection = function NotAMemberSection(_ref) {
  var t = _ref.t;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "pb-5 text-3xl text-center",
    children: [/*#__PURE__*/jsxRuntime.jsx("p", {
      children: t('loyaltyNotAMemberQuestion')
    }), /*#__PURE__*/jsxRuntime.jsx("p", {
      children: t('loyaltyNotAMemberAnswer')
    })]
  });
};

var LoyaltyLoginView = function LoyaltyLoginView(_ref) {
  var _ref$CustomLoginFaile = _ref.CustomLoginFailedModal,
    CustomLoginFailedModal = _ref$CustomLoginFaile === void 0 ? LoginFailedModal : _ref$CustomLoginFaile,
    _ref$CustomLoginWelco = _ref.CustomLoginWelcomeModal,
    CustomLoginWelcomeModal = _ref$CustomLoginWelco === void 0 ? LoyaltyWelcomeModal : _ref$CustomLoginWelco,
    _ref$CustomNotAMember = _ref.CustomNotAMemberSection,
    CustomNotAMemberSection = _ref$CustomNotAMember === void 0 ? NotAMemberSection : _ref$CustomNotAMember,
    _ref$CustomTheme = _ref.CustomTheme,
    CustomTheme = _ref$CustomTheme === void 0 ? false : _ref$CustomTheme,
    _ref$CustomClassName = _ref.CustomClassName,
    CustomClassName = _ref$CustomClassName === void 0 ? '' : _ref$CustomClassName,
    _ref$CustomLogo = _ref.CustomLogo,
    CustomLogo = _ref$CustomLogo === void 0 ? null : _ref$CustomLogo;
  var _useLoyaltyLoginView = useLoyaltyLoginView(),
    loginMachineStatus = _useLoyaltyLoginView.loginMachineStatus,
    successModalClosed = _useLoyaltyLoginView.successModalClosed,
    failedModalClosed = _useLoyaltyLoginView.failedModalClosed,
    loyaltyLoginCode = _useLoyaltyLoginView.loyaltyLoginCode,
    setLoyaltyLoginCode = _useLoyaltyLoginView.setLoyaltyLoginCode,
    modalAccessibilityClass = _useLoyaltyLoginView.modalAccessibilityClass,
    t = _useLoyaltyLoginView.t,
    loyaltyUser = _useLoyaltyLoginView.loyaltyUser,
    notAMemberAction = _useLoyaltyLoginView.notAMemberAction,
    loyaltyLoginCodeLength = _useLoyaltyLoginView.loyaltyLoginCodeLength,
    qrLoginEnabled = _useLoyaltyLoginView.qrLoginEnabled,
    sessionId = _useLoyaltyLoginView.sessionId;
  var showFailureModal = loginMachineStatus === 'failed';
  var showLoadingScreen = loginMachineStatus === 'processing';
  var showSuccessModal = loginMachineStatus === 'success';
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col w-full h-full",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "loyalty-login-page",
      className: "flex flex-col items-center justify-center flex-1",
      children: [/*#__PURE__*/jsxRuntime.jsx(Modal, {
        className: modalAccessibilityClass,
        open: showFailureModal,
        children: /*#__PURE__*/jsxRuntime.jsx(CustomLoginFailedModal, {
          t: t,
          onClose: failedModalClosed
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Modal, {
        className: modalAccessibilityClass,
        open: showSuccessModal,
        children: /*#__PURE__*/jsxRuntime.jsx(CustomLoginWelcomeModal, {
          t: t,
          loyaltyUser: loyaltyUser,
          onConfirm: successModalClosed
        })
      }), showLoadingScreen ? /*#__PURE__*/jsxRuntime.jsx(Loading, {
        isFirstLoad: true
      }) : /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [/*#__PURE__*/jsxRuntime.jsx(LoyaltyLoginCode, {
          CustomLogo: CustomLogo,
          loyaltyLoginCode: loyaltyLoginCode,
          setLoyaltyLoginCode: setLoyaltyLoginCode,
          customTheme: CustomTheme,
          className: CustomClassName,
          loyaltyLoginCodeLength: loyaltyLoginCodeLength
        }), qrLoginEnabled ? /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            className: "mt-16 text-5xl font-bold text-center",
            "data-test": "loyalty-login-code-title",
            children: t('loyaltyQrLoginCodeTitle')
          }), /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "mt-16",
            children: sessionId ? /*#__PURE__*/jsxRuntime.jsx(QRCode, {
              size: "260x260",
              url: sessionId
            }) : /*#__PURE__*/jsxRuntime.jsx(Loading, {
              isFirstLoad: true
            })
          })]
        }) : null]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(CustomNotAMemberSection, {
      t: t,
      notAMemberAction: notAMemberAction
    })]
  });
};

var AppDownloadViewContext = /*#__PURE__*/React.createContext();
var AppDownloadViewProvider = function AppDownloadViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    appDownloadUrl = _ref.appDownloadUrl;
  var history = reactRouterDom.useHistory();
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var previousPath = state.from === '/home' ? '/reset' : state.from;
  var nextPath = '/loyalty-login';
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var available = {
    setTemplate: setTemplate,
    previousPath: previousPath,
    locationState: state,
    nextPath: nextPath,
    history: history,
    appDownloadUrl: appDownloadUrl,
    t: t
  };
  return /*#__PURE__*/jsxRuntime.jsx(AppDownloadViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useAppDownloadViewContext = function useAppDownloadViewContext() {
  var context = React.useContext(AppDownloadViewContext);
  if (context === undefined) {
    throw new Error('useAppDownloadViewContext must be used within a AppDownloadViewProvider');
  }
  return context;
};

var useAppDownloadView = function useAppDownloadView() {
  var _useAppDownloadViewCo = useAppDownloadViewContext(),
    locationState = _useAppDownloadViewCo.locationState,
    previousPath = _useAppDownloadViewCo.previousPath,
    nextPath = _useAppDownloadViewCo.nextPath,
    setTemplate = _useAppDownloadViewCo.setTemplate,
    history = _useAppDownloadViewCo.history,
    appDownloadUrl = _useAppDownloadViewCo.appDownloadUrl,
    t = _useAppDownloadViewCo.t;
  var title = t('appDownloadTitle');
  var content = t('appDownloadContent');
  var subContent = t('appDownloadSubContent');
  var nextAction = React.useCallback(function () {
    history.push(nextPath, _extends({}, locationState, {
      from: '/app-download'
    }));
  }, [history, nextPath, locationState]);
  var previousAction = React.useCallback(function () {
    if (previousPath === '/reset') {
      history.push(previousPath);
    } else {
      history.goBack();
    }
  }, [history, previousPath]);
  React.useEffect(function () {
    var header = {
      title: title,
      isViewOrderDisabled: true,
      showBasketCount: false,
      previousText: t('appDownloadPreviousAction'),
      previousAction: previousAction,
      showSubtotal: false
    };
    var footer = {
      nextText: t('appDownloadNextAction'),
      nextAction: nextAction,
      spacer: true,
      enableCancelOrder: false,
      isPreviousActionEnabled: true,
      previousAction: previousAction,
      allowNextAction: true,
      showBasketCount: false,
      t: t
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [previousAction, setTemplate, nextAction, title, t]);
  return {
    content: content,
    subContent: subContent,
    appDownloadUrl: appDownloadUrl,
    t: t
  };
};

var AppDownloadView = function AppDownloadView() {
  var _useAppDownloadView = useAppDownloadView(),
    content = _useAppDownloadView.content,
    subContent = _useAppDownloadView.subContent,
    appDownloadUrl = _useAppDownloadView.appDownloadUrl;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col mt-40 text-center gap-14 items-center w-full h-full",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        className: "text-5xl font-bold",
        children: content
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "text-4xl",
        children: subContent
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "text-6xl",
      children: /*#__PURE__*/jsxRuntime.jsx(QRCode, {
        size: "200x200",
        url: appDownloadUrl
      })
    })]
  });
};

var RestaurantHomeViewContext = /*#__PURE__*/React.createContext();
var RestaurantHomeViewProvider = function RestaurantHomeViewProvider(_ref) {
  var children = _ref.children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/categories' : _ref$nextPath,
    _ref$beaconPath = _ref.beaconPath,
    beaconPath = _ref$beaconPath === void 0 ? '/beacon' : _ref$beaconPath,
    _ref$authPath = _ref.authPath,
    authPath = _ref$authPath === void 0 ? '/auth' : _ref$authPath,
    _ref$allowedLanguages = _ref.allowedLanguages,
    allowedLanguages = _ref$allowedLanguages === void 0 ? [] : _ref$allowedLanguages;
  var _useRestaurantOrder = useRestaurantOrder(),
    startSession = _useRestaurantOrder.startSession;
  var _useRestaurantMenu = useRestaurantMenu(),
    state = _useRestaurantMenu.state,
    loading = _useRestaurantMenu.loading,
    retry = _useRestaurantMenu.retry,
    retryAttempt = _useRestaurantMenu.retryAttempt,
    sendState = _useRestaurantMenu.send;
  var _useRestaurantLock = useRestaurantLock(),
    kioskClosed = _useRestaurantLock.kioskClosed,
    scheduleLock = _useRestaurantLock.scheduleLock,
    checkScheduleLock = _useRestaurantLock.checkScheduleLock,
    autoLock = _useRestaurantLock.autoLock,
    autoUnlock = _useRestaurantLock.autoUnlock,
    manualLock = _useRestaurantLock.manualLock,
    manualUnlock = _useRestaurantLock.manualUnlock,
    lockMachineState = _useRestaurantLock.lockMachineState;
  var settings = recoil.useRecoilValue(atoms.settingsState);
  var _useMenuScheduler = useMenuScheduler({
      settings: settings
    }),
    _useMenuScheduler$syn = _useMenuScheduler.syncMenu,
    syncMenu = _useMenuScheduler$syn === void 0 ? function () {} : _useMenuScheduler$syn;
  var _useRecoilState = recoil.useRecoilState(atoms.secondaryProductsState),
    secondaryProducts = _useRecoilState[0],
    setSecondaryProductsState = _useRecoilState[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.syncMenuState),
    isSyncMenuStateCalled = _useRecoilState2[0],
    setIsSyncMenuStateCalled = _useRecoilState2[1];
  var _useRecoilState3 = recoil.useRecoilState(atoms.secondaryCategoriesState),
    secondaryCategories = _useRecoilState3[0],
    setSecondaryCategoriesState = _useRecoilState3[1];
  var _useRecoilState4 = recoil.useRecoilState(atoms.secondaryPromotionalState),
    secondaryPromotional = _useRecoilState4[0],
    setSecondaryPromotionalState = _useRecoilState4[1];
  var setFormattedProducts = recoil.useSetRecoilState(atoms.formattedProductsState);
  var _useRecoilState5 = recoil.useRecoilState(atoms.productsState),
    products = _useRecoilState5[0],
    setProductsState = _useRecoilState5[1];
  var setPromotionalState = recoil.useSetRecoilState(atoms.promotionalState);
  var setCategoriesState = recoil.useSetRecoilState(atoms.categoriesState);
  var _useRecoilState6 = recoil.useRecoilState(atoms.menuIdState),
    menuId = _useRecoilState6[0],
    setMenuId = _useRecoilState6[1];
  var _useRecoilState7 = recoil.useRecoilState(atoms.currentMenuIdState),
    currentMenuId = _useRecoilState7[0],
    setCurrentMenuId = _useRecoilState7[1];
  var _useSystem = useSystem(),
    reboot = _useSystem.reboot,
    reload = _useSystem.reload;
  var shouldReboot = recoil.useRecoilValue(atoms.rebootState);
  var reloadStateValue = recoil.useRecoilValue(atoms.reloadState);
  var _ref2 = reloadStateValue || {},
    _ref2$shouldReload = _ref2.shouldReload,
    shouldReload = _ref2$shouldReload === void 0 ? false : _ref2$shouldReload;
  var onlineStatus = recoil.useRecoilValue(atoms.onlineStatusState);
  var _onlineStatus$isOnlin = onlineStatus.isOnline,
    isOnline = _onlineStatus$isOnlin === void 0 ? true : _onlineStatus$isOnlin;
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _useState = React.useState(false),
    showTermsAndConditionsModal = _useState[0],
    setShowTermsAndConditionsModal = _useState[1];
  var available = {
    allowedLanguages: allowedLanguages,
    setTemplate: setTemplate,
    sendState: sendState,
    reboot: reboot,
    retry: retry,
    retryAttempt: retryAttempt,
    state: state,
    loading: loading,
    settings: settings,
    shouldReboot: shouldReboot,
    kioskClosed: kioskClosed,
    scheduleLock: scheduleLock,
    checkScheduleLock: checkScheduleLock,
    nextPath: nextPath,
    beaconPath: beaconPath,
    startSession: startSession,
    secondaryCategories: secondaryCategories,
    setSecondaryCategoriesState: setSecondaryCategoriesState,
    secondaryProducts: secondaryProducts,
    setSecondaryProductsState: setSecondaryProductsState,
    secondaryPromotional: secondaryPromotional,
    setSecondaryPromotionalState: setSecondaryPromotionalState,
    setProductsState: setProductsState,
    setPromotionalState: setPromotionalState,
    setCategoriesState: setCategoriesState,
    menuId: menuId,
    setMenuId: setMenuId,
    currentMenuId: currentMenuId,
    setCurrentMenuId: setCurrentMenuId,
    authPath: authPath,
    autoLock: autoLock,
    autoUnlock: autoUnlock,
    manualLock: manualLock,
    manualUnlock: manualUnlock,
    lockMachineState: lockMachineState,
    reload: reload,
    shouldReload: shouldReload,
    isOnline: isOnline,
    setFormattedProducts: setFormattedProducts,
    products: products,
    showTermsAndConditionsModal: showTermsAndConditionsModal,
    setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
    isSyncMenuStateCalled: isSyncMenuStateCalled,
    setIsSyncMenuStateCalled: setIsSyncMenuStateCalled,
    syncMenu: syncMenu
  };
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantHomeViewContext.Provider, {
    value: available,
    children: children
  });
};
RestaurantHomeViewProvider.displayName = 'RestaurantHomeViewProvider';

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantHomeViewContext = function useRestaurantHomeViewContext() {
  var context = React.useContext(RestaurantHomeViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantHomeViewContext must be used within a RestaurantHomeViewProvider');
  }
  return context;
};

var usePaymentMethods = function usePaymentMethods() {
  var apple = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.apple',
    defaultValue: false
  });
  var paywave = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.paywave',
    defaultValue: false
  });
  var google = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.google',
    defaultValue: false
  });
  var mastercard = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.mastercard',
    defaultValue: false
  });
  var visa = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.visa',
    defaultValue: false
  });
  var amex = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.amex',
    defaultValue: false
  });
  var interac = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.interac',
    defaultValue: false
  });
  var card = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.majorCards',
    defaultValue: false
  });
  var logos = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.majorLogos',
    defaultValue: false
  });
  var cash = utilities.useSettingsAtPath({
    path: 'settings.paymentMethods.cashAndCredit',
    defaultValue: false
  });

  // Eventually would like KAS to just send this object
  var cards = {
    apple: apple,
    paywave: paywave,
    google: google,
    mastercard: mastercard,
    visa: visa,
    amex: amex,
    interac: interac
  };
  var icons = Object.entries(cards).reduce(function (result, _ref) {
    var key = _ref[0],
      value = _ref[1];
    if (value) result.push(key);
    return result;
  }, []);
  return {
    cash: cash,
    card: card,
    logos: logos,
    icons: icons
  };
};

var useRestaurantHomeView = function useRestaurantHomeView() {
  var _history$location;
  var history = reactRouterDom.useHistory();
  var currentRoute = (history == null ? void 0 : (_history$location = history.location) == null ? void 0 : _history$location.pathname) || '';
  var _useLocation = reactRouterDom.useLocation(),
    locationState = _useLocation.state;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _usePaymentMethods = usePaymentMethods(),
    cash = _usePaymentMethods.cash,
    card = _usePaymentMethods.card,
    logos = _usePaymentMethods.logos,
    icons = _usePaymentMethods.icons;
  var _useRestaurantHomeVie = useRestaurantHomeViewContext(),
    state = _useRestaurantHomeVie.state,
    loading = _useRestaurantHomeVie.loading,
    settings = _useRestaurantHomeVie.settings,
    _useRestaurantHomeVie2 = _useRestaurantHomeVie.nextPath,
    nextPath = _useRestaurantHomeVie2 === void 0 ? '/categories' : _useRestaurantHomeVie2,
    _useRestaurantHomeVie3 = _useRestaurantHomeVie.beaconPath,
    beaconPath = _useRestaurantHomeVie3 === void 0 ? '/beacon' : _useRestaurantHomeVie3,
    _useRestaurantHomeVie4 = _useRestaurantHomeVie.notAMemberPath,
    notAMemberPath = _useRestaurantHomeVie4 === void 0 ? '/app-download' : _useRestaurantHomeVie4,
    shouldReboot = _useRestaurantHomeVie.shouldReboot,
    retry = _useRestaurantHomeVie.retry,
    retryAttempt = _useRestaurantHomeVie.retryAttempt,
    reboot = _useRestaurantHomeVie.reboot,
    startSession = _useRestaurantHomeVie.startSession,
    checkScheduleLock = _useRestaurantHomeVie.checkScheduleLock,
    lockMachineState = _useRestaurantHomeVie.lockMachineState,
    secondaryCategories = _useRestaurantHomeVie.secondaryCategories,
    setSecondaryCategoriesState = _useRestaurantHomeVie.setSecondaryCategoriesState,
    secondaryProducts = _useRestaurantHomeVie.secondaryProducts,
    setSecondaryProductsState = _useRestaurantHomeVie.setSecondaryProductsState,
    secondaryPromotional = _useRestaurantHomeVie.secondaryPromotional,
    setSecondaryPromotionalState = _useRestaurantHomeVie.setSecondaryPromotionalState,
    setProductsState = _useRestaurantHomeVie.setProductsState,
    setPromotionalState = _useRestaurantHomeVie.setPromotionalState,
    setCategoriesState = _useRestaurantHomeVie.setCategoriesState,
    menuId = _useRestaurantHomeVie.menuId,
    setCurrentMenuId = _useRestaurantHomeVie.setCurrentMenuId,
    currentMenuId = _useRestaurantHomeVie.currentMenuId,
    authPath = _useRestaurantHomeVie.authPath,
    autoLock = _useRestaurantHomeVie.autoLock,
    kioskClosed = _useRestaurantHomeVie.kioskClosed,
    scheduleLock = _useRestaurantHomeVie.scheduleLock,
    reload = _useRestaurantHomeVie.reload,
    shouldReload = _useRestaurantHomeVie.shouldReload,
    isOnline = _useRestaurantHomeVie.isOnline,
    setFormattedProducts = _useRestaurantHomeVie.setFormattedProducts,
    products = _useRestaurantHomeVie.products,
    allowedLanguages = _useRestaurantHomeVie.allowedLanguages,
    showTermsAndConditionsModal = _useRestaurantHomeVie.showTermsAndConditionsModal,
    setShowTermsAndConditionsModal = _useRestaurantHomeVie.setShowTermsAndConditionsModal,
    isSyncMenuStateCalled = _useRestaurantHomeVie.isSyncMenuStateCalled,
    setIsSyncMenuStateCalled = _useRestaurantHomeVie.setIsSyncMenuStateCalled,
    syncMenu = _useRestaurantHomeVie.syncMenu;
  var _useLocaleSelection = useLocaleSelection({
      allowedLanguages: allowedLanguages
    }),
    t = _useLocaleSelection.t,
    languages = _useLocaleSelection.languages,
    currentLanguage = _useLocaleSelection.currentLanguage,
    onChangeLanguage = _useLocaleSelection.onChangeLanguage;
  var onCloseTermsAndConditionsModal = function onCloseTermsAndConditionsModal() {
    return setShowTermsAndConditionsModal(false);
  };
  var name = settings.name,
    _settings$settings = settings.settings,
    config = _settings$settings === void 0 ? {} : _settings$settings;
  var _config$content = config.content,
    content = _config$content === void 0 ? {} : _config$content,
    _config$modes = config.modes,
    modes = _config$modes === void 0 ? {} : _config$modes,
    _config$languages = config.languages,
    configLanguages = _config$languages === void 0 ? {} : _config$languages;
  var _configLanguages$defa = configLanguages["default"],
    defaultLang = _configLanguages$defa === void 0 ? 'en' : _configLanguages$defa;
  var showSecondaryHome = content.homeBurger;
  var _modes$dineIn = modes.dineIn,
    showSecondaryAction = _modes$dineIn === void 0 ? false : _modes$dineIn;
  var healthMsg = utilities.useSettingsAtPath({
    path: 'settings.content.healthMsg',
    defaultValue: true
  });
  var loyaltyEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.loyalty',
    defaultValue: false
  });
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var flags = launchdarklyReactClientSdk.useFlags();
  var computeNextPath = React.useCallback(function (_ref) {
    var skipLoyaltyLogin = _ref.skipLoyaltyLogin;
    if (loyaltyEnabled) {
      var login = !skipLoyaltyLogin;
      if (login) return '/loyalty-login';
      if (beaconEnabled) return beaconPath;
      return nextPath;
    }
    if (beaconEnabled) return beaconPath;
    return nextPath;
  }, [beaconEnabled, beaconPath, loyaltyEnabled, nextPath]);
  var termsAndConditionsEnabled = utilities.useSettingsAtPath({
    path: 'settings.content.termsAndConditionsEnabled',
    defaultValue: false
  });
  var termsAndConditionsURL = utilities.useSettingsAtPath({
    path: 'settings.content.termsAndConditionsURL',
    defaultValue: ''
  });

  // Sort languages to the same order as in the routes page
  var sortedLanguages = languages.sort(function (_ref2, _ref3) {
    var languageA = _ref2.key;
    var languageB = _ref3.key;
    var languageAIdx = allowedLanguages.findIndex(function (x) {
      return x === languageA;
    });
    var languageBIdx = allowedLanguages.findIndex(function (x) {
      return x === languageB;
    });
    return languageAIdx - languageBIdx;
  });

  //For now we are translating from UK to EN. It was created a tech debt to refactor this https://fingermarkglobal.atlassian.net/browse/S2-3767
  var formattedDefaultLang = defaultLang === 'uk' ? 'en' : !allowedLanguages.includes(defaultLang) ? 'en' : defaultLang;
  var syncPrices = React.useCallback(function () {
    var updatedProducts = products.filter(filterByTimeRestrictions({
      settings: settings,
      flags: flags
    })).map(function (product) {
      return updatePricesByTimeRestrictions({
        product: product,
        settings: settings
      });
    });
    setFormattedProducts(updatedProducts);
  }, [products, setFormattedProducts, settings, flags]);
  var onAdminActivate = function onAdminActivate() {
    return history.push(authPath, {
      successPath: '/admin',
      cancelPath: '/home'
    });
  };
  var secondaryAction = React.useCallback(function (_ref4) {
    var skipLoyaltyLogin = _ref4.skipLoyaltyLogin;
    syncPrices();
    startSession('DINE_IN');
    var nextPath = computeNextPath({
      skipLoyaltyLogin: skipLoyaltyLogin
    });
    history.push(nextPath, _extends({}, locationState, {
      from: currentRoute
    }));
  }, [history, startSession, computeNextPath, syncPrices, currentRoute, locationState]);
  var notAMemberAction = React.useCallback(function (_ref5) {
    var sessionType = _ref5.sessionType;
    syncPrices();
    if (sessionType === 'DINE_IN') {
      startSession('DINE_IN');
    } else if (sessionType === 'TAKEAWAY') {
      startSession('TAKEAWAY');
    }
    history.push(notAMemberPath, _extends({}, locationState, {
      from: '/home'
    })); // fix: changed to "from", was "origin"
  }, [history, locationState, notAMemberPath, syncPrices, startSession]);
  var primaryAction = React.useCallback(function (_ref6) {
    var skipLoyaltyLogin = _ref6.skipLoyaltyLogin;
    syncPrices();
    startSession('TAKEAWAY');
    var nextPath = computeNextPath({
      skipLoyaltyLogin: skipLoyaltyLogin
    });
    history.push(nextPath, _extends({}, locationState, {
      from: currentRoute
    }));
  }, [history, startSession, computeNextPath, syncPrices, currentRoute, locationState]);
  var hasBothActionButtons = React.useMemo(function () {
    return [primaryAction, secondaryAction, showSecondaryAction].every(function (value) {
      return !!value;
    });
  }, [primaryAction, secondaryAction, showSecondaryAction]);
  var isCurrentLang = React.useCallback(function (lang) {
    return currentLanguage.toUpperCase() === lang.toUpperCase();
  }, [currentLanguage]);
  React.useEffect(function () {
    onChangeLanguage(formattedDefaultLang)();
  }, [formattedDefaultLang, onChangeLanguage]);
  React.useEffect(function () {
    if (currentLanguage === formattedDefaultLang) onChangeLanguage(formattedDefaultLang)();
  }, [currentLanguage, formattedDefaultLang, onChangeLanguage]);
  React.useEffect(function () {
    if (lockMachineState != null && lockMachineState.matches('manualUnlocked')) return;
    if (kioskClosed || scheduleLock) {
      autoLock('lockMessage');
      return;
    }
    checkScheduleLock();
  }, [lockMachineState, history, kioskClosed, scheduleLock, autoLock, checkScheduleLock]);
  React.useEffect(function () {
    if (menuId && menuId !== currentMenuId) {
      logger.debug('cringer.components - restaurant home view new menu downloaded. applying...');
      setCurrentMenuId(menuId);
      if (secondaryCategories) {
        setCategoriesState(secondaryCategories);
        setSecondaryCategoriesState(null);
      }
      if (secondaryProducts) {
        setProductsState(secondaryProducts);
        setSecondaryProductsState(null);
      }
      if (secondaryPromotional) {
        setPromotionalState(secondaryPromotional);
        setSecondaryPromotionalState(null);
      }
    }
  }, [secondaryCategories, secondaryProducts, secondaryPromotional, setCategoriesState, setProductsState, setPromotionalState, setSecondaryCategoriesState, setSecondaryProductsState, setSecondaryPromotionalState, menuId, setCurrentMenuId, currentMenuId]);
  React.useEffect(function () {
    if (!isSyncMenuStateCalled) return;
    syncMenu();
    setIsSyncMenuStateCalled(false);
  }, [isSyncMenuStateCalled, setIsSyncMenuStateCalled, syncMenu]);
  React.useEffect(function () {
    if (shouldReboot) {
      reboot();
    } else if (shouldReload) {
      reload();
    }
  }, [shouldReboot, reboot, shouldReload, reload]);
  return {
    t: t,
    name: name,
    retry: retry,
    retryAttempt: retryAttempt,
    cash: cash,
    card: card,
    logos: logos,
    icons: icons,
    state: state,
    loading: loading,
    isCurrentLang: isCurrentLang,
    primaryAction: primaryAction,
    languages: sortedLanguages,
    secondaryAction: secondaryAction,
    notAMemberAction: notAMemberAction,
    onChangeLanguage: onChangeLanguage,
    accessibilityEnabled: accessibilityEnabled,
    onAdminActivate: onAdminActivate,
    showSecondaryHome: showSecondaryHome,
    showSecondaryAction: showSecondaryAction,
    hasBothActionButtons: hasBothActionButtons,
    isOnline: isOnline,
    healthMsg: healthMsg,
    termsAndConditionsURL: termsAndConditionsURL,
    showTermsAndConditionsModal: showTermsAndConditionsModal,
    onCloseTermsAndConditionsModal: onCloseTermsAndConditionsModal,
    setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
    loyaltyEnabled: loyaltyEnabled,
    showTermsAndConditionsButton: termsAndConditionsEnabled && termsAndConditionsURL !== ''
  };
};

var useAdminButton = function useAdminButton(_ref) {
  var _ref$onActivate = _ref.onActivate,
    onActivate = _ref$onActivate === void 0 ? function () {} : _ref$onActivate;
  var comboTimeout = React.useRef();
  var _useState = React.useState(0),
    clickCount = _useState[0],
    setClickCount = _useState[1];
  var onClick = function onClick() {
    clearTimeout(comboTimeout.current);
    setClickCount(clickCount + 1);
    comboTimeout.current = setTimeout(function () {
      try {
        setClickCount(0);
      } catch (err) {
        logger.error('Components - useAdminButton - error:', err);
      }
    }, 5000);
  };
  React.useEffect(function () {
    if (clickCount === 3) {
      clearTimeout(comboTimeout.current);
      onActivate();
    }
  }, [clickCount, onActivate]);
  return {
    onClick: onClick
  };
};

var AdminButton = function AdminButton(_ref) {
  var _ref$onActivate = _ref.onActivate,
    onActivate = _ref$onActivate === void 0 ? function () {} : _ref$onActivate;
  var _useAdminButton = useAdminButton({
      onActivate: onActivate
    }),
    onClick = _useAdminButton.onClick;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    id: "trAdminButton",
    className: "home-admin-button",
    onClick: onClick,
    "data-test": "home-admin-button"
  });
};

var LocaleSelection = function LocaleSelection(_ref) {
  var _ref$languages = _ref.languages,
    languages = _ref$languages === void 0 ? [] : _ref$languages,
    _ref$onChangeLanguage = _ref.onChangeLanguage,
    onChangeLanguage = _ref$onChangeLanguage === void 0 ? null : _ref$onChangeLanguage,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? false : _ref$showDivider,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  validation$1.validate({
    name: 'LocaleSelection',
    parameters: {
      onChangeLanguage: onChangeLanguage
    }
  });
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "locale-selection " + className,
    "data-test": "home-footer-languages",
    children: languages == null ? void 0 : languages.map(function (_ref2, index) {
      var _ref2$key = _ref2.key,
        key = _ref2$key === void 0 ? '' : _ref2$key,
        _ref2$label = _ref2.label,
        label = _ref2$label === void 0 ? '' : _ref2$label,
        _ref2$active = _ref2.active,
        active = _ref2$active === void 0 ? false : _ref2$active;
      return /*#__PURE__*/jsxRuntime.jsx("button", {
        onClick: onChangeLanguage(key),
        className: "locale-selection-button " + (showDivider && index < (languages == null ? void 0 : languages.length) - 1 && 'locale-selection-button__divider--on') + " " + (active ? 'locale-selection-button--active' : 'locale-selection-button--inactive') + "\n          ",
        "data-test": "home-footer-languages-button-" + (key == null ? void 0 : key.toLowerCase()),
        children: label
      }, key);
    })
  });
};

var img$2 = "data:image/png;base64,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";

var PrimaryHome = function PrimaryHome(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$languages = _ref.languages,
    languages = _ref$languages === void 0 ? [] : _ref$languages,
    _ref$onChangeLanguage = _ref.onChangeLanguage,
    onChangeLanguage = _ref$onChangeLanguage === void 0 ? function () {} : _ref$onChangeLanguage,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction,
    _ref$healthMsg = _ref.healthMsg,
    healthMsg = _ref$healthMsg === void 0 ? true : _ref$healthMsg,
    _ref$setShowTermsAndC = _ref.setShowTermsAndConditionsModal,
    setShowTermsAndConditionsModal = _ref$setShowTermsAndC === void 0 ? function () {} : _ref$setShowTermsAndC,
    _ref$showTermsAndCond = _ref.showTermsAndConditionsButton,
    showTermsAndConditionsButton = _ref$showTermsAndCond === void 0 ? false : _ref$showTermsAndCond;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "primary-home",
    className: "flex flex-col justify-between items-center h-full w-full overflow-y-hidden  " + className,
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center w-full",
      "data-test": "home-upper",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-center justify-center my-32",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "flex-1 font-extrabold text-black text-jumbo",
          "data-test": "home-title",
          children: t('homeTitle')
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "flex-1 font-extrabold text-black text-8xl",
          "data-test": "home-subtitle",
          children: t('homeSubtitle')
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex items-center justify-center w-3/4 space-x-32",
        "data-test": "home-services",
        children: [!!primaryAction && /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
          className: "w-2/4",
          onClick: primaryAction,
          children: t('homePrimaryAction')
        }), !!secondaryAction && /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
          className: "w-2/4",
          onClick: secondaryAction,
          children: t('homeSecondaryAction')
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "home-lower",
        className: "flex flex-col-reverse items-center justify-center w-3/4",
        children: [showTermsAndConditionsButton && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
          children: /*#__PURE__*/jsxRuntime.jsx(BannerWarning, {
            "data-test": "banner-terms",
            t: t,
            width: "109",
            className: "w-full mt-4",
            title: t('homeTermsAndConditionsBannerWarningTitle'),
            description: t('homeTermsAndConditionsBannerWarningDescription'),
            additionalDescription: t('homeTermsAndConditionsBannerWarningAdditionalDescription'),
            additionalDescriptionAction: function additionalDescriptionAction() {
              return setShowTermsAndConditionsModal(true);
            }
          })
        }), healthMsg && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
          children: /*#__PURE__*/jsxRuntime.jsx(BannerWarning, {
            "data-test": "banner-health",
            t: t,
            width: "109",
            image: img$2,
            className: "w-full mt-4"
          })
        })]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "absolute bottom-0 mb-12",
      "data-test": "home-footer",
      children: /*#__PURE__*/jsxRuntime.jsx(LocaleSelection, {
        languages: languages,
        onChangeLanguage: onChangeLanguage
      })
    })]
  });
};

var SecondaryHome = function SecondaryHome(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$languages = _ref.languages,
    languages = _ref$languages === void 0 ? [] : _ref$languages,
    _ref$onChangeLanguage = _ref.onChangeLanguage,
    onChangeLanguage = _ref$onChangeLanguage === void 0 ? function () {} : _ref$onChangeLanguage,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction,
    _ref$healthMsg = _ref.healthMsg,
    healthMsg = _ref$healthMsg === void 0 ? true : _ref$healthMsg,
    _ref$setShowTermsAndC = _ref.setShowTermsAndConditionsModal,
    setShowTermsAndConditionsModal = _ref$setShowTermsAndC === void 0 ? function () {} : _ref$setShowTermsAndC,
    _ref$showTermsAndCond = _ref.showTermsAndConditionsButton,
    showTermsAndConditionsButton = _ref$showTermsAndCond === void 0 ? false : _ref$showTermsAndCond;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "secondary-home",
    className: "flex flex-col justify-between items-center h-full w-full overflow-y-hidden  " + className,
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center w-full",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-center justify-center my-32",
        "data-test": "home-upper",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "flex-1 font-extrabold text-black text-jumbo",
          "data-test": "home-title",
          children: t('homeTitle')
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "flex-1 font-extrabold text-black text-8xl",
          "data-test": "home-subtitle",
          children: t('homeSubtitle')
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex items-center justify-center w-3/4 space-x-32",
        "data-test": "home-services",
        children: [!!primaryAction && /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
          className: "w-2/4",
          onClick: primaryAction,
          children: t('homePrimaryAction')
        }), !!secondaryAction && /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
          className: "w-2/4",
          onClick: secondaryAction,
          children: t('homeSecondaryAction')
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "home-lower",
        className: "flex flex-col-reverse items-center justify-center w-3/4",
        children: [showTermsAndConditionsButton && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
          children: /*#__PURE__*/jsxRuntime.jsx(BannerWarning, {
            "data-test": "banner-terms",
            t: t,
            width: "109",
            className: "w-full mt-4",
            title: t('homeTermsAndConditionsBannerWarningTitle'),
            description: t('homeTermsAndConditionsBannerWarningDescription'),
            additionalDescription: t('homeTermsAndConditionsBannerWarningAdditionalDescription'),
            additionalDescriptionAction: function additionalDescriptionAction() {
              return setShowTermsAndConditionsModal(true);
            }
          })
        }), healthMsg && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
          children: /*#__PURE__*/jsxRuntime.jsx(BannerWarning, {
            "data-test": "banner-health",
            t: t,
            width: "109",
            image: img$2,
            className: "w-full mt-4"
          })
        })]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(LocaleSelection, {
      className: "mt-4",
      languages: languages,
      onChangeLanguage: onChangeLanguage
    })]
  });
};

var RestaurantHomeView = function RestaurantHomeView() {
  var _useRestaurantHomeVie = useRestaurantHomeView(),
    state = _useRestaurantHomeVie.state,
    loading = _useRestaurantHomeVie.loading,
    retry = _useRestaurantHomeVie.retry,
    onAdminActivate = _useRestaurantHomeVie.onAdminActivate,
    t = _useRestaurantHomeVie.t,
    languages = _useRestaurantHomeVie.languages,
    onChangeLanguage = _useRestaurantHomeVie.onChangeLanguage,
    primaryAction = _useRestaurantHomeVie.primaryAction,
    secondaryAction = _useRestaurantHomeVie.secondaryAction,
    accessibilityEnabled = _useRestaurantHomeVie.accessibilityEnabled,
    showSecondaryHome = _useRestaurantHomeVie.showSecondaryHome,
    showSecondaryAction = _useRestaurantHomeVie.showSecondaryAction,
    isOnline = _useRestaurantHomeVie.isOnline,
    healthMsg = _useRestaurantHomeVie.healthMsg,
    setShowTermsAndConditionsModal = _useRestaurantHomeVie.setShowTermsAndConditionsModal,
    showTermsAndConditionsButton = _useRestaurantHomeVie.showTermsAndConditionsButton;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col items-center justify-center h-full p-8",
    children: [/*#__PURE__*/jsxRuntime.jsx(AdminButton, {
      onActivate: onAdminActivate
    }), loading && /*#__PURE__*/jsxRuntime.jsx(Loading, {}), (state == null ? void 0 : state.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "danger",
      onRetryAction: retry,
      message: state.context.message
    }), (state == null ? void 0 : state.matches('success')) && (!isOnline ? /*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "warning",
      message: t('homeConnectivityIssues')
    }) : showSecondaryHome ? /*#__PURE__*/jsxRuntime.jsx(SecondaryHome, {
      accessibilityEnabled: accessibilityEnabled,
      languages: languages,
      onChangeLanguage: onChangeLanguage,
      primaryAction: primaryAction,
      secondaryAction: showSecondaryAction && secondaryAction,
      t: t,
      healthMsg: healthMsg,
      setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
      showTermsAndConditionsButton: showTermsAndConditionsButton
    }) : /*#__PURE__*/jsxRuntime.jsx(PrimaryHome, {
      accessibilityEnabled: accessibilityEnabled,
      languages: languages,
      onChangeLanguage: onChangeLanguage,
      primaryAction: primaryAction,
      secondaryAction: showSecondaryAction && secondaryAction,
      t: t,
      healthMsg: healthMsg,
      setShowTermsAndConditionsModal: setShowTermsAndConditionsModal,
      showTermsAndConditionsButton: showTermsAndConditionsButton
    }))]
  });
};

var RestaurantBeaconViewContext = /*#__PURE__*/React.createContext();
var BeaconViewProvider = function BeaconViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantBeaconViewContext.Provider, {
    children: children
  });
};
var useBeaconViewContext = function useBeaconViewContext() {
  var context = React.useContext(RestaurantBeaconViewContext);
  if (context === undefined) {
    throw new Error('useBeaconViewContext must be used within a BeaconViewProvider');
  }
  return context;
};

var useBeaconView = function useBeaconView(_temp) {
  var _history$location;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 3 : _ref$maxLength,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/categories' : _ref$nextPath;
  var secondaryPath = null;
  var showBasketCount = false;
  var _useState = React.useState(''),
    inputError = _useState[0],
    setInputError = _useState[1];
  var _useState2 = React.useState(false),
    allowSubmit = _useState2[0],
    setAllowSubmit = _useState2[1];
  var _useRecoilState = recoil.useRecoilState(atoms.beaconState),
    beaconNumber = _useRecoilState[0],
    setBeaconNumber = _useRecoilState[1];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var history = reactRouterDom.useHistory();
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useLocation = reactRouterDom.useLocation(),
    locationState = _useLocation.state;
  var beaconPrefixEnable = utilities.useSettingsAtPath({
    path: 'settings.modes.beaconPrefix',
    defaultValue: false
  });
  var title = t('beaconTitle');
  var cancelOrderText = t('beaconCancelAction');
  var nextText = t('beaconNextAction');
  var beaconInputError = t('beaconInputError');
  var currentRoute = (history == null ? void 0 : (_history$location = history.location) == null ? void 0 : _history$location.pathname) || '';
  var beaconValue = React.useMemo(function () {
    return beaconNumber || '';
  }, [beaconNumber]);
  var beaconNumberOnChange = React.useCallback(function (value) {
    var newValue = beaconPrefixEnable && value ? "B" + value : value;
    setBeaconNumber(newValue);
  }, [setBeaconNumber, beaconPrefixEnable]);
  var currentSettings = React.useMemo(function () {
    return {
      inputName: 'beacon',
      maxLength: maxLength,
      onChange: beaconNumberOnChange
    };
  }, [maxLength, beaconNumberOnChange]);
  var allowSubmitMaxLength = React.useMemo(function () {
    if (beaconPrefixEnable) {
      return (currentSettings == null ? void 0 : currentSettings.maxLength) + 1;
    } else {
      return currentSettings == null ? void 0 : currentSettings.maxLength;
    }
  }, [beaconPrefixEnable, currentSettings]);
  var beaconSubmit = React.useCallback(function () {
    setInputError('');
    if ((beaconNumber == null ? void 0 : beaconNumber.length) > 0 && parseInt(beaconNumber) > 0 && (beaconNumber == null ? void 0 : beaconNumber.length) <= allowSubmitMaxLength) {
      return;
    }
    setInputError(beaconInputError);
  }, [beaconInputError, beaconNumber, allowSubmitMaxLength, setInputError]);
  var showSecondaryAction = React.useMemo(function () {
    return !!secondaryPath;
  }, [secondaryPath]);
  var secondaryAction = function secondaryAction() {
    return history.push(secondaryPath);
  };
  var primaryAction = function primaryAction() {
    beaconSubmit();
    if (inputError) return;
    history.push(nextPath, _extends({}, locationState, {
      from: currentRoute
    }));
  };
  var nextAction = React.useCallback(function () {
    beaconSubmit();
    if (inputError) return;
    history.push(nextPath, _extends({}, locationState, {
      from: currentRoute
    }));
  }, [beaconSubmit, inputError, history, nextPath, currentRoute, locationState]);
  React.useEffect(function () {
    if ((beaconNumber == null ? void 0 : beaconNumber.length) > 0) setBeaconNumber(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if ((beaconNumber == null ? void 0 : beaconNumber.length) > 0 && (beaconNumber == null ? void 0 : beaconNumber.length) <= allowSubmitMaxLength) {
      setInputError('');
      return setAllowSubmit(true);
    }
    return setAllowSubmit(false);
  }, [beaconNumber, allowSubmitMaxLength, setAllowSubmit, beaconInputError, setInputError]);
  React.useEffect(function () {
    var header = {
      title: title
    };
    var footer = {
      nextAction: nextAction,
      nextText: nextText,
      cancelOrderText: cancelOrderText,
      allowNextAction: allowSubmit,
      enableCancelOrder: true,
      showBasketCount: false
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        footer: footer,
        header: header
      });
    });
  }, [setTemplate, title, nextText, cancelOrderText, allowSubmit, nextAction, showBasketCount]);
  return {
    t: t,
    title: title,
    inputError: inputError,
    beaconValue: beaconValue,
    allowSubmit: allowSubmit,
    beaconSubmit: beaconSubmit,
    currentSettings: currentSettings,
    primaryAction: primaryAction,
    secondaryAction: secondaryAction,
    showSecondaryAction: showSecondaryAction,
    accessibilityEnabled: accessibilityEnabled
  };
};

var RestaurantDualBrandViewContext = /*#__PURE__*/React.createContext();
var RestaurantDualBrandViewProvider = function RestaurantDualBrandViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantDualBrandViewContext.Provider, {
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantDualBrandViewContext = function useRestaurantDualBrandViewContext() {
  var context = React.useContext(RestaurantDualBrandViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantDualBrandViewContext must be used within a RestaurantDualBrandViewProvider');
  }
  return context;
};

var CategoriesViewContext = /*#__PURE__*/React.createContext();
var CategoriesViewProvider = function CategoriesViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx(CategoriesViewContext.Provider, {
    children: children
  });
};
var useCategoriesViewContext = function useCategoriesViewContext() {
  var context = React.useContext(CategoriesViewContext);
  if (context === undefined) {
    throw new Error('useCategoriesViewContext must be used within a CategoriesViewProvider');
  }
  return context;
};

var useCategoriesView = function useCategoriesView(_temp) {
  var _history$location, _categories$find;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/customer-details' : _ref$nextPath,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$hideMiniCartModa = _ref.hideMiniCartModal,
    hideMiniCartModal = _ref$hideMiniCartModa === void 0 ? false : _ref$hideMiniCartModa;
  var history = reactRouterDom.useHistory();
  var _useAnalytics = jitsu.useAnalytics(),
    setViewItemListTrack = _useAnalytics.setViewItemListTrack,
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    orderViewedTrack = _useAnalytics.orderViewedTrack;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _useParams = reactRouterDom.useParams(),
    id = _useParams.id;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useOrigin = useOrigin(),
    origin = _useOrigin.origin,
    setOrigin = _useOrigin.setOrigin;
  var _useCart = cart.useCart(),
    commit = _useCart.commit;
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var flags = launchdarklyReactClientSdk.useFlags();
  var _useLocation = reactRouterDom.useLocation(),
    locationState = _useLocation.state;
  var _useRestaurantMenu = useRestaurantMenu(),
    products = _useRestaurantMenu.products,
    state = _useRestaurantMenu.state,
    loading = _useRestaurantMenu.loading,
    categories = _useRestaurantMenu.categories;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    offersAndRewards = _useOffersAndRewardsM.offersAndRewards;
  var _useRecoilState = recoil.useRecoilState(atoms.settingsState),
    settings = _useRecoilState[0];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var setCurrentCategory = recoil.useSetRecoilState(atoms.currentCategoryState);
  var isDeliverectProvider = recoil.useRecoilValue(atoms.isDeliverectProviderState);
  var _useState = React.useState(false),
    openProductCustomisationModal = _useState[0],
    setOpenProductCustomisationModal = _useState[1];
  var _useState2 = React.useState(null),
    customisationProductSelected = _useState2[0],
    setCustomisationProductSelected = _useState2[1];
  var _useState3 = React.useState(false),
    showMiniCartModal = _useState3[0],
    setShowMiniCartModal = _useState3[1];
  var _useState4 = React.useState(false),
    openOutOfStockModal = _useState4[0],
    setOpenOutOfStockModal = _useState4[1];
  var _useState5 = React.useState(false),
    cancelledOutOfStockModal = _useState5[0],
    setCancelledOutOfStockModal = _useState5[1];
  var _useState6 = React.useState(null),
    staged = _useState6[0],
    setStaged = _useState6[1];
  var disableCustomisation = utilities.useSettingsAtPath({
    path: 'settings.content.disableCustomisation',
    defaultValue: false
  });
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var beaconOrderNumberEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beaconOrderNumber',
    defaultValue: false
  });
  var customerSkipPath = '/validate';
  var previousPath = '/home';
  var menuPath = '/categories';
  var showPriceWarning = true;
  var showCategoriesHeader = false;
  var isCustomisationHeaderEnabled = false;
  var isCategoryTotalizerEnabled = true;
  var isAdditionalMessageEnabled = true;
  var showQuantityControllerLabel = false;
  var showAddonAvailability = false;
  var disableModifyUpsellOnCart = false;
  var hideDisabledButtons = false;
  var hidePriceWhenQuantityLessOrEqualDefault = false;
  var hidePriceWhenZero = false;
  var showLoyaltyBanner = true;
  var timeoutEnabled = true;
  var isCouponQuantityDisabled = false;
  var galleryMaxColumns = 3;
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath || beaconOrderNumberEnabled || !!customer ? customerSkipPath : nextPath;
  var computedPrevPath = id ? '/categories' : previousPath;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var translateInline = translateProductName(language);
  var title = t('categoriesTitle');
  var allowNextAction = React.useMemo(function () {
    return count > 0;
  }, [count]);
  var nextText = t('categoriesNextAction');
  var previousText = t('categoriesPreviousAction');
  var originPath = id ? "/categories/" + id : '/categories';
  var currentRoute = (history == null ? void 0 : (_history$location = history.location) == null ? void 0 : _history$location.pathname) || '';
  var subcategoryTitle = id && categories && (categories == null ? void 0 : (_categories$find = categories.find(function (category) {
    return "" + (category == null ? void 0 : category.id) === "" + id;
  })) == null ? void 0 : _categories$find.name);
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  var nextAction = React.useCallback(function () {
    orderCompletedTrack();
    history.push(computedNextPath);
  }, [history, computedNextPath, orderCompletedTrack]);
  var previousAction = React.useCallback(function () {
    history.push(computedPrevPath);
  }, [history, computedPrevPath]);
  var computedAction = React.useCallback(function (path) {
    return history.push(path, _extends({}, locationState, {
      from: currentRoute
    }));
  }, [history, currentRoute, locationState]);
  var couponAction = React.useCallback(function () {
    return computedAction('/coupon');
  }, [computedAction]);
  var formattedCategories = categories && categories.filter(filterByTimeRestrictions({
    settings: settings,
    flags: flags
  })).filter(function (category) {
    var parent = category.parent;
    // Filter item which is 0 (false) or by its parentId
    var parentId = id ? id : 0;
    return parent.filter(function (item) {
      return "" + item === "" + parentId;
    }).length > 0;
  }).map(function (category) {
    var itemId = category.id,
      name = category.name,
      image = category.imageUrl,
      dualBrand = category.dualBrand,
      children = category.children;
    return _extends({
      image: image,
      title: translateInline(name),
      onClick: function onClick() {
        if (itemId === 'coupons') {
          return couponAction();
        }
        setCurrentCategory(name == null ? void 0 : name.text);
        var productsFromCategory = getHydratedProductsFromCategory({
          category: category,
          id: itemId,
          hydratedProducts: products,
          offersAndRewards: offersAndRewards
        });
        setViewItemListTrack({
          deviceSettings: kioskSettings.kiosk,
          products: productsFromCategory,
          overrides: {
            item_id: itemId,
            item_list_name: name == null ? void 0 : name.text
          }
        });
        return (children == null ? void 0 : children.length) > 0 ? history.push("/categories/" + itemId) : history.push("/category/" + itemId, {
          subcategoryId: id ? id : null,
          from: id ? "/categories/" + id : null
        });
      }
    }, dualBrand && {
      dualBrand: dualBrand
    });
  });
  var onCloseMiniCartModal = function onCloseMiniCartModal(_ref3) {
    var updatedStaged = _ref3.updatedStaged;
    if (updatedStaged) onSelectCustomisationProduct(updatedStaged);
    setShowMiniCartModal(false);
  };
  var onConfirmMiniCartModal = React.useCallback(function () {
    history.push(computedNextPath);
  }, [history, computedNextPath]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
      orderViewedTrack(cartItems, kioskSettings.kiosk, orderTotal, couponNumber);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal, orderViewedTrack, cartItems, kioskSettings.kiosk, orderTotal, couponNumber]);
  React.useEffect(function () {
    if (count && origin && origin != null && origin.includes('categories') && !openProductCustomisationModal && !hideMiniCartModal) {
      setShowMiniCartModal(true);
    }
  }, [setShowMiniCartModal, count, origin, setOrigin, openProductCustomisationModal, hideMiniCartModal]);
  var onCloseProductCustomisationModal = function onCloseProductCustomisationModal() {
    return setOpenProductCustomisationModal(false);
  };
  var onSelectCustomisationProduct = React.useCallback(function (product) {
    setCustomisationProductSelected(product);
    setOpenProductCustomisationModal(true);
  }, [setCustomisationProductSelected, setOpenProductCustomisationModal]);
  var onConfirmProductCustomisationModal = function onConfirmProductCustomisationModal(_ref4) {
    var staged = _ref4.staged;
    setOpenProductCustomisationModal(false);
    setOpenOutOfStockModal(false);
    commit({
      staged: staged
    });
  };
  var onCloseOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(false);
    if (disableCustomisation) setCancelledOutOfStockModal(true);
  }, [setOpenOutOfStockModal, setCancelledOutOfStockModal, disableCustomisation]);
  var showOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(true);
  }, [setOpenOutOfStockModal]);
  React.useEffect(function () {
    var header = {
      title: id ? translateInline(subcategoryTitle) : title,
      nextText: nextText,
      nextAction: nextAction,
      onBasketClick: onBasketClick,
      allowNextAction: allowNextAction,
      previousText: previousText,
      menuAction: menuAction,
      showMenuAction: !!id,
      previousAction: id ? menuAction : undefined,
      allowPreviousAction: !!id,
      enableCancelOrder: true,
      showCategoriesHeader: id ? true : showCategoriesHeader,
      showCouponButton: true,
      showLoyaltyBanner: showLoyaltyBanner,
      showOrderHistory: !id
    };
    var footer = _extends({
      nextText: nextText,
      nextAction: nextAction,
      onBasketClick: onBasketClick,
      allowNextAction: allowNextAction,
      showMiniCartSlider: true,
      enableCancelOrder: id ? false : true,
      previousText: previousText,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      showCouponButton: true
    }, id && {
      previousAction: previousAction
    });
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer,
        timeoutEnabledOverride: timeoutEnabled
      });
    });
  }, [title, setTemplate, menuAction, nextAction, previousAction, allowNextAction, nextText, onBasketClick, showCategoriesHeader, subcategoryTitle, translateInline, id, previousText, onSelectCustomisationProduct, showLoyaltyBanner, timeoutEnabled]);
  return {
    state: state,
    title: title,
    loading: loading,
    categories: categories,
    nextAction: nextAction,
    previousAction: previousAction,
    allowNextAction: allowNextAction,
    formattedCategories: formattedCategories,
    t: t,
    showMiniCartModal: showMiniCartModal,
    onCloseMiniCartModal: onCloseMiniCartModal,
    onConfirmMiniCartModal: onConfirmMiniCartModal,
    originPath: originPath,
    showPriceWarning: showPriceWarning,
    openProductCustomisationModal: openProductCustomisationModal,
    customisationProductSelected: customisationProductSelected,
    onConfirmProductCustomisationModal: onConfirmProductCustomisationModal,
    onCloseProductCustomisationModal: onCloseProductCustomisationModal,
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    formatPrice: formatPrice,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    showQuantityControllerLabel: showQuantityControllerLabel,
    showAddonAvailability: showAddonAvailability,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    hideDisabledButtons: hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero,
    galleryMaxColumns: galleryMaxColumns,
    isCouponQuantityDisabled: isCouponQuantityDisabled,
    isDeliverectProvider: isDeliverectProvider,
    openOutOfStockModal: openOutOfStockModal,
    showOutOfStockModal: showOutOfStockModal,
    onCloseOutOfStockModal: onCloseOutOfStockModal,
    cancelledOutOfStockModal: cancelledOutOfStockModal,
    staged: staged,
    setStaged: setStaged
  };
};

var CategoryViewContext = /*#__PURE__*/React.createContext();
var CategoryViewProvider = function CategoryViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx(CategoryViewContext.Provider, {
    children: children
  });
};
var useCategoryViewContext = function useCategoryViewContext() {
  var context = React.useContext(CategoryViewContext);
  if (context === undefined) {
    throw new Error('useCategoryViewContext must be used within a CategoryViewProvider');
  }
  return context;
};

var formatComboProduct = function formatComboProduct(_ref) {
  var title = _ref.title,
    product = _ref.product,
    history = _ref.history,
    _ref$onSelectComboPro = _ref.onSelectComboProduct,
    onSelectComboProduct = _ref$onSelectComboPro === void 0 ? function () {} : _ref$onSelectComboPro,
    _ref$onClickCallback = _ref.onClickCallback,
    onClickCallback = _ref$onClickCallback === void 0 ? function () {} : _ref$onClickCallback,
    _ref$setOpenUpsellMod = _ref.setOpenUpsellModal,
    setOpenUpsellModal = _ref$setOpenUpsellMod === void 0 ? function () {} : _ref$setOpenUpsellMod,
    _ref$translateInline = _ref.translateInline,
    translateInline = _ref$translateInline === void 0 ? function () {} : _ref$translateInline,
    _ref$showComboSizeSel = _ref.showComboSizeSelection,
    showComboSizeSelection = _ref$showComboSizeSel === void 0 ? true : _ref$showComboSizeSel,
    upsizeItemSelectedTrack = _ref.upsizeItemSelectedTrack,
    kioskSettings = _ref.kioskSettings;
  var _ref2 = product || {},
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? [] : _ref2$options,
    type = _ref2.type,
    isAvailable = _ref2.isAvailable,
    posItemId = _ref2.posItemId,
    isVisible = _ref2.isVisible,
    _ref2$serves = _ref2.serves,
    serves = _ref2$serves === void 0 ? {} : _ref2$serves,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? {} : _ref2$name,
    productId = _ref2.productId,
    _ref2$isUpsell = _ref2.isUpsell,
    isUpsell = _ref2$isUpsell === void 0 ? false : _ref2$isUpsell,
    _ref2$isCrossSell = _ref2.isCrossSell,
    isCrossSell = _ref2$isCrossSell === void 0 ? false : _ref2$isCrossSell,
    fees = _ref2.fees;
  var navigateToProductDetails = function navigateToProductDetails(id, isUpsized) {
    if (isUpsized) {
      upsizeItemSelectedTrack == null ? void 0 : upsizeItemSelectedTrack(product, kioskSettings);
    }
    history.push("/product/" + productId + "/combo/" + id);
  };
  var formattedOptions = options.map(function (option, index) {
    var filteredOption = filterImageUrlFallback(option);
    var _ref3 = filteredOption || {},
      imageUrl = _ref3.imageUrl,
      _ref3$name = _ref3.name,
      name = _ref3$name === void 0 ? {} : _ref3$name,
      productId = _ref3.productId,
      price = _ref3.price,
      id = _ref3.id,
      _ref3$serves = _ref3.serves,
      serves = _ref3$serves === void 0 ? {} : _ref3$serves,
      _ref3$isAvailable = _ref3.isAvailable,
      isAvailable = _ref3$isAvailable === void 0 ? true : _ref3$isAvailable,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? true : _ref3$isVisible,
      energyInformation = _ref3.energyInformation;
    var isUpsized = options.length - 1 === index;
    return {
      id: id,
      name: name,
      price: price,
      productId: productId,
      energyInformation: energyInformation,
      image: imageUrl,
      title: translateInline(name),
      dataTag: 'combo-option-card',
      type: type,
      isAvailable: isAvailable,
      isVisible: isVisible,
      fees: fees,
      posItemId: posItemId,
      onClick: function onClick() {
        return navigateToProductDetails(id, isUpsized);
      },
      serves: translateInline(serves),
      isUpsized: isUpsized
    };
  });
  var formattedProduct = {
    title: title,
    productId: productId,
    isUpsell: isUpsell,
    isCrossSell: isCrossSell,
    type: type,
    name: title ? {
      text: title
    } : _extends({}, name),
    image: product.imageUrl,
    description: product.description.text,
    price: product.price,
    energyInformation: product.energyInformation,
    options: formattedOptions,
    isAvailable: isAvailable,
    isVisible: isVisible,
    fees: fees,
    serves: translateInline(serves)
  };
  return _extends({}, formattedProduct, {
    dataTag: 'combo-product-card',
    onClick: function onClick() {
      setOpenUpsellModal(false);
      onClickCallback();
      if (!options || !options.length) return;
      if (showComboSizeSelection && options.length > 1) return onSelectComboProduct(formattedProduct);
      // Automatically use the filter when there is only one
      history.push("/product/" + product.id + "/combo/" + options[0].id);
    }
  });
};

var formatCustomiseProduct = function formatCustomiseProduct(_ref) {
  var title = _ref.title,
    product = _ref.product,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? function () {} : _ref$onSelectCustomis,
    _ref$onClickCallback = _ref.onClickCallback,
    onClickCallback = _ref$onClickCallback === void 0 ? function () {} : _ref$onClickCallback,
    _ref$setOpenUpsellMod = _ref.setOpenUpsellModal,
    setOpenUpsellModal = _ref$setOpenUpsellMod === void 0 ? function () {} : _ref$setOpenUpsellMod,
    _ref$translateInline = _ref.translateInline,
    translateInline = _ref$translateInline === void 0 ? function () {} : _ref$translateInline;
  var _ref2 = product || {},
    image = _ref2.imageUrl,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? {} : _ref2$name,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? {} : _ref2$description,
    price = _ref2.price,
    energyInformation = _ref2.energyInformation,
    _ref2$productId = _ref2.productId,
    productId = _ref2$productId === void 0 ? null : _ref2$productId,
    type = _ref2.type,
    isAvailable = _ref2.isAvailable,
    posItemId = _ref2.posItemId,
    _ref2$serves = _ref2.serves,
    serves = _ref2$serves === void 0 ? {} : _ref2$serves,
    _ref2$isUpsell = _ref2.isUpsell,
    isUpsell = _ref2$isUpsell === void 0 ? false : _ref2$isUpsell,
    _ref2$isCrossSell = _ref2.isCrossSell,
    isCrossSell = _ref2$isCrossSell === void 0 ? false : _ref2$isCrossSell;
  if (!productId) return null;
  return {
    name: name,
    image: image,
    price: price,
    productId: productId,
    title: title,
    energyInformation: energyInformation,
    description: description.text,
    dataTag: 'customisable-product-card',
    serves: translateInline(serves),
    type: type,
    isAvailable: isAvailable,
    posItemId: posItemId,
    isUpsell: isUpsell,
    isCrossSell: isCrossSell,
    onClick: function onClick() {
      onSelectCustomisationProduct(product);
      setOpenUpsellModal(false);
      onClickCallback();
    },
    allergens: energyInformation
  };
};

var formatGroupedProduct = function formatGroupedProduct(_ref) {
  var title = _ref.title,
    product = _ref.product,
    products = _ref.products,
    history = _ref.history,
    categoryId = _ref.categoryId,
    _ref$onSelectGroupedP = _ref.onSelectGroupedProduct,
    onSelectGroupedProduct = _ref$onSelectGroupedP === void 0 ? function () {} : _ref$onSelectGroupedP,
    _ref$onCloseGroupedPr = _ref.onCloseGroupedProductModal,
    onCloseGroupedProductModal = _ref$onCloseGroupedPr === void 0 ? function () {} : _ref$onCloseGroupedPr,
    _ref$onSelectComboPro = _ref.onSelectComboProduct,
    onSelectComboProduct = _ref$onSelectComboPro === void 0 ? function () {} : _ref$onSelectComboPro,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? function () {} : _ref$onSelectCustomis,
    _ref$commit = _ref.commit,
    commit = _ref$commit === void 0 ? function () {} : _ref$commit,
    _ref$setProductAnimat = _ref.setProductAnimation,
    setProductAnimation = _ref$setProductAnimat === void 0 ? function () {} : _ref$setProductAnimat,
    _ref$setOpenUpsellMod = _ref.setOpenUpsellModal,
    setOpenUpsellModal = _ref$setOpenUpsellMod === void 0 ? function () {} : _ref$setOpenUpsellMod,
    _ref$translateInline = _ref.translateInline,
    translateInline = _ref$translateInline === void 0 ? function () {} : _ref$translateInline,
    _ref$onAddSimpleProdu = _ref.onAddSimpleProduct,
    onAddSimpleProduct = _ref$onAddSimpleProdu === void 0 ? function () {} : _ref$onAddSimpleProdu,
    _ref$registerAddedToC = _ref.registerAddedToCart,
    registerAddedToCart = _ref$registerAddedToC === void 0 ? function () {} : _ref$registerAddedToC,
    _ref$currentCategory = _ref.currentCategory,
    currentCategory = _ref$currentCategory === void 0 ? '' : _ref$currentCategory,
    _ref$productAddedToCa = _ref.productAddedToCartTrack,
    productAddedToCartTrack = _ref$productAddedToCa === void 0 ? function () {} : _ref$productAddedToCa;
  var _ref2 = product || {},
    _ref2$grouped = _ref2.grouped,
    grouped = _ref2$grouped === void 0 ? {} : _ref2$grouped,
    type = _ref2.type,
    isAvailable = _ref2.isAvailable,
    _ref2$isUpsell = _ref2.isUpsell,
    isUpsell = _ref2$isUpsell === void 0 ? false : _ref2$isUpsell,
    _ref2$serves = _ref2.serves,
    serves = _ref2$serves === void 0 ? {} : _ref2$serves;
  var _grouped$children = grouped.children,
    children = _grouped$children === void 0 ? [] : _grouped$children,
    defaultProductId = grouped["default"];
  var formattedProduct = {
    productId: product.productId,
    image: product.imageUrl,
    title: title,
    serves: translateInline(serves),
    description: product.description.text,
    price: product.price,
    energyInformation: product.energyInformation,
    dataTag: 'grouped-product-card',
    type: type,
    isAvailable: isAvailable,
    isUpsell: isUpsell,
    posItemId: product.posItemId
  };
  var formattedSettings = {
    product: null,
    history: history,
    onSelectComboProduct: onSelectComboProduct,
    onSelectCustomisationProduct: onSelectCustomisationProduct,
    onClickCallback: function onClickCallback() {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      var prod = (params == null ? void 0 : params.length) > 0 ? params == null ? void 0 : params[0] : params;
      productAddedToCartTrack(prod);
      registerAddedToCart(product);
      return onCloseGroupedProductModal(params);
    },
    products: products,
    commit: commit,
    overrideProductAnimate: formattedProduct,
    setProductAnimation: setProductAnimation,
    setOpenUpsellModal: setOpenUpsellModal,
    onAddSimpleProduct: onAddSimpleProduct,
    translateInline: translateInline
  };
  var formattedGrouped = children.map(function (id) {
    var child = getProductById({
      products: products,
      id: id
    });
    var _ref3 = child || {},
      _ref3$productId = _ref3.productId,
      productId = _ref3$productId === void 0 ? '' : _ref3$productId;
    var additionalValues = {
      "default": defaultProductId === productId,
      dataTag: 'grouped-option-card'
    };
    var childFormattedSettings = _extends({}, formattedSettings, {
      product: _extends({}, child, {
        parentCategory: currentCategory
      }),
      title: translateInline(child == null ? void 0 : child.name)
    });
    return _extends({}, formatProduct(childFormattedSettings), additionalValues);
  });
  var mergedFormatted = _extends({}, formattedProduct, {
    grouped: formattedGrouped
  });
  return _extends({}, mergedFormatted, {
    onClick: function onClick() {
      setOpenUpsellModal(false);
      if (children.length) return onSelectGroupedProduct(mergedFormatted);
      history.push("/category/" + categoryId + "/product/" + product.id + "?allowAutoAdd=true");
    }
  });
};

var formatSimpleProduct = function formatSimpleProduct(_ref) {
  var title = _ref.title,
    product = _ref.product,
    _ref$commit = _ref.commit,
    commit = _ref$commit === void 0 ? function () {} : _ref$commit,
    _ref$onClickCallback = _ref.onClickCallback,
    onClickCallback = _ref$onClickCallback === void 0 ? function () {} : _ref$onClickCallback,
    _ref$setProductAnimat = _ref.setProductAnimation,
    setProductAnimation = _ref$setProductAnimat === void 0 ? function () {} : _ref$setProductAnimat,
    overrideProductAnimate = _ref.overrideProductAnimate,
    _ref$setOpenUpsellMod = _ref.setOpenUpsellModal,
    setOpenUpsellModal = _ref$setOpenUpsellMod === void 0 ? function () {} : _ref$setOpenUpsellMod,
    _ref$onAddSimpleProdu = _ref.onAddSimpleProduct,
    onAddSimpleProduct = _ref$onAddSimpleProdu === void 0 ? function () {} : _ref$onAddSimpleProdu,
    _ref$registerAddedToC = _ref.registerAddedToCart,
    registerAddedToCart = _ref$registerAddedToC === void 0 ? function () {} : _ref$registerAddedToC,
    _ref$translateInline = _ref.translateInline,
    translateInline = _ref$translateInline === void 0 ? function () {} : _ref$translateInline;
  if (!product) return null;
  var _ref2 = product || {},
    image = _ref2.imageUrl,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? {} : _ref2$name,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? {} : _ref2$description,
    price = _ref2.price,
    energyInformation = _ref2.energyInformation,
    productId = _ref2.productId,
    type = _ref2.type,
    isAvailable = _ref2.isAvailable,
    posItemId = _ref2.posItemId,
    _ref2$serves = _ref2.serves,
    serves = _ref2$serves === void 0 ? {} : _ref2$serves,
    _ref2$isUpsell = _ref2.isUpsell,
    isUpsell = _ref2$isUpsell === void 0 ? false : _ref2$isUpsell,
    _ref2$isCrossSell = _ref2.isCrossSell,
    isCrossSell = _ref2$isCrossSell === void 0 ? false : _ref2$isCrossSell;
  var formattedProduct = {
    title: title,
    name: title ? {
      text: title
    } : _extends({}, name),
    image: image,
    price: price,
    productId: productId,
    energyInformation: energyInformation,
    description: description.text,
    dataTag: 'simple-product-card',
    type: type,
    isAvailable: isAvailable,
    posItemId: posItemId,
    isUpsell: isUpsell,
    isCrossSell: isCrossSell,
    serves: translateInline(serves)
  };
  return _extends({}, formattedProduct, {
    onClick: function onClick() {
      registerAddedToCart(product);
      commit({
        product: product
      });
      onClickCallback(product);
      setProductAnimation(overrideProductAnimate || formattedProduct);
      setOpenUpsellModal(false);
      onAddSimpleProduct(product);
    }
  });
};

var formatComposedProduct = function formatComposedProduct(_ref) {
  var title = _ref.title,
    product = _ref.product,
    history = _ref.history,
    _ref$onClickCallback = _ref.onClickCallback,
    onClickCallback = _ref$onClickCallback === void 0 ? function () {} : _ref$onClickCallback,
    _ref$translateInline = _ref.translateInline,
    translateInline = _ref$translateInline === void 0 ? function () {} : _ref$translateInline;
  if (!product) return null;
  var _ref2 = product || {},
    image = _ref2.imageUrl,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? {} : _ref2$name,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? {} : _ref2$description,
    price = _ref2.price,
    energyInformation = _ref2.energyInformation,
    productId = _ref2.productId,
    type = _ref2.type,
    isAvailable = _ref2.isAvailable,
    _ref2$composed = _ref2.composed,
    composed = _ref2$composed === void 0 ? {} : _ref2$composed,
    posItemId = _ref2.posItemId,
    _ref2$serves = _ref2.serves,
    serves = _ref2$serves === void 0 ? {} : _ref2$serves,
    _ref2$isUpsell = _ref2.isUpsell,
    isUpsell = _ref2$isUpsell === void 0 ? false : _ref2$isUpsell;
  var formattedProduct = {
    title: title,
    name: title ? {
      text: title
    } : _extends({}, name),
    image: image,
    price: price,
    productId: productId,
    energyInformation: energyInformation,
    description: description.text,
    dataTag: 'composed-product-card',
    type: type,
    isAvailable: isAvailable,
    composed: composed,
    posItemId: posItemId,
    isUpsell: isUpsell,
    serves: translateInline(serves)
  };
  return _extends({}, formattedProduct, {
    onClick: function onClick() {
      onClickCallback(product);
      history.push("/product/" + product.id + "/composed");
    }
  });
};

var formatUpsellProducts = function formatUpsellProducts(_ref) {
  var _settings$settings;
  var title = _ref.title,
    _ref$categoryUpsells = _ref.categoryUpsells,
    categoryUpsells = _ref$categoryUpsells === void 0 ? [] : _ref$categoryUpsells,
    _ref$productUpsells = _ref.productUpsells,
    productUpsells = _ref$productUpsells === void 0 ? [] : _ref$productUpsells,
    main = _ref.main,
    products = _ref.products,
    categories = _ref.categories,
    randomiseUpsells = _ref.randomiseUpsells,
    _ref$onSelectGroupedP = _ref.onSelectGroupedProduct,
    onSelectGroupedProduct = _ref$onSelectGroupedP === void 0 ? function () {} : _ref$onSelectGroupedP,
    _ref$onCloseGroupedPr = _ref.onCloseGroupedProductModal,
    onCloseGroupedProductModal = _ref$onCloseGroupedPr === void 0 ? function () {} : _ref$onCloseGroupedPr,
    _ref$onSelectComboPro = _ref.onSelectComboProduct,
    onSelectComboProduct = _ref$onSelectComboPro === void 0 ? function () {} : _ref$onSelectComboPro,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? function () {} : _ref$onSelectCustomis,
    _ref$commit = _ref.commit,
    commit = _ref$commit === void 0 ? function () {} : _ref$commit,
    _ref$setProductAnimat = _ref.setProductAnimation,
    setProductAnimation = _ref$setProductAnimat === void 0 ? function () {} : _ref$setProductAnimat,
    categoryId = _ref.categoryId,
    history = _ref.history,
    _ref$setOpenUpsellMod = _ref.setOpenUpsellModal,
    setOpenUpsellModal = _ref$setOpenUpsellMod === void 0 ? function () {} : _ref$setOpenUpsellMod,
    settings = _ref.settings,
    _ref$translateInline = _ref.translateInline,
    translateInline = _ref$translateInline === void 0 ? function () {} : _ref$translateInline,
    _ref$onAddSimpleProdu = _ref.onAddSimpleProduct,
    onAddSimpleProduct = _ref$onAddSimpleProdu === void 0 ? function () {} : _ref$onAddSimpleProdu,
    _ref$registerAddedToC = _ref.registerAddedToCart,
    registerAddedToCart = _ref$registerAddedToC === void 0 ? function () {} : _ref$registerAddedToC,
    _ref$setUpsellDepende = _ref.setUpsellDependency,
    setUpsellDependency = _ref$setUpsellDepende === void 0 ? function () {} : _ref$setUpsellDepende,
    _ref$setTrackedUpsell = _ref.setTrackedUpsells,
    setTrackedUpsells = _ref$setTrackedUpsell === void 0 ? function () {} : _ref$setTrackedUpsell,
    _ref$upsellAddedToCar = _ref.upsellAddedToCartTrack,
    upsellAddedToCartTrack = _ref$upsellAddedToCar === void 0 ? function () {} : _ref$upsellAddedToCar,
    _ref$registerProductA = _ref.registerProductAddToCart,
    registerProductAddToCart = _ref$registerProductA === void 0 ? function () {} : _ref$registerProductA,
    _ref$sessionId = _ref.sessionId,
    sessionId = _ref$sessionId === void 0 ? '' : _ref$sessionId,
    _ref$setUpsellState = _ref.setUpsellState,
    setUpsellState = _ref$setUpsellState === void 0 ? function () {} : _ref$setUpsellState,
    _ref$kioskSettings = _ref.kioskSettings,
    kioskSettings = _ref$kioskSettings === void 0 ? {} : _ref$kioskSettings,
    _ref$couponNumber = _ref.couponNumber,
    couponNumber = _ref$couponNumber === void 0 ? '' : _ref$couponNumber,
    _ref$isCrossSell = _ref.isCrossSell,
    isCrossSell = _ref$isCrossSell === void 0 ? false : _ref$isCrossSell;
  var items = [].concat(categoryUpsells, productUpsells);
  var formattedProducts = [];
  var _ref2 = (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : _settings$settings.content) || {},
    _ref2$upsellMaxProduc = _ref2.upsellMaxProducts,
    upsellMaxProducts = _ref2$upsellMaxProduc === void 0 ? 0 : _ref2$upsellMaxProduc;
  var formatSettings = {
    title: title,
    products: products,
    categoryId: categoryId,
    history: history,
    onSelectGroupedProduct: onSelectGroupedProduct,
    onCloseGroupedProductModal: onCloseGroupedProductModal,
    onSelectComboProduct: onSelectComboProduct,
    onSelectCustomisationProduct: onSelectCustomisationProduct,
    product: null,
    commit: commit,
    translateInline: translateInline,
    setProductAnimation: setProductAnimation,
    setOpenUpsellModal: setOpenUpsellModal,
    onAddSimpleProduct: onAddSimpleProduct,
    registerAddedToCart: registerAddedToCart
  };

  //Add standalone products
  items.filter(function (category) {
    return category && category.products;
  }).forEach(function (_ref3) {
    var categoryProducts = _ref3.products;
    var categoryProductsFormatted = categoryProducts.map(function (categoryProduct) {
      var upsellProduct = getProductById({
        products: products,
        id: categoryProduct
      });
      if (!upsellProduct) {
        return null;
      }
      formatSettings.product = _extends({}, upsellProduct, {
        isUpsell: true,
        isCrossSell: isCrossSell
      });
      formatSettings.title = translateInline(upsellProduct == null ? void 0 : upsellProduct.name);
      formatSettings.registerAddedToCart = function () {
        registerProductAddToCart({
          setUpsellState: setUpsellState
        }, {
          sessionId: sessionId,
          product: upsellProduct,
          settings: settings,
          staged: _extends({}, upsellProduct, {
            count: {
              current: 1
            }
          }),
          upsell: 'upsell'
        });
      };
      var formattedProduct = formatProduct(formatSettings);
      if (formattedProduct) {
        var trackUpsell = function trackUpsell(_ref4) {
          var productId = _ref4.productId;
          setTrackedUpsells(function (trackedUpsells) {
            return [].concat(trackedUpsells, [productId]);
          });
        };
        var trackAddonsByProduct = function trackAddonsByProduct(product) {
          if ((product == null ? void 0 : product.type) === 'simple') {
            upsellAddedToCartTrack(product, kioskSettings, couponNumber, main);
          }
          setUpsellDependency(function (addonState) {
            return [].concat(addonState, [{
              productId: product == null ? void 0 : product.productId,
              main: main
            }]);
          });
        };
        var oldOnClick = formattedProduct ? formattedProduct.onClick : function () {};
        formattedProduct.onClick = function () {
          trackUpsell(formattedProduct);
          trackAddonsByProduct(formattedProduct);
          oldOnClick();
        };
        return formattedProduct;
      }
      return null;
    });
    formattedProducts.push.apply(formattedProducts, categoryProductsFormatted);
  });

  //Add whole categories
  items.filter(function (category) {
    return category && category.categories;
  }).forEach(function (_ref5) {
    var filteredCategories = _ref5.categories;
    filteredCategories.forEach(function (upsellCategory) {
      var category = categories == null ? void 0 : categories.find(function (category) {
        return "" + category.id === "" + upsellCategory;
      });
      var categoryProducts = getHydratedProductsFromCategory({
        category: category,
        hydratedProducts: products
      });
      formattedProducts.push.apply(formattedProducts, categoryProducts.map(function (categoryProduct) {
        formatSettings.product = _extends({}, categoryProduct, {
          isUpsell: true,
          isCrossSell: isCrossSell
        });
        formatSettings.title = translateInline(categoryProduct == null ? void 0 : categoryProduct.name);
        var formattedProduct = formatProduct(formatSettings);
        var trackAddonsByProduct = function trackAddonsByProduct(product) {
          upsellAddedToCartTrack(product, kioskSettings, couponNumber, main);
          setUpsellDependency(function (addonState) {
            return [].concat(addonState, [{
              productId: product == null ? void 0 : product.productId,
              main: main
            }]);
          });
        };
        var oldOnClick = formattedProduct ? formattedProduct.onClick : function () {};
        formattedProduct.onClick = function () {
          trackAddonsByProduct(formattedProduct);
          oldOnClick();
        };
        if (formattedProduct) return formattedProduct;
        return null;
      }));
    });
  });
  var handleRandomiseUpsells = function handleRandomiseUpsells(_ref6) {
    var formattedProducts = _ref6.formattedProducts,
      upsellMaxProducts = _ref6.upsellMaxProducts;
    var shuffled = [].concat(formattedProducts);
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref7 = [shuffled[j], shuffled[i]];
      shuffled[i] = _ref7[0];
      shuffled[j] = _ref7[1];
    }
    return shuffled.slice(0, upsellMaxProducts);
  };

  //It will only randomise upsells if its quantity is greater than the setting and if randomiseUpsells is true
  if (upsellMaxProducts && formattedProducts.length > upsellMaxProducts) {
    if (!randomiseUpsells) {
      return formattedProducts.slice(0, upsellMaxProducts);
    }
    return handleRandomiseUpsells({
      formattedProducts: formattedProducts,
      upsellMaxProducts: upsellMaxProducts
    });
  }
  return formattedProducts;
};
var filterUpsellProductNotInCart = function filterUpsellProductNotInCart(_temp) {
  var _ref8 = _temp === void 0 ? {} : _temp,
    product = _ref8.product,
    cart = _ref8.cart;
  return !cart.some(function (cartItem) {
    var _ref9 = product || {},
      _ref9$type = _ref9.type,
      type = _ref9$type === void 0 ? '' : _ref9$type,
      _ref9$grouped = _ref9.grouped,
      grouped = _ref9$grouped === void 0 ? [] : _ref9$grouped,
      productId = _ref9.productId;
    if (type === 'grouped') {
      return grouped.some(function (child) {
        return child.productId === cartItem.productId;
      });
    } else {
      return cartItem.productId === productId;
    }
  });
};
var formatUpsells = function formatUpsells(_temp2) {
  var _ref10 = _temp2 === void 0 ? {} : _temp2,
    upsells = _ref10.upsells,
    history = _ref10.history,
    products = _ref10.products,
    settings = _ref10.settings,
    commit = _ref10.commit,
    randomiseUpsells = _ref10.randomiseUpsells,
    onCloseGroupedProductModal = _ref10.onCloseGroupedProductModal,
    onSelectComboProduct = _ref10.onSelectComboProduct,
    onSelectCustomisationProduct = _ref10.onSelectCustomisationProduct,
    onSelectGroupedProduct = _ref10.onSelectGroupedProduct,
    translateInline = _ref10.translateInline,
    buttonActionText = _ref10.buttonActionText,
    cart = _ref10.cart,
    onAddSimpleProduct = _ref10.onAddSimpleProduct,
    upsellAddedToCartTrack = _ref10.upsellAddedToCartTrack,
    registerProductAddToCart = _ref10.registerProductAddToCart,
    sessionId = _ref10.sessionId,
    setUpsellState = _ref10.setUpsellState,
    _ref10$kioskSettings = _ref10.kioskSettings,
    kioskSettings = _ref10$kioskSettings === void 0 ? {} : _ref10$kioskSettings,
    _ref10$couponNumber = _ref10.couponNumber,
    couponNumber = _ref10$couponNumber === void 0 ? '' : _ref10$couponNumber,
    _ref10$isCrossSell = _ref10.isCrossSell,
    isCrossSell = _ref10$isCrossSell === void 0 ? false : _ref10$isCrossSell;
  return upsells.map(function (upsell) {
    var id = upsell.id,
      _upsell$name = upsell.name,
      name = _upsell$name === void 0 ? {} : _upsell$name,
      upsellProducts = upsell.products,
      _upsell$categories = upsell.categories,
      categories = _upsell$categories === void 0 ? [] : _upsell$categories;
    return {
      title: translateInline(name),
      id: id,
      buttonActionText: buttonActionText,
      products: formatUpsellProducts({
        categoryUpsells: [_extends({}, upsell, {
          products: upsellProducts
        })],
        history: history,
        categories: categories,
        products: products,
        settings: settings,
        commit: commit,
        randomiseUpsells: randomiseUpsells,
        onCloseGroupedProductModal: onCloseGroupedProductModal,
        onSelectComboProduct: onSelectComboProduct,
        onSelectCustomisationProduct: onSelectCustomisationProduct,
        onSelectGroupedProduct: onSelectGroupedProduct,
        translateInline: translateInline,
        onAddSimpleProduct: onAddSimpleProduct,
        upsellAddedToCartTrack: upsellAddedToCartTrack,
        registerProductAddToCart: registerProductAddToCart,
        sessionId: sessionId,
        setUpsellState: setUpsellState,
        kioskSettings: kioskSettings,
        couponNumber: couponNumber,
        isCrossSell: isCrossSell
      }).filter(function (product) {
        return filterUpsellProductNotInCart({
          product: product,
          cart: cart
        });
      })
    };
  });
};
var formatShowUpsellModal = function formatShowUpsellModal(_ref11) {
  var _settings$settings2, _settings$settings2$c;
  var _ref11$registerProduc = _ref11.registerProductAddToCart,
    registerProductAddToCart = _ref11$registerProduc === void 0 ? function () {} : _ref11$registerProduc,
    _ref11$upsellAddedToC = _ref11.upsellAddedToCartTrack,
    upsellAddedToCartTrack = _ref11$upsellAddedToC === void 0 ? function () {} : _ref11$upsellAddedToC,
    _ref11$setFormattedUp = _ref11.setFormattedUpsells,
    setFormattedUpsells = _ref11$setFormattedUp === void 0 ? function () {} : _ref11$setFormattedUp,
    _ref11$setOpenUpsellM = _ref11.setOpenUpsellModal,
    setOpenUpsellModal = _ref11$setOpenUpsellM === void 0 ? function () {} : _ref11$setOpenUpsellM,
    _ref11$limitUpsellMod = _ref11.limitUpsellModalToOnce,
    limitUpsellModalToOnce = _ref11$limitUpsellMod === void 0 ? true : _ref11$limitUpsellMod,
    _ref11$randomiseUpsel = _ref11.randomiseUpsells,
    randomiseUpsells = _ref11$randomiseUpsel === void 0 ? true : _ref11$randomiseUpsel,
    _ref11$setTrackedUpse = _ref11.setTrackedUpsells,
    setTrackedUpsells = _ref11$setTrackedUpse === void 0 ? function () {} : _ref11$setTrackedUpse,
    _ref11$setUpsellDepen = _ref11.setUpsellDependency,
    setUpsellDependency = _ref11$setUpsellDepen === void 0 ? function () {} : _ref11$setUpsellDepen,
    _ref11$formatSettings = _ref11.formatSettings,
    formatSettings = _ref11$formatSettings === void 0 ? function () {} : _ref11$formatSettings,
    _ref11$setUpsellState = _ref11.setUpsellState,
    setUpsellState = _ref11$setUpsellState === void 0 ? function () {} : _ref11$setUpsellState,
    _ref11$filterId = _ref11.filterId,
    filterId = _ref11$filterId === void 0 ? null : _ref11$filterId,
    _ref11$sessionId = _ref11.sessionId,
    sessionId = _ref11$sessionId === void 0 ? '' : _ref11$sessionId,
    _ref11$settings = _ref11.settings,
    settings = _ref11$settings === void 0 ? {} : _ref11$settings,
    _ref11$product = _ref11.product,
    product = _ref11$product === void 0 ? {} : _ref11$product,
    _ref11$uid = _ref11.uid,
    uid = _ref11$uid === void 0 ? null : _ref11$uid,
    _ref11$kioskSettings = _ref11.kioskSettings,
    kioskSettings = _ref11$kioskSettings === void 0 ? {} : _ref11$kioskSettings,
    _ref11$couponNumber = _ref11.couponNumber,
    couponNumber = _ref11$couponNumber === void 0 ? '' : _ref11$couponNumber;
  var formattedSettings = formatSettings(product, filterId);
  var formattedUpsellProducts = formatUpsellProducts(_extends({
    main: product,
    randomiseUpsells: randomiseUpsells,
    setTrackedUpsells: setTrackedUpsells,
    setUpsellDependency: setUpsellDependency
  }, formattedSettings, {
    upsellAddedToCartTrack: upsellAddedToCartTrack,
    registerAddedToCart: function registerAddedToCart(product) {
      registerProductAddToCart({
        setUpsellState: setUpsellState
      }, {
        sessionId: sessionId,
        product: product,
        settings: settings,
        staged: _extends({}, product, {
          count: {
            current: 1
          }
        }),
        upsell: 'upsell' // this can be hardcoded as register events from simple actions will always be correct
      });
    },
    kioskSettings: kioskSettings,
    couponNumber: couponNumber
  })).filter(function (product) {
    return !!product;
  });
  var showUpsellPopup = (settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$c = _settings$settings2.content) == null ? void 0 : _settings$settings2$c.upsellPopup) || false;
  if (formattedUpsellProducts.length === 0) {
    setOpenUpsellModal(false);
    return;
  }
  if (!showUpsellPopup && limitUpsellModalToOnce) {
    setOpenUpsellModal(false);
    return;
  }

  // UID in this case means you are editing a product already added to the cart
  // When editing an existing product is does NOT make sense to show the modal again
  if (uid) {
    setOpenUpsellModal(false);
    return;
  }

  // We should not open the modal when the current product is an upsell. Otherwise, we will have the upsell chaining (open an upsell with another upsell, with another upsell...)
  if (product.isUpsell && limitUpsellModalToOnce) {
    setOpenUpsellModal(false);
    return;
  }
  setFormattedUpsells(formattedUpsellProducts);
  setOpenUpsellModal(true);
  return;
};

var formatProduct = function formatProduct(formatSettings) {
  var _formatSettings;
  if (formatSettings === void 0) {
    formatSettings = {};
  }
  var _ref = ((_formatSettings = formatSettings) == null ? void 0 : _formatSettings.product) || {},
    type = _ref.type;
  switch (type) {
    case 'grouped':
      return formatGroupedProduct(formatSettings);
    case 'combo':
      return formatComboProduct(formatSettings);
    case 'customise':
      return formatCustomiseProduct(formatSettings);
    case 'composed':
      return formatComposedProduct(formatSettings);
    default:
      return formatSimpleProduct(formatSettings);
  }
};
var formatProductList = function formatProductList(_ref2) {
  var _ref2$registerProduct = _ref2.registerProductAddToCart,
    registerProductAddToCart = _ref2$registerProduct === void 0 ? function () {} : _ref2$registerProduct,
    _ref2$productAddedToC = _ref2.productAddedToCartTrack,
    _productAddedToCartTrack = _ref2$productAddedToC === void 0 ? function () {} : _ref2$productAddedToC,
    _ref2$setTrackedUpsel = _ref2.setTrackedUpsells,
    setTrackedUpsells = _ref2$setTrackedUpsel === void 0 ? function () {} : _ref2$setTrackedUpsel,
    _ref2$showUpsellModal = _ref2.showUpsellModal,
    showUpsellModal = _ref2$showUpsellModal === void 0 ? function () {} : _ref2$showUpsellModal,
    _ref2$setUpsellState = _ref2.setUpsellState,
    setUpsellState = _ref2$setUpsellState === void 0 ? function () {} : _ref2$setUpsellState,
    _ref2$formatSettings = _ref2.formatSettings,
    formatSettings = _ref2$formatSettings === void 0 ? function () {} : _ref2$formatSettings,
    _ref2$trackedUpsells = _ref2.trackedUpsells,
    trackedUpsells = _ref2$trackedUpsells === void 0 ? [] : _ref2$trackedUpsells,
    _ref2$sessionId = _ref2.sessionId,
    sessionId = _ref2$sessionId === void 0 ? '' : _ref2$sessionId,
    _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? {} : _ref2$settings,
    _ref2$products = _ref2.products,
    products = _ref2$products === void 0 ? [] : _ref2$products,
    _ref2$showComboSizeSe = _ref2.showComboSizeSelection,
    showComboSizeSelection = _ref2$showComboSizeSe === void 0 ? true : _ref2$showComboSizeSe,
    _ref2$trackProductVie = _ref2.trackProductViewed,
    trackProductViewed = _ref2$trackProductVie === void 0 ? function () {} : _ref2$trackProductVie,
    _ref2$couponNumber = _ref2.couponNumber,
    couponNumber = _ref2$couponNumber === void 0 ? '' : _ref2$couponNumber,
    _ref2$kioskSettings = _ref2.kioskSettings,
    kioskSettings = _ref2$kioskSettings === void 0 ? {} : _ref2$kioskSettings,
    _ref2$upsizeItemSelec = _ref2.upsizeItemSelectedTrack,
    upsizeItemSelectedTrack = _ref2$upsizeItemSelec === void 0 ? function () {} : _ref2$upsizeItemSelec,
    _ref2$itemSelectTrack = _ref2.itemSelectTrack,
    itemSelectTrack = _ref2$itemSelectTrack === void 0 ? function () {} : _ref2$itemSelectTrack,
    _ref2$cartItems = _ref2.cartItems,
    cartItems = _ref2$cartItems === void 0 ? [] : _ref2$cartItems,
    currentCategory = _ref2.currentCategory,
    _ref2$setCouponNumber = _ref2.setCouponNumber,
    setCouponNumber = _ref2$setCouponNumber === void 0 ? function () {} : _ref2$setCouponNumber,
    _ref2$setCancelledOut = _ref2.setCancelledOutOfStockModal,
    setCancelledOutOfStockModal = _ref2$setCancelledOut === void 0 ? function () {} : _ref2$setCancelledOut;
  return products == null ? void 0 : products.map(function (product) {
    var productWithCategory = _extends({}, product, {
      parentCategory: currentCategory
    });
    var formattedSettings = formatSettings(productWithCategory);
    var isSimple = (product == null ? void 0 : product.type) === 'simple';
    var isCustomisable = (product == null ? void 0 : product.type) === 'customise';
    var hydratedSettings = _extends({}, formattedSettings, {
      showComboSizeSelection: showComboSizeSelection,
      upsizeItemSelectedTrack: upsizeItemSelectedTrack,
      kioskSettings: kioskSettings,
      currentCategory: currentCategory,
      registerAddedToCart: function registerAddedToCart(product) {
        var isUpsell = trackedUpsells.includes(product.id);
        registerProductAddToCart({
          setUpsellState: setUpsellState
        }, {
          sessionId: sessionId,
          product: product,
          settings: settings,
          staged: _extends({}, product, {
            count: {
              current: 1
            }
          }),
          upsell: isUpsell ? 'upsell' : 'normal'
        });
        if (!isUpsell) {
          itemSelectTrack == null ? void 0 : itemSelectTrack(_extends({}, product, {
            count: {
              current: 1
            }
          }), cartItems, kioskSettings, couponNumber, currentCategory);
          if (isSimple) {
            _productAddedToCartTrack(_extends({}, product, {
              count: {
                current: 1
              }
            }), kioskSettings, couponNumber, currentCategory);
          }
        }
      },
      productAddedToCartTrack: function productAddedToCartTrack(product) {
        _productAddedToCartTrack(product, kioskSettings, couponNumber, currentCategory);
      }
    }, isSimple ? {
      onClickCallback: function onClickCallback() {
        return showUpsellModal({
          product: product
        });
      },
      setOpenUpsellModal: function setOpenUpsellModal() {}
    } : {
      onClickCallback: function onClickCallback() {
        return setCouponNumber('');
      }
    });
    var formattedProduct = formatProduct(hydratedSettings);
    var oldOnClick = formattedProduct.onClick;
    formattedProduct.onClick = function () {
      trackProductViewed(product.id, formattedProduct);
      setTrackedUpsells([]);
      oldOnClick();
      // Reset the flag that prevents the out-of-stock modal from reopening
      // specifically after a simple/customisable product is directly added to the cart
      // (when no customizations are involved). This ensures the modal can
      // appear again for subsequent out-of-stock scenarios.
      if (isSimple || isCustomisable) setCancelledOutOfStockModal(false);
    };
    return formattedProduct;
  }).filter(function (formattedProduct) {
    return !!formattedProduct;
  });
};

var registerProductClickAndView = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_temp) {
    var _settings$settings, _settings$settings$or;
    var _ref2, sessionId, product, settings, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _temp === void 0 ? {} : _temp, sessionId = _ref2.sessionId, product = _ref2.product, settings = _ref2.settings, upsell = _ref2.upsell;
          registerPayload = {
            sessionId: sessionId,
            position: 0,
            productVariant: 0,
            categoryName: 0,
            product: product,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$or = _settings$settings.order) == null ? void 0 : _settings$settings$or.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell
          };
          _context.prev = 2;
          _context.next = 5;
          return googleAnalytics.registerProductClick(registerPayload);
        case 5:
          _context.next = 7;
          return googleAnalytics.registerProductView(registerPayload);
        case 7:
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          logger.error('cringer.components - registerProductClickAndView - Error:', _context.t0);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return function registerProductClickAndView(_x) {
    return _ref.apply(this, arguments);
  };
}();
var registerProductAddToCart = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options, _temp2) {
    var _staged$count, _settings$settings2, _settings$settings2$o;
    var _ref4, sessionId, settings, product, staged, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _temp2 === void 0 ? {} : _temp2, sessionId = _ref4.sessionId, settings = _ref4.settings, product = _ref4.product, staged = _ref4.staged, upsell = _ref4.upsell;
          registerPayload = {
            sessionId: sessionId,
            productVariant: '',
            categoryName: '',
            product: product,
            price: product == null ? void 0 : product.price,
            quantity: staged == null ? void 0 : (_staged$count = staged.count) == null ? void 0 : _staged$count.current,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$o = _settings$settings2.order) == null ? void 0 : _settings$settings2$o.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell
          };
          _context2.prev = 2;
          _context2.next = 5;
          return googleAnalytics.registerProductAddedToCart(options, registerPayload);
        case 5:
          _context2.next = 10;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](2);
          logger.error('cringer.components - registerProductAddToCart - Error:', _context2.t0);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 7]]);
  }));
  return function registerProductAddToCart(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
var mapScalableProducts = function mapScalableProducts(productsList, defaultResponseList) {
  if (productsList === void 0) {
    productsList = [];
  }
  if (defaultResponseList === void 0) {
    defaultResponseList = [];
  }
  var scalableProductsByType = defaultResponseList;
  productsList.map(function (product) {
    if (!(product != null && product.scalable)) return;
    var scalable = product.scalable,
      id = product.id;
    var isScaleAlreadyAdded = scalableProductsByType.filter(function (scale) {
      return (scale == null ? void 0 : scale.scalable) === scalable;
    })[0];
    if (isScaleAlreadyAdded) {
      return scalableProductsByType.filter(function (scale) {
        return (scale == null ? void 0 : scale.scalable) === scalable;
      })[0].products.push({
        id: id
      });
    }
    return scalableProductsByType.push({
      scalable: scalable,
      products: [{
        id: id
      }]
    });
  });
  return scalableProductsByType;
};
var mapSelectedScalableProducts = function mapSelectedScalableProducts(productsList, defaultResponseList) {
  if (productsList === void 0) {
    productsList = [];
  }
  if (defaultResponseList === void 0) {
    defaultResponseList = [];
  }
  var scalableProductsByType = defaultResponseList;
  productsList.map(function (product) {
    if (!(product != null && product.scalable) || !(product != null && product.selected)) return;
    var scalable = product.scalable,
      id = product.id;
    var isScaleAlreadyAdded = scalableProductsByType.filter(function (scale) {
      return (scale == null ? void 0 : scale.scalable) === scalable;
    })[0];
    if (isScaleAlreadyAdded) {
      return scalableProductsByType.filter(function (scale) {
        return (scale == null ? void 0 : scale.scalable) === scalable;
      })[0].products.push({
        id: id
      });
    }
    return scalableProductsByType.push({
      scalable: scalable,
      products: [{
        id: id
      }]
    });
  });
  return scalableProductsByType;
};

var computePrevPath = function computePrevPath(categoryId, categories, previousPath) {
  var _categories;
  if (categories === void 0) {
    categories = [];
  }
  if (previousPath === void 0) {
    previousPath = '/categories';
  }
  if (!categoryId || (categories || []).length === 0) return previousPath;
  var category = (_categories = categories) == null ? void 0 : _categories.find(function (x) {
    return x.id == categoryId;
  });
  if (!category) return previousPath;
  var parent = category.parent || [0];
  var subCategoryId = parent[0];
  if (!subCategoryId) return previousPath;
  return "/categories/" + subCategoryId;
};
var nextAction = function nextAction(_ref, orderCompletedTrack) {
  var history = _ref.history,
    nextPath = _ref.nextPath;
  return function () {
    orderCompletedTrack();
    history.push(nextPath);
  };
};
var useCategoryView = function useCategoryView(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$nextPath = _ref2.nextPath,
    nextPath = _ref2$nextPath === void 0 ? '/customer-details' : _ref2$nextPath,
    _ref2$showCategoriesH = _ref2.showCategoriesHeader,
    showCategoriesHeader = _ref2$showCategoriesH === void 0 ? false : _ref2$showCategoriesH,
    _ref2$limitUpsellModa = _ref2.limitUpsellModalToOnce,
    limitUpsellModalToOnce = _ref2$limitUpsellModa === void 0 ? true : _ref2$limitUpsellModa,
    _ref2$randomiseUpsell = _ref2.randomiseUpsells,
    randomiseUpsells = _ref2$randomiseUpsell === void 0 ? true : _ref2$randomiseUpsell,
    _ref2$hideMiniCartMod = _ref2.hideMiniCartModal,
    hideMiniCartModal = _ref2$hideMiniCartMod === void 0 ? false : _ref2$hideMiniCartMod,
    _ref2$shouldSkipCusto = _ref2.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref2$shouldSkipCusto === void 0 ? false : _ref2$shouldSkipCusto;
  var customerSkipPath = '/validate';
  var previousPath = '/categories';
  var showPriceWarning = true;
  var menuPath = '/categories';
  var displayDescription = true;
  var showComboSizeSelection = true;
  var isCustomisationHeaderEnabled = false;
  var isCustomiseCategoryTitleEnabled = true;
  var isCategoryTotalizerEnabled = true;
  var isAdditionalMessageEnabled = true;
  var showQuantityControllerLabel = false;
  var placeholder = null;
  var showAddonAvailability = false;
  var showEnergyInformationSeparated = false;
  var showModifierEnergyInformation = false;
  var titleSeparator = ' ';
  var disableModifyUpsellOnCart = false;
  var hideDisabledButtons = false;
  var hidePriceWhenQuantityLessOrEqualDefault = false;
  var hidePriceWhenZero = false;
  var showLoyaltyBanner = true;
  var propsGalleryMaxColumns = 3;
  var shouldChangeAddButtonText = false;
  var isCouponQuantityDisabled = false;
  var _useState = React.useState(false),
    showMiniCartModal = _useState[0],
    setShowMiniCartModal = _useState[1];
  var _useState2 = React.useState(false),
    openGroupedProductModal = _useState2[0],
    setOpenGroupedProductModal = _useState2[1];
  var _useState3 = React.useState(null),
    groupedProductSelected = _useState3[0],
    setGroupedProductSelected = _useState3[1];
  var _useState4 = React.useState(false),
    openComboProductModal = _useState4[0],
    setOpenComboProductModal = _useState4[1];
  var _useState5 = React.useState(null),
    comboProductSelected = _useState5[0],
    setComboProductSelected = _useState5[1];
  var _useState6 = React.useState(false),
    openProductCustomisationModal = _useState6[0],
    setOpenProductCustomisationModal = _useState6[1];
  var _useState7 = React.useState(null),
    customisationProductSelected = _useState7[0],
    setCustomisationProductSelected = _useState7[1];
  var _useState8 = React.useState(false),
    openUpsellModal = _useState8[0],
    setOpenUpsellModal = _useState8[1];
  var _useState9 = React.useState(null),
    formattedUpsells = _useState9[0],
    setFormattedUpsells = _useState9[1];
  var _useState10 = React.useState(false),
    openOutOfStockModal = _useState10[0],
    setOpenOutOfStockModal = _useState10[1];
  var _useState11 = React.useState(false),
    cancelledOutOfStockModal = _useState11[0],
    setCancelledOutOfStockModal = _useState11[1];
  var _useState12 = React.useState(null),
    staged = _useState12[0],
    setStaged = _useState12[1];
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var _useRecoilValue = recoil.useRecoilValue(atoms.computedMetadata),
    currency = _useRecoilValue.currency;
  var _useRecoilState = recoil.useRecoilState(atoms.sessionState),
    session = _useRecoilState[0];
  var _useRecoilState2 = recoil.useRecoilState(atoms.settingsState),
    settings = _useRecoilState2[0];
  var _useRecoilState3 = recoil.useRecoilState(atoms.categoryState),
    categoryId = _useRecoilState3[0],
    setCategoryId = _useRecoilState3[1];
  var _useRecoilState4 = recoil.useRecoilState(atoms.trackedUpsellsState),
    trackedUpsells = _useRecoilState4[0],
    setTrackedUpsells = _useRecoilState4[1];
  var _useRecoilState5 = recoil.useRecoilState(atoms.addedUpsellState),
    upsellDependency = _useRecoilState5[0],
    setUpsellDependency = _useRecoilState5[1];
  var _useRecoilState6 = recoil.useRecoilState(atoms.openCondAddonModalState),
    openCondAddonModal = _useRecoilState6[0],
    setOpenCondAddonModal = _useRecoilState6[1];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var setRemovedUpsells = recoil.useSetRecoilState(atoms.removedUpsellState);
  var setProductAnimation = recoil.useSetRecoilState(atoms.productAnimationState);
  var isDeliverectProvider = recoil.useRecoilValue(atoms.isDeliverectProviderState);
  var caloriesBannerEnabled = utilities.useSettingsAtPath({
    path: 'settings.content.caloriesBannerEnabled',
    defaultValue: false
  });
  var caloriesBannerTranslations = utilities.useSettingsAtPath({
    path: 'settings.content.caloriesBannerTranslations',
    defaultValue: []
  });
  var bannerEnabled = utilities.useSettingsAtPath({
    path: 'settings.content.bannerEnabled',
    defaultValue: false
  });
  var bannerTitle = utilities.useSettingsAtPath({
    path: 'settings.content.bannerTitle',
    defaultValue: ''
  });
  var bannerSubTitle = utilities.useSettingsAtPath({
    path: 'settings.content.bannerSubTitle',
    defaultValue: ''
  });
  var bannerImage = utilities.useSettingsAtPath({
    path: 'settings.content.bannerImage',
    defaultValue: ''
  });
  var disableCustomisation = utilities.useSettingsAtPath({
    path: 'settings.content.disableCustomisation',
    defaultValue: false
  });
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var beaconOrderNumberEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beaconOrderNumber',
    defaultValue: false
  });
  var flags = launchdarklyReactClientSdk.useFlags();
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count,
    total = _useRestaurantCart.total;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var _useRestaurantMenu = useRestaurantMenu(),
    loading = _useRestaurantMenu.loading,
    products = _useRestaurantMenu.products,
    categories = _useRestaurantMenu.categories,
    menuState = _useRestaurantMenu.state,
    promotions = _useRestaurantMenu.promotions;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    offersAndRewards = _useOffersAndRewardsM.offersAndRewards;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useOrigin = useOrigin(),
    origin = _useOrigin.origin,
    setOrigin = _useOrigin.setOrigin;
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    upsellAddedToCartTrack = _useAnalytics.upsellAddedToCartTrack,
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    orderViewedTrack = _useAnalytics.orderViewedTrack,
    productViewedTrack = _useAnalytics.productViewedTrack,
    upsizeItemSelectedTrack = _useAnalytics.upsizeItemSelectedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n,
    currentLanguage = _useLocaleSelection.currentLanguage;
  var history = reactRouterDom.useHistory();
  var _useParams = reactRouterDom.useParams(),
    id = _useParams.id;
  var location = reactRouterDom.useLocation();
  var _useCart = cart.useCart(),
    commit = _useCart.commit;
  var _ref3 = i18n || {},
    language = _ref3.language;
  var translateInline = translateProductName(language);

  // adjust id for rewards and rewards route
  if (location.pathname === '/category/rewards') {
    id = 'rewards';
  }
  if (location.pathname === '/category/offers') {
    id = 'offers';
  }
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath || beaconOrderNumberEnabled || !!customer ? customerSkipPath : nextPath;
  var computedPrevPath = computePrevPath(categoryId, categories, previousPath);
  var showBanner = bannerEnabled && bannerTitle;
  var nextText = React.useMemo(function () {
    return t('categoryNextAction');
  }, [t]);
  var previousText = React.useMemo(function () {
    return t('categoryPreviousAction');
  }, [t]);
  var originPath = React.useMemo(function () {
    return "/category/" + categoryId;
  }, [categoryId]);
  var upsells = React.useMemo(function () {
    return (promotions == null ? void 0 : promotions.upsells) || [];
  }, [promotions]);
  var allowNextAction = React.useMemo(function () {
    return count > 0;
  }, [count]);
  var caloriesBannerDescription = React.useMemo(function () {
    var _foundTranslation$des;
    //For now we are translating from EN to UK (because KAS uses UK ans kiosk uses EN...). It was created a tech debt to refactor this https://fingermarkglobal.atlassian.net/browse/S2-3767
    var language = (currentLanguage == null ? void 0 : currentLanguage.toUpperCase()) === 'EN' ? 'UK' : currentLanguage;
    var foundTranslation = caloriesBannerTranslations == null ? void 0 : caloriesBannerTranslations.find(function (caloriesBannerTranslationItem) {
      var _caloriesBannerTransl;
      return (caloriesBannerTranslationItem == null ? void 0 : (_caloriesBannerTransl = caloriesBannerTranslationItem.language) == null ? void 0 : _caloriesBannerTransl.toUpperCase()) === (language == null ? void 0 : language.toUpperCase());
    });
    return foundTranslation ? foundTranslation == null ? void 0 : (_foundTranslation$des = foundTranslation.description) == null ? void 0 : _foundTranslation$des.substring(0, 350) : '';
  }, [caloriesBannerTranslations, currentLanguage]);

  // Stop 'flash' of old products
  var category = React.useMemo(function () {
    return categories == null ? void 0 : categories.find(function (item) {
      return "" + item.categoryId === "" + categoryId;
    });
  }, [categories, categoryId]);
  var isCategoryFullWidth = React.useMemo(function () {
    return !!(category != null && category.isFullWidth);
  }, [category]);
  var galleryMaxColumns = isCategoryFullWidth ? 1 : propsGalleryMaxColumns;
  var productsFromCategory = React.useMemo(function () {
    return getHydratedProductsFromCategory({
      category: category,
      id: id,
      hydratedProducts: products,
      offersAndRewards: offersAndRewards
    });
  }, [category, id, products, offersAndRewards]);
  var sessionId = React.useMemo(function () {
    return session == null ? void 0 : session.id;
  }, [session]);
  var ready = React.useMemo(function () {
    return id === categoryId;
  }, [id, categoryId]);
  var title = React.useMemo(function () {
    return translateInline(category == null ? void 0 : category.name) || '';
  }, [category, translateInline]);
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  var trackProductViewed = React.useCallback(function (id, product) {
    productViewedTrack(id, product, currency, kioskSettings.kiosk, couponNumber, currentCategory);
  }, [currency, productViewedTrack, kioskSettings.kiosk, couponNumber, currentCategory]);
  var previousAction = React.useCallback(function () {
    history.push(computedPrevPath);
  }, [history, computedPrevPath]);
  var onCloseProductCustomisationModal = React.useCallback(function () {
    return setOpenProductCustomisationModal(null);
  }, [setOpenProductCustomisationModal]);
  var onCloseUpsellModal = React.useCallback(function () {
    setOpenUpsellModal(false);
  }, [setOpenUpsellModal]);
  var onCloseGroupedProductModal = React.useCallback(function () {
    setGroupedProductSelected(null);
    setOpenGroupedProductModal(false);
  }, [setGroupedProductSelected, setOpenGroupedProductModal]);
  var onSelectGroupedProduct = React.useCallback(function (product) {
    var updatedGrouped = product.grouped.map(function (item) {
      if (item.type === 'simple') {
        return _extends({}, item, {
          onClick: function onClick() {
            if (product.isUpsell) {
              var mainProduct = upsellDependency.find(function (upsell) {
                return upsell.productId === product.productId;
              });
              upsellAddedToCartTrack(item, kioskSettings.kiosk, couponNumber, (mainProduct == null ? void 0 : mainProduct.main) || product);
            }
            item.onClick();
          }
        });
      }
      return item;
    });
    var updatedProduct = _extends({}, product, {
      grouped: updatedGrouped
    });
    setGroupedProductSelected(updatedProduct);
    setOpenGroupedProductModal(true);
  }, [setGroupedProductSelected, setOpenGroupedProductModal, kioskSettings.kiosk, couponNumber, upsellAddedToCartTrack, upsellDependency]);
  var onCloseComboProductModal = React.useCallback(function () {
    setComboProductSelected(null);
    setOpenComboProductModal(false);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onSelectComboProduct = React.useCallback(function (product) {
    setComboProductSelected(product);
    setOpenComboProductModal(true);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onSelectCustomisationProduct = React.useCallback(function (product) {
    setCustomisationProductSelected(product);
    setOpenProductCustomisationModal(!!disableCustomisation ? 'directAdd' : 'customise');
  }, [disableCustomisation, setCustomisationProductSelected, setOpenProductCustomisationModal]);
  var onCloseOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(false);
    if (disableCustomisation) setCancelledOutOfStockModal(true);
  }, [setOpenOutOfStockModal, setCancelledOutOfStockModal, disableCustomisation]);
  var showOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(true);
  }, [setOpenOutOfStockModal]);
  var onForceSelectCustomisationProduct = React.useCallback(function (product) {
    setCustomisationProductSelected(product);
    setOpenProductCustomisationModal('customise');
  }, [setCustomisationProductSelected, setOpenProductCustomisationModal]);
  var onCloseMiniCartModal = React.useCallback(function (_ref4) {
    var updatedStaged = _ref4.updatedStaged;
    if (updatedStaged) onForceSelectCustomisationProduct(updatedStaged);
    setShowMiniCartModal(false);
  }, [setShowMiniCartModal, onForceSelectCustomisationProduct]);
  var onCloseAddonRemovedModal = React.useCallback(function () {
    setOpenCondAddonModal(false);
    setRemovedUpsells([]);
  }, [setOpenCondAddonModal, setRemovedUpsells]);
  var onConfirmMiniCartModal = React.useCallback(function () {
    orderCompletedTrack();
    history.push(computedNextPath);
  }, [history, computedNextPath, orderCompletedTrack]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
      orderViewedTrack(cartItems, kioskSettings.kiosk, orderTotal, couponNumber);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal, orderViewedTrack, cartItems, kioskSettings.kiosk, orderTotal, couponNumber]);
  var formatSettings = React.useCallback(function (product, filterId) {
    if (filterId === void 0) {
      filterId = null;
    }
    var categoryUpsells = getUpsellCategoryById(upsells, categoryId, filterId);
    var productUpsells = getUpsellCategoryById(upsells, product == null ? void 0 : product.productId, filterId);
    return {
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      onCloseGroupedProductModal: onCloseGroupedProductModal,
      onSelectGroupedProduct: onSelectGroupedProduct,
      onSelectComboProduct: onSelectComboProduct,
      setProductAnimation: setProductAnimation,
      setOpenUpsellModal: setOpenUpsellModal,
      translateInline: translateInline,
      categoryUpsells: categoryUpsells,
      productUpsells: productUpsells,
      categories: categories,
      categoryId: categoryId,
      products: products,
      settings: settings,
      history: history,
      product: product,
      commit: commit,
      title: translateInline(product == null ? void 0 : product.name)
    };
  }, [onSelectCustomisationProduct, onCloseGroupedProductModal, onSelectGroupedProduct, onSelectComboProduct, setProductAnimation, setOpenUpsellModal, translateInline, categories, categoryId, products, settings, upsells, history, commit]);
  var showUpsellModal = React.useCallback(function (_ref5) {
    var product = _ref5.product,
      _ref5$uid = _ref5.uid,
      uid = _ref5$uid === void 0 ? null : _ref5$uid,
      _ref5$filterId = _ref5.filterId,
      filterId = _ref5$filterId === void 0 ? null : _ref5$filterId;
    return formatShowUpsellModal({
      formatSettings: formatSettings,
      setTrackedUpsells: setTrackedUpsells,
      setUpsellDependency: setUpsellDependency,
      registerProductAddToCart: registerProductAddToCart,
      upsellAddedToCartTrack: upsellAddedToCartTrack,
      flags: flags,
      setUpsellState: setUpsellState,
      sessionId: sessionId,
      settings: settings,
      setOpenUpsellModal: setOpenUpsellModal,
      uid: uid,
      product: product,
      randomiseUpsells: randomiseUpsells,
      limitUpsellModalToOnce: limitUpsellModalToOnce,
      setFormattedUpsells: setFormattedUpsells,
      filterId: filterId,
      kioskSettings: kioskSettings.kiosk,
      couponNumber: couponNumber
    });
  }, [settings, formatSettings, setOpenUpsellModal, setFormattedUpsells, flags, sessionId, setUpsellState, setTrackedUpsells, limitUpsellModalToOnce, randomiseUpsells, upsellAddedToCartTrack, setUpsellDependency, kioskSettings.kiosk, couponNumber]);
  var onConfirmProductCustomisationModal = React.useCallback(function (_ref6) {
    var product = _ref6.product,
      staged = _ref6.staged,
      _ref6$animate = _ref6.animate,
      animate = _ref6$animate === void 0 ? true : _ref6$animate,
      _ref6$uid = _ref6.uid,
      uid = _ref6$uid === void 0 ? null : _ref6$uid;
    var formattedSettings = formatSettings(product);
    setOpenOutOfStockModal(null);
    setOpenProductCustomisationModal(null);
    setCancelledOutOfStockModal(false);
    if (product.isUpsell) {
      // find main upsell item
      var mainProduct = upsellDependency.find(function (upsell) {
        return upsell.productId === product.productId;
      });
      upsellAddedToCartTrack(product, kioskSettings.kiosk, couponNumber, (mainProduct == null ? void 0 : mainProduct.main) || product);
    }
    if (animate) setProductAnimation(formatProduct(formattedSettings));
    commit({
      staged: staged
    });
    showUpsellModal({
      uid: uid,
      product: product
    });
  }, [setOpenProductCustomisationModal, upsellAddedToCartTrack, setProductAnimation, kioskSettings.kiosk, showUpsellModal, formatSettings, couponNumber, commit, upsellDependency]);
  React.useEffect(function () {
    if (count && origin && !origin.includes('category') && !origin.includes('validate') && !origin.includes('offers') && !openProductCustomisationModal && !hideMiniCartModal) {
      setShowMiniCartModal(true);
    }
    setCategoryId(id);
  }, [id, setCategoryId, setShowMiniCartModal, count, setOrigin, origin, openUpsellModal, openProductCustomisationModal, hideMiniCartModal]);
  var formattedProducts = React.useMemo(function () {
    return formatProductList({
      products: productsFromCategory,
      formatSettings: formatSettings,
      registerProductAddToCart: registerProductAddToCart,
      productAddedToCartTrack: productAddedToCartTrack,
      flags: flags,
      setUpsellState: setUpsellState,
      sessionId: sessionId,
      settings: settings,
      trackedUpsells: trackedUpsells,
      showUpsellModal: showUpsellModal,
      setTrackedUpsells: setTrackedUpsells,
      showComboSizeSelection: showComboSizeSelection,
      trackProductViewed: trackProductViewed,
      couponNumber: couponNumber,
      kioskSettings: kioskSettings.kiosk,
      upsizeItemSelectedTrack: upsizeItemSelectedTrack,
      itemSelectTrack: itemSelectTrack,
      cartItems: cartItems,
      currentCategory: currentCategory,
      setCancelledOutOfStockModal: setCancelledOutOfStockModal
    });
  }, [formatSettings, showUpsellModal, productsFromCategory, flags, settings, sessionId, setUpsellState, trackedUpsells, setTrackedUpsells, showComboSizeSelection, productAddedToCartTrack, trackProductViewed, couponNumber, kioskSettings.kiosk, upsizeItemSelectedTrack, itemSelectTrack, cartItems, currentCategory]);
  React.useEffect(function () {
    var _location$state, _location$state2;
    if (location != null && location.state && location != null && (_location$state = location.state) != null && _location$state.product && !((_location$state2 = location.state) != null && _location$state2.uid)) {
      var _location$state3, _location$state4;
      showUpsellModal({
        product: location == null ? void 0 : (_location$state3 = location.state) == null ? void 0 : _location$state3.product,
        filterId: location == null ? void 0 : (_location$state4 = location.state) == null ? void 0 : _location$state4.filterId
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  React.useEffect(function () {
    var header = {
      title: title,
      menuAction: menuAction,
      previousText: previousText,
      onBasketClick: onBasketClick,
      showCategoriesHeader: showCategoriesHeader,
      previousAction: previousAction,
      allowPreviousAction: true,
      nextAction: nextAction({
        history: history,
        nextPath: computedNextPath
      }, orderCompletedTrack),
      nextText: nextText,
      allowNextAction: allowNextAction,
      showCouponButton: true,
      showLoyaltyBanner: showLoyaltyBanner
    };
    var footer = {
      showMiniCartSlider: true,
      nextAction: nextAction({
        history: history,
        nextPath: computedNextPath
      }, orderCompletedTrack),
      nextText: nextText,
      previousAction: previousAction,
      allowNextAction: allowNextAction,
      previousText: previousText,
      enableCancelOrder: true,
      onBasketClick: onBasketClick,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      showCouponButton: true,
      caloriesBannerEnabled: caloriesBannerEnabled,
      caloriesBannerDescription: caloriesBannerDescription,
      t: t
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [title, computedPrevPath, history, setTemplate, nextText, allowNextAction, computedNextPath, orderCompletedTrack, showCategoriesHeader, previousText, onBasketClick, previousAction, menuAction, categoryId, onSelectCustomisationProduct, caloriesBannerEnabled, caloriesBannerDescription, t, showLoyaltyBanner]);
  return {
    ready: ready,
    loading: loading,
    menuState: menuState,
    formattedProducts: formattedProducts,
    openGroupedProductModal: openGroupedProductModal,
    t: t,
    onCloseGroupedProductModal: onCloseGroupedProductModal,
    groupedProductSelected: groupedProductSelected,
    openComboProductModal: openComboProductModal,
    onCloseComboProductModal: onCloseComboProductModal,
    comboProductSelected: comboProductSelected,
    customisationProductSelected: customisationProductSelected,
    openProductCustomisationModal: openProductCustomisationModal,
    onCloseProductCustomisationModal: onCloseProductCustomisationModal,
    onConfirmProductCustomisationModal: onConfirmProductCustomisationModal,
    openUpsellModal: openUpsellModal,
    formattedUpsells: formattedUpsells,
    onCloseUpsellModal: onCloseUpsellModal,
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    displayDescription: displayDescription,
    showPriceWarning: showPriceWarning,
    total: total,
    showComboSizeSelection: showComboSizeSelection,
    showMiniCartModal: showMiniCartModal,
    onCloseMiniCartModal: onCloseMiniCartModal,
    onConfirmMiniCartModal: onConfirmMiniCartModal,
    originPath: originPath,
    formatPrice: formatPrice,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    isCustomiseCategoryTitleEnabled: isCustomiseCategoryTitleEnabled,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    showQuantityControllerLabel: showQuantityControllerLabel,
    galleryMaxColumns: galleryMaxColumns,
    showBanner: showBanner,
    bannerTitle: bannerTitle,
    bannerSubTitle: bannerSubTitle,
    bannerImage: bannerImage,
    placeholder: placeholder,
    showAddonAvailability: showAddonAvailability,
    showEnergyInformationSeparated: showEnergyInformationSeparated,
    showModifierEnergyInformation: showModifierEnergyInformation,
    openCondAddonModal: openCondAddonModal,
    onCloseAddonRemovedModal: onCloseAddonRemovedModal,
    titleSeparator: titleSeparator,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    hideDisabledButtons: hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero,
    offersAndRewards: offersAndRewards,
    products: products,
    shouldChangeAddButtonText: shouldChangeAddButtonText,
    isCouponQuantityDisabled: isCouponQuantityDisabled,
    isDeliverectProvider: isDeliverectProvider,
    openOutOfStockModal: openOutOfStockModal,
    showOutOfStockModal: showOutOfStockModal,
    onCloseOutOfStockModal: onCloseOutOfStockModal,
    cancelledOutOfStockModal: cancelledOutOfStockModal,
    staged: staged,
    setStaged: setStaged
  };
};

var CartViewContext = /*#__PURE__*/React.createContext();
var CartViewProvider = function CartViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx(CartViewContext.Provider, {
    children: children
  });
};
var useCartViewContext = function useCartViewContext() {
  var context = React.useContext(CartViewContext);
  if (context === undefined) {
    throw new Error('useCartViewContext must be used within a CartViewProvider');
  }
  return context;
};

var useCartView = function useCartView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? false : _ref$showCategoriesHe,
    _ref$randomiseUpsells = _ref.randomiseUpsells,
    randomiseUpsells = _ref$randomiseUpsells === void 0 ? true : _ref$randomiseUpsells,
    _ref$crossSellEnabled = _ref.crossSellEnabled,
    crossSellEnabled = _ref$crossSellEnabled === void 0 ? false : _ref$crossSellEnabled,
    _ref$upsellEnabled = _ref.upsellEnabled,
    upsellEnabled = _ref$upsellEnabled === void 0 ? false : _ref$upsellEnabled;
  var nextPath = '/payment-options';
  var onChangeTimeout = 1500;
  var showPriceWarning = true;
  var menuPath = '/categories';
  var onChangePath = '/validate';
  var previousPath = '/categories';
  var onEmptyCartReturnPath = '/categories';
  var showEnergyInformation = false;
  var isCustomisationHeaderEnabled = false;
  var isCategoryTotalizerEnabled = true;
  var isAdditionalMessageEnabled = true;
  var showQuantityControllerLabel = false;
  var isConcatUpsellProductsEnabled = false;
  var showAddonAvailability = false;
  var disableModifyUpsellOnCart = false;
  var hideDisabledButtons = false;
  var hidePriceWhenQuantityLessOrEqualDefault = false;
  var hidePriceWhenZero = false;
  var showLoyaltyBanner = true;
  var hideNoPrefixWhenDefaultNotSelected = true;
  var showCrossSellCategoryTitle = false;
  var showOrderTotalSummary = false;
  var hideComboProductsUnitPrice = false;
  var isCouponQuantityDisabled = false;
  var alignButtons = false;
  var _useState = React.useState(false),
    openProductCustomisationModal = _useState[0],
    setOpenProductCustomisationModal = _useState[1];
  var _useState2 = React.useState(null),
    customisationProductSelected = _useState2[0],
    setCustomisationProductSelected = _useState2[1];
  var _useState3 = React.useState(false),
    openGroupedProductModal = _useState3[0],
    setOpenGroupedProductModal = _useState3[1];
  var _useState4 = React.useState(null),
    groupedProductSelected = _useState4[0],
    setGroupedProductSelected = _useState4[1];
  var _useState5 = React.useState(false),
    openComboProductModal = _useState5[0],
    setOpenComboProductModal = _useState5[1];
  var _useState6 = React.useState(null),
    comboProductSelected = _useState6[0],
    setComboProductSelected = _useState6[1];
  var _useState7 = React.useState([]),
    crossSellCategories = _useState7[0],
    setCrossSellCategory = _useState7[1];
  var _useState8 = React.useState(false),
    openOutOfStockModal = _useState8[0],
    setOpenOutOfStockModal = _useState8[1];
  var _useState9 = React.useState(null),
    staged = _useState9[0],
    setStaged = _useState9[1];
  var _useRecoilState = recoil.useRecoilState(atoms.openCondAddonModalState),
    openCondAddonModal = _useRecoilState[0],
    setOpenCondAddonModal = _useRecoilState[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.sessionState),
    session = _useRecoilState2[0];
  var _useRecoilState3 = recoil.useRecoilState(atoms.menuBrandState),
    menuBrand = _useRecoilState3[0],
    setMenuBrand = _useRecoilState3[1];
  var resetValidatedOrderPayloadState = recoil.useResetRecoilState(atoms.validatedOrderPayloadState);
  var resetRemovedUpsells = recoil.useResetRecoilState(atoms.removedUpsellState);
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var setOrderServerTotal = recoil.useSetRecoilState(atoms.orderServerTotalState);
  var isDeliverectProvider = recoil.useRecoilValue(atoms.isDeliverectProviderState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var orderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState);
  var upsellDependency = recoil.useRecoilValue(atoms.addedUpsellState);
  var categories = recoil.useRecoilValue(atoms.categoriesState);
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useAnalytics = jitsu.useAnalytics(),
    upsellAddedToCartTrack = _useAnalytics.upsellAddedToCartTrack,
    beginCheckoutTrack = _useAnalytics.beginCheckoutTrack,
    cartItemEditTrack = _useAnalytics.cartItemEditTrack;
  var _useRestaurantMenu = useRestaurantMenu(),
    loading = _useRestaurantMenu.loading,
    products = _useRestaurantMenu.products,
    menuState = _useRestaurantMenu.state,
    promotions = _useRestaurantMenu.promotions,
    settings = _useRestaurantMenu.settings;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useCart = cart.useCart(),
    commit = _useCart.commit;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var history = reactRouterDom.useHistory();
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var _useOrigin = useOrigin(),
    setOrigin = _useOrigin.setOrigin;
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count,
    onCartUpdateHandler = _useRestaurantCart.onCartUpdateHandler,
    cartUpdateCount = _useRestaurantCart.cartUpdateCount,
    isCartProductsAvailable = _useRestaurantCart.isCartProductsAvailable,
    isCartValidated = _useRestaurantCart.isCartValidated,
    formattedCart = _useRestaurantCart.formattedCart,
    cartTotal = _useRestaurantCart.total,
    items = _useRestaurantCart.items;
  var translateInline = translateProductName(language);
  var _ref3 = promotions || {},
    _ref3$upsells = _ref3.upsells,
    upsells = _ref3$upsells === void 0 ? [] : _ref3$upsells;
  var title = t('cartTitle');
  var previousText = t('cartPreviousAction');
  var nextText = t('cartNextAction');
  var cancelOrderText = t('cartCancelOrderAction');
  var menuText = t('menuAction');
  var sessionId = React.useMemo(function () {
    return session == null ? void 0 : session.id;
  }, [session]);
  var loyaltyRewardsEnabled = utilities.useSettingsAtPath({
    path: 'settings.loyalty.enablePromosWithPoints',
    defaultValue: false
  });
  React.useEffect(function () {
    var crossSellCategoryId = process.env.POI_APP_CROSS_SELL_CATEGORY_ID;
    var crossSells = categories == null ? void 0 : categories.filter(function (category) {
      return crossSellCategoryId && category.id === crossSellCategoryId;
    });
    if (crossSells) {
      setCrossSellCategory(crossSells);
    }
  }, [categories, setCrossSellCategory]);
  React.useEffect(function () {
    setOrderServerTotal(cartOrderSummary.total);
  }, [setOrderServerTotal, cartOrderSummary]);
  reactUse.useDebounce(function () {
    if ((state || cartUpdateCount) && count > 0 && onChangePath) {
      /**
       * history.listen is not listening to this history event,
       * and by that it doesn't trigger the resetValidatedOrderPayloadState at the useEffect,
       * likely due to the timeout at this debounce hook, that's the reason to
       * resetValidatedOrderPayloadState here when the cart is updated.
       */
      resetValidatedOrderPayloadState();
      history.push(onChangePath);
    }
  }, onChangeTimeout, [cartUpdateCount]);
  React.useEffect(function () {
    /**
     * Reset the order payload when the nextPath is different from the current path
     * Ex: when we customize a combo, or when we select a product on the category slider
     */
    var disconnect = history.listen(function (_ref4) {
      var pathname = _ref4.pathname;
      if (pathname.includes(nextPath)) return;
      resetValidatedOrderPayloadState();
    });
    return disconnect;
  }, [history, nextPath, resetValidatedOrderPayloadState]);
  var nextAction = React.useCallback(function () {
    beginCheckoutTrack(items, kioskSettings == null ? void 0 : kioskSettings.kiosk, cartTotal, couponNumber, session == null ? void 0 : session.type, upsellDependency);
    history.push(nextPath);
  }, [history, nextPath, couponNumber, beginCheckoutTrack, items, kioskSettings.kiosk, cartTotal, session.type, upsellDependency]);
  var previousAction = React.useCallback(function () {
    history.push(previousPath);
  }, [history, previousPath]);
  var onEmptyCartReturn = function onEmptyCartReturn() {
    setOrigin(null);
    history.push(onEmptyCartReturnPath);
  };
  var onSelectCustomisationProduct = React.useCallback(function (product) {
    setCustomisationProductSelected(product);
    setOpenProductCustomisationModal(true);
  }, [setCustomisationProductSelected, setOpenProductCustomisationModal]);
  var onEditProductHandler = function onEditProductHandler(product) {
    return function () {
      var _product$type = product.type,
        type = _product$type === void 0 ? '' : _product$type,
        _product$uid = product.uid,
        uid = _product$uid === void 0 ? '' : _product$uid,
        _product$dualBrand = product.dualBrand,
        dualBrand = _product$dualBrand === void 0 ? '' : _product$dualBrand;
      handleChangeMenuBrandStateTheme(dualBrand, menuBrand, setMenuBrand);
      cartItemEditTrack(kioskSettings.kiosk);

      /**
       * Every time we leave the cart page and are not going to the next path (payment), we call resetValidatedOrderPayloadState
       * you can see this happening on line 102 of the useEffect cleanUp function
       *
       * As a result, every time we go back to the cart, we need to validate the order payload again
       * the "/validate" route is responsible for this, so we need to go back to that route
       *
       * That's why we're using the origin as onChangePath = '/validate' and not '/cart'.
       */
      setOrigin(onChangePath);
      switch (type) {
        case 'combo':
          return history.push("/product/" + product.productId + "/combo/" + product.id + "/cart/" + uid);
        case 'customise':
          return onSelectCustomisationProduct(product);
        default:
          history.push("/product/" + product.productId);
      }
    };
  };
  var allowNextAction = React.useMemo(function () {
    // do not allow if the cart update counter isn't 0 because it means the order should be re-validated
    if (cartUpdateCount) return false;
    // do not allow if cart is empty
    if (!formattedCart || !formattedCart.length) return false;
    // do not allow if products aren't available or validated after api validation step (pre order)
    if (!isCartProductsAvailable || !isCartValidated) return false;
    // if total is 0 (in case there are free products in the cart, we can only allow payment if theres a paid product alongside)
    if (cartTotal === 0) {
      if (!loyaltyRewardsEnabled) {
        return false;
      }
      var isEveryCartItemOnPromoOffer = formattedCart.every(function (item) {
        return item.providerData.PromoId;
      });
      return isEveryCartItemOnPromoOffer;
    }
    // if no total is set, don't allow payment
    if (!cartTotal) return false;
    // do not allow if state is not undefined (this means that the previous screen was /coupon)
    if (state) return false;
    return true;
  }, [cartUpdateCount, formattedCart, isCartProductsAvailable, isCartValidated, cartTotal, state, loyaltyRewardsEnabled]);
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  React.useEffect(function () {
    var header = {
      title: title,
      menuText: menuText,
      menuAction: menuAction,
      origin: "/cart",
      showCategoriesHeader: showCategoriesHeader,
      isViewOrderDisabled: true,
      previousText: previousText,
      previousAction: previousAction,
      showCouponButton: true,
      showLoyaltyBanner: showLoyaltyBanner
    };
    var footer = {
      nextAction: nextAction,
      nextText: nextText,
      allowNextAction: allowNextAction,
      previousAction: previousAction,
      previousText: previousText,
      enableCancelOrder: true,
      cancelOrderText: cancelOrderText,
      isViewOrderDisabled: true,
      nextActionClass: 'restaurant-cart-secondary-button',
      showCouponButton: true
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [nextAction, setTemplate, previousAction, title, previousText, nextText, allowNextAction, cancelOrderText, menuAction, menuText, showCategoriesHeader, showLoyaltyBanner]);
  var onConfirmCommitProduct = function onConfirmCommitProduct(_ref5) {
    var staged = _ref5.staged;
    commit({
      staged: staged
    });
    onCartUpdateHandler()();
    setOpenProductCustomisationModal(false);
    setOpenOutOfStockModal(false);
  };
  var onCloseProductCustomisationModal = function onCloseProductCustomisationModal() {
    return setOpenProductCustomisationModal(false);
  };
  var cartOrderSummary = React.useMemo(function () {
    var _ref6 = (orderPayload == null ? void 0 : orderPayload.financialSummary) || {},
      _ref6$taxes = _ref6.taxes,
      taxes = _ref6$taxes === void 0 ? 0 : _ref6$taxes,
      _ref6$total = _ref6.total,
      total = _ref6$total === void 0 ? 0 : _ref6$total;
    if (cartTotal === 0) {
      taxes = 0;
      total = 0;
    }
    return {
      taxes: formatPrice({
        price: taxes
      }),
      total: formatPrice({
        price: total
      }),
      subTotal: formatPrice({
        price: total - taxes
      })
    };
  }, [orderPayload, formatPrice, cartTotal]);
  var onCloseGroupedProductModal = React.useCallback(function () {
    setGroupedProductSelected(null);
    setOpenGroupedProductModal(false);
  }, [setGroupedProductSelected, setOpenGroupedProductModal]);
  var onCloseAddonRemovedModal = React.useCallback(function () {
    setOpenCondAddonModal(false);
    resetRemovedUpsells();
  }, [setOpenCondAddonModal, resetRemovedUpsells]);
  var onSelectComboProduct = React.useCallback(function (product) {
    setComboProductSelected(product);
    setOpenComboProductModal(true);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onSelectGroupedProduct = React.useCallback(function (product) {
    setGroupedProductSelected(product);
    setOpenGroupedProductModal(true);
  }, [setGroupedProductSelected, setOpenGroupedProductModal]);
  var onCloseComboProductModal = React.useCallback(function () {
    setComboProductSelected(null);
    setOpenComboProductModal(false);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onCloseOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(false);
  }, [setOpenOutOfStockModal]);
  var showOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(true);
  }, [setOpenOutOfStockModal]);
  var onAddUpsellSimpleProduct = React.useCallback(function (product) {
    var _ref7 = product || {},
      _ref7$type = _ref7.type,
      type = _ref7$type === void 0 ? '' : _ref7$type;
    if (type === 'simple') onCartUpdateHandler()();
  }, [onCartUpdateHandler]);
  var formattedUpsells = React.useMemo(function () {
    return formatUpsells({
      upsells: upsells,
      history: history,
      products: products,
      settings: settings,
      commit: commit,
      randomiseUpsells: randomiseUpsells,
      onCloseGroupedProductModal: onCloseGroupedProductModal,
      onSelectComboProduct: onSelectComboProduct,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      onSelectGroupedProduct: onSelectGroupedProduct,
      translateInline: translateInline,
      buttonActionText: t('cartUpsellsGalleryCardButtonAction'),
      cart: formattedCart,
      onAddSimpleProduct: onAddUpsellSimpleProduct,
      upsellAddedToCartTrack: upsellAddedToCartTrack,
      registerProductAddToCart: registerProductAddToCart,
      sessionId: sessionId,
      setUpsellState: setUpsellState,
      kioskSettings: kioskSettings.kiosk,
      couponNumber: couponNumber
    });
  }, [commit, formattedCart, history, randomiseUpsells, onAddUpsellSimpleProduct, onCloseGroupedProductModal, onSelectComboProduct, onSelectCustomisationProduct, onSelectGroupedProduct, products, settings, t, translateInline, upsells, upsellAddedToCartTrack, sessionId, setUpsellState, kioskSettings.kiosk, couponNumber]);

  // Phase 1:
  // - cross-sells feature will show products from a specific product category
  // - category with a unique ID will be added in KFC AU menus to be shown as cross-sells
  // - the products under this category must be treated the same as upsells including GA4 tracking
  var formattedCrossSells = React.useMemo(function () {
    if (!crossSellEnabled || (crossSellCategories == null ? void 0 : crossSellCategories.length) === 0) return [];
    // Flag to identify this upsells are cross sell products
    var isCrossSell = true;
    return formatUpsells({
      upsells: crossSellCategories,
      history: history,
      products: products,
      settings: settings,
      commit: commit,
      randomiseUpsells: randomiseUpsells,
      onCloseGroupedProductModal: onCloseGroupedProductModal,
      onSelectComboProduct: onSelectComboProduct,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      onSelectGroupedProduct: onSelectGroupedProduct,
      translateInline: translateInline,
      buttonActionText: t('cartUpsellsGalleryCardButtonAction'),
      cart: formattedCart,
      onAddSimpleProduct: onAddUpsellSimpleProduct,
      upsellAddedToCartTrack: upsellAddedToCartTrack,
      registerProductAddToCart: registerProductAddToCart,
      sessionId: sessionId,
      setUpsellState: setUpsellState,
      kioskSettings: kioskSettings.kiosk,
      couponNumber: couponNumber,
      isCrossSell: isCrossSell
    });
  }, [commit, formattedCart, history, randomiseUpsells, onAddUpsellSimpleProduct, onCloseGroupedProductModal, onSelectComboProduct, onSelectCustomisationProduct, onSelectGroupedProduct, products, settings, t, translateInline, upsellAddedToCartTrack, sessionId, setUpsellState, kioskSettings.kiosk, couponNumber, crossSellEnabled, crossSellCategories]);
  var formattedCartTranslated = React.useMemo(function () {
    return formattedCart.map(function (product) {
      var _product$options = product.options,
        options = _product$options === void 0 ? [] : _product$options,
        _product$customisatio = product.customisations,
        customisations = _product$customisatio === void 0 ? [] : _product$customisatio;
      var isEditDisabled = function () {
        if ((product == null ? void 0 : product.editDisabled) === true) {
          return true;
        } else if ((product == null ? void 0 : product.type) === 'customise') {
          return product == null ? void 0 : product.customisations.every(function (customisation) {
            return customisation == null ? void 0 : customisation.products.every(function (product) {
              return product.isAvailable === false;
            });
          });
        }
        return product == null ? void 0 : product.editDisabled;
      }();
      return _extends({}, product, {
        title: translateInline(product == null ? void 0 : product.name),
        editDisabled: isEditDisabled,
        options: options == null ? void 0 : options.map(function (option) {
          var _option$products = option.products,
            products = _option$products === void 0 ? [] : _option$products;
          return _extends({}, option, {
            products: products == null ? void 0 : products.map(function (optionProduct) {
              var _optionProduct$custom = optionProduct.customisations,
                customisations = _optionProduct$custom === void 0 ? [] : _optionProduct$custom;
              return _extends({}, optionProduct, {
                customisations: customisations == null ? void 0 : customisations.map(function (optionProductCustomisations) {
                  var _optionProductCustomi = optionProductCustomisations.products,
                    products = _optionProductCustomi === void 0 ? [] : _optionProductCustomi;
                  return _extends({}, optionProductCustomisations, {
                    products: products == null ? void 0 : products.map(function (optionProductCustomisationsProduct) {
                      return _extends({}, optionProductCustomisationsProduct, {
                        title: translateInline(optionProductCustomisationsProduct == null ? void 0 : optionProductCustomisationsProduct.name)
                      });
                    }),
                    title: translateInline(optionProductCustomisations == null ? void 0 : optionProductCustomisations.name)
                  });
                }),
                title: translateInline(optionProduct == null ? void 0 : optionProduct.name)
              });
            })
          });
        }),
        customisations: customisations.map(function (customisation) {
          var _customisation$produc = customisation.products,
            products = _customisation$produc === void 0 ? [] : _customisation$produc;
          return _extends({}, customisation, {
            products: products == null ? void 0 : products.map(function (customisationProduct) {
              return _extends({}, customisationProduct, {
                title: translateInline(customisationProduct == null ? void 0 : customisationProduct.name)
              });
            })
          });
        })
      });
    });
  }, [formattedCart, translateInline]);
  var upsellGroupedItems = React.useMemo(function () {
    if (!upsellEnabled) return [];
    var reducedUpsellItems = formattedUpsells.reduce(function (holder, current) {
      return holder.concat(current.products);
    }, []).filter(function (upsell) {
      return upsell && upsell;
    });
    var items = reducedUpsellItems.length > 0 ? Array.from(new Set(reducedUpsellItems.map(function (upsell) {
      return upsell.productId;
    }))).map(function (productId) {
      return reducedUpsellItems == null ? void 0 : reducedUpsellItems.find(function (item) {
        return item.productId === productId;
      });
    }) : [];
    return items;
  }, [formattedUpsells, upsellEnabled]);
  return {
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero,
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    formattedCart: formattedCartTranslated,
    onConfirmCommitProduct: onConfirmCommitProduct,
    onCloseProductCustomisationModal: onCloseProductCustomisationModal,
    isConcatUpsellProductsEnabled: isConcatUpsellProductsEnabled,
    openProductCustomisationModal: openProductCustomisationModal,
    customisationProductSelected: customisationProductSelected,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    showQuantityControllerLabel: showQuantityControllerLabel,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    onCloseGroupedProductModal: onCloseGroupedProductModal,
    onCloseComboProductModal: onCloseComboProductModal,
    onCloseAddonRemovedModal: onCloseAddonRemovedModal,
    openGroupedProductModal: openGroupedProductModal,
    groupedProductSelected: groupedProductSelected,
    openComboProductModal: openComboProductModal,
    showEnergyInformation: showEnergyInformation,
    showAddonAvailability: showAddonAvailability,
    onEditProductHandler: onEditProductHandler,
    comboProductSelected: comboProductSelected,
    upsellGroupedItems: upsellGroupedItems,
    openCondAddonModal: openCondAddonModal,
    onEmptyCartReturn: onEmptyCartReturn,
    formattedUpsells: formattedUpsells,
    showPriceWarning: showPriceWarning,
    upsellEnabled: upsellEnabled,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    formatPrice: formatPrice,
    menuState: menuState,
    loading: loading,
    t: t,
    hideDisabledButtons: hideDisabledButtons,
    hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected,
    crossSellEnabled: crossSellEnabled,
    showCrossSellCategoryTitle: showCrossSellCategoryTitle,
    formattedCrossSells: formattedCrossSells,
    cartOrderSummary: cartOrderSummary,
    showOrderTotalSummary: showOrderTotalSummary,
    hideComboProductsUnitPrice: hideComboProductsUnitPrice,
    isCouponQuantityDisabled: isCouponQuantityDisabled,
    alignButtons: alignButtons,
    isDeliverectProvider: isDeliverectProvider,
    openOutOfStockModal: openOutOfStockModal,
    showOutOfStockModal: showOutOfStockModal,
    onCloseOutOfStockModal: onCloseOutOfStockModal,
    staged: staged,
    setStaged: setStaged
  };
};

var RestaurantProductViewContext = /*#__PURE__*/React.createContext();
var RestaurantProductViewProvider = function RestaurantProductViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$showQuantityCont = _ref.showQuantityControllerLabel,
    showQuantityControllerLabel = _ref$showQuantityCont === void 0 ? false : _ref$showQuantityCont,
    _ref$customerSkipPath = _ref.customerSkipPath,
    customerSkipPath = _ref$customerSkipPath === void 0 ? '/validate' : _ref$customerSkipPath,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/customer-details' : _ref$nextPath,
    _ref$previousPath = _ref.previousPath,
    previousPath = _ref$previousPath === void 0 ? '/category/:categoryId' : _ref$previousPath,
    _ref$menuPath = _ref.menuPath,
    menuPath = _ref$menuPath === void 0 ? '/categories' : _ref$menuPath,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity;
  var _useParams = reactRouterDom.useParams(),
    id = _useParams.id,
    _useParams$categoryId = _useParams.categoryId,
    categoryId = _useParams$categoryId === void 0 ? null : _useParams$categoryId,
    _useParams$uid = _useParams.uid,
    uid = _useParams$uid === void 0 ? null : _useParams$uid;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count;
  var _useCart = cart.useCart(),
    commit = _useCart.commit,
    items = _useCart.items,
    cart$1 = _useCart.cart;
  var _useStage = cart.useStage(),
    stage = _useStage.stage,
    staged = _useStage.staged;
  var _useRestaurantMenu = useRestaurantMenu(),
    menuState = _useRestaurantMenu.state,
    loading = _useRestaurantMenu.loading,
    settings = _useRestaurantMenu.settings,
    categories = _useRestaurantMenu.categories,
    products = _useRestaurantMenu.products,
    promotions = _useRestaurantMenu.promotions;
  var _useOrigin = useOrigin(),
    origin = _useOrigin.origin,
    setOrigin = _useOrigin.setOrigin;
  var flags = launchdarklyReactClientSdk.useFlags();
  var history = reactRouterDom.useHistory();
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _useState = React.useState(null),
    activeOption = _useState[0],
    setActiveOption = _useState[1];

  // All the data for customising products is hoisted to a `RestaurantProductViewProvider`
  // so that we can interact with our current customisation state at a component level and also at a view level
  // without passing setters.

  // These 2 states and useEffects cant probably be merged if i change combos and customisations
  // to use the same state / format, will keep it split for now until we understand how this will work

  // Hoisted data for editing combo products
  var _useState2 = React.useState(null),
    groupSelected = _useState2[0],
    setGroupSelected = _useState2[1];
  var _useState3 = React.useState({}),
    optionsSelected = _useState3[0],
    setOptionsSelected = _useState3[1];

  // Hoisted data for editing customisable products
  var _useState4 = React.useState(null),
    customisations = _useState4[0],
    setCustomisations = _useState4[1];
  var _useState5 = React.useState({}),
    customisationsSelected = _useState5[0],
    setCustomisationsSelected = _useState5[1];
  var _useState6 = React.useState(false),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  var _useState7 = React.useState(false),
    hasUpsell = _useState7[0],
    setHasUpsell = _useState7[1];
  var _useState8 = React.useState([]),
    upsellsToShow = _useState8[0],
    setUpsellsToShow = _useState8[1];
  var _useState9 = React.useState(null),
    commitedItem = _useState9[0],
    setCommitedItem = _useState9[1];
  var search = reactRouterDom.useLocation().search;
  var urlSearchParams = new URLSearchParams(search);
  var filterId = urlSearchParams.get('filterId');
  var allowAutoAdd = urlSearchParams.get('allowAutoAdd');
  var recoilCategoryId = recoil.useRecoilValue(atoms.categoryState);
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var _useRecoilState = recoil.useRecoilState(atoms.sessionState),
    session = _useRecoilState[0];
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var sessionId = session.id;
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath ? customerSkipPath : !!customer ? customerSkipPath : nextPath;
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    orderViewedTrack = _useAnalytics.orderViewedTrack,
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    orderUpdatedTrack = _useAnalytics.orderUpdatedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var available = {
    t: t,
    translateInline: translateProductName(language),
    id: id,
    stage: stage,
    staged: staged,
    commit: commit,
    history: history,
    loading: loading,
    settings: settings,
    sessionId: sessionId,
    products: products,
    nextPath: nextPath,
    categories: categories,
    menuState: menuState,
    setTemplate: setTemplate,
    previousPath: previousPath,
    optionsSelected: optionsSelected,
    setOptionsSelected: setOptionsSelected,
    activeOption: activeOption,
    setActiveOption: setActiveOption,
    groupSelected: groupSelected,
    setGroupSelected: setGroupSelected,
    customisations: customisations,
    setCustomisations: setCustomisations,
    customisationsSelected: customisationsSelected,
    setCustomisationsSelected: setCustomisationsSelected,
    showModal: showModal,
    setShowModal: setShowModal,
    items: items,
    commitedItem: commitedItem,
    setCommitedItem: setCommitedItem,
    filterId: filterId,
    allowAutoAdd: allowAutoAdd,
    count: count,
    promotions: promotions,
    categoryId: categoryId,
    upsellsToShow: upsellsToShow,
    setUpsellsToShow: setUpsellsToShow,
    recoilCategoryId: recoilCategoryId,
    uid: uid,
    cart: cart$1,
    hasUpsell: hasUpsell,
    setHasUpsell: setHasUpsell,
    computedNextPath: computedNextPath,
    menuPath: menuPath,
    origin: origin,
    setOrigin: setOrigin,
    showPriceWarning: showPriceWarning,
    flags: flags,
    setUpsellState: setUpsellState,
    showQuantityControllerLabel: showQuantityControllerLabel,
    productAddedToCartTrack: productAddedToCartTrack,
    orderViewedTrack: orderViewedTrack,
    orderCompletedTrack: orderCompletedTrack,
    orderUpdatedTrack: orderUpdatedTrack,
    itemSelectTrack: itemSelectTrack,
    isCouponQuantityDisabled: isCouponQuantityDisabled
  };

  // Select defaults when grouping changes
  React.useEffect(function () {
    if (!groupSelected) return;
    var options = groupSelected.options;
    var defaults = options.reduce(reduceComboDefaults, {});
    setOptionsSelected(defaults);
  }, [groupSelected]);

  // Select defaults when customisations changes
  React.useEffect(function () {
    if (!customisations) return;
    var defaults = customisations.reduce(reduceCustomisationDefaults, {});
    setCustomisationsSelected(defaults);
  }, [customisations]);
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantProductViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantProductViewContext = function useRestaurantProductViewContext() {
  var context = React.useContext(RestaurantProductViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantProductViewContext must be used within a RestaurantProductViewProvider');
  }
  return context;
};

var QuantityControllerOutlined = function QuantityControllerOutlined(_ref) {
  var t = _ref.t,
    staged = _ref.staged,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity;
  var _ref2 = staged || {},
    _ref2$add = _ref2.add,
    add = _ref2$add === void 0 ? function () {} : _ref2$add,
    _ref2$remove = _ref2.remove,
    remove = _ref2$remove === void 0 ? function () {} : _ref2$remove,
    _ref2$count = _ref2.count,
    count = _ref2$count === void 0 ? {} : _ref2$count;
  var couponProductId = recoil.useRecoilValue(atoms.couponProductIdState);
  var disabledButtonForCoupon = isCouponQuantityDisabled && couponProductId === (staged == null ? void 0 : staged.productId);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "quantity-controller-outlined",
    className: "flex flex-col h-full gap-2 ml-4 quantity-controller-wrapper " + (showLabel ? 'with-quantity-label' : ''),
    children: [!!showLabel && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "text-xl text-center text-black md:text-2xl quantity-controller-label",
      children: t('quantityControllerOutlinedLabel')
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-row items-center justify-center w-24 h-full text-3xl text-center border border-black rounded-lg md:w-64 md:border-2 quantity-controller",
      children: [/*#__PURE__*/jsxRuntime.jsx("button", {
        "data-test": "product-quantity-controller-remove",
        className: "px-4 py-1 md:py-3 focus:outline-none disabled:opacity-50",
        disabled: count.current <= 1 || disabledButtonForCoupon,
        onClick: remove,
        children: "-"
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex-col justify-center flex-grow",
        children: /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "text-center",
          children: count.current
        })
      }), /*#__PURE__*/jsxRuntime.jsx("button", {
        "data-test": "product-quantity-controller-add",
        className: "px-4 py-1 md:py-3 focus:outline-none disabled:opacity-50",
        disabled: disabledButtonForCoupon,
        onClick: add,
        children: "+"
      })]
    })]
  });
};

var parseUpsellProducts = function parseUpsellProducts(products, upsells, categoryId, product, history) {
  var categoryUpsells = getUpsellCategoryById(upsells, categoryId);
  var productUpsells = getUpsellCategoryById(upsells, product.id);
  var items = [].concat(categoryUpsells, productUpsells);
  var hydratedProducts = [];
  items.forEach(function (category) {
    if (!category) return;
    var upsellProducts = (category == null ? void 0 : category.products) || [];
    upsellProducts.forEach(function (product) {
      var productToHydrate = getProductById({
        products: products,
        id: product
      });
      var item = {
        image: productToHydrate.imageUrl,
        title: productToHydrate.name.text,
        description: productToHydrate.description.text,
        onClick: function onClick() {
          history.push("/product/" + productToHydrate.id);
        }
      };
      hydratedProducts.push(item);
    });
  });
  return hydratedProducts;
};
var registerProductClickAndView$1 = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_temp) {
    var _settings$settings, _settings$settings$or;
    var _ref2, sessionId, product, settings, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _temp === void 0 ? {} : _temp, sessionId = _ref2.sessionId, product = _ref2.product, settings = _ref2.settings, upsell = _ref2.upsell;
          registerPayload = {
            sessionId: sessionId,
            position: 0,
            productVariant: 0,
            categoryName: 0,
            product: product,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$or = _settings$settings.order) == null ? void 0 : _settings$settings$or.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell || ''
          };
          _context.prev = 2;
          _context.next = 5;
          return googleAnalytics.registerProductClick(registerPayload);
        case 5:
          _context.next = 7;
          return googleAnalytics.registerProductView(registerPayload);
        case 7:
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          logger.error('cringer.components - registerProductClickAndView - Error:', _context.t0);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return function registerProductClickAndView(_x) {
    return _ref.apply(this, arguments);
  };
}();
var registerProductAddToCart$1 = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options, _ref3) {
    var _staged$count, _settings$settings2, _settings$settings2$o;
    var sessionId, product, settings, staged, _ref3$upsell, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          sessionId = _ref3.sessionId, product = _ref3.product, settings = _ref3.settings, staged = _ref3.staged, _ref3$upsell = _ref3.upsell, upsell = _ref3$upsell === void 0 ? '' : _ref3$upsell;
          registerPayload = {
            sessionId: sessionId,
            productVariant: '',
            categoryName: '',
            product: product,
            price: product == null ? void 0 : product.price,
            quantity: staged == null ? void 0 : (_staged$count = staged.count) == null ? void 0 : _staged$count.current,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$o = _settings$settings2.order) == null ? void 0 : _settings$settings2$o.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell
          };
          _context2.prev = 2;
          _context2.next = 5;
          return googleAnalytics.registerProductAddedToCart(options, registerPayload);
        case 5:
          _context2.next = 10;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](2);
          logger.error('cringer.components - registerProductAddToCart - Error:', _context2.t0);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 7]]);
  }));
  return function registerProductAddToCart(_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

var useRestaurantProductView = function useRestaurantProductView() {
  var _useRestaurantProduct = useRestaurantProductViewContext(),
    t = _useRestaurantProduct.t,
    translateInline = _useRestaurantProduct.translateInline,
    id = _useRestaurantProduct.id,
    stage = _useRestaurantProduct.stage,
    staged = _useRestaurantProduct.staged,
    commit = _useRestaurantProduct.commit,
    history = _useRestaurantProduct.history,
    products = _useRestaurantProduct.products,
    loading = _useRestaurantProduct.loading,
    settings = _useRestaurantProduct.settings,
    sessionId = _useRestaurantProduct.sessionId,
    nextPath = _useRestaurantProduct.nextPath,
    menuState = _useRestaurantProduct.menuState,
    previousPath = _useRestaurantProduct.previousPath,
    activeOption = _useRestaurantProduct.activeOption,
    setActiveOption = _useRestaurantProduct.setActiveOption,
    items = _useRestaurantProduct.items,
    commitedItem = _useRestaurantProduct.commitedItem,
    setCommitedItem = _useRestaurantProduct.setCommitedItem,
    filterId = _useRestaurantProduct.filterId,
    allowAutoAdd = _useRestaurantProduct.allowAutoAdd,
    setTemplate = _useRestaurantProduct.setTemplate,
    count = _useRestaurantProduct.count,
    categoryId = _useRestaurantProduct.categoryId,
    promotions = _useRestaurantProduct.promotions,
    recoilCategoryId = _useRestaurantProduct.recoilCategoryId,
    uid = _useRestaurantProduct.uid,
    hasUpsell = _useRestaurantProduct.hasUpsell,
    setHasUpsell = _useRestaurantProduct.setHasUpsell,
    computedNextPath = _useRestaurantProduct.computedNextPath,
    menuPath = _useRestaurantProduct.menuPath,
    origin = _useRestaurantProduct.origin,
    showPriceWarning = _useRestaurantProduct.showPriceWarning,
    setUpsellState = _useRestaurantProduct.setUpsellState,
    showQuantityControllerLabel = _useRestaurantProduct.showQuantityControllerLabel,
    productAddedToCartTrack = _useRestaurantProduct.productAddedToCartTrack,
    orderViewedTrack = _useRestaurantProduct.orderViewedTrack,
    orderCompletedTrack = _useRestaurantProduct.orderCompletedTrack,
    orderUpdatedTrack = _useRestaurantProduct.orderUpdatedTrack,
    itemSelectTrack = _useRestaurantProduct.itemSelectTrack,
    isCouponQuantityDisabled = _useRestaurantProduct.isCouponQuantityDisabled;
  var _ref = promotions || {},
    _ref$upsells = _ref.upsells,
    upsells = _ref$upsells === void 0 ? [] : _ref$upsells;
  var title = t('productTitle');
  var previousText = t('productPreviousAction');
  var nextText = uid ? t('productEditingNextAction') : t('productNextAction');
  var cancelOrderText = t('productCancelOrderAction');
  var menuText = t('menuAction');
  var _useState = React.useState(false),
    showMiniCartModal = _useState[0],
    setShowMiniCartModal = _useState[1];
  var trackedUpsells = recoil.useRecoilValue(atoms.trackedUpsellsState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var product = React.useMemo(function () {
    if (!(menuState != null && menuState.matches('success'))) return null;
    if (!id) return;
    return getProductById({
      products: products,
      id: id
    });
  }, [id, menuState, products]);
  var groups = React.useMemo(function () {
    if (!product) return;
    var _ref2 = product || {},
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options;
    return options.map(function (category) {
      var formatted = _extends({}, product, category, {
        name: product.name,
        filterName: category.name
      });
      var select = function select() {
        if (uid) stage({
          uid: uid
        });else stage({
          product: formatted
        });
      };
      return _extends({}, category, {
        select: select
      });
    });
  }, [product, uid, stage]);
  var formattedOptions = React.useMemo(function () {
    var _ref3 = staged || {},
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options;
    return options.map(function (option) {
      var active = option.id === activeOption;
      var activate = function activate() {
        return setActiveOption(active ? null : option.id);
      };
      return _extends({}, option, {
        active: active,
        activate: activate
      });
    });
  }, [staged, activeOption, setActiveOption]);
  var previousAction = React.useCallback(function () {
    var prev = previousPath.replace(':categoryId', recoilCategoryId);
    var path = origin ? origin : prev;
    history.push(path);
  }, [recoilCategoryId, history, previousPath, origin]);
  var upsellProducts = React.useMemo(function () {
    if (!(menuState != null && menuState.matches('success'))) return [];
    if (!categoryId) return [];
    if (!product) return [];
    return parseUpsellProducts(products, upsells, categoryId, product, history);
  }, [categoryId, history, product, menuState, products, upsells]);
  var nextAction = React.useCallback(function () {
    var isUpsell = trackedUpsells.includes(product.id);
    registerProductAddToCart$1({
      setUpsellState: setUpsellState
    }, {
      sessionId: sessionId,
      product: product,
      settings: settings,
      staged: staged,
      upsell: isUpsell ? 'upsell' : 'normal'
    });
    if (!isUpsell) {
      itemSelectTrack == null ? void 0 : itemSelectTrack(staged, cartItems, kioskSettings.kiosk, couponNumber, currentCategory);
      productAddedToCartTrack(staged, kioskSettings.kiosk, couponNumber, currentCategory);
    }
    if (uid) orderUpdatedTrack();
    if (upsellProducts.length > 0) {
      setHasUpsell(true);
      commit({
        staged: staged
      });
    } else {
      commit({
        staged: staged
      });
      setCommitedItem(staged);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commit, setCommitedItem, staged, settings, sessionId, setHasUpsell, upsellProducts, product]);
  React.useEffect(function () {
    if (!commitedItem) return;
    var isCommited = items.some(function (item) {
      return commitedItem.uid === item.uid;
    });
    if (isCommited) {
      var prev = previousPath.replace(':categoryId', recoilCategoryId);
      var next = computedNextPath;
      var path = origin ? origin : uid ? next : prev;
      if (path === next) orderCompletedTrack();
      history.push(path);
    }
  }, [items, history, nextPath, previousPath, commitedItem, recoilCategoryId, uid, computedNextPath, origin, orderViewedTrack, orderCompletedTrack]);
  var closeUpsellModal = React.useCallback(function () {
    history.push(previousPath.replace(':categoryId', recoilCategoryId));
  }, [history, recoilCategoryId, previousPath]);
  React.useEffect(function () {
    if (!groups || !groups.length) return;

    // Automatically select the size if there is only one
    if (groups.length === 1) {
      var group = groups[0];
      return group.select();
    }

    // Automatically select the size if there is a filterId passed through route params
    if (filterId) {
      var _group = groups == null ? void 0 : groups.find(function (group) {
        return "" + group.id === "" + filterId;
      });
      if (_group) return _group.select();
    }
  }, [groups, filterId]);
  React.useEffect(function () {
    if (!product) return;
    var type = product.type;
    registerProductClickAndView$1({
      sessionId: sessionId,
      product: product,
      settings: settings
    });

    // dont stage `combo` products as staging is handled differently
    if (type === 'combo') return;
    if (uid) return stage({
      uid: uid
    });
    stage({
      product: product
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stage, sessionId, settings, categoryId, upsells, products, history, uid, product]);

  // auto add product to the cart when it is type "simple"
  React.useEffect(function () {
    if (!staged || !allowAutoAdd || commitedItem) return;
    // wait for new staged product to be added
    if ("" + id !== "" + staged.productId) return;
    var _staged$type = staged.type,
      type = _staged$type === void 0 ? '' : _staged$type;
    if (type === 'simple') nextAction();
  }, [nextAction, staged, allowAutoAdd, commitedItem, id]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
      orderViewedTrack(cartItems, kioskSettings.kiosk, orderTotal, couponNumber);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal, orderViewedTrack, cartItems, kioskSettings.kiosk, orderTotal, couponNumber]);
  var allowNextAction = React.useMemo(function () {
    return staged == null ? void 0 : staged.ready;
  }, [staged == null ? void 0 : staged.ready]);
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  React.useEffect(function () {
    var header = {
      title: title,
      count: count,
      previousAction: previousAction,
      previousText: previousText,
      menuAction: menuAction,
      menuText: menuText,
      onBasketClick: onBasketClick,
      setShowMiniCartModal: setShowMiniCartModal,
      showMiniCartModal: showMiniCartModal,
      showCouponButton: true
    };
    var footer = {
      nextAction: nextAction,
      nextText: nextText,
      count: count,
      spacer: /*#__PURE__*/jsxRuntime.jsx(QuantityControllerOutlined, {
        t: t,
        staged: staged,
        showLabel: showQuantityControllerLabel,
        isCouponQuantityDisabled: isCouponQuantityDisabled
      }),
      enableCancelOrder: true,
      cancelOrderText: cancelOrderText,
      previousAction: previousAction,
      previousText: previousText,
      allowPreviousAction: true,
      allowNextAction: allowNextAction,
      showMiniCartModal: showMiniCartModal,
      showCouponButton: true
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [nextAction, setTemplate, previousAction, title, previousText, nextText, cancelOrderText, staged, isCouponQuantityDisabled, allowNextAction, upsellProducts, onBasketClick, setShowMiniCartModal, showMiniCartModal, showQuantityControllerLabel, menuAction, menuText, count, t]);
  return {
    groups: groups,
    staged: staged,
    product: product,
    loading: loading,
    menuState: menuState,
    formattedOptions: formattedOptions,
    hasUpsell: hasUpsell,
    upsellProducts: upsellProducts,
    t: t,
    translateInline: translateInline,
    closeUpsellModal: closeUpsellModal,
    showPriceWarning: showPriceWarning
  };
};

var Accordion = function Accordion(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$expand = _ref.expand,
    expand = _ref$expand === void 0 ? true : _ref$expand,
    _ref$toggle = _ref.toggle,
    toggle = _ref$toggle === void 0 ? null : _ref$toggle,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "accordion",
    className: "accordion-wrapper",
    children: [/*#__PURE__*/jsxRuntime.jsxs("button", {
      className: "button-accordion",
      onClick: toggle,
      "data-test": "button-accordion",
      children: [title, /*#__PURE__*/jsxRuntime.jsx(ChevronLeft, {
        "data-test": "button-accordion-icon",
        className: (expand && '-rotate-90') + " button-accordion-icon"
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "container-content-accordion",
      className: (expand ? 'max-h-ceil' : 'max-h-0') + " container-content-accordion",
      children: children
    })]
  });
};

var useSwitchButton = function useSwitchButton(_ref) {
  var add = _ref.add,
    remove = _ref.remove,
    selected = _ref.selected;
  var _useState = React.useState(selected),
    isEnabled = _useState[0],
    setEnabled = _useState[1];
  var toggleButton = React.useCallback(function () {
    setEnabled(function (currentState) {
      return !currentState;
    });
    remove && selected && remove();
    add && !selected && add();
  }, [setEnabled, add, remove, selected]);
  return {
    isEnabled: isEnabled,
    toggleButton: toggleButton
  };
};

var SwitchButton = function SwitchButton(_ref) {
  var add = _ref.add,
    remove = _ref.remove,
    disabled = _ref.disabled,
    selected = _ref.selected,
    className = _ref.className;
  var _useSwitchButton = useSwitchButton({
      add: add,
      remove: remove,
      selected: selected
    }),
    isEnabled = _useSwitchButton.isEnabled,
    toggleButton = _useSwitchButton.toggleButton;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "flex items-center",
    children: /*#__PURE__*/jsxRuntime.jsx("button", {
      onClick: toggleButton,
      className: "relative w-28 h-14 rounded-full focus:outline-none " + (isEnabled ? 'bg-green-500' : 'bg-gray-400') + " " + className,
      disabled: disabled,
      children: /*#__PURE__*/jsxRuntime.jsx("span", {
        className: "absolute inset-y-0 left-0 -ml-1 w-14 h-14 rounded-full bg-gray-300 shadow transition-transform " + (isEnabled ? 'transform translate-x-full' : '')
      })
    })
  });
};

var Actions = function Actions(_ref) {
  var _providerData$substit;
  var product = _ref.product,
    type = _ref.type,
    shouldChangeAddButtonText = _ref.shouldChangeAddButtonText,
    onOpenSubstitutionModal = _ref.onOpenSubstitutionModal,
    staged = _ref.staged;
  var isDefault = product["default"],
    selected = product.selected,
    add = product.add,
    remove = product.remove,
    select = product.select,
    _product$isAvailable = product.isAvailable,
    isAvailable = _product$isAvailable === void 0 ? true : _product$isAvailable,
    count = product.count,
    _product$providerData = product.providerData,
    providerData = _product$providerData === void 0 ? {} : _product$providerData,
    name = product.name;
  var _ref2 = providerData || {},
    _ref2$defaultData = _ref2.defaultData,
    defaultData = _ref2$defaultData === void 0 ? {} : _ref2$defaultData;
  var shouldRenameAddButton = shouldChangeAddButtonText ? (count == null ? void 0 : count.initial) === 0 && (count == null ? void 0 : count.min) === 0 && (count == null ? void 0 : count.max) > 1 ? true : false : false;
  var isChangeDisabled = !Array.isArray(providerData == null ? void 0 : providerData.substitutions) || (providerData == null ? void 0 : (_providerData$substit = providerData.substitutions) == null ? void 0 : _providerData$substit.length) === 0;
  switch (type) {
    case 'substitutable':
      {
        return /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex justify-end gap-2",
          "data-test": "substitutable-buttons-container",
          children: [/*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
            onClick: function onClick() {
              return onOpenSubstitutionModal(product);
            },
            disabled: isChangeDisabled,
            className: "substitutable-buttons",
            "data-test": "substitute-button",
            children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
              i18nKey: 'productCustomisationsChange'
            })
          }), !((defaultData == null ? void 0 : defaultData.name) !== (name == null ? void 0 : name.text)) || !isDefault && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
            onClick: function onClick() {
              staged == null ? void 0 : staged.resetSubstitutions(product);
            },
            disabled: !isAvailable,
            className: "substitutable-buttons",
            "data-test": "default-button",
            children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
              i18nKey: !shouldRenameAddButton ? 'productCustomisationsRemove' : 'productCustomisationsDeselect'
            })
          })]
        });
      }
    case 'boolean':
      {
        return /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "button-product-boolean",
          children: /*#__PURE__*/jsxRuntime.jsx(SwitchButton, {
            add: add,
            remove: remove,
            selected: selected,
            disabled: !isAvailable
          })
        });
      }
    case 'checkbox':
      return /*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "button-product-checkbox",
        className: "flex justify-end w-40",
        children: selected ? /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          onClick: remove,
          disabled: !isAvailable,
          className: "footer-action-button",
          children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
            i18nKey: !shouldRenameAddButton ? 'productCustomisationsRemove' : 'productCustomisationsDeselect'
          })
        }) : /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          onClick: add,
          disabled: !isAvailable,
          className: "footer-action-button",
          children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
            i18nKey: !shouldRenameAddButton ? 'productCustomisationsAdd' : 'productCustomisationsSelect'
          })
        })
      });
    case 'radio':
      return /*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "button-product-radio",
        children: /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          onClick: function onClick() {
            return select({
              resetDefaultToZero: true
            });
          },
          disabled: !isAvailable,
          className: "footer-action-button",
          children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
            i18nKey: "" + (selected ? 'productCustomisationsRemove' : 'productCustomisationsAdd')
          })
        })
      });
    case 'quantity':
    case 'extra':
    case 'selectOption':
      return /*#__PURE__*/jsxRuntime.jsx(QuantityControllerButtons, {
        product: product,
        className: "font-bold"
      });
    default:
      return null;
  }
};
var Content$1 = function Content(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
    category = _ref3.category,
    disabledClass = _ref3.disabledClass,
    showSignaledFormatPrice = _ref3.showSignaledFormatPrice,
    _ref3$showAddonAvaila = _ref3.showAddonAvailability,
    showAddonAvailability = _ref3$showAddonAvaila === void 0 ? false : _ref3$showAddonAvaila,
    _ref3$showModifierEne = _ref3.showModifierEnergyInformation,
    showModifierEnergyInformation = _ref3$showModifierEne === void 0 ? false : _ref3$showModifierEne,
    _ref3$t = _ref3.t,
    t = _ref3$t === void 0 ? function () {} : _ref3$t,
    _ref3$titleSeparator = _ref3.titleSeparator,
    titleSeparator = _ref3$titleSeparator === void 0 ? ' ' : _ref3$titleSeparator,
    _ref3$hidePriceWhenQu = _ref3.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref3$hidePriceWhenQu === void 0 ? false : _ref3$hidePriceWhenQu,
    _ref3$hidePriceWhenZe = _ref3.hidePriceWhenZero,
    hidePriceWhenZero = _ref3$hidePriceWhenZe === void 0 ? false : _ref3$hidePriceWhenZe,
    _ref3$shouldChangeAdd = _ref3.shouldChangeAddButtonText,
    shouldChangeAddButtonText = _ref3$shouldChangeAdd === void 0 ? false : _ref3$shouldChangeAdd,
    onOpenSubstitutionModal = _ref3.onOpenSubstitutionModal,
    _ref3$staged = _ref3.staged,
    staged = _ref3$staged === void 0 ? {} : _ref3$staged,
    _ref3$onEdit = _ref3.onEdit,
    onEdit = _ref3$onEdit === void 0 ? function () {} : _ref3$onEdit;
  var type = category.type,
    products = category.products;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useProductCustomisat = useProductCustomisations(),
    removeDeleteIcon = _useProductCustomisat.removeDeleteIcon,
    showOutOfStockDefaultItemWarnings = _useProductCustomisat.showOutOfStockDefaultItemWarnings,
    isDeliverectProvider = _useProductCustomisat.isDeliverectProvider;
  return products.map(function (product) {
    var id = product.id,
      name = product.name,
      selected = product.selected,
      image = product.imageUrl,
      _product$price = product.price,
      price = _product$price === void 0 ? {} : _product$price,
      title = product.title,
      _product$isAvailable2 = product.isAvailable,
      isAvailable = _product$isAvailable2 === void 0 ? true : _product$isAvailable2,
      serves = product.serves,
      energyInformation = product.energyInformation,
      _product$isVisible = product.isVisible,
      isVisible = _product$isVisible === void 0 ? true : _product$isVisible,
      isDefault = product["default"],
      count = product.count,
      _product$providerData2 = product.providerData,
      providerData = _product$providerData2 === void 0 ? {} : _product$providerData2,
      _product$customisatio = product.customisations,
      customisations = _product$customisatio === void 0 ? false : _product$customisatio;
    var _ref4 = providerData || {},
      _ref4$defaultData = _ref4.defaultData,
      defaultData = _ref4$defaultData === void 0 ? {} : _ref4$defaultData;
    var showSubstitutedLine = !isDefault && (defaultData == null ? void 0 : defaultData.name) && (defaultData == null ? void 0 : defaultData.name) !== (name == null ? void 0 : name.text);
    var unit = price.unit;
    if (!isVisible) return null;
    var showAddonAvailabilityDisabledClass = !isAvailable && showAddonAvailability && 'opacity-30';
    var currentQuantitySelected = count.current,
      defaultQuantity = count.initial;
    var hidePrice = currentQuantitySelected <= defaultQuantity && hidePriceWhenQuantityLessOrEqualDefault || unit === 0 && hidePriceWhenZero;
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex items-center justify-between " + (!isAvailable && !showAddonAvailability ? disabledClass : '') + " " + (showOutOfStockDefaultItemWarnings && isDefault && !isAvailable ? 'px-4 border-4 border-orange' : ''),
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex items-center justify-start space-x-2",
        children: [showOutOfStockDefaultItemWarnings && isDefault && !isAvailable ? /*#__PURE__*/jsxRuntime.jsx(ExclamationCircle, {
          className: "w-6 h-6 text-orange min-w-5 sm:w-12 sm:h-12"
        }) : null, /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "relative w-16 h-12 min-w-12 sm:w-32 sm:h-32",
          children: [/*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
            src: image,
            alt: "Display image",
            className: "object-contain w-full h-full " + showAddonAvailabilityDisabledClass
          }), !isAvailable && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsx("p", {
            className: "absolute inset-0 flex items-center justify-center text-2xl font-bold text-gray-600",
            children: t('showAddonAvailabilityMessage')
          })]
        }), /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex items-center justify-start space-x-2 modal-text-div " + showAddonAvailabilityDisabledClass,
          children: [selected ? /*#__PURE__*/jsxRuntime.jsx(CheckCircle, {
            className: "w-6 h-6 text-green-500 min-w-5 sm:w-12 sm:h-12"
          }) : removeDeleteIcon ? null : /*#__PURE__*/jsxRuntime.jsx(XCircle, {
            className: "w-6 h-6 text-red-600 min-w-5 sm:w-12 sm:h-12"
          }), /*#__PURE__*/jsxRuntime.jsxs("div", {
            className: "flex flex-col " + showAddonAvailabilityDisabledClass,
            children: [/*#__PURE__*/jsxRuntime.jsxs("p", {
              className: "w-auto max-w-sm text-base font-bold product-customisations-content-title xs:text-xl sm:text-3xl",
              children: [title || name.text, isDeliverectProvider && /*#__PURE__*/jsxRuntime.jsx("br", {}), !hidePrice && /*#__PURE__*/jsxRuntime.jsxs("span", {
                className: "product-customisations-price",
                children: [titleSeparator, !!unit && showSignaledFormatPrice ? " " + utilities.signaledFormatPrice({
                  formatPrice: formatPrice,
                  price: unit
                }) : " " + formatPrice({
                  price: unit
                })]
              })]
            }), showSubstitutedLine && /*#__PURE__*/jsxRuntime.jsx("p", {
              className: "text-3xl text-gray-400 substituted-line",
              children: product.providerData.defaultData.name
            }), showModifierEnergyInformation && /*#__PURE__*/jsxRuntime.jsx("p", {
              className: "w-auto max-w-sm text-base xs:text-xl sm:text-3xl",
              children: utilities.join(energyInformation, serves)()
            })]
          })]
        })]
      }), !!customisations && customisations.length > 0 && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
        onClick: function onClick() {
          onEdit(product);
        },
        disabled: !selected,
        className: "edit-button py-small-secondary-button",
        "data-test": "cart-product-change-button",
        children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
          i18nKey: 'productOptionCardSecondaryAction'
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Actions, {
        product: product,
        type: type,
        shouldChangeAddButtonText: shouldChangeAddButtonText,
        onOpenSubstitutionModal: onOpenSubstitutionModal,
        staged: staged
      })]
    }, "" + id);
  });
};
var CategoryTotalizer = function CategoryTotalizer(_ref5) {
  var currentCount = _ref5.currentCount,
    maxCount = _ref5.maxCount;
  return maxCount === -1 ? /*#__PURE__*/jsxRuntime.jsxs("div", {
    children: [currentCount, " / ", /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
      i18nKey: "productCustomisationsUnlimitedMax"
    })]
  }) : /*#__PURE__*/jsxRuntime.jsxs("div", {
    children: [currentCount, " / ", maxCount]
  });
};
var ProductCustomisations = function ProductCustomisations(_ref6) {
  var _ref6$customisations = _ref6.customisations,
    customisations = _ref6$customisations === void 0 ? [] : _ref6$customisations,
    _ref6$className = _ref6.className,
    className = _ref6$className === void 0 ? '' : _ref6$className,
    _ref6$showPriceWarnin = _ref6.showPriceWarning,
    showPriceWarning = _ref6$showPriceWarnin === void 0 ? true : _ref6$showPriceWarnin,
    _ref6$showSignaledFor = _ref6.showSignaledFormatPrice,
    showSignaledFormatPrice = _ref6$showSignaledFor === void 0 ? true : _ref6$showSignaledFor,
    _ref6$disabledClass = _ref6.disabledClass,
    disabledClass = _ref6$disabledClass === void 0 ? 'opacity-30 line-through' : _ref6$disabledClass,
    _ref6$isCategoryTotal = _ref6.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref6$isCategoryTotal === void 0 ? true : _ref6$isCategoryTotal,
    _ref6$isCustomiseCate = _ref6.isCustomiseCategoryTitleEnabled,
    isCustomiseCategoryTitleEnabled = _ref6$isCustomiseCate === void 0 ? true : _ref6$isCustomiseCate,
    _ref6$isAdditionalMes = _ref6.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref6$isAdditionalMes === void 0 ? true : _ref6$isAdditionalMes,
    _ref6$showAddonAvaila = _ref6.showAddonAvailability,
    showAddonAvailability = _ref6$showAddonAvaila === void 0 ? false : _ref6$showAddonAvaila,
    _ref6$showModifierEne = _ref6.showModifierEnergyInformation,
    showModifierEnergyInformation = _ref6$showModifierEne === void 0 ? false : _ref6$showModifierEne,
    _ref6$t = _ref6.t,
    t = _ref6$t === void 0 ? function () {} : _ref6$t,
    _ref6$titleSeparator = _ref6.titleSeparator,
    titleSeparator = _ref6$titleSeparator === void 0 ? ' ' : _ref6$titleSeparator,
    _ref6$hidePriceWhenQu = _ref6.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref6$hidePriceWhenQu === void 0 ? false : _ref6$hidePriceWhenQu,
    _ref6$hidePriceWhenZe = _ref6.hidePriceWhenZero,
    hidePriceWhenZero = _ref6$hidePriceWhenZe === void 0 ? false : _ref6$hidePriceWhenZe,
    _ref6$shouldChangeAdd = _ref6.shouldChangeAddButtonText,
    shouldChangeAddButtonText = _ref6$shouldChangeAdd === void 0 ? false : _ref6$shouldChangeAdd,
    onOpenSubstitutionModal = _ref6.onOpenSubstitutionModal,
    _ref6$staged = _ref6.staged,
    staged = _ref6$staged === void 0 ? {} : _ref6$staged,
    _ref6$formattedProduc = _ref6.formattedProduct,
    formattedProduct = _ref6$formattedProduc === void 0 ? {} : _ref6$formattedProduc,
    _ref6$onEdit = _ref6.onEdit,
    onEdit = _ref6$onEdit === void 0 ? function () {} : _ref6$onEdit;
  var _usePrice2 = usePrice(),
    formatPrice = _usePrice2.formatPrice;
  var _useProductCustomisat2 = useProductCustomisations(),
    formatAllergens = _useProductCustomisat2.formatAllergens;
  var _useState = React.useState(false),
    isResetting = _useState[0],
    setIsResetting = _useState[1];
  var handleResetAllSubstitutions = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var substitutableProducts, _iterator, _step, product;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isResetting) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            setIsResetting(true);
            _context.prev = 3;
            substitutableProducts = customisations.filter(function (category) {
              return category.type === 'substitutable';
            }).flatMap(function (category) {
              return category.products.filter(function (product) {
                return !product["default"] && product.isAvailable;
              });
            });
            _iterator = _createForOfIteratorHelperLoose(substitutableProducts);
          case 6:
            if ((_step = _iterator()).done) {
              _context.next = 12;
              break;
            }
            product = _step.value;
            _context.next = 10;
            return staged == null ? void 0 : staged.resetSubstitutions(product);
          case 10:
            _context.next = 6;
            break;
          case 12:
            _context.prev = 12;
            setIsResetting(false);
            return _context.finish(12);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3,, 12, 15]]);
    }));
    return function handleResetAllSubstitutions() {
      return _ref7.apply(this, arguments);
    };
  }();
  var hasAllergens = formattedProduct.allergens && formattedProduct.allergens.length > 0;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "p-4 md:p-8 " + className,
    children: [hasAllergens ? /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "mb-10 -mt-10 text-4xl text-center font-secondary",
      children: t('allergensMessage', {
        allergens: formattedProduct == null ? void 0 : formattedProduct.allergens.map(function (allerger) {
          return formatAllergens(allerger);
        }).join(', ')
      })
    }) : /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {}), customisations.map(function (category) {
      var _category$price = category.price,
        price = _category$price === void 0 ? {} : _category$price,
        _category$count = category.count,
        count = _category$count === void 0 ? {} : _category$count,
        _category$isCustomisa = category.isCustomisable,
        isCustomisable = _category$isCustomisa === void 0 ? true : _category$isCustomisa;
      var currentPrice = price.current;
      var currentCount = count.current,
        maxCount = count.max,
        minCount = count.min;
      var productsMissingCount = minCount - currentCount;
      var hasAtLeastOneAvailable = category.products.findIndex(function (product) {
        return product.isAvailable;
      }) >= 0;
      var isSubstitutable = (category == null ? void 0 : category.type) === 'substitutable';
      if (isCustomisable === false) return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: " "
      });
      return /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "w-full mb-8 space-y-4",
        children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex items-center justify-between w-full pb-2 text-xl font-bold border-b-2 border-gray-300 sm:pb-4 xs:text-2xl sm:text-4xl",
          children: [/*#__PURE__*/jsxRuntime.jsx("p", {
            className: "customisation-modal-option-title",
            children: isCustomiseCategoryTitleEnabled && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
              children: category.title || category.name
            })
          }), isSubstitutable && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
            onClick: handleResetAllSubstitutions,
            disabled: isResetting,
            className: "px-4 py-4 m-0",
            "data-test": "reset-substitutions",
            children: isResetting ? /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
              i18nKey: "productCustomisationsResetting",
              "data-test": "reset-text"
            }) : /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
              i18nKey: "productCustomisationsReset",
              "data-test": "reset-text"
            })
          }), isCategoryTotalizerEnabled && /*#__PURE__*/jsxRuntime.jsx(CategoryTotalizer, {
            currentCount: currentCount,
            maxCount: maxCount
          })]
        }), productsMissingCount > 0 && hasAtLeastOneAvailable && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "text-4xl text-center text-red-600",
          children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
            i18nKey: "productCustomisationsProductsMissingError",
            count: productsMissingCount,
            values: {
              productsMissingCount: productsMissingCount
            }
          })
        }), isAdditionalMessageEnabled && !!currentPrice && showPriceWarning && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "text-4xl text-center text-red-600",
          children: /*#__PURE__*/jsxRuntime.jsx(reactI18next.Trans, {
            i18nKey: "productCustomisationsAdditionalPriceWarning",
            values: {
              price: showSignaledFormatPrice ? " " + utilities.signaledFormatPrice({
                formatPrice: formatPrice,
                price: currentPrice
              }) : " " + formatPrice({
                price: currentPrice
              })
            }
          })
        }), /*#__PURE__*/jsxRuntime.jsx(Content$1, {
          showSignaledFormatPrice: showSignaledFormatPrice,
          category: category,
          disabledClass: disabledClass,
          showAddonAvailability: showAddonAvailability,
          showModifierEnergyInformation: showModifierEnergyInformation,
          t: t,
          titleSeparator: titleSeparator,
          hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
          hidePriceWhenZero: hidePriceWhenZero,
          shouldChangeAddButtonText: shouldChangeAddButtonText,
          onOpenSubstitutionModal: onOpenSubstitutionModal,
          staged: staged,
          onEdit: onEdit
        })]
      }, category.id);
    })]
  });
};

var Groups = function Groups(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$groups = _ref.groups,
    groups = _ref$groups === void 0 ? [] : _ref$groups;
  return groups.map(function (group) {
    var id = group.id,
      name = group.name,
      image = group.image,
      select = group.select;
    return /*#__PURE__*/jsxRuntime.jsxs("button", {
      onClick: select,
      children: [/*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
        alt: "product group",
        src: image,
        className: "w-32"
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        children: name.text
      })]
    }, id);
  });
};
var GroupOption = function GroupOption(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    _ref2$groups = _ref2.groups,
    groups = _ref2$groups === void 0 ? [] : _ref2$groups;
  if (groups.length <= 1) return null;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    children: [/*#__PURE__*/jsxRuntime.jsx("p", {
      children: "Please select an option"
    }), /*#__PURE__*/jsxRuntime.jsx(Groups, {
      groups: groups
    })]
  });
};
var Products$1 = function Products(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    _ref3$products = _ref3.products,
    products = _ref3$products === void 0 ? [] : _ref3$products;
  return products.map(function (product) {
    var id = product.id,
      name = product.name,
      select = product.select,
      selected = product.selected,
      customisations = product.customisations;
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      onClick: select,
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "px-8 py-4",
        children: /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "text-4xl",
          children: name.text
        })
      }), selected && /*#__PURE__*/jsxRuntime.jsx(ProductCustomisations, {
        customisations: customisations,
        formattedProduct: product
      })]
    }, "product-" + id);
  });
};
var ProductOption$1 = function ProductOption(_temp4) {
  var _ref4 = _temp4 === void 0 ? {} : _temp4,
    _ref4$options = _ref4.options,
    options = _ref4$options === void 0 ? [] : _ref4$options;
  return options.map(function (option) {
    var id = option.id,
      name = option.name,
      active = option.active,
      activate = option.activate,
      products = option.products;
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      children: /*#__PURE__*/jsxRuntime.jsx(Accordion, {
        title: name.text,
        expand: active,
        toggle: activate,
        children: /*#__PURE__*/jsxRuntime.jsx(Products$1, {
          products: products
        })
      })
    }, "option-" + id);
  });
};
var ProductOptions = function ProductOptions(_temp5) {
  var _ref5 = _temp5 === void 0 ? {} : _temp5,
    _ref5$groups = _ref5.groups,
    groups = _ref5$groups === void 0 ? [] : _ref5$groups,
    _ref5$options = _ref5.options,
    options = _ref5$options === void 0 ? [] : _ref5$options,
    _ref5$showGroupOption = _ref5.showGroupOption,
    showGroupOption = _ref5$showGroupOption === void 0 ? false : _ref5$showGroupOption;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "w-full",
    "data-test": "product-options",
    children: [showGroupOption && /*#__PURE__*/jsxRuntime.jsx(GroupOption, {
      groups: groups
    }), /*#__PURE__*/jsxRuntime.jsx(ProductOption$1, {
      options: options
    })]
  });
};

var currencyFormat = process.env.POI_APP_CURRENCY_FORMAT || '$0,0.00';
var currencySymbol = process.env.POI_APP_CURRENCY_SYMBOL || null;
var currencyPosition = process.env.POI_APP_CURRENCY_POSITION || 'START';
var currencySeparator = process.env.POI_APP_CURRENCY_SEPARATOR || null;
var formatPrice = function formatPrice(price, currency) {
  if (!price) return '';
  // string value will be `price not found` so return that to display
  if (typeof price === 'string') return price;
  var amount = Math.round(price * 100);
  var options = {
    amount: amount
  };
  var formattedPrice = Dinero(currency ? _extends({}, options, {
    currency: currency
  }) : options).toFormat(currencyFormat);
  if (!currencySymbol) return formattedPrice;
  var customFormatPrice = currencySeparator ? formattedPrice.replace(/,/g, currencySeparator) : formattedPrice;
  return currencyPosition === 'START' ? "" + currencySymbol + customFormatPrice : "" + customFormatPrice + currencySymbol;
};
var formatEnergyInfo = function formatEnergyInfo(energyInformation, count) {
  if (energyInformation === void 0) {
    energyInformation = '';
  }
  if (count === void 0) {
    count = 1;
  }
  // Energy information is a string that contains number and measuring unit (kj or j)
  var energyInfo = energyInformation.match(/[kjKJ]+|[0-9]+/g);
  if (energyInfo.length === 2) {
    var joules = energyInfo[0];
    var unit = energyInfo[1].toLowerCase();

    // Convert to joules
    if (unit === 'kj') joules *= 1000;
    var totalJoules = joules * count; // Multiply by product count

    if (totalJoules > 1000) return Math.ceil(totalJoules / 1000) + "KJ";
    return totalJoules + "J";
  }
  return '';
};

/*
Flatten array of arrays containing products, down to usable objects, eg:
[[product1, product1], [product2], [product3, product3, product3]]
[{quantity:2}, {quantity:1}, {quantity:3}]
*/
var flattenProducts = function flattenProducts(productArray) {
  var product = productArray[0];
  var quantity = productArray.length;
  var total = product.price * quantity;
  return _extends({}, product, {
    total: total,
    quantity: quantity
  });
};

var Product$1 = function Product(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$groups = _ref.groups,
    groups = _ref$groups === void 0 ? null : _ref$groups,
    _ref$staged = _ref.staged,
    staged = _ref$staged === void 0 ? null : _ref$staged,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? null : _ref$options,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? null : _ref$loading,
    _ref$menuState = _ref.menuState,
    menuState = _ref$menuState === void 0 ? null : _ref$menuState,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning;
  validation$1.validate({
    name: 'Product',
    parameters: {
      menuState: menuState
    }
  });
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  if (loading) return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "flex items-center justify-center",
    children: /*#__PURE__*/jsxRuntime.jsx(Loading, {})
  });
  if (menuState != null && menuState.matches('failure')) return /*#__PURE__*/jsxRuntime.jsx(Alert, {
    type: "danger",
    message: menuState.context.message
  });
  if (menuState != null && menuState.matches('success')) {
    var _ref2 = staged || {},
      customisations = _ref2.customisations,
      price = _ref2.price,
      type = _ref2.type,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? {} : _ref2$name,
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? {} : _ref2$description,
      energyInformation = _ref2.energyInformation,
      imageUrl = _ref2.imageUrl,
      _ref2$filterName = _ref2.filterName,
      filterName = _ref2$filterName === void 0 ? {} : _ref2$filterName;
    var _ref3 = price || {},
      _ref3$unit = _ref3.unit,
      unit = _ref3$unit === void 0 ? 0 : _ref3$unit;
    var Content = function Content() {
      switch (type) {
        case 'combo':
          return /*#__PURE__*/jsxRuntime.jsx(ProductOptions, {
            groups: groups,
            options: options
          });
        case 'customise':
          return /*#__PURE__*/jsxRuntime.jsx(ProductCustomisations, {
            customisations: customisations,
            showPriceWarning: showPriceWarning,
            showAddonAvailability: true,
            formattedProduct: staged
          });
        default:
          return null;
      }
    };
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-start",
      children: [/*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
        className: "w-1/2",
        src: imageUrl,
        alt: name.text
      }), /*#__PURE__*/jsxRuntime.jsx("h1", {
        className: "mb-6 text-6xl",
        children: (filterName == null ? void 0 : filterName.text) || name.text
      }), description && /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mb-2 text-4xl",
        children: description.text
      }), /*#__PURE__*/jsxRuntime.jsxs("p", {
        className: "mb-8 text-4xl",
        children: [unit && formatPrice({
          price: unit
        }), energyInformation && " | " + formatEnergyInfo(energyInformation, 1)]
      }), /*#__PURE__*/jsxRuntime.jsx(Content, {})]
    });
  }
  return null;
};

var useUpsellModal = function useUpsellModal(_ref) {
  var _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? null : _ref$products;
  var _useAnalytics = jitsu.useAnalytics(),
    upsellDismissedTrack = _useAnalytics.upsellDismissedTrack;
  var formattedProducts = React.useMemo(function () {
    return products == null ? void 0 : products.reduce(function (newList, item) {
      var _item$name;
      if (item.productId) newList.push({
        product_id: item == null ? void 0 : item.productId,
        product_name: item == null ? void 0 : (_item$name = item.name) == null ? void 0 : _item$name.text
      });
      return newList;
    }, []);
  }, [products]);
  var onDismiss = function onDismiss() {
    upsellDismissedTrack(formattedProducts);
    closeModal();
  };
  return {
    onDismiss: onDismiss
  };
};

var UpsellModal = function UpsellModal(_ref) {
  var _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? null : _ref$products,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showEnergyInform = _ref.showEnergyInformationSeparated,
    showEnergyInformationSeparated = _ref$showEnergyInform === void 0 ? false : _ref$showEnergyInform;
  var _useUpsellModal = useUpsellModal({
      closeModal: closeModal,
      products: products
    }),
    onDismiss = _useUpsellModal.onDismiss;
  return /*#__PURE__*/jsxRuntime.jsx(Modal, {
    open: open,
    title: t('upsellModalTitle'),
    closeModal: onDismiss,
    closeText: t('upsellModalCloseAction'),
    className: "inset-0 upsell-modal z-40 " + className,
    "data-test": "upsell-modal",
    formatPrice: formatPrice,
    children: products && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex-1 overflow-auto overscroll-contain",
      children: /*#__PURE__*/jsxRuntime.jsx(Gallery, {
        items: products,
        formatPrice: formatPrice,
        t: t,
        showAddonAvailability: showAddonAvailability,
        showEnergyInformationSeparated: showEnergyInformationSeparated
      })
    })
  });
};

var RestaurantProductView = function RestaurantProductView() {
  var _useRestaurantProduct = useRestaurantProductView(),
    groups = _useRestaurantProduct.groups,
    staged = _useRestaurantProduct.staged,
    product = _useRestaurantProduct.product,
    loading = _useRestaurantProduct.loading,
    menuState = _useRestaurantProduct.menuState,
    formattedOptions = _useRestaurantProduct.formattedOptions,
    hasUpsell = _useRestaurantProduct.hasUpsell,
    upsellProducts = _useRestaurantProduct.upsellProducts,
    t = _useRestaurantProduct.t,
    closeUpsellModal = _useRestaurantProduct.closeUpsellModal,
    showPriceWarning = _useRestaurantProduct.showPriceWarning;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [loading && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center flex-grow h-full overflow-scroll",
      children: /*#__PURE__*/jsxRuntime.jsx(Loading, {})
    }), (menuState == null ? void 0 : menuState.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex-grow overflow-scroll",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        message: menuState.context.message
      })
    }), (menuState == null ? void 0 : menuState.matches('success')) && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center w-full h-full p-8 space-y-8 overflow-y-auto",
      children: [/*#__PURE__*/jsxRuntime.jsx(Product$1, {
        groups: groups,
        staged: staged,
        product: product,
        loading: loading,
        menuState: menuState,
        options: formattedOptions,
        showPriceWarning: showPriceWarning
      }), upsellProducts && /*#__PURE__*/jsxRuntime.jsx(UpsellModal, {
        open: hasUpsell,
        closeModal: closeUpsellModal,
        t: t,
        products: upsellProducts
      })]
    })]
  });
};

var ProductComboViewContext = /*#__PURE__*/React.createContext();
var ProductComboViewProvider = function ProductComboViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsxRuntime.jsx(ProductComboViewContext.Provider, {
    children: children
  });
};
var useProductComboViewContext = function useProductComboViewContext() {
  var context = React.useContext(ProductComboViewContext);
  if (context === undefined) {
    throw new Error('useProductComboViewContext must be used within a ProductComboViewProvider');
  }
  return context;
};

var useProductComboView = function useProductComboView(_temp) {
  var _settings$settings, _settings$settings$mo, _ref12;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/customer-details' : _ref$nextPath,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? false : _ref$showCategoriesHe,
    _ref$basketCountPath = _ref.basketCountPath,
    basketCountPath = _ref$basketCountPath === void 0 ? '/customer-details' : _ref$basketCountPath,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$shouldValidateEv = _ref.shouldValidateEveryCustomisations,
    shouldValidateEveryCustomisations = _ref$shouldValidateEv === void 0 ? false : _ref$shouldValidateEv,
    _ref$showOriginalPric = _ref.showOriginalPriceForCombo,
    showOriginalPriceForCombo = _ref$showOriginalPric === void 0 ? false : _ref$showOriginalPric,
    _ref$showQuantityCont = _ref.showQuantityControllerLabel,
    showQuantityControllerLabel = _ref$showQuantityCont === void 0 ? false : _ref$showQuantityCont;
  var showSignaledFormatPrice = true;
  var menuPath = '/categories';
  var previousPath = '/category/:categoryId';
  var showComboInfo = false;
  var showEnergyInformation = false;
  var showSizeButton = false;
  var isCustomisationHeaderEnabled = false;
  var isCategoryTotalizerEnabled = true;
  var isAdditionalMessageEnabled = true;
  var mergeComboAndFilterName = false;
  var showDescription = false;
  var showAddonAvailability = false;
  var isCustomiseCategoryTitleEnabled = true;
  var disableModifyUpsellOnCart = false;
  var hideDisabledButtons = false;
  var hidePriceWhenQuantityLessOrEqualDefault = false;
  var hidePriceWhenZero = false;
  var showOnlyMealSize = false;
  var showLoyaltyBanner = true;
  var hideNoPrefixWhenDefaultNotSelected = false;
  var validateOptions = false;
  var hideNoImageAvailable = false;
  var isCouponQuantityDisabled = false;
  var customerSkipPath = '/validate';
  var _useState = React.useState(false),
    showMiniCartModal = _useState[0],
    setShowMiniCartModal = _useState[1];
  var _useState2 = React.useState(false),
    showOfferLimitModal = _useState2[0],
    setShowOfferLimitModal = _useState2[1];
  var _useState3 = React.useState(null),
    commitedItem = _useState3[0],
    setCommitedItem = _useState3[1];
  var _useState4 = React.useState(false),
    showProductOptionsChangeModal = _useState4[0],
    setShowProductOptionsChangeModal = _useState4[1];
  var _useState5 = React.useState(null),
    selectedOption = _useState5[0],
    setSelectedOption = _useState5[1];
  var _useState6 = React.useState(false),
    showProductOptionCustomisationModal = _useState6[0],
    setShowProductOptionCustomisationModal = _useState6[1];
  var _useState7 = React.useState(null),
    selectedProductCustomisation = _useState7[0],
    setSelectedProductCustomisation = _useState7[1];
  var _useState8 = React.useState(false),
    openProductCustomisationModal = _useState8[0],
    setOpenProductCustomisationModal = _useState8[1];
  var _useState9 = React.useState(null),
    customisationProductSelected = _useState9[0],
    setCustomisationProductSelected = _useState9[1];
  var _useState10 = React.useState(false),
    openComboProductModal = _useState10[0],
    setOpenComboProductModal = _useState10[1];
  var _useState11 = React.useState(null),
    comboProductSelected = _useState11[0],
    setComboProductSelected = _useState11[1];
  var _useState12 = React.useState(false),
    isComboUpdateMode = _useState12[0],
    setIsComboUpdateMode = _useState12[1];
  var _useState13 = React.useState(true),
    allowNextAction = _useState13[0],
    setAllowNextAction = _useState13[1];
  var _useState14 = React.useState(null),
    selectedComboProductUid = _useState14[0],
    setSelectedComboProductUid = _useState14[1];
  var _useState15 = React.useState(false),
    openOutOfStockModal = _useState15[0],
    setOpenOutOfStockModal = _useState15[1];
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var products = recoil.useRecoilValue(atoms.rawProductsState);
  var categoryId = recoil.useRecoilValue(atoms.categoryState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var trackedUpsells = recoil.useRecoilValue(atoms.trackedUpsellsState);
  var setShowOriginalPriceForCombo = recoil.useSetRecoilState(atoms.showOriginalPriceForComboState);
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    offersAndRewards = _useOffersAndRewardsM.offersAndRewards,
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    orderViewedTrack = _useAnalytics.orderViewedTrack,
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    orderUpdatedTrack = _useAnalytics.orderUpdatedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count,
    formattedCart = _useRestaurantCart.formattedCart,
    onCartUpdateHandler = _useRestaurantCart.onCartUpdateHandler,
    offerInCart = _useRestaurantCart.offerInCart;
  var _useRestaurantMenu = useRestaurantMenu(),
    menuState = _useRestaurantMenu.state,
    loading = _useRestaurantMenu.loading,
    settings = _useRestaurantMenu.settings;
  var history = reactRouterDom.useHistory();
  var _useParams = reactRouterDom.useParams(),
    productId = _useParams.productId,
    filterId = _useParams.filterId,
    uid = _useParams.uid;
  var _useCart = cart.useCart(),
    commit = _useCart.commit,
    items = _useCart.items,
    _useCart$cart = _useCart.cart,
    cart$1 = _useCart$cart === void 0 ? [] : _useCart$cart;
  var _useScale = cart.useScale(),
    tempStaged = _useScale.tempStaged,
    scale = _useScale.scale;
  var _useStage = cart.useStage(),
    stage = _useStage.stage,
    staged = _useStage.staged;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var _useOrigin = useOrigin(),
    origin = _useOrigin.origin;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var translateInline = translateProductName(language);
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var showOutOfStockDefaultItemWarnings = utilities.useSettingsAtPath({
    path: 'settings.content.outOfStockDefaultItemWarning',
    defaultValue: false
  });
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath ? customerSkipPath : !!customer ? customerSkipPath : nextPath;
  var _ref3 = session || {},
    sessionId = _ref3.id;
  var scaleEnable = (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$mo = _settings$settings.modes) == null ? void 0 : _settings$settings$mo.scale) || false;
  var title = t('productTitle');
  var previousText = t('productPreviousAction');
  var cancelOrderText = t('productCancelOrderAction');
  var menuText = t('menuAction');
  var nextText = selectedComboProductUid || uid || isComboUpdateMode ? t('productEditingNextAction') : t('productNextAction');
  var product = React.useMemo(function () {
    if (!menuState) return;
    if (!(menuState != null && menuState.matches('success'))) return;
    var productDetails = getProductById({
      products: products,
      id: productId
    });
    return _extends({}, productDetails, {
      parentCategory: currentCategory
    });
  }, [productId, menuState, products, currentCategory]);
  var previousAction = React.useCallback(function () {
    var prev = categoryId ? previousPath.replace(':categoryId', categoryId) : '/categories';
    var path = origin ? origin : prev;
    history.push(path);
  }, [categoryId, history, previousPath, origin]);
  var addProductToCart = React.useCallback(function () {
    var isUpsell = trackedUpsells.includes(product.id);
    registerProductAddToCart({
      setUpsellState: setUpsellState
    }, {
      sessionId: sessionId,
      settings: settings,
      product: product,
      staged: staged,
      upsell: isUpsell ? 'upsell' : 'normal'
    });
    if (!isUpsell) {
      itemSelectTrack == null ? void 0 : itemSelectTrack(staged, cartItems, kioskSettings.kiosk, couponNumber, currentCategory);
      if (!uid) productAddedToCartTrack(staged, kioskSettings.kiosk, couponNumber, currentCategory);
    }
    if (uid || isComboUpdateMode) orderUpdatedTrack();
  }, [trackedUpsells, product, setUpsellState, sessionId, settings, staged, productAddedToCartTrack, uid, couponNumber, kioskSettings.kiosk, isComboUpdateMode, orderUpdatedTrack, itemSelectTrack, cartItems, currentCategory]);
  var outOfStockDefaultItems = React.useMemo(function () {
    if (!(product != null && product.options)) {
      return [];
    }
    var results = product.options.flatMap(function (option) {
      return option.options;
    }).flatMap(function (op) {
      return op.products;
    }).flatMap(function (product) {
      var _product$customise$ca, _product$customise;
      return (_product$customise$ca = (_product$customise = product.customise) == null ? void 0 : _product$customise.categories) != null ? _product$customise$ca : [];
    }).flatMap(function (category) {
      var _category$products;
      return (_category$products = category.products) != null ? _category$products : [];
    }).filter(function (product) {
      return (product == null ? void 0 : product["default"]) && !product.isAvailable;
    });
    return results;
  }, [product]);
  var onConfirmCommitProduct = React.useCallback(function () {
    setOpenOutOfStockModal(null);
    commit({
      staged: staged
    });
    setCommitedItem(staged);
  }, [staged, setOpenOutOfStockModal, commit, setCommitedItem]);
  var nextAction = React.useCallback(function () {
    var _formattedCart$find, _offersAndRewards$pro;
    formattedCart == null ? void 0 : (_formattedCart$find = formattedCart.find(function (item) {
      return item.uid === selectedComboProductUid;
    })) == null ? void 0 : _formattedCart$find.removeAll();
    var isOffer = !!(offersAndRewards != null && (_offersAndRewards$pro = offersAndRewards.promos) != null && _offersAndRewards$pro.find(function (offer) {
      return offer.promoId === product.providerData.PromoId;
    }));
    if (isOffer && !!offerInCart && !(uid || isComboUpdateMode)) {
      setShowOfferLimitModal(true);
    } else {
      var hasOutOfStockDefaultItem = outOfStockDefaultItems.length > 0;
      if (hasOutOfStockDefaultItem && showOutOfStockDefaultItemWarnings) {
        return showOutOfStockModal();
      }
      addProductToCart();
      onConfirmCommitProduct();
    }
  }, [offerInCart, offersAndRewards, product, uid, isComboUpdateMode, formattedCart, selectedComboProductUid, outOfStockDefaultItems, addProductToCart, onConfirmCommitProduct, showOutOfStockModal, showOutOfStockDefaultItemWarnings]);
  var replaceExistingOffer = React.useCallback(function () {
    var selectedOffer = cart$1 == null ? void 0 : cart$1.find(function (cartItem) {
      return cartItem.providerData.PromoId === offerInCart.providerData.PromoId;
    });
    var cartWithoutCurrentOffer = cart$1.filter(function (cartItem) {
      return cartItem.providerData.PromoId !== offerInCart.providerData.PromoId;
    });
    var removeAll = selectedOffer.removeAll;
    var removeMiniCartItem = onCartUpdateHandler(removeAll);
    removeMiniCartItem();
    addProductToCart();
    commit({
      staged: staged,
      cart: cartWithoutCurrentOffer
    });
    setCommitedItem(staged);
  }, [addProductToCart, commit, staged, setCommitedItem, cart$1, offerInCart, onCartUpdateHandler]);
  var onCloseOfferLimitModal = React.useCallback(function () {
    setShowOfferLimitModal(false);
  }, [setShowOfferLimitModal]);
  var onCloseComboProductModal = React.useCallback(function () {
    setComboProductSelected(null);
    setOpenComboProductModal(false);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onSelectComboProduct = React.useCallback(function (product) {
    if (uid) {
      setIsComboUpdateMode(true);
    } else {
      setIsComboUpdateMode(false);
    }
    setComboProductSelected(product);
    setOpenComboProductModal(true);
  }, [setComboProductSelected, setOpenComboProductModal, uid, setIsComboUpdateMode]);
  React.useEffect(function () {
    setShowOriginalPriceForCombo(showOriginalPriceForCombo);
  }, [setShowOriginalPriceForCombo, showOriginalPriceForCombo]);
  React.useEffect(function () {
    if (!commitedItem) return;
    var isCommited = items.some(function (item) {
      return commitedItem.uid === item.uid;
    });
    if (isCommited) {
      var prev = categoryId ? previousPath.replace(':categoryId', categoryId) : '/categories';
      var next = computedNextPath;
      var path = origin ? origin : uid ? next : prev;
      if (path === next) orderCompletedTrack();
      history.push(path, {
        product: product,
        filterId: filterId,
        uid: uid
      });
    }
  }, [items, history, nextPath, previousPath, commitedItem, uid, categoryId, computedNextPath, origin, product, filterId, orderCompletedTrack]);
  var scalableProductsOnOptions = React.useMemo(function () {
    if (!scaleEnable) return [];
    var comboProductOptions = (product == null ? void 0 : product.options) || [];
    var scalableItemsOnProductOptions = comboProductOptions == null ? void 0 : comboProductOptions.map(function (option) {
      var _option$options;
      var optionsConcatedProducts = option == null ? void 0 : (_option$options = option.options) == null ? void 0 : _option$options.map(function (option) {
        var _option$hasScalablePr = option.hasScalableProduct,
          hasScalableProduct = _option$hasScalablePr === void 0 ? false : _option$hasScalablePr,
          _option$products = option.products,
          products = _option$products === void 0 ? [] : _option$products;
        return {
          products: products,
          hasScalableProduct: hasScalableProduct
        };
      });
      var internalProductsWithinOptions = optionsConcatedProducts == null ? void 0 : optionsConcatedProducts.map(function (item) {
        var _item$hasScalableProd = item.hasScalableProduct,
          hasScalableProduct = _item$hasScalableProd === void 0 ? false : _item$hasScalableProd,
          _item$products = item.products,
          products = _item$products === void 0 ? [] : _item$products;
        return {
          hasScalableProduct: hasScalableProduct,
          options: mapScalableProducts(products)
        };
      });
      return internalProductsWithinOptions;
    });

    //The map generates the array inversed from original options, so needs to be reversed when returning
    return scalableItemsOnProductOptions.reverse();
  }, [product, scaleEnable]);
  var selectOption = React.useCallback(function (option) {
    registerProductClickAndView({
      sessionId: sessionId,
      product: product,
      settings: settings
    });
    if (uid) {
      return stage({
        uid: uid
      });
    }
    stage({
      product: _extends({}, product, option, {
        name: product.name,
        filterName: option.name,
        imageUrl: product == null ? void 0 : product.imageUrl
      })
    });
  }, [product, sessionId, settings, stage, uid]);
  React.useEffect(function () {
    var _ref4 = staged || {},
      id = _ref4.id,
      _ref4$uid = _ref4.uid,
      stagedUid = _ref4$uid === void 0 ? '' : _ref4$uid;
    var _ref5 = product || {},
      _ref5$options = _ref5.options,
      options = _ref5$options === void 0 ? [] : _ref5$options;
    if (uid === stagedUid) return;
    if (!options.length) return;

    /*
      This line prevents us from losing customisations when the user
      clicks to see the mini cart while changing a product that has not yet been added to the cart
      the error is described in S2UI-285
    */
    if (id !== null && id !== undefined && "" + filterId === "" + id) return;

    // Automatically select the size if there is a filterId passed through route params
    if (filterId) {
      var option = options == null ? void 0 : options.find(function (option) {
        return "" + (option == null ? void 0 : option.id) === "" + filterId;
      });
      if (option) selectOption(option);
    }

    // this was added to prevent infinite rerenders if theres uid and an already staged product
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterId, product, selectOption]);
  var basketCountAction = React.useCallback(function () {
    return history.push(basketCountPath);
  }, [basketCountPath, history]);
  var onChangeOption = React.useCallback(function (option) {
    return function () {
      setSelectedOption(option);
      setShowProductOptionsChangeModal(true);
    };
  }, [setSelectedOption, setShowProductOptionsChangeModal]);
  var onSelectOptionProduct = React.useCallback(function (product) {
    return function () {
      setShowProductOptionsChangeModal(false);
      setSelectedOption(null);
      product.select();
    };
  }, [setSelectedOption, setShowProductOptionsChangeModal]);
  var onCustomiseProduct = React.useCallback(function (productCustomisation) {
    return function () {
      setSelectedProductCustomisation(productCustomisation);
      setShowProductOptionCustomisationModal(true);
    };
  }, [setSelectedProductCustomisation, setShowProductOptionCustomisationModal]);
  var onCloseProductOptionsChangeModal = function onCloseProductOptionsChangeModal() {
    return setShowProductOptionsChangeModal(false);
  };
  var onCloseProductOptionCustomisationModal = function onCloseProductOptionCustomisationModal() {
    return setShowProductOptionCustomisationModal(false);
  };
  var onConfirmProductOptionCustomisationModal = function onConfirmProductOptionCustomisationModal(_ref6) {
    var updatedStaged = _ref6.updatedStaged;
    stage({
      staged: updatedStaged
    });
    setShowProductOptionCustomisationModal(false);
  };
  var formattedComboModal = React.useMemo(function () {
    var _product$options;
    return _extends({}, product, {
      options: product == null ? void 0 : (_product$options = product.options) == null ? void 0 : _product$options.map(function (option) {
        return _extends({}, option, {
          image: option.imageUrl,
          title: translateInline(option == null ? void 0 : option.name),
          onClick: function onClick() {
            uid && setSelectedComboProductUid(uid);
            setOpenComboProductModal(false);
            return history.push("/product/" + option.productId + "/combo/" + option.id);
          }
        });
      }),
      dataTag: 'combo-product-card'
    });
  }, [product, translateInline, setOpenComboProductModal, history, setSelectedComboProductUid, uid]);
  var formattedProduct = React.useMemo(function () {
    var _ref7 = staged || {},
      _ref7$options = _ref7.options,
      options = _ref7$options === void 0 ? [] : _ref7$options;
    var formattedOptions = options == null ? void 0 : options.map(function (option) {
      var filteredOption = filterImageUrlFallback(option);
      var _filteredOption$produ = filteredOption.products,
        products = _filteredOption$produ === void 0 ? [] : _filteredOption$produ,
        _filteredOption$hidde = filteredOption.hidden,
        hidden = _filteredOption$hidde === void 0 ? false : _filteredOption$hidde;
      if (hidden) return null;
      var formattedProducts = products == null ? void 0 : products.map(function (product) {
        var _productWithFallback$;
        var productWithFallback = filterImageUrlFallback(product);
        return _extends({}, productWithFallback, {
          title: translateInline(productWithFallback == null ? void 0 : productWithFallback.name),
          name: {
            text: translateInline(productWithFallback == null ? void 0 : productWithFallback.name)
          },
          customisations: (_productWithFallback$ = productWithFallback.customisations) == null ? void 0 : _productWithFallback$.map(function (customisation) {
            var _customisation$produc;
            return _extends({}, customisation, {
              title: translateInline(customisation == null ? void 0 : customisation.name),
              products: (_customisation$produc = customisation.products) == null ? void 0 : _customisation$produc.map(function (customisationProduct) {
                return _extends({}, customisationProduct, {
                  title: translateInline(customisationProduct == null ? void 0 : customisationProduct.name)
                });
              })
            });
          }),
          onSelect: onSelectOptionProduct,
          onCustomise: onCustomiseProduct
        });
      });
      return _extends({}, filteredOption, {
        name: {
          text: translateInline(filteredOption == null ? void 0 : filteredOption.name)
        },
        title: translateInline(filteredOption == null ? void 0 : filteredOption.name),
        products: formattedProducts,
        onChangeSelection: onChangeOption
      });
    }).filter(function (product) {
      return product;
    }); // filter `null`s

    var calculatedEnergyInformation = calculateTotalEnergy(_extends({}, staged, {
      options: formattedOptions
    }));
    return _extends({}, staged, {
      options: formattedOptions,
      title: translateInline((staged == null ? void 0 : staged.filterName) || (staged == null ? void 0 : staged.name)),
      calculatedEnergyInformation: calculatedEnergyInformation
    });
  }, [onChangeOption, onCustomiseProduct, onSelectOptionProduct, staged, translateInline]);
  var availabilities = React.useMemo(function () {
    var formattedOptions = formattedProduct == null ? void 0 : formattedProduct.options.map(function (option) {
      if (option && option.isVisible) {
        var _selectedProduct$cust;
        var _option$products2 = option.products,
          _products = _option$products2 === void 0 ? [] : _option$products2;
        var selectedProduct = _products == null ? void 0 : _products.find(function (product) {
          return product.selected;
        });
        var allUnavailable = _products == null ? void 0 : _products.every(function (product) {
          return product.isAvailable === false;
        });
        var mustChange = allUnavailable ? false : selectedProduct && !(selectedProduct != null && selectedProduct.isAvailable) && (_products == null ? void 0 : _products.length) > 1 ? _products == null ? void 0 : _products.some(function (product) {
          return product.isAvailable === true;
        }) : false;
        var isValid = selectedProduct == null ? void 0 : (_selectedProduct$cust = selectedProduct.customisations) == null ? void 0 : _selectedProduct$cust.every(function (customisation) {
          var _customisation$count = customisation.count,
            _customisation$count2 = _customisation$count === void 0 ? {} : _customisation$count,
            current = _customisation$count2.current,
            min = _customisation$count2.min,
            max = _customisation$count2.max;
          return current >= min && current <= max;
        });
        var _allowNext = !allUnavailable && !mustChange;
        return {
          optionId: option == null ? void 0 : option.id,
          mustChange: mustChange,
          allUnavailable: allUnavailable,
          allowNext: _allowNext,
          isValid: isValid
        };
      }
    });
    var allowNext = formattedOptions ? !formattedOptions.some(function (option) {
      return option && ((option == null ? void 0 : option.allUnavailable) || (option == null ? void 0 : option.mustChange) || shouldValidateEveryCustomisations && !(option != null && option.isValid));
    }) : true;
    return {
      formattedOptions: formattedOptions,
      allowNext: allowNext
    };
  }, [formattedProduct, shouldValidateEveryCustomisations]);
  React.useEffect(function () {
    setAllowNextAction(availabilities.allowNext);
  }, [availabilities, setAllowNextAction]);

  //Will map the formattedProduct, and identify selected products that are scalable
  var scalableProductsSelected = React.useMemo(function () {
    var _formattedProduct$opt;
    if (!scaleEnable) return [];
    if (!formattedProduct) return [];
    var optionsConcatedProducts = formattedProduct == null ? void 0 : (_formattedProduct$opt = formattedProduct.options) == null ? void 0 : _formattedProduct$opt.map(function (option) {
      var _option$products3 = option.products,
        products = _option$products3 === void 0 ? [] : _option$products3;
      return mapSelectedScalableProducts(products);
    });
    return optionsConcatedProducts;
  }, [formattedProduct, scaleEnable]);
  var hasAcomplishedScalableRequirements = React.useMemo(function () {
    if (!scaleEnable) return false;
    if (!formattedProduct || !product || !scalableProductsOnOptions) return false;
    var selectedOptionScalableRequirement = scalableProductsOnOptions[formattedProduct.id];
    var scaleTo = [];
    var optionsWithScale = [];
    var optionsRequiredToScale = selectedOptionScalableRequirement && (selectedOptionScalableRequirement == null ? void 0 : selectedOptionScalableRequirement.map(function (item) {
      return item.hasScalableProduct;
    }));

    //Side number is the same as scaleItemIndex value
    scalableProductsSelected == null ? void 0 : scalableProductsSelected.map(function (scaleItems, scaleItemIndex) {
      if (!scaleItems.length) return optionsWithScale[scaleItemIndex] = false;
      var _ref8 = (selectedOptionScalableRequirement == null ? void 0 : selectedOptionScalableRequirement[scaleItemIndex]) || {},
        _ref8$options = _ref8.options,
        options = _ref8$options === void 0 ? [] : _ref8$options;
      scaleItems == null ? void 0 : scaleItems.map(function (scaleItem) {
        var _options$filter$, _scaleItem$products, _scaleItem$products$f;
        var scalableRequirements = options == null ? void 0 : (_options$filter$ = options.filter(function (item) {
          return (item == null ? void 0 : item.scalable) === (scaleItem == null ? void 0 : scaleItem.scalable);
        })[0]) == null ? void 0 : _options$filter$.products;
        var hasSelectedScaleProduct = scaleItem == null ? void 0 : (_scaleItem$products = scaleItem.products) == null ? void 0 : (_scaleItem$products$f = _scaleItem$products.filter(function (a) {
          return !(scalableRequirements != null && scalableRequirements.includes(a));
        })) == null ? void 0 : _scaleItem$products$f.length;
        if (hasSelectedScaleProduct) {
          scaleTo[scaleItemIndex] = scaleItem == null ? void 0 : scaleItem.scalable;
          optionsWithScale[scaleItemIndex] = true;
        }
      });
      return;
    });
    var hasSingleScaleType = scaleTo.filter(function (val, id, array) {
      return array.indexOf(val) == id;
    }).length === 1;
    var hasAllRequiredSideScalables = lodash.isEqual(optionsWithScale, optionsRequiredToScale);
    if (hasSingleScaleType && hasAllRequiredSideScalables) return scaleTo.pop();
    return false;
  }, [scalableProductsSelected, formattedProduct, product, scalableProductsOnOptions, scaleEnable]);
  React.useMemo(function () {
    if (!hasAcomplishedScalableRequirements) return;
    if (!scaleEnable) return;
    var _ref9 = product || {},
      _ref9$options = _ref9.options,
      options = _ref9$options === void 0 ? [] : _ref9$options;
    if (!options.length) return;
    scale({
      originalItem: formattedProduct,
      sizeToScale: hasAcomplishedScalableRequirements,
      product: product
    });
  }, [product, hasAcomplishedScalableRequirements, formattedProduct, scale, scaleEnable]);
  React.useMemo(function () {
    if (!tempStaged) return;
    var stagedUid = formattedProduct.uid;
    stage({
      staged: _extends({}, tempStaged, {
        uid: stagedUid
      })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempStaged, stage]);
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  var promoItem = getPromoItem({
    productId: formattedProduct == null ? void 0 : formattedProduct.productId
  });
  var hasAllergens = formattedProduct.allergens && formattedProduct.allergens.length > 0;
  var onCloseMiniCartModal = function onCloseMiniCartModal(_ref10) {
    var updatedStaged = _ref10.updatedStaged;
    setShowMiniCartModal(false);
    if (updatedStaged) {
      var _updatedStaged$type = updatedStaged.type,
        type = _updatedStaged$type === void 0 ? '' : _updatedStaged$type;
      if (type === 'customise') return onSelectCustomisationProduct(updatedStaged);
      stage({
        staged: updatedStaged
      });
    }
  };
  var onCloseProductCustomisationModal = function onCloseProductCustomisationModal() {
    return setOpenProductCustomisationModal(false);
  };
  var onSelectCustomisationProduct = function onSelectCustomisationProduct(product) {
    setCustomisationProductSelected(product);
    setOpenProductCustomisationModal(true);
  };
  var onConfirmProductCustomisationModal = function onConfirmProductCustomisationModal(_ref11) {
    var staged = _ref11.staged;
    setOpenProductCustomisationModal(false);
    commit({
      staged: staged
    });
  };
  var onConfirmMiniCartModal = React.useCallback(function () {
    orderCompletedTrack();
    history.push(computedNextPath);
  }, [history, computedNextPath, orderCompletedTrack]);
  var onCloseOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(false);
  }, [setOpenOutOfStockModal]);
  var showOutOfStockModal = React.useCallback(function () {
    setOpenOutOfStockModal(true);
  }, [setOpenOutOfStockModal]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
      orderViewedTrack(cartItems, kioskSettings.kiosk, orderTotal, couponNumber);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal, orderViewedTrack, cartItems, kioskSettings.kiosk, orderTotal, couponNumber]);
  React.useEffect(function () {
    var header = {
      count: count,
      title: title,
      menuText: menuText,
      menuAction: menuAction,
      previousText: previousText,
      onBasketClick: onBasketClick,
      previousAction: previousAction,
      showLoyaltyBanner: showLoyaltyBanner,
      showCategoriesHeader: showCategoriesHeader,
      allowPreviousAction: true,
      showCouponButton: true
    };
    var footer = {
      nextAction: nextAction,
      nextText: nextText,
      spacer: /*#__PURE__*/jsxRuntime.jsx(QuantityControllerOutlined, {
        t: t,
        staged: staged,
        showLabel: showQuantityControllerLabel,
        isCouponQuantityDisabled: isCouponQuantityDisabled
      }),
      previousAction: previousAction,
      previousText: previousText,
      allowPreviousAction: true,
      allowNextAction: allowNextAction,
      cancelOrderText: cancelOrderText,
      enableCancelOrder: true,
      onBasketClick: onBasketClick,
      showCouponButton: true
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [nextAction, setTemplate, previousAction, title, previousText, nextText, basketCountAction, cancelOrderText, staged, menuAction, menuText, onBasketClick, count, showCategoriesHeader, showLoyaltyBanner, showQuantityControllerLabel, isCouponQuantityDisabled, t, allowNextAction]);
  return _ref12 = {
    menuState: menuState,
    t: t,
    loading: loading,
    formatPrice: formatPrice,
    formattedProduct: formattedProduct,
    showProductOptionsChangeModal: showProductOptionsChangeModal,
    setShowProductOptionsChangeModal: setShowProductOptionsChangeModal,
    setSelectedOption: setSelectedOption,
    selectedOption: selectedOption,
    onCloseProductOptionsChangeModal: onCloseProductOptionsChangeModal,
    showProductOptionCustomisationModal: showProductOptionCustomisationModal,
    selectedProductCustomisation: selectedProductCustomisation,
    onCloseProductOptionCustomisationModal: onCloseProductOptionCustomisationModal,
    onConfirmProductOptionCustomisationModal: onConfirmProductOptionCustomisationModal,
    showSignaledFormatPrice: showSignaledFormatPrice,
    showMiniCartModal: showMiniCartModal,
    onCloseMiniCartModal: onCloseMiniCartModal,
    onConfirmMiniCartModal: onConfirmMiniCartModal,
    staged: staged,
    openProductCustomisationModal: openProductCustomisationModal,
    customisationProductSelected: customisationProductSelected,
    onConfirmProductCustomisationModal: onConfirmProductCustomisationModal,
    onCloseProductCustomisationModal: onCloseProductCustomisationModal,
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    hasAcomplishedScalableRequirements: hasAcomplishedScalableRequirements,
    nextText: nextText,
    nextAction: nextAction,
    showComboInfo: showComboInfo,
    showEnergyInformation: showEnergyInformation,
    showSizeButton: showSizeButton,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    isCustomiseCategoryTitleEnabled: isCustomiseCategoryTitleEnabled,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    showQuantityControllerLabel: showQuantityControllerLabel,
    openComboProductModal: openComboProductModal,
    onCloseComboProductModal: onCloseComboProductModal,
    comboProductSelected: comboProductSelected != null ? comboProductSelected : product,
    onSelectComboProduct: onSelectComboProduct,
    formattedComboModal: formattedComboModal,
    mergeComboAndFilterName: mergeComboAndFilterName,
    showDescription: showDescription,
    showAddonAvailability: showAddonAvailability,
    availabilities: availabilities.formattedOptions
  }, _ref12["isCustomiseCategoryTitleEnabled"] = isCustomiseCategoryTitleEnabled, _ref12.disableModifyUpsellOnCart = disableModifyUpsellOnCart, _ref12.hideDisabledButtons = hideDisabledButtons, _ref12.hidePriceWhenQuantityLessOrEqualDefault = hidePriceWhenQuantityLessOrEqualDefault, _ref12.hidePriceWhenZero = hidePriceWhenZero, _ref12.showOnlyMealSize = showOnlyMealSize, _ref12.hideNoPrefixWhenDefaultNotSelected = hideNoPrefixWhenDefaultNotSelected, _ref12.showOfferLimitModal = showOfferLimitModal, _ref12.onCloseOfferLimitModal = onCloseOfferLimitModal, _ref12.replaceExistingOffer = replaceExistingOffer, _ref12.validateOptions = validateOptions, _ref12.hideNoImageAvailable = hideNoImageAvailable, _ref12.accessibilityEnabled = accessibilityEnabled, _ref12.isCouponQuantityDisabled = isCouponQuantityDisabled, _ref12.promoItem = promoItem, _ref12.hasAllergens = hasAllergens, _ref12.onConfirmCommitProduct = onConfirmCommitProduct, _ref12.openOutOfStockModal = openOutOfStockModal, _ref12.showOutOfStockModal = showOutOfStockModal, _ref12.onCloseOutOfStockModal = onCloseOutOfStockModal, _ref12;
};

var RestaurantProductComposedViewContext = /*#__PURE__*/React.createContext();
var RestaurantProductComposedViewProvider = function RestaurantProductComposedViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$previousPath = _ref.previousPath,
    previousPath = _ref$previousPath === void 0 ? '/category/:categoryId' : _ref$previousPath,
    _ref$basketCountPath = _ref.basketCountPath,
    basketCountPath = _ref$basketCountPath === void 0 ? '/customer-details' : _ref$basketCountPath,
    _ref$isCustomisationH = _ref.isCustomisationHeaderEnabled,
    isCustomisationHeaderEnabled = _ref$isCustomisationH === void 0 ? false : _ref$isCustomisationH,
    _ref$isCategoryTotali = _ref.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref$isCategoryTotali === void 0 ? true : _ref$isCategoryTotali,
    _ref$isAdditionalMess = _ref.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref$isAdditionalMess === void 0 ? true : _ref$isAdditionalMess,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/customer-details' : _ref$nextPath,
    _ref$customerSkipPath = _ref.customerSkipPath,
    customerSkipPath = _ref$customerSkipPath === void 0 ? '/validate' : _ref$customerSkipPath,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? true : _ref$showCategoriesHe,
    _ref$menuPath = _ref.menuPath,
    menuPath = _ref$menuPath === void 0 ? '/categories' : _ref$menuPath,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$disableModifyUps = _ref.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref$disableModifyUps === void 0 ? false : _ref$disableModifyUps,
    _ref$hideDisabledButt = _ref.hideDisabledButtons,
    hideDisabledButtons = _ref$hideDisabledButt === void 0 ? false : _ref$hideDisabledButt,
    _ref$hidePriceWhenQua = _ref.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref$hidePriceWhenQua === void 0 ? false : _ref$hidePriceWhenQua,
    _ref$hidePriceWhenZer = _ref.hidePriceWhenZero,
    hidePriceWhenZero = _ref$hidePriceWhenZer === void 0 ? false : _ref$hidePriceWhenZer,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom;
  var _useParams = reactRouterDom.useParams(),
    productId = _useParams.productId,
    filterId = _useParams.filterId,
    uid = _useParams.uid;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var _useCart = cart.useCart(),
    commit = _useCart.commit,
    items = _useCart.items;
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count;
  var _useStage = cart.useStage(),
    stage = _useStage.stage,
    staged = _useStage.staged;
  var _useRestaurantMenu = useRestaurantMenu(),
    menuState = _useRestaurantMenu.state,
    loading = _useRestaurantMenu.loading,
    settings = _useRestaurantMenu.settings;
  var _useOrigin = useOrigin(),
    origin = _useOrigin.origin;
  var history = reactRouterDom.useHistory();
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useFlags = launchdarklyReactClientSdk.useFlags(),
    flags = _useFlags.flags;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath ? customerSkipPath : !!customer ? customerSkipPath : nextPath;
  var products = recoil.useRecoilValue(atoms.rawProductsState);
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var categoryId = recoil.useRecoilValue(atoms.categoryState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var _useState = React.useState(false),
    openProductCustomisationModal = _useState[0],
    setOpenProductCustomisationModal = _useState[1];
  var _useState2 = React.useState(null),
    customisationProductSelected = _useState2[0],
    setCustomisationProductSelected = _useState2[1];
  var _useState3 = React.useState(null),
    selectedLayerOption = _useState3[0],
    setSelectedLayerOption = _useState3[1];
  var _useState4 = React.useState([]),
    navigationList = _useState4[0],
    setNavigationList = _useState4[1];
  var _useState5 = React.useState(false),
    openComboProductModal = _useState5[0],
    setOpenComboProductModal = _useState5[1];
  var _useState6 = React.useState(null),
    commitedItem = _useState6[0],
    setCommitedItem = _useState6[1];
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    orderViewedTrack = _useAnalytics.orderViewedTrack,
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    orderUpdatedTrack = _useAnalytics.orderUpdatedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var available = {
    translateInline: translateProductName(language),
    setOpenProductCustomisationModal: setOpenProductCustomisationModal,
    openProductCustomisationModal: openProductCustomisationModal,
    customisationProductSelected: customisationProductSelected,
    setCustomisationProductSelected: setCustomisationProductSelected,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    setOpenComboProductModal: setOpenComboProductModal,
    productAddedToCartTrack: productAddedToCartTrack,
    orderViewedTrack: orderViewedTrack,
    orderCompletedTrack: orderCompletedTrack,
    orderUpdatedTrack: orderUpdatedTrack,
    setSelectedLayerOption: setSelectedLayerOption,
    showAddonAvailability: showAddonAvailability,
    openComboProductModal: openComboProductModal,
    accessibilityEnabled: accessibilityEnabled,
    showCategoriesHeader: showCategoriesHeader,
    selectedLayerOption: selectedLayerOption,
    setNavigationList: setNavigationList,
    showPriceWarning: showPriceWarning,
    computedNextPath: computedNextPath,
    setCommitedItem: setCommitedItem,
    basketCountPath: basketCountPath,
    navigationList: navigationList,
    setUpsellState: setUpsellState,
    commitedItem: commitedItem,
    previousPath: previousPath,
    formatPrice: formatPrice,
    setTemplate: setTemplate,
    categoryId: categoryId,
    menuState: menuState,
    productId: productId,
    menuPath: menuPath,
    settings: settings,
    products: products,
    nextPath: nextPath,
    filterId: filterId,
    loading: loading,
    session: session,
    history: history,
    commit: commit,
    origin: origin,
    staged: staged,
    items: items,
    stage: stage,
    flags: flags,
    count: count,
    uid: uid,
    t: t,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    hideDisabledButtons: hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero,
    itemSelectTrack: itemSelectTrack
  };
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantProductComposedViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantProductComposedViewContext = function useRestaurantProductComposedViewContext() {
  var context = React.useContext(RestaurantProductComposedViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantProductComposedViewContext must be used within a RestaurantProductComposedViewProvider');
  }
  return context;
};

var registerProductAddToCart$2 = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options, _temp) {
    var _staged$count, _settings$settings, _settings$settings$or;
    var _ref2, sessionId, settings, product, staged, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _temp === void 0 ? {} : _temp, sessionId = _ref2.sessionId, settings = _ref2.settings, product = _ref2.product, staged = _ref2.staged, upsell = _ref2.upsell;
          registerPayload = {
            sessionId: sessionId,
            productVariant: '',
            categoryName: '',
            product: product,
            price: product == null ? void 0 : product.price,
            quantity: staged == null ? void 0 : (_staged$count = staged.count) == null ? void 0 : _staged$count.current,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$or = _settings$settings.order) == null ? void 0 : _settings$settings$or.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell
          };
          _context.prev = 2;
          _context.next = 5;
          return googleAnalytics.registerProductAddedToCart(options, registerPayload);
        case 5:
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](2);
          logger.error('cringer.components - registerProductAddToCart - Error:', _context.t0);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 7]]);
  }));
  return function registerProductAddToCart(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var useRestaurantProductComposedView = function useRestaurantProductComposedView() {
  var _useRestaurantProduct = useRestaurantProductComposedViewContext(),
    setOpenProductCustomisationModal = _useRestaurantProduct.setOpenProductCustomisationModal,
    openProductCustomisationModal = _useRestaurantProduct.openProductCustomisationModal,
    customisationProductSelected = _useRestaurantProduct.customisationProductSelected,
    setCustomisationProductSelected = _useRestaurantProduct.setCustomisationProductSelected,
    isCustomisationHeaderEnabled = _useRestaurantProduct.isCustomisationHeaderEnabled,
    isCategoryTotalizerEnabled = _useRestaurantProduct.isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled = _useRestaurantProduct.isAdditionalMessageEnabled,
    productAddedToCartTrack = _useRestaurantProduct.productAddedToCartTrack,
    orderUpdatedTrack = _useRestaurantProduct.orderUpdatedTrack,
    orderViewedTrack = _useRestaurantProduct.orderViewedTrack,
    orderCompletedTrack = _useRestaurantProduct.orderCompletedTrack,
    setSelectedLayerOption = _useRestaurantProduct.setSelectedLayerOption,
    showAddonAvailability = _useRestaurantProduct.showAddonAvailability,
    accessibilityEnabled = _useRestaurantProduct.accessibilityEnabled,
    showCategoriesHeader = _useRestaurantProduct.showCategoriesHeader,
    selectedLayerOption = _useRestaurantProduct.selectedLayerOption,
    setNavigationList = _useRestaurantProduct.setNavigationList,
    showPriceWarning = _useRestaurantProduct.showPriceWarning,
    computedNextPath = _useRestaurantProduct.computedNextPath,
    setCommitedItem = _useRestaurantProduct.setCommitedItem,
    basketCountPath = _useRestaurantProduct.basketCountPath,
    translateInline = _useRestaurantProduct.translateInline,
    navigationList = _useRestaurantProduct.navigationList,
    setUpsellState = _useRestaurantProduct.setUpsellState,
    commitedItem = _useRestaurantProduct.commitedItem,
    previousPath = _useRestaurantProduct.previousPath,
    formatPrice = _useRestaurantProduct.formatPrice,
    setTemplate = _useRestaurantProduct.setTemplate,
    categoryId = _useRestaurantProduct.categoryId,
    menuState = _useRestaurantProduct.menuState,
    productId = _useRestaurantProduct.productId,
    menuPath = _useRestaurantProduct.menuPath,
    settings = _useRestaurantProduct.settings,
    products = _useRestaurantProduct.products,
    nextPath = _useRestaurantProduct.nextPath,
    filterId = _useRestaurantProduct.filterId,
    loading = _useRestaurantProduct.loading,
    session = _useRestaurantProduct.session,
    history = _useRestaurantProduct.history,
    commit = _useRestaurantProduct.commit,
    origin = _useRestaurantProduct.origin,
    staged = _useRestaurantProduct.staged,
    items = _useRestaurantProduct.items,
    stage = _useRestaurantProduct.stage,
    count = _useRestaurantProduct.count,
    uid = _useRestaurantProduct.uid,
    t = _useRestaurantProduct.t,
    disableModifyUpsellOnCart = _useRestaurantProduct.disableModifyUpsellOnCart,
    hideDisabledButtons = _useRestaurantProduct.hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault = _useRestaurantProduct.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero = _useRestaurantProduct.hidePriceWhenZero,
    itemSelectTrack = _useRestaurantProduct.itemSelectTrack;
  var previousText = t('composedPreviousAction');
  var nextText = t('composedNextAction');
  var cancelOrderText = t('composedCancelOrderAction');
  var menuText = t('menuAction');
  var title = t('composedHeaderTitle');
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  var _useState = React.useState(false),
    showMiniCartModal = _useState[0],
    setShowMiniCartModal = _useState[1];
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var _ref = session || {},
    sessionId = _ref.id;
  var formattedOptions = React.useCallback(function (layers) {
    var formattedOptions = layers == null ? void 0 : layers.options.map(function (option) {
      return _extends({}, option, {
        title: translateInline(option == null ? void 0 : option.name)
      });
    });
    return {
      options: formattedOptions,
      title: translateInline(layers == null ? void 0 : layers.name)
    };
  }, [translateInline]);
  var product = React.useMemo(function () {
    if (!menuState) return;
    if (!(menuState != null && menuState.matches('success'))) return;
    var formattedProduct = getProductById({
      products: products,
      id: productId
    });
    return _extends({}, formattedProduct, {
      title: translateInline(formattedProduct == null ? void 0 : formattedProduct.name)
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, menuState, products]);
  var layer = React.useMemo(function () {
    var _product$composed;
    if (!menuState) return;
    if (!(menuState != null && menuState.matches('success'))) return;
    if (!product) return;
    if (selectedLayerOption) return formattedOptions(selectedLayerOption == null ? void 0 : selectedLayerOption.layers[0]);
    return formattedOptions(product == null ? void 0 : (_product$composed = product.composed) == null ? void 0 : _product$composed.layers[0]);
  }, [selectedLayerOption, formattedOptions, menuState, product]);
  var composedProductFinal = React.useMemo(function () {
    var _selectedLayerOption$, _selectedLayerOption$2;
    if (!menuState) return;
    if (!(menuState != null && menuState.matches('success'))) return;
    if (!product) return;
    if ((selectedLayerOption == null ? void 0 : (_selectedLayerOption$ = selectedLayerOption.layers) == null ? void 0 : _selectedLayerOption$.length) === 0 && (selectedLayerOption == null ? void 0 : (_selectedLayerOption$2 = selectedLayerOption.products) == null ? void 0 : _selectedLayerOption$2.length) > 0) {
      var finalProduct = getProductById({
        products: products,
        id: selectedLayerOption == null ? void 0 : selectedLayerOption.products[0]
      });
      return _extends({}, finalProduct, {
        title: translateInline(finalProduct == null ? void 0 : finalProduct.name)
      });
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLayerOption, menuState, products, product]);
  var onSelectComposedLayerOptions = React.useCallback(function (product) {
    var translatedName = translateInline(product == null ? void 0 : product.name);
    setSelectedLayerOption(_extends({}, product, {
      id: product == null ? void 0 : product.id,
      name: translatedName,
      layers: product == null ? void 0 : product.layers
    }));
    setNavigationList(function (currentSelection) {
      return [].concat(currentSelection, [_extends({}, product, {
        id: product == null ? void 0 : product.id,
        name: translatedName,
        layers: product == null ? void 0 : product.layers,
        layerTitle: layer.title,
        layerValue: translatedName
      })]);
    });
  }, [setSelectedLayerOption, translateInline, layer, setNavigationList]);
  var validateLayerNavigation = React.useCallback(function () {
    //if there is just one item and there is one layer selected, this means that we need to go back to category view.
    if ((navigationList == null ? void 0 : navigationList.length) === 1 && selectedLayerOption) {
      setSelectedLayerOption(null);
      setNavigationList([]);
    } else {
      //first we remove the last item of the navigationList and then we get the next-to-last layer to be the current one.
      var auxArray = Array.from(navigationList);
      var _auxArray$slice = auxArray == null ? void 0 : auxArray.slice(-2),
        lastItem = _auxArray$slice[0];
      setNavigationList(navigationList == null ? void 0 : navigationList.slice(0, -1));
      setSelectedLayerOption(_extends({}, lastItem));
    }
  }, [navigationList, selectedLayerOption, setSelectedLayerOption, setNavigationList]);
  var previousAction = React.useCallback(function () {
    if ((navigationList == null ? void 0 : navigationList.length) > 0) {
      validateLayerNavigation();
    } else {
      var prev = categoryId ? previousPath.replace(':categoryId', categoryId) : '/categories';
      var path = origin ? origin : prev;
      history.push(path);
    }
  }, [categoryId, history, previousPath, origin, navigationList, validateLayerNavigation]);
  var nextAction = React.useCallback(function () {
    registerProductAddToCart$2({
      setUpsellState: setUpsellState
    }, {
      sessionId: sessionId,
      settings: settings,
      product: product,
      staged: staged,
      upsell: 'normal'
    });
    itemSelectTrack == null ? void 0 : itemSelectTrack(staged, cartItems, kioskSettings.kiosk, couponNumber, currentCategory);
    productAddedToCartTrack(staged, kioskSettings.kiosk, couponNumber, currentCategory);
    if (uid) orderUpdatedTrack();
    commit({
      staged: staged
    });
    setCommitedItem(staged);
  }, [setCommitedItem, setUpsellState, sessionId, settings, product, staged, commit, productAddedToCartTrack, orderUpdatedTrack, uid, couponNumber, kioskSettings.kiosk, itemSelectTrack, cartItems, currentCategory]);
  var basketCountAction = React.useCallback(function () {
    return history.push(basketCountPath);
  }, [basketCountPath, history]);
  var onCloseProductCustomisationModal = function onCloseProductCustomisationModal() {
    return setOpenProductCustomisationModal(false);
  };
  var onSelectCustomisationProduct = React.useCallback(function (product) {
    var isFinalProductCombo = (composedProductFinal == null ? void 0 : composedProductFinal.type) === 'combo' && (composedProductFinal == null ? void 0 : composedProductFinal.combo);
    if (isFinalProductCombo) {
      var formattedSettings = formatSettings(composedProductFinal);
      var formattedProduct = formatProduct(formattedSettings);
      var callbackClick = formattedProduct == null ? void 0 : formattedProduct.onClick;
      callbackClick();
    } else {
      setOpenProductCustomisationModal(true);
      setCustomisationProductSelected(product);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setOpenProductCustomisationModal, composedProductFinal, formatSettings, setCustomisationProductSelected]);
  var formatSettings = React.useCallback(function (product) {
    return {
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      translateInline: translateInline,
      categoryId: categoryId,
      products: products,
      settings: settings,
      history: history,
      product: product,
      commit: commit,
      title: translateInline(product == null ? void 0 : product.name)
    };
  }, [onSelectCustomisationProduct, translateInline, categoryId, products, settings, history, commit]);
  var onConfirmProductCustomisationModal = function onConfirmProductCustomisationModal(_ref2) {
    var staged = _ref2.staged;
    setOpenProductCustomisationModal(false);
    commit({
      staged: staged
    });

    /* 
      When we set the commited item, we redirect to a different route (usually the category route).
      If it is the last phase of the composite product, we must set the committed item and redirect to the new route.
      But if we are editing a customizable item in the mini cart, we must not redirect after confirming the product edit.
    */
    if (composedProductFinal) {
      setCommitedItem(staged);
    }
  };
  var onCloseMiniCartModal = function onCloseMiniCartModal(_ref3) {
    var updatedStaged = _ref3.updatedStaged;
    setShowMiniCartModal(false);
    if (updatedStaged) {
      var _updatedStaged$type = updatedStaged.type,
        type = _updatedStaged$type === void 0 ? '' : _updatedStaged$type;
      if (type === 'customise') return onSelectCustomisationProduct(updatedStaged);
      stage({
        staged: updatedStaged
      });
    }
  };
  var onConfirmMiniCartModal = React.useCallback(function () {
    orderCompletedTrack();
    history.push(computedNextPath);
  }, [history, computedNextPath, orderCompletedTrack]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
      orderViewedTrack(cartItems, kioskSettings.kiosk, orderTotal, couponNumber);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal, orderViewedTrack, cartItems, kioskSettings.kiosk, orderTotal, couponNumber]);
  React.useEffect(function () {
    if (!(composedProductFinal != null && composedProductFinal.id)) return;
    stage({
      product: composedProductFinal
    });
  }, [composedProductFinal, stage]);
  React.useEffect(function () {
    if (!commitedItem) return;
    var isCommited = items.some(function (item) {
      return commitedItem.uid === item.uid;
    });
    if (isCommited) {
      var prev = categoryId ? previousPath.replace(':categoryId', categoryId) : '/categories';
      var next = computedNextPath;
      var path = origin ? origin : uid ? next : prev;
      if (path === next) orderCompletedTrack();
      history.push(path, {
        product: product,
        filterId: filterId
      });
    }
  }, [orderCompletedTrack, computedNextPath, previousPath, commitedItem, categoryId, nextPath, filterId, history, product, origin, items, uid]);
  React.useEffect(function () {
    var header = {
      allowPreviousAction: true,
      showCouponButton: true,
      showCategoriesHeader: showCategoriesHeader,
      previousAction: previousAction,
      onBasketClick: onBasketClick,
      previousText: previousText,
      menuAction: menuAction,
      menuText: menuText,
      count: count,
      title: title
    };
    var footer = {
      allowNextAction: (composedProductFinal == null ? void 0 : composedProductFinal.type) === 'simple' ? true : false,
      allowPreviousAction: true,
      enableCancelOrder: true,
      showCouponButton: true,
      cancelOrderText: cancelOrderText,
      onBasketClick: onBasketClick,
      previousAction: previousAction,
      previousText: previousText,
      nextAction: nextAction,
      nextText: nextText
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [showCategoriesHeader, composedProductFinal, basketCountAction, cancelOrderText, previousAction, onBasketClick, previousText, setTemplate, menuAction, nextAction, nextText, menuText, staged, title, count, t]);
  return {
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    onConfirmProductCustomisationModal: onConfirmProductCustomisationModal,
    onCloseProductCustomisationModal: onCloseProductCustomisationModal,
    openProductCustomisationModal: openProductCustomisationModal,
    customisationProductSelected: customisationProductSelected,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    onSelectCustomisationProduct: onSelectCustomisationProduct,
    onSelectComposedLayerOptions: onSelectComposedLayerOptions,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    onConfirmMiniCartModal: onConfirmMiniCartModal,
    showAddonAvailability: showAddonAvailability,
    onCloseMiniCartModal: onCloseMiniCartModal,
    composedProductFinal: composedProductFinal,
    accessibilityEnabled: accessibilityEnabled,
    selectedLayerOption: selectedLayerOption,
    showMiniCartModal: showMiniCartModal,
    showPriceWarning: showPriceWarning,
    navigationList: navigationList,
    formatPrice: formatPrice,
    menuState: menuState,
    loading: loading,
    product: product,
    layer: layer,
    t: t,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    hideDisabledButtons: hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero
  };
};

var ProductSubstitutionModal = function ProductSubstitutionModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$formattedSubstit = _ref.formattedSubstitutions,
    formattedSubstitutions = _ref$formattedSubstit === void 0 ? [] : _ref$formattedSubstit,
    onSelect = _ref.onSelect;
  var itemsContainerHeight = 'h-[40rem]';
  var modalContent = /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "w-full space-y-4 divide-y divide-gray-200",
    "data-test": "substitution-list",
    children: formattedSubstitutions.map(function (substitution) {
      var _substitution$name;
      return /*#__PURE__*/jsxRuntime.jsxs("button", {
        disabled: !substitution.isAvailable,
        "data-test": "substitution-item-" + substitution.id,
        onClick: function onClick() {
          onSelect(substitution);
          onClose();
        },
        className: "flex items-center w-full p-8 hover:bg-gray-50 transition-colors min-h-[8rem] " + (!substitution.isAvailable ? 'opacity-50 cursor-not-allowed' : ''),
        children: [/*#__PURE__*/jsxRuntime.jsx(PlusCircle, {
          className: "w-8 h-8 text-gray-500 shrink-0"
        }), /*#__PURE__*/jsxRuntime.jsx("span", {
          "data-test": "substitution-name-" + substitution.id,
          className: "ml-4 text-4xl font-medium " + (substitution.isAvailable ? 'text-gray-800' : 'text-gray-400 line-through'),
          children: (_substitution$name = substitution.name) == null ? void 0 : _substitution$name.text
        })]
      }, substitution.id);
    })
  });
  var CustomModalHeader = function CustomModalHeader(_ref2) {
    var title = _ref2.title;
    return /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "relative border-b-2 border-gray-300",
      "data-test": "modal-header",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center p-4",
        children: /*#__PURE__*/jsxRuntime.jsx("h2", {
          "data-test": "modal-title",
          className: "text-5xl font-bold text-gray-900",
          children: title
        })
      }), /*#__PURE__*/jsxRuntime.jsx("button", {
        onClick: onClose,
        "data-test": "close-button",
        className: "absolute text-gray-500 transition-colors top-4 left-4 hover:text-gray-700",
        children: /*#__PURE__*/jsxRuntime.jsx(XCircle, {
          className: "w-8 h-8"
        })
      })]
    });
  };
  return /*#__PURE__*/jsxRuntime.jsx(Modal, {
    open: isOpen,
    title: "Substitute",
    closeModal: onClose,
    ModalHeader: CustomModalHeader,
    ModalFooter: null,
    className: "inset-0 bg-black/50",
    contentContainerClassName: "flex flex-col w-3/5 border-0 mx-auto rounded-lg shadow-lg bg-white custom-modal bg-modal p-4",
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "overflow-y-auto " + itemsContainerHeight,
      "data-test": "modal-content",
      children: modalContent
    })
  });
};

var registerClickAndView = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_temp) {
    var _settings$settings, _settings$settings$or;
    var _ref2, sessionId, settings, product, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _temp === void 0 ? {} : _temp, sessionId = _ref2.sessionId, settings = _ref2.settings, product = _ref2.product, upsell = _ref2.upsell;
          registerPayload = {
            sessionId: sessionId,
            position: 0,
            productVariant: 0,
            categoryName: 0,
            product: product,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$or = _settings$settings.order) == null ? void 0 : _settings$settings$or.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell
          };
          _context.prev = 2;
          _context.next = 5;
          return googleAnalytics.registerProductClick(registerPayload);
        case 5:
          _context.next = 7;
          return googleAnalytics.registerProductView(registerPayload);
        case 7:
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          logger.error('cringer.components - registerClickAndView - Error:', _context.t0);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return function registerClickAndView(_x) {
    return _ref.apply(this, arguments);
  };
}();
var registerAddedToCart = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options, _temp2) {
    var _staged$count, _settings$settings2, _settings$settings2$o;
    var _ref4, sessionId, settings, product, staged, upsell, registerPayload;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _temp2 === void 0 ? {} : _temp2, sessionId = _ref4.sessionId, settings = _ref4.settings, product = _ref4.product, staged = _ref4.staged, upsell = _ref4.upsell;
          registerPayload = {
            sessionId: sessionId,
            productVariant: '',
            categoryName: '',
            product: product,
            price: product == null ? void 0 : product.price,
            quantity: staged == null ? void 0 : (_staged$count = staged.count) == null ? void 0 : _staged$count.current,
            listName: '',
            storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
            organisation: (settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$o = _settings$settings2.order) == null ? void 0 : _settings$settings2$o.organisationId) || '',
            serial: (settings == null ? void 0 : settings.serial) || '',
            upsell: upsell
          };
          _context2.prev = 2;
          _context2.next = 5;
          return googleAnalytics.registerProductAddedToCart(options, registerPayload);
        case 5:
          _context2.next = 10;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](2);
          logger.error('cringer.components - registerAddedToCart - Error:', _context2.t0);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 7]]);
  }));
  return function registerAddedToCart(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var _excluded$4 = ["defaultData"],
  _excluded2 = ["setValidatedValues", "select", "substitute", "resetSubstitutions", "removeAll", "remove", "add", "edit"];
function mapSubstitutions(substitutions) {
  return substitutions.map(function (s) {
    var _s$providerData, _s$providerData2, _s$providerData3, _s$providerData4;
    return {
      id: s.id,
      isSelected: s.isSelected,
      providerData: {
        modGroupId: (_s$providerData = s.providerData) == null ? void 0 : _s$providerData.modGroupId,
        itemId: (_s$providerData2 = s.providerData) == null ? void 0 : _s$providerData2.itemId,
        modCodeId: (_s$providerData3 = s.providerData) == null ? void 0 : _s$providerData3.modCodeId,
        oloChainId: (_s$providerData4 = s.providerData) == null ? void 0 : _s$providerData4.oloChainId
      }
    };
  });
}
function removeDefaultData(item) {
  if (!item || !item.providerData) return item;
  var _item$providerData = item.providerData,
    restProviderData = _objectWithoutPropertiesLoose(_item$providerData, _excluded$4);
  return _extends({}, item, {
    providerData: restProviderData
  });
}
function buildDefaultData(cleanedSubstitution) {
  var _cleanedSubstitution$, _cleanedSubstitution$2;
  return {
    id: cleanedSubstitution.id,
    name: (cleanedSubstitution == null ? void 0 : (_cleanedSubstitution$ = cleanedSubstitution.name) == null ? void 0 : _cleanedSubstitution$.text) || '',
    product: _extends({}, cleanedSubstitution, {
      providerData: _extends({}, cleanedSubstitution.providerData, {
        substitutions: mapSubstitutions((_cleanedSubstitution$2 = cleanedSubstitution.providerData) == null ? void 0 : _cleanedSubstitution$2.substitutions),
        defaultData: undefined
      })
    })
  };
}
function removeFunctions(substitutionData) {
  if (!substitutionData) return null;
  var rest = _objectWithoutPropertiesLoose(substitutionData, _excluded2);
  return rest;
}
function hydrateProductData(product, substitutionData, isDefault) {
  var _substitutionData$pro, _substitutionData$pro2, _finalDefaultData$pro, _finalDefaultData$pro2, _finalDefaultData$pro3;
  if (!product) return null;
  // Prevents error when trying to serialize the object in recoil
  var serializableData = removeFunctions(substitutionData);
  var cleanedSubstitution = removeDefaultData(serializableData);
  var substitutionList = (substitutionData == null ? void 0 : (_substitutionData$pro = substitutionData.providerData) == null ? void 0 : _substitutionData$pro.substitutions) || [];
  var finalDefaultData = isDefault ? buildDefaultData(cleanedSubstitution) : substitutionData == null ? void 0 : (_substitutionData$pro2 = substitutionData.providerData) == null ? void 0 : _substitutionData$pro2.defaultData;
  var providerData = _extends({}, product.providerData, {
    substitutions: mapSubstitutions(substitutionList),
    defaultData: finalDefaultData ? _extends({}, finalDefaultData, {
      product: _extends({}, finalDefaultData.product, {
        providerData: _extends({}, (_finalDefaultData$pro = finalDefaultData.product) == null ? void 0 : _finalDefaultData$pro.providerData, {
          substitutions: mapSubstitutions((_finalDefaultData$pro2 = finalDefaultData.product) == null ? void 0 : (_finalDefaultData$pro3 = _finalDefaultData$pro2.providerData) == null ? void 0 : _finalDefaultData$pro3.substitutions),
          defaultData: undefined
        })
      })
    }) : undefined
  });
  return _extends({}, product, {
    price: 0,
    providerData: providerData
  });
}

var useProductCustomisationModal = function useProductCustomisationModal(_ref) {
  var product = _ref.product,
    onConfirmCallback = _ref.onConfirmCallback,
    onCloseCallback = _ref.onCloseCallback,
    showOutOfStockModal = _ref.showOutOfStockModal,
    setStaged = _ref.setStaged;
  var _useState = React.useState(false),
    isSubstitutionModalOpen = _useState[0],
    setIsSubstitutionModalOpen = _useState[1];
  var _useState2 = React.useState(null),
    selectedProductForSubstitution = _useState2[0],
    setSelectedProductForSubstitution = _useState2[1];
  var _useState3 = React.useState(null),
    pendingSubstitution = _useState3[0],
    setPendingSubstitution = _useState3[1];
  var _useState4 = React.useState([]),
    productStack = _useState4[0],
    setProductStack = _useState4[1];
  var _useState5 = React.useState(product),
    currentProduct = _useState5[0],
    setCurrentProduct = _useState5[1];
  var _useRestaurantMenu = useRestaurantMenu(),
    products = _useRestaurantMenu.products,
    loading = _useRestaurantMenu.loading,
    settings = _useRestaurantMenu.settings,
    menuState = _useRestaurantMenu.state;
  var _useStage = cart.useStage(),
    stage = _useStage.stage,
    staged = _useStage.staged;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var translateInline = translateProductName(language);
  var flags = launchdarklyReactClientSdk.useFlags();
  var session = recoil.useRecoilValue(atoms.sessionState);
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var trackedUpsells = recoil.useRecoilValue(atoms.trackedUpsellsState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var _ref3 = session || {},
    sessionId = _ref3.id;
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    orderUpdatedTrack = _useAnalytics.orderUpdatedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var showOutOfStockDefaultItemWarnings = utilities.useSettingsAtPath({
    path: 'settings.content.outOfStockDefaultItemWarning',
    defaultValue: false
  });
  var substitute = React.useCallback(function (substitution) {
    if (!staged) return;
    if (!substitution) return;
    if (typeof staged.substitute !== 'function') return;
    staged.substitute(selectedProductForSubstitution, substitution);
  }, [staged, selectedProductForSubstitution]);
  var handleSubstitutionSelect = function handleSubstitutionSelect(product) {
    substitute(product);
    handleCloseSubstitutionModal();
  };
  var handleOpenSubstitutionModal = function handleOpenSubstitutionModal(product) {
    setSelectedProductForSubstitution(product);
    setIsSubstitutionModalOpen(true);
  };
  var handleCloseSubstitutionModal = function handleCloseSubstitutionModal() {
    setIsSubstitutionModalOpen(false);
    setSelectedProductForSubstitution(null);
  };
  React.useEffect(function () {
    // Handle substitutions that are pending
    if (selectedProductForSubstitution && pendingSubstitution) {
      substitute(_extends({}, pendingSubstitution, {
        "default": true
      }));
      setPendingSubstitution(null);
    }
  }, [selectedProductForSubstitution, pendingSubstitution, substitute]);
  var handleEditProduct = function handleEditProduct(newStage) {
    setProductStack(function (prevStack) {
      return [].concat(prevStack, [staged]);
    });
    stage({
      staged: _extends({}, newStage)
    });
  };
  var formattedSubstitutions = React.useMemo(function () {
    var _selectedProductForSu, _staged$customisation, _staged$customisation2, _staged$customisation3;
    var substitutions = selectedProductForSubstitution == null ? void 0 : (_selectedProductForSu = selectedProductForSubstitution.providerData) == null ? void 0 : _selectedProductForSu.substitutions;
    if (!substitutions || !Array.isArray(substitutions)) return [];
    var _ref4 = selectedProductForSubstitution || {},
      isDefault = _ref4["default"];
    var stagedNames = (staged == null ? void 0 : (_staged$customisation = staged.customisations) == null ? void 0 : (_staged$customisation2 = _staged$customisation.filter(function (customisation) {
      return customisation.type === 'substitutable';
    })) == null ? void 0 : (_staged$customisation3 = _staged$customisation2.flatMap(function (customisation) {
      return customisation.products;
    })) == null ? void 0 : _staged$customisation3.map(function (product) {
      var _foundProduct$name;
      var foundProduct = products.find(function (p) {
        return (p == null ? void 0 : p.id) === product.id;
      });
      return (foundProduct == null ? void 0 : (_foundProduct$name = foundProduct.name) == null ? void 0 : _foundProduct$name.text) || '';
    })) || [];
    var result = substitutions.map(function (substitution) {
      var _product$name;
      var productId = substitution.id;
      var product = products.find(function (p) {
        return (p == null ? void 0 : p.id) === productId;
      });

      // Prevent the same product to be included again
      if (stagedNames.includes(product == null ? void 0 : (_product$name = product.name) == null ? void 0 : _product$name.text)) return null;
      return hydrateProductData(product, selectedProductForSubstitution, isDefault);
    }).filter(Boolean);
    return result;
  }, [selectedProductForSubstitution, products, staged]);
  var formatProducts = React.useCallback(function (products) {
    if (products === void 0) {
      products = [];
    }
    return products.map(function (p) {
      var productWithFallback = filterImageUrlFallback(p);
      return _extends({}, productWithFallback, {
        title: translateInline(productWithFallback == null ? void 0 : productWithFallback.name)
      });
    });
  }, [translateInline]);
  var onConfirm = function onConfirm() {
    if (productStack.length > 0) {
      var previousProduct = _extends({}, productStack[productStack.length - 1]);
      previousProduct.customisations.map(function (customisation, index) {
        customisation.products.map(function (product, index_) {
          if (product.id === currentProduct.id) {
            customisation.products[index_] = currentProduct;
          }
        });
        previousProduct.customisations[index] = customisation;
      });
      productStack.pop();
      setProductStack(productStack);
      stage({
        staged: _extends({}, previousProduct)
      });
    } else {
      var _staged$customisation4, _staged$customisation5;
      var customisationProducts = (_staged$customisation4 = staged == null ? void 0 : (_staged$customisation5 = staged.customisations) == null ? void 0 : _staged$customisation5.flatMap(function (category) {
        var _category$products;
        return (_category$products = category.products) != null ? _category$products : [];
      })) != null ? _staged$customisation4 : [];
      var hasOutOfStockDefaultItem = customisationProducts == null ? void 0 : customisationProducts.some(function (product) {
        return product["default"] && !product.isAvailable;
      });

      /**
       * Conditionally opens a warning modal on top of customisation modal when the customers clicks "Add to order"
       * if exactly one default recipe is out of stock.
       *
       * If this condition is true, the responsibility for tracking analytics add adding the product to the cart
       * is handled by the `useHeadsUpModal` hook.
       *
       * @link packages/components/src/components/stateful/heads-up-modal/hook/index.js
       * @see https://fingermarkglobal.atlassian.net/browse/S2OP-2086
       */
      if (hasOutOfStockDefaultItem && showOutOfStockDefaultItemWarnings) {
        return showOutOfStockModal();
      }
      var isUpsell = trackedUpsells.includes(product.id);
      registerAddedToCart({
        setUpsellState: setUpsellState
      }, {
        sessionId: sessionId,
        settings: settings,
        product: product,
        staged: staged,
        upsell: isUpsell ? 'upsell' : 'normal'
      });
      if (!isUpsell) {
        itemSelectTrack == null ? void 0 : itemSelectTrack(staged, cartItems, kioskSettings.kiosk, couponNumber, currentCategory);
        if (!product.uid) productAddedToCartTrack(_extends({}, staged, {
          isCrossSell: product.isCrossSell
        }), kioskSettings.kiosk, couponNumber, currentCategory);
      }
      if (product.uid) orderUpdatedTrack();
      onConfirmCallback({
        staged: staged,
        product: product,
        animate: product.uid ? false : true,
        uid: product.uid
      });
    }
  };
  var onCancel = function onCancel() {
    if (productStack.length <= 0) {
      onCloseCallback();
    } else {
      var previousProduct = productStack[productStack.length - 1];
      setCurrentProduct(previousProduct || staged);
      setProductStack(function (prevStack) {
        return prevStack.slice(0, -1);
      });
      stage({
        staged: _extends({}, previousProduct)
      });
    }
  };
  React.useEffect(function () {
    if (!product) return;
    registerClickAndView({
      sessionId: sessionId,
      product: product,
      settings: settings
    });
    var _ref5 = product || {},
      uid = _ref5.uid;
    if (uid) return stage({
      uid: uid
    });
    stage({
      product: _extends({}, product, {
        parentCategory: currentCategory
      })
    });
  }, [sessionId, settings, product, flags, stage, currentCategory]);
  React.useEffect(function () {
    if (!staged) return;
    setCurrentProduct(staged);
    setStaged(staged);
  }, [staged, setStaged]);
  var customisations = React.useMemo(function () {
    return (staged == null ? void 0 : staged.customisations) || [];
  }, [staged]);
  var formattedCustomisations = React.useMemo(function () {
    return customisations == null ? void 0 : customisations.map(function (customisation) {
      return _extends({}, customisation, {
        title: translateInline(customisation == null ? void 0 : customisation.name),
        products: formatProducts(customisation == null ? void 0 : customisation.products)
      });
    });
  }, [customisations, translateInline, formatProducts]);
  var allowOnConfirm = React.useMemo(function () {
    var _staged$customisation6, _substitutableCustomi;
    if (!(staged != null && staged.ready)) return false;
    var substitutableCustomisations = (staged == null ? void 0 : (_staged$customisation6 = staged.customisations) == null ? void 0 : _staged$customisation6.filter(function (customisation) {
      return (customisation == null ? void 0 : customisation.type) === 'substitutable';
    })) || [];
    if (substitutableCustomisations.length === 0) {
      return staged.ready;
    }
    var allAvailable = (substitutableCustomisations == null ? void 0 : (_substitutableCustomi = substitutableCustomisations.flatMap(function (customisation) {
      return customisation.products;
    })) == null ? void 0 : _substitutableCustomi.every(function (product) {
      return product.isAvailable;
    })) || false;
    return allAvailable;
  }, [staged]);
  return {
    customisations: formattedCustomisations,
    staged: staged,
    stage: stage,
    onConfirm: onConfirm,
    onCancel: onCancel,
    t: t,
    loading: loading,
    menuState: menuState,
    allowOnConfirm: allowOnConfirm,
    isSubstitutionModalOpen: isSubstitutionModalOpen,
    handleOpenSubstitutionModal: handleOpenSubstitutionModal,
    handleCloseSubstitutionModal: handleCloseSubstitutionModal,
    handleSubstitutionSelect: handleSubstitutionSelect,
    selectedProductForSubstitution: selectedProductForSubstitution,
    formattedSubstitutions: formattedSubstitutions,
    handleEditProduct: handleEditProduct
  };
};

var ProductCustomisationModal = function ProductCustomisationModal(_ref) {
  var product = _ref.product,
    _ref$showSpacer = _ref.showSpacer,
    showSpacer = _ref$showSpacer === void 0 ? true : _ref$showSpacer,
    _ref$ProductCustomisa = _ref.ProductCustomisations,
    ProductCustomisations$1 = _ref$ProductCustomisa === void 0 ? ProductCustomisations : _ref$ProductCustomisa,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$addToCartDirectl = _ref.addToCartDirectly,
    addToCartDirectly = _ref$addToCartDirectl === void 0 ? false : _ref$addToCartDirectl,
    _ref$showQuantityCont = _ref.showQuantityControllerLabel,
    showQuantityControllerLabel = _ref$showQuantityCont === void 0 ? false : _ref$showQuantityCont,
    _ref$isCustomisationH = _ref.isCustomisationHeaderEnabled,
    isCustomisationHeaderEnabled = _ref$isCustomisationH === void 0 ? false : _ref$isCustomisationH,
    _ref$isCustomiseCateg = _ref.isCustomiseCategoryTitleEnabled,
    isCustomiseCategoryTitleEnabled = _ref$isCustomiseCateg === void 0 ? true : _ref$isCustomiseCateg,
    _ref$isCategoryTotali = _ref.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref$isCategoryTotali === void 0 ? true : _ref$isCategoryTotali,
    _ref$isAdditionalMess = _ref.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref$isAdditionalMess === void 0 ? true : _ref$isAdditionalMess,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$showOutOfStockMo = _ref.showOutOfStockModal,
    showOutOfStockModal = _ref$showOutOfStockMo === void 0 ? function () {} : _ref$showOutOfStockMo,
    _ref$setStaged = _ref.setStaged,
    setStaged = _ref$setStaged === void 0 ? function () {} : _ref$setStaged,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showModifierEner = _ref.showModifierEnergyInformation,
    showModifierEnergyInformation = _ref$showModifierEner === void 0 ? false : _ref$showModifierEner,
    _ref$titleSeparator = _ref.titleSeparator,
    titleSeparator = _ref$titleSeparator === void 0 ? ' ' : _ref$titleSeparator,
    _ref$hidePriceWhenQua = _ref.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref$hidePriceWhenQua === void 0 ? false : _ref$hidePriceWhenQua,
    _ref$hidePriceWhenZer = _ref.hidePriceWhenZero,
    hidePriceWhenZero = _ref$hidePriceWhenZer === void 0 ? false : _ref$hidePriceWhenZer,
    _ref$shouldChangeAddB = _ref.shouldChangeAddButtonText,
    shouldChangeAddButtonText = _ref$shouldChangeAddB === void 0 ? false : _ref$shouldChangeAddB,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity,
    _ref$isOpenOutOfStock = _ref.isOpenOutOfStockModal,
    isOpenOutOfStockModal = _ref$isOpenOutOfStock === void 0 ? false : _ref$isOpenOutOfStock,
    _ref$cancelledOutOfSt = _ref.cancelledOutOfStockModal,
    cancelledOutOfStockModal = _ref$cancelledOutOfSt === void 0 ? false : _ref$cancelledOutOfSt;
  var _useProductCustomisat = useProductCustomisationModal({
      product: product,
      onConfirmCallback: onConfirmCallback,
      onCloseCallback: onCloseCallback,
      showOutOfStockModal: showOutOfStockModal,
      setStaged: setStaged
    }),
    customisations = _useProductCustomisat.customisations,
    t = _useProductCustomisat.t,
    onConfirm = _useProductCustomisat.onConfirm,
    menuState = _useProductCustomisat.menuState,
    allowOnConfirm = _useProductCustomisat.allowOnConfirm,
    loading = _useProductCustomisat.loading,
    staged = _useProductCustomisat.staged,
    isSubstitutionModalOpen = _useProductCustomisat.isSubstitutionModalOpen,
    handleOpenSubstitutionModal = _useProductCustomisat.handleOpenSubstitutionModal,
    handleCloseSubstitutionModal = _useProductCustomisat.handleCloseSubstitutionModal,
    handleSubstitutionSelect = _useProductCustomisat.handleSubstitutionSelect,
    formattedSubstitutions = _useProductCustomisat.formattedSubstitutions,
    handleEditProduct = _useProductCustomisat.handleEditProduct,
    onCancel = _useProductCustomisat.onCancel;

  // Conditionally triggers onConfirm:
  // - When addToCartDirectly is true (skips customization).
  // - AND the out-of-stock modal isn't cancelled (cancelledOutOfStockModal is false).
  // - AND the out-of-stock modal isn't currently open (isOpenOutOfStockModal is false).
  var confirmProduct = addToCartDirectly && !cancelledOutOfStockModal && !isOpenOutOfStockModal;
  React.useEffect(function () {
    if (!loading && menuState != null && menuState.matches('success') && confirmProduct) {
      onConfirm();
    }
  }, [loading, menuState, onConfirm, confirmProduct]);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "product-customisation-modal",
    className: "flex flex-col items-center justify-center w-full max-h-full product-customisation-modal",
    children: [loading && /*#__PURE__*/jsxRuntime.jsx(Loading, {}), (menuState == null ? void 0 : menuState.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "danger",
      className: "p-8",
      message: menuState.context.message
    }), (menuState == null ? void 0 : menuState.matches('success')) && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col w-full max-h-full",
      children: [isCustomisationHeaderEnabled && /*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
        title: t('productCustomisationModalHeaderTitle'),
        className: 'text-primary'
      }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisations$1, {
        className: "max-h-full overflow-y-auto",
        customisations: customisations,
        showPriceWarning: showPriceWarning,
        isAdditionalMessageEnabled: isAdditionalMessageEnabled,
        isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
        isCustomiseCategoryTitleEnabled: isCustomiseCategoryTitleEnabled,
        showAddonAvailability: showAddonAvailability,
        showModifierEnergyInformation: showModifierEnergyInformation,
        t: t,
        titleSeparator: titleSeparator,
        hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
        hidePriceWhenZero: hidePriceWhenZero,
        shouldChangeAddButtonText: shouldChangeAddButtonText,
        onOpenSubstitutionModal: handleOpenSubstitutionModal,
        staged: staged,
        formattedProduct: product,
        onEdit: handleEditProduct
      }), /*#__PURE__*/jsxRuntime.jsx(ProductSubstitutionModal, {
        isOpen: isSubstitutionModalOpen,
        onClose: handleCloseSubstitutionModal,
        formattedSubstitutions: formattedSubstitutions,
        onSelect: handleSubstitutionSelect
      }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
        allowAction: allowOnConfirm,
        action: onConfirm,
        actionText: product != null && product.uid ? t('productCustomisationModalUpdateCartAction') : t('productCustomisationModalAddToCartAction'),
        closeModal: onCancel,
        closeText: t('productCustomisationModalCloseAction'),
        buttonsClassName: showQuantityControllerLabel ? 'mt-10' : '',
        spacer: showSpacer ? /*#__PURE__*/jsxRuntime.jsx(QuantityControllerOutlined, {
          t: t,
          staged: staged,
          showLabel: showQuantityControllerLabel,
          isCouponQuantityDisabled: isCouponQuantityDisabled
        }) : null
      })]
    })]
  });
};

var ProductComposedSubHeader = function ProductComposedSubHeader(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showPrice = _ref.showPrice,
    showPrice = _ref$showPrice === void 0 ? false : _ref$showPrice,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? null : _ref$product;
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "product-composed-product-sub-header",
      className: "product-composed-product-sub-header fixed z-40 flex w-full p-2 md:p-8 md:-mt-1 text-base xs:text-xl sm:text-2xl md:text-4xl bg-white",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "product-composed-product-sub-header-info",
        className: "product-composed-product-sub-header-info flex justify-between w-full font-bold uppercase",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "product-composed-product-sub-header-info-name",
          children: product == null ? void 0 : product.title
        }), showPrice && (product == null ? void 0 : product.price) && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex-col",
          children: /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "product-composed-product-sub-header-info-price",
            children: formatPrice({
              price: product.price
            })
          })
        })]
      })
    })
  });
};

var ProductComposedOptions = function ProductComposedOptions(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$accessibilityEna = _ref.accessibilityEnabled,
    accessibilityEnabled = _ref$accessibilityEna === void 0 ? false : _ref$accessibilityEna,
    _ref$onSelectAction = _ref.onSelectAction,
    onSelectAction = _ref$onSelectAction === void 0 ? function () {} : _ref$onSelectAction,
    _ref$selectedOption = _ref.selectedOption,
    selectedOption = _ref$selectedOption === void 0 ? null : _ref$selectedOption,
    _ref$headerTitle = _ref.headerTitle,
    headerTitle = _ref$headerTitle === void 0 ? '' : _ref$headerTitle,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? null : _ref$product,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ProductComposedSubHeader, {
      product: product
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-composed",
      className: "product-composed flex-col flex items-center justify-center w-full h-full",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "product-composed-option-header",
        className: "product-composed-option-header flex w-full uppercase text-2xl xs:text-3xl md:text-7xl text-center font-bold align-center justify-center mb-4 md:mb-16 mt-12 " + (accessibilityEnabled ? 'mt-40' : 'md:mt-0'),
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "product-composed-option-header-title",
          className: "product-composed-option-header-title",
          children: headerTitle
        })
      }), options == null ? void 0 : options.map(function (option) {
        var isSelected = (selectedOption == null ? void 0 : selectedOption.id) === (option == null ? void 0 : option.id);
        return /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "product-composed-options",
          className: "product-composed-options flex items-center justify-center space-y-4 shadow-lg w-11/12 md:w-2/5 h-20 md:h-32 mb-8 md:mb-12 \n              " + (isSelected ? "bg-primary text-secondary" : "bg-white"),
          onClick: function onClick() {
            return onSelectAction(option);
          },
          children: /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "product-composed-options-description",
            className: "text-2xl font-bold text-center product-composed-options-description xs:text-3xl md:text-4xl",
            children: option == null ? void 0 : option.title
          })
        }, "product-composed-options-" + (option == null ? void 0 : option.id));
      })]
    })]
  });
};

var ProductComposedFinalProduct = function ProductComposedFinalProduct(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$onSelectCustomis = _ref.onSelectCustomisationProduct,
    onSelectCustomisationProduct = _ref$onSelectCustomis === void 0 ? function () {} : _ref$onSelectCustomis,
    _ref$accessibilityEna = _ref.accessibilityEnabled,
    accessibilityEnabled = _ref$accessibilityEna === void 0 ? false : _ref$accessibilityEna,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$layersSelection = _ref.layersSelection,
    layersSelection = _ref$layersSelection === void 0 ? [] : _ref$layersSelection,
    _ref$headerTitle = _ref.headerTitle,
    headerTitle = _ref$headerTitle === void 0 ? '' : _ref$headerTitle,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? null : _ref$product,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  var isCustomiseButtonEnabled = (product == null ? void 0 : product.type) === 'customise' || (product == null ? void 0 : product.type) === 'combo';
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ProductComposedSubHeader, {
      product: product,
      formatPrice: formatPrice,
      showPrice: true
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-composed",
      className: "product-composed flex-col flex items-center justify-center w-full md:h-full mt-16 md:mt-0 mb-4 md:mb-0",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        "data-test": "product-composed-product",
        className: "product-composed-product flex flex-col items-center justify-center w-full py-4 mb-4 text-4xl text-center",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "product-composed-option-header",
          className: "product-composed-option-header flex w-full uppercase text-2xl xs:text-3xl md:text-7xl text-center font-bold align-center justify-center " + (accessibilityEnabled ? 'mt-40' : ''),
          children: /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "product-composed-option-header-title",
            className: "product-composed-option-header-title",
            children: headerTitle
          })
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "product-composed-product-image",
          className: "product-composed-product-image flex justify-center w-full p-4",
          children: /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
            src: product == null ? void 0 : product.imageUrl,
            className: "w-1/2 mx-auto"
          })
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          "data-test": "product-composed-product-name",
          className: "product-composed-product-name md:w-3/4 mb-4 text-xl xs:text-3xl md:text-5xl text-center font-secondary",
          children: product == null ? void 0 : product.title
        }), layersSelection == null ? void 0 : layersSelection.map(function (layer, index) {
          return /*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "product-composed-product-selection-layers-" + index,
            className: "product-composed-product-selection-layers-" + index + " flex justify-center md:w-1/2 mb-6 text-xl xs:text-3xl md:text-4xl font-secondary",
            children: /*#__PURE__*/jsxRuntime.jsxs("div", {
              children: [layer == null ? void 0 : layer.layerTitle, ": ", layer == null ? void 0 : layer.layerValue]
            })
          }, index);
        }), (product == null ? void 0 : product.price) && /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "product-composed-product-price",
          className: "product-composed-product-price text-xl xs:text-3xl md:text-4xl font-secondary",
          children: /*#__PURE__*/jsxRuntime.jsx("div", {
            children: formatPrice({
              price: product.price
            })
          })
        })]
      }), isCustomiseButtonEnabled && /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
        className: "footer-action-button",
        onClick: function onClick() {
          return onSelectCustomisationProduct(product);
        },
        children: t('composedProductFinalCustomise')
      })]
    })]
  });
};

var RestaurantProductComposedView = function RestaurantProductComposedView() {
  var _useRestaurantProduct = useRestaurantProductComposedView(),
    onConfirmProductCustomisationModal = _useRestaurantProduct.onConfirmProductCustomisationModal,
    onCloseProductCustomisationModal = _useRestaurantProduct.onCloseProductCustomisationModal,
    openProductCustomisationModal = _useRestaurantProduct.openProductCustomisationModal,
    customisationProductSelected = _useRestaurantProduct.customisationProductSelected,
    isCustomisationHeaderEnabled = _useRestaurantProduct.isCustomisationHeaderEnabled,
    onSelectCustomisationProduct = _useRestaurantProduct.onSelectCustomisationProduct,
    onSelectComposedLayerOptions = _useRestaurantProduct.onSelectComposedLayerOptions,
    isCategoryTotalizerEnabled = _useRestaurantProduct.isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled = _useRestaurantProduct.isAdditionalMessageEnabled,
    modalAccessibilityClass = _useRestaurantProduct.modalAccessibilityClass,
    onConfirmMiniCartModal = _useRestaurantProduct.onConfirmMiniCartModal,
    showAddonAvailability = _useRestaurantProduct.showAddonAvailability,
    onCloseMiniCartModal = _useRestaurantProduct.onCloseMiniCartModal,
    composedProductFinal = _useRestaurantProduct.composedProductFinal,
    accessibilityEnabled = _useRestaurantProduct.accessibilityEnabled,
    selectedLayerOption = _useRestaurantProduct.selectedLayerOption,
    showMiniCartModal = _useRestaurantProduct.showMiniCartModal,
    showPriceWarning = _useRestaurantProduct.showPriceWarning,
    navigationList = _useRestaurantProduct.navigationList,
    formatPrice = _useRestaurantProduct.formatPrice,
    menuState = _useRestaurantProduct.menuState,
    loading = _useRestaurantProduct.loading,
    product = _useRestaurantProduct.product,
    layer = _useRestaurantProduct.layer,
    t = _useRestaurantProduct.t,
    disableModifyUpsellOnCart = _useRestaurantProduct.disableModifyUpsellOnCart,
    hideDisabledButtons = _useRestaurantProduct.hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault = _useRestaurantProduct.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero = _useRestaurantProduct.hidePriceWhenZero;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(Modal, {
      className: modalAccessibilityClass,
      formatPrice: formatPrice,
      open: showMiniCartModal,
      children: /*#__PURE__*/jsxRuntime.jsx(MiniCartModal, {
        onConfirmCallback: onConfirmMiniCartModal,
        onCloseCallback: onCloseMiniCartModal,
        showPriceWarning: showPriceWarning,
        disableModifyUpsellOnCart: disableModifyUpsellOnCart,
        hideDisabledButtons: hideDisabledButtons
      })
    }), /*#__PURE__*/jsxRuntime.jsx(Modal, {
      open: openProductCustomisationModal,
      className: modalAccessibilityClass,
      formatPrice: formatPrice,
      children: /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationModal, {
        isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
        isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
        isAdditionalMessageEnabled: isAdditionalMessageEnabled,
        onConfirmCallback: onConfirmProductCustomisationModal,
        onCloseCallback: onCloseProductCustomisationModal,
        showPriceWarning: showPriceWarning,
        product: customisationProductSelected,
        showAddonAvailability: showAddonAvailability,
        hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
        hidePriceWhenZero: hidePriceWhenZero
      })
    }), loading && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center w-full h-full",
      children: /*#__PURE__*/jsxRuntime.jsx(Loading, {})
    }), (menuState == null ? void 0 : menuState.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex items-center justify-center w-full h-full",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        message: menuState.context.message
      })
    }), (menuState == null ? void 0 : menuState.matches('success')) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [!composedProductFinal && /*#__PURE__*/jsxRuntime.jsx(ProductComposedOptions, {
        headerTitle: t('composedProductLayerTitle', {
          layer: layer == null ? void 0 : layer.title
        }),
        options: layer == null ? void 0 : layer.options,
        onSelectAction: onSelectComposedLayerOptions,
        accessibilityEnabled: accessibilityEnabled,
        selectedOption: selectedLayerOption,
        product: product
      }), composedProductFinal && /*#__PURE__*/jsxRuntime.jsx(ProductComposedFinalProduct, {
        onSelectCustomisationProduct: onSelectCustomisationProduct,
        headerTitle: t('composedProductFinalTitle'),
        accessibilityEnabled: accessibilityEnabled,
        layersSelection: navigationList,
        product: composedProductFinal,
        formatPrice: formatPrice,
        t: t
      })]
    })]
  });
};

var RestaurantOrderValidationViewContext = /*#__PURE__*/React.createContext();
var RestaurantOrderValidationViewProvider = function RestaurantOrderValidationViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/cart' : _ref$nextPath,
    _ref$previousPath = _ref.previousPath,
    previousPath = _ref$previousPath === void 0 ? '/categories' : _ref$previousPath,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? false : _ref$showCategoriesHe,
    _ref$showLoyaltyBanne = _ref.showLoyaltyBanner,
    showLoyaltyBanner = _ref$showLoyaltyBanne === void 0 ? false : _ref$showLoyaltyBanne,
    _ref$showFinancialSum = _ref.showFinancialSummaryTotal,
    showFinancialSummaryTotal = _ref$showFinancialSum === void 0 ? false : _ref$showFinancialSum;
  var _useCart = cart.useCart(),
    items = _useCart.items,
    validate = _useCart.validate;
  var _useRestaurantCart = useRestaurantCart(),
    isCartValidated = _useRestaurantCart.isCartValidated;
  var settings = recoil.useRecoilValue(atoms.settingsState);
  var payload = recoil.useRecoilValue(atoms.formattedOrderPayloadState({
    items: items
  }));
  var _useRecoilState = recoil.useRecoilState(atoms.validatedOrderPayloadState),
    validatedOrderPayload = _useRecoilState[0],
    setValidatedOrderPayload = _useRecoilState[1];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useTransactions = useTransactions(),
    addTransaction = _useTransactions.addTransaction;
  var setTotal = recoil.useSetRecoilState(atoms.orderTotalState);
  var available = {
    validatedOrderPayload: validatedOrderPayload,
    setValidatedOrderPayload: setValidatedOrderPayload,
    nextPath: nextPath,
    settings: settings,
    payload: payload,
    t: t,
    setTemplate: setTemplate,
    previousPath: previousPath,
    addTransaction: addTransaction,
    items: items,
    validate: validate,
    setTotal: setTotal,
    isCartValidated: isCartValidated,
    showCategoriesHeader: showCategoriesHeader,
    showLoyaltyBanner: showLoyaltyBanner,
    showFinancialSummaryTotal: showFinancialSummaryTotal
  };
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantOrderValidationViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantOrderValidationViewContext = function useRestaurantOrderValidationViewContext() {
  var context = React.useContext(RestaurantOrderValidationViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantOrderValidationViewContext must be used within a RestaurantOrderValidationViewProvider');
  }
  return context;
};

var useRestaurantOrderValidation = function useRestaurantOrderValidation() {
  var _settings$interval;
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useRestaurantOrder = useRestaurantOrder(),
    saveSession = _useRestaurantOrder.saveSession,
    saveSessionState = _useRestaurantOrder.saveSessionState;
  var history = reactRouterDom.useHistory();
  var setSession = recoil.useSetRecoilState(atoms.sessionState);
  var _useRecoilState = recoil.useRecoilState(atoms.totalValidatedState),
    totalValidated = _useRecoilState[0],
    setTotalValidated = _useRecoilState[1];
  var _useState = React.useState(null),
    orderState = _useState[0],
    setOrderState = _useState[1];
  var _useState2 = React.useState(0),
    retryCount = _useState2[0],
    setRetryCount = _useState2[1];
  var _useRestaurantOrderVa = useRestaurantOrderValidationViewContext(),
    config = _useRestaurantOrderVa.settings,
    nextPath = _useRestaurantOrderVa.nextPath,
    payload = _useRestaurantOrderVa.payload,
    validatedOrderPayload = _useRestaurantOrderVa.validatedOrderPayload,
    setValidatedOrderPayload = _useRestaurantOrderVa.setValidatedOrderPayload,
    t = _useRestaurantOrderVa.t,
    setTemplate = _useRestaurantOrderVa.setTemplate,
    previousPath = _useRestaurantOrderVa.previousPath,
    addTransaction = _useRestaurantOrderVa.addTransaction,
    validate = _useRestaurantOrderVa.validate,
    setTotal = _useRestaurantOrderVa.setTotal,
    isCartValidated = _useRestaurantOrderVa.isCartValidated,
    showCategoriesHeader = _useRestaurantOrderVa.showCategoriesHeader,
    showLoyaltyBanner = _useRestaurantOrderVa.showLoyaltyBanner,
    showFinancialSummaryTotal = _useRestaurantOrderVa.showFinancialSummaryTotal;
  var _ref = config || {},
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings;
  var _ref2 = (settings == null ? void 0 : (_settings$interval = settings.interval) == null ? void 0 : _settings$interval.timeout) || {},
    _ref2$order = _ref2.order,
    timeout = _ref2$order === void 0 ? 30 : _ref2$order;
  var _settings$order = settings.order,
    order = _settings$order === void 0 ? {} : _settings$order;
  var _order$local = order.local,
    local = _order$local === void 0 ? {} : _order$local,
    _order$type = order.type,
    provider = _order$type === void 0 ? '' : _order$type;
  var ip = local.ip;
  var translatedErrorDetails = React.useMemo(function () {
    var _orderState$context, _orderState$context$d, _orderState$context$d2;
    if (orderState != null && orderState.matches('error') && (orderState == null ? void 0 : (_orderState$context = orderState.context) == null ? void 0 : (_orderState$context$d = _orderState$context.data) == null ? void 0 : (_orderState$context$d2 = _orderState$context$d.message) == null ? void 0 : _orderState$context$d2.length) > 0) {
      var _orderState$context2, _orderState$context2$;
      var translationKey = toCamelCase(orderState == null ? void 0 : (_orderState$context2 = orderState.context) == null ? void 0 : (_orderState$context2$ = _orderState$context2.data) == null ? void 0 : _orderState$context2$.message);
      return t(translationKey);
    }
    return '';
  }, [orderState, t]);
  React.useEffect(function () {
    // TODO:
    // - This needs to be removed once we migrate to BSP
    // - This is required because of the bridge server
    // - https://fingermarkglobal.atlassian.net/browse/S2-2286

    if (!validatedOrderPayload) return;
    if (!(orderState != null && orderState.matches('success')) && !(orderState != null && orderState.matches('error'))) return;
    if (!saveSessionState) {
      saveSession();
      return;
    }
    if (saveSessionState != null && saveSessionState.matches('success') || saveSessionState != null && saveSessionState.matches('error')) {
      history.push(nextPath);
      return;
    }
  }, [history, nextPath, orderState, saveSession, saveSessionState, validatedOrderPayload]);
  React.useEffect(function () {
    if (orderState) return;
    fmApi.doPreOrder({
      ip: ip,
      payload: payload,
      timeout: timeout,
      provider: provider,
      transition: function transition(machine) {
        return setOrderState(machine);
      }
    });
  }, [payload, setOrderState, timeout, orderState, ip, provider]);
  React.useEffect(function () {
    // IF this has already been set abort
    // - This feels like a code smell
    // - Unfortunately I am not really sure how to resolve this
    if (validatedOrderPayload) return;
    if (orderState != null && orderState.matches('error')) {
      var _orderState$context3 = orderState.context,
        context = _orderState$context3 === void 0 ? {} : _orderState$context3;
      var _context$message = context.message,
        message = _context$message === void 0 ? '' : _context$message;
      setValidatedOrderPayload(null);
      return addTransaction({
        status: 'ORDER_VALIDATION_ERROR',
        message: message
      });
    }
    if (!(orderState != null && orderState.matches('success'))) return;
    var _ref3 = orderState.context || {},
      _ref3$data = _ref3.data,
      payload = _ref3$data === void 0 ? null : _ref3$data;
    setSession(function (session) {
      var _payload$session, _payload$session2;
      return _extends({}, session, {
        status: payload == null ? void 0 : payload.status,
        kitchenId: payload == null ? void 0 : (_payload$session = payload.session) == null ? void 0 : _payload$session.kitchenId,
        customer: _extends({}, session.customer, payload == null ? void 0 : (_payload$session2 = payload.session) == null ? void 0 : _payload$session2.customer)
      });
    });
    addTransaction({
      status: 'ORDER_VALIDATION_SUCCESS',
      orderStatus: payload == null ? void 0 : payload.status
    });
    setValidatedOrderPayload(payload);
  }, [orderState, setSession, addTransaction, validatedOrderPayload, setValidatedOrderPayload]);
  React.useEffect(function () {
    var _validatedOrderPayloa, _validatedOrderPayloa2;
    if (!validatedOrderPayload) return;
    if (!(orderState != null && orderState.matches('success')) && !(orderState != null && orderState.matches('error'))) return;
    if (isCartValidated && totalValidated !== false) return;
    var total = showFinancialSummaryTotal && validatedOrderPayload != null && validatedOrderPayload.financialSummary ? validatedOrderPayload == null ? void 0 : (_validatedOrderPayloa = validatedOrderPayload.financialSummary) == null ? void 0 : _validatedOrderPayloa.total : validatedOrderPayload == null ? void 0 : (_validatedOrderPayloa2 = validatedOrderPayload.cart) == null ? void 0 : _validatedOrderPayloa2.total;
    // Set validated values to the cart tree and total state
    // The kiosk will take the validated values as the source of truth unless the user modify the cart again
    validate({
      validatedOrderPayload: validatedOrderPayload
    });
    setTotal(total);
    setTotalValidated(true);
  }, [orderState, setTotal, validate, validatedOrderPayload, isCartValidated, totalValidated, setTotalValidated, showFinancialSummaryTotal]);
  var onRetry = function onRetry() {
    setRetryCount(function (count) {
      return count + 1;
    });
    fmApi.doPreOrder({
      payload: payload,
      timeout: timeout,
      ip: ip,
      transition: function transition(machine) {
        return setOrderState(machine);
      },
      provider: provider
    });
  };
  React.useEffect(function () {
    if (retryCount >= 3 && orderState != null && orderState.matches('error')) history.push('/notify', {
      redirectPath: previousPath
    });
  }, [retryCount, orderState, history, previousPath]);
  var onCancel = React.useCallback(function () {
    return history.push(previousPath);
  }, [previousPath, history]);
  React.useEffect(function () {
    setTemplate(function (template) {
      return _extends({}, template, {
        timeoutEnabledOverride: orderState == null ? void 0 : orderState.matches('error'),
        header: _extends({}, template.header, {
          showCategoriesHeader: showCategoriesHeader,
          showCouponButton: false,
          showLoyaltyBanner: showLoyaltyBanner
        })
      });
    });
  }, [orderState, setTemplate, onCancel, showCategoriesHeader, showLoyaltyBanner]);
  return {
    orderState: orderState,
    onRetry: onRetry,
    t: t,
    onCancel: onCancel,
    accessibilityEnabled: accessibilityEnabled,
    translatedErrorDetails: translatedErrorDetails
  };
};

var RestaurantOrderValidationView = function RestaurantOrderValidationView(_ref) {
  var _orderState$context, _orderState$context$d;
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$isLogoEnabled = _ref.isLogoEnabled,
    isLogoEnabled = _ref$isLogoEnabled === void 0 ? false : _ref$isLogoEnabled,
    _ref$Loading = _ref.Loading,
    Loading$1 = _ref$Loading === void 0 ? Loading : _ref$Loading;
  var _useRestaurantOrderVa = useRestaurantOrderValidation(),
    orderState = _useRestaurantOrderVa.orderState,
    translatedErrorDetails = _useRestaurantOrderVa.translatedErrorDetails,
    t = _useRestaurantOrderVa.t,
    onRetry = _useRestaurantOrderVa.onRetry,
    onCancel = _useRestaurantOrderVa.onCancel,
    accessibilityEnabled = _useRestaurantOrderVa.accessibilityEnabled;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col items-center justify-center w-full h-full bg-default order-validation-view",
    children: [((orderState == null ? void 0 : orderState.matches('processing')) || (orderState == null ? void 0 : orderState.matches('success'))) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [isLogoEnabled && !accessibilityEnabled && image, /*#__PURE__*/jsxRuntime.jsx(Loading$1, {
        "data-test": "cart-page-loading",
        title: t('orderValidationLoadingTitle'),
        message: t('orderValidationLoadingMessage')
      })]
    }), (orderState == null ? void 0 : orderState.matches('error')) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [isLogoEnabled && !accessibilityEnabled && image, /*#__PURE__*/jsxRuntime.jsx(Alert, {
        "data-test": "cart-page-error",
        type: "danger",
        message: t('orderValidationErrorMessage'),
        detail: translatedErrorDetails || (orderState == null ? void 0 : (_orderState$context = orderState.context) == null ? void 0 : (_orderState$context$d = _orderState$context.data) == null ? void 0 : _orderState$context$d.message) || '',
        onRetryText: t('orderValidationErrorPrimaryAction'),
        onRetryAction: onRetry,
        onCancelAction: onCancel,
        onCancelText: t('orderValidationErrorSecondaryAction')
      })]
    })]
  });
};

var RestaurantOrderConfirmationViewContext = /*#__PURE__*/React.createContext();
var RestaurantOrderConfirmationViewProvider = function RestaurantOrderConfirmationViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/receipt' : _ref$nextPath,
    _ref$cancelPath = _ref.cancelPath,
    cancelPath = _ref$cancelPath === void 0 ? '/refund' : _ref$cancelPath,
    _ref$customOrderRefer = _ref.customOrderReference,
    customOrderReference = _ref$customOrderRefer === void 0 ? false : _ref$customOrderRefer;
  var _useCart = cart.useCart(),
    items = _useCart.items;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useRecoilState = recoil.useRecoilState(atoms.confirmedOrderPayloadState),
    confirmedOrderPayload = _useRecoilState[0],
    setConfirmedOrderPayload = _useRecoilState[1];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var flags = launchdarklyReactClientSdk.useFlags();
  var meta = recoil.useRecoilValue(atoms.metadataState);
  var settings = recoil.useRecoilValue(atoms.settingsState);
  var payload = recoil.useRecoilValue(atoms.formattedOrderPayloadState({
    items: items
  }));
  var _useTransactions = useTransactions(),
    addTransaction = _useTransactions.addTransaction;
  var onlineStatus = recoil.useRecoilValue(atoms.onlineStatusState);
  var _onlineStatus$isOnlin = onlineStatus.isOnline,
    isOnline = _onlineStatus$isOnlin === void 0 ? true : _onlineStatus$isOnlin,
    _onlineStatus$isOnlin2 = onlineStatus.isOnlineTimedOut,
    isOnlineTimedOut = _onlineStatus$isOnlin2 === void 0 ? false : _onlineStatus$isOnlin2;
  var timezone = settings.timezone;
  var paymentData = recoil.useRecoilValue(atoms.paymentState);
  var info = paymentData.info;
  var orderPayload = recoil.useRecoilValue(atoms.validatedOrderPayloadState);
  var cart$1 = (orderPayload == null ? void 0 : orderPayload.cart) || {};
  var available = {
    confirmedOrderPayload: confirmedOrderPayload,
    setConfirmedOrderPayload: setConfirmedOrderPayload,
    settings: settings,
    meta: meta,
    payload: payload,
    nextPath: nextPath,
    setTemplate: setTemplate,
    cancelPath: cancelPath,
    registerProductCheckout: googleAnalytics.registerProductCheckout,
    t: t,
    addTransaction: addTransaction,
    flags: flags,
    isOnline: isOnline,
    isOnlineTimedOut: isOnlineTimedOut,
    timezone: timezone,
    info: info,
    cart: cart$1,
    customOrderReference: customOrderReference
  };
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantOrderConfirmationViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantOrderConfirmationViewContext = function useRestaurantOrderConfirmationViewContext() {
  var context = React.useContext(RestaurantOrderConfirmationViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantOrderConfirmationViewContext must be used within a RestaurantOrderConfirmationViewProvider');
  }
  return context;
};

var useRestaurantOrderConfirmation = function useRestaurantOrderConfirmation() {
  var _settings$interval;
  var history = reactRouterDom.useHistory();
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _useState = React.useState(false),
    hasOnlineTimedOutOnce = _useState[0],
    setHasOnlineTimedOutOnce = _useState[1];
  var _useState2 = React.useState(false),
    shouldOnlineAutoRetry = _useState2[0],
    setShouldOnlineAutoRetry = _useState2[1];
  var _useState3 = React.useState(null),
    orderState = _useState3[0],
    setOrderState = _useState3[1];
  var _useState4 = React.useState(0),
    retryCount = _useState4[0],
    setRetryCount = _useState4[1];
  var _useState5 = React.useState(null),
    fiscalState = _useState5[0],
    setFiscalState = _useState5[1];
  var _useRestaurantOrderCo = useRestaurantOrderConfirmationViewContext(),
    confirmedOrderPayload = _useRestaurantOrderCo.confirmedOrderPayload,
    setConfirmedOrderPayload = _useRestaurantOrderCo.setConfirmedOrderPayload,
    nextPath = _useRestaurantOrderCo.nextPath,
    cancelPath = _useRestaurantOrderCo.cancelPath,
    payload = _useRestaurantOrderCo.payload,
    config = _useRestaurantOrderCo.settings,
    registerProductCheckout = _useRestaurantOrderCo.registerProductCheckout,
    t = _useRestaurantOrderCo.t,
    setTemplate = _useRestaurantOrderCo.setTemplate,
    addTransaction = _useRestaurantOrderCo.addTransaction,
    flags = _useRestaurantOrderCo.flags,
    isOnline = _useRestaurantOrderCo.isOnline,
    isOnlineTimedOut = _useRestaurantOrderCo.isOnlineTimedOut,
    timezone = _useRestaurantOrderCo.timezone,
    info = _useRestaurantOrderCo.info,
    cart = _useRestaurantOrderCo.cart,
    customOrderReference = _useRestaurantOrderCo.customOrderReference;
  var setSession = recoil.useSetRecoilState(atoms.sessionState);
  var _useState6 = React.useState(t('orderConfirmationLoadingMessage')),
    loadingMessage = _useState6[0],
    setLoadingMessage = _useState6[1];
  var _useState7 = React.useState(false),
    isAutoRetryRunning = _useState7[0],
    setIsAutoRetryRunning = _useState7[1];
  var loyaltyEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.loyalty',
    defaultValue: false
  });
  var _ref = config || {},
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings;
  var _ref2 = (settings == null ? void 0 : (_settings$interval = settings.interval) == null ? void 0 : _settings$interval.timeout) || {},
    _ref2$order = _ref2.order,
    timeout = _ref2$order === void 0 ? 30 : _ref2$order;
  var _settings$order = settings.order,
    order = _settings$order === void 0 ? {} : _settings$order;
  var _order$local = order.local,
    local = _order$local === void 0 ? {} : _order$local,
    _order$type = order.type,
    provider = _order$type === void 0 ? '' : _order$type,
    _order$autoRetryEnabl = order.autoRetryEnabled,
    shouldProviderAutoRetry = _order$autoRetryEnabl === void 0 ? false : _order$autoRetryEnabl,
    _order$autoRetryTime = order.autoRetryTime,
    autoRetryTime = _order$autoRetryTime === void 0 ? 2000 : _order$autoRetryTime;
  var ip = local.ip;
  var maxRetriesFormatted = 3; // hardcoded see SUPERAPAC-17
  var _useRestaurantOrder = useRestaurantOrder(),
    saveSession = _useRestaurantOrder.saveSession,
    saveSessionState = _useRestaurantOrder.saveSessionState;
  var isFiscalMocked = utilities.useSettingsAtPath({
    path: 'settings.mocks.fiscal',
    defaultValue: false
  });
  var dateTime = utilities.getFormattedDateTime({
    currentTimestamp: utilities.timestamp(),
    timezone: timezone
  });
  var _info$cardNumber = info.cardNumber,
    cardNumber = _info$cardNumber === void 0 ? '' : _info$cardNumber,
    paymentType = info.paymentType;
  var _ref3 = cart || {},
    _ref3$items = _ref3.items,
    items = _ref3$items === void 0 ? [] : _ref3$items;
  var status = payload.status;
  var onRetry = React.useCallback(function () {
    setRetryCount(function (count) {
      return count + 1;
    });
    fmApi.doPlaceOrder({
      payload: payload,
      timeout: timeout,
      ip: ip,
      transition: function transition(machine) {
        return setOrderState(machine);
      },
      provider: provider
    });
  }, [payload, timeout, ip, provider, setRetryCount, setOrderState]);
  var handleSavePushHistory = React.useCallback(function (path, state) {
    if (!saveSessionState) {
      saveSession();
    }
    history.push(path, state);
  }, [history, saveSession, saveSessionState]);
  var onReset = function onReset() {
    return history.push('/reset');
  };
  var onCancel = React.useCallback(function () {
    handleSavePushHistory(cancelPath);
  }, [handleSavePushHistory, cancelPath]);
  React.useEffect(function () {
    if (shouldOnlineAutoRetry && isOnline && !setHasOnlineTimedOutOnce) {
      fmApi.doPlaceOrder({
        payload: payload,
        timeout: timeout,
        ip: ip,
        transition: function transition(machine) {
          return setOrderState(machine);
        },
        provider: provider
      });
      setShouldOnlineAutoRetry(false);
    }
  }, [payload, timeout, ip, provider, shouldOnlineAutoRetry, isOnline, setShouldOnlineAutoRetry, setHasOnlineTimedOutOnce]);
  React.useEffect(function () {
    if (shouldProviderAutoRetry && orderState && orderState != null && orderState.matches('error') && !isAutoRetryRunning) {
      if (retryCount === 1) {
        setIsAutoRetryRunning(true);
        setTimeout(function () {
          onRetry();
          setLoadingMessage(t('orderConfirmationLoadingMessageSecondAutoRetry'));
          setIsAutoRetryRunning(false);
        }, autoRetryTime);
      } else {
        onRetry();
        setLoadingMessage(t('orderConfirmationLoadingMessageFirstAutoRetry'));
      }
    }
  }, [payload, timeout, ip, provider, orderState, shouldProviderAutoRetry, autoRetryTime, loadingMessage, setLoadingMessage, onRetry, isAutoRetryRunning, setIsAutoRetryRunning, retryCount, t]);
  React.useEffect(function () {
    // TODO:
    // - This needs to be removed once we migrate to BSP
    // - This is required because of the bridge server
    // - https://fingermarkglobal.atlassian.net/browse/S2-2286

    if (!isOnline && !shouldOnlineAutoRetry) {
      setShouldOnlineAutoRetry(true);
    }
    if (isOnlineTimedOut && !hasOnlineTimedOutOnce) {
      setHasOnlineTimedOutOnce(true);
    }
    if (!confirmedOrderPayload) return;
    if (!(orderState != null && orderState.matches('success')) && !(orderState != null && orderState.matches('error'))) return;
    if (!saveSessionState) {
      saveSession();
      return;
    }
    if (saveSessionState != null && saveSessionState.matches('success') || saveSessionState != null && saveSessionState.matches('error')) {
      if (isOnline && !isOnlineTimedOut) {
        history.push(nextPath);
        return;
      }
    }
  }, [history, nextPath, orderState, saveSession, saveSessionState, confirmedOrderPayload, isOnline, isOnlineTimedOut, hasOnlineTimedOutOnce, setHasOnlineTimedOutOnce, shouldOnlineAutoRetry, setShouldOnlineAutoRetry]);
  React.useEffect(function () {
    if (orderState) return;
    fmApi.doPlaceOrder({
      payload: payload,
      timeout: timeout,
      ip: ip,
      transition: function transition(machine) {
        return setOrderState(machine);
      },
      provider: provider
    });
  }, [timeout, orderState, payload, ip, provider]);
  React.useEffect(function () {
    if (!(orderState != null && orderState.matches('success'))) return;
    var _settings$fiscal = settings.fiscal,
      fiscal = _settings$fiscal === void 0 ? {} : _settings$fiscal,
      _settings$properties = settings.properties,
      properties = _settings$properties === void 0 ? {} : _settings$properties;
    var enableShift = fiscal.enableShift;
    if (!fiscal || !enableShift) return;
    if (status !== 'FINISHED') return;
    var payment = payload.payment;
    if (!payment) return;
    var provider = fiscal.provider;
    var deviceId = properties.deviceId,
      organisation = properties.organisation,
      storeId = properties.storeId;
    var fiscalPayload = _extends({}, payload, {
      session: _extends({}, payload.session),
      settings: _extends({}, payload.settings)
    });
    fiscalPayload.settings.fiscal = settings.fiscal || {};
    fiscalPayload.settings.fiscal = _extends({}, fiscalPayload.settings.fiscal, {
      deviceId: deviceId,
      organisation: organisation,
      storeId: storeId,
      isFiscalMocked: isFiscalMocked
    });
    fmApi.doFiscalManagement({
      payload: fiscalPayload,
      timeout: timeout,
      ip: ip,
      transition: function transition(machine) {
        return setFiscalState(machine);
      },
      provider: provider
    });
  }, [timeout, orderState, payload, ip, provider, settings, isFiscalMocked, status]);
  React.useEffect(function () {
    var _settings$order2, _settings$order3, _resultPayload$cart;
    // IF this has already been set abort
    // - This feels like a code smell
    // - Unfortunately I am not really sure how to resolve this
    if (confirmedOrderPayload) return;
    if (orderState != null && orderState.matches('error')) {
      var _orderState$context = orderState.context,
        context = _orderState$context === void 0 ? {} : _orderState$context;
      var _context$message = context.message,
        message = _context$message === void 0 ? '' : _context$message;
      return addTransaction({
        status: 'ORDER_CONFIRMATION_ERROR',
        message: message
      });
    }
    if (!(orderState != null && orderState.matches('success'))) return;
    var _ref4 = orderState.context || {},
      _ref4$data = _ref4.data,
      resultPayload = _ref4$data === void 0 ? null : _ref4$data;
    var _ref5 = resultPayload || {},
      receiptId = _ref5.receiptId,
      status = _ref5.status,
      resultSession = _ref5.session;
    var aloha = settings == null ? void 0 : (_settings$order2 = settings.order) == null ? void 0 : _settings$order2.aloha;
    var oracleMicros = settings == null ? void 0 : (_settings$order3 = settings.order) == null ? void 0 : _settings$order3.oracleMicros;
    if (customOrderReference && (aloha || oracleMicros)) {
      var _resultPayload$sessio;
      var formattedLastName = getDisplayOrderNumber({
        aloha: aloha,
        oracleMicros: oracleMicros,
        customer: resultPayload == null ? void 0 : (_resultPayload$sessio = resultPayload.session) == null ? void 0 : _resultPayload$sessio.customer,
        orderNumber: resultPayload == null ? void 0 : resultPayload.orderNumber
      });
      addTransaction({
        status: 'ORDER_CONFIRMATION_SUCCESS',
        receiptId: receiptId,
        orderStatus: status,
        formattedLastName: formattedLastName,
        orderNumber: resultPayload == null ? void 0 : resultPayload.orderNumber
      });
    } else {
      addTransaction({
        status: 'ORDER_CONFIRMATION_SUCCESS',
        receiptId: receiptId,
        orderStatus: status
      });
    }
    setSession(function (session) {
      return _extends({}, session, resultSession, {
        status: resultPayload == null ? void 0 : resultPayload.status
      });
    });
    setConfirmedOrderPayload(resultPayload);
    var products = (resultPayload == null ? void 0 : (_resultPayload$cart = resultPayload.cart) == null ? void 0 : _resultPayload$cart.items) || {};
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _iterator, _step, item, _resultPayload$sessio2, _item$filter, _item$filter$name, _item$product, _settings$settings, _settings$settings$or;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _iterator = _createForOfIteratorHelperLoose(products);
          case 1:
            if ((_step = _iterator()).done) {
              _context.next = 13;
              break;
            }
            item = _step.value;
            _context.prev = 3;
            _context.next = 6;
            return registerProductCheckout({
              sessionId: (resultPayload == null ? void 0 : (_resultPayload$sessio2 = resultPayload.session) == null ? void 0 : _resultPayload$sessio2.sessionId) || null,
              productVariant: (item == null ? void 0 : item.type) === 'combo' ? item == null ? void 0 : (_item$filter = item.filter) == null ? void 0 : (_item$filter$name = _item$filter.name) == null ? void 0 : _item$filter$name.text : '',
              categoryName: (item == null ? void 0 : item.categoryNameAnalytics) || '',
              product: (item == null ? void 0 : item.product) || {},
              price: (item == null ? void 0 : (_item$product = item.product) == null ? void 0 : _item$product.price) || 0,
              quantity: (item == null ? void 0 : item.quantity) || 1,
              listName: item.listNameAnalytics || '',
              upsell: (item == null ? void 0 : item.upsell) || '',
              storeAddress: (settings == null ? void 0 : settings.storeAddress) || '',
              organisation: (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$or = _settings$settings.order) == null ? void 0 : _settings$settings$or.organisationId) || '',
              serial: (settings == null ? void 0 : settings.serial) || ''
            });
          case 6:
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](3);
            logger.error('cringer.components - registerProductCheckout - Error:', _context.t0);
          case 11:
            _context.next = 1;
            break;
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 8]]);
    }))();
  }, [flags, settings, orderState, setSession, addTransaction, confirmedOrderPayload, registerProductCheckout, setConfirmedOrderPayload, customOrderReference]);
  React.useEffect(function () {
    if (retryCount >= maxRetriesFormatted && orderState != null && orderState.matches('error')) {
      handleSavePushHistory('/notify', {
        redirectPath: cancelPath
      });
    }
  }, [retryCount, orderState, history, cancelPath, maxRetriesFormatted, saveSession, saveSessionState, handleSavePushHistory]);
  React.useEffect(function () {
    setTemplate(function (template) {
      return _extends({}, template, {
        timeoutEnabledOverride: (orderState == null ? void 0 : orderState.matches('error')) && isOnline,
        timeoutActionOverride: onCancel
      });
    });
  }, [orderState, setTemplate, onCancel, history, isOnline]);
  var loyaltyUser = recoil.useRecoilValue(atoms.loyaltyState);
  var loyaltyPayload = recoil.useRecoilValue(atoms.formattedLoyaltyPayloadState());
  var possibleRedemptions = recoil.useRecoilValue(atoms.possibleRedemptionsState);
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    offersAndRewards = _useOffersAndRewardsM.offersAndRewards;
  var isOrderSucceeded = orderState == null ? void 0 : orderState.matches('success');
  var isStatusFinished = payload.status === 'FINISHED';
  React.useEffect(function () {
    if (!loyaltyEnabled) {
      return;
    }
    if (!isOrderSucceeded) {
      return;
    }
    if (!isStatusFinished) {
      return;
    }
    if (loyaltyUser != null && loyaltyUser.token) {
      var allPromos = [].concat(offersAndRewards.promosWithPoints, offersAndRewards.promos);
      var selectedPromo = allPromos.find(function (promo) {
        return promo.isSelected;
      });
      var redemptions = possibleRedemptions == null ? void 0 : possibleRedemptions.redemptions;
      if (selectedPromo && redemptions) {
        fmApi.doLoyaltyCreateRedemptions({
          token: loyaltyUser.token,
          transactionId: loyaltyUser.transactionId,
          payload: payload,
          promoId: selectedPromo.promoId,
          redemptions: redemptions,
          transition: function transition(machine) {
            var value = machine.value,
              _machine$context = machine.context,
              _machine$context2 = _machine$context === void 0 ? {} : _machine$context,
              data = _machine$context2.data;
            if (value !== 'success') {
              return;
            }
            jitsu.setLoyaltyCreateRedemptionsTrack(data);
          }
        });
      }
      fmApi.doLoyaltyClaim({
        token: loyaltyUser.token,
        transactionId: loyaltyUser.transactionId,
        cart: payload.cart,
        integrationStoreId: loyaltyPayload.integrationStoreId,
        transition: function transition(machine) {
          var value = machine.value,
            _machine$context3 = machine.context,
            _machine$context4 = _machine$context3 === void 0 ? {} : _machine$context3,
            data = _machine$context4.data;
          if (value !== 'success') {
            return;
          }
          jitsu.setLoyaltyClaimTrack(data);
        }
      });
      return;
    }
    fmApi.doLoyaltyGuestClaim({
      sessionId: loyaltyPayload.sessionId,
      organisationId: loyaltyPayload.organisationId,
      integrationStoreId: loyaltyPayload.integrationStoreId,
      kioskSerialKey: loyaltyPayload.kioskSerialKey,
      storeId: loyaltyPayload.storeId,
      cart: payload.cart,
      transition: function transition(machine) {
        var value = machine.value,
          _machine$context5 = machine.context,
          _machine$context6 = _machine$context5 === void 0 ? {} : _machine$context5,
          data = _machine$context6.data;
        if (value !== 'success') {
          return;
        }
        jitsu.setLoyaltyGuestClaimTrack(data);
      }
    });
  }, [payload.cart, isOrderSucceeded, isStatusFinished, loyaltyEnabled, loyaltyUser, loyaltyPayload, payload, offersAndRewards, possibleRedemptions]);
  return {
    orderState: orderState,
    t: t,
    dateTime: dateTime,
    cardNumber: cardNumber,
    items: items,
    accessibilityEnabled: accessibilityEnabled,
    isOnline: isOnline,
    isOnlineTimedOut: isOnlineTimedOut,
    onRetry: onRetry,
    onCancel: onCancel,
    onReset: onReset,
    hasOnlineTimedOutOnce: hasOnlineTimedOutOnce,
    fiscalState: fiscalState,
    loadingMessage: loadingMessage,
    retryCount: retryCount,
    shouldProviderAutoRetry: shouldProviderAutoRetry,
    paymentType: paymentType
  };
};

var RestaurantOrderConfirmationView = function RestaurantOrderConfirmationView(_ref) {
  var _orderState$context;
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$loadingImage = _ref.loadingImage,
    loadingImage = _ref$loadingImage === void 0 ? null : _ref$loadingImage,
    _ref$isLogoEnabled = _ref.isLogoEnabled,
    isLogoEnabled = _ref$isLogoEnabled === void 0 ? false : _ref$isLogoEnabled,
    _ref$Loading = _ref.Loading,
    Loading$1 = _ref$Loading === void 0 ? Loading : _ref$Loading;
  var _useRestaurantOrderCo = useRestaurantOrderConfirmation(),
    orderState = _useRestaurantOrderCo.orderState,
    t = _useRestaurantOrderCo.t,
    dateTime = _useRestaurantOrderCo.dateTime,
    items = _useRestaurantOrderCo.items,
    accessibilityEnabled = _useRestaurantOrderCo.accessibilityEnabled,
    isOnline = _useRestaurantOrderCo.isOnline,
    isOnlineTimedOut = _useRestaurantOrderCo.isOnlineTimedOut,
    onRetry = _useRestaurantOrderCo.onRetry,
    onCancel = _useRestaurantOrderCo.onCancel,
    onReset = _useRestaurantOrderCo.onReset,
    hasOnlineTimedOutOnce = _useRestaurantOrderCo.hasOnlineTimedOutOnce,
    loadingMessage = _useRestaurantOrderCo.loadingMessage,
    retryCount = _useRestaurantOrderCo.retryCount,
    shouldProviderAutoRetry = _useRestaurantOrderCo.shouldProviderAutoRetry,
    paymentType = _useRestaurantOrderCo.paymentType;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "order-confirmation-page",
    className: "flex flex-col items-center justify-center w-full h-full bg-default order-validation-view",
    children: [(orderState == null ? void 0 : orderState.matches('performWebhookPolling')) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [isLogoEnabled && !accessibilityEnabled && image, isOnline && !isOnlineTimedOut && /*#__PURE__*/jsxRuntime.jsx(Loading$1, {
        title: t('orderWebhookPollingConfirmationLoadingTitle'),
        message: t('orderWebhookPollingConfirmationLoadingMessage'),
        Image: !!loadingImage && !accessibilityEnabled && loadingImage
      })]
    }), ((orderState == null ? void 0 : orderState.matches('processing')) || (orderState == null ? void 0 : orderState.matches('success')) || (orderState == null ? void 0 : orderState.matches('checkWebhookUse')) || (orderState == null ? void 0 : orderState.matches('error')) && shouldProviderAutoRetry && retryCount < 3) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [isLogoEnabled && !accessibilityEnabled && image, isOnline && !isOnlineTimedOut && /*#__PURE__*/jsxRuntime.jsx(Loading$1, {
        title: t('orderConfirmationLoadingTitle'),
        message: loadingMessage,
        Image: !!loadingImage && !accessibilityEnabled && loadingImage
      })]
    }), (orderState == null ? void 0 : orderState.matches('error')) && !shouldProviderAutoRetry && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [isLogoEnabled && !accessibilityEnabled && image, !isOnline && !isOnlineTimedOut && /*#__PURE__*/jsxRuntime.jsx(Loading$1, {
        title: t('orderConfirmationNoInternetLoadingTitle'),
        message: t('orderConfirmationNoInternetLoadingMessage')
      }), hasOnlineTimedOutOnce && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex items-center justify-center flex-grow h-full",
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-col items-center justify-center h-full p-8",
          children: [/*#__PURE__*/jsxRuntime.jsx("p", {
            className: "mb-32 text-5xl font-bold text-center uppercase",
            children: t('orderConfirmationNoInternetTitle')
          }), /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "flex flex-row items-center justify-center",
            children: /*#__PURE__*/jsxRuntime.jsxs("div", {
              className: "flex flex-col py-8 mb-8 text-center",
              children: [/*#__PURE__*/jsxRuntime.jsx("p", {
                className: "mb-4 text-4xl uppercase",
                children: t('orderConfirmationNoInternetDetailsTitle')
              }), /*#__PURE__*/jsxRuntime.jsxs("p", {
                className: "mb-4 text-3xl",
                children: [t('orderConfirmationNoInternetDetailsDateTime'), ": ", dateTime]
              })]
            })
          }), /*#__PURE__*/jsxRuntime.jsx(ProductSummary, {
            items: items
          }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
            className: "mt-8",
            onClick: onReset,
            children: t('orderConfirmationNoInternetClose')
          })]
        })
      }), !hasOnlineTimedOutOnce && isOnline && /*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        message: t('orderConfirmationErrorMessage'),
        additionalMessage: t(paymentType === 'MOMOPAY' ? 'orderConfirmationGenericAdditionalMessage' : 'orderConfirmationAdditionalMessage'),
        detail: orderState == null ? void 0 : (_orderState$context = orderState.context) == null ? void 0 : _orderState$context.message,
        onRetryText: t('orderConfirmationErrorPrimaryAction'),
        onRetryAction: onRetry,
        onCancelAction: onCancel,
        onCancelText: t('orderConfirmationErrorSecondaryAction')
      })]
    })]
  });
};

var RestaurantLockViewContext = /*#__PURE__*/React.createContext();
var RestaurantLockViewProvider = function RestaurantLockViewProvider(_ref) {
  var children = _ref.children,
    _ref$authPath = _ref.authPath,
    authPath = _ref$authPath === void 0 ? '/auth' : _ref$authPath,
    _ref$isLogoEnabled = _ref.isLogoEnabled,
    isLogoEnabled = _ref$isLogoEnabled === void 0 ? false : _ref$isLogoEnabled;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useRestaurantLock = useRestaurantLock(),
    kioskClosed = _useRestaurantLock.kioskClosed,
    scheduleLock = _useRestaurantLock.scheduleLock,
    checkScheduleLock = _useRestaurantLock.checkScheduleLock,
    autoLock = _useRestaurantLock.autoLock,
    autoUnlock = _useRestaurantLock.autoUnlock,
    manualLock = _useRestaurantLock.manualLock,
    manualUnlock = _useRestaurantLock.manualUnlock,
    lockMachineState = _useRestaurantLock.lockMachineState,
    scheduleUnlock = _useRestaurantLock.scheduleUnlock,
    lockMessageRecoilState = _useRestaurantLock.lockMessageRecoilState;
  var history = reactRouterDom.useHistory();
  var _useRecoilState = recoil.useRecoilState(atoms.settingsState),
    settings = _useRecoilState[0];
  var _useLocation = reactUse.useLocation(),
    state = _useLocation.state;
  var _ref2 = state || {},
    _ref2$from = _ref2.from,
    from = _ref2$from === void 0 ? '' : _ref2$from;
  var available = {
    t: t,
    settings: settings,
    kioskClosed: kioskClosed,
    scheduleLock: scheduleLock,
    lockMachineState: lockMachineState,
    lockMessage: t(lockMessageRecoilState),
    checkScheduleLock: checkScheduleLock,
    authPath: authPath,
    autoLock: autoLock,
    autoUnlock: autoUnlock,
    manualLock: manualLock,
    manualUnlock: manualUnlock,
    scheduleUnlock: scheduleUnlock,
    isLogoEnabled: isLogoEnabled,
    history: history,
    from: from
  };
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantLockViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantLockViewContext = function useRestaurantLockViewContext() {
  var context = React.useContext(RestaurantLockViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantLockViewContext must be used within a RestaurantLockViewProvider');
  }
  return context;
};

var useRestaurantLockView = function useRestaurantLockView() {
  var _useRestaurantLockVie = useRestaurantLockViewContext(),
    lockMachineState = _useRestaurantLockVie.lockMachineState,
    lockMessage = _useRestaurantLockVie.lockMessage,
    checkScheduleLock = _useRestaurantLockVie.checkScheduleLock,
    authPath = _useRestaurantLockVie.authPath,
    manualLock = _useRestaurantLockVie.manualLock,
    scheduleUnlock = _useRestaurantLockVie.scheduleUnlock,
    autoUnlock = _useRestaurantLockVie.autoUnlock,
    kioskClosed = _useRestaurantLockVie.kioskClosed,
    isLogoEnabled = _useRestaurantLockVie.isLogoEnabled,
    history = _useRestaurantLockVie.history,
    from = _useRestaurantLockVie.from;
  React.useEffect(function () {
    if (!lockMachineState || !(lockMachineState != null && lockMachineState.matches)) return;
    var matches = lockMachineState.matches;
    if (matches('manualLocked')) return;
    checkScheduleLock();
    if (from === authPath && matches('manualUnlocked')) return;
    if (scheduleUnlock && !kioskClosed) {
      autoUnlock();
      return;
    }

    // Handles being redirect back from auth after cancel
    // and relocks the kiosk
    if (from === authPath) {
      manualLock();
    }
  }, [authPath, autoUnlock, from, kioskClosed, lockMachineState, manualLock, scheduleUnlock, checkScheduleLock]);
  var unlock = React.useCallback(function () {
    if (history && typeof history.push === 'function') {
      history.push('/auth', {
        successPath: '/home',
        cancelPath: "/lock",
        shouldUnlock: true
      });
    }
  }, [history]);
  return {
    lockMessage: lockMessage,
    unlock: unlock,
    isLogoEnabled: isLogoEnabled
  };
};

var RestaurantLockView = function RestaurantLockView() {
  var _useRestaurantLockVie = useRestaurantLockView(),
    lockMessage = _useRestaurantLockVie.lockMessage,
    unlock = _useRestaurantLockVie.unlock,
    isLogoEnabled = _useRestaurantLockVie.isLogoEnabled;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "lock-screen",
    className: "h-full lock-view",
    children: [/*#__PURE__*/jsxRuntime.jsx(AdminButton, {
      onActivate: unlock
    }), isLogoEnabled && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col justify-center items-center w-full mb-16 mt-12",
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "logo-icon"
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col justify-center lock-view__content text-center " + (isLogoEnabled ? 'mt-64' : 'h-full'),
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "lock-message",
        className: "text-4xl md:text-9xl sm:leading-none text-black font-extrabold uppercase text-lock font-lock lock-view__content__text " + (isLogoEnabled && 'mt-8 md:mt-52'),
        children: lockMessage
      })
    })]
  });
};

var RestaurantCouponViewContext = /*#__PURE__*/React.createContext();
var RestaurantCouponViewProvider = function RestaurantCouponViewProvider(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$showHeaderTitleW = _ref.showHeaderTitleWhenAccessibility,
    showHeaderTitleWhenAccessibility = _ref$showHeaderTitleW === void 0 ? true : _ref$showHeaderTitleW,
    _ref$limitUpsellModal = _ref.limitUpsellModalToOnce,
    limitUpsellModalToOnce = _ref$limitUpsellModal === void 0 ? true : _ref$limitUpsellModal,
    _ref$randomiseUpsells = _ref.randomiseUpsells,
    randomiseUpsells = _ref$randomiseUpsells === void 0 ? true : _ref$randomiseUpsells,
    _ref$isCustomisationH = _ref.isCustomisationHeaderEnabled,
    isCustomisationHeaderEnabled = _ref$isCustomisationH === void 0 ? false : _ref$isCustomisationH,
    _ref$isCategoryTotali = _ref.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref$isCategoryTotali === void 0 ? true : _ref$isCategoryTotali,
    _ref$isAdditionalMess = _ref.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref$isAdditionalMess === void 0 ? true : _ref$isAdditionalMess,
    _ref$showQuantityCont = _ref.showQuantityControllerLabel,
    showQuantityControllerLabel = _ref$showQuantityCont === void 0 ? false : _ref$showQuantityCont,
    _ref$nextPath = _ref.nextPath,
    nextPath = _ref$nextPath === void 0 ? '/customer-details' : _ref$nextPath,
    _ref$customerSkipPath = _ref.customerSkipPath,
    customerSkipPath = _ref$customerSkipPath === void 0 ? '/validate' : _ref$customerSkipPath,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$disableModifyUps = _ref.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref$disableModifyUps === void 0 ? false : _ref$disableModifyUps,
    _ref$hideDisabledButt = _ref.hideDisabledButtons,
    hideDisabledButtons = _ref$hideDisabledButt === void 0 ? false : _ref$hideDisabledButt,
    _ref$hidePriceWhenQua = _ref.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref$hidePriceWhenQua === void 0 ? false : _ref$hidePriceWhenQua,
    _ref$hidePriceWhenZer = _ref.hidePriceWhenZero,
    hidePriceWhenZero = _ref$hidePriceWhenZer === void 0 ? false : _ref$hidePriceWhenZer,
    _ref$shouldSkipCustom = _ref.shouldSkipCustomerDetailsPath,
    shouldSkipCustomerDetailsPath = _ref$shouldSkipCustom === void 0 ? false : _ref$shouldSkipCustom,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity;
  var _useState = React.useState(false),
    allowNextAction = _useState[0],
    setAllowNextAction = _useState[1];
  var _useState2 = React.useState(null),
    productsFromCoupons = _useState2[0],
    setProductsFromCoupons = _useState2[1];
  var _useState3 = React.useState(false),
    openGroupedProductModal = _useState3[0],
    setOpenGroupedProductModal = _useState3[1];
  var _useState4 = React.useState(null),
    groupedProductSelected = _useState4[0],
    setGroupedProductSelected = _useState4[1];
  var _useState5 = React.useState(false),
    openComboProductModal = _useState5[0],
    setOpenComboProductModal = _useState5[1];
  var _useState6 = React.useState(null),
    comboProductSelected = _useState6[0],
    setComboProductSelected = _useState6[1];
  var _useState7 = React.useState(false),
    openProductCustomisationModal = _useState7[0],
    setOpenProductCustomisationModal = _useState7[1];
  var _useState8 = React.useState(null),
    customisationProductSelected = _useState8[0],
    setCustomisationProductSelected = _useState8[1];
  var _useState9 = React.useState(false),
    openUpsellModal = _useState9[0],
    setOpenUpsellModal = _useState9[1];
  var _useState10 = React.useState(null),
    formattedUpsells = _useState10[0],
    setFormattedUpsells = _useState10[1];
  var _useState11 = React.useState(false),
    showMiniCartModal = _useState11[0],
    setShowMiniCartModal = _useState11[1];
  var _useState12 = React.useState(null),
    couponMachineState = _useState12[0],
    setCouponMachineState = _useState12[1];
  var _useRecoilState = recoil.useRecoilState(atoms.couponNumberState),
    couponNumber = _useRecoilState[0],
    setCouponNumber = _useRecoilState[1];
  var _useRecoilState2 = recoil.useRecoilState(atoms.couponProductIdState),
    couponProductId = _useRecoilState2[0],
    setCouponProductId = _useRecoilState2[1];
  var _useRecoilState3 = recoil.useRecoilState(atoms.categoryState),
    categoryId = _useRecoilState3[0],
    setCategoryId = _useRecoilState3[1];
  var coupons = recoil.useRecoilValue(atoms.promotionalState);
  var products = recoil.useRecoilValue(atoms.rawProductsState);
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  var _useRecoilState4 = recoil.useRecoilState(atoms.settingsState),
    settings = _useRecoilState4[0];
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var _useRecoilState5 = recoil.useRecoilState(atoms.sessionState),
    session = _useRecoilState5[0];
  var setProductAnimation = recoil.useSetRecoilState(atoms.productAnimationState);
  var _useRecoilState6 = recoil.useRecoilState(atoms.trackedUpsellsState),
    trackedUpsells = _useRecoilState6[0],
    setTrackedUpsells = _useRecoilState6[1];
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer;
  var previousPath = state.from;
  var locationState = state;
  var beaconEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.beacon',
    defaultValue: false
  });
  var computedNextPath = beaconEnabled && shouldSkipCustomerDetailsPath ? customerSkipPath : !!customer ? customerSkipPath : nextPath;
  var _useRestaurantMenu = useRestaurantMenu(),
    loading = _useRestaurantMenu.loading,
    categories = _useRestaurantMenu.categories,
    menuState = _useRestaurantMenu.state,
    promotions = _useRestaurantMenu.promotions;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var _useCart = cart.useCart(),
    commit = _useCart.commit,
    items = _useCart.items;
  var _useRestaurantCart = useRestaurantCart(),
    count = _useRestaurantCart.count,
    total = _useRestaurantCart.total;
  var flags = launchdarklyReactClientSdk.useFlags();
  var _useAccessibility = useAccessibility(),
    accessibilityEnabled = _useAccessibility.accessibilityEnabled;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var history = reactRouterDom.useHistory();
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    upsellAddedToCartTrack = _useAnalytics.upsellAddedToCartTrack,
    orderViewedTrack = _useAnalytics.orderViewedTrack,
    orderCompletedTrack = _useAnalytics.orderCompletedTrack,
    upsizeItemSelectedTrack = _useAnalytics.upsizeItemSelectedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var payload = recoil.useRecoilValue(atoms.formattedOrderPayloadState({
    items: items
  }));
  var available = {
    couponMachineState: couponMachineState,
    setCouponMachineState: setCouponMachineState,
    translateInline: translateProductName(language),
    setOpenProductCustomisationModal: setOpenProductCustomisationModal,
    showHeaderTitleWhenAccessibility: showHeaderTitleWhenAccessibility,
    setCustomisationProductSelected: setCustomisationProductSelected,
    openProductCustomisationModal: openProductCustomisationModal,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    customisationProductSelected: customisationProductSelected,
    showQuantityControllerLabel: showQuantityControllerLabel,
    setOpenGroupedProductModal: setOpenGroupedProductModal,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    setGroupedProductSelected: setGroupedProductSelected,
    setOpenComboProductModal: setOpenComboProductModal,
    setComboProductSelected: setComboProductSelected,
    openGroupedProductModal: openGroupedProductModal,
    productAddedToCartTrack: productAddedToCartTrack,
    upsellAddedToCartTrack: upsellAddedToCartTrack,
    orderViewedTrack: orderViewedTrack,
    orderCompletedTrack: orderCompletedTrack,
    setProductsFromCoupons: setProductsFromCoupons,
    groupedProductSelected: groupedProductSelected,
    limitUpsellModalToOnce: limitUpsellModalToOnce,
    showAddonAvailability: showAddonAvailability,
    randomiseUpsells: randomiseUpsells,
    openComboProductModal: openComboProductModal,
    accessibilityEnabled: accessibilityEnabled,
    comboProductSelected: comboProductSelected,
    setShowMiniCartModal: setShowMiniCartModal,
    setProductAnimation: setProductAnimation,
    setFormattedUpsells: setFormattedUpsells,
    productsFromCoupons: productsFromCoupons,
    setOpenUpsellModal: setOpenUpsellModal,
    setAllowNextAction: setAllowNextAction,
    setTrackedUpsells: setTrackedUpsells,
    showMiniCartModal: showMiniCartModal,
    formattedUpsells: formattedUpsells,
    computedNextPath: computedNextPath,
    showPriceWarning: showPriceWarning,
    allowNextAction: allowNextAction,
    setCouponNumber: setCouponNumber,
    setCouponProductId: setCouponProductId,
    openUpsellModal: openUpsellModal,
    setUpsellState: setUpsellState,
    trackedUpsells: trackedUpsells,
    setCategoryId: setCategoryId,
    locationState: locationState,
    previousPath: previousPath,
    couponNumber: couponNumber,
    couponProductId: couponProductId,
    formatPrice: formatPrice,
    setTemplate: setTemplate,
    categories: categories,
    promotions: promotions,
    categoryId: categoryId,
    menuState: menuState,
    products: products,
    settings: settings,
    loading: loading,
    history: history,
    session: session,
    coupons: coupons,
    commit: commit,
    count: count,
    total: total,
    flags: flags,
    t: t,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    hideDisabledButtons: hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero,
    upsizeItemSelectedTrack: upsizeItemSelectedTrack,
    itemSelectTrack: itemSelectTrack,
    payload: payload,
    isCouponQuantityDisabled: isCouponQuantityDisabled
  };
  return /*#__PURE__*/jsxRuntime.jsx(RestaurantCouponViewContext.Provider, {
    value: available,
    children: children
  });
};

// https://kentcdodds.com/blog/how-to-use-react-context-effectively
var useRestaurantCouponViewContext = function useRestaurantCouponViewContext() {
  var context = React.useContext(RestaurantCouponViewContext);
  if (context === undefined) {
    throw new Error('useRestaurantCouponViewContext must be used within a RestaurantCouponViewProvider');
  }
  return context;
};

var filterComboOptions = function filterComboOptions(_ref) {
  var productsFromCoupon = _ref.productsFromCoupon,
    couponProducts = _ref.couponProducts;
  return productsFromCoupon.map(function (formatProdCouponIterator) {
    var _formatProdCouponIter, _formatProdCouponIter2, _formatProdCouponIter3;
    if (formatProdCouponIterator.type !== 'combo') {
      return formatProdCouponIterator;
    }
    var couponProd = couponProducts == null ? void 0 : couponProducts.find(function (couponProductsIterator) {
      return "" + formatProdCouponIterator.productId === "" + couponProductsIterator.productId;
    });
    return couponProd && couponProd.filterId !== null && couponProd.filterId !== undefined ? _extends({}, formatProdCouponIterator, {
      combo: _extends({}, formatProdCouponIterator.combo, {
        filters: (_formatProdCouponIter = formatProdCouponIterator.combo) == null ? void 0 : (_formatProdCouponIter2 = _formatProdCouponIter.filters) == null ? void 0 : _formatProdCouponIter2.filter(function (formatProdComboFilter) {
          return "" + formatProdComboFilter.id === "" + couponProd.filterId;
        })
      }),
      options: (_formatProdCouponIter3 = formatProdCouponIterator.options) == null ? void 0 : _formatProdCouponIter3.filter(function (formatProdComboFilter) {
        return "" + formatProdComboFilter.id === "" + couponProd.filterId;
      })
    }) : formatProdCouponIterator;
  });
};
var filterProductsFromCoupon = function filterProductsFromCoupon(_ref2) {
  var couponProducts = _ref2.couponProducts,
    menuProducts = _ref2.menuProducts;
  var productsFromCoupon = menuProducts == null ? void 0 : menuProducts.filter(function (productsIterator) {
    return couponProducts == null ? void 0 : couponProducts.find(function (couponProductsIterator) {
      return "" + productsIterator.productId === "" + couponProductsIterator.productId;
    });
  });
  var productsWithFilteredComboOptions = filterComboOptions({
    productsFromCoupon: productsFromCoupon,
    couponProducts: couponProducts
  });
  return productsWithFilteredComboOptions;
};

var useRestaurantCouponView = function useRestaurantCouponView() {
  var _couponMachineState$c, _couponMachineState$c2, _couponMachineState$c3, _getCouponProductsRes;
  var _useRestaurantCouponV = useRestaurantCouponViewContext(),
    couponMachineState = _useRestaurantCouponV.couponMachineState,
    setCouponMachineState = _useRestaurantCouponV.setCouponMachineState,
    hidePriceWhenQuantityLessOrEqualDefault = _useRestaurantCouponV.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero = _useRestaurantCouponV.hidePriceWhenZero,
    setOpenProductCustomisationModal = _useRestaurantCouponV.setOpenProductCustomisationModal,
    showHeaderTitleWhenAccessibility = _useRestaurantCouponV.showHeaderTitleWhenAccessibility,
    setCustomisationProductSelected = _useRestaurantCouponV.setCustomisationProductSelected,
    openProductCustomisationModal = _useRestaurantCouponV.openProductCustomisationModal,
    customisationProductSelected = _useRestaurantCouponV.customisationProductSelected,
    isCustomisationHeaderEnabled = _useRestaurantCouponV.isCustomisationHeaderEnabled,
    showQuantityControllerLabel = _useRestaurantCouponV.showQuantityControllerLabel,
    setOpenGroupedProductModal = _useRestaurantCouponV.setOpenGroupedProductModal,
    isCategoryTotalizerEnabled = _useRestaurantCouponV.isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled = _useRestaurantCouponV.isAdditionalMessageEnabled,
    setGroupedProductSelected = _useRestaurantCouponV.setGroupedProductSelected,
    setOpenComboProductModal = _useRestaurantCouponV.setOpenComboProductModal,
    openGroupedProductModal = _useRestaurantCouponV.openGroupedProductModal,
    setComboProductSelected = _useRestaurantCouponV.setComboProductSelected,
    productAddedToCartTrack = _useRestaurantCouponV.productAddedToCartTrack,
    upsellAddedToCartTrack = _useRestaurantCouponV.upsellAddedToCartTrack,
    orderViewedTrack = _useRestaurantCouponV.orderViewedTrack,
    orderCompletedTrack = _useRestaurantCouponV.orderCompletedTrack,
    groupedProductSelected = _useRestaurantCouponV.groupedProductSelected,
    setProductsFromCoupons = _useRestaurantCouponV.setProductsFromCoupons,
    limitUpsellModalToOnce = _useRestaurantCouponV.limitUpsellModalToOnce,
    showAddonAvailability = _useRestaurantCouponV.showAddonAvailability,
    randomiseUpsells = _useRestaurantCouponV.randomiseUpsells,
    openComboProductModal = _useRestaurantCouponV.openComboProductModal,
    setShowMiniCartModal = _useRestaurantCouponV.setShowMiniCartModal,
    comboProductSelected = _useRestaurantCouponV.comboProductSelected,
    accessibilityEnabled = _useRestaurantCouponV.accessibilityEnabled,
    setProductAnimation = _useRestaurantCouponV.setProductAnimation,
    setFormattedUpsells = _useRestaurantCouponV.setFormattedUpsells,
    productsFromCoupons = _useRestaurantCouponV.productsFromCoupons,
    setAllowNextAction = _useRestaurantCouponV.setAllowNextAction,
    setOpenUpsellModal = _useRestaurantCouponV.setOpenUpsellModal,
    setTrackedUpsells = _useRestaurantCouponV.setTrackedUpsells,
    showMiniCartModal = _useRestaurantCouponV.showMiniCartModal,
    formattedUpsells = _useRestaurantCouponV.formattedUpsells,
    showPriceWarning = _useRestaurantCouponV.showPriceWarning,
    computedNextPath = _useRestaurantCouponV.computedNextPath,
    translateInline = _useRestaurantCouponV.translateInline,
    allowNextAction = _useRestaurantCouponV.allowNextAction,
    setCouponProductId = _useRestaurantCouponV.setCouponProductId,
    setCouponNumber = _useRestaurantCouponV.setCouponNumber,
    openUpsellModal = _useRestaurantCouponV.openUpsellModal,
    setUpsellState = _useRestaurantCouponV.setUpsellState,
    trackedUpsells = _useRestaurantCouponV.trackedUpsells,
    locationState = _useRestaurantCouponV.locationState,
    previousPath = _useRestaurantCouponV.previousPath,
    couponNumber = _useRestaurantCouponV.couponNumber,
    setTemplate = _useRestaurantCouponV.setTemplate,
    formatPrice = _useRestaurantCouponV.formatPrice,
    categories = _useRestaurantCouponV.categories,
    promotions = _useRestaurantCouponV.promotions,
    categoryId = _useRestaurantCouponV.categoryId,
    menuState = _useRestaurantCouponV.menuState,
    settings = _useRestaurantCouponV.settings,
    products = _useRestaurantCouponV.products,
    history = _useRestaurantCouponV.history,
    coupons = _useRestaurantCouponV.coupons,
    session = _useRestaurantCouponV.session,
    loading = _useRestaurantCouponV.loading,
    commit = _useRestaurantCouponV.commit,
    count = _useRestaurantCouponV.count,
    total = _useRestaurantCouponV.total,
    flags = _useRestaurantCouponV.flags,
    t = _useRestaurantCouponV.t,
    disableModifyUpsellOnCart = _useRestaurantCouponV.disableModifyUpsellOnCart,
    hideDisabledButtons = _useRestaurantCouponV.hideDisabledButtons,
    upsizeItemSelectedTrack = _useRestaurantCouponV.upsizeItemSelectedTrack,
    itemSelectTrack = _useRestaurantCouponV.itemSelectTrack,
    payload = _useRestaurantCouponV.payload,
    isCouponQuantityDisabled = _useRestaurantCouponV.isCouponQuantityDisabled;
  var getCouponProductsResponse = (_couponMachineState$c = couponMachineState == null ? void 0 : (_couponMachineState$c2 = couponMachineState.context) == null ? void 0 : (_couponMachineState$c3 = _couponMachineState$c2.response) == null ? void 0 : _couponMachineState$c3.data) != null ? _couponMachineState$c : [];
  var firstResponseItem = (_getCouponProductsRes = getCouponProductsResponse[0]) != null ? _getCouponProductsRes : {};
  var isValidCoupon = firstResponseItem.isValidCoupon,
    validatedCouponMessage = firstResponseItem.validatedCouponMessage,
    productId = firstResponseItem.productId;
  var title = React.useMemo(function () {
    return showHeaderTitleWhenAccessibility ? t('couponTitle') : accessibilityEnabled ? '' : t('couponTitle');
  }, [t, accessibilityEnabled, showHeaderTitleWhenAccessibility]);
  var previousText = React.useMemo(function () {
    return t('couponPreviousAction');
  }, [t]);
  var couponValue = React.useMemo(function () {
    return couponNumber || '';
  }, [couponNumber]);
  var upsells = React.useMemo(function () {
    return (promotions == null ? void 0 : promotions.upsells) || [];
  }, [promotions]);
  var sessionId = React.useMemo(function () {
    return session == null ? void 0 : session.id;
  }, [session]);
  var footerNextText = React.useMemo(function () {
    return t('couponNextAction');
  }, [t]);
  var showCouponForm = React.useMemo(function () {
    return !couponMachineState || (couponMachineState == null ? void 0 : couponMachineState.matches('idle'));
  }, [couponMachineState]);
  var showCouponError = React.useMemo(function () {
    return couponMachineState != null && couponMachineState.matches('error') || couponMachineState != null && couponMachineState.matches('success') && !(productsFromCoupons != null && productsFromCoupons.length) || isValidCoupon === false ? true : false;
  }, [couponMachineState, productsFromCoupons, isValidCoupon]);
  var showCouponList = React.useMemo(function () {
    return couponMachineState != null && couponMachineState.matches('success') && productsFromCoupons != null && productsFromCoupons.length && !showCouponError ? true : false;
  }, [couponMachineState, productsFromCoupons, showCouponError]);
  var showCouponLoading = React.useMemo(function () {
    return couponMachineState == null ? void 0 : couponMachineState.matches('getting');
  }, [couponMachineState]);
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var resetCouponPage = React.useCallback(function () {
    fmApi.resetCouponMachine({
      transition: function transition(machine) {
        return setCouponMachineState(machine);
      }
    });
    setCouponNumber('');
    setProductsFromCoupons([]);
  }, [setCouponMachineState, setCouponNumber, setProductsFromCoupons]);
  var currentSettings = React.useMemo(function () {
    return {
      inputName: 'coupon',
      onChange: setCouponNumber
    };
  }, [setCouponNumber]);
  var previousAction = React.useCallback(function () {
    if (showCouponForm) {
      history.push(previousPath, _extends({}, locationState, {
        origin: '/coupon'
      }));
    } else {
      resetCouponPage();
    }
  }, [resetCouponPage, locationState, previousPath, history, showCouponForm]);
  var nextAction = function nextAction() {
    handleCouponSubmit();
  };
  var goToCategoriesAction = function goToCategoriesAction() {
    resetCouponPage();
    history.push('/categories');
  };
  var onCloseGroupedProductModal = React.useCallback(function () {
    setGroupedProductSelected(null);
    setOpenGroupedProductModal(false);
  }, [setGroupedProductSelected, setOpenGroupedProductModal]);
  var onSelectGroupedProduct = React.useCallback(function (product) {
    setGroupedProductSelected(product);
    setOpenGroupedProductModal(true);
  }, [setGroupedProductSelected, setOpenGroupedProductModal]);
  var onCloseComboProductModal = React.useCallback(function () {
    setComboProductSelected(null);
    setOpenComboProductModal(false);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onSelectComboProduct = React.useCallback(function (product) {
    setComboProductSelected(product);
    setOpenComboProductModal(true);
  }, [setComboProductSelected, setOpenComboProductModal]);
  var onCloseProductCustomisationModal = React.useCallback(function () {
    return setOpenProductCustomisationModal(false);
  }, [setOpenProductCustomisationModal]);
  var onSelectCustomisationProduct = React.useCallback(function (product) {
    setCustomisationProductSelected(product);
    setOpenProductCustomisationModal(true);
  }, [setCustomisationProductSelected, setOpenProductCustomisationModal]);
  var onAddSimpleProduct = React.useCallback(function () {
    history.goBack();
  }, [history]);
  var formatSettings = React.useCallback(function (product, filterId) {
    if (filterId === void 0) {
      filterId = null;
    }
    var categoryUpsells = getUpsellCategoryById(upsells, categoryId, filterId);
    var productUpsells = getUpsellCategoryById(upsells, product == null ? void 0 : product.productId, filterId);
    return {
      title: translateInline(product == null ? void 0 : product.name),
      onAddSimpleProduct: onAddSimpleProduct,
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      onCloseGroupedProductModal: onCloseGroupedProductModal,
      onSelectGroupedProduct: onSelectGroupedProduct,
      onSelectComboProduct: onSelectComboProduct,
      setProductAnimation: setProductAnimation,
      setOpenUpsellModal: setOpenUpsellModal,
      translateInline: translateInline,
      categoryUpsells: categoryUpsells,
      productUpsells: productUpsells,
      categories: categories,
      categoryId: categoryId,
      products: products,
      settings: settings,
      history: history,
      product: product,
      commit: commit
    };
  }, [onAddSimpleProduct, onSelectCustomisationProduct, onCloseGroupedProductModal, onSelectGroupedProduct, onSelectComboProduct, setProductAnimation, setOpenUpsellModal, translateInline, categories, categoryId, products, settings, upsells, history, commit]);
  var showUpsellModal = React.useCallback(function (_ref) {
    var product = _ref.product,
      _ref$uid = _ref.uid,
      uid = _ref$uid === void 0 ? null : _ref$uid,
      _ref$filterId = _ref.filterId,
      filterId = _ref$filterId === void 0 ? null : _ref$filterId;
    return formatShowUpsellModal({
      registerProductAddToCart: registerProductAddToCart,
      upsellAddedToCartTrack: upsellAddedToCartTrack,
      limitUpsellModalToOnce: limitUpsellModalToOnce,
      randomiseUpsells: randomiseUpsells,
      setFormattedUpsells: setFormattedUpsells,
      setOpenUpsellModal: setOpenUpsellModal,
      setTrackedUpsells: setTrackedUpsells,
      formatSettings: formatSettings,
      setUpsellState: setUpsellState,
      sessionId: sessionId,
      filterId: filterId,
      settings: settings,
      product: product,
      flags: flags,
      uid: uid,
      kioskSettings: kioskSettings.kiosk,
      couponNumber: couponNumber
    });
  }, [upsellAddedToCartTrack, limitUpsellModalToOnce, randomiseUpsells, setFormattedUpsells, setOpenUpsellModal, setTrackedUpsells, formatSettings, setUpsellState, sessionId, settings, flags, kioskSettings.kiosk, couponNumber]);
  var onConfirmProductCustomisationModal = React.useCallback(function (_ref2) {
    var product = _ref2.product,
      staged = _ref2.staged,
      _ref2$animate = _ref2.animate,
      animate = _ref2$animate === void 0 ? true : _ref2$animate,
      _ref2$uid = _ref2.uid,
      uid = _ref2$uid === void 0 ? null : _ref2$uid;
    var formattedSettings = formatSettings(product);
    setOpenProductCustomisationModal(false);
    if (animate) setProductAnimation(formatProduct(formattedSettings));
    commit({
      staged: staged
    });
    showUpsellModal({
      uid: uid,
      product: product
    });
    history.push(previousPath);
  }, [setOpenProductCustomisationModal, setProductAnimation, showUpsellModal, formatSettings, commit, history, previousPath]);
  var onCloseUpsellModal = React.useCallback(function () {
    setOpenUpsellModal(false);
  }, [setOpenUpsellModal]);
  var onCloseMiniCartModal = React.useCallback(function (_ref3) {
    var updatedStaged = _ref3.updatedStaged;
    if (updatedStaged) onSelectCustomisationProduct(updatedStaged);
    setShowMiniCartModal(false);
  }, [setShowMiniCartModal, onSelectCustomisationProduct]);
  var onConfirmMiniCartModal = React.useCallback(function () {
    orderCompletedTrack();
    history.push(computedNextPath);
  }, [history, computedNextPath, orderCompletedTrack]);
  var onBasketClick = React.useCallback(function () {
    if (count) {
      setShowMiniCartModal(true);
      orderViewedTrack(cartItems, kioskSettings.kiosk, orderTotal, couponNumber);
    } else {
      setShowMiniCartModal(false);
    }
  }, [count, setShowMiniCartModal, orderViewedTrack, cartItems, kioskSettings.kiosk, orderTotal, couponNumber]);
  var formattedProducts = React.useMemo(function () {
    return formatProductList({
      products: productsFromCoupons,
      registerProductAddToCart: registerProductAddToCart,
      productAddedToCartTrack: productAddedToCartTrack,
      setTrackedUpsells: setTrackedUpsells,
      showUpsellModal: showUpsellModal,
      formatSettings: formatSettings,
      setUpsellState: setUpsellState,
      trackedUpsells: trackedUpsells,
      sessionId: sessionId,
      settings: settings,
      flags: flags,
      couponNumber: couponNumber,
      kioskSettings: kioskSettings.kiosk,
      upsizeItemSelectedTrack: upsizeItemSelectedTrack,
      itemSelectTrack: itemSelectTrack,
      cartItems: cartItems,
      currentCategory: currentCategory,
      setCouponNumber: setCouponNumber
    });
  }, [productAddedToCartTrack, productsFromCoupons, setTrackedUpsells, showUpsellModal, trackedUpsells, setUpsellState, formatSettings, sessionId, settings, flags, couponNumber, kioskSettings.kiosk, upsizeItemSelectedTrack, itemSelectTrack, cartItems, currentCategory, setCouponNumber]);
  React.useEffect(function () {
    var _couponMachineState$e, _couponMachineState$e2;
    if (!couponMachineState || couponMachineState != null && couponMachineState.matches('idle')) {
      return;
    }
    var couponProducts = (_couponMachineState$e = couponMachineState == null ? void 0 : (_couponMachineState$e2 = couponMachineState.event) == null ? void 0 : _couponMachineState$e2.data) != null ? _couponMachineState$e : [];
    if (couponMachineState != null && couponMachineState.matches('success') && couponProducts.length) {
      var filteredProductsFromCoupon = filterProductsFromCoupon({
        couponProducts: couponProducts,
        menuProducts: products
      });
      !showCouponError && setCouponProductId(productId);
      setProductsFromCoupons([].concat(filteredProductsFromCoupon));
    }
  }, [couponMachineState, setProductsFromCoupons, products, productId, setCouponProductId, showCouponError]);
  var handleCouponSubmit = React.useCallback(function () {
    fmApi.getCouponProducts({
      couponNumber: couponNumber,
      coupons: coupons,
      transition: function transition(machine) {
        return setCouponMachineState(machine);
      },
      settings: settings,
      payload: payload
    });
  }, [couponNumber, settings, coupons, setCouponMachineState, payload]);
  React.useEffect(function () {
    if (showCouponList && count === 0) return setAllowNextAction(false);
    if ((couponNumber == null ? void 0 : couponNumber.length) > 0) return setAllowNextAction(true);
    return setAllowNextAction(false);
  }, [setAllowNextAction, couponNumber, showCouponList, count]);
  React.useEffect(function () {
    var header = {
      showBasketCount: showCouponList ? true : false,
      showSubtotal: showCouponList ? true : false,
      allowPreviousAction: true,
      allowNextAction: allowNextAction,
      previousAction: previousAction,
      onBasketClick: onBasketClick,
      previousText: previousText,
      title: title
    };
    var footer = _extends({}, showCouponList && {
      previousAction: function previousAction() {
        return history.push('/categories');
      },
      nextAction: function nextAction() {
        orderCompletedTrack();
        history.push(computedNextPath);
      },
      onSelectCustomisationProduct: onSelectCustomisationProduct,
      showMiniCartSlider: true,
      nextText: footerNextText,
      enableCancelOrder: true,
      allowNextAction: allowNextAction,
      previousText: previousText,
      onBasketClick: onBasketClick
    });
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [onSelectCustomisationProduct, orderCompletedTrack, handleCouponSubmit, computedNextPath, allowNextAction, showCouponList, previousAction, footerNextText, onBasketClick, previousText, setTemplate, history, title]);
  return {
    modalAccessibilityClass: formatModalAccessibilityClass(accessibilityEnabled),
    onConfirmProductCustomisationModal: onConfirmProductCustomisationModal,
    onCloseProductCustomisationModal: onCloseProductCustomisationModal,
    openProductCustomisationModal: openProductCustomisationModal,
    customisationProductSelected: customisationProductSelected,
    isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
    showQuantityControllerLabel: showQuantityControllerLabel,
    isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled: isAdditionalMessageEnabled,
    onCloseGroupedProductModal: onCloseGroupedProductModal,
    onCloseComboProductModal: onCloseComboProductModal,
    openGroupedProductModal: openGroupedProductModal,
    groupedProductSelected: groupedProductSelected,
    onConfirmMiniCartModal: onConfirmMiniCartModal,
    openComboProductModal: openComboProductModal,
    showAddonAvailability: showAddonAvailability,
    accessibilityEnabled: accessibilityEnabled,
    comboProductSelected: comboProductSelected,
    goToCategoriesAction: goToCategoriesAction,
    onCloseMiniCartModal: onCloseMiniCartModal,
    productsFromCoupons: productsFromCoupons,
    onCloseUpsellModal: onCloseUpsellModal,
    formattedProducts: formattedProducts,
    showMiniCartModal: showMiniCartModal,
    showPriceWarning: showPriceWarning,
    formattedUpsells: formattedUpsells,
    openUpsellModal: openUpsellModal,
    allowNextAction: allowNextAction,
    currentSettings: currentSettings,
    showCouponError: showCouponError,
    showCouponLoading: showCouponLoading,
    showCouponList: showCouponList,
    previousAction: previousAction,
    formatPrice: formatPrice,
    couponValue: couponValue,
    nextAction: nextAction,
    menuState: menuState,
    couponMachineState: couponMachineState,
    showCouponForm: showCouponForm,
    products: products,
    loading: loading,
    title: title,
    total: total,
    t: t,
    disableModifyUpsellOnCart: disableModifyUpsellOnCart,
    hideDisabledButtons: hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero: hidePriceWhenZero,
    validatedCouponMessage: validatedCouponMessage,
    isCouponQuantityDisabled: isCouponQuantityDisabled
  };
};

var CouponFormHeader = function CouponFormHeader(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$additionalText = _ref.additionalText,
    additionalText = _ref$additionalText === void 0 ? null : _ref$additionalText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "coupon-header",
    className: "coupon-header flex w-full uppercase text-4xl md:text-7xl text-center font-bold " + className,
    children: additionalText ? /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "coupon-header-title",
        className: "justify-start coupon-header-title",
        children: text
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "coupon-header-additional-title",
        className: "justify-end coupon-header-additional-title",
        children: additionalText
      })]
    }) : /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "coupon-header-title",
      className: "coupon-header-title",
      children: text
    })
  });
};
var CouponForm = function CouponForm(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    _ref2$previousAction = _ref2.previousAction,
    previousAction = _ref2$previousAction === void 0 ? function () {} : _ref2$previousAction,
    _ref2$allowNextAction = _ref2.allowNextAction,
    allowNextAction = _ref2$allowNextAction === void 0 ? true : _ref2$allowNextAction,
    _ref2$nextAction = _ref2.nextAction,
    nextAction = _ref2$nextAction === void 0 ? function () {} : _ref2$nextAction,
    _ref2$currentSettings = _ref2.currentSettings,
    currentSettings = _ref2$currentSettings === void 0 ? {} : _ref2$currentSettings,
    _ref2$couponValue = _ref2.couponValue,
    couponValue = _ref2$couponValue === void 0 ? '' : _ref2$couponValue,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$t = _ref2.t,
    t = _ref2$t === void 0 ? function () {} : _ref2$t;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(CouponFormHeader, {
      className: "flex-col items-center justify-center space-y-4 md:space-y-8",
      text: t('couponFormHeaderTitle')
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "coupon-form",
      className: "coupon-form space-y-4 flex flex-col items-center justify-center w-full " + className,
      children: [/*#__PURE__*/jsxRuntime.jsx(Input, {
        id: currentSettings.inputName,
        value: couponValue,
        className: "w-1/2",
        type: "text",
        "data-test": "coupon-input"
      }), /*#__PURE__*/jsxRuntime.jsx(OnScreenKeyboard, {
        inputName: currentSettings.inputName,
        onChange: currentSettings.onChange,
        initial: "numpad",
        letter: false,
        symbol: false
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        disabled: !allowNextAction,
        onClick: nextAction,
        className: "w-1/2 home-primary-button",
        children: t('couponFormPrimaryAction')
      }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        onClick: previousAction,
        className: "w-1/2 home-primary-button",
        children: t('couponFormSecondaryAction')
      })]
    })]
  });
};
var CouponList = function CouponList(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    _ref3$formattedProduc = _ref3.formattedProducts,
    formattedProducts = _ref3$formattedProduc === void 0 ? null : _ref3$formattedProduc,
    _ref3$couponValue = _ref3.couponValue,
    couponValue = _ref3$couponValue === void 0 ? '' : _ref3$couponValue,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$t = _ref3.t,
    t = _ref3$t === void 0 ? function () {} : _ref3$t;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(CouponFormHeader, {
      className: "justify-between",
      text: t('couponListHeaderTitle'),
      additionalText: couponValue
    }), formattedProducts == null ? void 0 : formattedProducts.map(function (formattedProductsIterator, index) {
      return formattedProductsIterator && /*#__PURE__*/jsxRuntime.jsx("div", {
        "data-test": "coupon-list",
        className: "coupon-list flex flex-col items-center justify-center space-y-4 shadow-lg p-4 w-full " + className,
        children: /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "flex flex-row w-full p-4",
          children: [/*#__PURE__*/jsxRuntime.jsx("div", {
            "data-test": "coupon-list-image",
            className: "flex items-center justify-center w-1/3 my-2 mr-2 coupon-list-image",
            id: formattedProductsIterator.productId,
            children: /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
              src: formattedProductsIterator.image,
              className: "w-auto mx-auto mb-4 text-center max-h-48 gallery-card-image"
            })
          }), /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "flex items-center justify-center w-1/3 my-2 mr-2",
            children: /*#__PURE__*/jsxRuntime.jsx("div", {
              "data-test": "coupon-list-description",
              className: "text-4xl font-bold text-center coupon-list-description",
              children: formattedProductsIterator.title
            })
          }), /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "flex items-center justify-center w-1/3 my-2 mr-2",
            children: /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
              "data-test": "coupon-list-primary-button",
              onClick: formattedProductsIterator.onClick,
              className: "text-3xl coupon-list-primary-button",
              children: ['combo', 'customise'].includes(formattedProductsIterator.type) ? t('couponListChangeAction') : t('couponListAddToCartAction')
            })
          })]
        })
      }, "coupon-list-item-" + index);
    })]
  });
};
var CouponError = function CouponError(_temp4) {
  var _ref4 = _temp4 === void 0 ? {} : _temp4,
    _ref4$validatedCoupon = _ref4.validatedCouponMessage,
    validatedCouponMessage = _ref4$validatedCoupon === void 0 ? '' : _ref4$validatedCoupon,
    _ref4$secondaryAction = _ref4.secondaryAction,
    secondaryAction = _ref4$secondaryAction === void 0 ? function () {} : _ref4$secondaryAction,
    _ref4$primaryAction = _ref4.primaryAction,
    primaryAction = _ref4$primaryAction === void 0 ? function () {} : _ref4$primaryAction,
    _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className,
    _ref4$t = _ref4.t,
    t = _ref4$t === void 0 ? function () {} : _ref4$t;
  var text = validatedCouponMessage || t('couponErrorHeaderTitle');
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(CouponFormHeader, {
      className: "justify-center space-y-4 mb-4 md:space-y-12",
      text: text
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "coupon-error",
      className: "coupon-error flex flex-col items-stretch md:items-center justify-center w-3/4 sm:w-6/12 md:w-full space-y-4 " + className,
      children: [/*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        "data-test": "coupon-error-secondary-button",
        className: "coupon-error-secondary-button md:w-1/2 home-primary-button",
        onClick: secondaryAction,
        children: t('couponErrorSecondaryAction')
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        "data-test": "coupon-error-primary-button",
        className: "coupon-error-primary-button md:w-1/2 home-primary-button",
        onClick: primaryAction,
        children: t('couponErrorPrimaryAction')
      })]
    })]
  });
};

var animationDuration = 1;
var useProductAnimationSpawn = function useProductAnimationSpawn() {
  var _useState = React.useState([]),
    animateProps = _useState[0],
    setAnimateProps = _useState[1];
  var productAnimation = recoil.useRecoilValue(atoms.productAnimationState);
  var resetProductAnimation = recoil.useResetRecoilState(atoms.productAnimationState);
  var _useState2 = React.useState(animationDuration * 1000),
    duration = _useState2[0];
  var _useState3 = React.useState([]),
    animationQueue = _useState3[0],
    setAnimationQueue = _useState3[1];

  /**
   * Add source products in a queue that will execute every product animation
   * without having to stop the actual animation.
   */
  React.useEffect(function () {
    if (!productAnimation) return;
    setAnimationQueue([].concat(animationQueue, [productAnimation]));
    resetProductAnimation();
  }, [animationQueue, setAnimationQueue, productAnimation, resetProductAnimation]);

  /**
   * Execute every product animation from the queue and clear at the end.
   */
  React.useEffect(function () {
    if (!animationQueue.length) return;
    animationQueue.forEach(function (item) {
      var cartIcon = document.getElementById('cart-icon');
      var productCard = document.getElementById(item.productId);
      if (!cartIcon || !productCard) return;
      var refBounds = productCard.getBoundingClientRect();
      var cartBounds = cartIcon.getBoundingClientRect();
      var styleProps = {
        position: 'fixed',
        top: refBounds.top,
        left: refBounds.left
      };
      var scale = 0.3;
      var animateConfig = {
        scale: scale,
        top: cartBounds.top - refBounds.height * scale,
        left: cartBounds.left - refBounds.width * scale,
        rotate: [0, 360, 720],
        opacity: [1, 0.75, 0.5, 0.25, 0]
      };

      // Set an empty `productId` to the animated `Card` to avoid next animations to get the incorrect card by `productId`.
      setAnimateProps([].concat(animateProps, [{
        animateConfig: animateConfig,
        styleProps: styleProps,
        product: _extends({}, item, {
          productId: ''
        })
      }]));
    });
    setAnimationQueue([]);
  }, [animationQueue, setAnimateProps, animateProps, duration]);

  /**
   * This is like a garbage collector which will reset the `animateProps` to unmount
   * the `Card` components that have been already animated to the cart but are hidden.
   * It's important to reset only if there isn't any animation in the queue to not rerender
   * the screen and stop the actual animations.
   * */
  React.useEffect(function () {
    var interval = setInterval(function () {
      try {
        if (animationQueue.length || !animateProps.length) return;
        setAnimateProps([]);
      } catch (err) {
        logger.error('components - useProductAnimationSpawn - error:', err);
      }
    }, duration);
    return function () {
      return clearInterval(interval);
    };
  }, [animateProps.length, animationQueue.length, duration, setAnimateProps]);
  var transitionProps = {
    duration: animationDuration
  };
  return {
    animateProps: animateProps,
    transitionProps: transitionProps
  };
};

var ProductAnimationSpawn = function ProductAnimationSpawn(_ref) {
  var _ref$Card = _ref.Card,
    Card = _ref$Card === void 0 ? GalleryCard : _ref$Card;
  var _useProductAnimationS = useProductAnimationSpawn(),
    animateProps = _useProductAnimationS.animateProps,
    transitionProps = _useProductAnimationS.transitionProps;
  return animateProps.map(function (animateProp, index) {
    return /*#__PURE__*/jsxRuntime.jsx(framerMotion.motion.div, {
      className: "z-40",
      animate: animateProp == null ? void 0 : animateProp.animateConfig,
      transition: transitionProps,
      style: animateProp == null ? void 0 : animateProp.styleProps,
      children: /*#__PURE__*/jsxRuntime.jsx(Card, _extends({}, animateProp == null ? void 0 : animateProp.product, {
        isAnimated: true
      }))
    }, index);
  });
};

var RestaurantCouponView = function RestaurantCouponView() {
  var _useRestaurantCouponV = useRestaurantCouponView(),
    onConfirmProductCustomisationModal = _useRestaurantCouponV.onConfirmProductCustomisationModal,
    onCloseProductCustomisationModal = _useRestaurantCouponV.onCloseProductCustomisationModal,
    openProductCustomisationModal = _useRestaurantCouponV.openProductCustomisationModal,
    customisationProductSelected = _useRestaurantCouponV.customisationProductSelected,
    isCustomisationHeaderEnabled = _useRestaurantCouponV.isCustomisationHeaderEnabled,
    showQuantityControllerLabel = _useRestaurantCouponV.showQuantityControllerLabel,
    isCategoryTotalizerEnabled = _useRestaurantCouponV.isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled = _useRestaurantCouponV.isAdditionalMessageEnabled,
    onCloseGroupedProductModal = _useRestaurantCouponV.onCloseGroupedProductModal,
    onCloseComboProductModal = _useRestaurantCouponV.onCloseComboProductModal,
    modalAccessibilityClass = _useRestaurantCouponV.modalAccessibilityClass,
    openGroupedProductModal = _useRestaurantCouponV.openGroupedProductModal,
    onConfirmMiniCartModal = _useRestaurantCouponV.onConfirmMiniCartModal,
    groupedProductSelected = _useRestaurantCouponV.groupedProductSelected,
    showAddonAvailability = _useRestaurantCouponV.showAddonAvailability,
    openComboProductModal = _useRestaurantCouponV.openComboProductModal,
    accessibilityEnabled = _useRestaurantCouponV.accessibilityEnabled,
    goToCategoriesAction = _useRestaurantCouponV.goToCategoriesAction,
    onCloseMiniCartModal = _useRestaurantCouponV.onCloseMiniCartModal,
    comboProductSelected = _useRestaurantCouponV.comboProductSelected,
    onCloseUpsellModal = _useRestaurantCouponV.onCloseUpsellModal,
    formattedProducts = _useRestaurantCouponV.formattedProducts,
    showMiniCartModal = _useRestaurantCouponV.showMiniCartModal,
    showPriceWarning = _useRestaurantCouponV.showPriceWarning,
    formattedUpsells = _useRestaurantCouponV.formattedUpsells,
    openUpsellModal = _useRestaurantCouponV.openUpsellModal,
    allowNextAction = _useRestaurantCouponV.allowNextAction,
    currentSettings = _useRestaurantCouponV.currentSettings,
    showCouponError = _useRestaurantCouponV.showCouponError,
    showCouponLoading = _useRestaurantCouponV.showCouponLoading,
    showCouponList = _useRestaurantCouponV.showCouponList,
    showCouponForm = _useRestaurantCouponV.showCouponForm,
    previousAction = _useRestaurantCouponV.previousAction,
    formatPrice = _useRestaurantCouponV.formatPrice,
    couponValue = _useRestaurantCouponV.couponValue,
    nextAction = _useRestaurantCouponV.nextAction,
    menuState = _useRestaurantCouponV.menuState,
    products = _useRestaurantCouponV.products,
    loading = _useRestaurantCouponV.loading,
    t = _useRestaurantCouponV.t,
    disableModifyUpsellOnCart = _useRestaurantCouponV.disableModifyUpsellOnCart,
    hideDisabledButtons = _useRestaurantCouponV.hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault = _useRestaurantCouponV.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero = _useRestaurantCouponV.hidePriceWhenZero,
    validatedCouponMessage = _useRestaurantCouponV.validatedCouponMessage,
    isCouponQuantityDisabled = _useRestaurantCouponV.isCouponQuantityDisabled;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ProductAnimationSpawn, {}), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "coupon-view",
      className: "flex flex-col items-center justify-center w-full h-full p-2 space-y-8 overflow-y-auto coupon-view md:p-8",
      children: [/*#__PURE__*/jsxRuntime.jsx(Modal, {
        open: showMiniCartModal,
        formatPrice: formatPrice,
        children: /*#__PURE__*/jsxRuntime.jsx(MiniCartModal, {
          onCloseCallback: onCloseMiniCartModal,
          onConfirmCallback: onConfirmMiniCartModal,
          showPriceWarning: showPriceWarning,
          disableModifyUpsellOnCart: disableModifyUpsellOnCart,
          hideDisabledButtons: hideDisabledButtons,
          isCouponQuantityDisabled: isCouponQuantityDisabled
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Modal, {
        "data-test": "grouped-option-modal",
        className: modalAccessibilityClass + " grouped-option-modal",
        open: openGroupedProductModal,
        title: groupedProductSelected == null ? void 0 : groupedProductSelected.title,
        closeModal: onCloseGroupedProductModal,
        closeText: t('couponGroupedModalSecondaryAction'),
        formatPrice: formatPrice,
        children: /*#__PURE__*/jsxRuntime.jsx(Gallery, {
          items: groupedProductSelected == null ? void 0 : groupedProductSelected.grouped,
          dynamicColumns: true,
          formatPrice: formatPrice
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Modal, {
        "data-test": "combo-option-modal",
        className: "combo-option-modal " + modalAccessibilityClass,
        open: openComboProductModal,
        title: t('couponComboModalTitle'),
        closeModal: onCloseComboProductModal,
        closeText: t('couponComboModalSecondaryAction'),
        formatPrice: formatPrice,
        children: /*#__PURE__*/jsxRuntime.jsx(Gallery, {
          items: comboProductSelected == null ? void 0 : comboProductSelected.options,
          dynamicColumns: true,
          formatPrice: formatPrice
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Modal, {
        open: openProductCustomisationModal,
        className: modalAccessibilityClass,
        formatPrice: formatPrice,
        children: /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationModal, {
          product: customisationProductSelected,
          onCloseCallback: onCloseProductCustomisationModal,
          onConfirmCallback: onConfirmProductCustomisationModal,
          showPriceWarning: showPriceWarning,
          isCustomisationHeaderEnabled: isCustomisationHeaderEnabled,
          isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
          isAdditionalMessageEnabled: isAdditionalMessageEnabled,
          showQuantityControllerLabel: showQuantityControllerLabel,
          showAddonAvailability: showAddonAvailability,
          hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
          hidePriceWhenZero: hidePriceWhenZero,
          isCouponQuantityDisabled: isCouponQuantityDisabled
        })
      }), /*#__PURE__*/jsxRuntime.jsx(UpsellModal, {
        open: openUpsellModal,
        closeModal: onCloseUpsellModal,
        t: t,
        products: formattedUpsells,
        className: modalAccessibilityClass,
        formatPrice: formatPrice
      }), loading && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex flex-col items-center justify-center h-full p-8",
        children: /*#__PURE__*/jsxRuntime.jsx(Loading, {})
      }), (menuState == null ? void 0 : menuState.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex flex-col items-center justify-center h-full p-8",
        children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
          type: "danger",
          message: menuState.context.message
        })
      }), (menuState == null ? void 0 : menuState.matches('success')) && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [showCouponForm && /*#__PURE__*/jsxRuntime.jsx(CouponForm, {
          accessibilityEnabled: accessibilityEnabled,
          currentSettings: currentSettings,
          allowNextAction: allowNextAction,
          previousAction: previousAction,
          couponValue: couponValue,
          nextAction: nextAction,
          t: t
        }), showCouponList && /*#__PURE__*/jsxRuntime.jsx(CouponList, {
          formattedProducts: formattedProducts,
          couponValue: couponValue,
          products: products,
          t: t
        }), showCouponError && /*#__PURE__*/jsxRuntime.jsx(CouponError, {
          validatedCouponMessage: validatedCouponMessage,
          secondaryAction: goToCategoriesAction,
          primaryAction: previousAction,
          t: t
        }), showCouponLoading && /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex flex-col items-center justify-center h-full p-8",
          children: /*#__PURE__*/jsxRuntime.jsx(Loading, {
            title: t('loadingCoupon')
          })
        })]
      })]
    })]
  });
};

var NotificationContext = /*#__PURE__*/React.createContext();
var NotificationProvider = function NotificationProvider(_temp) {
  var _settings$settings, _settings$settings$in;
  var _ref = _temp === void 0 ? {} : _temp,
    children = _ref.children;
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var _ref2 = (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$in = _settings$settings.interval) == null ? void 0 : _settings$settings$in.session) || {},
    _ref2$notification = _ref2.notification,
    notificationTime = _ref2$notification === void 0 ? 5 : _ref2$notification;
  var available = {
    notificationTime: notificationTime
  };
  return /*#__PURE__*/jsxRuntime.jsx(NotificationContext.Provider, {
    value: available,
    children: children
  });
};
var useNotificationContext = function useNotificationContext() {
  var context = React.useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
};

var useNotification = function useNotification() {
  var _useNotificationConte = useNotificationContext(),
    notificationTime = _useNotificationConte.notificationTime;
  var _useState = React.useState(null),
    timer = _useState[0],
    setTimer = _useState[1];
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var history = reactRouterDom.useHistory();
  var _state$redirectPath = state.redirectPath,
    redirectPath = _state$redirectPath === void 0 ? '/reset' : _state$redirectPath;
  var redirect = React.useCallback(function () {
    return history.push(redirectPath);
  }, [history, redirectPath]);
  React.useEffect(function () {
    if (timer) return;
    var timerInstance = setTimeout(function () {
      try {
        redirect();
      } catch (err) {
        logger.error('Components - useNotification - error:', err);
      }
    }, notificationTime * 1000);
    setTimer(timerInstance);
  }, [redirectPath, history, notificationTime, timer, redirect]);
  return {
    t: t,
    redirect: redirect
  };
};

var NotificationView = function NotificationView() {
  var _useNotification = useNotification(),
    t = _useNotification.t,
    redirect = _useNotification.redirect;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "flex flex-col items-center justify-center w-full h-full notification-view",
    children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
      type: "danger",
      message: t('autoRedirectNotificationTitle'),
      additionalMessage: t('autoRedirectNotificationAdditionalMessage'),
      detail: t('autoRedirectNotificationMessage'),
      onRetryAction: redirect,
      onRetryText: t('autoRedirectNotificationButton')
    })
  });
};

var AdminAuthenticateContext = /*#__PURE__*/React.createContext();
var AdminAuthenticateProvider = function AdminAuthenticateProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    children = _ref.children;
  var available = {};
  return /*#__PURE__*/jsxRuntime.jsx(AdminAuthenticateContext.Provider, {
    value: available,
    children: children
  });
};
var useAdminAuthenticateContext = function useAdminAuthenticateContext() {
  var context = React.useContext(AdminAuthenticateContext);
  if (context === undefined) {
    throw new Error('useAdminAuthenticateContext must be used within a AdminAuthenticateProvider');
  }
  return context;
};

var useAdminAuthenticate = function useAdminAuthenticate() {
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  return {
    t: t
  };
};

var useAdminLogin = function useAdminLogin(_ref) {
  var authPath = _ref.authPath;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useState = React.useState(''),
    password = _useState[0],
    setPassword = _useState[1];
  var _useState2 = React.useState(false),
    incorrectPassword = _useState2[0],
    setIncorrectPassword = _useState2[1];
  var history = reactRouterDom.useHistory();
  var _useLocation = reactRouterDom.useLocation(),
    state = _useLocation.state;
  var _useRestaurantLock = useRestaurantLock(),
    manualUnlock = _useRestaurantLock.manualUnlock;
  var _state$successPath = state.successPath,
    successPath = _state$successPath === void 0 ? '/admin' : _state$successPath,
    _state$cancelPath = state.cancelPath,
    cancelPath = _state$cancelPath === void 0 ? '/home' : _state$cancelPath,
    _state$shouldUnlock = state.shouldUnlock,
    shouldUnlock = _state$shouldUnlock === void 0 ? false : _state$shouldUnlock;
  var numbers = React.useMemo(function () {
    return lodash.shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]);
  }, []);
  var numpadLayout = [lodash.times(3, function (index) {
    return numbers[index];
  }).join(' '), lodash.times(3, function (index) {
    return numbers[index + 3];
  }).join(' '), lodash.times(3, function (index) {
    return numbers[index + 6];
  }).join(' '), numbers[9] + " {bksp}" // Backspace button symbol for onscreen keyboard
  ];
  var handleSuccess = function handleSuccess() {
    if (shouldUnlock) manualUnlock();
    history.push(successPath, {
      from: authPath
    });
  };
  var handleCancel = function handleCancel() {
    return history.push(cancelPath, {
      from: authPath
    });
  };
  var onSubmit = function onSubmit() {
    setIncorrectPassword(false);
    if (password === process.env.POI_APP_ADMIN_CLIENT_PASSWORD) handleSuccess();else setIncorrectPassword(true);
  };
  var onCancel = function onCancel() {
    return handleCancel();
  };
  return {
    setPassword: setPassword,
    password: password,
    onSubmit: onSubmit,
    t: t,
    onCancel: onCancel,
    incorrectPassword: incorrectPassword,
    numpadLayout: numpadLayout
  };
};

var AdminLogin = function AdminLogin(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$authPath = _ref.authPath,
    authPath = _ref$authPath === void 0 ? '/auth' : _ref$authPath;
  var _useAdminLogin = useAdminLogin({
      authPath: authPath
    }),
    setPassword = _useAdminLogin.setPassword,
    onSubmit = _useAdminLogin.onSubmit,
    password = _useAdminLogin.password,
    t = _useAdminLogin.t,
    onCancel = _useAdminLogin.onCancel,
    incorrectPassword = _useAdminLogin.incorrectPassword,
    numpadLayout = _useAdminLogin.numpadLayout;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "admin-login",
    className: "admin-login",
    children: [incorrectPassword && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "admin-login-incorrect-password",
      children: t('adminLoginErrorPasswordMessage')
    }), /*#__PURE__*/jsxRuntime.jsx(Input, {
      type: "password",
      id: "password",
      value: password,
      className: "admin-login-password"
    }), /*#__PURE__*/jsxRuntime.jsx(OnScreenKeyboard, {
      letter: false,
      symbol: false,
      numpadLayout: numpadLayout,
      initial: "numpad",
      onChange: setPassword,
      inputName: "password"
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "admin-login-buttons-group",
      children: [/*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        onClick: onSubmit,
        className: "admin-login-button home-primary-button",
        children: t('adminLoginPrimaryAction')
      }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        onClick: onCancel,
        className: "admin-login-button home-primary-button",
        children: t('adminLoginSecondaryAction')
      })]
    })]
  });
};

var AdminAuthenticateView = function AdminAuthenticateView() {
  var _useAdminAuthenticate = useAdminAuthenticate(),
    t = _useAdminAuthenticate.t;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "auth-screen",
    className: "flex flex-col p-2 sm:p-8 md:h-screen mt-20 md:mt-0 justify-center bg-default",
    children: [/*#__PURE__*/jsxRuntime.jsx("h1", {
      className: "text-4xl sm:text-6xl text-center font-bold mb-4 sm:mb-16 sm:leading-none uppercase",
      children: t('adminLoginTitle')
    }), /*#__PURE__*/jsxRuntime.jsx(AdminLogin, {})]
  });
};

var CustomerDetailsViewContext = /*#__PURE__*/React.createContext();
var CustomerDetailsViewProvider = function CustomerDetailsViewProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsxRuntime.jsx(CustomerDetailsViewContext.Provider, {
    children: children
  });
};
var useCustomerDetailsViewContext = function useCustomerDetailsViewContext() {
  var context = React.useContext(CustomerDetailsViewContext);
  if (context === undefined) {
    throw new Error('useCustomerDetailsViewContext must be used within a CustomerDetailsViewProvider');
  }
  return context;
};

var en = {
	"4r5e": null,
	"5h1t": null,
	"5h1t5": null,
	"5h1ts": null,
	"5hit": null,
	"5hit5": null,
	"5hits": null,
	a55: null,
	anal: null,
	anals: null,
	anus: null,
	ar5e: null,
	arrse: null,
	arse: null,
	ass: null,
	"as s": null,
	"ass-fucker": null,
	"ass-fuckers": null,
	asses: null,
	assfucker: null,
	assfuckers: null,
	assfukka: null,
	assfukkas: null,
	asshole: null,
	assholes: null,
	asswhole: null,
	asswholes: null,
	a_s_s: null,
	"b!tch": null,
	"b!tches": null,
	b00bs: null,
	b00b: null,
	b00bie: null,
	b00bies: null,
	"b00bie s": null,
	"b00bie. s.": null,
	b000bs: null,
	b0000bs: null,
	b00000bs: null,
	b000000bs: null,
	b0000000bs: null,
	b17ch: null,
	b1tch: null,
	ballbag: null,
	balls: null,
	ballsack: null,
	bastard: null,
	bastards: null,
	beastial: null,
	beastiality: null,
	bellend: null,
	bendover: null,
	bestial: null,
	bestiality: null,
	"bi+ch": null,
	biatch: null,
	"big d": null,
	"big. d.": null,
	bitch: null,
	bitcher: null,
	bitchers: null,
	bitches: null,
	bitchin: null,
	bitching: null,
	bitchs: null,
	bloody: null,
	"blow job": null,
	blowjob: null,
	blowjobs: null,
	boiolas: null,
	bollock: null,
	bollocks: null,
	bollok: null,
	bolloks: null,
	boner: null,
	boners: null,
	boob: null,
	boobie: null,
	boobies: null,
	"boobie s": null,
	"boobie. s.": null,
	boobs: null,
	booobs: null,
	boooobs: null,
	booooobs: null,
	booooooobs: null,
	breasts: null,
	buceta: null,
	bugger: null,
	bum: null,
	bums: null,
	"bunny fucker": null,
	butt: null,
	butthole: null,
	buttmunch: null,
	buttplug: null,
	buttplugs: null,
	butts: null,
	"c!ldm.olester": null,
	"c!nt": null,
	"c.o.c.k": null,
	c0ck: null,
	c0cksucker: null,
	"carpet muncher": null,
	cawk: null,
	ccunt: null,
	ccuunnt: null,
	ccuunntt: null,
	ccuunt: null,
	cccunt: null,
	ccccunt: null,
	"childm.olester": null,
	childmolester: null,
	chink: null,
	cipa: null,
	cl1t: null,
	clit: null,
	clitoris: null,
	clits: null,
	cnut: null,
	cock: null,
	"cock-sucker": null,
	cockface: null,
	cockfaces: null,
	cockhead: null,
	cockheads: null,
	cockmunch: null,
	cockmuncher: null,
	cocks: null,
	"cocksuck ": null,
	"cocksucked ": null,
	cocksucker: null,
	cocksucking: null,
	"cocksucks ": null,
	cocksuka: null,
	cocksukka: null,
	cok: null,
	cokmuncher: null,
	coksucka: null,
	coon: null,
	cox: null,
	crap: null,
	cum: null,
	cummer: null,
	cumming: null,
	cums: null,
	cumshot: null,
	cun: null,
	"cun.t": null,
	cunilingus: null,
	cunillingus: null,
	cunnilingus: null,
	cunnnnt: null,
	cunnt: null,
	cunt: null,
	"cuntlick ": null,
	"cuntlicker ": null,
	"cuntlicking ": null,
	cuntss: null,
	cunts: null,
	cuntt: null,
	cunttt: null,
	cuntttt: null,
	cuunt: null,
	cuuunt: null,
	cuunts: null,
	cyalis: null,
	cyberfuc: null,
	"cyberfuck ": null,
	"cyberfucked ": null,
	cyberfucker: null,
	cyberfuckers: null,
	"cyberfucking ": null,
	daddy: null,
	deeznutz: null,
	"deeznutz d": null,
	"deeznutz. d.": null,
	d1ck: null,
	damn: null,
	dick: null,
	dick5: null,
	dicks: null,
	dickhead: null,
	dickhead5: null,
	dickheads: null,
	diddy: null,
	dildo: null,
	dildoes: null,
	dildos: null,
	dink: null,
	dinks: null,
	dirsa: null,
	dlck: null,
	"dog-fucker": null,
	doggin: null,
	dogging: null,
	donkeyribber: null,
	doosh: null,
	duche: null,
	dyke: null,
	ejaculate: null,
	ejaculated: null,
	"ejaculates ": null,
	"ejaculating ": null,
	ejaculatings: null,
	ejaculation: null,
	ejakulate: null,
	"f u c k": null,
	"f u c k e r": null,
	f4nny: null,
	fag: null,
	fagging: null,
	faggitt: null,
	faggot: null,
	faggot5: null,
	faggots: null,
	faggs: null,
	fagot: null,
	fagots: null,
	fags: null,
	fanny: null,
	fannyflaps: null,
	fannyfucker: null,
	fanyy: null,
	fatass: null,
	fcuk: null,
	fcuks: null,
	fcuker: null,
	fcuking: null,
	feck: null,
	fecker: null,
	feckers: null,
	felching: null,
	fellate: null,
	fellatio: null,
	ffuucck: null,
	ffuucckk: null,
	ffuuck: null,
	fffuck: null,
	"fingerfuck ": null,
	"fingerfucked ": null,
	"fingerfucker ": null,
	fingerfuckers: null,
	"fingerfucking ": null,
	"fingerfucks ": null,
	fistfuck: null,
	"fistfucked ": null,
	"fistfucker ": null,
	"fistfuckers ": null,
	"fistfucking ": null,
	"fistfuckings ": null,
	"fistfucks ": null,
	flange: null,
	fock: null,
	"fock u": null,
	"fock. u.": null,
	fook: null,
	fooker: null,
	fucck: null,
	fuccck: null,
	fuccks: null,
	fuuck: null,
	fuuuck: null,
	fuuuuck: null,
	fuck: null,
	fucka: null,
	fucked: null,
	fucker: null,
	fuckers: null,
	ffuck: null,
	fuckhead: null,
	fuckheads: null,
	fuckin: null,
	fucking: null,
	fuckings: null,
	fuckingshitmotherfucker: null,
	fuckk: null,
	fuckkkk: null,
	fuckkkkk: null,
	fuckkkkkk: null,
	fuckkks: null,
	fuckks: null,
	"fuckme ": null,
	fucks: null,
	fuckwit: null,
	"fudge packer": null,
	fudgepacker: null,
	fuk: null,
	fuker: null,
	fukinn: null,
	fukinnn: null,
	fuking: null,
	fukk: null,
	fukkk: null,
	fukker: null,
	fukks: null,
	fukkin: null,
	fuks: null,
	fukwhit: null,
	fukwhits: null,
	fuckwhit: null,
	fuckwhit5: null,
	fuckwhits: null,
	fukwit: null,
	fukwits: null,
	fux: null,
	fux0r: null,
	f_u_c_k: null,
	gangbang: null,
	"gangbanged ": null,
	"gangbangs ": null,
	gaylord: null,
	gaysex: null,
	givemehead: null,
	goatse: null,
	"god-dam": null,
	"god-damned": null,
	goddamn: null,
	goddamned: null,
	"hardcoresex ": null,
	hell: null,
	heshe: null,
	"hilter.wasright": null,
	hitler: null,
	hitlerwasright: null,
	hoar: null,
	hoare: null,
	hoer: null,
	homo: null,
	homos: null,
	homoe: null,
	homoes: null,
	hore: null,
	hores: null,
	hornie: null,
	horniest: null,
	horny: null,
	hotsex: null,
	"iwant.morehead": null,
	iwanthead: null,
	iwantmorehead: null,
	"jack-off ": null,
	jackoff: null,
	jap: null,
	"jerk-off ": null,
	jism: null,
	"jiz ": null,
	"jizm ": null,
	jizz: null,
	"jizz.le": null,
	jizzle: null,
	jizzing: null,
	kawk: null,
	knob: null,
	knobead: null,
	knobed: null,
	knobend: null,
	knobhead: null,
	knobjocky: null,
	knobjokey: null,
	kock: null,
	kondum: null,
	kondums: null,
	kum: null,
	kummer: null,
	kumming: null,
	kums: null,
	kunilingus: null,
	kiunt: null,
	kkk: null,
	"l3i+ch": null,
	l3itch: null,
	labia: null,
	lmfao: null,
	lust: null,
	lusting: null,
	m0f0: null,
	m0fo: null,
	m45terbate: null,
	ma5terb8: null,
	ma5terbate: null,
	masochist: null,
	"master-bate": null,
	masterb8: null,
	"masterbat*": null,
	masterbat3: null,
	masterbate: null,
	masterbation: null,
	masterbations: null,
	masturbate: null,
	"mo-fo": null,
	mof0: null,
	mofo: null,
	molest: null,
	molester: null,
	mothafuck: null,
	mothafucka: null,
	mothafuckas: null,
	mothafuckaz: null,
	"mothafucked ": null,
	mothafucker: null,
	mothafuckers: null,
	mothafuckin: null,
	"mothafucking ": null,
	mothafuckings: null,
	mothafucks: null,
	"mother fucker": null,
	motherfuck: null,
	motherfucked: null,
	motherfucker: null,
	motherfuckers: null,
	motherfuckin: null,
	motherfucking: null,
	motherfuckings: null,
	motherfuckka: null,
	motherfucks: null,
	muff: null,
	mutha: null,
	muthafecker: null,
	muthafuckker: null,
	muther: null,
	mutherfucker: null,
	nig: null,
	nigg: null,
	"nigg a": null,
	"nigg.r": null,
	"nigg. a.": null,
	nigs: null,
	"nig r": null,
	"nig. r.": null,
	n1gga: null,
	n1gger: null,
	nazi: null,
	nigg3r: null,
	nigg4h: null,
	nigga: null,
	niggah: null,
	niggas: null,
	niggaz: null,
	nigger: null,
	"niggers ": null,
	"niggg.r": null,
	niggs: null,
	nob: null,
	"nob jokey": null,
	"nob jockey": null,
	nobhead: null,
	nobjocky: null,
	nobjokey: null,
	numbnut: null,
	numbnuts: null,
	nutsack: null,
	"orgasim ": null,
	"orgasims ": null,
	orgasm: null,
	"orgasms ": null,
	p00p: null,
	p00ps: null,
	p00pies: null,
	p0rn: null,
	p0rn0: null,
	pawn: null,
	"peda.file": null,
	pedafile: null,
	pedo: null,
	pedofile: null,
	pecker: null,
	peckers: null,
	peni: null,
	penii: null,
	peniii: null,
	penis: null,
	penisfucker: null,
	phonesex: null,
	phuck: null,
	phuk: null,
	phuked: null,
	phuking: null,
	phukked: null,
	phukking: null,
	phuks: null,
	phuq: null,
	pigfucker: null,
	pimpis: null,
	piss: null,
	pissed: null,
	pisser: null,
	pissers: null,
	"pisses ": null,
	pissflaps: null,
	"pissin ": null,
	pissing: null,
	"pissoff ": null,
	poop: null,
	poops: null,
	poopie: null,
	poopies: null,
	porn: null,
	porno: null,
	pornography: null,
	pornos: null,
	prick: null,
	"pricks ": null,
	pron: null,
	pube: null,
	pusse: null,
	pussi: null,
	pussies: null,
	pussy: null,
	"pussys ": null,
	rap: null,
	"rap.ist": null,
	rapist: null,
	rectum: null,
	retard: null,
	rimjaw: null,
	rimming: null,
	"s hit": null,
	"s.o.b.": null,
	sadist: null,
	schlong: null,
	schlongs: null,
	screwing: null,
	scroat: null,
	scrote: null,
	scrotum: null,
	semen: null,
	sex: null,
	"sh!+": null,
	"sh!t": null,
	sh1t: null,
	shag: null,
	shagger: null,
	shaggin: null,
	shagging: null,
	shemale: null,
	shemales: null,
	"shi+": null,
	shit: null,
	shitdick: null,
	shite: null,
	shited: null,
	shitey: null,
	shitfuck: null,
	shitfull: null,
	shithead: null,
	shitheads: null,
	shiting: null,
	shitings: null,
	shits: null,
	shitted: null,
	shitter: null,
	"shitters ": null,
	shitting: null,
	shittings: null,
	"shitty ": null,
	siccunt: null,
	sickcunt: null,
	sickkunt: null,
	sikcnt: null,
	sickknt: null,
	sikcunt: null,
	sikknt: null,
	sikkunt: null,
	skank: null,
	skanks: null,
	slut: null,
	sluts: null,
	slutty: null,
	smegma: null,
	smut: null,
	smutty: null,
	snatch: null,
	"son-of-a-bitch": null,
	sonofabitch: null,
	sonnofabitch: null,
	spac: null,
	spunk: null,
	s_h_i_t: null,
	t1tt1e5: null,
	t1tties: null,
	teets: null,
	teez: null,
	testical: null,
	testicle: null,
	tit: null,
	titfuck: null,
	tits: null,
	titt: null,
	tittie5: null,
	tittiefucker: null,
	titties: null,
	tittyfuck: null,
	tittywank: null,
	titwank: null,
	tosser: null,
	tossers: null,
	turd: null,
	tw4t: null,
	twat: null,
	twathead: null,
	twatty: null,
	twunt: null,
	twunter: null,
	uarcun: null,
	v14gra: null,
	v1gra: null,
	vagina: null,
	viagra: null,
	vulva: null,
	w00se: null,
	wang: null,
	wank: null,
	wanker: null,
	wanky: null,
	whoar: null,
	whore: null,
	whores: null,
	willies: null,
	willy: null,
	willys: null,
	youracun: null,
	youracunt: null,
	xrated: null,
	xxxrated: null,
	xxx: null
};
var uae = {
	"4r5e": null,
	"5h1t": null,
	"5hit": null,
	a55: null,
	anal: null,
	anus: null,
	ar5e: null,
	arrse: null,
	arse: null,
	ass: null,
	"as s": null,
	"ass-fucker": null,
	asses: null,
	assfucker: null,
	assfukka: null,
	asshole: null,
	assholes: null,
	asswhole: null,
	a_s_s: null,
	"b!tch": null,
	b00bs: null,
	b17ch: null,
	b1tch: null,
	ballbag: null,
	balls: null,
	ballsack: null,
	bastard: null,
	beastial: null,
	beastiality: null,
	bellend: null,
	bendover: null,
	bestial: null,
	bestiality: null,
	"bi+ch": null,
	biatch: null,
	"big d": null,
	"big. d.": null,
	bitch: null,
	bitcher: null,
	bitchers: null,
	bitches: null,
	bitchin: null,
	bitching: null,
	bloody: null,
	"blow job": null,
	blowjob: null,
	blowjobs: null,
	boiolas: null,
	bollock: null,
	bollok: null,
	boner: null,
	boob: null,
	boobie: null,
	boobies: null,
	"boobie s": null,
	"boobie. s.": null,
	boobs: null,
	booobs: null,
	boooobs: null,
	booooobs: null,
	booooooobs: null,
	b00b: null,
	b00bie: null,
	b00bies: null,
	"b00bie s": null,
	"b00bie. s.": null,
	b000bs: null,
	b0000bs: null,
	b00000bs: null,
	b000000bs: null,
	b0000000bs: null,
	breasts: null,
	buceta: null,
	bugger: null,
	bum: null,
	"bunny fucker": null,
	butt: null,
	butthole: null,
	buttmunch: null,
	buttplug: null,
	"c!ldm.olester": null,
	"c!nt": null,
	"c.o.c.k": null,
	c0ck: null,
	c0cksucker: null,
	"carpet muncher": null,
	cawk: null,
	ccunt: null,
	ccuunnt: null,
	ccuunntt: null,
	ccuunt: null,
	cccunt: null,
	ccccunt: null,
	"childm.olester": null,
	childmolester: null,
	chink: null,
	cipa: null,
	cl1t: null,
	clit: null,
	clitoris: null,
	clits: null,
	cnut: null,
	cock: null,
	"cock-sucker": null,
	cockface: null,
	cockhead: null,
	cockheads: null,
	cockmunch: null,
	cockmuncher: null,
	cocks: null,
	"cocksuck ": null,
	"cocksucked ": null,
	cocksucker: null,
	cocksucking: null,
	"cocksucks ": null,
	cocksuka: null,
	cocksukka: null,
	cok: null,
	cokmuncher: null,
	coksucka: null,
	coon: null,
	cox: null,
	crap: null,
	cum: null,
	cummer: null,
	cumming: null,
	cums: null,
	cumshot: null,
	cun: null,
	"cun.t": null,
	cunilingus: null,
	cunillingus: null,
	cunnilingus: null,
	cunnnnt: null,
	cunnt: null,
	cunt: null,
	"cuntlick ": null,
	"cuntlicker ": null,
	"cuntlicking ": null,
	cuntss: null,
	cunts: null,
	cuntt: null,
	cunttt: null,
	cuntttt: null,
	cuunt: null,
	cuuunt: null,
	cuunts: null,
	cyalis: null,
	cyberfuc: null,
	"cyberfuck ": null,
	"cyberfucked ": null,
	cyberfucker: null,
	cyberfuckers: null,
	"cyberfucking ": null,
	d1ck: null,
	daddy: null,
	damn: null,
	deeznutz: null,
	"deeznutz d": null,
	"deeznutz. d.": null,
	diccck: null,
	dick: null,
	dicks: null,
	dickhead: null,
	diddy: null,
	dildo: null,
	dildos: null,
	dink: null,
	dinks: null,
	dirsa: null,
	dlck: null,
	"dog-fucker": null,
	doggin: null,
	dogging: null,
	donkeyribber: null,
	doosh: null,
	duche: null,
	dyke: null,
	ejaculate: null,
	ejaculated: null,
	"ejaculates ": null,
	"ejaculating ": null,
	ejaculatings: null,
	ejaculation: null,
	ejakulate: null,
	"f u c k": null,
	"f u c k e r": null,
	f4nny: null,
	fag: null,
	fagging: null,
	faggitt: null,
	faggot: null,
	faggs: null,
	fagot: null,
	fagots: null,
	fags: null,
	fanny: null,
	fannyflaps: null,
	fannyfucker: null,
	fanyy: null,
	fatass: null,
	fcuk: null,
	fcuker: null,
	fcuking: null,
	feck: null,
	fecker: null,
	felching: null,
	fellate: null,
	fellatio: null,
	ffuucck: null,
	ffuucckk: null,
	ffuuck: null,
	fffuck: null,
	"fingerfuck ": null,
	"fingerfucked ": null,
	"fingerfucker ": null,
	fingerfuckers: null,
	"fingerfucking ": null,
	"fingerfucks ": null,
	fistfuck: null,
	"fistfucked ": null,
	"fistfucker ": null,
	"fistfuckers ": null,
	"fistfucking ": null,
	"fistfuckings ": null,
	"fistfucks ": null,
	flange: null,
	fook: null,
	fock: null,
	"fock u": null,
	"fock. u.": null,
	fooker: null,
	fucck: null,
	fuccck: null,
	fuccks: null,
	fuuck: null,
	fuuuck: null,
	fuuuuck: null,
	fuck: null,
	fucka: null,
	fucked: null,
	fucker: null,
	fuckers: null,
	ffuck: null,
	fuckhead: null,
	fuckheads: null,
	fuckin: null,
	fucking: null,
	fuckings: null,
	fuckingshitmotherfucker: null,
	fuckk: null,
	fuckkkk: null,
	fuckkkkk: null,
	fuckkkkkk: null,
	fuckkks: null,
	fuckks: null,
	"fuckme ": null,
	fucks: null,
	fuckwhit: null,
	fuckwit: null,
	"fudge packer": null,
	fudgepacker: null,
	fuk: null,
	fuker: null,
	fukinn: null,
	fukinnn: null,
	fuking: null,
	fukk: null,
	fukkk: null,
	fukker: null,
	fukks: null,
	fukkin: null,
	fuks: null,
	fukwhit: null,
	fukwit: null,
	fux: null,
	fux0r: null,
	f_u_c_k: null,
	gangbang: null,
	"gangbanged ": null,
	"gangbangs ": null,
	gaylord: null,
	gaysex: null,
	givemehead: null,
	goatse: null,
	"god-dam": null,
	"god-damned": null,
	goddamn: null,
	goddamned: null,
	"hardcoresex ": null,
	hell: null,
	heshe: null,
	"hilter.wasright": null,
	hitler: null,
	hitlerwasright: null,
	hoar: null,
	hoare: null,
	hoer: null,
	homo: null,
	hore: null,
	horniest: null,
	horny: null,
	hotsex: null,
	"iwant.morehead": null,
	iwanthead: null,
	iwantmorehead: null,
	"jack-off ": null,
	jackoff: null,
	jap: null,
	"jerk-off ": null,
	jism: null,
	"jiz ": null,
	"jizm ": null,
	jizz: null,
	"jizz.le": null,
	jizzle: null,
	jizzing: null,
	kawk: null,
	knob: null,
	knobead: null,
	knobed: null,
	knobend: null,
	knobhead: null,
	knobjocky: null,
	knobjokey: null,
	kock: null,
	kondum: null,
	kondums: null,
	kum: null,
	kummer: null,
	kumming: null,
	kums: null,
	kunilingus: null,
	kiunt: null,
	kkk: null,
	"l3i+ch": null,
	l3itch: null,
	labia: null,
	lmfao: null,
	lust: null,
	lusting: null,
	m0f0: null,
	m0fo: null,
	m45terbate: null,
	ma5terb8: null,
	ma5terbate: null,
	masochist: null,
	"master-bate": null,
	masterb8: null,
	"masterbat*": null,
	masterbat3: null,
	masterbate: null,
	masterbation: null,
	masterbations: null,
	masturbate: null,
	"mo-fo": null,
	mof0: null,
	mofo: null,
	molest: null,
	molester: null,
	mothafuck: null,
	mothafucka: null,
	mothafuckas: null,
	mothafuckaz: null,
	"mothafucked ": null,
	mothafucker: null,
	mothafuckers: null,
	mothafuckin: null,
	"mothafucking ": null,
	mothafuckings: null,
	mothafucks: null,
	"mother fucker": null,
	motherfuck: null,
	motherfucked: null,
	motherfucker: null,
	motherfuckers: null,
	motherfuckin: null,
	motherfucking: null,
	motherfuckings: null,
	motherfuckka: null,
	motherfucks: null,
	muff: null,
	mutha: null,
	muthafecker: null,
	muthafuckker: null,
	muther: null,
	mutherfucker: null,
	n1gga: null,
	n1gger: null,
	nazi: null,
	nig: null,
	"nigg.r": null,
	nigg3r: null,
	nigg4h: null,
	nigga: null,
	niggah: null,
	niggas: null,
	niggaz: null,
	nigger: null,
	"niggers ": null,
	nigg: null,
	"nigg a": null,
	"nigg. a.": null,
	"nig r": null,
	"nig. r.": null,
	nob: null,
	"nob jockey": null,
	"nob jokey": null,
	nobhead: null,
	nobjocky: null,
	nobjokey: null,
	numbnuts: null,
	nutsack: null,
	"orgasim ": null,
	"orgasims ": null,
	orgasm: null,
	"orgasms ": null,
	p0rn: null,
	pawn: null,
	"peda.file": null,
	pedafile: null,
	pedo: null,
	pedofile: null,
	pecker: null,
	peni: null,
	penii: null,
	peniii: null,
	penis: null,
	penisfucker: null,
	phonesex: null,
	phuck: null,
	phuk: null,
	phuked: null,
	phuking: null,
	phukked: null,
	phukking: null,
	phuks: null,
	phuq: null,
	pigfucker: null,
	pimpis: null,
	piss: null,
	pissed: null,
	pisser: null,
	pissers: null,
	"pisses ": null,
	pissflaps: null,
	"pissin ": null,
	pissing: null,
	"pissoff ": null,
	poop: null,
	porn: null,
	porno: null,
	pornography: null,
	pornos: null,
	prick: null,
	"pricks ": null,
	pron: null,
	pube: null,
	pusse: null,
	pussi: null,
	pussies: null,
	pussy: null,
	"pussys ": null,
	rap: null,
	"rap.ist": null,
	rapist: null,
	rectum: null,
	retard: null,
	rimjaw: null,
	rimming: null,
	"s hit": null,
	"s.o.b.": null,
	sadist: null,
	schlong: null,
	screwing: null,
	scroat: null,
	scrote: null,
	scrotum: null,
	semen: null,
	sex: null,
	"sh!+": null,
	"sh!t": null,
	sh1t: null,
	shag: null,
	shagger: null,
	shaggin: null,
	shagging: null,
	shemale: null,
	"shi+": null,
	shit: null,
	shitdick: null,
	shite: null,
	shited: null,
	shitey: null,
	shitfuck: null,
	shitfull: null,
	shithead: null,
	shiting: null,
	shitings: null,
	shits: null,
	shitted: null,
	shitter: null,
	"shitters ": null,
	shitting: null,
	shittings: null,
	"shitty ": null,
	skank: null,
	slut: null,
	sluts: null,
	smegma: null,
	smut: null,
	snatch: null,
	"son-of-a-bitch": null,
	spac: null,
	spunk: null,
	s_h_i_t: null,
	t1tt1e5: null,
	t1tties: null,
	teets: null,
	teez: null,
	testical: null,
	testicle: null,
	tit: null,
	titfuck: null,
	tits: null,
	titt: null,
	tittie5: null,
	tittiefucker: null,
	titties: null,
	tittyfuck: null,
	tittywank: null,
	titwank: null,
	tosser: null,
	turd: null,
	tw4t: null,
	twat: null,
	twathead: null,
	twatty: null,
	twunt: null,
	twunter: null,
	uarcun: null,
	v14gra: null,
	v1gra: null,
	vagina: null,
	viagra: null,
	vulva: null,
	w00se: null,
	wang: null,
	wank: null,
	"wankk.r": null,
	wanker: null,
	wanky: null,
	whoar: null,
	whore: null,
	willies: null,
	willy: null,
	youracun: null,
	xrated: null,
	xxx: null
};
var profanityList = {
	en: en,
	uae: uae
};

var leetMap = {
  4: 'a',
  3: 'e',
  1: 'l',
  0: 'o',
  5: 's',
  '@': 'a',
  '!': 'i',
  $: 's'
};
var sanitizeWord = function sanitizeWord(word) {
  if (!word) return '';
  var cleanedWord = word.toLocaleLowerCase();
  for (var _char in leetMap) {
    var escapedChar = _char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var regex = new RegExp(escapedChar, 'g');
    cleanedWord = cleanedWord.replace(regex, leetMap[_char]);
  }
  cleanedWord = cleanedWord.replace(/[^a-z0-9\s]/gi, '');
  cleanedWord = cleanedWord.replace(/\s+/g, ' ').trim();
  return cleanedWord;
};
var sanitizeWordCompletely = function sanitizeWordCompletely(word) {
  var fullyCleaned = sanitizeWord(word).replace(/\s/g, '');
  return fullyCleaned;
};
var useProfanitySanitation = function useProfanitySanitation(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? profanityList : _ref$list;
  var isProfanityFilterEnabled = utilities.useSettingsAtPath({
    path: 'settings.modes.profanityFilter',
    defaultValue: false
  });
  var isProfane = React.useCallback(function (_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$word = _ref2.word,
      word = _ref2$word === void 0 ? '' : _ref2$word,
      _ref2$lang = _ref2.lang,
      lang = _ref2$lang === void 0 ? 'en' : _ref2$lang;
    if (!isProfanityFilterEnabled) return false;
    var currentProfanityList = list[lang] || {};
    var wordWithNormalizedSpaces = sanitizeWord(word);
    var wordWithoutSpacesAndPunctuation = sanitizeWordCompletely(word);
    if (wordWithoutSpacesAndPunctuation in currentProfanityList) {
      return true;
    }
    if (wordWithNormalizedSpaces in currentProfanityList) {
      return true;
    }
    for (var profaneWordInList in currentProfanityList) {
      var sanitizedProfaneWordInList = profaneWordInList.replace(/\s/g, '');
      if (wordWithoutSpacesAndPunctuation.includes(sanitizedProfaneWordInList)) {
        return true;
      }
    }
    return false;
  }, [isProfanityFilterEnabled, list]);
  return {
    isProfane: isProfane,
    list: list
  };
};

var setKeyboardConfig = /*#__PURE__*/xstate.assign(function (context, event) {
  return {
    onChange: event.onChange,
    maxLength: event.maxLength,
    inputName: event.inputName
  };
});
var customerDetailsService = function customerDetailsService(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'customerDetailsMachine' : _ref$id,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 'firstName' : _ref$initial;
  var customerDetailsMachine = xstate.Machine({
    id: id,
    initial: initial,
    states: {
      firstName: {
        on: {
          LAST_NAME: {
            target: 'lastName',
            actions: ['setKeyboardConfig']
          },
          EMAIL: {
            target: 'email',
            actions: ['setKeyboardConfig']
          },
          PHONE_NUMBER: {
            target: 'phoneNumber',
            actions: ['setKeyboardConfig']
          }
        }
      },
      lastName: {
        on: {
          FIRST_NAME: {
            target: 'firstName',
            actions: ['setKeyboardConfig']
          },
          EMAIL: {
            target: 'email',
            actions: ['setKeyboardConfig']
          },
          PHONE_NUMBER: {
            target: 'phoneNumber',
            actions: ['setKeyboardConfig']
          }
        }
      },
      fullName: {
        on: {
          PHONE_NUMBER: {
            target: 'phoneNumber',
            actions: ['setKeyboardConfig']
          },
          EMAIL: {
            target: 'email',
            actions: ['setKeyboardConfig']
          }
        }
      },
      phoneNumber: {
        on: {
          FULL_NAME: {
            target: 'fullName',
            actions: ['setKeyboardConfig']
          },
          EMAIL: {
            target: 'email',
            actions: ['setKeyboardConfig']
          }
        }
      },
      email: {
        on: {
          FULL_NAME: {
            target: 'fullName',
            actions: ['setKeyboardConfig']
          },
          FIRST_NAME: {
            target: 'firstName',
            actions: ['setKeyboardConfig']
          },
          LAST_NAME: {
            target: 'lastName',
            actions: ['setKeyboardConfig']
          },
          PHONE_NUMBER: {
            target: 'phoneNumber',
            actions: ['setKeyboardConfig']
          }
        }
      }
    }
  }, {
    actions: {
      setKeyboardConfig: setKeyboardConfig
    }
  });
  return {
    customerDetailsMachine: customerDetailsMachine
  };
};

var useCustomerDetailsView = function useCustomerDetailsView(_ref) {
  var _ref$isFirstNameRequi = _ref.isFirstNameRequired,
    isFirstNameRequired = _ref$isFirstNameRequi === void 0 ? false : _ref$isFirstNameRequi,
    _ref$isLastNameRequir = _ref.isLastNameRequired,
    isLastNameRequired = _ref$isLastNameRequir === void 0 ? false : _ref$isLastNameRequir,
    _ref$showCategoriesHe = _ref.showCategoriesHeader,
    showCategoriesHeader = _ref$showCategoriesHe === void 0 ? false : _ref$showCategoriesHe,
    _ref$displayRequiredL = _ref.displayRequiredLabel,
    displayRequiredLabel = _ref$displayRequiredL === void 0 ? true : _ref$displayRequiredL,
    _ref$showEmail = _ref.showEmail,
    showEmail = _ref$showEmail === void 0 ? true : _ref$showEmail,
    _ref$firstNameMaxLeng = _ref.firstNameMaxLength,
    firstNameMaxLength = _ref$firstNameMaxLeng === void 0 ? 64 : _ref$firstNameMaxLeng,
    _ref$showPrimaryActio = _ref.showPrimaryAction,
    showPrimaryAction = _ref$showPrimaryActio === void 0 ? false : _ref$showPrimaryActio,
    _ref$showSecondaryAct = _ref.showSecondaryAction,
    showSecondaryAction = _ref$showSecondaryAct === void 0 ? false : _ref$showSecondaryAct,
    _ref$showNameFields = _ref.showNameFields,
    showNameFields = _ref$showNameFields === void 0 ? true : _ref$showNameFields;
  var nextPath = '/validate';
  var previousPath = '/categories';
  var menuPath = '/categories';
  var layout = 'EN';
  var emailCodes = '@GMAIL.COM @HOTMAIL.COM @ICLOUD.COM ';
  var isFullNameRequired = false;
  var isEmailRequired = false;
  var isPhoneNumberRequired = false;
  var lastNameMaxLength = 1;
  var fullNameMaxLength = 64;
  var emailMaxLength = 64;
  var phoneNumberMaxLength = 12;
  var showFullNameField = false;
  var showPhoneNumberField = false;
  var showReceiveMarketingEmail = false;
  var showEmailDescription = true;
  var showSubtitle = true;
  var isEmailAutoFocus = false;
  var showNumbers = true;
  var showAsteriskOnRequiredFields = false;
  var showLoyaltyBanner = true;
  var _useState = React.useState(''),
    firstName = _useState[0],
    setFirstName = _useState[1];
  var _useState2 = React.useState(''),
    lastName = _useState2[0],
    setLastName = _useState2[1];
  var _useState3 = React.useState(''),
    fullName = _useState3[0],
    setFullName = _useState3[1];
  var _useState4 = React.useState(''),
    email = _useState4[0],
    setEmail = _useState4[1];
  var _useState5 = React.useState(''),
    phoneNumber = _useState5[0],
    setPhoneNumber = _useState5[1];
  var _useState6 = React.useState(false),
    receiveMarketingEmail = _useState6[0],
    setReceiveMarketingEmail = _useState6[1];
  var _useState7 = React.useState(''),
    inputError = _useState7[0],
    setInputError = _useState7[1];
  var _useState8 = React.useState(false),
    firstNameError = _useState8[0],
    setFirstNameError = _useState8[1];
  var _useState9 = React.useState(false),
    lastNameError = _useState9[0],
    setLastNameError = _useState9[1];
  var _useState10 = React.useState(false),
    fullNameError = _useState10[0],
    setFullNameError = _useState10[1];
  var _useState11 = React.useState(false),
    emailError = _useState11[0],
    setEmailError = _useState11[1];
  var _useState12 = React.useState(false),
    phoneNumberError = _useState12[0],
    setPhoneNumberError = _useState12[1];
  var _useState13 = React.useState(''),
    submitClass = _useState13[0],
    setSubmitClass = _useState13[1];
  var _useState14 = React.useState(true),
    allowSubmit = _useState14[0],
    setAllowSubmit = _useState14[1];
  var _useCustomer = useCustomer(),
    customer = _useCustomer.customer,
    setCustomer = _useCustomer.setCustomer;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var history = reactRouterDom.useHistory();
  var _customerDetailsServi = customerDetailsService(),
    customerDetailsMachine = _customerDetailsServi.customerDetailsMachine;
  var _useMachine = react.useMachine(customerDetailsMachine),
    customerDetailsMachineState = _useMachine[0],
    customerDetailsMachineSend = _useMachine[1];
  var setTemplate = recoil.useSetRecoilState(atoms.templateState);
  React.useEffect(function () {
    if (customer) history.push(nextPath);
  }, [customer, history, nextPath]);
  var _useProfanitySanitati = useProfanitySanitation(),
    isProfane = _useProfanitySanitati.isProfane;
  var title = t('customerDetailsTitle');
  var previousText = t('customerDetailsPreviousAction');
  var cancelOrderText = t('customerDetailsCancelOrderAction');
  var nextText = t('customerDetailsNextAction');
  var menuText = t('menuAction');
  var isOptional = !( isFirstNameRequired || isLastNameRequired);
  var firstNameLabel = t('customerDetailsFirstNameLabel', {
    required: displayRequiredLabel ? isFirstNameRequired ? t('customerDetailsRequired') : t('customerDetailsOptional') :  ''
  });
  var lastNameLabel = t('customerDetailsLastNameLabel', {
    required: displayRequiredLabel ? isLastNameRequired ? t('customerDetailsRequired') : t('customerDetailsOptional') :  ''
  });
  var fullNameLabel = t('customerDetailsFullNameLabel', {
    required: displayRequiredLabel ?  t('customerDetailsOptional') :  ''
  });
  var phoneNumberLabel = t('customerDetailsPhoneNumberLabel', {
    required: displayRequiredLabel ?  t('customerDetailsOptional') :  ''
  });
  var emailLabel = t('customerDetailsEmailLabel', {
    required: displayRequiredLabel ?  t('customerDetailsOptional') :  ''
  });
  var formatFirstNameSettings = function formatFirstNameSettings(settings) {
    if (settings === void 0) {
      settings = {
        inputName: 'firstName',
        maxLength: firstNameMaxLength,
        onChange: setFirstName,
        label: firstNameLabel.trim()
      };
    }
    return _extends({}, settings, {
      onFocus: function onFocus() {
        return customerDetailsMachineSend('FIRST_NAME', settings);
      }
    });
  };
  var formatLastNameSettings = function formatLastNameSettings(settings) {
    if (settings === void 0) {
      settings = {
        inputName: 'lastName',
        maxLength: lastNameMaxLength,
        onChange: setLastName,
        label: lastNameLabel.trim()
      };
    }
    return _extends({}, settings, {
      onFocus: function onFocus() {
        return customerDetailsMachineSend('LAST_NAME', settings);
      }
    });
  };
  var formatFullNameSettings = function formatFullNameSettings(settings) {
    if (settings === void 0) {
      settings = {
        inputName: 'fullName',
        maxLength: fullNameMaxLength,
        onChange: setFullName,
        label: fullNameLabel.trim()
      };
    }
    return _extends({}, settings, {
      onFocus: function onFocus() {
        return customerDetailsMachineSend('FULL_NAME', settings);
      }
    });
  };
  var formatPhoneNumberSettings = function formatPhoneNumberSettings(settings) {
    if (settings === void 0) {
      settings = {
        inputName: 'phoneNumber',
        maxLength: phoneNumberMaxLength,
        onChange: setPhoneNumber,
        label: phoneNumberLabel.trim()
      };
    }
    return _extends({}, settings, {
      onFocus: function onFocus() {
        return customerDetailsMachineSend('PHONE_NUMBER', settings);
      }
    });
  };
  var formatEmailSettings = function formatEmailSettings(settings) {
    if (settings === void 0) {
      settings = {
        inputName: 'email',
        maxLength: emailMaxLength,
        onChange: setEmail,
        label: emailLabel.trim()
      };
    }
    return _extends({}, settings, {
      onFocus: function onFocus() {
        return customerDetailsMachineSend('EMAIL', settings);
      }
    });
  };
  var formatReceiveMarketingEmailSettings = function formatReceiveMarketingEmailSettings(settings) {
    if (settings === void 0) {
      settings = {
        inputName: 'receiveMarketingEmail'
      };
    }
    return _extends({}, settings, {
      onChange: function onChange(_ref2) {
        var target = _ref2.target;
        return setReceiveMarketingEmail(target.checked);
      }
    });
  };
  var firstNameSettings = formatFirstNameSettings();
  var lastNameSettings = formatLastNameSettings();
  var fullNameSettings = formatFullNameSettings();
  var emailSettings = formatEmailSettings();
  var phoneNumberSettings = formatPhoneNumberSettings();
  var receiveMarketingEmailSettings = formatReceiveMarketingEmailSettings();
  var currentSettings = React.useMemo(function () {
    var _ref3 = customerDetailsMachineState || {},
      context = _ref3.context;
    var fallbackSettings =  showNameFields && firstNameSettings || showEmail && emailSettings || showPhoneNumberField  || context;
    var settings = context != null && context.inputName ? context : fallbackSettings;
    var _context$inputName = context.inputName,
      inputName = _context$inputName === void 0 ? settings.inputName : _context$inputName,
      _context$maxLength = context.maxLength,
      maxLength = _context$maxLength === void 0 ? settings.maxLength : _context$maxLength,
      _context$onChange = context.onChange,
      onChange = _context$onChange === void 0 ? settings.onChange : _context$onChange;
    return {
      inputName: inputName,
      maxLength: maxLength,
      onChange: onChange
    };
  }, [customerDetailsMachineState, firstNameSettings, fullNameSettings, phoneNumberSettings, showFullNameField, showPhoneNumberField, emailSettings, showEmail, showNameFields]);
  React.useEffect(function () {
    if (fullName.length > 0) {
      var trimmedFullName = fullName.trim().replace(/\s+/g, ' ');
      var firstSpaceIndex = trimmedFullName.indexOf(' ');
      if (firstSpaceIndex !== -1) {
        setFirstName(trimmedFullName.slice(0, firstSpaceIndex));
        setLastName(trimmedFullName.slice(firstSpaceIndex + 1));
      } else {
        setFirstName(trimmedFullName);
      }
    }
  }, [fullName, setFirstName, setLastName]);
  var onSubmit = React.useCallback(function () {
    setInputError('');
    setFirstNameError(false);
    setLastNameError(false);
    setFullNameError(false);
    setEmailError(false);
    var errorMessage = [];
    if (isProfane({
      word: firstName
    }) || isProfane({
      word: lastName
    }) || isProfane({
      word: firstName + " " + lastName
    }) || isProfane({
      word: fullName
    })) {
      if (fullName) {
        setFullNameError(true);
      } else {
        setFirstNameError(true);
      }
      errorMessage.push(t('customerDetailsProfaneInputError', {
        label: t('customerDetailsFirstNameLabel')
      }));
    }
    if (isThereSpecialCharacters(firstName) || isThereSpecialCharacters(lastName)) errorMessage.push(t('customerDetailsSpecialCharactersInputError', {
      label: t('customerDetailsFirstNameLabel')
    }));
    if (isFirstNameRequired && !isFullNameRequired && firstName.trim().length === 0) {
      setFirstNameError(true);
      errorMessage.push(t('customerDetailsInputRequiredError', {
        label: t('customerDetailsFirstNameLabel')
      }));
    }
    if (isLastNameRequired && lastName.trim().length === 0) {
      setLastNameError(true);
      errorMessage.push(t('customerDetailsInputRequiredError', {
        label: t('customerDetailsLastNameLabel')
      }));
    }
    if (email.length > 0 && !emailValidator.validate(email)) {
      setEmailError(true);
      if (t('customerDetailsCustomEmailError') !== 'customerDetailsCustomEmailError') {
        errorMessage.push(t('customerDetailsCustomEmailError'));
      } else {
        errorMessage.push(t('customerDetailsInputInvalidError', {
          label: t('customerDetailsEmailLabel')
        }));
      }
    }
    if (errorMessage.length) return setInputError(errorMessage.join('. '));
    setCustomer({
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNumber,
      receiveMarketingEmail: receiveMarketingEmail
    });
  }, [email, firstName, isEmailRequired, isFirstNameRequired, isLastNameRequired, lastName, phoneNumber, receiveMarketingEmail, setCustomer, setInputError, t, isProfane, setFirstNameError, setLastNameError, setEmailError, fullName, isFullNameRequired, isPhoneNumberRequired, setFullNameError, setPhoneNumberError]);
  var onSkip = React.useCallback(function () {
    setEmail('');
    setFirstName('');
    setLastName('');
    onSubmit();
  }, [setEmail, setFirstName, setLastName, onSubmit]);
  var previousAction = React.useCallback(function () {
    return history.push(previousPath);
  }, [previousPath, history]);
  var menuAction = React.useCallback(function () {
    return history.push(menuPath);
  }, [history, menuPath]);
  var validateOnChange = React.useCallback(function () {
    setInputError('');
    var errorMessage = [];
    if (isThereSpecialCharacters(firstName) || isThereSpecialCharacters(lastName)) {
      errorMessage.push(t('customerDetailsSpecialCharactersInputError', {
        label: t('customerDetailsFirstNameLabel')
      }));
    }
    if (errorMessage.length) return setInputError(errorMessage.join('. '));
  }, [t, firstName, lastName, setInputError]);
  React.useEffect(function () {
    validateOnChange();
  }, [email, firstName, lastName, validateOnChange]);
  React.useEffect(function () {
    if (email.length && !emailValidator.validate(email)) {
      setSubmitClass('opacity-50');
      setAllowSubmit(false);
      return;
    }
  }, [setSubmitClass, email, t, setAllowSubmit]);
  React.useEffect(function () {
    var firstNameValid = isFirstNameRequired ? firstName.length : true;
    var lastNameValid = isLastNameRequired ? lastName.length : true;
    var emailValid = email.length ? emailValidator.validate(email) : true;
    var phoneNumberValid =  true;
    var valid =  firstNameValid && lastNameValid && emailValid && phoneNumberValid && !isProfane({
      word: fullName
    }) && !isProfane({
      word: firstName
    }) && !isProfane({
      word: lastName
    }) && !isProfane({
      word: firstName + " " + lastName
    }) && !isThereSpecialCharacters(fullName) && !isThereSpecialCharacters(firstName) && !isThereSpecialCharacters(lastName) && !isThereSpecialCharacters(phoneNumber);
    var submitable = valid ? '' : 'opacity-50';
    setSubmitClass(submitable);
    setAllowSubmit(valid);
  }, [isFullNameRequired, isFirstNameRequired, isLastNameRequired, setSubmitClass, isEmailRequired, fullName, firstName, lastName, email, phoneNumber, setAllowSubmit, setInputError, isProfane, isPhoneNumberRequired]);
  React.useEffect(function () {
    var header = {
      title: title,
      previousAction: previousAction,
      previousText: previousText,
      menuAction: menuAction,
      menuText: menuText,
      isViewOrderDisabled: true,
      showCategoriesHeader: showCategoriesHeader,
      showBasketCount: false,
      showCouponButton: true,
      showLoyaltyBanner: showLoyaltyBanner,
      showOrderHistory: false
    };
    var footer = {
      enableCancelOrder: true,
      cancelOrderText: cancelOrderText,
      previousAction: previousAction,
      previousText: previousText,
      showBasketCount: false,
      showSubtotal: false,
      nextAction: onSubmit,
      nextText: nextText,
      allowNextAction: true,
      nextActionClass: submitClass,
      isViewOrderDisabled: true,
      showCouponButton: true,
      skipAction: showSecondaryAction && isOptional ? onSkip : null,
      t: t
    };
    setTemplate(function (template) {
      return _extends({}, template, {
        header: header,
        footer: footer
      });
    });
  }, [setTemplate, previousAction, title, previousText, cancelOrderText, submitClass, nextText, onSubmit, menuAction, menuText, showCategoriesHeader, showSecondaryAction, isOptional, onSkip, t, showLoyaltyBanner]);
  return {
    inputError: inputError,
    onSubmit: onSubmit,
    lastName: lastName,
    firstName: firstName,
    fullName: fullName,
    email: email,
    phoneNumber: phoneNumber,
    firstNameSettings: firstNameSettings,
    lastNameSettings: lastNameSettings,
    fullNameSettings: fullNameSettings,
    phoneNumberSettings: phoneNumberSettings,
    emailSettings: emailSettings,
    currentSettings: currentSettings,
    t: t,
    layout: layout,
    submitClass: submitClass,
    allowSubmit: allowSubmit,
    showPrimaryAction: showPrimaryAction,
    showEmail: showEmail,
    emailCodes: emailCodes,
    showSubtitle: showSubtitle,
    showNameFields: showNameFields,
    showFullNameField: showFullNameField,
    showPhoneNumberField: showPhoneNumberField,
    showEmailDescription: showEmailDescription,
    showReceiveMarketingEmail: showReceiveMarketingEmail,
    receiveMarketingEmail: receiveMarketingEmail,
    receiveMarketingEmailSettings: receiveMarketingEmailSettings,
    isEmailAutoFocus: isEmailAutoFocus,
    showSecondaryAction: showSecondaryAction,
    onSkip: onSkip,
    isOptional: isOptional,
    showNumbers: showNumbers,
    firstNameError: firstNameError,
    lastNameError: lastNameError,
    fullNameError: fullNameError,
    emailError: emailError,
    phoneNumberError: phoneNumberError,
    showAsteriskOnRequiredFields: showAsteriskOnRequiredFields
  };
};

var TransactionsViewContext = /*#__PURE__*/React.createContext();
var TransactionsViewProvider = function TransactionsViewProvider(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    children = _ref.children,
    _ref$showDotAfterInit = _ref.showDotAfterInitials,
    showDotAfterInitials = _ref$showDotAfterInit === void 0 ? false : _ref$showDotAfterInit,
    _ref$showFullFirstNam = _ref.showFullFirstName,
    showFullFirstName = _ref$showFullFirstNam === void 0 ? false : _ref$showFullFirstNam;
  var transactions$1 = recoil.useRecoilValue(atoms.transactionsState);
  var _useState = React.useState(transactions$1.length - 1),
    selectedTransactionIndex = _useState[0],
    setSelectedTransactionIndex = _useState[1];
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var history = reactRouterDom.useHistory();
  var settings = recoil.useRecoilValue(atoms.settingsState);
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _useSystem = useSystem(),
    port = _useSystem.port;
  var paymentData = recoil.useRecoilValue(atoms.paymentState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var _useState2 = React.useState(null),
    refundState = _useState2[0],
    setRefundState = _useState2[1];
  var _useState3 = React.useState(null),
    refundMachine = _useState3[0],
    setRefundMachine = _useState3[1];
  var provider = React.useMemo(function () {
    var _ref2 = paymentData || {},
      _ref2$paymentType = _ref2.paymentType,
      paymentType = _ref2$paymentType === void 0 ? 'card' : _ref2$paymentType;
    var isUsingProviders = paymentType === 'card';
    if (isUsingProviders) {
      var _settings$settings, _settings$settings$pa, _settings$settings2, _settings$settings2$p;
      if ((settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : (_settings$settings$pa = _settings$settings.payment) == null ? void 0 : _settings$settings$pa.provider) === 'ksa-mada') {
        return 'ksaMada';
      }
      return settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$p = _settings$settings2.payment) == null ? void 0 : _settings$settings2$p.provider;
    }
    return paymentType;
  }, [settings, paymentData]);
  var _ref3 = session || {},
    sessionId = _ref3.id;
  var _settings$settings3 = settings == null ? void 0 : settings.settings,
    payment = _settings$settings3.payment,
    mocks = _settings$settings3.mocks;
  var _mocks$payment = mocks.payment,
    isRefundMocked = _mocks$payment === void 0 ? false : _mocks$payment;
  var providerSettings = payment == null ? void 0 : payment[provider];
  var paymentSettings = _extends({}, providerSettings);
  var config = {
    settings: paymentSettings,
    port: port,
    sessionId: sessionId
  };
  var _useMemo = React.useMemo(function () {
      return transactions.buildPaymentHandlers({
        provider: provider,
        mock: isRefundMocked
      });
    }, [provider, isRefundMocked]),
    refund = _useMemo.refund;
  var _useTransactions = useTransactions(),
    updateTransaction = _useTransactions.updateTransaction,
    addTransaction = _useTransactions.addTransaction;
  var available = {
    transactions: transactions$1,
    selectedTransactionIndex: selectedTransactionIndex,
    setSelectedTransactionIndex: setSelectedTransactionIndex,
    t: t,
    history: history,
    settings: settings,
    formatPrice: formatPrice,
    config: config,
    refund: refund,
    refundState: refundState,
    setRefundState: setRefundState,
    refundMachine: refundMachine,
    setRefundMachine: setRefundMachine,
    updateTransaction: updateTransaction,
    addTransaction: addTransaction,
    showDotAfterInitials: showDotAfterInitials,
    showFullFirstName: showFullFirstName
  };
  return /*#__PURE__*/jsxRuntime.jsx(TransactionsViewContext.Provider, {
    value: available,
    children: children
  });
};
var useTransactionsViewContext = function useTransactionsViewContext() {
  var context = React.useContext(TransactionsViewContext);
  if (context === undefined) {
    throw new Error('useTransactionsViewContext must be used within a TransactionsViewProvider');
  }
  return context;
};

var ORDERFAILEDSTATE = {
  ORDER_REFUND_CANCELLED: 'ORDER_REFUND_CANCELLED',
  ORDER_CONFIRMATION_SUCCESS: 'ORDER_CONFIRMATION_SUCCESS'
};
var REFUND_STATUS = 'ORDER_REFUND_SUCCESS';
var useTransactionsView = function useTransactionsView() {
  var _useTransactionsViewC = useTransactionsViewContext(),
    transactions = _useTransactionsViewC.transactions,
    selectedTransactionIndex = _useTransactionsViewC.selectedTransactionIndex,
    setSelectedTransactionIndex = _useTransactionsViewC.setSelectedTransactionIndex,
    t = _useTransactionsViewC.t,
    history = _useTransactionsViewC.history,
    settings = _useTransactionsViewC.settings,
    formatPrice = _useTransactionsViewC.formatPrice,
    config = _useTransactionsViewC.config,
    refund = _useTransactionsViewC.refund,
    refundState = _useTransactionsViewC.refundState,
    setRefundState = _useTransactionsViewC.setRefundState,
    refundMachine = _useTransactionsViewC.refundMachine,
    setRefundMachine = _useTransactionsViewC.setRefundMachine,
    updateTransaction = _useTransactionsViewC.updateTransaction,
    addTransaction = _useTransactionsViewC.addTransaction,
    showDotAfterInitials = _useTransactionsViewC.showDotAfterInitials,
    showFullFirstName = _useTransactionsViewC.showFullFirstName;
  var timezone = settings == null ? void 0 : settings.timezone;
  var selectedTransaction = React.useMemo(function () {
    if (!transactions.length) return null;
    return transactions[selectedTransactionIndex];
  }, [selectedTransactionIndex, transactions]);
  var previousActionDisabled = React.useMemo(function () {
    return selectedTransactionIndex - 1 < 0;
  }, [selectedTransactionIndex]);
  var nextActionDisabled = React.useMemo(function () {
    return selectedTransactionIndex + 1 >= (transactions == null ? void 0 : transactions.length);
  }, [selectedTransactionIndex, transactions]);
  var orderReference = React.useMemo(function () {
    var _settings$settings, _selectedTransaction$, _settings$settings2, _settings$settings2$o, _settings$settings3, _settings$settings3$o;
    var _ref = (selectedTransaction == null ? void 0 : selectedTransaction.session) || {},
      customer = _ref.customer,
      beaconNumber = _ref.beaconNumber;
    var _ref2 = (settings == null ? void 0 : (_settings$settings = settings.settings) == null ? void 0 : _settings$settings.receipt) || {},
      _ref2$showInitials = _ref2.showInitials,
      showInitials = _ref2$showInitials === void 0 ? false : _ref2$showInitials;
    var shoulUseFullNameConfiguration = !showInitials ? showFullFirstName : false;
    var reference = getDisplayOrderNumber({
      beacon: beaconNumber,
      customer: customer,
      orderNumber: selectedTransaction == null ? void 0 : (_selectedTransaction$ = selectedTransaction.session) == null ? void 0 : _selectedTransaction$.orderNumber,
      aloha: (settings == null ? void 0 : (_settings$settings2 = settings.settings) == null ? void 0 : (_settings$settings2$o = _settings$settings2.order) == null ? void 0 : _settings$settings2$o.aloha) || {},
      oracleMicros: settings == null ? void 0 : (_settings$settings3 = settings.settings) == null ? void 0 : (_settings$settings3$o = _settings$settings3.order) == null ? void 0 : _settings$settings3$o.oracleMicros,
      showFullFirstName: shoulUseFullNameConfiguration,
      showDotAfterInitials: showDotAfterInitials
    });
    if (reference) return reference;
  }, [selectedTransaction, settings, showDotAfterInitials, showFullFirstName]);
  var _useState = React.useState(false),
    showLateRefundModal = _useState[0],
    setShowLateRefundModal = _useState[1];
  var _useState2 = React.useState(true),
    showLateRefundOption = _useState2[0],
    setShowLateRefundOption = _useState2[1];
  var _useState3 = React.useState(null),
    refundMachineConfig = _useState3[0],
    setRefundMachineConfig = _useState3[1];
  var _useState4 = React.useState(null),
    refundTransactionId = _useState4[0],
    setRefundTransactionId = _useState4[1];
  var _useState5 = React.useState(null),
    refundPaymentMethod = _useState5[0],
    setRefundPaymentMethod = _useState5[1];
  var _useState6 = React.useState(0),
    refundPaymentAmount = _useState6[0],
    setRefundPaymentAmount = _useState6[1];
  var _useState7 = React.useState(false),
    showRefundStates = _useState7[0],
    setShowRefundStates = _useState7[1];
  var _useState8 = React.useState(false),
    performChangeInTransaction = _useState8[0],
    setPerformChangeInTransaction = _useState8[1];
  var primaryAction = function primaryAction() {
    return history.push('/admin');
  };
  var showOriginalPriceForCombo = recoil.useRecoilValue(atoms.showOriginalPriceForComboState);
  var resetStates = function resetStates() {
    setRefundMachineConfig(null);
    setRefundPaymentMethod(null);
    setRefundTransactionId(null);
    setRefundPaymentAmount(0);
    setShowLateRefundOption(false);
  };
  var nextAction = function nextAction() {
    resetStates();
    setSelectedTransactionIndex(selectedTransactionIndex + 1);
  };
  var previousAction = function previousAction() {
    resetStates();
    setSelectedTransactionIndex(selectedTransactionIndex - 1);
  };
  React.useEffect(function () {
    var kasSettings = settings.settings;
    var paymentInfo = kasSettings.payment;
    var isLateRefundEnabled = paymentInfo.lateRefund;
    var _ref3 = selectedTransaction || {},
      status = _ref3.status,
      payment = _ref3.payment;
    if (isLateRefundEnabled && status in ORDERFAILEDSTATE && payment) {
      var amount = payment.amount,
        _payment$paymentMetho = payment.paymentMethod,
        paymentMethod = _payment$paymentMetho === void 0 ? 'qr' : _payment$paymentMetho,
        transactionId = payment.transactionId;
      var machineConfig = _extends({}, config, {
        amount: amount
      });
      setRefundMachineConfig(machineConfig);
      setRefundPaymentMethod(paymentMethod);
      setRefundTransactionId(transactionId);
      setRefundPaymentAmount(amount);
      setShowLateRefundOption(true);
    } else {
      resetStates();
    }
  }, [selectedTransactionIndex, config, settings, selectedTransaction]);
  var lateRefundAction = function lateRefundAction() {
    setShowLateRefundModal(!showLateRefundModal);
  };
  var closeRefundModal = function closeRefundModal() {
    setShowLateRefundModal(!showLateRefundModal);
  };
  var retryRefund = function retryRefund() {
    return refundMachine.send('RETRY', {
      transactionId: refundTransactionId,
      paymentMethod: refundPaymentMethod,
      config: _extends({}, refundMachineConfig)
    });
  };
  var cancelRefund = function cancelRefund() {
    return refundMachine.send('CANCEL');
  };
  var finishRefund = function finishRefund() {
    return history.goBack();
  };
  var triggerLateRefund = function triggerLateRefund() {
    setShowRefundStates(true);
    closeRefundModal();
    var _refund = refund({
        transactionId: refundTransactionId,
        paymentMethod: refundPaymentMethod,
        config: _extends({}, refundMachineConfig),
        transition: function transition(machine) {
          return setRefundState(machine);
        }
      }),
      refundMachine = _refund.refundMachine;
    setRefundMachine(refundMachine);
    setPerformChangeInTransaction(true);
  };
  React.useEffect(function () {
    if (!showRefundStates) return;
    if (!performChangeInTransaction) return;
    if (!(refundState != null && refundState.matches('success'))) return;
    var session = selectedTransaction.session;
    var _ref4 = session || {},
      receiptId = _ref4.receiptId;
    var context = refundState.context;
    var _ref5 = context || {},
      info = _ref5.info,
      request = _ref5.request;
    var _ref6 = request || {},
      paymentMethod = _ref6.paymentMethod;
    var refundInformation = _extends({}, info, {
      paymentMethod: paymentMethod,
      paymentType: 'CARD'
    });
    var updatedTransaction = _extends({}, selectedTransaction, {
      status: REFUND_STATUS
    });
    updateTransaction({
      transactionToUpdate: updatedTransaction
    });
    addTransaction({
      status: REFUND_STATUS,
      receiptId: receiptId,
      useExistingCart: true,
      currentTransaction: selectedTransaction,
      refundInformation: refundInformation
    });
    setPerformChangeInTransaction(false);
  }, [refundState, showRefundStates, performChangeInTransaction, updateTransaction, addTransaction, selectedTransaction]);
  return {
    previousAction: previousAction,
    nextAction: nextAction,
    previousActionDisabled: previousActionDisabled,
    nextActionDisabled: nextActionDisabled,
    t: t,
    selectedTransaction: selectedTransaction,
    primaryAction: primaryAction,
    timezone: timezone,
    transactions: transactions,
    formatPrice: formatPrice,
    orderReference: orderReference,
    showLateRefundModal: showLateRefundModal,
    showLateRefundOption: showLateRefundOption,
    lateRefundAction: lateRefundAction,
    closeRefundModal: closeRefundModal,
    triggerLateRefund: triggerLateRefund,
    refundPaymentAmount: refundPaymentAmount,
    refundState: refundState,
    showRefundStates: showRefundStates,
    finishRefund: finishRefund,
    retryRefund: retryRefund,
    cancelRefund: cancelRefund,
    showOriginalPriceForCombo: showOriginalPriceForCombo
  };
};

var SummaryField = function SummaryField(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: className,
    "data-test": "summary-field",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "text-gray-500  text-xl md:text-2xl font-medium uppercase",
      "data-test": "summary-field-title",
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: " text-2xl md:text-3xl break-words",
      "data-test": "summary-field-text",
      children: text
    })]
  });
};

var SummarySection = function SummarySection(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$rightTitle = _ref.rightTitle,
    rightTitle = _ref$rightTitle === void 0 ? '' : _ref$rightTitle;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-wrap w-full shadow-lg summary-section p-2 md:p-4 " + className,
    "data-test": "summary-section",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-wrap justify-between w-full p-2 md:p-4 space-x-4 text-2xl md:text-4xl font-bold uppercase",
      children: [title && /*#__PURE__*/jsxRuntime.jsx("div", {
        children: title
      }), rightTitle && /*#__PURE__*/jsxRuntime.jsx("div", {
        children: rightTitle
      })]
    }), children]
  });
};

var TransactionsIdentity = function TransactionsIdentity(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$session = _ref.session,
    session = _ref$session === void 0 ? {} : _ref$session,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? '' : _ref$message,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    _ref$orderReference = _ref.orderReference,
    orderReference = _ref$orderReference === void 0 ? '' : _ref$orderReference,
    timezone = _ref.timezone;
  var _ref2 = session || {},
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? '' : _ref2$id,
    _ref2$timestamp = _ref2.timestamp,
    timestamp = _ref2$timestamp === void 0 ? '' : _ref2$timestamp,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? '' : _ref2$type;
  var formattedTimestamp = timestamp ? utilities.getFormattedDateTime({
    currentTimestamp: timestamp,
    timezone: timezone
  }) : '';
  var showQRCode = utilities.isShowQRCode({
    status: status
  });
  var orderType = type === 'DINE_IN' ? t('receiptDineIn') : t('receiptTakeaway');
  return /*#__PURE__*/jsxRuntime.jsx(SummarySection, {
    title: t('transactionsIdentityTitle'),
    className: className,
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "grid grid-cols-2 md:grid-cols-3",
      "data-test": "transactions-identity",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-wrap col-span-2",
        children: [/*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsIdentityId'),
          text: id,
          className: "p-4 md:w-1/2"
        }), /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsIdentityStatus'),
          text: t(status),
          className: "p-4 md:w-1/2"
        }), /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsIdentityTimestamp'),
          text: formattedTimestamp,
          className: "p-4 md:w-1/2"
        }), /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsIdentityType'),
          text: orderType,
          className: "p-4 md:w-1/2"
        }), !!orderReference && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsIdentityOrderReference'),
          text: orderReference,
          className: "p-4 md:w-1/2"
        }), message && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsIdentityMessage'),
          text: message,
          className: "w-full p-4 text-red-600"
        })]
      }), showQRCode && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "col-span-2 pb-4 pl-16 pr-0 md:col-auto",
        children: /*#__PURE__*/jsxRuntime.jsx(ReceiptQRCode, {
          customSession: session
        })
      })]
    })
  });
};

var TransactionsNavigator = function TransactionsNavigator(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$nextAction = _ref.nextAction,
    nextAction = _ref$nextAction === void 0 ? function () {} : _ref$nextAction,
    _ref$nextActionDisabl = _ref.nextActionDisabled,
    nextActionDisabled = _ref$nextActionDisabl === void 0 ? false : _ref$nextActionDisabl,
    _ref$previousAction = _ref.previousAction,
    previousAction = _ref$previousAction === void 0 ? function () {} : _ref$previousAction,
    _ref$previousActionDi = _ref.previousActionDisabled,
    previousActionDisabled = _ref$previousActionDi === void 0 ? false : _ref$previousActionDi,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex justify-between w-full " + className,
    "data-test": "transactions-navigator",
    children: [/*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
      className: "admin-button",
      onClick: previousAction,
      disabled: previousActionDisabled,
      children: t('transactionsNavigatorPreviousAction')
    }), /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
      className: "admin-button",
      onClick: nextAction,
      disabled: nextActionDisabled,
      children: t('transactionsNavigatorNextAction')
    })]
  });
};

var getPaymentTypeTitle = function getPaymentTypeTitle(paymentType) {
  switch (paymentType) {
    case 'CARD':
      return 'paymentOptionsCARDTitle';
    case 'MOMOPAY':
      return 'paymentOptionsMOMOPAYTitle';
    case 'CASH':
    default:
      return 'paymentOptionsCASHTitle';
  }
};

var TransactionsPayment = function TransactionsPayment(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    payment = _ref.payment,
    total = _ref.total,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var _ref2 = payment || {},
    paymentType = _ref2.paymentType,
    amount = _ref2.amount,
    authCode = _ref2.authCode,
    cardNumber = _ref2.cardNumber,
    transactionId = _ref2.transactionId,
    cardType = _ref2.cardType;
  var formattedTotal = formatPrice({
    price: total || 0
  });
  var formattedAmount = amount ? formatPrice({
    price: amount
  }) : null;
  var showCardInfo = paymentType === 'CARD';
  var paymentTypeTitle = getPaymentTypeTitle(paymentType);
  return /*#__PURE__*/jsxRuntime.jsxs(SummarySection, {
    title: t('transactionsPaymentTitle'),
    rightTitle: formattedTotal,
    className: className,
    children: [!payment && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "p-4 text-4xl",
      children: t('transactionsPaymentNoPaymentFound')
    }), payment && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-wrap w-full",
      "data-test": "transactions-payment",
      children: [/*#__PURE__*/jsxRuntime.jsx(SummaryField, {
        title: t('transactionsPaymentType'),
        text: t(paymentTypeTitle),
        className: "w-1/3 p-4"
      }), showCardInfo && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [cardType && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsPaymentCardType'),
          text: cardType,
          className: "w-1/3 p-4"
        }), formattedAmount && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsPaymentAmount'),
          text: formattedAmount,
          className: "w-1/3 p-4"
        }), authCode && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsPaymentAuthCode'),
          text: authCode,
          className: "w-1/3 p-4"
        }), cardNumber && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsPaymentCardNumber'),
          text: cardNumber,
          className: "w-1/3 p-4"
        }), transactionId && /*#__PURE__*/jsxRuntime.jsx(SummaryField, {
          title: t('transactionsPaymentTransactionId'),
          text: transactionId,
          className: "w-1/3 p-4"
        })]
      })]
    })]
  });
};

var currencySymbol$1 = process.env.POI_APP_CURRENCY_SYMBOL || null;
var LateRefundModal = function LateRefundModal(_ref) {
  var _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$refundAmount = _ref.refundAmount,
    refundAmount = _ref$refundAmount === void 0 ? '' : _ref$refundAmount,
    _ref$Modal = _ref.Modal,
    Modal$1 = _ref$Modal === void 0 ? Modal : _ref$Modal;
  return /*#__PURE__*/jsxRuntime.jsx(Modal$1, {
    "data-test": "late-refund-modal",
    open: true,
    title: t('transactionsLateRefund'),
    closeText: t('transactionsLateRefundFalse'),
    closeModal: onClose,
    action: onConfirm,
    actionText: t('transactionsLateRefundTrue'),
    children: /*#__PURE__*/jsxRuntime.jsxs("p", {
      className: "text-3xl p-8 modal-text modal-content",
      children: [t('transactionLateRefundModalText'), " ", refundAmount, " ", currencySymbol$1, " ?"]
    })
  });
};

var TransactionsView = function TransactionsView() {
  var _selectedTransaction$;
  var _useTransactionsView = useTransactionsView(),
    nextAction = _useTransactionsView.nextAction,
    previousAction = _useTransactionsView.previousAction,
    nextActionDisabled = _useTransactionsView.nextActionDisabled,
    previousActionDisabled = _useTransactionsView.previousActionDisabled,
    t = _useTransactionsView.t,
    selectedTransaction = _useTransactionsView.selectedTransaction,
    primaryAction = _useTransactionsView.primaryAction,
    timezone = _useTransactionsView.timezone,
    transactions = _useTransactionsView.transactions,
    formatPrice = _useTransactionsView.formatPrice,
    orderReference = _useTransactionsView.orderReference,
    showLateRefundModal = _useTransactionsView.showLateRefundModal,
    showLateRefundOption = _useTransactionsView.showLateRefundOption,
    lateRefundAction = _useTransactionsView.lateRefundAction,
    closeRefundModal = _useTransactionsView.closeRefundModal,
    triggerLateRefund = _useTransactionsView.triggerLateRefund,
    refundPaymentAmount = _useTransactionsView.refundPaymentAmount,
    refundState = _useTransactionsView.refundState,
    showRefundStates = _useTransactionsView.showRefundStates,
    finishRefund = _useTransactionsView.finishRefund,
    retryRefund = _useTransactionsView.retryRefund,
    cancelRefund = _useTransactionsView.cancelRefund,
    showOriginalPriceForCombo = _useTransactionsView.showOriginalPriceForCombo;
  if (!transactions.length) return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "flex flex-col items-center justify-center w-full h-full",
    children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
      message: t('transactionsNotFound'),
      onCancelText: t('transactionsPrimaryAction'),
      onCancelAction: primaryAction
    })
  });
  if (showRefundStates && refundState != null && refundState.matches('loading')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "refund-page-loading",
    className: "flex items-center justify-center flex-grow h-full",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center h-full p-2 md:p-8",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mt-8 text-3xl font-bold text-center uppercase md:my-16 md:text-5xl",
        children: t('refundLoadingTitle')
      }), /*#__PURE__*/jsxRuntime.jsx(SvgPinPad, {
        className: "block mb-32 h-1/2"
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mb-32 text-3xl font-bold text-center uppercase md:text-5xl",
        children: t('refundInstructions')
      }), /*#__PURE__*/jsxRuntime.jsx(ChevronDown, {
        className: "w-32 h-32 animate-bounce text-primary"
      })]
    })
  });
  if (showRefundStates && refundState != null && refundState.matches('success')) return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "refund-page-success",
    className: "flex items-center justify-center flex-grow h-full refund-success",
    children: /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center h-full p-2 md:p-8",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        className: "my-8 text-3xl font-bold text-center uppercase md:my-16 md:text-5xl",
        children: t('refundSuccessTitle')
      }), /*#__PURE__*/jsxRuntime.jsx(SvgPinPad, {
        className: "block mb-32 h-1/2"
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "mb-32 text-3xl font-bold text-center uppercase md:text-5xl",
        children: t('refundSuccessMessage')
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        onClick: finishRefund,
        children: t('refundSuccessButton')
      })]
    })
  });
  if (showRefundStates && refundState != null && refundState.matches('failure')) {
    var _refundState$context;
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "refund-page-error",
      className: "flex items-center justify-center flex-grow h-full refund-page-error",
      children: /*#__PURE__*/jsxRuntime.jsx(Alert, {
        type: "danger",
        message: t('transactionLateRefundFailedMessage'),
        detail: refundState == null ? void 0 : (_refundState$context = refundState.context) == null ? void 0 : _refundState$context.message,
        onRetryText: t('refundRetryMessage'),
        onRetryAction: retryRefund,
        onCancelAction: cancelRefund,
        onCancelText: t('refundCancelMessage')
      })
    });
  }
  if (showRefundStates && refundState != null && refundState.matches('cancelled')) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "refund-page-cancelled",
      className: "flex items-center justify-center flex-grow md:h-full",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-center justify-center h-full p-2 md:p-8",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "mb-4 text-3xl font-bold text-center uppercase md:mb-32 md:text-5xl",
          children: t('transactionLateRefundCancelledMessage')
        }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
          className: "mt-4 md:mt-8 home-primary-button",
          onClick: finishRefund,
          children: t('refundCancelButton')
        })]
      })
    });
  }
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex flex-col w-full h-full transactions-view",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col w-full p-2 space-y-4 md:p-8 md:space-y-8",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "w-full text-4xl font-bold text-center uppercase md:text-6xl",
        children: t('transactionsTitle')
      }), /*#__PURE__*/jsxRuntime.jsx(TransactionsNavigator, {
        nextAction: nextAction,
        previousAction: previousAction,
        nextActionDisabled: nextActionDisabled,
        previousActionDisabled: previousActionDisabled,
        t: t
      }), /*#__PURE__*/jsxRuntime.jsx(TransactionsIdentity, {
        t: t,
        session: selectedTransaction == null ? void 0 : selectedTransaction.session,
        message: selectedTransaction == null ? void 0 : selectedTransaction.message,
        status: selectedTransaction == null ? void 0 : selectedTransaction.status,
        orderReference: orderReference,
        timezone: timezone
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col w-full p-2 space-y-4 md:h-full md:p-8 md:space-y-8 md:overflow-y-auto",
      children: selectedTransaction == null ? void 0 : (_selectedTransaction$ = selectedTransaction.cart) == null ? void 0 : _selectedTransaction$.map(function (product, index) {
        return /*#__PURE__*/jsxRuntime.jsx(CartViewProduct, {
          product: product,
          t: t,
          boxClassName: "shadow-lg",
          formatPrice: formatPrice,
          showOriginalPriceForCombo: showOriginalPriceForCombo
        }, index);
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col w-full p-2 space-y-4 md:p-8 md:space-y-8",
      children: [/*#__PURE__*/jsxRuntime.jsx(TransactionsPayment, {
        t: t,
        payment: selectedTransaction == null ? void 0 : selectedTransaction.payment,
        total: selectedTransaction == null ? void 0 : selectedTransaction.total
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex justify-center mt-4 md:mt-8",
        children: showLateRefundOption && /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
          onClick: lateRefundAction,
          className: "home-primary-button",
          children: t('transactionsLateRefund')
        })
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "flex justify-center mt-4 md:mt-8",
        children: /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
          onClick: primaryAction,
          className: "home-primary-button",
          children: t('transactionsPrimaryAction')
        })
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      children: showLateRefundModal && /*#__PURE__*/jsxRuntime.jsx(LateRefundModal, {
        t: t,
        onClose: closeRefundModal,
        onConfirm: triggerLateRefund,
        refundAmount: refundPaymentAmount
      })
    })]
  });
};

var _defs$1, _g$2;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 542 175.11"
  }, props), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_svg__a",
    x1: 30.38,
    y1: 89.82,
    x2: 539.13,
    y2: 93.17,
    gradientTransform: "matrix(1 0 0 -1 0 180.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d429b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_svg__b",
    x1: 30.37,
    y1: 91.05,
    x2: 539.12,
    y2: 94.4,
    xlinkHref: "#visa_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_svg__c",
    x1: 30.36,
    y1: 92.6,
    x2: 539.11,
    y2: 95.95,
    xlinkHref: "#visa_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa_svg__d",
    x1: 30.37,
    y1: 91.46,
    x2: 539.12,
    y2: 94.81,
    xlinkHref: "#visa_svg__a"
  }))), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542 172.3h-40.8c-1.5-7.2-3.1-14.2-4.4-21.3-.5-2.9-1.5-4.1-4.7-4-16.4.2-32.7.2-49.1 0-2.5 0-3.5.8-4.2 3.1q-3.45 10.05-7.2 20.1c-.3.9-1.5 2.1-2.3 2.1-14.7.1-29.5.1-44.7.1 2.8-6.7 5.4-13 8-19.4q28.5-68.1 57.1-136.1C453.8 7.1 460 3 470.6 3h35.8c1.2 5.5 2.4 11 3.5 16.4Q524 86.6 538 153.9c1.2 5.7 2.6 11.4 3.9 17.2a4.87 4.87 0 01.1 1.2zm-53.4-60.1c-4.3-20.8-8.6-41.4-12.9-62a4.33 4.33 0 01-.5-.1c-7.5 20.6-14.9 41.2-22.5 62.1z",
    fill: "url(#visa_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.2 0c5.4 1 10.8 1.8 16.1 3.1 4.9 1.1 9.6 2.7 14.8 4.2-2.6 12.2-5.1 24.1-7.6 35.7-6.8-2-13.3-4.3-20-5.8-9.2-2-18.6-2.8-27.7-.2a27.46 27.46 0 00-10.4 5.5c-5 4.3-5.1 10.5-.3 15a59.89 59.89 0 0011.2 8c8.9 5.4 18.3 10 27 15.8 10.2 6.8 17.7 16 19.2 28.6 2.8 22.2-5.4 39.7-24.1 52.1-11.7 7.8-25 11.3-38.8 12.5a139.89 139.89 0 01-56.7-6.4c-1.2-.4-2.4-.9-3.6-1.4a3.55 3.55 0 01-1.2-.8c2.6-12.2 5.2-24.4 7.9-37 3.1 1.4 6.1 2.7 9.1 4 14.4 5.8 29.3 8.5 44.7 5.6a32.35 32.35 0 0011.5-4.8c7.4-4.9 8.1-14.2 1.4-20.1-4.4-3.8-9.7-6.6-14.8-9.7-7.9-4.8-16.2-8.9-23.7-14.2-9.5-6.9-16.4-16-17.8-28.2-2-18.2 4.8-33 18.8-44.5 12.2-10 26.6-14.5 42-16.3a18.29 18.29 0 002.5-.6c6.9-.1 13.7-.1 20.5-.1z",
    fill: "url(#visa_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6 3.2c-2.3 5.5-4.5 10.8-6.7 16Q167.4 94.35 136 169.5c-1 2.4-2.2 3-4.6 3-13.3-.1-26.5-.2-39.8 0-2.8 0-3.7-.9-4.4-3.5C76 125.3 64.6 81.5 53.5 37.7c-2-8-6.1-13.5-13.8-16.9a221.67 221.67 0 00-38-12.3C1.1 8.4.6 8.2 0 8.1.1 3 .1 3 4.9 3h69.6c11 0 19 6.4 21 17.3 5.9 30.8 11.6 61.7 17.5 92.5.3 1.3.5 2.7.9 4.6.6-1.1 1-1.8 1.3-2.5q21.6-54.6 43.1-109.3c.8-2 1.7-2.7 3.9-2.6 13.5.1 26.9.1 40.4.1a15.76 15.76 0 013 .1z",
    fill: "url(#visa_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 172.4c12.1-56.6 24.1-112.8 36.2-169.2h43.9c-1.8 8.6-3.6 17-5.4 25.4q-15 69.9-29.8 139.7c-.7 3.2-1.8 4.3-5.2 4.2-12-.2-24.1-.1-36.1-.1z",
    fill: "url(#visa_svg__d)"
  })))));
}

var _defs$2, _path$6, _path2$4, _path3$3;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.39 86.9"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mastercard_svg__e{fill:#f79e1b}"))), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M48.37 15.14h34.66v56.61H48.37z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.94 43.45a35.94 35.94 0 0113.75-28.3 36 36 0 100 56.61 35.94 35.94 0 01-13.75-28.31z",
    fill: "#eb001b"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    className: "mastercard_svg__e",
    d: "M120.5 65.76V64.6h.5v-.24h-1.19v.24h.47v1.16zm2.31 0v-1.4h-.36l-.42 1-.42-1h-.36v1.4h.26V64.7l.39.91h.27l.39-.91v1.06zM123.94 43.45a36 36 0 01-58.25 28.3 36 36 0 000-56.61 36 36 0 0158.25 28.3z"
  })));
}

var _path$7, _path2$5, _path3$4, _path4$3, _path5$1;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    fill: "#A1A1A1",
    className: "google-pay_svg__main-header__logo-image",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435.97 173.13"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.2 84.58v50.75h-16.1V10h42.7a38.61 38.61 0 0127.65 10.85A34.88 34.88 0 01272 47.3a34.72 34.72 0 01-11.55 26.6q-11.2 10.68-27.65 10.67h-26.6zm0-59.15v43.75h27a21.28 21.28 0 0015.93-6.48 21.36 21.36 0 000-30.63 21 21 0 00-15.93-6.65h-27zM309.1 46.78q17.85 0 28.18 9.54t10.32 26.16v52.85h-15.4v-11.9h-.7q-10 14.7-26.6 14.7-14.17 0-23.71-8.4a26.82 26.82 0 01-9.54-21q0-13.31 10.06-21.17t26.86-7.88q14.34 0 23.62 5.25v-3.68A18.33 18.33 0 00325.54 67 22.8 22.8 0 00310 61.13q-13.49 0-21.35 11.38l-14.18-8.93q11.7-16.8 34.63-16.8zm-20.83 62.3a12.86 12.86 0 005.34 10.5 19.64 19.64 0 0012.51 4.2 25.67 25.67 0 0018.11-7.52q8-7.53 8-17.67-7.53-6-21-6-9.81 0-16.36 4.73c-4.41 3.2-6.6 7.09-6.6 11.76zM436 49.58l-53.76 123.55h-16.62l19.95-43.23-35.35-80.32h17.5l25.55 61.6h.35l24.85-61.6z",
    fill: "#5f6368"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.14 73.64A85.79 85.79 0 00139.9 59H72v27.73h38.89a33.33 33.33 0 01-14.38 21.88v18h23.21c13.59-12.53 21.42-31.06 21.42-52.97z",
    fill: "#4285f4"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 144c19.43 0 35.79-6.38 47.72-17.38l-23.21-18C90.05 113 81.73 115.5 72 115.5c-18.78 0-34.72-12.66-40.42-29.72H7.67v18.55A72 72 0 0072 144z",
    fill: "#34a853"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.58 85.78a43.14 43.14 0 010-27.56V39.67H7.67a72 72 0 000 64.66z",
    fill: "#fbbc04"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28.5a39.09 39.09 0 0127.62 10.8l20.55-20.55A69.18 69.18 0 0072 0 72 72 0 007.67 39.67l23.91 18.55C37.28 41.16 53.22 28.5 72 28.5z",
    fill: "#ea4335"
  })));
}

var _path$8;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function SvgContactlessCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313.581 186.091"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.993 185.818c-37.375-3.276-70.355-17.141-91.835-38.606-12.238-12.23-19.662-25.496-23.018-41.135-1.527-7.114-1.519-18.92.018-26.094 4.658-21.744 18.709-40.765 40.835-55.274 50.462-33.091 127.764-32.925 177.75.383 6.64 4.424 10.927 7.936 16.933 13.867 7.579 7.485 12.908 14.92 18.531 25.855.208.405 1.239.916 2.291 1.134 3.545.736 8.27 3.496 12.08 7.053 2.951 2.756 5.24 5.762 10.875 14.283 5.682 8.591 31.403 48.309 32.967 50.907.608 1.01-.594 2.635-1.95 2.635-.962 0-1.646-.641-3.065-2.875a9107.217 9107.217 0 00-14.579-22.625c-24.818-38.44-26.168-40.224-33.08-43.681l-3.636-1.819h-10.673c-10.659 0-10.674.001-10.933 1.125-1.417 6.149-1.676 7.655-1.368 7.941.197.183 6.254 3.632 13.459 7.665l13.102 7.333-.819 1.718c-.451.945-.968 1.718-1.15 1.718-.182 0-11.207-6.104-24.5-13.566s-24.946-13.78-25.895-14.042c-3.781-1.044-9.589 3.145-9.589 6.916 0 3.82 1.134 4.934 24.489 24.06 14.573 11.934 22.908 19.103 24.181 20.797 2.316 3.082 4.657 7.623 6.817 13.223 3.797 9.845 9.972 15.338 20.099 17.878l3.335.836-.281 1.824c-.155 1.003-.369 1.926-.477 2.049-.428.492-7.144-1.651-11.031-3.518-6.077-2.92-10.25-7.08-14.354-14.304-.03-.053-2.411.763-5.292 1.813-5.116 1.866-5.35 2.02-10.183 6.736-20.598 20.099-50.137 32.942-85.804 37.308-5.781.708-28.092 1.021-34.25.482zm35.5-6.189c16.365-2.159 29.054-5.41 42.337-10.848 13.942-5.708 27.088-13.91 36.287-22.641l3.625-3.44-9.125-4.359c-9.749-4.658-10.709-5.43-11.958-9.594-.788-2.63.104-5.423 2.593-8.124l1.94-2.105-4.229-3.212c-3.348-2.543-4.398-3.656-5.042-5.342-1.042-2.728-.666-5.679 1.026-8.057l1.286-1.808-13.371-2.353c-7.354-1.293-14.209-2.599-15.233-2.902-2.005-.592-4.045-2.872-4.573-5.109-.284-1.2 6.269-33.195 7.733-37.759.655-2.043 3.456-4.512 5.566-4.907 2.21-.414 41.621 6.514 43.583 7.661 3.106 1.815 4.088 4.733 3.103 9.221l-.412 1.875 2.181-.003c1.199-.001 4.039-.147 6.309-.324l4.128-.322-2.047-3.8c-6.199-11.509-17.391-23.086-31.209-32.284-6.447-4.292-20.213-11.072-28.5-14.04-11.783-4.218-26.044-7.378-39.75-8.807-7.516-.783-27.203-.772-34.5.02-17.489 1.897-33.375 5.856-47.26 11.775-32.145 13.706-53.759 36.41-59.292 62.286-1.446 6.763-1.559 18.601-.236 24.75 2.926 13.596 9.313 25.365 19.712 36.32 21.18 22.314 53.531 36.021 92.328 39.121 5.194.415 27.715-.191 33-.889zm-7.084-24.351c-2.001-.579-4.029-2.96-4.455-5.233-.278-1.48.061-2.507 2.182-6.61 8.571-16.58 12.296-31.838 12.296-50.358 0-17.898-3.298-31.824-11.491-48.515-1.759-3.583-3.198-6.91-3.198-7.391 0-1.776 1.486-4.351 3.095-5.361 2.207-1.385 5.905-1.126 7.675.536.68.639 2.448 3.541 3.928 6.447 5.862 11.511 9.879 24.14 11.862 37.285 1.227 8.135 1.471 23.553.491 31-1.809 13.738-5.435 25.996-11.241 38.005-3.509 7.259-5.712 10.245-7.556 10.245-.369 0-.971.092-1.337.205-.368.111-1.38-.003-2.251-.255zm-23.857-12.481c-3.069-.893-5.282-4.658-4.395-7.479.215-.683 1.66-3.829 3.21-6.991 6.565-13.388 9.296-27.74 7.958-41.831-1.1-11.578-3.175-18.88-8.402-29.564-3.507-7.168-3.67-8.279-1.631-11.165 1.939-2.744 6.778-3.189 9.32-.857 1.762 1.616 7.242 13.06 9.357 19.541 7 21.448 5.932 44.472-3.039 65.542-4.595 10.793-7.821 14.13-12.378 12.804zM95.95 130.14c-1.896-.855-3.528-2.86-3.972-4.881-.271-1.231.195-2.593 2.445-7.149 8.263-16.735 8.352-32.854.272-49.2-3.548-7.179-3.626-8.608-.625-11.439 1.481-1.397 2.11-1.644 4.19-1.644 3.489 0 5.298 1.753 8.416 8.157 4.795 9.85 6.758 18.395 6.742 29.343-.017 11.253-1.852 18.978-6.975 29.365-2.934 5.947-4.384 7.517-7.321 7.92-.896.123-2.323-.09-3.172-.472zm-22.957-11.79c-1.502-.622-3.217-2.666-3.727-4.443-.569-1.986-.103-3.562 2.152-7.27 2.9-4.769 3.575-7.328 3.575-13.561 0-6.232-.675-8.792-3.575-13.561-.983-1.617-1.97-3.554-2.194-4.305-.934-3.143 1.685-6.995 5.203-7.655 2.982-.56 5.03.771 7.772 5.051 7.939 12.392 7.938 28.946-.004 41.233-2.801 4.335-5.925 5.867-9.202 4.511zm171.039 19.25c2.656-.949 4.952-1.848 5.101-1.997.149-.149-.363-1.847-1.139-3.773-1.592-3.955-1.334-3.853-6.986-2.771-6.103 1.168-9.646.127-16.326-4.792-1.821-1.341-3.7-2.439-4.174-2.439-.475 0-1.516.699-2.314 1.553-1.712 1.833-1.97 4.704-.576 6.402 1.212 1.476 17.987 9.458 19.979 9.506.883.02 3.778-.739 6.435-1.689zm-2.64-12.839c2.487-.5 2.76-.671 2.333-1.468-.477-.892-23.679-20.148-25.691-21.324-1.661-.969-3.009-.744-4.386.732-4.03 4.321-3.56 5.226 6.879 13.23 12.589 9.653 13.933 10.223 20.865 8.83zm-31.149-29.155c0-.121-2.632-2.388-5.848-5.036-7.947-6.543-9.652-8.985-9.652-13.824 0-4.04 2.695-7.943 7.034-10.187 2.154-1.114 5.994-1.466 8.167-.749 1.537.507 8.466 4.256 18.074 9.777l2.024 1.163 1.668-7.911c1.708-8.102 1.739-10.226.158-10.719-.481-.15-9.742-1.833-20.581-3.74-19.246-3.386-21.346-3.588-22.242-2.138-.477.771-7.799 34.704-7.8 36.147-.001.722.366 1.619.816 1.992.449.373 6.693 1.73 13.875 3.016 13.876 2.485 14.307 2.552 14.307 2.209z"
  })));
}

var _path$9;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 210.2"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6 27.1C87.6 34.2 78 39.8 68.4 39c-1.2-9.6 3.5-19.8 9-26.1 6-7.3 16.5-12.5 25-12.9 1 10-2.9 19.8-8.8 27.1m8.7 13.8c-13.9-.8-25.8 7.9-32.4 7.9-6.7 0-16.8-7.5-27.8-7.3-14.3.2-27.6 8.3-34.9 21.2-15 25.8-3.9 64 10.6 85 7.1 10.4 15.6 21.8 26.8 21.4 10.6-.4 14.8-6.9 27.6-6.9 12.9 0 16.6 6.9 27.8 6.7 11.6-.2 18.9-10.4 26-20.8 8.1-11.8 11.4-23.3 11.6-23.9-.2-.2-22.4-8.7-22.6-34.3-.2-21.4 17.5-31.6 18.3-32.2-10-14.8-25.6-16.4-31-16.8m80.3-29v155.9h24.2v-53.3h33.5c30.6 0 52.1-21 52.1-51.4s-21.1-51.2-51.3-51.2h-58.5zm24.2 20.4h27.9c21 0 33 11.2 33 30.9s-12 31-33.1 31h-27.8V32.3zM336.6 169c15.2 0 29.3-7.7 35.7-19.9h.5v18.7h22.4V90.2c0-22.5-18-37-45.7-37-25.7 0-44.7 14.7-45.4 34.9h21.8c1.8-9.6 10.7-15.9 22.9-15.9 14.8 0 23.1 6.9 23.1 19.6v8.6l-30.2 1.8c-28.1 1.7-43.3 13.2-43.3 33.2 0 20.2 15.7 33.6 38.2 33.6zm6.5-18.5c-12.9 0-21.1-6.2-21.1-15.7 0-9.8 7.9-15.5 23-16.4l26.9-1.7v8.8c0 14.6-12.4 25-28.8 25zm82 59.7c23.6 0 34.7-9 44.4-36.3L512 54.7h-24.6l-28.5 92.1h-.5l-28.5-92.1h-25.3l41 113.5-2.2 6.9c-3.7 11.7-9.7 16.2-20.4 16.2-1.9 0-5.6-.2-7.1-.4v18.7c1.4.4 7.4.6 9.2.6z"
  })));
}

var _path$a, _path2$6;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.764 291.764"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M18.235 41.025h255.294c10.066 0 18.235 8.169 18.235 18.244v173.235c0 10.066-8.169 18.235-18.235 18.235H18.235C8.16 250.74 0 242.57 0 232.505V59.269c0-10.075 8.169-18.244 18.235-18.244z",
    fill: "#26a6d1"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.047 113.966l-28.812 63.76h34.492l4.276-10.166h9.774l4.276 10.166h37.966v-7.759l3.383 7.759h19.639l3.383-7.923v7.923h78.959l9.601-9.902 8.99 9.902 40.555.082-28.903-31.784 28.903-32.058h-39.926l-9.346 9.719-8.707-9.719h-85.897l-7.376 16.457-7.549-16.457h-34.42v7.495l-3.829-7.495H47.047zm6.674 9.054h16.813l19.111 43.236V123.02h18.418l14.761 31 13.604-31h18.326v45.752h-11.151l-.091-35.851-16.257 35.851h-9.975l-16.348-35.851v35.851h-22.94l-4.349-10.257H50.147l-4.34 10.248H33.516l20.205-45.743zm111.235 0h45.342L224.166 138l14.315-14.98h13.868l-21.071 22.995 21.071 22.73h-14.497l-13.868-15.154-14.388 15.154h-44.64V123.02zM61.9 130.761l-7.741 18.272h15.473L61.9 130.761zm114.253 1.732v8.352h24.736v9.309h-24.736v9.118h27.745l12.892-13.43-12.345-13.357h-28.292v.008z",
    fill: "#fff"
  })));
}

var _defs$3, _g$3;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function SvgInterac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.271 174.274"
  }, props), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "interac_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h174.271v174.274H0z"
  })))), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#interac_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.996 2.97h140.277a14.029 14.029 0 0114.03 14.028v140.28a14.028 14.028 0 01-14.029 14.027H16.994A14.026 14.026 0 012.968 157.28V16.997A14.028 14.028 0 0116.996 2.97z",
    fill: "#fdb913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.276 2.969a14.03 14.03 0 0114.026 14.029v140.279a14.029 14.029 0 01-14.026 14.028H16.997a14.025 14.025 0 01-14.028-14.028V16.998A14.026 14.026 0 0116.997 2.969h140.279m0-2.969H16.997A17.015 17.015 0 000 16.998v140.279a17.016 17.016 0 0016.997 16.997h140.279a17.015 17.015 0 0016.995-16.997V16.998A17.014 17.014 0 00157.276 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.958 88.954l-.014-30.139 7.867-1.867V60.9s2.038-5.196 6.767-6.402a4.528 4.528 0 012.188-.147v7.69a11.023 11.023 0 00-4.122.858c-2.907 1.148-4.37 3.653-4.37 7.477l.005 16.642zM55.487 98.755s-1.28-1.918-1.28-8.7V75.05l-4.047.963V69.83l4.057-.958v-6.74l8.365-1.975v6.739l5.91-1.404v6.175l-5.91 1.403s-.01 12.295 0 15.28c0 6.949 1.844 8.283 1.844 8.283zM69.367 80.825c0-5.358.763-9.267 2.401-12.267 1.95-3.56 5.145-5.88 9.801-6.94 9.177-2.087 12.49 3.345 12.361 10.629-.049 2.605-.037 3.874-.037 3.874l-16.168 3.8v.26c0 5.09 1.067 7.505 4.292 6.82 2.786-.587 3.561-2.332 3.781-4.49.036-.348.053-1.233.053-1.233l7.574-1.815s.018.62.007 1.316c-.066 2.892-.907 10.066-11.434 12.555-9.972 2.367-12.63-3.723-12.63-12.51m12.537-13.592c-2.679.608-4.084 3.236-4.145 7.59l8.133-1.937c.014-.197.016-.631.014-1.311-.014-3.287-1.03-5.022-4.002-4.342M142.08 63.2c-.314-9.179 2.067-16.464 12.308-18.784 6.527-1.483 9.006.215 10.261 1.856 1.207 1.566 1.673 3.678 1.673 6.636l.007.543-8.012 1.904-.006-1.115c.006-3.508-.969-4.842-3.517-4.204-3.03.761-4.254 3.637-4.254 9.355 0 2.03.01 2.394.01 2.668 0 5.811.793 8.471 4.285 7.74 3.03-.626 3.444-3.286 3.493-5.618.006-.366.021-1.538.021-1.538l8-1.89s.008.591.008 1.248c-.02 7.62-4.036 12.422-11.56 14.173-10.366 2.43-12.396-3.56-12.718-12.974M114.383 76.051c0-6.982 4.09-9.19 10.246-11.737 5.536-2.29 5.656-3.427 5.679-5.417.03-1.675-.746-3.108-3.502-2.405a4.16 4.16 0 00-3.336 3.943 14.368 14.368 0 00-.052 1.547l-7.762 1.833a15.442 15.442 0 01.536-4.586c1.24-4.175 4.923-6.984 11.279-8.455 8.258-1.903 11.01 1.721 11.02 7.358v13.349c0 6.456 1.199 7.402 1.199 7.402l-7.62 1.803a16.56 16.56 0 01-1.021-2.737s-1.67 4.204-7.423 5.556c-6.043 1.425-9.243-2.32-9.243-7.454m15.872-9.534a28.771 28.771 0 01-4.054 2.374c-2.54 1.241-3.688 2.772-3.688 5.13 0 2.042 1.265 3.383 3.564 2.815 2.466-.622 4.178-2.923 4.178-6.12zM11.749 119.882a4.837 4.837 0 01-4.053-7.468l.054-.07.09-.024 11.379-2.686v8.641l-.177.041a396.424 396.424 0 01-6.301 1.463 4.758 4.758 0 01-.992.103M11.749 130.936a4.83 4.83 0 01-4.831-4.825 4.779 4.779 0 01.778-2.627l.054-.08.09-.024 11.379-2.685v8.641l-.177.046c-2.581.62-5.666 1.334-6.301 1.461a5.116 5.116 0 01-.992.093M11.749 142.012a4.834 4.834 0 01-4.831-4.83 4.762 4.762 0 01.778-2.626l.054-.087 11.469-2.703v8.64l-.177.047c-2.726.656-5.753 1.34-6.301 1.46a5.04 5.04 0 01-.992.099M10.406 109.294l-.003-48.349 8.815-2.083v48.348l-8.812 2.084zM32.362 105.18a5.439 5.439 0 10-10.877 0l.01 45.19a14.744 14.744 0 0014.715 14.726c4.117 0 15.395-.02 15.395-.02l.005-18.852.005-21.023a7.12 7.12 0 00-3.163-5.927l-13.72-9.32-.004 21.163a1.17 1.17 0 11-2.34 0c0-.227-.026-23.141-.026-25.936M39.707 71.465a11.892 11.892 0 00-7.846 6.066v-3.398l-7.937 1.878.01 21.7a8.12 8.12 0 018.356 1.461v-14.01c0-3.357 1.67-6.038 4.056-6.564 1.795-.394 3.294.248 3.294 3.445l.006 20.442 8.36-1.96V78.9c0-5.243-2.019-8.908-8.299-7.435M161.173 40.52a5.168 5.168 0 115.163-5.164 5.17 5.17 0 01-5.163 5.165m0-9.685a4.519 4.519 0 104.518 4.52 4.524 4.524 0 00-4.518-4.52",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.291 32.277h2.227a1.456 1.456 0 011.601 1.62c0 .819-.363 1.448-1.05 1.555v.012c.625.064.954.409.986 1.296.012.4.018.896.037 1.282a.65.65 0 00.3.545h-1.139a1.05 1.05 0 01-.17-.56c-.035-.377-.026-.733-.043-1.191-.017-.688-.228-.99-.919-.99h-.824v2.74h-1.006zm1.812 2.81a.928.928 0 001.007-1.023c0-.673-.29-1.027-.954-1.027h-.859v2.05z",
    fill: "#231f20"
  }))));
}

var PayIcons = {
  visa: /*#__PURE__*/jsxRuntime.jsx(SvgVisa, {}),
  mastercard: /*#__PURE__*/jsxRuntime.jsx(SvgMastercard, {}),
  google: /*#__PURE__*/jsxRuntime.jsx(SvgGooglePay, {}),
  paywave: /*#__PURE__*/jsxRuntime.jsx(SvgContactlessCard, {}),
  apple: /*#__PURE__*/jsxRuntime.jsx(SvgApplePay, {}),
  amex: /*#__PURE__*/jsxRuntime.jsx(SvgAmex, {}),
  interac: /*#__PURE__*/jsxRuntime.jsx(SvgInterac, {})
};

var PaymentMethods = function PaymentMethods(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? null : _ref$t,
    _ref$cash = _ref.cash,
    cash = _ref$cash === void 0 ? null : _ref$cash,
    _ref$card = _ref.card,
    card = _ref$card === void 0 ? null : _ref$card,
    _ref$momopay = _ref.momopay,
    momopay = _ref$momopay === void 0 ? null : _ref$momopay,
    _ref$icons = _ref.icons,
    icons = _ref$icons === void 0 ? [] : _ref$icons,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$enableIcons = _ref.enableIcons,
    enableIcons = _ref$enableIcons === void 0 ? true : _ref$enableIcons,
    _ref$enableLogo = _ref.enableLogo,
    enableLogo = _ref$enableLogo === void 0 ? true : _ref$enableLogo,
    _ref$Logo = _ref.Logo,
    Logo = _ref$Logo === void 0 ? null : _ref$Logo;
  validation$1.validate({
    name: 'PaymentMethods',
    parameters: {
      t: t
    }
  });
  var IconsList = icons.map(function (icon) {
    return icon in PayIcons ? /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-" + icon,
      className: "flex self-center w-12 mx-1 md:w-20 md:h-20",
      children: PayIcons[icon]
    }, icon + "-icon") : null;
  }).filter(function (e) {
    return e;
  });
  var showIcons = enableIcons && IconsList.length;
  var Icons = showIcons ? /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "flex flex-row",
    children: IconsList
  }) : null;
  if (showIcons) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-methods",
      className: className,
      children: Icons
    });
  }
  if (card) {
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-methods",
      className: className,
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "self-center",
        children: t('paymentMethodCard')
      })
    });
  }
  if (cash || momopay) {
    var isImagePath = function isImagePath() {
      var imageExtensions = /\.(png|jpe?g)$/i;
      return imageExtensions.test(Logo);
    };
    return /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "payment-methods",
      className: className,
      children: Logo && enableLogo ? isImagePath() ? /*#__PURE__*/jsxRuntime.jsx("img", {
        "data-test": "logo",
        alt: "Logo",
        src: Logo
      }) : /*#__PURE__*/jsxRuntime.jsx(Logo, {
        "data-test": "logo",
        className: "w-48 h-48"
      }) : null
    });
  }
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "payment-methods",
    className: className,
    children: Icons
  });
};

var SummaryField$1 = function SummaryField(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'summary-field--default' : _ref$className;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "summary-field " + className,
    "data-test": "summary-field",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "summary-field__title",
      "data-test": "summary-field-title",
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "summary-field__text",
      "data-test": "summary-field-text",
      children: text
    })]
  });
};

var Spinner$1 = function Spinner(_ref) {
  var isFirstLoad = _ref.isFirstLoad;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "loading-wrapper-spinner sk-chase " + (isFirstLoad && 'mt-8'),
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "sk-chase-dot"
    })]
  });
};
var useFormattedMessages$1 = function useFormattedMessages(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    title = _ref2.title,
    message = _ref2.message,
    isFirstLoad = _ref2.isFirstLoad;
  if (title === '' && message === '' && isFirstLoad === false) {
    var _useLocaleSelection = useLocaleSelection(),
      t = _useLocaleSelection.t;
    var formattedTitle = t('defaultLoadingTitle');
    var formattedMessage = t('defaultLoadingMessage');
    return {
      formattedTitle: formattedTitle,
      formattedMessage: formattedMessage
    };
  }
  return {
    formattedTitle: title,
    formattedMessage: message
  };
};
var Loading$1 = function Loading(_temp2) {
  var _ref3 = _temp2 === void 0 ? {} : _temp2,
    _ref3$dataTest = _ref3['data-test'],
    dataTest = _ref3$dataTest === void 0 ? 'loading' : _ref3$dataTest,
    _ref3$title = _ref3.title,
    title = _ref3$title === void 0 ? '' : _ref3$title,
    _ref3$message = _ref3.message,
    message = _ref3$message === void 0 ? '' : _ref3$message,
    _ref3$Image = _ref3.Image,
    Image = _ref3$Image === void 0 ? null : _ref3$Image,
    _ref3$isFirstLoad = _ref3.isFirstLoad,
    isFirstLoad = _ref3$isFirstLoad === void 0 ? false : _ref3$isFirstLoad;
  var _useFormattedMessages = useFormattedMessages$1({
      title: title,
      message: message,
      isFirstLoad: isFirstLoad
    }),
    formattedTitle = _useFormattedMessages.formattedTitle,
    formattedMessage = _useFormattedMessages.formattedMessage;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: "loading-wrapper",
    children: [!isFirstLoad && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "loading-wrapper-title",
      children: formattedTitle
    }), Image ? /*#__PURE__*/jsxRuntime.jsx(Image, {
      className: "loading-wrapper-image"
    }) : /*#__PURE__*/jsxRuntime.jsx(Spinner$1, {
      isFirstLoad: true
    }), !isFirstLoad && /*#__PURE__*/jsxRuntime.jsx("p", {
      className: "loading-wrapper-message",
      children: formattedMessage
    })]
  });
};

var UpsellGallery = function UpsellGallery(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    title = _ref.title,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    emptyMessage = _ref.emptyMessage,
    emptyAction = _ref.emptyAction,
    emptyActionText = _ref.emptyActionText,
    upsellGroupedItems = _ref.upsellGroupedItems,
    galleryCardButtonActionText = _ref.galleryCardButtonActionText,
    isConcatUpsellProductsEnabled = _ref.isConcatUpsellProductsEnabled,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  var showUpsellCards = items.some(function (item) {
    var _item$products;
    return (item == null ? void 0 : (_item$products = item.products) == null ? void 0 : _item$products.length) > 0;
  });
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "upsell-gallery",
    className: "flex flex-col w-full",
    children: [!showUpsellCards && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-center justify-center w-full mb-8 ",
      "data-test": "add-more-panel",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "mb-4 text-2xl font-bold md:text-4xl",
        children: emptyMessage
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
        onClick: emptyAction,
        children: emptyActionText
      })]
    }), showUpsellCards && isConcatUpsellProductsEnabled ? /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-start justify-center w-full",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "px-2 text-xl xs:text-3xl md:text-5xl md:px-8 font-header upsell-gallery-header",
        children: title
      }), /*#__PURE__*/jsxRuntime.jsx(Gallery, {
        items: upsellGroupedItems,
        enableGalleryCardActionButton: true,
        galleryCardButtonActionText: galleryCardButtonActionText,
        formatPrice: formatPrice,
        showAddonAvailability: showAddonAvailability,
        t: t
      })]
    }) : items.filter(function (item) {
      var _item$products2;
      return (item == null ? void 0 : (_item$products2 = item.products) == null ? void 0 : _item$products2.length) || false;
    }).map(function (_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
        itemTitle = _ref2.title,
        products = _ref2.products,
        id = _ref2.id;
      return /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-start justify-center w-full",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          className: "px-2 text-2xl font-bold xs:text-4xl md:text-6xl md:px-8",
          children: itemTitle
        }), /*#__PURE__*/jsxRuntime.jsx(Gallery, {
          items: products,
          enableGalleryCardActionButton: true,
          galleryCardButtonActionText: galleryCardButtonActionText,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          t: t
        })]
      }, id);
    })]
  });
};

var UpsellGallery$1 = function UpsellGallery(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    title = _ref.title,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    emptyMessage = _ref.emptyMessage,
    emptyAction = _ref.emptyAction,
    emptyActionText = _ref.emptyActionText,
    upsellGroupedItems = _ref.upsellGroupedItems,
    galleryCardButtonActionText = _ref.galleryCardButtonActionText,
    isConcatUpsellProductsEnabled = _ref.isConcatUpsellProductsEnabled,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  var showUpsellCards = items.some(function (item) {
    var _item$products;
    return (item == null ? void 0 : (_item$products = item.products) == null ? void 0 : _item$products.length) > 0;
  });
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "upsell-gallery",
    className: "upsell-gallery",
    children: [!showUpsellCards && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "upsell-gallery__empty-state",
      "data-test": "add-more-panel",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "upsell-gallery__empty-message",
        children: emptyMessage
      }), /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
        onClick: emptyAction,
        children: emptyActionText
      })]
    }), showUpsellCards && isConcatUpsellProductsEnabled ? /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "upsell-gallery__group",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "upsell-gallery__heading",
        children: title
      }), /*#__PURE__*/jsxRuntime.jsx(Gallery, {
        items: upsellGroupedItems,
        enableGalleryCardActionButton: true,
        galleryCardButtonActionText: galleryCardButtonActionText,
        formatPrice: formatPrice,
        showAddonAvailability: showAddonAvailability,
        t: t
      })]
    }) : items.filter(function (item) {
      var _item$products2;
      return item == null ? void 0 : (_item$products2 = item.products) == null ? void 0 : _item$products2.length;
    }).map(function (_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
        itemTitle = _ref2.title,
        products = _ref2.products,
        id = _ref2.id;
      return /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "upsell-gallery__group",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          className: "upsell-gallery__subheading",
          children: itemTitle
        }), /*#__PURE__*/jsxRuntime.jsx(Gallery, {
          items: products,
          enableGalleryCardActionButton: true,
          galleryCardButtonActionText: galleryCardButtonActionText,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          t: t
        })]
      }, id);
    })]
  });
};

var CrossSellGallery = function CrossSellGallery(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    galleryCardButtonActionText = _ref.galleryCardButtonActionText,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showCrossSellCat = _ref.showCrossSellCategoryTitle,
    showCrossSellCategoryTitle = _ref$showCrossSellCat === void 0 ? false : _ref$showCrossSellCat,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "upsell-gallery",
    className: "flex flex-col w-full",
    children: items.filter(function (item) {
      var _item$products;
      return (item == null ? void 0 : (_item$products = item.products) == null ? void 0 : _item$products.length) || false;
    }).map(function (_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
        itemTitle = _ref2.title,
        products = _ref2.products,
        id = _ref2.id;
      return /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col items-start justify-center w-full",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          className: "px-2 text-2xl font-bold xs:text-4xl md:text-6xl md:px-8",
          children: showCrossSellCategoryTitle ? itemTitle : "We think you'll love these..."
        }), /*#__PURE__*/jsxRuntime.jsx(Gallery, {
          items: lodash.compact(products),
          enableGalleryCardActionButton: true,
          galleryCardButtonActionText: galleryCardButtonActionText,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          t: t
        })]
      }, id);
    })
  });
};

var CrossSellGallery$1 = function CrossSellGallery(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    galleryCardButtonActionText = _ref.galleryCardButtonActionText,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showCrossSellCat = _ref.showCrossSellCategoryTitle,
    showCrossSellCategoryTitle = _ref$showCrossSellCat === void 0 ? false : _ref$showCrossSellCat,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "upsell-gallery",
    className: "cross-sell-gallery",
    children: items.filter(function (item) {
      var _item$products;
      return (item == null ? void 0 : (_item$products = item.products) == null ? void 0 : _item$products.length) || false;
    }).map(function (_temp2) {
      var _ref2 = _temp2 === void 0 ? {} : _temp2,
        itemTitle = _ref2.title,
        products = _ref2.products,
        id = _ref2.id;
      return /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "cross-sell-gallery__group",
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          className: "cross-sell-gallery__heading",
          children: showCrossSellCategoryTitle ? itemTitle : "We think you'll love these..."
        }), /*#__PURE__*/jsxRuntime.jsx(Gallery, {
          items: lodash.compact(products),
          enableGalleryCardActionButton: true,
          galleryCardButtonActionText: galleryCardButtonActionText,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          t: t
        })]
      }, id);
    })
  });
};

var Alert$1 = function Alert(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$dataTest = _ref["data-test"],
    dataTest = _ref$dataTest === void 0 ? "alert" : _ref$dataTest,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "information" : _ref$type,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? null : _ref$message,
    _ref$additionalMessag = _ref.additionalMessage,
    additionalMessage = _ref$additionalMessag === void 0 ? null : _ref$additionalMessag,
    _ref$detail = _ref.detail,
    detail = _ref$detail === void 0 ? null : _ref$detail,
    _ref$onRetryAction = _ref.onRetryAction,
    onRetryAction = _ref$onRetryAction === void 0 ? null : _ref$onRetryAction,
    _ref$onRetryText = _ref.onRetryText,
    onRetryText = _ref$onRetryText === void 0 ? "Retry" : _ref$onRetryText,
    _ref$onCancelAction = _ref.onCancelAction,
    onCancelAction = _ref$onCancelAction === void 0 ? null : _ref$onCancelAction,
    _ref$onCancelText = _ref.onCancelText,
    onCancelText = _ref$onCancelText === void 0 ? "Cancel" : _ref$onCancelText;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: "alert " + (type === "danger" ? "alert--danger" : ""),
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "alert-content",
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "alert-message",
        children: message
      }), additionalMessage && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "alert-additional-message",
        children: additionalMessage
      }), detail && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "alert-message-details",
        children: detail
      })]
    }), (onRetryAction || onCancelAction || children) && /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "alert-actions",
      className: "alert-actions",
      children: [onRetryAction && /*#__PURE__*/jsxRuntime.jsx(PrimaryButtonLarge, {
        className: "home-primary-button",
        onClick: onRetryAction,
        children: onRetryText
      }), onCancelAction && /*#__PURE__*/jsxRuntime.jsx(SecondaryButtonLarge, {
        className: "home-primary-button",
        onClick: onCancelAction,
        children: onCancelText
      }), children]
    })]
  });
};

var Modal$1 = function Modal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'modal' : _ref$dataTest,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'modal--inset' : _ref$className,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? null : _ref$action,
    _ref$actionText = _ref.actionText,
    actionText = _ref$actionText === void 0 ? null : _ref$actionText,
    _ref$allowAction = _ref.allowAction,
    allowAction = _ref$allowAction === void 0 ? true : _ref$allowAction,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$ModalHeader = _ref.ModalHeader,
    ModalHeader$1 = _ref$ModalHeader === void 0 ? ModalHeader : _ref$ModalHeader,
    _ref$ModalFooter = _ref.ModalFooter,
    ModalFooter$1 = _ref$ModalFooter === void 0 ? ModalFooter : _ref$ModalFooter,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? null : _ref$closeModal,
    _ref$closeText = _ref.closeText,
    closeText = _ref$closeText === void 0 ? null : _ref$closeText,
    _ref$spacer = _ref.spacer,
    spacer = _ref$spacer === void 0 ? null : _ref$spacer,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$loadingTitle = _ref.loadingTitle,
    loadingTitle = _ref$loadingTitle === void 0 ? ' ' : _ref$loadingTitle,
    _ref$loadingMessage = _ref.loadingMessage,
    loadingMessage = _ref$loadingMessage === void 0 ? ' ' : _ref$loadingMessage,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$contentContainer = _ref.contentContainerClassName,
    contentContainerClassName = _ref$contentContainer === void 0 ? '' : _ref$contentContainer,
    _ref$modalClassName = _ref.modalClassName,
    modalClassName = _ref$modalClassName === void 0 ? '' : _ref$modalClassName;
  if (!open) return null;
  var hasActions = (!!action || !!closeModal) && ModalFooter$1 !== null;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": dataTest,
    className: classNames('modal', modalClassName, className),
    children: [isLoading && /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "container-loading-modal",
      className: "modal__container--loading",
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "modal__loading-content",
        children: /*#__PURE__*/jsxRuntime.jsx(Loading$1, {
          title: loadingTitle,
          message: loadingMessage
        })
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "container-content-modal",
      className: classNames('modal__container--content', contentContainerClassName, "" + (isLoading ? 'modal__container--hidden' : '')),
      children: [title && /*#__PURE__*/jsxRuntime.jsx(ModalHeader$1, {
        title: title,
        formatPrice: formatPrice
      }), children, hasActions && /*#__PURE__*/jsxRuntime.jsx(ModalFooter$1, {
        action: action,
        actionText: actionText,
        allowAction: allowAction,
        closeModal: closeModal,
        closeText: closeText,
        spacer: spacer
      })]
    })]
  });
};

var getPromoQty$1 = function getPromoQty(promoItem, product) {
  return promoItem.promoId === product.providerData.PromoId && product.count.current;
};
var CartUnitPrice$1 = function CartUnitPrice(_ref) {
  var promoItem = _ref.promoItem,
    unitPrice = _ref.unitPrice,
    t = _ref.t,
    formatPrice = _ref.formatPrice;
  var formattedPrice = t('cartProductUnitPriceEach', {
    price: formatPrice({
      price: unitPrice
    })
  });
  if (promoItem) {
    if (unitPrice) {
      return /*#__PURE__*/jsxRuntime.jsx("span", {
        children: formattedPrice
      });
    }
    return null;
  }
  return /*#__PURE__*/jsxRuntime.jsx("span", {
    children: formattedPrice
  });
};
var CartProduct$1 = function CartProduct(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? null : _ref2$product,
    _ref2$changeText = _ref2.changeText,
    changeText = _ref2$changeText === void 0 ? 'Change' : _ref2$changeText,
    _ref2$removeText = _ref2.removeText,
    removeText = _ref2$removeText === void 0 ? 'Remove' : _ref2$removeText,
    _ref2$onEditProductHa = _ref2.onEditProductHandler,
    onEditProductHandler = _ref2$onEditProductHa === void 0 ? function () {
      return function () {};
    } : _ref2$onEditProductHa,
    _ref2$formatPrice = _ref2.formatPrice,
    formatPrice = _ref2$formatPrice === void 0 ? function () {} : _ref2$formatPrice,
    _ref2$t = _ref2.t,
    t = _ref2$t === void 0 ? function () {} : _ref2$t,
    _ref2$showEnergyInfor = _ref2.showEnergyInformation,
    showEnergyInformation = _ref2$showEnergyInfor === void 0 ? false : _ref2$showEnergyInfor,
    _ref2$showAddonAvaila = _ref2.showAddonAvailability,
    showAddonAvailability = _ref2$showAddonAvaila === void 0 ? false : _ref2$showAddonAvaila,
    _ref2$disableModifyUp = _ref2.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref2$disableModifyUp === void 0 ? false : _ref2$disableModifyUp,
    _ref2$isCouponQuantit = _ref2.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref2$isCouponQuantit === void 0 ? false : _ref2$isCouponQuantit,
    _ref2$hideDisabledBut = _ref2.hideDisabledButtons,
    hideDisabledButtons = _ref2$hideDisabledBut === void 0 ? false : _ref2$hideDisabledBut,
    _ref2$RewardPointsCom = _ref2.RewardPointsComponent,
    RewardPointsComponent = _ref2$RewardPointsCom === void 0 ? null : _ref2$RewardPointsCom,
    _ref2$hideNoPrefixWhe = _ref2.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref2$hideNoPrefixWhe === void 0 ? false : _ref2$hideNoPrefixWhe,
    _ref2$hideComboProduc = _ref2.hideComboProductsUnitPrice,
    hideComboProductsUnitPrice = _ref2$hideComboProduc === void 0 ? false : _ref2$hideComboProduc,
    _ref2$alignButtons = _ref2.alignButtons,
    alignButtons = _ref2$alignButtons === void 0 ? false : _ref2$alignButtons;
  var _useAnalytics = jitsu.useAnalytics(),
    productRemovedTrack = _useAnalytics.productRemovedTrack,
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    embeddedErrorTrack = _useAnalytics.embeddedErrorTrack;
  validation$1.validate({
    name: 'CartProduct',
    parameters: {
      product: product
    }
  });
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  var _useProductCustomisat = useProductCustomisations(),
    formatAllergens = _useProductCustomisat.formatAllergens;
  var promoItem = getPromoItem({
    productId: product == null ? void 0 : product.productId
  });
  var orderTotal = recoil.useRecoilValue(atoms.orderTotalState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var addedUpsells = recoil.useRecoilValue(atoms.addedUpsellState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var title = product.title,
    name = product.name,
    price = product.price,
    options = product.options,
    _product$customisatio = product.customisations,
    customisations = _product$customisatio === void 0 ? [] : _product$customisatio,
    _product$isAvailable = product.isAvailable,
    isAvailable = _product$isAvailable === void 0 ? true : _product$isAvailable,
    removeAll = product.removeAll,
    _product$editDisabled = product.editDisabled,
    editDisabled = _product$editDisabled === void 0 ? false : _product$editDisabled,
    _product$count = product.count,
    count = _product$count === void 0 ? {} : _product$count,
    _product$filterName = product.filterName,
    filterName = _product$filterName === void 0 ? {} : _product$filterName,
    _product$isBag = product.isBag,
    isBag = _product$isBag === void 0 ? false : _product$isBag,
    _product$type = product.type,
    type = _product$type === void 0 ? '' : _product$type,
    _product$allergens = product.allergens,
    allergens = _product$allergens === void 0 ? [] : _product$allergens,
    _product$dualBrand = product.dualBrand,
    dualBrand = _product$dualBrand === void 0 ? '' : _product$dualBrand,
    _product$calculatedEn = product.calculatedEnergyInformation,
    calculatedEnergyInformation = _product$calculatedEn === void 0 ? '' : _product$calculatedEn;
  var currentPrice = price.current,
    unitPrice = price.unit;
  var shouldRenderCartProductChangeButton = !hideDisabledButtons || hideDisabledButtons && !(!isAvailable || editDisabled);
  var shouldRenderButtonsBag = !isBag;
  React.useEffect(function () {
    if (!isAvailable) {
      embeddedErrorTrack(kioskSettings.kiosk, t('cartProductUnavailableGeneral'), 'cart');
    }
  }, [isAvailable, product, kioskSettings.kiosk, t, embeddedErrorTrack]);
  var hasAllergens = allergens.length > 0;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "cart-product",
    className: (!isAvailable && 'bg-red-100') + " cart-product",
    children: [!isAvailable && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "cart-product-unavailable-message",
      children: [/*#__PURE__*/jsxRuntime.jsx(Ban, {
        className: "cart-product-unavailable-message-icon"
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "cart-product-unavailable-text",
        children: t('cartProductUnavailableGeneral')
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "cart-product-name",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "cart-product-name-text",
        children: [dualBrand === 'KFC' && /*#__PURE__*/jsxRuntime.jsx(SvgKfcIcon, {
          className: "cart-product-name-brand"
        }), dualBrand === 'TB' && /*#__PURE__*/jsxRuntime.jsx(SvgTbIcon, {
          className: "cart-product-name-brand"
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "cart-product-name--text",
          "data-test": "cart-product-name",
          children: (promoItem == null ? void 0 : promoItem.name) || title || (filterName == null ? void 0 : filterName.text) || name.text
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "cart-product-controls",
        children: [shouldRenderButtonsBag && /*#__PURE__*/jsxRuntime.jsx(QuantityControllerButtons, {
          product: product,
          className: "quantity-controller-cart",
          disableModifyUpsellOnCart: disableModifyUpsellOnCart,
          isCouponQuantityDisabled: isCouponQuantityDisabled,
          onQtyUpdate: function onQtyUpdate(qty) {
            if (qty < 1) {
              productRemovedTrack(product, count.current + qty, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
            } else {
              var categoryName = product != null && product.isUpsell ? 'cart' : currentCategory;
              productAddedToCartTrack(_extends({}, product, {
                count: {
                  current: count.current + qty
                }
              }), kioskSettings.kiosk, couponNumber, categoryName);
            }
          }
        }), /*#__PURE__*/jsxRuntime.jsxs("div", {
          className: "cart-product-total",
          children: [promoItem != null && promoItem.pointsCost ? /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
            pointsCost: (promoItem == null ? void 0 : promoItem.pointsCost) * getPromoQty$1(promoItem, product)
          }) : /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "cart-product-total-amount",
            "data-test": "cart-product-total",
            children: formatPrice({
              price: currentPrice
            })
          }), showEnergyInformation && calculatedEnergyInformation && /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "cart-product-energy-information",
            "data-test": "cart-product-energy-information",
            children: calculatedEnergyInformation
          })]
        })]
      })]
    }), hasAllergens && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "cart-product-allergen",
      children: /*#__PURE__*/jsxRuntime.jsx("p", {
        children: t('allergensMessage', {
          allergens: allergens.map(function (allerger) {
            return formatAllergens(allerger);
          }).join(', ')
        })
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "cart-product-addon\n          " + (alignButtons ? 'sm:flex-row' : showAddonAvailability ? 'sm:flex-col' : 'sm:flex-row') + "\n        ",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "cart-product-prices",
        children: [hideComboProductsUnitPrice && type === 'combo' ? /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {}) : /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "cart-product-unit-price",
          "data-test": "cart-product-unit-price",
          children: /*#__PURE__*/jsxRuntime.jsx(CartUnitPrice$1, {
            t: t,
            promoItem: promoItem,
            unitPrice: unitPrice,
            formatPrice: formatPrice
          })
        }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
          customisations: customisations,
          t: t,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
        }), /*#__PURE__*/jsxRuntime.jsx(ProductOptionsReadonly, {
          options: options,
          t: t,
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
        })]
      }), /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "product-cart-actions space-y-modal-actions-none space-x-modal-actions\n            " + (alignButtons ? 'product-cart-actions-alignment' : showAddonAvailability ? 'product-cart-actions-addon' : 'product-cart-actions-alignment') + "\n          ",
        children: [shouldRenderButtonsBag && shouldRenderCartProductChangeButton && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "cart-product-change-button footer-action-button",
          "data-test": "cart-product-change-button",
          disabled: !isAvailable || editDisabled,
          onClick: onEditProductHandler(product),
          children: changeText
        }), shouldRenderButtonsBag && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
          className: "cart-product-remove-button footer-action-button",
          "data-test": "cart-product-remove-button",
          disabled: isBag,
          onClick: function onClick() {
            removeAll();
            productRemovedTrack(product, count.current, kioskSettings.kiosk, orderTotal, couponNumber, addedUpsells);
          },
          children: removeText
        })]
      })]
    })]
  });
};

var ServiceCardButton = function ServiceCardButton(_ref) {
  var _ref$dataTest = _ref['data-test'],
    dataTag = _ref$dataTest === void 0 ? 'service-card-button' : _ref$dataTest,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    children = _ref.children;
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    "data-test": dataTag,
    className: "flex flex-col-reverse p-8 items-center shadow-lg font-bold uppercase text-6xl " + className,
    onClick: onClick,
    children: children
  });
};

var ImageButton = function ImageButton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'capitalize' : _ref$className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$dataTest = _ref.dataTest,
    dataTest = _ref$dataTest === void 0 ? 'image-button' : _ref$dataTest;
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    disabled: disabled,
    className: "p-5 h-48 disabled:opacity-50 bg-contain bg-center bg-no-repeat font-button py-6 px-8 focus:outline-none w-full " + className,
    onClick: onClick,
    "data-test": dataTest,
    children: children
  });
};

var UpsellModal$1 = function UpsellModal(_ref) {
  var _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? null : _ref$products,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showEnergyInform = _ref.showEnergyInformationSeparated,
    showEnergyInformationSeparated = _ref$showEnergyInform === void 0 ? false : _ref$showEnergyInform,
    _ref$accessibilityEna = _ref.accessibilityEnabled,
    accessibilityEnabled = _ref$accessibilityEna === void 0 ? false : _ref$accessibilityEna;
  var _useUpsellModal = useUpsellModal({
      closeModal: closeModal,
      products: products
    }),
    onDismiss = _useUpsellModal.onDismiss;
  return /*#__PURE__*/jsxRuntime.jsx(Modal, {
    open: open,
    title: t('upsellModalTitle'),
    closeModal: onDismiss,
    closeText: t('upsellModalCloseAction'),
    className: "upsell-modal " + (accessibilityEnabled && formatModalAccessibilityClass(accessibilityEnabled)),
    "data-test": "upsell-modal",
    formatPrice: formatPrice,
    children: products && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "upsell-modal-content",
      children: /*#__PURE__*/jsxRuntime.jsx(Gallery, {
        items: products,
        formatPrice: formatPrice,
        t: t,
        showAddonAvailability: showAddonAvailability,
        showEnergyInformationSeparated: showEnergyInformationSeparated
      })
    })
  });
};

var ProductOptionCard = function ProductOptionCard(_temp) {
  var _selectedProduct$name, _selectedProduct$name2, _selectedProduct$name3, _selectedProduct$name4, _selectedProduct$name5;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$option = _ref.option,
    option = _ref$option === void 0 ? {} : _ref$option,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$availabilities = _ref.availabilities,
    availabilities = _ref$availabilities === void 0 ? {} : _ref$availabilities,
    _ref$hideNoPrefixWhen = _ref.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref$hideNoPrefixWhen === void 0 ? false : _ref$hideNoPrefixWhen,
    _ref$hideNoImageAvail = _ref.hideNoImageAvailable,
    hideNoImageAvailable = _ref$hideNoImageAvail === void 0 ? false : _ref$hideNoImageAvail;
  var _ref2 = option || {},
    _ref2$products = _ref2.products,
    products = _ref2$products === void 0 ? [] : _ref2$products,
    _ref2$onChangeSelecti = _ref2.onChangeSelection,
    onChangeSelection = _ref2$onChangeSelecti === void 0 ? function () {
      return function () {};
    } : _ref2$onChangeSelecti,
    _ref2$imageUrl = _ref2.imageUrl,
    imageUrl = _ref2$imageUrl === void 0 ? null : _ref2$imageUrl,
    _ref2$imageOverrideUr = _ref2.imageOverrideUrl,
    imageOverrideUrl = _ref2$imageOverrideUr === void 0 ? null : _ref2$imageOverrideUr,
    _ref2$selectionButton = _ref2.selectionButtonText,
    selectionButtonText = _ref2$selectionButton === void 0 ? null : _ref2$selectionButton;
  var selectedProduct = products == null ? void 0 : products.find(function (product) {
    return product.selected;
  });
  var _ref3 = selectedProduct || {},
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? '' : _ref3$type,
    _ref3$price = _ref3.price,
    price = _ref3$price === void 0 ? {} : _ref3$price,
    _ref3$onCustomise = _ref3.onCustomise,
    onCustomise = _ref3$onCustomise === void 0 ? function () {
      return function () {};
    } : _ref3$onCustomise,
    _ref3$customisations = _ref3.customisations,
    customisations = _ref3$customisations === void 0 ? [] : _ref3$customisations,
    _ref3$isCustomisable = _ref3.isCustomisable,
    isCustomisable = _ref3$isCustomisable === void 0 ? true : _ref3$isCustomisable,
    _ref3$isAvailable = _ref3.isAvailable,
    isAvailable = _ref3$isAvailable === void 0 ? true : _ref3$isAvailable;
  var unitPrice = price.unit;
  var showAddonAvailabilityDisabledClass = !isAvailable && showAddonAvailability && 'opacity-30';
  var availability = showAddonAvailability ? availabilities == null ? void 0 : availabilities.find(function (avail) {
    return avail.optionId === option.id;
  }) : undefined;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "product-option-card",
    className: "flex flex-col items-center justify-between w-full p-2 bg-white shadow-lg sm:flex-row md:p-4 product-option-card font-card",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "relative flex justify-center w-1/2 p-4 sm:w-1/3",
      children: [hideNoImageAvailable && !(selectedProduct != null && selectedProduct.title || selectedProduct != null && (_selectedProduct$name = selectedProduct.name) != null && _selectedProduct$name.text) ? /*#__PURE__*/jsxRuntime.jsx("div", {}) : /*#__PURE__*/jsxRuntime.jsx(ProductCardLoadableImage, {
        className: "w-full h-card-image product-option-card__image " + showAddonAvailabilityDisabledClass,
        alt: selectionButtonText ? selectionButtonText : (selectedProduct == null ? void 0 : selectedProduct.title) || (selectedProduct == null ? void 0 : (_selectedProduct$name2 = selectedProduct.name) == null ? void 0 : _selectedProduct$name2.text),
        src: imageOverrideUrl ? imageOverrideUrl : imageUrl ? imageUrl : selectedProduct == null ? void 0 : selectedProduct.imageUrl
      }), ((availability == null ? void 0 : availability.allUnavailable) || !isAvailable) && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "absolute inset-0 flex items-center justify-center text-4xl font-bold text-gray-600",
        children: t('showAddonAvailabilityMessage')
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col items-center justify-center w-auto p-2 text-xl font-bold sm:w-1/3 md:p-4 sm:text-3xl " + showAddonAvailabilityDisabledClass,
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "flex flex-col ml-0 mr-auto",
        children: [(selectedProduct == null ? void 0 : selectedProduct.title) || (selectedProduct == null ? void 0 : (_selectedProduct$name3 = selectedProduct.name) == null ? void 0 : _selectedProduct$name3.text), !!unitPrice && " " + utilities.signaledFormatPrice({
          formatPrice: formatPrice,
          price: unitPrice
        }), (customisations == null ? void 0 : customisations.length) > 0 && /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
          customisations: customisations,
          className: "pt-4 text-2xl",
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          formatAddonAvailability: true,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
        }), !(availability != null && availability.isValid) && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [/*#__PURE__*/jsxRuntime.jsx("span", {
            className: "text-red-600 font-bold",
            children: selectedProduct != null && selectedProduct.title || selectedProduct != null && (_selectedProduct$name4 = selectedProduct.name) != null && _selectedProduct$name4.text ? '' : option.title + " & " + t('chooseProductCustomisations')
          }), ((selectedProduct == null ? void 0 : selectedProduct.title) || (selectedProduct == null ? void 0 : (_selectedProduct$name5 = selectedProduct.name) == null ? void 0 : _selectedProduct$name5.text)) && !(availability != null && availability.isValid) && /*#__PURE__*/jsxRuntime.jsx("span", {
            className: "text-red-600 font-bold",
            children: t('chooseCustomisations')
          })]
        })]
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex flex-col items-stretch w-auto p-4 space-y-4 sm:w-1/3 product-option-card-buttons",
      children: [products.length > 1 && /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
        disabled: availability == null ? void 0 : availability.allUnavailable,
        className: "footer-action-button product-option-card-button-selection",
        onClick: onChangeSelection(option),
        children: t('productOptionCardPrimaryAction')
      }), type === 'customise' && isCustomisable && isCustomisable !== false && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
        disabled: (availability == null ? void 0 : availability.mustChange) === true || (availability == null ? void 0 : availability.allUnavailable),
        className: "footer-action-button product-option-card-button-customise",
        onClick: onCustomise(selectedProduct),
        children: t('productOptionCardSecondaryAction')
      })]
    })]
  });
};

var ProductOptionCard$1 = function ProductOptionCard(_temp) {
  var _selectedProduct$name, _selectedProduct$name2, _selectedProduct$name3, _selectedProduct$name4, _selectedProduct$name5;
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$option = _ref.option,
    option = _ref$option === void 0 ? {} : _ref$option,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$availabilities = _ref.availabilities,
    availabilities = _ref$availabilities === void 0 ? {} : _ref$availabilities,
    _ref$hideNoPrefixWhen = _ref.hideNoPrefixWhenDefaultNotSelected,
    hideNoPrefixWhenDefaultNotSelected = _ref$hideNoPrefixWhen === void 0 ? false : _ref$hideNoPrefixWhen,
    _ref$hideNoImageAvail = _ref.hideNoImageAvailable,
    hideNoImageAvailable = _ref$hideNoImageAvail === void 0 ? false : _ref$hideNoImageAvail;
  var _ref2 = option || {},
    _ref2$products = _ref2.products,
    products = _ref2$products === void 0 ? [] : _ref2$products,
    _ref2$onChangeSelecti = _ref2.onChangeSelection,
    onChangeSelection = _ref2$onChangeSelecti === void 0 ? function () {
      return function () {};
    } : _ref2$onChangeSelecti,
    _ref2$imageUrl = _ref2.imageUrl,
    imageUrl = _ref2$imageUrl === void 0 ? null : _ref2$imageUrl,
    _ref2$imageOverrideUr = _ref2.imageOverrideUrl,
    imageOverrideUrl = _ref2$imageOverrideUr === void 0 ? null : _ref2$imageOverrideUr,
    _ref2$selectionButton = _ref2.selectionButtonText,
    selectionButtonText = _ref2$selectionButton === void 0 ? null : _ref2$selectionButton;
  var selectedProduct = products == null ? void 0 : products.find(function (product) {
    return product.selected;
  });
  var _ref3 = selectedProduct || {},
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? '' : _ref3$type,
    _ref3$price = _ref3.price,
    price = _ref3$price === void 0 ? {} : _ref3$price,
    _ref3$onCustomise = _ref3.onCustomise,
    onCustomise = _ref3$onCustomise === void 0 ? function () {
      return function () {};
    } : _ref3$onCustomise,
    _ref3$customisations = _ref3.customisations,
    customisations = _ref3$customisations === void 0 ? [] : _ref3$customisations,
    _ref3$isCustomisable = _ref3.isCustomisable,
    isCustomisable = _ref3$isCustomisable === void 0 ? true : _ref3$isCustomisable,
    _ref3$isAvailable = _ref3.isAvailable,
    isAvailable = _ref3$isAvailable === void 0 ? true : _ref3$isAvailable;
  var unitPrice = price.unit;
  var showAddonAvailabilityDisabledClass = !isAvailable && showAddonAvailability && 'product-option-card-disabled';
  var availability = showAddonAvailability ? availabilities == null ? void 0 : availabilities.find(function (avail) {
    return avail.optionId === option.id;
  }) : undefined;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "product-option-card",
    className: "product-option-card font-card",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "product-option-card-detail",
      children: [hideNoImageAvailable && !(selectedProduct != null && selectedProduct.title || selectedProduct != null && (_selectedProduct$name = selectedProduct.name) != null && _selectedProduct$name.text) ? /*#__PURE__*/jsxRuntime.jsx("div", {}) : /*#__PURE__*/jsxRuntime.jsx(ProductCardLoadableImage, {
        className: "product-option-card__image " + showAddonAvailabilityDisabledClass,
        alt: selectionButtonText ? selectionButtonText : (selectedProduct == null ? void 0 : selectedProduct.title) || (selectedProduct == null ? void 0 : (_selectedProduct$name2 = selectedProduct.name) == null ? void 0 : _selectedProduct$name2.text),
        src: imageOverrideUrl ? imageOverrideUrl : imageUrl ? imageUrl : selectedProduct == null ? void 0 : selectedProduct.imageUrl
      }), ((availability == null ? void 0 : availability.allUnavailable) || !isAvailable) && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "product-option-availability-message",
        children: t('showAddonAvailabilityMessage')
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "product-options " + showAddonAvailabilityDisabledClass,
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "product-options-customisations",
        children: [(selectedProduct == null ? void 0 : selectedProduct.title) || (selectedProduct == null ? void 0 : (_selectedProduct$name3 = selectedProduct.name) == null ? void 0 : _selectedProduct$name3.text), !!unitPrice && " " + utilities.signaledFormatPrice({
          formatPrice: formatPrice,
          price: unitPrice
        }), (customisations == null ? void 0 : customisations.length) > 0 && /*#__PURE__*/jsxRuntime.jsx(ProductCustomisationsReadonly, {
          customisations: customisations,
          className: "product-option-card-customisation-text",
          formatPrice: formatPrice,
          showAddonAvailability: showAddonAvailability,
          formatAddonAvailability: true,
          hideNoPrefixWhenDefaultNotSelected: hideNoPrefixWhenDefaultNotSelected
        }), !(availability != null && availability.isValid) && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
          children: [/*#__PURE__*/jsxRuntime.jsx("span", {
            className: "product-options-unavailable-customisations",
            children: selectedProduct != null && selectedProduct.title || selectedProduct != null && (_selectedProduct$name4 = selectedProduct.name) != null && _selectedProduct$name4.text ? '' : option.title + " & " + t('chooseProductCustomisations')
          }), ((selectedProduct == null ? void 0 : selectedProduct.title) || (selectedProduct == null ? void 0 : (_selectedProduct$name5 = selectedProduct.name) == null ? void 0 : _selectedProduct$name5.text)) && !(availability != null && availability.isValid) && /*#__PURE__*/jsxRuntime.jsx("span", {
            className: "product-options-unavailable-customisations",
            children: t('chooseCustomisations')
          })]
        })]
      })
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "product-option-card-buttons",
      children: [products.length > 1 && /*#__PURE__*/jsxRuntime.jsx(PrimaryButton, {
        disabled: availability == null ? void 0 : availability.allUnavailable,
        className: "footer-action-button product-option-card-button-selection",
        onClick: onChangeSelection(option),
        children: t('productOptionCardPrimaryAction')
      }), type === 'customise' && isCustomisable && isCustomisable !== false && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
        disabled: (availability == null ? void 0 : availability.mustChange) === true || (availability == null ? void 0 : availability.allUnavailable),
        className: "footer-action-button product-option-card-button-customise",
        onClick: onCustomise(selectedProduct),
        children: t('productOptionCardSecondaryAction')
      })]
    })]
  });
};

var ProductOptionItemCard = function ProductOptionItemCard(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$disabledClass = _ref.disabledClass,
    disabledClass = _ref$disabledClass === void 0 ? 'opacity-30 line-through' : _ref$disabledClass,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab;
  var _product$onSelect = product.onSelect,
    onSelect = _product$onSelect === void 0 ? function () {} : _product$onSelect,
    _product$name = product.name,
    name = _product$name === void 0 ? {} : _product$name,
    imageUrl = product.imageUrl,
    energyInformation = product.energyInformation,
    selected = product.selected,
    price = product.price,
    _product$isAvailable = product.isAvailable,
    isAvailable = _product$isAvailable === void 0 ? true : _product$isAvailable;
  var unit = price.unit;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var showAddonAvailabilityDisabledClass = !isAvailable && showAddonAvailability ? 'opacity-30' : '';
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "product-option-item-card",
    className: "flex flex-col items-center w-full p-2 md:p-4 pb-8 md:pb-12 text-center shadow-lg custom-product-option-item-card bg-product-option-item-card font-card " + (!isAvailable && !showAddonAvailability ? disabledClass : ''),
    onClick: !selected ? isAvailable ? onSelect(product) : function () {} : function () {},
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-option-item-card-selected",
      className: "flex items-center justify-center text-primary " + (!selected && 'invisible') + " " + showAddonAvailabilityDisabledClass,
      children: [/*#__PURE__*/jsxRuntime.jsx(CheckCircle, {
        className: "h-8 md:h-12"
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "text-2xl font-bold sm:text-3xl",
        children: t('productOptionItemCardSelectedMessage')
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "relative w-full",
      children: [/*#__PURE__*/jsxRuntime.jsx(ProductCardLoadableImage, {
        "data-test": "product-option-item-card-image",
        src: imageUrl,
        alt: "",
        className: "mt-4 h-card-image custom-product-option-item-card__image " + showAddonAvailabilityDisabledClass
      }), !isAvailable && showAddonAvailability && /*#__PURE__*/jsxRuntime.jsx("p", {
        className: "absolute inset-0 flex items-center justify-center text-4xl font-bold text-gray-600 gallery-cart-availability",
        children: t('showAddonAvailabilityMessage')
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "product-option-item-card-name",
      className: "mt-4 text-2xl font-bold sm:text-3xl " + showAddonAvailabilityDisabledClass,
      children: name == null ? void 0 : name.text
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "product-option-item-card-info",
      className: "mt-2 text-2xl font-bold sm:text-3xl " + showAddonAvailabilityDisabledClass,
      children: utilities.join(unit && " " + utilities.signaledFormatPrice({
        formatPrice: formatPrice,
        price: unit
      }), energyInformation)()
    })]
  });
};

var ProductOptionsChangeModal = function ProductOptionsChangeModal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$option = _ref.option,
    option = _ref$option === void 0 ? {} : _ref$option,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$showModal = _ref.showModal,
    showModal = _ref$showModal === void 0 ? false : _ref$showModal,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    className = _ref.className,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab;
  var _ref2 = option || {},
    _ref2$products = _ref2.products,
    products = _ref2$products === void 0 ? [] : _ref2$products,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? {} : _ref2$name;
  return /*#__PURE__*/jsxRuntime.jsx(Modal, {
    "data-test": "product-options-change-modal",
    open: showModal,
    title: name.text,
    closeModal: onClose,
    closeText: t('productOptionsChangeModalCloseAction'),
    className: className,
    formatPrice: formatPrice,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "max-h-full overflow-y-auto",
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "grid gap-2 p-2 sm:grid-cols-3 md:gap-4 md:p-4 custom-product-options-change-modal",
        children: products.map(function (product, index) {
          return /*#__PURE__*/jsxRuntime.jsx(ProductOptionItemCard, {
            product: product,
            t: t,
            showAddonAvailability: showAddonAvailability
          }, index);
        })
      })
    })
  });
};

var ProductOptionsChangeModal$1 = function ProductOptionsChangeModal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$option = _ref.option,
    option = _ref$option === void 0 ? {} : _ref$option,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$showModal = _ref.showModal,
    showModal = _ref$showModal === void 0 ? false : _ref$showModal,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$formatPrice = _ref.formatPrice,
    formatPrice = _ref$formatPrice === void 0 ? function () {} : _ref$formatPrice,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$accessibilityEna = _ref.accessibilityEnabled,
    accessibilityEnabled = _ref$accessibilityEna === void 0 ? false : _ref$accessibilityEna;
  var _ref2 = option || {},
    _ref2$products = _ref2.products,
    products = _ref2$products === void 0 ? [] : _ref2$products,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? {} : _ref2$name;
  var modalAccessibilityClass = formatModalAccessibilityClass(accessibilityEnabled);
  return /*#__PURE__*/jsxRuntime.jsx(Modal$1, {
    "data-test": "product-options-change-modal",
    open: showModal,
    title: name.text,
    closeModal: onClose,
    closeText: t('productOptionsChangeModalCloseAction'),
    className: modalAccessibilityClass,
    formatPrice: formatPrice,
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "product-options-change-modal-content",
      children: /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "custom-product-options-change-modal",
        children: products.map(function (product, index) {
          return /*#__PURE__*/jsxRuntime.jsx(ProductOptionItemCard, {
            product: product,
            t: t,
            showAddonAvailability: showAddonAvailability
          }, index);
        })
      })
    })
  });
};

var InputError = function InputError(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'input-error-message' : _ref$dataTest;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "text-red-600 text-2xl text-center " + className,
    "data-test": dataTest,
    children: children
  });
};

var InputError$1 = function InputError(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'input-error--default' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'input-error-message' : _ref$dataTest;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "input-error " + className,
    "data-test": dataTest,
    children: children
  });
};

var InputLabel$1 = function InputLabel(_ref) {
  var _ref$dataTest = _ref['data-test'],
    dataTest = _ref$dataTest === void 0 ? 'input-label' : _ref$dataTest,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'input-label--default' : _ref$className;
  return /*#__PURE__*/jsxRuntime.jsxs("label", {
    "data-test": dataTest,
    className: "input-label " + className,
    htmlFor: id,
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      children: label ? "" + label : null
    }), children]
  });
};
var Input$1 = function Input(_ref2) {
  var _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? 'input' : _ref2$dataTest,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$onFocus = _ref2.onFocus,
    onFocus = _ref2$onFocus === void 0 ? function () {} : _ref2$onFocus,
    _ref2$onChange = _ref2.onChange,
    onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? '' : _ref2$value,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? '' : _ref2$id,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'text' : _ref2$type,
    _ref2$checked = _ref2.checked,
    checked = _ref2$checked === void 0 ? false : _ref2$checked,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? '' : _ref2$placeholder,
    _ref2$autoFocus = _ref2.autoFocus,
    autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus,
    _ref2$isError = _ref2.isError,
    isError = _ref2$isError === void 0 ? false : _ref2$isError;
  var isText = type === 'text';
  var isCheckbox = type === 'checkbox';
  var inputRef = React.useRef();
  var baseClass = 'input';
  var typeClass = isCheckbox ? 'input--checkbox' : 'input--text';
  var errorClass = isText && isError ? 'input--error' : '';
  React.useEffect(function () {
    if (isText && inputRef != null && inputRef.current && value != null && value.length) {
      setTimeout(function () {
        var _inputRef$current, _inputRef$current2;
        (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
        (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.setSelectionRange(value.length, value.length);
      }, 300);
    }
  }, [value, inputRef, isText]);
  return /*#__PURE__*/jsxRuntime.jsx("input", {
    ref: inputRef,
    id: id,
    type: type,
    value: value,
    checked: checked,
    "data-test": dataTest,
    className: baseClass + " " + typeClass + " " + errorClass + " " + className,
    placeholder: placeholder,
    onFocus: onFocus,
    onChange: onChange,
    autoFocus: autoFocus
  });
};

var CustomerDetailsForm = function CustomerDetailsForm(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$firstNameSetting = _ref.firstNameSettings,
    firstNameSettings = _ref$firstNameSetting === void 0 ? {} : _ref$firstNameSetting,
    _ref$lastNameSettings = _ref.lastNameSettings,
    lastNameSettings = _ref$lastNameSettings === void 0 ? {} : _ref$lastNameSettings,
    _ref$fullNameSettings = _ref.fullNameSettings,
    fullNameSettings = _ref$fullNameSettings === void 0 ? {} : _ref$fullNameSettings,
    _ref$emailSettings = _ref.emailSettings,
    emailSettings = _ref$emailSettings === void 0 ? {} : _ref$emailSettings,
    _ref$phoneNumberSetti = _ref.phoneNumberSettings,
    phoneNumberSettings = _ref$phoneNumberSetti === void 0 ? {} : _ref$phoneNumberSetti,
    _ref$currentSettings = _ref.currentSettings,
    currentSettings = _ref$currentSettings === void 0 ? {} : _ref$currentSettings,
    _ref$showEmail = _ref.showEmail,
    showEmail = _ref$showEmail === void 0 ? true : _ref$showEmail,
    emailCodes = _ref.emailCodes,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    fullName = _ref.fullName,
    layout = _ref.layout,
    email = _ref.email,
    phoneNumber = _ref.phoneNumber,
    _ref$showNameFields = _ref.showNameFields,
    showNameFields = _ref$showNameFields === void 0 ? true : _ref$showNameFields,
    _ref$showFullNameFiel = _ref.showFullNameField,
    showFullNameField = _ref$showFullNameFiel === void 0 ? false : _ref$showFullNameFiel,
    _ref$showPhoneNumberF = _ref.showPhoneNumberField,
    showPhoneNumberField = _ref$showPhoneNumberF === void 0 ? false : _ref$showPhoneNumberF,
    _ref$receiveMarketing = _ref.receiveMarketingEmail,
    receiveMarketingEmail = _ref$receiveMarketing === void 0 ? false : _ref$receiveMarketing,
    _ref$receiveMarketing2 = _ref.receiveMarketingEmailSettings,
    receiveMarketingEmailSettings = _ref$receiveMarketing2 === void 0 ? {} : _ref$receiveMarketing2,
    _ref$showReceiveMarke = _ref.showReceiveMarketingEmail,
    showReceiveMarketingEmail = _ref$showReceiveMarke === void 0 ? false : _ref$showReceiveMarke,
    _ref$showEmailDescrip = _ref.showEmailDescription,
    showEmailDescription = _ref$showEmailDescrip === void 0 ? true : _ref$showEmailDescrip,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t,
    _ref$OnScreenKeyboard = _ref.OnScreenKeyboard,
    OnScreenKeyboard$1 = _ref$OnScreenKeyboard === void 0 ? OnScreenKeyboard : _ref$OnScreenKeyboard,
    _ref$Input = _ref.Input,
    Input = _ref$Input === void 0 ? Input$1 : _ref$Input,
    _ref$InputLabel = _ref.InputLabel,
    InputLabel = _ref$InputLabel === void 0 ? InputLabel$1 : _ref$InputLabel,
    _ref$isEmailAutoFocus = _ref.isEmailAutoFocus,
    isEmailAutoFocus = _ref$isEmailAutoFocus === void 0 ? false : _ref$isEmailAutoFocus,
    _ref$showNumbers = _ref.showNumbers,
    showNumbers = _ref$showNumbers === void 0 ? true : _ref$showNumbers,
    _ref$inputError = _ref.inputError,
    inputError = _ref$inputError === void 0 ? '' : _ref$inputError,
    _ref$firstNameError = _ref.firstNameError,
    firstNameError = _ref$firstNameError === void 0 ? false : _ref$firstNameError,
    _ref$lastNameError = _ref.lastNameError,
    lastNameError = _ref$lastNameError === void 0 ? false : _ref$lastNameError,
    _ref$fullNameError = _ref.fullNameError,
    fullNameError = _ref$fullNameError === void 0 ? false : _ref$fullNameError,
    _ref$emailError = _ref.emailError,
    emailError = _ref$emailError === void 0 ? false : _ref$emailError,
    _ref$phoneNumberError = _ref.phoneNumberError,
    phoneNumberError = _ref$phoneNumberError === void 0 ? false : _ref$phoneNumberError;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "customer-details-form",
    className: "customer-details-form",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "customer-details-form-inputs",
      children: [showFullNameField && /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "customer-full-name-input-group",
          children: /*#__PURE__*/jsxRuntime.jsx(InputLabel, {
            id: fullNameSettings.inputName,
            label: fullNameSettings.label,
            children: /*#__PURE__*/jsxRuntime.jsx(Input, {
              autoFocus: true,
              "data-test": "customer-full-name-input",
              type: "text",
              className: fullNameError ? 'customer-input-error' : '',
              id: fullNameSettings.inputName,
              value: fullName,
              onFocus: fullNameSettings.onFocus,
              placeholder: fullNameSettings.placeholder
            })
          })
        })
      }), !showFullNameField && showNameFields && /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [/*#__PURE__*/jsxRuntime.jsx("div", {
          className: "customer-first-name-input-group",
          children: /*#__PURE__*/jsxRuntime.jsx(InputLabel, {
            id: firstNameSettings.inputName,
            label: firstNameSettings.label,
            children: /*#__PURE__*/jsxRuntime.jsx(Input, {
              autoFocus: true,
              "data-test": "customer-first-name-input",
              type: "text",
              className: firstNameError ? 'customer-input-error' : '',
              id: firstNameSettings.inputName,
              value: firstName,
              onFocus: firstNameSettings.onFocus,
              placeholder: firstNameSettings.placeholder
            })
          })
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "customer-last-name-input-group",
          children: /*#__PURE__*/jsxRuntime.jsx(InputLabel, {
            id: lastNameSettings.inputName,
            label: lastNameSettings.label,
            children: /*#__PURE__*/jsxRuntime.jsx(Input, {
              "data-test": "customer-last-name-input",
              type: "text",
              className: lastNameError ? 'customer-input-error' : '',
              id: lastNameSettings.inputName,
              value: lastName,
              onFocus: lastNameSettings.onFocus,
              placeholder: lastNameSettings.placeholder
            })
          })
        })]
      }), showPhoneNumberField && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "customer-phone-number-input-group",
        children: /*#__PURE__*/jsxRuntime.jsx(InputLabel, {
          id: phoneNumberSettings.inputName,
          label: phoneNumberSettings.label,
          children: /*#__PURE__*/jsxRuntime.jsx(Input, {
            "data-test": "customer-phone-number-input",
            type: "text",
            className: phoneNumberError ? 'customer-input-error' : '',
            id: phoneNumberSettings.inputName,
            value: phoneNumber,
            onFocus: phoneNumberSettings.onFocus,
            placeholder: phoneNumberSettings.placeholder
          })
        })
      }), showEmail && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "customer-email-input",
        children: /*#__PURE__*/jsxRuntime.jsxs(InputLabel, {
          id: emailSettings.inputName,
          label: emailSettings.label,
          children: [showEmailDescription && /*#__PURE__*/jsxRuntime.jsx("small", {
            children: t('customerDetailsEmailDescription')
          }), /*#__PURE__*/jsxRuntime.jsx(Input, {
            type: "text",
            "data-test": "customer-email-input",
            className: emailError ? 'customer-input-error' : '',
            id: emailSettings.inputName,
            value: email,
            onFocus: emailSettings.onFocus,
            placeholder: emailSettings.placeholder,
            autoFocus: isEmailAutoFocus
          })]
        })
      }), !!inputError && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "customer-details-form-input-error",
        children: /*#__PURE__*/jsxRuntime.jsx(InputError$1, {
          children: inputError
        })
      }), showReceiveMarketingEmail && /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "customer-email-input-group",
        children: [/*#__PURE__*/jsxRuntime.jsx(Input, {
          type: "checkbox",
          "data-test": "customer-receive-marketing-email-input",
          id: receiveMarketingEmailSettings.inputName,
          checked: receiveMarketingEmail,
          onChange: receiveMarketingEmailSettings.onChange
        }), /*#__PURE__*/jsxRuntime.jsx("label", {
          className: "customer-email-input-label",
          id: receiveMarketingEmailSettings.inputName,
          htmlFor: receiveMarketingEmailSettings.inputName,
          children: t('receiveEmailAddress')
        })]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(OnScreenKeyboard$1, {
      layout: layout,
      onChange: currentSettings.onChange,
      maxLength: currentSettings.maxLength,
      inputName: currentSettings.inputName,
      initial: currentSettings.inputName === 'phoneNumber' ? 'numpad' : 'letter',
      initialValue: showFullNameField ? fullName : firstName,
      showEmailCodes: currentSettings.inputName === 'email',
      numpad: showNumbers || currentSettings.inputName === 'phoneNumber',
      letter: currentSettings.inputName !== 'phoneNumber',
      symbol: currentSettings.inputName !== 'phoneNumber',
      space: showFullNameField,
      emailCodes: emailCodes
    })]
  });
};

var OrderTotalSummary = function OrderTotalSummary(_ref) {
  var t = _ref.t,
    orderTotalSummary = _ref.orderTotalSummary,
    products = _ref.products,
    _ref$RewardPointsComp = _ref.RewardPointsComponent,
    RewardPointsComponent = _ref$RewardPointsComp === void 0 ? null : _ref$RewardPointsComp;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  if (!orderTotalSummary) {
    return null;
  }
  var getPromoQty = function getPromoQty(promoItem, product) {
    return promoItem.promoId === product.providerData.PromoId && product.count.current;
  };
  var taxes = orderTotalSummary.taxes,
    subTotal = orderTotalSummary.subTotal,
    total = orderTotalSummary.total,
    discount = orderTotalSummary.discount;
  var promoItems = products.map(function (product) {
    var promoItem = getPromoItem({
      productId: product == null ? void 0 : product.productId
    });
    if (!!promoItem) {
      return _extends({}, promoItem, {
        pointsCost: (promoItem.pointsCost || 0) * getPromoQty(promoItem, product)
      });
    }
  });
  var totalRewards = promoItems.reduce(function (acc, promoItem) {
    return (acc || 0) + ((promoItem == null ? void 0 : promoItem.pointsCost) || 0);
  }, 0);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "order-summary",
    className: "flex flex-col justify-center w-full p-2 space-y-4 shadow-lg items-left md:p-4",
    children: [totalRewards > 0 && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between w-full text-2xl font-bold md:text-3xl",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "totalrewards-text",
        className: "mb-4",
        children: [t('loyaltyTotal'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
        pointsCost: totalRewards
      })]
    }), discount && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between w-full text-2xl font-bold md:text-3xl",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "discount-text",
        className: "mb-4",
        children: [t('discount'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "discount-value",
        children: discount
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between w-full text-2xl font-bold md:text-3xl ",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "subtotal-text",
        className: "mb-4",
        children: [t('receiptPaymentSubTotal'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "subtotal-value",
        children: subTotal
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between w-full text-2xl font-bold md:text-3xl",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "taxes-text",
        className: "mb-4",
        children: [t('taxesFees'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "taxes-value",
        children: taxes
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "flex justify-between w-full text-2xl font-bold md:text-4xl",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "total-text",
        className: "mb-4",
        children: [t('transactionsPaymentOrderTotal'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "total-value",
        children: total
      })]
    })]
  });
};

var OrderTotalSummary$1 = function OrderTotalSummary(_ref) {
  var t = _ref.t,
    orderTotalSummary = _ref.orderTotalSummary,
    products = _ref.products,
    _ref$RewardPointsComp = _ref.RewardPointsComponent,
    RewardPointsComponent = _ref$RewardPointsComp === void 0 ? null : _ref$RewardPointsComp;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  if (!orderTotalSummary) {
    return null;
  }
  var getPromoQty = function getPromoQty(promoItem, product) {
    return promoItem.promoId === product.providerData.PromoId && product.count.current;
  };
  var taxes = orderTotalSummary.taxes,
    subTotal = orderTotalSummary.subTotal,
    total = orderTotalSummary.total,
    discount = orderTotalSummary.discount;
  var promoItems = products.map(function (product) {
    var promoItem = getPromoItem({
      productId: product == null ? void 0 : product.productId
    });
    if (!!promoItem) {
      return _extends({}, promoItem, {
        pointsCost: (promoItem.pointsCost || 0) * getPromoQty(promoItem, product)
      });
    }
  });
  var totalRewards = promoItems.reduce(function (acc, promoItem) {
    return (acc || 0) + ((promoItem == null ? void 0 : promoItem.pointsCost) || 0);
  }, 0);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "order-summary",
    className: "order-total-summary-container",
    children: [totalRewards > 0 && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "order-loyalty-summary",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "totalrewards-text",
        className: "order-summary-amount",
        children: [t('loyaltyTotal'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
        pointsCost: totalRewards
      })]
    }), discount && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "order-summary-item",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "discount-text",
        className: "order-summary-amount",
        children: [t('discount'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "discount-value",
        children: discount
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "order-summary-item ",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "subtotal-text",
        className: "order-summary-amount",
        children: [t('receiptPaymentSubTotal'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "subtotal-value",
        children: subTotal
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "order-summary-item",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "taxes-text",
        className: "order-summary-amount",
        children: [t('taxesFees'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "taxes-value",
        children: taxes
      })]
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "order-summary-amount-total",
      children: [/*#__PURE__*/jsxRuntime.jsxs("span", {
        "data-test": "total-text",
        className: "order-summary-amount",
        children: [t('transactionsPaymentOrderTotal'), ":"]
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        "data-test": "total-value",
        children: total
      })]
    })]
  });
};

var BeaconForm = function BeaconForm(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$inputError = _ref.inputError,
    inputError = _ref$inputError === void 0 ? '' : _ref$inputError,
    _ref$beaconValue = _ref.beaconValue,
    beaconValue = _ref$beaconValue === void 0 ? '' : _ref$beaconValue,
    _ref$currentSettings = _ref.currentSettings,
    currentSettings = _ref$currentSettings === void 0 ? {} : _ref$currentSettings,
    _ref$OnScreenKeyboard = _ref.OnScreenKeyboard,
    OnScreenKeyboard$1 = _ref$OnScreenKeyboard === void 0 ? OnScreenKeyboard : _ref$OnScreenKeyboard,
    _ref$Input = _ref.Input,
    Input$1 = _ref$Input === void 0 ? Input : _ref$Input;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "beacon-form",
    className: "beacon-form",
    children: [inputError && /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "beacon-form__input--error",
      children: inputError
    }), /*#__PURE__*/jsxRuntime.jsx(Input$1, {
      type: "text",
      "data-test": "beacon-form-input",
      id: currentSettings.inputName,
      value: beaconValue,
      className: "beacon-form__input"
    }), /*#__PURE__*/jsxRuntime.jsx(OnScreenKeyboard$1, {
      letter: false,
      symbol: false,
      initial: "numpad",
      onChange: currentSettings.onChange,
      maxLength: currentSettings.maxLength,
      inputName: currentSettings.inputName
    })]
  });
};

var BeaconFormHeaderSubtitle = function BeaconFormHeaderSubtitle() {
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "beacon-form-header-subtitle",
    "data-test": "beacon-form-header-subtitle",
    children: t('beaconFormHeaderSubtitle')
  });
};

var img$3 = "data:image/png;base64,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";

var BeaconFormHeaderIcon = function BeaconFormHeaderIcon(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$Image = _ref.Image,
    Image = _ref$Image === void 0 ? img$3 : _ref$Image;
  return function () {
    return /*#__PURE__*/jsxRuntime.jsx("img", {
      src: Image,
      className: "beacon-form-header-icon",
      alt: "beacon",
      "data-test": "beacon-form-header-icon"
    });
  };
};

var BeaconFormHeader = function BeaconFormHeader(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$accessibilityEna = _ref.accessibilityEnabled,
    accessibilityEnabled = _ref$accessibilityEna === void 0 ? false : _ref$accessibilityEna,
    _ref$Image = _ref.Image,
    Image = _ref$Image === void 0 ? undefined : _ref$Image,
    _ref$Icon = _ref.Icon,
    Icon = _ref$Icon === void 0 ? BeaconFormHeaderIcon({
      Image: Image
    }) : _ref$Icon,
    Subtitle = _ref.Subtitle,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? function () {} : _ref$t;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "beacon-form-header",
    "data-test": "beacon-form-header",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      className: "beacon-form-header__title",
      "data-test": "beacon-form-header-title",
      children: t('beaconFormHeaderTitle')
    }), Icon && !accessibilityEnabled && /*#__PURE__*/jsxRuntime.jsx(Icon, {}), Subtitle && /*#__PURE__*/jsxRuntime.jsx(Subtitle, {})]
  });
};

var _excluded$5 = ["src", "className", "placeholder", "customDefaultImage", "data-test"];
var Wrapper$1 = function Wrapper(_ref) {
  var children = _ref.children,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  if (placeholder) return /*#__PURE__*/jsxRuntime.jsx("div", {
    className: "loadable-image__skeleton-wrapper",
    children: children
  });
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: children
  });
};
var LoadableImage$1 = function LoadableImage(_ref2) {
  var _ref2$src = _ref2.src,
    src = _ref2$src === void 0 ? null : _ref2$src,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? 'loadable-image--default' : _ref2$className,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? null : _ref2$placeholder,
    _ref2$customDefaultIm = _ref2.customDefaultImage,
    customDefaultImage = _ref2$customDefaultIm === void 0 ? img : _ref2$customDefaultIm,
    _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? 'loadable-image' : _ref2$dataTest,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$5);
  var imageSrc = src || customDefaultImage;
  var _useLoadableImage = useLoadableImage({
      customDefaultImage: customDefaultImage
    }),
    hiddenImageClassName = _useLoadableImage.hiddenImageClassName,
    onLoad = _useLoadableImage.onLoad,
    isLoading = _useLoadableImage.isLoading,
    handleFailure = _useLoadableImage.handleFailure;
  var defaultSkeletonHeight = 0;
  var skeletonHeight = placeholder ? placeholder.height : defaultSkeletonHeight;
  var skeletonWidth = placeholder ? placeholder.width : undefined;
  var skeletonClassName = placeholder ? '' : 'loadable-image__skeleton';
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [isLoading && /*#__PURE__*/jsxRuntime.jsx(Wrapper$1, {
      placeholder: placeholder,
      children: /*#__PURE__*/jsxRuntime.jsx(Skeleton.SkeletonTheme, {
        children: /*#__PURE__*/jsxRuntime.jsx(Skeleton__default, {
          "data-test": "skeleton-loader",
          height: skeletonHeight,
          width: skeletonWidth,
          className: skeletonClassName
        })
      })
    }), /*#__PURE__*/React.createElement("img", _extends({}, props, {
      "data-test": dataTest,
      key: imageSrc,
      src: imageSrc,
      onLoad: onLoad,
      onError: handleFailure,
      className: "loadable-image " + hiddenImageClassName + " " + className
    }))]
  });
};

var ProductCustomisationModal$1 = function ProductCustomisationModal(_ref) {
  var _product$count, _product$count2;
  var product = _ref.product,
    _ref$showSpacer = _ref.showSpacer,
    showSpacer = _ref$showSpacer === void 0 ? true : _ref$showSpacer,
    _ref$ProductCustomisa = _ref.ProductCustomisations,
    ProductCustomisations$1 = _ref$ProductCustomisa === void 0 ? ProductCustomisations : _ref$ProductCustomisa,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$addToCartDirectl = _ref.addToCartDirectly,
    addToCartDirectly = _ref$addToCartDirectl === void 0 ? false : _ref$addToCartDirectl,
    _ref$showQuantityCont = _ref.showQuantityControllerLabel,
    showQuantityControllerLabel = _ref$showQuantityCont === void 0 ? false : _ref$showQuantityCont,
    _ref$isCustomisationH = _ref.isCustomisationHeaderEnabled,
    isCustomisationHeaderEnabled = _ref$isCustomisationH === void 0 ? false : _ref$isCustomisationH,
    _ref$isCustomiseCateg = _ref.isCustomiseCategoryTitleEnabled,
    isCustomiseCategoryTitleEnabled = _ref$isCustomiseCateg === void 0 ? true : _ref$isCustomiseCateg,
    _ref$isCategoryTotali = _ref.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref$isCategoryTotali === void 0 ? true : _ref$isCategoryTotali,
    _ref$isAdditionalMess = _ref.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref$isAdditionalMess === void 0 ? true : _ref$isAdditionalMess,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$showOutOfStockMo = _ref.showOutOfStockModal,
    showOutOfStockModal = _ref$showOutOfStockMo === void 0 ? function () {} : _ref$showOutOfStockMo,
    _ref$setStaged = _ref.setStaged,
    setStaged = _ref$setStaged === void 0 ? function () {} : _ref$setStaged,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$showModifierEner = _ref.showModifierEnergyInformation,
    showModifierEnergyInformation = _ref$showModifierEner === void 0 ? false : _ref$showModifierEner,
    _ref$titleSeparator = _ref.titleSeparator,
    titleSeparator = _ref$titleSeparator === void 0 ? ' ' : _ref$titleSeparator,
    _ref$hidePriceWhenQua = _ref.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref$hidePriceWhenQua === void 0 ? false : _ref$hidePriceWhenQua,
    _ref$hidePriceWhenZer = _ref.hidePriceWhenZero,
    hidePriceWhenZero = _ref$hidePriceWhenZer === void 0 ? false : _ref$hidePriceWhenZer,
    _ref$shouldChangeAddB = _ref.shouldChangeAddButtonText,
    shouldChangeAddButtonText = _ref$shouldChangeAddB === void 0 ? false : _ref$shouldChangeAddB,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity,
    _ref$isDeliverectProv = _ref.isDeliverectProvider,
    isDeliverectProvider = _ref$isDeliverectProv === void 0 ? false : _ref$isDeliverectProv,
    _ref$isOpenOutOfStock = _ref.isOpenOutOfStockModal,
    isOpenOutOfStockModal = _ref$isOpenOutOfStock === void 0 ? false : _ref$isOpenOutOfStock,
    _ref$cancelledOutOfSt = _ref.cancelledOutOfStockModal,
    cancelledOutOfStockModal = _ref$cancelledOutOfSt === void 0 ? false : _ref$cancelledOutOfSt;
  var _useProductCustomisat = useProductCustomisationModal({
      product: product,
      onConfirmCallback: onConfirmCallback,
      onCloseCallback: onCloseCallback,
      showOutOfStockModal: showOutOfStockModal,
      setStaged: setStaged
    }),
    customisations = _useProductCustomisat.customisations,
    t = _useProductCustomisat.t,
    onConfirm = _useProductCustomisat.onConfirm,
    menuState = _useProductCustomisat.menuState,
    allowOnConfirm = _useProductCustomisat.allowOnConfirm,
    loading = _useProductCustomisat.loading,
    staged = _useProductCustomisat.staged,
    isSubstitutionModalOpen = _useProductCustomisat.isSubstitutionModalOpen,
    handleOpenSubstitutionModal = _useProductCustomisat.handleOpenSubstitutionModal,
    handleCloseSubstitutionModal = _useProductCustomisat.handleCloseSubstitutionModal,
    handleSubstitutionSelect = _useProductCustomisat.handleSubstitutionSelect,
    formattedSubstitutions = _useProductCustomisat.formattedSubstitutions,
    handleEditProduct = _useProductCustomisat.handleEditProduct,
    onCancel = _useProductCustomisat.onCancel;

  // Conditionally triggers onConfirm:
  // - When addToCartDirectly is true (skips customization).
  // - AND the out-of-stock modal isn't cancelled (cancelledOutOfStockModal is false).
  // - AND the out-of-stock modal isn't currently open (isOpenOutOfStockModal is false).
  var confirmProduct = addToCartDirectly && !cancelledOutOfStockModal && !isOpenOutOfStockModal;
  React.useEffect(function () {
    if (!loading && menuState != null && menuState.matches('success') && confirmProduct) {
      onConfirm();
    }
  }, [loading, menuState, onConfirm, confirmProduct]);
  var isEditMode = (product == null ? void 0 : (_product$count = product.count) == null ? void 0 : _product$count.current) > (product == null ? void 0 : (_product$count2 = product.count) == null ? void 0 : _product$count2.initial);
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "product-customisation-modal",
    className: "product-customisation-modal " + (isEditMode && 'product-customisation-modal-edit'),
    children: [loading && /*#__PURE__*/jsxRuntime.jsx(Loading, {}), (menuState == null ? void 0 : menuState.matches('failure')) && /*#__PURE__*/jsxRuntime.jsx(Alert$1, {
      type: "danger",
      message: menuState.context.message
    }), (menuState == null ? void 0 : menuState.matches('success')) && /*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "product-customisation-modal-body",
      children: [isCustomisationHeaderEnabled && /*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
        title: t('productCustomisationModalHeaderTitle'),
        className: 'text-primary'
      }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisations$1, {
        className: "max-h-full overflow-y-auto",
        customisations: customisations,
        showPriceWarning: showPriceWarning,
        isAdditionalMessageEnabled: isAdditionalMessageEnabled,
        isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
        isCustomiseCategoryTitleEnabled: isCustomiseCategoryTitleEnabled,
        showAddonAvailability: showAddonAvailability,
        showModifierEnergyInformation: showModifierEnergyInformation,
        t: t,
        titleSeparator: titleSeparator,
        hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
        hidePriceWhenZero: hidePriceWhenZero,
        shouldChangeAddButtonText: shouldChangeAddButtonText,
        onOpenSubstitutionModal: handleOpenSubstitutionModal,
        staged: staged,
        formattedProduct: product,
        onEdit: handleEditProduct,
        isDeliverect: isDeliverectProvider
      }), /*#__PURE__*/jsxRuntime.jsx(ProductSubstitutionModal, {
        isOpen: isSubstitutionModalOpen,
        onClose: handleCloseSubstitutionModal,
        formattedSubstitutions: formattedSubstitutions,
        onSelect: handleSubstitutionSelect
      }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
        allowAction: allowOnConfirm,
        action: onConfirm,
        actionText: product != null && product.uid ? t('productCustomisationModalUpdateCartAction') : t('productCustomisationModalAddToCartAction'),
        closeModal: onCancel,
        closeText: t('productCustomisationModalCloseAction'),
        buttonsClassName: showQuantityControllerLabel ? 'mt-10' : '',
        spacer: showSpacer ? /*#__PURE__*/jsxRuntime.jsx(QuantityControllerOutlined, {
          t: t,
          staged: staged,
          showLabel: showQuantityControllerLabel,
          isCouponQuantityDisabled: isCouponQuantityDisabled
        }) : null
      })]
    })]
  });
};

var useProductOptionCustomisationModal = function useProductOptionCustomisationModal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    productCustomisation = _ref.productCustomisation,
    currentStaged = _ref.currentStaged,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$validateOptions = _ref.validateOptions,
    validateOptions = _ref$validateOptions === void 0 ? false : _ref$validateOptions;
  var _useStage = cart.useStage(),
    staged = _useStage.staged,
    stage = _useStage.stage;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t,
    i18n = _useLocaleSelection.i18n;
  var _ref2 = i18n || {},
    language = _ref2.language;
  var translateInline = translateProductName(language);
  var _useRestaurantMenu = useRestaurantMenu(),
    products = _useRestaurantMenu.products;
  var _useState = React.useState(false),
    isSubstitutionModalOpen = _useState[0],
    setIsSubstitutionModalOpen = _useState[1];
  var _useState2 = React.useState(null),
    selectedProductForSubstitution = _useState2[0],
    setSelectedProductForSubstitution = _useState2[1];
  var _useState3 = React.useState(null),
    pendingSubstitution = _useState3[0],
    setPendingSubstitution = _useState3[1];
  var substitute = React.useCallback(function (substitution) {
    if (!staged) return;
    if (!substitution) return;
    if (typeof staged.substitute !== 'function') return;
    staged.substitute(selectedProductForSubstitution, substitution);
  }, [staged, selectedProductForSubstitution]);
  var handleSubstitutionSelect = function handleSubstitutionSelect(product) {
    substitute(product);
    handleCloseSubstitutionModal();
  };
  var handleOpenSubstitutionModal = function handleOpenSubstitutionModal(product) {
    setSelectedProductForSubstitution(product);
    setIsSubstitutionModalOpen(true);
  };
  var handleCloseSubstitutionModal = function handleCloseSubstitutionModal() {
    setIsSubstitutionModalOpen(false);
    setSelectedProductForSubstitution(null);
  };
  React.useEffect(function () {
    // Handle substitutions that are pending
    if (selectedProductForSubstitution && pendingSubstitution) {
      substitute(_extends({}, pendingSubstitution, {
        "default": true
      }));
      setPendingSubstitution(null);
    }
  }, [selectedProductForSubstitution, pendingSubstitution, substitute]);
  var formattedSubstitutions = React.useMemo(function () {
    var _selectedProductForSu, _staged$options, _staged$options$filte, _staged$options$filte2, _staged$options$filte3, _staged$options$filte4, _staged$options$filte5, _staged$options$filte6;
    var substitutions = selectedProductForSubstitution == null ? void 0 : (_selectedProductForSu = selectedProductForSubstitution.providerData) == null ? void 0 : _selectedProductForSu.substitutions;
    if (!substitutions || !Array.isArray(substitutions)) return [];
    var _ref3 = selectedProductForSubstitution || {},
      isDefault = _ref3["default"];
    var stagedNames = (_staged$options = staged.options) == null ? void 0 : (_staged$options$filte = _staged$options.filter(function (option) {
      var _option$count;
      return (option == null ? void 0 : (_option$count = option.count) == null ? void 0 : _option$count.current) > 0;
    })) == null ? void 0 : (_staged$options$filte2 = _staged$options$filte.flatMap(function (option) {
      return option == null ? void 0 : option.products;
    })) == null ? void 0 : (_staged$options$filte3 = _staged$options$filte2.filter(function (product) {
      var _product$count;
      return (product == null ? void 0 : (_product$count = product.count) == null ? void 0 : _product$count.current) > 0;
    })) == null ? void 0 : (_staged$options$filte4 = _staged$options$filte3.flatMap(function (product) {
      return product == null ? void 0 : product.customisations;
    })) == null ? void 0 : (_staged$options$filte5 = _staged$options$filte4.filter(function (customisation) {
      return (customisation == null ? void 0 : customisation.type) === 'substitutable';
    })) == null ? void 0 : (_staged$options$filte6 = _staged$options$filte5.flatMap(function (customisation) {
      return customisation == null ? void 0 : customisation.products;
    })) == null ? void 0 : _staged$options$filte6.map(function (product) {
      var _product$name;
      return (product == null ? void 0 : (_product$name = product.name) == null ? void 0 : _product$name.text) || '';
    });
    var result = substitutions.map(function (substitution) {
      var _product$name2;
      var productId = substitution.id;
      var product = products.find(function (p) {
        return (p == null ? void 0 : p.id) === productId;
      });

      // Prevent the same product to be included again
      if (stagedNames.includes(product == null ? void 0 : (_product$name2 = product.name) == null ? void 0 : _product$name2.text)) return null;
      return hydrateProductData(product, selectedProductForSubstitution, isDefault);
    }).filter(Boolean);
    return result;
  }, [selectedProductForSubstitution, products, staged]);
  var onConfirm = function onConfirm() {
    onConfirmCallback({
      updatedStaged: staged
    });
  };
  var translateProducts = React.useCallback(function (products) {
    if (products === void 0) {
      products = [];
    }
    return products.map(function (product) {
      var productWithFallback = filterImageUrlFallback(product);
      return _extends({}, productWithFallback, {
        title: translateInline(productWithFallback == null ? void 0 : productWithFallback.name)
      });
    });
  }, [translateInline]);
  React.useEffect(function () {
    if (!currentStaged) return;
    stage({
      staged: currentStaged
    });
  }, [currentStaged, stage]);
  var customisations = React.useMemo(function () {
    if (!staged) return [];
    if (!productCustomisation) return [];
    var _ref4 = productCustomisation || {},
      uid = _ref4.uid;
    return getOptionCustomisationsByUid({
      product: staged,
      uid: uid
    });
  }, [productCustomisation, staged]);
  var formattedCustomisations = React.useMemo(function () {
    return customisations == null ? void 0 : customisations.map(function (customisation) {
      return _extends({}, customisation, {
        title: translateInline(customisation == null ? void 0 : customisation.name),
        products: translateProducts(customisation == null ? void 0 : customisation.products)
      });
    });
  }, [customisations, translateInline, translateProducts]);
  var allowOnConfirm = React.useMemo(function () {
    var _staged$options2, _staged$options2$filt, _staged$options2$filt2, _staged$options2$filt3, _staged$options2$filt4, _staged$options2$filt5;
    var substitutableCustomisations = (staged == null ? void 0 : (_staged$options2 = staged.options) == null ? void 0 : (_staged$options2$filt = _staged$options2.filter(function (option) {
      var _option$count2;
      return (option == null ? void 0 : (_option$count2 = option.count) == null ? void 0 : _option$count2.current) > 0;
    })) == null ? void 0 : (_staged$options2$filt2 = _staged$options2$filt.flatMap(function (option) {
      return option == null ? void 0 : option.products;
    })) == null ? void 0 : (_staged$options2$filt3 = _staged$options2$filt2.filter(function (product) {
      var _product$count2;
      return (product == null ? void 0 : (_product$count2 = product.count) == null ? void 0 : _product$count2.current) > 0;
    })) == null ? void 0 : (_staged$options2$filt4 = _staged$options2$filt3.flatMap(function (product) {
      return product == null ? void 0 : product.customisations;
    })) == null ? void 0 : (_staged$options2$filt5 = _staged$options2$filt4.filter(function (customisation) {
      return (customisation == null ? void 0 : customisation.type) === 'substitutable';
    })) == null ? void 0 : _staged$options2$filt5.flatMap(function (customisation) {
      return customisation == null ? void 0 : customisation.products;
    })) || [];
    if (substitutableCustomisations.length === 0) {
      if (validateOptions) {
        var _staged$options3;
        return staged == null ? void 0 : (_staged$options3 = staged.options) == null ? void 0 : _staged$options3.some(function (opt) {
          var _opt$products;
          return opt == null ? void 0 : (_opt$products = opt.products) == null ? void 0 : _opt$products.some(function (prd) {
            return (prd == null ? void 0 : prd.id) === (productCustomisation == null ? void 0 : productCustomisation.id) && (prd == null ? void 0 : prd.ready);
          });
        });
      }
      return staged == null ? void 0 : staged.ready;
    }
    var allAvailable = substitutableCustomisations.every(function (product) {
      return (product == null ? void 0 : product.isAvailable) || false;
    });
    if (validateOptions) {
      var _staged$options4;
      var validOptions = staged == null ? void 0 : (_staged$options4 = staged.options) == null ? void 0 : _staged$options4.some(function (opt) {
        var _opt$products2;
        return opt == null ? void 0 : (_opt$products2 = opt.products) == null ? void 0 : _opt$products2.some(function (prd) {
          return (prd == null ? void 0 : prd.id) === (productCustomisation == null ? void 0 : productCustomisation.id) && (prd == null ? void 0 : prd.ready);
        });
      });
      return validOptions && allAvailable;
    }
    return (staged == null ? void 0 : staged.ready) && allAvailable;
  }, [staged, productCustomisation == null ? void 0 : productCustomisation.id, validateOptions]);
  var getCurrentStaged = React.useCallback(function () {
    return staged;
  }, [staged]);
  return {
    customisations: formattedCustomisations,
    onConfirm: onConfirm,
    t: t,
    allowOnConfirm: allowOnConfirm,
    isSubstitutionModalOpen: isSubstitutionModalOpen,
    handleOpenSubstitutionModal: handleOpenSubstitutionModal,
    handleCloseSubstitutionModal: handleCloseSubstitutionModal,
    handleSubstitutionSelect: handleSubstitutionSelect,
    selectedProductForSubstitution: selectedProductForSubstitution,
    formattedSubstitutions: formattedSubstitutions,
    getCurrentStaged: getCurrentStaged
  };
};

var ProductOptionCustomisationModal = function ProductOptionCustomisationModal(_ref) {
  var currentStaged = _ref.currentStaged,
    productCustomisation = _ref.productCustomisation,
    _ref$ModalFooter = _ref.ModalFooter,
    ModalFooter$1 = _ref$ModalFooter === void 0 ? ModalFooter : _ref$ModalFooter,
    _ref$ModalHeader = _ref.ModalHeader,
    ModalHeader$1 = _ref$ModalHeader === void 0 ? ModalHeader : _ref$ModalHeader,
    _ref$ProductCustomisa = _ref.ProductCustomisations,
    ProductCustomisations$1 = _ref$ProductCustomisa === void 0 ? ProductCustomisations : _ref$ProductCustomisa,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$showSignaledForm = _ref.showSignaledFormatPrice,
    showSignaledFormatPrice = _ref$showSignaledForm === void 0 ? true : _ref$showSignaledForm,
    _ref$isCustomisationH = _ref.isCustomisationHeaderEnabled,
    isCustomisationHeaderEnabled = _ref$isCustomisationH === void 0 ? false : _ref$isCustomisationH,
    _ref$isCustomiseCateg = _ref.isCustomiseCategoryTitleEnabled,
    isCustomiseCategoryTitleEnabled = _ref$isCustomiseCateg === void 0 ? true : _ref$isCustomiseCateg,
    _ref$isCategoryTotali = _ref.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref$isCategoryTotali === void 0 ? true : _ref$isCategoryTotali,
    _ref$isAdditionalMess = _ref.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref$isAdditionalMess === void 0 ? true : _ref$isAdditionalMess,
    _ref$isUpdateMode = _ref.isUpdateMode,
    isUpdateMode = _ref$isUpdateMode === void 0 ? false : _ref$isUpdateMode,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$hidePriceWhenQua = _ref.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref$hidePriceWhenQua === void 0 ? false : _ref$hidePriceWhenQua,
    _ref$hidePriceWhenZer = _ref.hidePriceWhenZero,
    hidePriceWhenZero = _ref$hidePriceWhenZer === void 0 ? false : _ref$hidePriceWhenZer,
    _ref$validateOptions = _ref.validateOptions,
    validateOptions = _ref$validateOptions === void 0 ? false : _ref$validateOptions;
  var _useProductOptionCust = useProductOptionCustomisationModal({
      currentStaged: currentStaged,
      productCustomisation: productCustomisation,
      onConfirmCallback: onConfirmCallback,
      validateOptions: validateOptions
    }),
    customisations = _useProductOptionCust.customisations,
    t = _useProductOptionCust.t,
    onConfirm = _useProductOptionCust.onConfirm,
    allowOnConfirm = _useProductOptionCust.allowOnConfirm,
    isSubstitutionModalOpen = _useProductOptionCust.isSubstitutionModalOpen,
    handleOpenSubstitutionModal = _useProductOptionCust.handleOpenSubstitutionModal,
    handleCloseSubstitutionModal = _useProductOptionCust.handleCloseSubstitutionModal,
    handleSubstitutionSelect = _useProductOptionCust.handleSubstitutionSelect,
    formattedSubstitutions = _useProductOptionCust.formattedSubstitutions,
    getCurrentStaged = _useProductOptionCust.getCurrentStaged;
  var staged = getCurrentStaged();
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: customisations.length > 0 && /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-customisation-modal",
      className: "flex flex-col max-h-full",
      children: [isCustomisationHeaderEnabled && /*#__PURE__*/jsxRuntime.jsx(ModalHeader$1, {
        title: t('productCustomisationModalHeaderTitle'),
        className: 'text-primary'
      }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisations$1, {
        customisations: customisations,
        className: "max-h-full overflow-y-auto",
        showPriceWarning: showPriceWarning,
        showSignaledFormatPrice: showSignaledFormatPrice,
        isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
        isAdditionalMessageEnabled: isAdditionalMessageEnabled,
        showAddonAvailability: showAddonAvailability,
        isCustomiseCategoryTitleEnabled: isCustomiseCategoryTitleEnabled,
        t: t,
        hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
        hidePriceWhenZero: hidePriceWhenZero,
        onOpenSubstitutionModal: handleOpenSubstitutionModal,
        staged: staged
      }), /*#__PURE__*/jsxRuntime.jsx(ProductSubstitutionModal, {
        isOpen: isSubstitutionModalOpen,
        onClose: handleCloseSubstitutionModal,
        formattedSubstitutions: formattedSubstitutions,
        onSelect: handleSubstitutionSelect
      }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter$1, {
        allowAction: allowOnConfirm,
        closeText: t('productOptionCustomisationModalCloseAction'),
        closeModal: onCloseCallback,
        action: onConfirm,
        actionText: isUpdateMode ? t('productOptionCustomisationModalUpdateCartAction') : t('productOptionCustomisationModalAddToCartAction')
      })]
    })
  });
};

var ProductOptionCustomisationModal$1 = function ProductOptionCustomisationModal(_ref) {
  var currentStaged = _ref.currentStaged,
    productCustomisation = _ref.productCustomisation,
    _ref$ModalFooter = _ref.ModalFooter,
    ModalFooter$1 = _ref$ModalFooter === void 0 ? ModalFooter : _ref$ModalFooter,
    _ref$ModalHeader = _ref.ModalHeader,
    ModalHeader$1 = _ref$ModalHeader === void 0 ? ModalHeader : _ref$ModalHeader,
    _ref$ProductCustomisa = _ref.ProductCustomisations,
    ProductCustomisations$1 = _ref$ProductCustomisa === void 0 ? ProductCustomisations : _ref$ProductCustomisa,
    _ref$showPriceWarning = _ref.showPriceWarning,
    showPriceWarning = _ref$showPriceWarning === void 0 ? true : _ref$showPriceWarning,
    _ref$showSignaledForm = _ref.showSignaledFormatPrice,
    showSignaledFormatPrice = _ref$showSignaledForm === void 0 ? true : _ref$showSignaledForm,
    _ref$isCustomisationH = _ref.isCustomisationHeaderEnabled,
    isCustomisationHeaderEnabled = _ref$isCustomisationH === void 0 ? false : _ref$isCustomisationH,
    _ref$isCustomiseCateg = _ref.isCustomiseCategoryTitleEnabled,
    isCustomiseCategoryTitleEnabled = _ref$isCustomiseCateg === void 0 ? true : _ref$isCustomiseCateg,
    _ref$isCategoryTotali = _ref.isCategoryTotalizerEnabled,
    isCategoryTotalizerEnabled = _ref$isCategoryTotali === void 0 ? true : _ref$isCategoryTotali,
    _ref$isAdditionalMess = _ref.isAdditionalMessageEnabled,
    isAdditionalMessageEnabled = _ref$isAdditionalMess === void 0 ? true : _ref$isAdditionalMess,
    _ref$isUpdateMode = _ref.isUpdateMode,
    isUpdateMode = _ref$isUpdateMode === void 0 ? false : _ref$isUpdateMode,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$showAddonAvailab = _ref.showAddonAvailability,
    showAddonAvailability = _ref$showAddonAvailab === void 0 ? false : _ref$showAddonAvailab,
    _ref$hidePriceWhenQua = _ref.hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenQuantityLessOrEqualDefault = _ref$hidePriceWhenQua === void 0 ? false : _ref$hidePriceWhenQua,
    _ref$hidePriceWhenZer = _ref.hidePriceWhenZero,
    hidePriceWhenZero = _ref$hidePriceWhenZer === void 0 ? false : _ref$hidePriceWhenZer,
    _ref$validateOptions = _ref.validateOptions,
    validateOptions = _ref$validateOptions === void 0 ? false : _ref$validateOptions,
    _ref$titleSeparator = _ref.titleSeparator,
    titleSeparator = _ref$titleSeparator === void 0 ? ' ' : _ref$titleSeparator;
  var _useProductOptionCust = useProductOptionCustomisationModal({
      currentStaged: currentStaged,
      productCustomisation: productCustomisation,
      onConfirmCallback: onConfirmCallback,
      validateOptions: validateOptions
    }),
    customisations = _useProductOptionCust.customisations,
    t = _useProductOptionCust.t,
    onConfirm = _useProductOptionCust.onConfirm,
    allowOnConfirm = _useProductOptionCust.allowOnConfirm,
    isSubstitutionModalOpen = _useProductOptionCust.isSubstitutionModalOpen,
    handleOpenSubstitutionModal = _useProductOptionCust.handleOpenSubstitutionModal,
    handleCloseSubstitutionModal = _useProductOptionCust.handleCloseSubstitutionModal,
    handleSubstitutionSelect = _useProductOptionCust.handleSubstitutionSelect,
    formattedSubstitutions = _useProductOptionCust.formattedSubstitutions,
    getCurrentStaged = _useProductOptionCust.getCurrentStaged;
  var staged = getCurrentStaged();
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: customisations.length > 0 && /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "product-customisation-modal",
      className: "product-option-customisation-modal",
      children: [isCustomisationHeaderEnabled && /*#__PURE__*/jsxRuntime.jsx(ModalHeader$1, {
        title: t('productCustomisationModalHeaderTitle'),
        className: "product-option-customisation-modal__header"
      }), /*#__PURE__*/jsxRuntime.jsx(ProductCustomisations$1, {
        customisations: customisations,
        className: "product-option-customisation-modal__customisations",
        showPriceWarning: showPriceWarning,
        showSignaledFormatPrice: showSignaledFormatPrice,
        isCategoryTotalizerEnabled: isCategoryTotalizerEnabled,
        isAdditionalMessageEnabled: isAdditionalMessageEnabled,
        showAddonAvailability: showAddonAvailability,
        isCustomiseCategoryTitleEnabled: isCustomiseCategoryTitleEnabled,
        t: t,
        hidePriceWhenQuantityLessOrEqualDefault: hidePriceWhenQuantityLessOrEqualDefault,
        hidePriceWhenZero: hidePriceWhenZero,
        onOpenSubstitutionModal: handleOpenSubstitutionModal,
        staged: staged,
        titleSeparator: titleSeparator
      }), /*#__PURE__*/jsxRuntime.jsx(ProductSubstitutionModal, {
        isOpen: isSubstitutionModalOpen,
        onClose: handleCloseSubstitutionModal,
        formattedSubstitutions: formattedSubstitutions,
        onSelect: handleSubstitutionSelect
      }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter$1, {
        allowAction: allowOnConfirm,
        closeText: t('productOptionCustomisationModalCloseAction'),
        closeModal: onCloseCallback,
        action: onConfirm,
        actionText: isUpdateMode ? t('productOptionCustomisationModalUpdateCartAction') : t('productOptionCustomisationModalAddToCartAction')
      })]
    })
  });
};

var MiniCartModal$1 = function MiniCartModal(_ref) {
  var _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? function () {} : _ref$onCloseCallback,
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    _ref$disableModifyUps = _ref.disableModifyUpsellOnCart,
    disableModifyUpsellOnCart = _ref$disableModifyUps === void 0 ? false : _ref$disableModifyUps,
    _ref$isCouponQuantity = _ref.isCouponQuantityDisabled,
    isCouponQuantityDisabled = _ref$isCouponQuantity === void 0 ? false : _ref$isCouponQuantity,
    _ref$hideDisabledButt = _ref.hideDisabledButtons,
    hideDisabledButtons = _ref$hideDisabledButt === void 0 ? false : _ref$hideDisabledButt;
  var _useMiniCartModal = useMiniCartModal({
      origin: origin,
      onCloseCallback: onCloseCallback,
      onConfirmCallback: onConfirmCallback
    }),
    t = _useMiniCartModal.t,
    onEditProductHandler = _useMiniCartModal.onEditProductHandler,
    formattedSecondaryCart = _useMiniCartModal.formattedSecondaryCart,
    total = _useMiniCartModal.total,
    onClose = _useMiniCartModal.onClose,
    onConfirm = _useMiniCartModal.onConfirm,
    formatPrice = _useMiniCartModal.formatPrice;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
      title: t('cartTitle'),
      total: total
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "mini-cart-modal",
      id: "mini-cart-modal",
      className: "mini-cart-modal-body",
      children: formattedSecondaryCart && formattedSecondaryCart.map(function (product, i) {
        return /*#__PURE__*/jsxRuntime.jsx(CartProduct, {
          product: product,
          t: t,
          onEditProductHandler: onEditProductHandler,
          changeText: t('cartChangeAction'),
          removeText: t('cartRemoveAction'),
          formatPrice: formatPrice,
          disableModifyUpsellOnCart: disableModifyUpsellOnCart,
          isCouponQuantityDisabled: isCouponQuantityDisabled,
          hideDisabledButtons: hideDisabledButtons
        }, "cart-product-" + i);
      })
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      action: onConfirm,
      actionText: t('miniCartNextAction'),
      closeModal: onClose,
      closeText: t('miniCartCloseAction')
    })]
  });
};

var ProductAnimationSpawn$1 = function ProductAnimationSpawn(_ref) {
  var _ref$Card = _ref.Card,
    Card = _ref$Card === void 0 ? GalleryCard : _ref$Card;
  var _useProductAnimationS = useProductAnimationSpawn(),
    animateProps = _useProductAnimationS.animateProps,
    transitionProps = _useProductAnimationS.transitionProps;
  return animateProps.map(function (animateProp, index) {
    return /*#__PURE__*/jsxRuntime.jsx(framerMotion.motion.div, {
      className: "product-animation-spawn",
      animate: animateProp == null ? void 0 : animateProp.animateConfig,
      transition: transitionProps,
      style: animateProp == null ? void 0 : animateProp.styleProps,
      children: /*#__PURE__*/jsxRuntime.jsx(Card, _extends({}, animateProp == null ? void 0 : animateProp.product, {
        isAnimated: true
      }))
    }, index);
  });
};

var useFallbackRender = function useFallbackRender(_ref) {
  var _ref$errorHandler = _ref.errorHandler,
    errorHandler = _ref$errorHandler === void 0 ? null : _ref$errorHandler,
    _ref$resetHandler = _ref.resetHandler,
    resetHandler = _ref$resetHandler === void 0 ? null : _ref$resetHandler;
  var onReset = function onReset() {
    if (resetHandler) return resetHandler();
    return window.location.href = '/reset';
  };
  var onError = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(error, info) {
      var errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            errorMessage = (error == null ? void 0 : error.message) || 'Caught error with no message:';
            logger.error("[cringer.components] - Oops Screen - " + errorMessage, error, info);
            _context.next = 4;
            return logger.resetLogs();
          case 4:
            if (!errorHandler) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", errorHandler());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onError(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    onError: onError,
    onReset: onReset
  };
};

var Fallback = function Fallback(_ref) {
  var _ref$resetErrorBounda = _ref.resetErrorBoundary,
    resetErrorBoundary = _ref$resetErrorBounda === void 0 ? function () {} : _ref$resetErrorBounda,
    brandHeader = _ref.brandHeader;
  var _useState = React.useState(15),
    countdown = _useState[0],
    setCountdown = _useState[1];
  React.useEffect(function () {
    var countdownInterval = setInterval(function () {
      setCountdown(function (prevCountdown) {
        return prevCountdown - 1;
      });
    }, 1000);
    return function () {
      return clearInterval(countdownInterval);
    };
  }, []);
  React.useEffect(function () {
    if (countdown === 0) {
      resetErrorBoundary();
    }
  }, [countdown, resetErrorBoundary]);
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    id: "app",
    children: /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "flex flex-col justify-between h-screen",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        id: "accessibility",
        className: "absolute bottom-0 flex flex-col w-full h-full overflow-y-hidden accessibility-static",
        "data-test": "accessibility-wrapper",
        children: [brandHeader && /*#__PURE__*/jsxRuntime.jsx("div", {
          "data-test": "brand-header",
          className: "brand-header",
          children: brandHeader
        }), /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "flex flex-col w-screen h-full",
          children: /*#__PURE__*/jsxRuntime.jsx("div", {
            className: "flex flex-col h-full overflow-auto",
            children: /*#__PURE__*/jsxRuntime.jsxs("div", {
              "data-test": "warning",
              className: "flex flex-col items-center justify-center w-full h-full",
              children: [/*#__PURE__*/jsxRuntime.jsx("p", {
                "data-test": "warning-text",
                className: "mb-8 text-3xl font-bold text-center md:text-5xl",
                children: "Oops, looks like something went wrong"
              }), /*#__PURE__*/jsxRuntime.jsx("p", {
                className: "mb-8 text-2xl md:text-4xl",
                children: "Redirecting in " + countdown + " seconds..."
              }), countdown > 0 && /*#__PURE__*/jsxRuntime.jsx(SecondaryButton, {
                "data-test": "reset-btn",
                onClick: resetErrorBoundary,
                children: "Reset"
              })]
            })
          })
        })]
      })
    })
  });
};
var FallbackRender = function FallbackRender(_ref2) {
  var _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? null : _ref2$children,
    _ref2$resetHandler = _ref2.resetHandler,
    resetHandler = _ref2$resetHandler === void 0 ? null : _ref2$resetHandler,
    _ref2$errorHandler = _ref2.errorHandler,
    errorHandler = _ref2$errorHandler === void 0 ? null : _ref2$errorHandler,
    _ref2$brandHeader = _ref2.brandHeader,
    brandHeader = _ref2$brandHeader === void 0 ? null : _ref2$brandHeader;
  var _useFallbackRender = useFallbackRender({
      resetHandler: resetHandler,
      errorHandler: errorHandler
    }),
    onReset = _useFallbackRender.onReset,
    onError = _useFallbackRender.onError;
  return /*#__PURE__*/jsxRuntime.jsx(reactErrorBoundary.ErrorBoundary, {
    fallbackRender: function fallbackRender(props) {
      return /*#__PURE__*/jsxRuntime.jsx(Fallback, _extends({}, props, {
        brandHeader: brandHeader
      }));
    },
    onError: onError,
    onReset: onReset,
    children: children
  });
};

var ProductComboPrice = function ProductComboPrice(_ref) {
  var _promoItem$pointsCost, _formattedProduct$pri, _formattedProduct$pri2;
  var formattedProduct = _ref.formattedProduct,
    formatPrice = _ref.formatPrice,
    RewardPointsComponent = _ref.RewardPointsComponent,
    showEnergyInformation = _ref.showEnergyInformation;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    _useOffersAndRewardsM2 = _useOffersAndRewardsM.loading,
    loading = _useOffersAndRewardsM2 === void 0 ? false : _useOffersAndRewardsM2,
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  if (loading) {
    return null;
  }
  var promoItem = getPromoItem({
    productId: formattedProduct.productId
  });
  var pointsCost = (_promoItem$pointsCost = promoItem == null ? void 0 : promoItem.pointsCost) != null ? _promoItem$pointsCost : 0;
  var hasPrice = formattedProduct != null && (_formattedProduct$pri = formattedProduct.price) != null && _formattedProduct$pri.current ? true : false;
  var points = pointsCost ? /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
    pointsCost: pointsCost
  }, "rewardPoints") : null;
  var pointsAndPriceSeparator = pointsCost && hasPrice ? /*#__PURE__*/jsxRuntime.jsx("span", {
    children: "+"
  }) : null;
  var priceAndEnergyInformation = formattedProduct != null && (_formattedProduct$pri2 = formattedProduct.price) != null && _formattedProduct$pri2.current ? /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex-col",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      children: formatPrice({
        price: formattedProduct.price.current
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      children: showEnergyInformation && (formattedProduct == null ? void 0 : formattedProduct.calculatedEnergyInformation)
    })]
  }, "price") : null;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex items-center gap-2",
    children: [points, pointsAndPriceSeparator, priceAndEnergyInformation]
  });
};

var ProductComboPrice$1 = function ProductComboPrice(_ref) {
  var _promoItem$pointsCost, _formattedProduct$pri, _formattedProduct$pri2;
  var formattedProduct = _ref.formattedProduct,
    formatPrice = _ref.formatPrice,
    RewardPointsComponent = _ref.RewardPointsComponent,
    showEnergyInformation = _ref.showEnergyInformation;
  var _useOffersAndRewardsM = useOffersAndRewardsMenu(),
    _useOffersAndRewardsM2 = _useOffersAndRewardsM.loading,
    loading = _useOffersAndRewardsM2 === void 0 ? false : _useOffersAndRewardsM2,
    getPromoItem = _useOffersAndRewardsM.getPromoItem;
  if (loading) {
    return null;
  }
  var promoItem = getPromoItem({
    productId: formattedProduct.productId
  });
  var pointsCost = (_promoItem$pointsCost = promoItem == null ? void 0 : promoItem.pointsCost) != null ? _promoItem$pointsCost : 0;
  var hasPrice = formattedProduct != null && (_formattedProduct$pri = formattedProduct.price) != null && _formattedProduct$pri.current ? true : false;
  var points = pointsCost ? /*#__PURE__*/jsxRuntime.jsx(RewardPointsComponent, {
    pointsCost: pointsCost
  }, "rewardPoints") : null;
  var pointsAndPriceSeparator = pointsCost && hasPrice ? /*#__PURE__*/jsxRuntime.jsx("span", {
    children: "+"
  }) : null;
  var priceAndEnergyInformation = formattedProduct != null && (_formattedProduct$pri2 = formattedProduct.price) != null && _formattedProduct$pri2.current ? /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "product-combo-price--content",
    children: [/*#__PURE__*/jsxRuntime.jsx("div", {
      children: formatPrice({
        price: formattedProduct.price.current
      })
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      children: showEnergyInformation && (formattedProduct == null ? void 0 : formattedProduct.calculatedEnergyInformation)
    })]
  }, "price") : null;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "product-combo-price",
    children: [points, pointsAndPriceSeparator, priceAndEnergyInformation]
  });
};

var SummarySection$1 = function SummarySection(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$rightTitle = _ref.rightTitle,
    rightTitle = _ref$rightTitle === void 0 ? '' : _ref$rightTitle;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "summary-section " + className,
    "data-test": "summary-section",
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "summary-section-title",
      children: [title && /*#__PURE__*/jsxRuntime.jsx("div", {
        children: title
      }), rightTitle && /*#__PURE__*/jsxRuntime.jsx("div", {
        children: rightTitle
      })]
    }), children]
  });
};

var Banner = function Banner(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$subTitle = _ref.subTitle,
    subTitle = _ref$subTitle === void 0 ? '' : _ref$subTitle,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "banner",
    className: "banner-wrapper",
    children: [image && /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
      "data-test": "banner-image",
      className: "banner-image",
      src: image,
      alt: "Banner",
      placeholder: placeholder
    }), /*#__PURE__*/jsxRuntime.jsxs("div", {
      "data-test": "banner-content",
      className: "banner-content",
      children: [/*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "banner-title",
        className: "banner-title",
        children: title.substring(0, 50)
      }), /*#__PURE__*/jsxRuntime.jsx("p", {
        "data-test": "banner-subtitle",
        className: "banner-subtitle",
        children: subTitle.substring(0, 250)
      })]
    })]
  });
};

var replaceLastComma = function replaceLastComma(string, replacement) {
  if (replacement === void 0) {
    replacement = 'and';
  }
  var lastCommaIndex = string.lastIndexOf(',');
  return lastCommaIndex > -1 ? string.substring(0, lastCommaIndex) + (" " + replacement + " ") + string.substring(lastCommaIndex + 1) : string;
};
var useAddonRemovedModalHook = function useAddonRemovedModalHook() {
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _usePrice = usePrice(),
    formatPrice = _usePrice.formatPrice;
  var removedUpsells = recoil.useRecoilValue(atoms.removedUpsellState);
  var upsellProductsText = removedUpsells.map(function (item) {
    return item.upsell.name.text;
  }).join(', ');
  var mainProductsText = lodash.uniqBy(removedUpsells.flatMap(function (item) {
    return item.mainProducts.map(function (main) {
      return main.nameText;
    });
  })).join(', ');
  return {
    t: t,
    formatPrice: formatPrice,
    upsellProducts: removedUpsells.map(function (item) {
      return item.upsell;
    }),
    upsellProductsText: replaceLastComma(upsellProductsText, 'and'),
    mainProductsText: replaceLastComma(mainProductsText, 'or')
  };
};

var UpsellProductRow = function UpsellProductRow(_ref) {
  var imageUrl = _ref.imageUrl,
    displayName = _ref.displayName,
    price = _ref.price;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex w-full px-4 my-8 shadow-md max-h-36",
    children: [/*#__PURE__*/jsxRuntime.jsx("span", {
      className: "w-1/5 pr-4",
      children: /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
        className: "",
        src: imageUrl,
        alt: displayName
      })
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "self-center flex-1",
      children: displayName
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "self-center",
      children: price
    })]
  });
};
var AddonRemovedModal = function AddonRemovedModal(_ref2) {
  var _ref2$onCloseCallback = _ref2.onCloseCallback,
    onCloseCallback = _ref2$onCloseCallback === void 0 ? function () {} : _ref2$onCloseCallback;
  var _useAddonRemovedModal = useAddonRemovedModalHook(),
    t = _useAddonRemovedModal.t,
    upsellProducts = _useAddonRemovedModal.upsellProducts,
    formatPrice = _useAddonRemovedModal.formatPrice,
    mainProductsText = _useAddonRemovedModal.mainProductsText;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
      title: t('addonRemovedModalTitle')
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "addon-removed-cart-modal",
      id: "addon-removed-cart-modal",
      className: "max-h-full p-2 space-y-8 overflow-y-auto md:p-8 overscroll-auto",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "text-3xl modal-text modal-content",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "pb-2",
          children: t('addonRemovedMessage')
        }), upsellProducts.map(function (item) {
          return /*#__PURE__*/jsxRuntime.jsx(UpsellProductRow, {
            imageUrl: item.imageUrl,
            displayName: item.name.text,
            price: formatPrice({
              price: item.price.current
            })
          }, item.id);
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "pb-2",
          children: t('addonRemovedFooterMessage') + " \u201C" + mainProductsText + "\u201D"
        })]
      })
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      closeModal: onCloseCallback,
      closeText: 'Dismiss'
    })]
  });
};

var UpsellProductRow$1 = function UpsellProductRow(_ref) {
  var imageUrl = _ref.imageUrl,
    displayName = _ref.displayName,
    price = _ref.price;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "upsell-product",
    children: [/*#__PURE__*/jsxRuntime.jsx("span", {
      className: "upsell-product__image",
      children: /*#__PURE__*/jsxRuntime.jsx(LoadableImage$1, {
        src: imageUrl,
        alt: displayName
      })
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "upsell-product__name",
      children: displayName
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "upsell-product__price",
      children: price
    })]
  });
};
var AddonRemovedModal$1 = function AddonRemovedModal(_ref2) {
  var _ref2$onCloseCallback = _ref2.onCloseCallback,
    onCloseCallback = _ref2$onCloseCallback === void 0 ? function () {} : _ref2$onCloseCallback;
  var _useAddonRemovedModal = useAddonRemovedModalHook(),
    t = _useAddonRemovedModal.t,
    upsellProducts = _useAddonRemovedModal.upsellProducts,
    formatPrice = _useAddonRemovedModal.formatPrice,
    mainProductsText = _useAddonRemovedModal.mainProductsText;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(ModalHeader, {
      title: t('addonRemovedModalTitle')
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "addon-removed-cart-modal",
      id: "addon-removed-cart-modal",
      className: "addon-removed-modal",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "addon-removed-modal__content",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "addon-removed-modal__message",
          children: t('addonRemovedMessage')
        }), upsellProducts.map(function (item) {
          return /*#__PURE__*/jsxRuntime.jsx(UpsellProductRow$1, {
            imageUrl: item.imageUrl,
            displayName: item.name.text,
            price: formatPrice({
              price: item.price.current
            })
          }, item.id);
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "addon-removed-modal__footer-message",
          children: t('addonRemovedFooterMessage') + " \u201C" + mainProductsText + "\u201D"
        })]
      })
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      closeModal: onCloseCallback,
      closeText: t('upsellModalCloseAction')
    })]
  });
};

var useOutOfStockModal = function useOutOfStockModal(_ref) {
  var product = _ref.product,
    staged = _ref.staged,
    _ref$onConfirmCallbac = _ref.onConfirmCallback,
    onConfirmCallback = _ref$onConfirmCallbac === void 0 ? function () {} : _ref$onConfirmCallbac;
  var _useLocaleSelection = useLocaleSelection(),
    t = _useLocaleSelection.t;
  var _useAnalytics = jitsu.useAnalytics(),
    productAddedToCartTrack = _useAnalytics.productAddedToCartTrack,
    orderUpdatedTrack = _useAnalytics.orderUpdatedTrack,
    itemSelectTrack = _useAnalytics.itemSelectTrack;
  var _useSettings = utilities.useSettings(),
    settings = _useSettings.settings;
  var _useRestaurantMenu = useRestaurantMenu(),
    products = _useRestaurantMenu.products;
  var setUpsellState = recoil.useSetRecoilState(atoms.upsellState);
  var session = recoil.useRecoilValue(atoms.sessionState);
  var trackedUpsells = recoil.useRecoilValue(atoms.trackedUpsellsState);
  var couponNumber = recoil.useRecoilValue(atoms.couponNumberState);
  var currentCategory = recoil.useRecoilValue(atoms.currentCategoryState);
  var kioskSettings = recoil.useRecoilValue(atoms.formattedSettingsState);
  var cartItems = recoil.useRecoilValue(cart.formattedCartState);
  var _ref2 = session || {},
    sessionId = _ref2.id;
  var onConfirm = function onConfirm() {
    var isUpsell = trackedUpsells.includes(product.id);
    registerAddedToCart({
      setUpsellState: setUpsellState
    }, {
      sessionId: sessionId,
      settings: settings,
      product: product,
      staged: staged,
      upsell: isUpsell ? 'upsell' : 'normal'
    });
    if (!isUpsell) {
      itemSelectTrack == null ? void 0 : itemSelectTrack(staged, cartItems, kioskSettings.kiosk, couponNumber, currentCategory);
      if (!product.uid) productAddedToCartTrack(_extends({}, staged, {
        isCrossSell: product.isCrossSell
      }), kioskSettings.kiosk, couponNumber, currentCategory);
    }
    if (product.uid) orderUpdatedTrack();
    onConfirmCallback({
      staged: staged,
      product: product,
      animate: product.uid ? false : true,
      uid: product.uid
    });
  };
  var unavailableProducts = React.useMemo(function () {
    if (!staged) return [];
    if ((staged == null ? void 0 : staged.type) === types.ProductType.CUSTOMISE) {
      var _staged$customisation, _staged$customisation2;
      var unavailableDefaultCustomisationIds = (_staged$customisation = (_staged$customisation2 = staged.customisations) == null ? void 0 : _staged$customisation2.flatMap(function (category) {
        var _category$products;
        return (_category$products = category.products) != null ? _category$products : [];
      }).filter(function (p) {
        return (p == null ? void 0 : p["default"]) && !p.isAvailable;
      }).map(function (item) {
        return item.id;
      })) != null ? _staged$customisation : [];
      return products.filter(function (p) {
        return unavailableDefaultCustomisationIds.includes(p.productId);
      });
    } else if ((staged == null ? void 0 : staged.type) === types.ProductType.COMBO) {
      var _staged$options$flatM, _staged$options, _staged$options$flatM2, _staged$options$flatM3, _staged$options$flatM4;
      var unavailableDefaultComboItems = (_staged$options$flatM = staged == null ? void 0 : (_staged$options = staged.options) == null ? void 0 : (_staged$options$flatM2 = _staged$options.flatMap(function (op) {
        return op.products;
      })) == null ? void 0 : (_staged$options$flatM3 = _staged$options$flatM2.flatMap(function (p) {
        var _p$customisations;
        return (_p$customisations = p.customisations) != null ? _p$customisations : [];
      })) == null ? void 0 : (_staged$options$flatM4 = _staged$options$flatM3.flatMap(function (customisation) {
        var _customisation$produc;
        return (_customisation$produc = customisation.products) != null ? _customisation$produc : [];
      })) == null ? void 0 : _staged$options$flatM4.filter(function (p) {
        return (p == null ? void 0 : p["default"]) && !p.isAvailable;
      }).map(function (item) {
        return item.id;
      })) != null ? _staged$options$flatM : [];
      return products.filter(function (p) {
        return unavailableDefaultComboItems.includes(p.productId);
      });
    }
  }, [staged, products]);
  return {
    t: t,
    onConfirm: onConfirm,
    unavailableProducts: unavailableProducts
  };
};

var RecipeProductRow = function RecipeProductRow(_ref) {
  var imageUrl = _ref.imageUrl,
    displayName = _ref.displayName;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    className: "flex w-full px-4 my-8 shadow-md max-h-36",
    children: [/*#__PURE__*/jsxRuntime.jsx("span", {
      className: "w-1/5 pr-4",
      children: /*#__PURE__*/jsxRuntime.jsx(LoadableImage, {
        className: "",
        src: imageUrl,
        alt: displayName
      })
    }), /*#__PURE__*/jsxRuntime.jsx("span", {
      className: "self-center flex-1",
      children: displayName
    })]
  });
};
var CustomModalHeader = function CustomModalHeader(_ref2) {
  var _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title;
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    "data-test": "modal-header",
    className: "out-of-stock-modal-header",
    children: [/*#__PURE__*/jsxRuntime.jsx(ExclamationCircle, {
      className: "w-8 h-8 text-orange sm:w-16 sm:h-16 mr-3"
    }), /*#__PURE__*/jsxRuntime.jsx("h3", {
      className: "text-2xl md:text-5xl font-bold font-header modal-header",
      children: title
    })]
  });
};
var OutOfStockModal = function OutOfStockModal(_ref3) {
  var product = _ref3.product,
    staged = _ref3.staged,
    _ref3$onCloseCallback = _ref3.onCloseCallback,
    onCloseCallback = _ref3$onCloseCallback === void 0 ? function () {} : _ref3$onCloseCallback,
    _ref3$onConfirmCallba = _ref3.onConfirmCallback,
    onConfirmCallback = _ref3$onConfirmCallba === void 0 ? function () {} : _ref3$onConfirmCallba,
    _ref3$onCloseProductC = _ref3.onCloseProductCustomisationModal,
    onCloseProductCustomisationModal = _ref3$onCloseProductC === void 0 ? function () {} : _ref3$onCloseProductC;
  var _useOutOfStockModal = useOutOfStockModal({
      product: product,
      staged: staged,
      onConfirmCallback: onConfirmCallback
    }),
    t = _useOutOfStockModal.t,
    onConfirm = _useOutOfStockModal.onConfirm,
    unavailableProducts = _useOutOfStockModal.unavailableProducts;
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsx(CustomModalHeader, {
      title: t('headsUpModalTitle')
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      "data-test": "out-of-stock-modal",
      id: "out-of-stock-modal",
      className: "max-h-full p-2 space-y-8 overflow-y-auto md:p-8 overscroll-auto",
      children: /*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "text-3xl modal-text py-2",
        children: [/*#__PURE__*/jsxRuntime.jsx("p", {
          className: "pb-2",
          children: t('headsUpModalMessage')
        }), unavailableProducts.map(function (item) {
          return /*#__PURE__*/jsxRuntime.jsx(RecipeProductRow, {
            imageUrl: item.imageUrl,
            displayName: item.name.text
          }, item.id);
        }), /*#__PURE__*/jsxRuntime.jsx("p", {
          className: "pt-2",
          children: t('headsUpModalFooterMessage')
        })]
      })
    }), /*#__PURE__*/jsxRuntime.jsx(ModalFooter, {
      closeModal: function closeModal() {
        onCloseCallback();
        onCloseProductCustomisationModal();
      },
      closeText: 'Cancel',
      action: onConfirm,
      actionText: 'Proceed',
      spacer: true
    })]
  });
};

var HomePageCustomisationContext = /*#__PURE__*/React.createContext();
var useHomePageCustomisationContext = function useHomePageCustomisationContext() {
  var context = React.useContext(HomePageCustomisationContext);
  if (!context) {
    throw new Error('useHomePageCustomisationContext must be used within a <CoreHomePageCustomisationProvider/>');
  }
  return context;
};

var ScreenType = {
  DEFAULT: 'DEFAULT',
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};
var useBackgroundComponent = function useBackgroundComponent(_ref) {
  var _fallback$background2;
  var _ref$customisation = _ref.customisation,
    customisation = _ref$customisation === void 0 ? {} : _ref$customisation,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _useRecoilValue = recoil.useRecoilValue(atoms.settingsState),
    _useRecoilValue$setti = _useRecoilValue.settings,
    settings = _useRecoilValue$setti === void 0 ? {} : _useRecoilValue$setti;
  var isSecondaryHome = settings.content.homeBurger;
  var background = React.useMemo(function () {
    var _ref2 = (customisation == null ? void 0 : customisation.customisations) || {},
      _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? [] : _ref2$background;
    var defaultBackground = background == null ? void 0 : background.find(function (_ref3) {
      var type = _ref3.type;
      return type === ScreenType.DEFAULT;
    });
    var scheduledBackground = background == null ? void 0 : background.find(function (_ref4) {
      var startHour = _ref4.startHour,
        finishHour = _ref4.finishHour,
        type = _ref4.type;
      if (!startHour || !finishHour) return false;
      var now = new Date();
      var start = new Date(now);
      var finish = new Date(now);
      var _startHour$split$map = startHour.split(':').map(Number),
        startHours = _startHour$split$map[0],
        startMinutes = _startHour$split$map[1];
      var _finishHour$split$map = finishHour.split(':').map(Number),
        finishHours = _finishHour$split$map[0],
        finishMinutes = _finishHour$split$map[1];
      start.setHours(startHours, startMinutes, 0, 0);
      finish.setHours(finishHours, finishMinutes, 0, 0);
      var hasMatched = now >= start && now <= finish;
      return isSecondaryHome ? hasMatched && type === ScreenType.SECONDARY : hasMatched && type === ScreenType.PRIMARY;
    });
    return {
      defaultBackground: defaultBackground,
      scheduledBackground: scheduledBackground
    };
  }, [customisation, isSecondaryHome]);
  var media = React.useMemo(function () {
    var _scheduledBackground$, _defaultBackground$me;
    var _ref5 = background || {},
      _ref5$defaultBackgrou = _ref5.defaultBackground,
      defaultBackground = _ref5$defaultBackgrou === void 0 ? {} : _ref5$defaultBackgrou,
      _ref5$scheduledBackgr = _ref5.scheduledBackground,
      scheduledBackground = _ref5$scheduledBackgr === void 0 ? {} : _ref5$scheduledBackgr;
    var _ref6 = fallback.background || {},
      video = _ref6.video,
      image = _ref6.image;
    return (scheduledBackground == null ? void 0 : (_scheduledBackground$ = scheduledBackground.media) == null ? void 0 : _scheduledBackground$.url) || (defaultBackground == null ? void 0 : (_defaultBackground$me = defaultBackground.media) == null ? void 0 : _defaultBackground$me.url) || video || image;
  }, [background, fallback]);
  var enableVideoAudio = React.useMemo(function () {
    var scheduledBackground = background.scheduledBackground,
      defaultBackground = background.defaultBackground;
    if (scheduledBackground) {
      return scheduledBackground.enableVideoAudio || false;
    }
    return (defaultBackground == null ? void 0 : defaultBackground.enableVideoAudio) || false;
  }, [background]);
  var type = React.useMemo(function () {
    var scheduledBackground = background.scheduledBackground,
      defaultBackground = background.defaultBackground;
    if (!(scheduledBackground != null && scheduledBackground.media) && !(defaultBackground != null && defaultBackground.media)) {
      var _fallback$background;
      var _ref7 = fallback.background || {},
        video = _ref7.video,
        image = _ref7.image;
      if (!video && !image) return BACKGROUND_MEDIA_TYPE.EMPTY;
      return (_fallback$background = fallback.background) != null && _fallback$background.video ? BACKGROUND_MEDIA_TYPE.VIDEO : BACKGROUND_MEDIA_TYPE.IMAGE;
    }
    var _ref8 = (scheduledBackground == null ? void 0 : scheduledBackground.media) || (defaultBackground == null ? void 0 : defaultBackground.media),
      contentType = _ref8.contentType;
    var splitContentType = contentType == null ? void 0 : contentType.split('/')[0];
    var availableMediaTypes = {
      image: BACKGROUND_MEDIA_TYPE.IMAGE,
      video: BACKGROUND_MEDIA_TYPE.VIDEO
    };
    return availableMediaTypes[splitContentType] || BACKGROUND_MEDIA_TYPE.EMPTY;
  }, [background, fallback]);
  return {
    media: media,
    type: type,
    color: (_fallback$background2 = fallback.background) == null ? void 0 : _fallback$background2.color,
    enableVideoAudio: enableVideoAudio
  };
};

var useCustomisation = function useCustomisation() {
  var _useFlags = launchdarklyReactClientSdk.useFlags(),
    kioskUseNewCustomisationEndpoint = _useFlags.kioskUseNewCustomisationEndpoint;
  var _useState = React.useState({}),
    activeCustomisation = _useState[0],
    setActiveCustomisation = _useState[1];
  var _useRecoilValue = recoil.useRecoilValue(atoms.settingsState),
    serial = _useRecoilValue.serial,
    _useRecoilValue$setti = _useRecoilValue.settings,
    settings = _useRecoilValue$setti === void 0 ? {} : _useRecoilValue$setti;
  useSWR('@customisation', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _settings$properties, _settings$properties2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fmApi.getCustomisation({
            payload: {
              serial: serial,
              storeId: (_settings$properties = settings.properties) == null ? void 0 : _settings$properties.storeId,
              organisationId: (_settings$properties2 = settings.properties) == null ? void 0 : _settings$properties2.organisation
            },
            version: kioskUseNewCustomisationEndpoint ? 'v2' : null
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), {
    isPaused: function isPaused() {
      return !serial || !settings.properties;
    },
    refreshInterval: 60000,
    refreshWhenHidden: true,
    onSuccess: function onSuccess(data) {
      if (data === void 0) {
        data = {};
      }
      setActiveCustomisation(data);
      var valueWithExpiry = {
        value: data,
        expiry: Date.now() + 1000 * 60 * 60 // 1 hour cache
      };
      localStorage.setItem('@cache/customisation', JSON.stringify(valueWithExpiry));
      return data;
    }
  });
  React.useEffect(function () {
    var storedCustomisation = localStorage.getItem('@cache/customisation');
    var parsedCustomisation = JSON.parse(storedCustomisation);
    if (!!lodash.isObject(parsedCustomisation)) {
      if (parsedCustomisation.expiry < Date.now()) {
        localStorage.removeItem('@cache/customisation');
        return;
      }
      setActiveCustomisation(parsedCustomisation.value);
    }
  }, []);
  return activeCustomisation;
};

var useHeroComponent = function useHeroComponent(_ref) {
  var customisation = _ref.customisation,
    fallback = _ref.fallback;
  var _useRecoilValue = recoil.useRecoilValue(atoms.settingsState),
    _useRecoilValue$setti = _useRecoilValue.settings,
    settings = _useRecoilValue$setti === void 0 ? {} : _useRecoilValue$setti;
  var _ref2 = settings.content || {},
    _ref2$enableHeroImage = _ref2.enableHeroImage,
    enableHeroImage = _ref2$enableHeroImage === void 0 ? false : _ref2$enableHeroImage;
  var media = React.useMemo(function () {
    var _fallback$hero, _heroImage$media, _heroImage$, _heroImage$$media;
    if (!enableHeroImage) return null;
    if (!(customisation != null && customisation.customisations)) return (_fallback$hero = fallback.hero) == null ? void 0 : _fallback$hero.image;
    var _ref3 = customisation.customisations || {},
      _ref3$heroImage = _ref3.heroImage,
      heroImage = _ref3$heroImage === void 0 ? {} : _ref3$heroImage;
    return (heroImage == null ? void 0 : (_heroImage$media = heroImage.media) == null ? void 0 : _heroImage$media.url) || ((_heroImage$ = heroImage[0]) == null ? void 0 : (_heroImage$$media = _heroImage$.media) == null ? void 0 : _heroImage$$media.url);
  }, [customisation, fallback, enableHeroImage]);
  return {
    media: media
  };
};

var NewHomePageCustomisationProvider = function NewHomePageCustomisationProvider(_ref) {
  var children = _ref.children,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var customisation = useCustomisation();
  var background = useBackgroundComponent({
    customisation: customisation,
    fallback: fallback
  });
  var hero = useHeroComponent({
    customisation: customisation,
    fallback: fallback
  });
  return /*#__PURE__*/jsxRuntime.jsx(HomePageCustomisationContext.Provider, {
    value: {
      kind: 'new',
      background: background,
      hero: hero
    },
    children: children
  });
};

var OldHomePageCustomisationProvider = function OldHomePageCustomisationProvider(_ref) {
  var _fallback$background3;
  var children = _ref.children,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _useRecoilValue = recoil.useRecoilValue(atoms.settingsState),
    _useRecoilValue$setti = _useRecoilValue.settings,
    config = _useRecoilValue$setti === void 0 ? {} : _useRecoilValue$setti;
  var _config$homePageCusto = config.homePageCustomisation,
    homePageCustomisation = _config$homePageCusto === void 0 ? {} : _config$homePageCusto,
    content = config.content;
  var isSecondaryHome = content.homeBurger,
    _content$enableHeroIm = content.enableHeroImage,
    enableHeroImage = _content$enableHeroIm === void 0 ? false : _content$enableHeroIm;
  var heroMedia = React.useMemo(function () {
    var _fallback$hero;
    if (!enableHeroImage) return null;
    var availableHero = (homePageCustomisation == null ? void 0 : homePageCustomisation.heroImageUrl) || ((_fallback$hero = fallback.hero) == null ? void 0 : _fallback$hero.image);
    return availableHero;
  }, [homePageCustomisation, fallback, enableHeroImage]);
  var backgroundMedia = React.useMemo(function () {
    var _fallback$background, _fallback$background2;
    var availableBackgrounds = {
      primary: (homePageCustomisation == null ? void 0 : homePageCustomisation.primaryBackgroundUrl) || ((_fallback$background = fallback.background) == null ? void 0 : _fallback$background.image),
      secondary: (homePageCustomisation == null ? void 0 : homePageCustomisation.secondaryBackgroundUrl) || ((_fallback$background2 = fallback.background) == null ? void 0 : _fallback$background2.image)
    };
    return isSecondaryHome ? availableBackgrounds.secondary : availableBackgrounds.primary;
  }, [homePageCustomisation, fallback, isSecondaryHome]);
  return /*#__PURE__*/jsxRuntime.jsx(HomePageCustomisationContext.Provider, {
    value: {
      kind: 'old',
      background: {
        type: BACKGROUND_MEDIA_TYPE.IMAGE,
        media: backgroundMedia,
        color: (_fallback$background3 = fallback.background) == null ? void 0 : _fallback$background3.color
      },
      hero: {
        media: heroMedia
      }
    },
    children: children
  });
};

var BACKGROUND_MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
  EMPTY: 'empty'
};
var CoreHomePageCustomisationProvider = function CoreHomePageCustomisationProvider(_ref) {
  var children = _ref.children,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _useFlags = launchdarklyReactClientSdk.useFlags(),
    kioskUseNewCustomisationVersion = _useFlags.kioskUseNewCustomisationVersion;
  var CurrentProvider = kioskUseNewCustomisationVersion ? NewHomePageCustomisationProvider : OldHomePageCustomisationProvider;
  return /*#__PURE__*/jsxRuntime.jsx(CurrentProvider, {
    fallback: fallback,
    children: children
  });
};

var CoreHomePageCustomisationBackgroundImage = function CoreHomePageCustomisationBackgroundImage() {
  var _useHomePageCustomisa = useHomePageCustomisationContext(),
    background = _useHomePageCustomisa.background;
  if (!(background != null && background.media)) return null;
  return /*#__PURE__*/jsxRuntime.jsx("img", {
    alt: "background image",
    "data-test": "home-page-customisation__background__image",
    src: background.media,
    className: clsx('w-full object-cover', 'core__home-page-customisation__background__image')
  });
};

var CoreHomePageCustomisationBackgroundVideo = function CoreHomePageCustomisationBackgroundVideo() {
  var _useHomePageCustomisa = useHomePageCustomisationContext(),
    background = _useHomePageCustomisa.background;
  if (!(background != null && background.media)) return null;
  return /*#__PURE__*/jsxRuntime.jsx("video", {
    loop: true,
    muted: !background.enableVideoAudio,
    autoPlay: true,
    playsInline: true,
    type: "video/mp4",
    "data-test": "home-page-customisation__background__video",
    src: background.media,
    className: clsx('w-full object-cover', 'core__home-page-customisation__background__video')
  });
};

var CoreHomePageCustomisationBackground = function CoreHomePageCustomisationBackground(_ref) {
  var _BACKGROUND_MEDIA_TYP;
  var className = _ref.className;
  var _useHomePageCustomisa = useHomePageCustomisationContext(),
    background = _useHomePageCustomisa.background;
  var BackgroundComponent = (_BACKGROUND_MEDIA_TYP = {}, _BACKGROUND_MEDIA_TYP[BACKGROUND_MEDIA_TYPE.IMAGE] = CoreHomePageCustomisationBackgroundImage, _BACKGROUND_MEDIA_TYP[BACKGROUND_MEDIA_TYPE.VIDEO] = CoreHomePageCustomisationBackgroundVideo, _BACKGROUND_MEDIA_TYP[BACKGROUND_MEDIA_TYPE.EMPTY] = function () {
    return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {});
  }, _BACKGROUND_MEDIA_TYP)[background.type];
  return /*#__PURE__*/jsxRuntime.jsx("div", {
    "data-test": "home-page-customisation__background",
    style: {
      backgroundColor: background.color
    },
    className: clsx('w-full h-full absolute flex items-start top-0 left-0', 'core__home-page-customisation__background', className),
    children: /*#__PURE__*/jsxRuntime.jsx(BackgroundComponent, {})
  });
};

var CoreHomePageCustomisationHeroImage = function CoreHomePageCustomisationHeroImage(_ref) {
  var className = _ref.className;
  var _useHomePageCustomisa = useHomePageCustomisationContext(),
    hero = _useHomePageCustomisa.hero;
  if (!(hero != null && hero.media)) return null;
  return /*#__PURE__*/jsxRuntime.jsx("img", {
    alt: "hero",
    "data-test": "home-page-customisation__hero-image",
    src: hero.media,
    className: tailwindMerge.twMerge('w-5/6 mx-auto', 'core__home-page-customisation__hero-image', className)
  });
};

var HomeCustomisation = {
  Provider: CoreHomePageCustomisationProvider,
  Background: CoreHomePageCustomisationBackground,
  HeroImage: CoreHomePageCustomisationHeroImage
};

/* eslint-disable max-lines */

// Failsafe logger check at app entry...
window.logger = window.logger || /*#__PURE__*/new logger$1.FallbackLogger();

exports.AccessibilityButton = AccessibilityButton;
exports.AccessibilityWrapper = AccessibilityWrapper;
exports.AddonRemovedModal = AddonRemovedModal;
exports.AddonRemovedModalV2 = AddonRemovedModal$1;
exports.AdminAuthenticateProvider = AdminAuthenticateProvider;
exports.AdminAuthenticateView = AdminAuthenticateView;
exports.AdminButton = AdminButton;
exports.AdminLogin = AdminLogin;
exports.AdminViewProvider = AdminViewProvider;
exports.Alert = Alert;
exports.AlertV2 = Alert$1;
exports.AppDownloadView = AppDownloadView;
exports.AppDownloadViewProvider = AppDownloadViewProvider;
exports.Banner = Banner;
exports.BannerWarning = BannerWarning;
exports.BasketCount = BasketCount;
exports.BeaconForm = BeaconForm;
exports.BeaconFormHeader = BeaconFormHeader;
exports.BeaconFormHeaderIcon = BeaconFormHeaderIcon;
exports.BeaconFormHeaderSubtitle = BeaconFormHeaderSubtitle;
exports.BeaconViewProvider = BeaconViewProvider;
exports.CancelOrderButton = CancelOrderButton;
exports.CardPaymentView = CardPaymentView;
exports.CardPaymentViewProvider = CardPaymentViewProvider;
exports.CartProduct = CartProduct;
exports.CartProductV2 = CartProduct$1;
exports.CartViewProduct = CartViewProduct;
exports.CartViewProvider = CartViewProvider;
exports.CategoriesHeader = CategoriesHeader;
exports.CategoriesViewProvider = CategoriesViewProvider;
exports.CategoryViewProvider = CategoryViewProvider;
exports.CrossSellGallery = CrossSellGallery;
exports.CrossSellGalleryV2 = CrossSellGallery$1;
exports.CustomerDetailsForm = CustomerDetailsForm;
exports.CustomerDetailsViewProvider = CustomerDetailsViewProvider;
exports.DefaultTemplate = DefaultTemplate;
exports.FallbackRender = FallbackRender;
exports.Footer = Footer;
exports.Gallery = Gallery;
exports.GalleryCard = GalleryCard;
exports.Header = Header;
exports.HomeCustomisation = HomeCustomisation;
exports.IFrameModal = IFrameModal;
exports.IconButton = IconButton;
exports.ImageButton = ImageButton;
exports.Input = Input;
exports.InputError = InputError;
exports.InputLabel = InputLabel;
exports.InvalidRouteView = InvalidRouteView;
exports.InvalidRouteViewProvider = InvalidRouteViewProvider;
exports.LateRefundModal = LateRefundModal;
exports.LoadableImage = LoadableImage;
exports.LoadableImageV2 = LoadableImage$1;
exports.Loading = Loading;
exports.LoadingV2 = Loading$1;
exports.LocaleSelection = LocaleSelection;
exports.LoyaltyBanner = LoyaltyBanner;
exports.LoyaltyLoginCode = LoyaltyLoginCode;
exports.LoyaltyLoginView = LoyaltyLoginView;
exports.LoyaltyLoginViewProvider = LoyaltyLoginViewProvider;
exports.LoyaltyOffersView = LoyaltyOffersView;
exports.LoyaltyOffersViewProvider = LoyaltyOffersViewProvider;
exports.MAX_MENU_RETRIES = MAX_MENU_RETRIES;
exports.MAX_MENU_RETRY_DELAY = MAX_MENU_RETRY_DELAY;
exports.MiniCart = MiniCart;
exports.MiniCartModal = MiniCartModal;
exports.MiniCartModalV2 = MiniCartModal$1;
exports.Modal = Modal;
exports.ModalFooter = ModalFooter;
exports.ModalHeader = ModalHeader;
exports.ModalV2 = Modal$1;
exports.NotificationProvider = NotificationProvider;
exports.NotificationView = NotificationView;
exports.OnScreenKeyboard = OnScreenKeyboard;
exports.OrderTotalSummary = OrderTotalSummary;
exports.OrderTotalSummaryV2 = OrderTotalSummary$1;
exports.OutOfStockModal = OutOfStockModal;
exports.PaymentMethods = PaymentMethods;
exports.PaymentOptionsView = PaymentOptionsView;
exports.PaymentOptionsViewProvider = PaymentOptionsViewProvider;
exports.PrimaryButton = PrimaryButton;
exports.PrimaryButtonLarge = PrimaryButtonLarge;
exports.Product = Product$1;
exports.ProductAnimationSpawn = ProductAnimationSpawn;
exports.ProductAnimationSpawnV2 = ProductAnimationSpawn$1;
exports.ProductCardLoadableImage = ProductCardLoadableImage;
exports.ProductComboPrice = ProductComboPrice;
exports.ProductComboPriceV2 = ProductComboPrice$1;
exports.ProductComboViewProvider = ProductComboViewProvider;
exports.ProductCustomisationModal = ProductCustomisationModal;
exports.ProductCustomisationModalV2 = ProductCustomisationModal$1;
exports.ProductCustomisations = ProductCustomisations;
exports.ProductCustomisationsReadonly = ProductCustomisationsReadonly;
exports.ProductOptionCard = ProductOptionCard;
exports.ProductOptionCardV2 = ProductOptionCard$1;
exports.ProductOptionCustomisationModal = ProductOptionCustomisationModal;
exports.ProductOptionCustomisationModalV2 = ProductOptionCustomisationModal$1;
exports.ProductOptionsChangeModal = ProductOptionsChangeModal;
exports.ProductOptionsChangeModalV2 = ProductOptionsChangeModal$1;
exports.ProductOptionsReadonly = ProductOptionsReadonly;
exports.ProductSummary = ProductSummary;
exports.QRCardPaymentView = QRCardPaymentView;
exports.QRCode = QRCode;
exports.QuantityControllerButtons = QuantityControllerButtons;
exports.QuantityControllerOutlined = QuantityControllerOutlined;
exports.ReceiptDetails = ReceiptDetails;
exports.ReceiptPayment = ReceiptPayment;
exports.ReceiptQRCode = ReceiptQRCode;
exports.ReceiptView = ReceiptView;
exports.ReceiptViewProvider = ReceiptViewProvider;
exports.RefundView = RefundView;
exports.RefundViewProvider = RefundViewProvider;
exports.ResetView = ResetView;
exports.ResetViewProvider = ResetViewProvider;
exports.RestaurantCouponView = RestaurantCouponView;
exports.RestaurantCouponViewProvider = RestaurantCouponViewProvider;
exports.RestaurantDualBrandViewProvider = RestaurantDualBrandViewProvider;
exports.RestaurantHomeView = RestaurantHomeView;
exports.RestaurantHomeViewProvider = RestaurantHomeViewProvider;
exports.RestaurantLockView = RestaurantLockView;
exports.RestaurantLockViewProvider = RestaurantLockViewProvider;
exports.RestaurantOrderConfirmationView = RestaurantOrderConfirmationView;
exports.RestaurantOrderConfirmationViewProvider = RestaurantOrderConfirmationViewProvider;
exports.RestaurantOrderValidationView = RestaurantOrderValidationView;
exports.RestaurantOrderValidationViewProvider = RestaurantOrderValidationViewProvider;
exports.RestaurantProductComposedView = RestaurantProductComposedView;
exports.RestaurantProductComposedViewProvider = RestaurantProductComposedViewProvider;
exports.RestaurantProductView = RestaurantProductView;
exports.RestaurantProductViewProvider = RestaurantProductViewProvider;
exports.RootViewProvider = RootViewProvider;
exports.SecondaryButton = SecondaryButton;
exports.SecondaryButtonLarge = SecondaryButtonLarge;
exports.ServiceCardButton = ServiceCardButton;
exports.SettingsView = SettingsView;
exports.SettingsViewProvider = SettingsViewProvider;
exports.SmsView = SmsView;
exports.SmsViewProvider = SmsViewProvider;
exports.SummaryField = SummaryField;
exports.SummaryFieldV2 = SummaryField$1;
exports.SummarySectionV2 = SummarySection$1;
exports.TimeoutModal = TimeoutModal;
exports.TransactionsView = TransactionsView;
exports.TransactionsViewProvider = TransactionsViewProvider;
exports.UpsellGallery = UpsellGallery;
exports.UpsellGalleryV2 = UpsellGallery$1;
exports.UpsellModal = UpsellModal;
exports.UpsellModalV2 = UpsellModal$1;
exports.Warning = Warning;
exports.arrayToString = arrayToString;
exports.filterByTimeRestrictions = filterByTimeRestrictions;
exports.filterByVisibilityFlag = filterByVisibilityFlag;
exports.filterImageUrlFallback = filterImageUrlFallback;
exports.findAndReplaceByUID = findAndReplaceByUID;
exports.flattenProducts = flattenProducts;
exports.formatComboProduct = formatComboProduct;
exports.formatComposedProduct = formatComposedProduct;
exports.formatCustomiseProduct = formatCustomiseProduct;
exports.formatEnergyInfo = formatEnergyInfo;
exports.formatGroupedProduct = formatGroupedProduct;
exports.formatModalAccessibilityClass = formatModalAccessibilityClass;
exports.formatPrice = formatPrice;
exports.formatProduct = formatProduct;
exports.formatProductList = formatProductList;
exports.formatShowUpsellModal = formatShowUpsellModal;
exports.formatSimpleProduct = formatSimpleProduct;
exports.formatUpsellProducts = formatUpsellProducts;
exports.formatUpsells = formatUpsells;
exports.getDisplayOrderNumber = getDisplayOrderNumber;
exports.getFirstName = getFirstName;
exports.getHydratedProductsFromCategory = getHydratedProductsFromCategory;
exports.getOptionCustomisationsByUid = getOptionCustomisationsByUid;
exports.getProductById = getProductById;
exports.getQRCodeSize = getQRCodeSize;
exports.getUpsellCategoryById = getUpsellCategoryById;
exports.handleChangeMenuBrandStateTheme = handleChangeMenuBrandStateTheme;
exports.initializeSentry = initializeSentry;
exports.isThereSpecialCharacters = isThereSpecialCharacters;
exports.reduceComboDefaults = reduceComboDefaults;
exports.reduceCustomisationDefaults = reduceCustomisationDefaults;
exports.registerProductAddToCart = registerProductAddToCart;
exports.resolveEnvironment = resolveEnvironment;
exports.setUpSentryTags = setUpSentryTags;
exports.toCamelCase = toCamelCase;
exports.translateProductName = translateProductName;
exports.updatePricesByTimeRestrictions = updatePricesByTimeRestrictions;
exports.useAccessibility = useAccessibility;
exports.useAdminAuthenticate = useAdminAuthenticate;
exports.useAdminAuthenticateContext = useAdminAuthenticateContext;
exports.useAdminView = useAdminView;
exports.useAdminViewContext = useAdminViewContext;
exports.useAppDownloadView = useAppDownloadView;
exports.useAppDownloadViewContext = useAppDownloadViewContext;
exports.useBeaconView = useBeaconView;
exports.useBeaconViewContext = useBeaconViewContext;
exports.useCancelOrder = useCancelOrder;
exports.useCardPaymentView = useCardPaymentView;
exports.useCardPaymentViewContext = useCardPaymentViewContext;
exports.useCartView = useCartView;
exports.useCartViewContext = useCartViewContext;
exports.useCategoriesHeader = useCategoriesHeader;
exports.useCategoriesView = useCategoriesView;
exports.useCategoriesViewContext = useCategoriesViewContext;
exports.useCategoryView = useCategoryView;
exports.useCategoryViewContext = useCategoryViewContext;
exports.useCustomer = useCustomer;
exports.useCustomerDetailsView = useCustomerDetailsView;
exports.useCustomerDetailsViewContext = useCustomerDetailsViewContext;
exports.useFallbackRender = useFallbackRender;
exports.useInvalidRouteView = useInvalidRouteView;
exports.useInvalidRouteViewContext = useInvalidRouteViewContext;
exports.useLocaleSelection = useLocaleSelection;
exports.useLoyaltyLoginView = useLoyaltyLoginView;
exports.useLoyaltyLoginViewContext = useLoyaltyLoginViewContext;
exports.useLoyaltyOffersView = useLoyaltyOffersView;
exports.useLoyaltyOffersViewContext = useLoyaltyOffersViewContext;
exports.useModalPromise = useModalPromise;
exports.useNotification = useNotification;
exports.useNotificationContext = useNotificationContext;
exports.useOffersAndRewardsMenu = useOffersAndRewardsMenu;
exports.useOrigin = useOrigin;
exports.usePaymentOptionsView = usePaymentOptionsView;
exports.usePaymentOptionsViewContext = usePaymentOptionsViewContext;
exports.usePrevious = usePrevious;
exports.usePrice = usePrice;
exports.useProductComboView = useProductComboView;
exports.useProductComboViewContext = useProductComboViewContext;
exports.useProductCustomisationModal = useProductCustomisationModal;
exports.useReceiptView = useReceiptView;
exports.useRefundView = useRefundView;
exports.useRefundViewContext = useRefundViewContext;
exports.useResetView = useResetView;
exports.useResetViewContext = useResetViewContext;
exports.useRestaurantCart = useRestaurantCart;
exports.useRestaurantCouponView = useRestaurantCouponView;
exports.useRestaurantCouponViewContext = useRestaurantCouponViewContext;
exports.useRestaurantDualBrandViewContext = useRestaurantDualBrandViewContext;
exports.useRestaurantHomeView = useRestaurantHomeView;
exports.useRestaurantHomeViewContext = useRestaurantHomeViewContext;
exports.useRestaurantLockView = useRestaurantLockView;
exports.useRestaurantLockViewContext = useRestaurantLockViewContext;
exports.useRestaurantMenu = useRestaurantMenu;
exports.useRestaurantOrder = useRestaurantOrder;
exports.useRestaurantOrderConfirmation = useRestaurantOrderConfirmation;
exports.useRestaurantOrderConfirmationViewContext = useRestaurantOrderConfirmationViewContext;
exports.useRestaurantOrderValidation = useRestaurantOrderValidation;
exports.useRestaurantOrderValidationViewContext = useRestaurantOrderValidationViewContext;
exports.useRestaurantProductComposedView = useRestaurantProductComposedView;
exports.useRestaurantProductComposedViewContext = useRestaurantProductComposedViewContext;
exports.useRestaurantProductView = useRestaurantProductView;
exports.useRestaurantProductViewContext = useRestaurantProductViewContext;
exports.useRestaurantSecondaryCart = useRestaurantSecondaryCart;
exports.useRootViewContext = useRootViewContext;
exports.useSettingsView = useSettingsView;
exports.useSettingsViewContext = useSettingsViewContext;
exports.useSmsView = useSmsView;
exports.useSmsViewContext = useSmsViewContext;
exports.useTemplate = useTemplate;
exports.useTimeoutModal = useTimeoutModal;
exports.useTransactions = useTransactions;
exports.useTransactionsView = useTransactionsView;
exports.useTransactionsViewContext = useTransactionsViewContext;
//# sourceMappingURL=cringer.components.cjs.development.js.map
